(function () {
    'use strict';

    angular
            .module('gestioneAttiApp', [
                'ngStorage',
                'tmh.dynamicLocale',
                'pascalprecht.translate',
                'ngSanitize',
                'ngMaterial',
                'ngAnimate',
                'ngAria',
                'ngResource',
                'ngCookies',
                'ngCacheBuster',
                'ngFileUpload',
                'ui.bootstrap',
                'ui.bootstrap.datetimepicker',
                'ui.router',
                'infinite-scroll',
                // jhipster-needle-angularjs-add-module JHipster will add new module here
                'angular-loading-bar',
                'toastr',
                'hl.sticky',
                'ngFileSaver',
                //'angularSlideables',
                'angular.filter',
                'ui.tree',
                'ngMessages'
            ])
            .run(run)
            .config(config)
            .config(dateFormat);

    run.$inject = ['stateHandler', 'translationHandler', '$state'];
    config.$inject = ['toastrConfig', '$mdThemingProvider'];
    dateFormat.$inject = ['$mdDateLocaleProvider'];

    function run(stateHandler, translationHandler, $state) {
        stateHandler.initialize();
        translationHandler.initialize();
        $state.go('home');
    }

    function config(toastrConfig, $mdThemingProvider) {

        angular.extend(toastrConfig, {
            //autoDismiss: false,
            //containerId: 'toast-container',
            allowHtml: true,
            closeButton: true,
            maxOpened: 3,
            progressBar: true,
            tapToDismiss: true,
            newestOnTop: true,
            timeOut: 2000,
            positionClass: 'toast-top-right',
            //preventDuplicates: true,
            preventOpenDuplicates: true,
            target: 'body'
        });

        $mdThemingProvider.theme('default')
                .primaryPalette('red')
                .accentPalette('orange');
    }

    function dateFormat($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            } else {
                return null;
            }
        }
    }


    angular.module('gestioneAttiApp').constant('GESTIONE_ATTI_DOC_VISIBILITIES', [
        {
            value: 'PUBLIC',
            textKey: 'documentToolbar.visibilityPublic',
            onlyForCommission: false
        },
        {
            value: 'INTRANET',
            textKey: 'documentToolbar.visibilityIntranet',
            onlyForCommission: false
        },
        {
            value: 'COMMISSION_MEMBER',
            textKey: 'documentToolbar.visibilityCommissionMember',
            onlyForCommission: true
        },
        {
            value: 'COMMISSION_PRESIDENT',
            textKey: 'documentToolbar.visibilityCommissionPresident',
            onlyForCommission: true
        },
        {
            value: 'SECTION_VISIBILITY',
            textKey: 'documentToolbar.visibilitySection',
            onlyForCommission: false
        }
    ]);


    angular.module('gestioneAttiApp').constant('AUTHORITIES', [
        {
            name: 'ROLE_ADMIN',
            textKey: 'authority.roleAdmin'
        },
        {
            name: 'ROLE_SETTORE',
            textKey: 'authority.roleSettore'
        },
        {
            name: 'ROLE_COMMISSIONE',
            textKey: 'authority.roleCommissione'
        },
        {
            name: 'ROLE_AULA',
            textKey: 'authority.aula'
        },
        {
            name: 'ROLE_ENTE',
            textKey: 'authority.ente'
        },
        {
            name: 'ROLE_EXTERNAL',
            textKey: 'authority.external'
        },
        {
            name: 'ROLE_PROTOCOLLO',
            textKey: 'authority.protocollo'
        },
        {
            name: 'ROLE_SECTION',
            textKey: 'authority.roleSection'
        }
    ]);

    angular.module('gestioneAttiApp').constant('TIPO_ANAGRAFICA_ITERLEGIS', [
        {
            name: 'ENTE'
        },
        {
            name: 'ORGANO'
        }
    ]);

    // Admin has permission for all resources
    angular.module('gestioneAttiApp').constant('RESOURCE_PERMISSIONS', [
        {
            name: 'ROLE_SETTORE',
            textKey: 'authority.roleSettore'
        },
        {
            name: 'ROLE_COMMISSIONE',
            textKey: 'authority.roleCommissione'
        },
        {
            name: 'ROLE_AULA',
            textKey: 'authority.roleAula'
        },
        {
            name: 'ROLE_ENTE',
            textKey: 'authority.roleEnte'
        },
        {
            name: 'ROLE_EXTERNAL',
            textKey: 'authority.roleExternal'
        },
        {
            name: 'ROLE_PROTOCOLLO',
            textKey: 'authority.protocollo'
        },
        {
            name: 'ROLE_SECTION',
            textKey: 'authority.roleSection'
        }
    ]);


    angular.module('gestioneAttiApp').constant('MAX_UPLOAD_SIZE', 50728640); //50MB Richiesta Caldini aumentato da 15MB

    angular.module('gestioneAttiApp').constant('SEARCH_STATES', [
        {
            value: 'PRESENTATO',
            name: 'gestioneAttiApp.atto.statoQuery.Presentato'
        },
        {
            value: 'COMMISSIONE',
            name: 'gestioneAttiApp.atto.statoQuery.Commissione'
        },
        {
            value: 'AULA',
            name: 'gestioneAttiApp.atto.statoQuery.Aula'
        },
        {
            value: 'APPROVATO',
            name: 'gestioneAttiApp.atto.statoQuery.Approvato'
        },
        {
            value: 'RESPINTO',
            name: 'gestioneAttiApp.atto.statoQuery.Respinto'
        },
        {
            value: 'DECADUTO',
            name: 'gestioneAttiApp.atto.statoQuery.Decaduto'
        },
        {
            value: 'IMPROCEDIBILE',
            name: 'gestioneAttiApp.atto.statoQuery.Improcedibile'
        },
        {
            value: 'RITIRATO',
            name: 'gestioneAttiApp.atto.statoQuery.Ritirato'
        },
        {
            value: 'SVOLTA',
            name: 'gestioneAttiApp.atto.statoQuery.Svolta'
        },
        {
            value: 'TRASMISSIONE_GIUNTA',
            name: 'gestioneAttiApp.atto.statoQuery.TrasmissioneGiunta'
        },
        {
            value: 'RISPOSTA_SCRITTA',
            name: 'gestioneAttiApp.atto.statoQuery.RispostaScritta'
        },
        {
            value: 'INAMMISSIBILE',
            name: 'gestioneAttiApp.atto.statoQuery.Inammissibile'
        },
        {
            value: 'TRASFERITA_COMPETENZA',
            name: 'gestioneAttiApp.atto.statoQuery.TrasferitaCompetenza'
        }
    ]);

    angular.module('gestioneAttiApp').constant('ACT_TYPES', [
        {
            value: 'PDL',
            name: 'gestioneAttiApp.atto.type.pdl'
        },
        {
            value: 'PDD',
            name: 'gestioneAttiApp.atto.type.pdd'
        },
        {
            value: 'PLIP',
            name: 'gestioneAttiApp.atto.type.plip'
        },{
            value: 'PDLP',
            name: 'gestioneAttiApp.atto.type.pdlp'
        },
        {
            value: 'PDLS',
            name: 'gestioneAttiApp.atto.type.pdls'
        },
/*         {
            value: 'PDR',
            name: 'gestioneAttiApp.atto.type.pdr'
        }, */
        {
            value: 'ODG',
            name: 'gestioneAttiApp.atto.type.odg'
        },
        {
            value: 'MOZIONE',
            name: 'gestioneAttiApp.atto.type.mozione'
        },
        {
            value: 'PEA',
            name: 'gestioneAttiApp.atto.type.pea'
        },
        {
            value: 'IO',
            name: 'gestioneAttiApp.atto.type.io'
        },
        {
            value: 'IS',
            name: 'gestioneAttiApp.atto.type.is'
        },
        {
            value: 'CDG',
            name: 'gestioneAttiApp.atto.type.cdg'
        },
        {
            value: 'PEL',
            name: 'gestioneAttiApp.atto.type.pel'
        },
        {
            value: 'IEA',
            name: 'gestioneAttiApp.atto.type.iea'
        },
        {
            value: 'DEA',
            name: 'gestioneAttiApp.atto.type.dea'
        },
        {
            value: 'PDRIS',
            name: 'gestioneAttiApp.atto.type.pdris'
        },
        {
            value: 'REL',
            name: 'gestioneAttiApp.atto.type.rel'
        },
        {
            value: 'RINT',
            name: 'gestioneAttiApp.atto.type.rint'
        }
    ]);

    angular.module('gestioneAttiApp').constant('EVENTI_NOTIFICA_ATTO', [
        {
            value: 'PRESENTAZIONE',
            name: 'gestioneAttiApp.atto.evento-notifica.presentazione'
        },
        {
            value: 'ASSEGNAZIONE',
            name: 'gestioneAttiApp.atto.evento-notifica.assegnazione'
        },
        {
            value: 'PASSAGGIO_IN_AULA',
            name: 'gestioneAttiApp.atto.evento-notifica.passaggio-aula'
        }
    ]);

    angular.module('gestioneAttiApp').constant('TIPOLOGIA_REPORT', [
        'DEFAULT',
        'COMMISSIONE'
    ]);

    angular.module('gestioneAttiApp').constant('TIPOLOGIA_ORDINAMENTO_REPORT', [
        'SCADENZA_ADEMPIMENTO',
        'DESTINATARIO_ADEMPIMENTO',
        'MACRO_MATERIA'
    ]);

    /*
    * 2023-06-05 Usata per disabilitare le opzioni "Protocolla al passaggio di stato" e "Protocolla immediatamente"
    * Inserire false quando verrà abilitata la protocollazione JOSH
    */
    angular.module('gestioneAttiApp').constant('PROTOCOLLAZIONE_DISABILITATA', true);

    angular.module('gestioneAttiApp').constant('ATTI_TABLE_TYPE', {
        'ATTI' : 0,
        'COMMISSIONE_ESAME' : 1,
        'COMMISSIONE_ESAMINATI' : 2
    });

    angular.module('gestioneAttiApp').constant('TIPO_NUMERAZIONE_SEDUTA', {
        LEGISLATURA: 'LEGISLATURA',
        ANNO: 'ANNO'
    });

})();






(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .factory('User', User);

    User.$inject = ['$resource', 'Principal'];

    function User($resource, Principal) {
        var service = $resource('api/users/:login/:fromLdap', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'fromLdap': {method: 'GET', params: {fromLdap: 'fromLdap'}, isArray: true},
        });

        /**
         * Restituisce true se l'utente appartiene ad una o più delle 
         * commissioni fornite, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} commissions
         * @returns {Boolean}
         */
        service.hasAnyCommission = function (utente, commissions, legislatura) {
            if (!utente || !commissions) { // || !utente.commissioni
                return false;
            }
            for (var i = 0; i < commissions.length; i++) {
                
                var id = getIdSoggetto(commissions[i]);
                if (utente.commissioni && utente.commissioni.indexOf(id) > -1) {
                    return true;
                }
                // Cerca nelle authority di legislatura -> Se trovo almeno un oggetto legislaturaAuthority
                // Il quale ha almeno un oggetto commissioneRuoloAssociato.commissione con lo stesso id di quello cercato -> Ritorna TRUE
                if (utente.legislaturaAuthorities && utente.legislaturaAuthorities.some( function (legiAuth) {
                    if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        if(legiAuth.commissioneRuoloAssociato && 
                            legiAuth.commissioneRuoloAssociato.some( function (commRuoloAssoc) {
                                return commRuoloAssoc.commissione && commRuoloAssoc.commissione.id === id;
                            })
                        ) { 
                            return true;
                        } else {
                            return false;
                        }
                    }
                })) {
                    return true;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente appartiene ad una o più dei soggetti 
         * esterni forniti, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} subjects
         * @returns {Boolean}
         */
        service.hasAnyExternalSubject = function (utente, subjects, legislatura) {
            if (!utente || !subjects ) { // || !utente.soggettiEsterni
                return false;
            }
            for (var i = 0; i < subjects.length; i++) {
                
                var id = getIdSoggetto(subjects[i]);
                if (utente.soggettiEsterni && utente.soggettiEsterni.indexOf(id) > -1) {
                    return true;
                }
                // Cerca nelle authority di legislatura -> Se trovo almeno un oggetto legislaturaAuthority
                // Il quale ha almeno un oggetto soggettiEsterni con lo stesso id di quello cercato -> Ritorna TRUE
                if (utente.legislaturaAuthorities && utente.legislaturaAuthorities.some( function (legiAuth) {
                    if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        if(legiAuth.soggettiEsterni) { 
                            return legiAuth.soggettiEsterni.some( function (soggEst) {
                                return soggEst.id === id;
                            });
                        }
                        return false;
                    }
                })) {
                    return true;
                }
            }
            return false;
        };

        // Estrae il campo id di un elemento
        // Se è un oggett,o prende il campo id, se è stringa restituisce l'elemento
        function getIdSoggetto(elemento) {
            var id;
            if (angular.isObject(elemento)) {
                id = elemento.id;
            } else {
                id = elemento;
            }
            return id;
        }
        
         /**
         * Restituisce true se l'utente appartiene ad uno o più dei settori 
         * forniti, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} settori
         * @returns {Boolean}
         */
        service.hasAnySector = function (utente, sectors) {
            if (!utente || !utente.settori || !sectors) {
                return false;
            }
            for (var i = 0; i < sectors.length; i++) {
                var id = null;
                if (angular.isObject(sectors[i])) {
                    id = sectors[i].id;
                } else {
                    id = sectors[i];
                }
                if (utente.settori.indexOf(id) > -1) {
                    return true;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente ha ruolo settore e per uno o più
         * settori cui appartiene sono possibili le azioni specificate in
         * actions, false altrimenti. Il mapping delle azioni abilitate per
         * ciascun settore è definito da azioniSettoriById.
         * 
         * @param {type} utente
         * @param {type} actions
         * @param {type} azioniSettoriById
         * @returns {Boolean}
         */
        service.isSectorUserEnabled = function (utente, actions, azioniSettoriById) {
            if (Principal.hasAnyAuthority(['ROLE_SETTORE']) && utente.settori) {
                for (var i = 0; i < utente.settori.length; i++) {
                    var idSettore = utente.settori[i];
                    if (azioniSettoriById[idSettore]) {
                        return azioniSettoriById[idSettore].some(function (action) {
                            return actions.indexOf(action) > -1;
                        });
                    }
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente ha ruolo commissione e all'interno
         * della commissione ha il ruolo commissionRoleName.
         * 
         * @param {type} utente
         * @param {type} commissioneRoleName
         * @returns {Boolean}
         */
        service.isCommissionRole = function (utente, commissioneRoleName, legislatura) {
            if(utente.commissioneRuolo && utente.commissioneRuolo.nome) {
                if( Principal.hasAnyAuthority(['ROLE_COMMISSIONE']) && utente.commissioneRuolo && utente.commissioneRuolo.nome === commissioneRoleName) {
                    return true;
                }
            }
            if(utente.legislaturaAuthorities && utente.legislaturaAuthorities.some(function (legiAuth){
                if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                    // LegiAuth ha qualche "commissioneRuoloAssociato" in cui commissioneRuolo.nome = commissioneRoleName --Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], legislatura) && 
                    return legiAuth.commissioneRuoloAssociato && legiAuth.commissioneRuoloAssociato.some(function (commRuoloAssoc) {
                        return commRuoloAssoc.commissioneRuolo && commRuoloAssoc.commissioneRuolo.nome === commissioneRoleName;
                    });
                }
            })) {
                return true;
            }
            return false;
        };


        service.isCommissionRoleForCommissionId = function (utente, commissionId, commissionRole, legislatura) {

            if (utente && service.isCommissionUser(utente, legislatura)) {

                //Nella legislatura l'utente ha ROLE_COMMISSIONE -> Si controlla commissioneRuolo 
                // Gestione pregresso nelle autorities persistenti (non dovrebbe essere più popolato)
                var isCommissionRole = utente.commissioneRuolo && utente.commissioneRuolo.nome && utente.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toUpperCase();

                if (isCommissionRole) {
                    return true;
                }
                var legislaturaAuthorities = utente.legislaturaAuthorities;
                
                if(legislaturaAuthorities) {
                    // Controllo commissioneRuolo per le authorities della legislatura in input
                    var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                
                    return legiAuth.commissioneRuoloAssociato.some(function(commRuolo) {
                        // Controlla se il nome del ruolo corrisponde
                        var roleMatch = commRuolo.commissioneRuolo && 
                                        commRuolo.commissioneRuolo.nome && 
                                        commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase();
            
                        if (!roleMatch) {
                            return false;
                        }
            
                        // Controllo la specifica commissione: commissionId
                        if (commissionId) {
                            return commRuolo.commissione && 
                                    commRuolo.commissione.id && 
                                    commRuolo.commissione.id === commissionId;
                        } else {
                            // Se non si richiede la commissione specifica qui ho fatto il match con il ruolo -> Return true
                            return true;
                        }
                    });
                } else {
                    return false;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente appartiene alla commissione 
         * referente, false altrimenti.
         * @param {type} utente
         * @param {type} primaryCommissionIds
         * @returns {Boolean}
         */
        service.isPrimaryCommission = function (utente, primaryCommissionIds, legislatura) {
            if (utente !== null && utente.commissioni !== null && primaryCommissionIds) {
                for (var i = 0; i < utente.commissioni.length; i++) {
                    var idCommissione = utente.commissioni[i];
                    if (primaryCommissionIds.indexOf(idCommissione) > -1) {
                        return true;
                    }
                }
            }
            if(utente !== null && primaryCommissionIds && utente.legislaturaAuthorities && utente.legislaturaAuthorities.some(function (legiAuth){
                if (service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                    // LegiAuth ha qualche "commissioneRuoloAssociato" in cui commissione.id = primaryCommissionIds (id delle commissioni del parere referente)
                    return legiAuth.commissioneRuoloAssociato && legiAuth.commissioneRuoloAssociato.some(function (commRuoloAssoc) {
                        return commRuoloAssoc.commissione && primaryCommissionIds.indexOf(commRuoloAssoc.commissione.id) > -1;
                    });
                }
            })) {
                return true;
            }
            return false;
        };

        service.isLegislaturaAuthoritiesToCheck = function (legislaturaAuthority, legislatura) {
            if (!legislatura) {
                return true;
            }
            if (legislaturaAuthority.legislatura && 
                legislaturaAuthority.legislatura.legislatura && 
                parseInt(legislaturaAuthority.legislatura.legislatura, 10) === parseInt(legislatura, 10)) {
                return true;
            } else {
                return false;
            }
        };

        service.isSectionRoleEnabledForSection = function (utente, nomeSezione) {

            if (utente.authorities && utente.authorities.indexOf("ROLE_SECTION") !== -1
                 && utente.sectionAuthorities && utente.sectionAuthorities.length > 0) {

                for (var i = 0; i < utente.sectionAuthorities.length; i++) {
                    var authSectionName = utente.sectionAuthorities[i].nomeSezione;
                    if (authSectionName === nomeSezione) {
                        return true;
                    }
                }
            }
            return false;
        };

        service.isCommissionUser = function (utente, legislatura) {
            if(!legislatura) {
                return hasAuthority(utente, 'ROLE_COMMISSIONE');
            } else {
                var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_COMMISSIONE') > -1;
                } else {
                    return false;
                }
            }
        };

        service.isExternalUser = function (utente, legislatura) {
            if(!legislatura) {
                return hasAuthority(utente, 'ROLE_EXTERNAL');
            } else {
                var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_EXTERNAL') > -1;
                } else {
                    return false;
                }    
            }
        };

        service.isSectorUser = function () {
            return hasAuthority('ROLE_SETTORE');
        };

        service.isSectionUser = function () {
            return hasAuthority('ROLE_SECTION');
        };

        // Recupera le authorities di legsilatura per la legislatura in input
        service.getLegislaturaAuthorities = function(utente, legislatura) {
            if(utente && angular.isArray(utente.legislaturaAuthorities)) {
                return findByLegislatura(utente.legislaturaAuthorities, legislatura);
            } else  {
                return null;
            }
        };

        // Recupera l'oggetto CommissioneRuoloAssociato 
        // relativo alla commissione in input
        // Per la legislatura in input
        service.getCommissioneRuoloAssociato = function(utente, legislatura, commissione){
            var legAuth = utente.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth['commissioneRuoloAssociato'])) {
                for (var i = 0; i < legAuth['commissioneRuoloAssociato'].length; i++) {
                    var item = legAuth['commissioneRuoloAssociato'][i];
                    if (item.commissione && item.commissione.id === commissione.id) {
                        return legAuth.commissioneRuoloAssociato[i];
                    }
                }
            }
        };

        function findByLegislatura(legiAuths, legislatura) {
            for (var i = 0; i < legiAuths.length; i++) {
                if (legiAuths[i].legislatura && parseInt(legiAuths[i].legislatura.legislatura, 10) === parseInt(legislatura, 10)) {
                    return legiAuths[i];
                }
            }
            return null;
        }

        function hasAuthority(utente, authority) {
            return utente.authorities !== null
                    && angular.isDefined(utente.authorities)
                    && utente.authorities.indexOf(authority) > -1;
        }

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.windowsAuthEnabled = result.data.windowsAuthEnabled;
                        response.inDev = result.data.activeProfiles.indexOf("dev") !== -1;
                        response.inStaging = result.data.activeProfiles.indexOf("stage") !== -1;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isEnteUser: isEnteUser,
            isOnlyRoleSectionUser : isOnlyRoleSectionUser,
            isCommissionWithRole: isCommissionWithRole,
            isCitizenUser: isCitizenUser
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities, legislatura) {
            if (!_authenticated || !_identity ) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if ( _identity.authorities && _identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
                if (_identity.legislaturaAuthorities && _identity.legislaturaAuthorities.some(function(legiAuth){
                    if(isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        return legiAuth.authorities && legiAuth.authorities.indexOf(authorities[i]) !== -1;
                    }
                })) {
                    return true;
                }
            }
            return false;
        }

        function hasAuthority(authority, legislatura) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                if( _id.authorities && _id.authorities.indexOf(authority) !== -1) {
                    return true;
                }
                if (_id.legislaturaAuthorities && _id.legislaturaAuthorities.some(function(legiAuth){
                    if(isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        return legiAuth.authorities && legiAuth.authorities.indexOf(authority) !== -1;
                    }
                })) {
                    return true;
                }
                return false;
            }, function () {
                return false;
            });
        }

        function isEnteUser(user, legislatura) {
            var authorities = user.authorities;
            var legislaturaAuthorities = user.legislaturaAuthorities;
            if (authorities) {
                for (var i = 0; i < authorities.length; i++) {
                    var auth = authorities[i];
                    if (auth !== 'ROLE_ENTE' && auth !== 'ROLE_USER' && auth !== 'ROLE_TEMPORARYENTE') {
                        return false;
                    }
                }
            }
            if(legislaturaAuthorities) {
                for (var j = 0; j < legislaturaAuthorities.length; j++) {
                    var legislaturaAuth = legislaturaAuthorities[j];
                    if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                        if (legislaturaAuth.authorities) {
                            for (var k = 0; k < legislaturaAuth.authorities.length; k++) {
                                var legiAuth = legislaturaAuth.authorities[k];
                                if (legiAuth !== 'ROLE_ENTE' && legiAuth !== 'ROLE_USER' && legiAuth !== 'ROLE_TEMPORARYENTE') {
                                    return false;
                                }
                            }
                        }
                    }
                }
                return true;
            }
            // FIXME: Se non ha associate authorities nè persistenti, nè di legislatura, è considerato ENTEUSER?
            return false;
        }

        function isOnlyRoleSectionUser(user, legislatura) {

            var authorities = user.authorities;
            var legislaturaAuthorities = user.legislaturaAuthorities;
            if (authorities) {
                for (var i = 0; i < authorities.length; i++) {
                    var auth = authorities[i];
                    if (auth !== 'ROLE_ENTE' && auth !== 'ROLE_USER' && auth !== 'ROLE_TEMPORARYENTE' && auth !== 'ROLE_SECTION') {
                        return false;
                    }
                }
            }
            if(legislaturaAuthorities) {
                for (var j = 0; j < legislaturaAuthorities.length; j++) {
                    var legislaturaAuth = legislaturaAuthorities[j];
                    if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                        if (legislaturaAuth.authorities) {
                            for (var k = 0; k < legislaturaAuth.authorities.length; k++) {
                                var legiAuth = legislaturaAuth.authorities[k];
                                if (legiAuth !== 'ROLE_ENTE' && legiAuth !== 'ROLE_USER' && legiAuth !== 'ROLE_TEMPORARYENTE' && legiAuth !== 'ROLE_SECTION') {
                                    return false;
                                }
                            }
                        }
                    }
                }
                return true;
            }
            return false;
        }

        function isCommissionWithRole(commissionId, commissionRole, legislatura) {

            var commissionAuthorities = ["ROLE_COMMISSIONE"];
            if (hasAnyAuthority(commissionAuthorities, legislatura)) {
                var user = _identity;

                //Nella legislatura l'utente ha ROLE_COMMISSIONE -> Si controlla commissioneRuolo 
                // Gestione pregresso nelle autorities persistenti (non dovrebbe essere più popolato)
                var isCommissionRole = user.commissioneRuolo && user.commissioneRuolo.nome && user.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase();

                if (isCommissionRole) {
                    return true;
                }

                var legislaturaAuthorities = user.legislaturaAuthorities;
                // Controllo commissioneRuolo per authorities di legislatura
                if(legislaturaAuthorities) {
                    for (var i = 0; i < legislaturaAuthorities.length; i++) {
                        var legislaturaAuth = legislaturaAuthorities[i];
                        if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                            if (legislaturaAuth.commissioneRuoloAssociato) {
                                var commRuoloArray = legislaturaAuth.commissioneRuoloAssociato;
                                for (var j = 0; j < commRuoloArray.length; j++) {
                                    var commRuolo = commRuoloArray[j];
                                    if (commissionId) {
                                        if (commRuolo.commissione && commRuolo.commissione.id &&
                                            commRuolo.commissione.id === commissionId &&
                                            commRuolo.commissioneRuolo && commRuolo.commissioneRuolo.nome &&
                                            commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase()){
                                            return true;
                                        }
                                    } else {
                                        // Non è stata specificata la commissione, basta che per una commissione si abbia il ruolo "commissionRole"
                                        if (commRuolo.commissioneRuolo && commRuolo.commissioneRuolo.nome &&
                                            commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase()){
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            } else {
                return false;
            }
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                    .then(getAccountThen)
                    .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function isLegislaturaAuthoritiesToCheck(legislaturaAuthority, legislatura) {
            if (!legislatura) {
                return true;
            }
            if (legislaturaAuthority.legislatura && 
                legislaturaAuthority.legislatura.legislatura && 
                legislaturaAuthority.legislatura.legislatura === legislatura) {
                return true;
            } else {
                return false;
            }
        }

        function isCitizenUser(){
            if(_identity && _identity.authorities && _identity.authorities.indexOf("ROLE_ARPA_CITIZEN_USER") !== -1) return true;
            return false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('isIntranet', isIntranet);

    isIntranet.$inject = ['$http', 'Principal'];

    function isIntranet($http, Principal) {
        var directive = {         
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var deleteElement = function () {
                element.remove();
            },
            onSuccess = function () {
            },
            onError = function (error) {
                if(error.status === 403){
                    deleteElement();
                } 
            },
            defineVisibility = function () {
                $http.get('/api/internal/check').then(onSuccess, onError);
            }; 

            if (attrs.isIntranet === "true") {
                defineVisibility();

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility();
                });
            }

        }

       
    }

})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$window' ];

    function AuthServerProvider ($http, $localStorage, $window ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                
                // to get a new csrf token call the api
                $http.get('api/account');
                
                // --- INTEGRAZIONE ARPA ---
                // Se c'è l'url di logout di ARPA
                if (response && response.arpaLogoutUrl) {
                    // Si fa redirect verso l'url di logout
                    $window.location.href = response.arpaLogoutUrl;
                }
                
                return response;
            }).error(function() {
                // Fallback di sicurezza in caso di errore di rete
                delete $localStorage.authenticationToken;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {
        var service = $resource('api/account/:testProtocolCredentials', {}, {
            'get': {method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            },
            'testProtocolCredentials': {
                method: 'GET',
                params: {testProtocolCredentials: 'testProtocolCredentials'},
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response.data;
                    }
                }
            }
        });

        return service;
    }
})();

/**
 * Created by Michele Romani on 22/06/2017.
 */


angular.module('gestioneAttiApp').factory('MockDataFunctionsFactory', function() {
    console.log("Building MockDataFunctionsFactory");

    var MockDataFunctionsFactory = {

        getPdlList : function(){
            return [
                {
                    "id": 1,
                    "title" : "Disposizioni per favorire la trasparenza tra le Società Cooperative e la Pubblica Amministrazione.",
                    "date" : "25/06/2015",
                    "prot" : "15138",
                    "proposer" : "Donzelli,Vescovi,Borghi",
                    "state" : "new"
                },
                {
                    "id": 2,
                    "title" : "Rendiconto generale per l'anno finanziario 2014.",
                    "date" : "02/07/2015",
                    "prot" : "15852",
                    "proposer" : "GR-Bugli",
                    "state" : "approved"
                },
                {
                    "id": 3,
                    "title" : "Bilancio di previsione per l’esercizio finanziario 2015 e pluriennale 2015 – 2017 e bilancio di previsione conoscitivo 2015 – 2017. Assestamento.",
                    "date" : "22/07/2015",
                    "prot" : "15910",
                    "proposer" : "GR-Bugli",
                    "state" : "rejected"
                },
                {
                    "id": 4,
                    "title" : "Disciplina dello stemma, del gonfalone, del sigillo e della fascia della Regione Toscana.",
                    "date" : "14/07/2015",
                    "prot" : "17168",
                    "proposer" : "Giani, De Robertis, Donzelli",
                    "state" : "rejected"
                },
                {
                    "id": 5,
                    "title" : "Comitato regionale delle associazioni e delle manifestazioni di rievocazione e ricostruzione storica. Modifiche alla Lr.5/2012.",
                    "date" : "17/07/2015",
                    "prot" : "17171",
                    "proposer" : "GR-Bugli",
                    "state" : "approved"
                },
                {
                    "id": 6,
                    "title" : "Modifiche alla legge regionale 8 gennaio 2009 n. 1 (Testo unico in materia di organizzazione e ordinamento del personale).",
                    "date" : "07/07/2015",
                    "prot" : "17173",
                    "proposer" : "Giani, De Robertis, Donzelli, Mazzeo",
                    "state" : "approved"
                }
            ]
        }

    };
    return MockDataFunctionsFactory;
});

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Settore', 'User', '$mdMedia', 'toastr', '$anchorScroll', '$location', '$window'];

    function NavbarController($rootScope, $state, Auth, Principal, ProfileService, LoginService, Settore, User, $mdMedia, toastr, $anchorScroll, $location, $window) {
        var vm = this;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.screenIsSmall = $mdMedia('xs') || $mdMedia('sm');

        vm.isCommissioneAtti = $location.$$url.includes('commissione-atti');

        vm.canViewProtoSync = Principal.hasAnyAuthority(['ROLE_ADMIN']) || Principal.hasAnyAuthority(['ROLE_PROTOCOLLO']);
        vm.canViewImporterMonitorBoard = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_PROTOCOLLO']);
        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
        vm.showReportGenerator = false;
        vm.showAdempimentiReportGenerator = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_COMMISSIONE', 'ROLE_AULA']);
        vm.showGestioneSedute = canShowGestioneSedute();

        ProfileService.getProfileInfo().then(function (response) {
            vm.inDev = response.inDev;
            vm.inStaging = response.inStaging;
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
            vm.windowsAuthEnabled = response.windowsAuthEnabled;
        });

        if (vm.isAuthenticated()) {
            Principal.identity().then(function (user) {
                vm.user = user;
                if (user) {
                    vm.showGestioneSedute = canShowGestioneSedute();
                    vm.showReportGenerator = vm.user.reportGeneratorEnabled;
                    $rootScope.userDescription = user.firstName + " " + user.lastName;
                    if (!Principal.isEnteUser(user) && (!user.protocolLogin || !user.protocolPassword) && user.instantProtocolEnabled) {
                        toastr.warning("Non hai impostato le tue credenziali di protocollo! Fallo subito cliccando in alto a destra sul tuo nome e quindi su Impostazioni.")
                    }
                }
            });
        }

        // RIMUOVERE UNA VOLTA TOLTA FUNZIONALITA' DI INSERT
        $rootScope.$watch('userDescription', function () {
            if ($rootScope.userDescription) {
                initAzioniSettore();
            }
            if (vm.isAuthenticated()) {
                Principal.identity().then(function (user) {
                    vm.user = user;
                });
            }
        });

        vm.canInsert = function () {
            return vm.inDev
                    && (Principal.hasAnyAuthority(['ROLE_ADMIN'])
                            || Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'])
                            || (vm.azioniSettoriById && User.isSectorUserEnabled(vm.user, ['GENERAL_SECTIONS'], vm.azioniSettoriById)));
        };

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        vm.isTemporaryUser = function() {
            return vm.user && Principal.hasAnyAuthority(['ROLE_TEMPORARYENTE']);
        };

        vm.isCitizenUser = function() {
            return vm.user && Principal.isCitizenUser();
        };

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            vm.showGestioneSedute = false;
            //if (!vm.windowsAuthEnabled) {
            collapseNavbar();
            Auth.logout();
            vm.user = null;
            $state.go('home');
            //}
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function canShowGestioneSedute() {
            if (!vm.isAuthenticated()) {
                return false;
            }
            if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_EXTERNAL'])) {
                return true;
            }
            if (Principal.hasAnyAuthority(['ROLE_COMMISSIONE'])) {
                return Principal.isCommissionWithRole(null, 'Dipendente');
            }
            return false;
        }

        // RIMUOVERE UNA VOLTA TOLTA FUNZIONALITA' DI INSERT
        function initAzioniSettore() {
            if (Principal.hasAnyAuthority(['ROLE_SETTORE'])) {
                Settore.query({}, function (settori) {
                    vm.azioniSettoriById = {};
                    angular.forEach(settori, function (settore) {
                        vm.azioniSettoriById[settore.id] = settore.azioniAbilitate;
                    });
                });
            }
        }

        vm.onClickNotificheAnchor = function () {
            $anchorScroll('notifiche-anchor-name');
        };

        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.gtag('config', 'G-Y8RPM76EDY', {
                'cookie_domain': 'consiglio.regione.toscana.it',
                'page_path': $location.path()});
            $window.gtag('event', 'page_view');

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

/**
 * Created by Michele Romani on 27/06/2017.
 */
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pdlForm', {
            parent: 'app',
            url: '/pdlForm',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/layouts/form/form.html',
                    controller: 'FormController',
                    controllerAs: 'vm'
                }
            },
            params: {
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('form');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/**
 * Created by Michele Romani on 27/06/2017.
 */
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('FormController', FormController);

    FormController.$inject = ['$scope', 'Principal', 'Atto'];

    function FormController ($scope, Principal, Atto) {
        var vm = this;
        $scope.sezioni = Atto.getSezioni({id: "4"});
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

/**
 * Created by Michele Romani on 22/06/2017.
 */
(function () {
    'use strict';

    angular.module('gestioneAttiApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home_logged', {
            parent: 'app',
            url: '/homeLogged?page&sort&type&state&term&legislatura&numeroAttoSearch&numeroLegge&dataPromulgazione',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home_logged/homeLogged.html',
                    controller: 'HomeLoggedController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroAtto,desc',
                    squash: true
                },
                type: {
                    value: null,
                    squash:true
                },
                state: {
                    value: null,
                    squash:true
                },
                term: {
                    value: null,
                    squash:true
                },
                legislatura: {
                    value: null,
                    squash: false
                },
                numeroAttoSearch: {
                    value: null,
                    squash: true
                },
                numeroLegge: {
                    value: null,
                    squash: true
                },
                dataPromulgazione: {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('notifications');
                    $translatePartialLoader.addPart('form');
                    return $translate.refresh();
                }],
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }],
                pagingParams: ['PaginationUtil', '$stateParams', 'defaultLegislatura', function (PaginationUtil, $stateParams, defaultLegislatura) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        type: $stateParams.type,
                        state: $stateParams.state,
                        term: $stateParams.term,
                        legislatura: $stateParams.legislatura || defaultLegislatura.legislatura,
                        numeroAttoSearch: $stateParams.numeroAttoSearch,
                        numeroLegge: $stateParams.numeroLegge,
                        dataPromulgazione: $stateParams.dataPromulgazione
                    };
                }]
            }
        });
    }
})();

/**
 * Created by Michele Romani on 22/06/2017.
 */
(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('HomeLoggedController', HomeLoggedController);

    HomeLoggedController.$inject = ['$scope', 'Principal', 'LoginService', 'pagingParams'];

    function HomeLoggedController($scope, Principal, LoginService, pagingParams) {
        var vm = this;

        vm.pagingParams = pagingParams;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/home?page&sort&type&state&term&legislatura&numeroAtto&numeroLegge&dataPromulgazione',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroAtto,desc',
                    squash: true
                },
                type: {
                    value: null,
                    squash:true
                },
                state: {
                    value: null,
                    squash:true
                },
                term: {
                    value: null,
                    squash:true
                },
                legislatura: {
                    value: null,
                    squash:false
                },
                numeroAttoSearch: {
                    value: null,
                    squash: true
                },
                numeroLegge: {
                    value: null,
                    squash: true
                },
                dataPromulgazione: {
                    value: null,
                    squash: true
                }
            },
            onEnter: ['$state', 'Principal', '$timeout', function ($state, Principal, $timeout) {
                if (Principal.isAuthenticated()) {
                    $timeout(function () {
                        $state.go('home_logged', {}, {reload: true});
                    }, 0);
                }
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('tipoProponente');
                    $translatePartialLoader.addPart('form');
                    return $translate.refresh();
                }],
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }],
                pagingParams: ['PaginationUtil', '$stateParams', 'defaultLegislatura', function (PaginationUtil, $stateParams, defaultLegislatura) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        type: $stateParams.type,
                        state: $stateParams.state,
                        term: $stateParams.term,
                        legislatura: $stateParams.legislatura || defaultLegislatura.legislatura,
                        numeroAttoSearch: $stateParams.numeroAttoSearch,
                        numeroLegge: $stateParams.numeroLegge,
                        dataPromulgazione: $stateParams.dataPromulgazione
                    };
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', 'PaginationUtil', '$translate', 'pagingParams'];

    function HomeController ($scope, Principal, LoginService, $state, $stateParams, PaginationUtil, $translate, pagingParams) {
        $translate.refresh();

        var vm = this;

        vm.pagingParams = pagingParams;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;

        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('TipoDocumentoDialogController', TipoDocumentoDialogController);

    TipoDocumentoDialogController.$inject = ['$timeout', '$scope', '$translate', '$uibModalInstance', 'entity', 'TipoDocumento', 'GESTIONE_ATTI_DOC_VISIBILITIES', 'Commissione', 'CommissioneRuolo', 'SoggettoEsterno', 'Settore', 'RESOURCE_PERMISSIONS', 'ACT_TYPES'];

    function TipoDocumentoDialogController ($timeout, $scope, $translate, $uibModalInstance, entity, TipoDocumento, GESTIONE_ATTI_DOC_VISIBILITIES, Commissione, CommissioneRuolo, SoggettoEsterno, Settore, RESOURCE_PERMISSIONS, ACT_TYPES) {
        var vm = this;

        vm.tipoDocumento = entity;
        vm.authorities = RESOURCE_PERMISSIONS;

        vm.availableActTypes = ACT_TYPES;
        vm.availableCommissions = [];
        vm.availableCommissionsRoles = [];
        vm.availableExternalSubjects = [];
        vm.availableSectors = [];
        vm.visibilities = GESTIONE_ATTI_DOC_VISIBILITIES;
        
        angular.forEach(vm.visibilities, function(visibility) {
           visibility.text = $translate.instant(visibility.textKey); 
        });

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        // load availableSectors
        Settore.query({}, function (availableSectors) {
            vm.availableSectors = availableSectors;
        }, function (error) {
            toastr.error('Impossibile reperire la lista dei availableSectors: ' + error.message, 'Errore!');
        });

        // load availableCommissions
        Commissione.query({}, function (availableCommissions) {
            vm.availableCommissions = availableCommissions;
        }, function (error) {
            toastr.error('Impossibile reperire la lista delle availableCommissions: ' + error.message, 'Errore!');
        });

        // load availableCommissions ruoli
        CommissioneRuolo.query({}, function (availableCommissionsRoles) {
            vm.availableCommissionsRoles = availableCommissionsRoles;
        }, function (error) {
            toastr.error('Impossibile reperire la lista dei ruoli delle availableCommissions: ' + error.message, 'Errore!');
        });

        // load soggetti
        SoggettoEsterno.query({}, function (soggetto) {
            vm.availableExternalSubjects = soggetto;
        }, function (error) {
            toastr.error('Impossibile reperire la lista dei soggetti esterni: ' + error.message, 'Errore!');
        });

        vm.toggleAuthorityPermission = function (authority) {
            var found = -1;
            for (var i=0; i<vm.tipoDocumento.authorities.length; i++) {
                var auth = vm.tipoDocumento.authorities[i];
                if (authority.name === auth.name) {
                    found = i;
                    break;
                }
            }
            if (found === -1) {
                vm.tipoDocumento.authorities.push(authority);
            } else {
                vm.tipoDocumento.authorities.splice(found, 1);
                switch (authority.name) {
                    case "ROLE_SETTORE": vm.tipoDocumento.settori = [];
                        break;
                    case "ROLE_EXTERNAL": vm.tipoDocumento.soggettiEsterni = [];
                        break;
                    case "ROLE_COMMISSIONE": vm.tipoDocumento.commissioni = [];
                        break;
                }
            }
        };

        vm.toggleAuthoritySpecPermission = function(authority, authoritySpec) {
            var found = -1;
            for (var i=0; i<vm.tipoDocumento[authority].length; i++) {
                var auth = vm.tipoDocumento[authority][i];
                if (authoritySpec.id === auth.id) {
                    found = i;
                    break;
                }
            }
            (found > -1) ? vm.tipoDocumento[authority].splice(found, 1) : vm.tipoDocumento[authority].push(authoritySpec);
        };

        vm.toggleActTypePermission = function (actType) {
            var found = -1;
            for (var i=0; i<vm.tipoDocumento.tipiAtto.length; i++) {
                var type = vm.tipoDocumento.tipiAtto[i];
                if (type === actType) {
                    found = i;
                    break;
                }
            }
            if (found === -1) {
                vm.tipoDocumento.tipiAtto.push(actType);
            } else {
                vm.tipoDocumento.tipiAtto.splice(found, 1);
            }
        };

        vm.hasPermissionOnAuthority = function (authority) {
            for (var i = 0; i < vm.tipoDocumento.authorities.length; i++) {
                var auth = vm.tipoDocumento.authorities[i];
                if (auth.name === authority) {
                    return true;
                }
            }
            return false;
        };

        vm.hasPermissionOnAuthoritySpec = function (authority, authoritySpec) {
            for (var i = 0; i < vm.tipoDocumento[authority].length; i++) {
                var authSpec = vm.tipoDocumento[authority][i];
                if (authSpec.id === authoritySpec.id) {
                    return true;
                }
            }
            return false;
        };

        vm.hasPermissionOnActType = function (actType) {
            for (var i = 0; i < vm.tipoDocumento.tipiAtto.length; i++) {
                var type = vm.tipoDocumento.tipiAtto[i];
                if (actType === type) {
                    return true;
                }
            }
            return false;
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tipoDocumento.id !== null) {
                TipoDocumento.update(vm.tipoDocumento, onSaveSuccess, onSaveError);
            } else {
                TipoDocumento.save(vm.tipoDocumento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:tipoDocumentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('TipoDocumentoDetailController', TipoDocumentoDetailController);

    TipoDocumentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TipoDocumento'];

    function TipoDocumentoDetailController($scope, $rootScope, $stateParams, previousState, entity, TipoDocumento) {
        var vm = this;

        vm.tipoDocumento = entity;
        vm.previousState = previousState.name;

        vm.hasAuthority = function (authority) {
            if (vm.tipoDocumento.authorities.length === 0) return true;

            for (var i = 0; i < vm.tipoDocumento.authorities.length; i++) {
                var auth = vm.tipoDocumento.authorities[i];
                if (auth.name === authority) {
                    return true;
                }
            }
            return false;
        };

        var unsubscribe = $rootScope.$on('gestioneAttiApp:tipoDocumentoUpdate', function(event, result) {
            vm.tipoDocumento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('TipoDocumentoDeleteController',TipoDocumentoDeleteController);

    TipoDocumentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'TipoDocumento'];

    function TipoDocumentoDeleteController($uibModalInstance, entity, TipoDocumento) {
        var vm = this;

        vm.tipoDocumento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TipoDocumento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tipo-documento', {
            parent: 'entity',
            url: '/tipo-documento',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.tipoDocumento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tipo-documento/tipo-documentos.html',
                    controller: 'TipoDocumentoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoDocumento');
                    $translatePartialLoader.addPart('document-toolbar');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tipo-documento-detail', {
            parent: 'tipo-documento',
            url: '/tipo-documento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.tipoDocumento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tipo-documento/tipo-documento-detail.html',
                    controller: 'TipoDocumentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoDocumento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TipoDocumento', function($stateParams, TipoDocumento) {
                    return TipoDocumento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tipo-documento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tipo-documento-detail.edit', {
            parent: 'tipo-documento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-documento/tipo-documento-dialog.html',
                    controller: 'TipoDocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoDocumento', function(TipoDocumento) {
                            return TipoDocumento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-documento.new', {
            parent: 'tipo-documento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-documento/tipo-documento-dialog.html',
                    controller: 'TipoDocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                id: null,
                                authorities: [],
                                commissioni: [],
                                soggettiEsterni: [],
                                settori: [],
                                tipiAtto: []
                            }
                        }
                    }
                }).result.then(function() {
                    $state.go('tipo-documento', null, { reload: 'tipo-documento' });
                }, function() {
                    $state.go('tipo-documento');
                });
            }]
        })
        .state('tipo-documento.edit', {
            parent: 'tipo-documento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-documento/tipo-documento-dialog.html',
                    controller: 'TipoDocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoDocumento', function(TipoDocumento) {
                            return TipoDocumento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-documento', null, { reload: 'tipo-documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-documento.delete', {
            parent: 'tipo-documento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-documento/tipo-documento-delete-dialog.html',
                    controller: 'TipoDocumentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TipoDocumento', function(TipoDocumento) {
                            return TipoDocumento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-documento', null, { reload: 'tipo-documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('TipoDocumento', TipoDocumento);

    TipoDocumento.$inject = ['$resource'];

    function TipoDocumento($resource) {
        var resourceUrl = 'api/:public/tipo-documentos/:id/:seduta/:ordineDelGiorno';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'tipiDocumentoSeduta' : {
                method : 'GET',
                params : {
                    public: 'public',
                    seduta : 'seduta'
                },
                isArray : true
            },
            'tipiDocumentoOdg' : {
                method : 'GET',
                params : {
                    public: 'public',
                    ordineDelGiorno : 'ordine-del-giorno'
                },
                isArray : true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('TipoDocumentoController', TipoDocumentoController);

    TipoDocumentoController.$inject = ['TipoDocumento'];

    function TipoDocumentoController(TipoDocumento) {

        var vm = this;

        vm.tipoDocumentos = [];

        loadAll();

        function loadAll() {
            TipoDocumento.query(function(result) {
                vm.tipoDocumentos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGDialogController', StatoODGDialogController);

    StatoODGDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatoODG'];

    function StatoODGDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatoODG) {
        var vm = this;

        vm.statoODG = entity;
        vm.clear = clear;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statoODG.id !== null) {
                StatoODG.update(vm.statoODG, onSaveSuccess, onSaveError);
            } else {
                StatoODG.save(vm.statoODG, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:statoODGUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataOraCambioStato = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGDetailController', StatoODGDetailController);

    StatoODGDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'StatoODG'];

    function StatoODGDetailController($scope, $rootScope, $stateParams, previousState, entity, StatoODG) {
        var vm = this;

        vm.statoODG = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:statoODGUpdate', function(event, result) {
            vm.statoODG = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGDeleteController',StatoODGDeleteController);

    StatoODGDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatoODG'];

    function StatoODGDeleteController($uibModalInstance, entity, StatoODG) {
        var vm = this;

        vm.statoODG = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatoODG.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stato-odg', {
            parent: 'entity',
            url: '/stato-odg',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.statoODG.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stato-odg/stato-odgs.html',
                    controller: 'StatoODGController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statoODG');
                    $translatePartialLoader.addPart('statoODGType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stato-odg-detail', {
            parent: 'stato-odg',
            url: '/stato-odg/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.statoODG.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stato-odg/stato-odg-detail.html',
                    controller: 'StatoODGDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statoODG');
                    $translatePartialLoader.addPart('statoODGType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatoODG', function($stateParams, StatoODG) {
                    return StatoODG.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'stato-odg',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('stato-odg-detail.edit', {
            parent: 'stato-odg-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stato-odg.new', {
            parent: 'stato-odg',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stato: null,
                                dataOraCambioStato: null,
                                utenteCambioStato: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('stato-odg');
                });
            }]
        })
        .state('stato-odg.edit', {
            parent: 'stato-odg',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-dialog.html',
                    controller: 'StatoODGDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stato-odg.delete', {
            parent: 'stato-odg',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stato-odg/stato-odg-delete-dialog.html',
                    controller: 'StatoODGDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatoODG', function(StatoODG) {
                            return StatoODG.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stato-odg', null, { reload: 'stato-odg' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('StatoODG', StatoODG);

    StatoODG.$inject = ['$resource', 'DateUtils'];

    function StatoODG ($resource, DateUtils) {
        var resourceUrl =  'api/stato-odgs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataOraCambioStato = DateUtils.convertDateTimeFromServer(data.dataOraCambioStato);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGController', StatoODGController);

    StatoODGController.$inject = ['StatoODG'];

    function StatoODGController(StatoODG) {

        var vm = this;

        vm.statoODGS = [];

        loadAll();

        function loadAll() {
            StatoODG.query(function(result) {
                vm.statoODGS = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDialogController', SoggettoEsternoDialogController);

    SoggettoEsternoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SoggettoEsterno', 'legislature'];

    function SoggettoEsternoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SoggettoEsterno, legislature) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.clear = clear;
        vm.save = save;
        vm.legislature = legislature;
        vm.selectedLegislature = {};
        
        if (vm.soggettoEsterno.legislature) {
            vm.soggettoEsterno.legislature.forEach(function(legislatura) {
                vm.selectedLegislature[legislatura] = true;
            });
        }
        
        $scope.$watch('vm.selectedLegislature', function() {
            vm.soggettoEsterno.legislature = Object.keys(vm.selectedLegislature)
                .filter(function(key) {
                    return vm.selectedLegislature[key];
                });
        }, true);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.soggettoEsterno.id !== null) {
                SoggettoEsterno.update(vm.soggettoEsterno, onSaveSuccess, onSaveError);
            } else {
                SoggettoEsterno.save(vm.soggettoEsterno, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:soggettoEsternoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDetailController', SoggettoEsternoDetailController);

    SoggettoEsternoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SoggettoEsterno'];

    function SoggettoEsternoDetailController($scope, $rootScope, $stateParams, previousState, entity, SoggettoEsterno) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:soggettoEsternoUpdate', function(event, result) {
            vm.soggettoEsterno = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDeleteController',SoggettoEsternoDeleteController);

    SoggettoEsternoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SoggettoEsterno'];

    function SoggettoEsternoDeleteController($uibModalInstance, entity, SoggettoEsterno) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SoggettoEsterno.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('soggetto-esterno', {
            parent: 'entity',
            url: '/soggetto-esterno?legislatura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.soggettoEsterno.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esternos.html',
                    controller: 'SoggettoEsternoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('soggettoEsterno');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('soggetto-esterno-detail', {
            parent: 'soggetto-esterno',
            url: '/soggetto-esterno/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.soggettoEsterno.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-detail.html',
                    controller: 'SoggettoEsternoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('soggettoEsterno');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SoggettoEsterno', function($stateParams, SoggettoEsterno) {
                    return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'soggetto-esterno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                legislature: ['Atto', function(Atto) {
                    return Atto.queryLegislature().$promise;
                }]
            }
        })
        .state('soggetto-esterno-detail.edit', {
            parent: 'soggetto-esterno-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('soggetto-esterno.new', {
            parent: 'soggetto-esterno',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        },
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('soggetto-esterno');
                });
            }]
        })
        .state('soggetto-esterno.edit', {
            parent: 'soggetto-esterno',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('soggetto-esterno.delete', {
            parent: 'soggetto-esterno',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-delete-dialog.html',
                    controller: 'SoggettoEsternoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('SoggettoEsterno', SoggettoEsterno);

    SoggettoEsterno.$inject = ['$resource'];

    function SoggettoEsterno ($resource) {
        var resourceUrl =  'api/:public/soggetto-esternos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', params: {public: 'public'}, isArray: true},
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoController', SoggettoEsternoController);

    SoggettoEsternoController.$inject = ['SoggettoEsterno', 'Atto', '$stateParams', '$state'];

    function SoggettoEsternoController(SoggettoEsterno, Atto, $stateParams, $state) {

        var vm = this;
        vm.basicSearchLegislatura = $stateParams.legislatura;

        vm.soggettoEsternos = [];
        vm.transition = transition;

        vm.legislature = [];
        Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);

        function onSuccessLeg(data){
            vm.legislature=data;
            if(vm.legislature && vm.legislature.indexOf(11) === -1) {
                vm.legislature.push(11);
            }
        }
        function onErrorLeg(error){
            console.log("Failure!", error);
            toastr.error(error.data.message);
        }

        loadAll();

        function loadAll() {
            SoggettoEsterno.query({legislature: vm.basicSearchLegislatura}, function(result) {
                vm.soggettoEsternos = result;
                vm.searchQuery = null;
            });
        }

        function transition() {

            if(vm.basicSearchLegislatura && vm.basicSearchLegislatura !== 'ALL') {
                $state.transitionTo($state.$current, {
                    legislatura: vm.basicSearchLegislatura
                });
            }else {
                console.log(vm.basicSearchLegislatura)
                $state.transitionTo($state.$current, {
                    legislatura: null
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('sincronizzatore-anagrafiche', {
                    parent: 'account',
                    url: '/sincronizzatore-anagrafiche',
                    data: {
                        authorities: ['ROLE_ADMIN', 'ROLE_PROTOCOLLO'],
                        pageTitle: 'sincronizzatore.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/SincronizzatoreAnagrafiche/sincronizzatore-anagrafiche.html',
                            controller: 'SincronizzatoreAnagraficheController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');

                                return $translate.refresh();
                            }],
                        runningSyncro: ['SincronizzatoreAnagrafiche', function (SincronizzatoreAnagrafiche) {
                                return SincronizzatoreAnagrafiche.getRunningSyncro().$promise;
                            }],
                        latestSyncro: ['SincronizzatoreAnagrafiche', function (SincronizzatoreAnagrafiche) {
                            return SincronizzatoreAnagrafiche.getLatestSyncro().$promise;
                        }],     
                    }
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('SincronizzatoreAnagrafiche', SincronizzatoreAnagrafiche);

        SincronizzatoreAnagrafiche.$inject = ['$resource'];

    function SincronizzatoreAnagrafiche ($resource) {
        var resourceUrl =  'api/:public/sincronizzatore-anagrafiche/:id/:latest';

        return $resource(resourceUrl, {}, {
            'startSyncro': { method: 'POST', isArray: false},
            'getRunningSyncro': {
                method: 'GET',
                isArray: true
/*                 transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                } */
            },
            'getLatestSyncro': {
                method: 'GET',
                isArray: true,
                params: {latest: 'latest'}
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SincronizzatoreAnagraficheController', SincronizzatoreAnagraficheController);

    SincronizzatoreAnagraficheController.$inject = ['$state', 'SincronizzatoreAnagrafiche', 'runningSyncro', 'toastr', 'latestSyncro'];

    function SincronizzatoreAnagraficheController($state, SincronizzatoreAnagrafiche, runningSyncro, toastr, latestSyncro) {
        var vm = this;
        vm.anagraficTypeCodes = ['UFF', 'EST' , 'DIP'];
        vm.selectedCode = null;
        vm.runningSyncro = runningSyncro;
        vm.latestSyncro = latestSyncro;

        vm.clickStart = function() {
            if(vm.selectedCode === null){
                toastr.error("Devi specificare il tipo anagrafica");
                return;
            }
            SincronizzatoreAnagrafiche.startSyncro({anagraficTypeCode: vm.selectedCode}, {}, onSuccess, onError);
        };

        function onSuccess(result){
            vm.runningSyncro.push(result);
        }

        function onError(error) {
            console.log("Failure!", error);
            toastr.error(error.data.message);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreDialogController', SettoreDialogController);

    SettoreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Settore'];

    function SettoreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Settore) {
        var vm = this;

        vm.settore = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.settore.id !== null) {
                Settore.update(vm.settore, onSaveSuccess, onSaveError);
            } else {
                Settore.save(vm.settore, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:settoreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreDetailController', SettoreDetailController);

    SettoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Settore'];

    function SettoreDetailController($scope, $rootScope, $stateParams, previousState, entity, Settore) {
        var vm = this;

        vm.settore = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:settoreUpdate', function(event, result) {
            vm.settore = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreDeleteController',SettoreDeleteController);

    SettoreDeleteController.$inject = ['$uibModalInstance', 'entity', 'Settore'];

    function SettoreDeleteController($uibModalInstance, entity, Settore) {
        var vm = this;

        vm.settore = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Settore.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('settore', {
            parent: 'entity',
            url: '/settore',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.settore.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/settore/settores.html',
                    controller: 'SettoreController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settore');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('settore-detail', {
            parent: 'settore',
            url: '/settore/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.settore.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/settore/settore-detail.html',
                    controller: 'SettoreDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settore');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Settore', function($stateParams, Settore) {
                    return Settore.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'settore',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('settore-detail.edit', {
            parent: 'settore-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('settore.new', {
            parent: 'settore',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('settore');
                });
            }]
        })
        .state('settore.edit', {
            parent: 'settore',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-dialog.html',
                    controller: 'SettoreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('settore.delete', {
            parent: 'settore',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/settore/settore-delete-dialog.html',
                    controller: 'SettoreDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Settore', function(Settore) {
                            return Settore.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('settore', null, { reload: 'settore' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('Settore', Settore);

    Settore.$inject = ['$resource'];

    function Settore($resource) {
        var resourceUrl = 'api/:public/settores/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', params: {public: 'public'}, isArray: true},
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreController', SettoreController);

    SettoreController.$inject = ['Settore'];

    function SettoreController(Settore) {

        var vm = this;

        vm.settores = [];

        loadAll();

        function loadAll() {
            Settore.query(function(result) {
                vm.settores = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sedute-pubbliche', {
            parent: 'app', 
            url: '/sedute-pubbliche?page&sort&legislatura&anno&tipoOrganismo&idOrganismo',
            data: {
                authorities: [],
                pageTitle: 'gestioneAttiApp.sedute-pubbliche.title' 
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sedute-pubbliche/sedute-pubbliche.html',
                    controller: 'SedutePubblicheController',
                    controllerAs: 'vm'
                },
                'navbar@' : {
                    templateUrl: 'app/layouts/navbar/navbar-commission-pages.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroSeduta,desc',
                    squash: false
                },
                anno : {
                    value: null,
                    squash: false
                },
                tipoOrganismo : {
                    value: null,
                    squash: false
                },
                idOrganismo : {
                    value: null,
                    squash: false
                },
                legislatura : {
                    value: null,
                    squash: false
                },
            },
            resolve: {
                legislaturaDetails: ['Atto', '$stateParams', function(Atto, $stateParams) {
                    return Atto.legislatura({default: $stateParams.legislatura}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('seduta');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('SedutaPubblica', SedutaPubblica);

    SedutaPubblica.$inject = ['$resource', 'DateUtils'];

    function SedutaPubblica($resource, DateUtils) {

        var resourceUrl = 'api/public/sedute';

        return $resource(resourceUrl, {}, {

            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        angular.forEach(data, function(seduta) {
                            seduta.dataSeduta = DateUtils.convertDateTimeFromServer(seduta.dataSeduta);
                        });
                    }
                    return data;
                }
            },

            'getDettagliCommissione': {
                url: 'api/public/commissiones/:idCommissione',
                method: 'GET'
            },

            'getDettagliSoggettoEsterno': {
                url: 'api/public/soggetto-esternos/:idSoggettoEsterno',
                method: 'GET'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutePubblicheController', SedutePubblicheController);

    SedutePubblicheController.$inject = ['$state', '$stateParams', 'SedutaPubblica', 'Documento', 'FileSaver','paginationConstants', 'legislaturaDetails', 'PaginationUtil','toastr'];

    function SedutePubblicheController($state, $stateParams,  SedutaPubblica, Documento, FileSaver, paginationConstants, legislaturaDetails, PaginationUtil, toastr) {
        var vm = this;


        vm.legislaturaDetails = legislaturaDetails;
        vm.legislatura = $stateParams.legislatura;
        vm.idOrganismo = $stateParams.idOrganismo;
        vm.tipoOrganismo = $stateParams.tipoOrganismo;
        vm.anno = $stateParams.anno;
        vm.page = $stateParams.page;
        vm.sort = $stateParams.sort;
        vm.predicate = PaginationUtil.parsePredicate($stateParams.sort),
        vm.ascending = PaginationUtil.parseAscending($stateParams.sort),

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        
        vm.sedute = [];
        vm.organismo = {};
        vm.anniDisponibili = [];

        vm.caricaSedute = caricaSedute;
        vm.transition = transition;
        vm.downloadDocument = downloadDocument;
        vm.getOdgTitle = getOdgTitle;

        init();

        function init() {
            caricaDettagliOrganismo();
            calcolaAnniDisponibili(vm.legislaturaDetails.validityStartDate, vm.legislaturaDetails.validityEndDate);
            caricaSedute();
            
        }

        function calcolaAnniDisponibili(startDate, endDate) {
            var annoInizio = new Date(startDate).getFullYear();
            var annoCorrente = new Date().getFullYear();
            var annoFine;
            if(!endDate) {
                annoFine = annoCorrente;
            } else {
                annoFine = new Date(endDate).getFullYear();
            }
            if(!vm.anno) {
                vm.anno = annoCorrente;
            }

            for (var i = annoInizio; i <= annoFine; i++) {
                vm.anniDisponibili.push(i);
            }
        }

        function caricaDettagliOrganismo() {

            if (!vm.idOrganismo) {
                return;
            }

            if (vm.tipoOrganismo === 'C') {

                SedutaPubblica.getDettagliCommissione({ idCommissione: vm.idOrganismo }, onSuccessGetOrganismo, onErroGetOrganismo);
            } else {
                SedutaPubblica.getDettagliSoggettoEsterno({ idSoggettoEsterno: vm.idOrganismo }, onSuccessGetOrganismo, onErroGetOrganismo);
            }
        }

        function onSuccessGetOrganismo(result) {
            vm.organismo = result;
        }

        function onErroGetOrganismo(error) {
            toastr.error("Errore nel recupero dei dettagli dell'organismo", error);
        }

        function caricaSedute() {

            SedutaPubblica.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                legislatura: vm.legislatura,
                idOrganismo: vm.idOrganismo,
                tipoOrganismo: vm.tipoOrganismo,
                anno: vm.anno
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sedute = data;
            }

            function onError(error) {
                toastr.error("Errore nel caricamento delle sedute", error);
                vm.sedute = [];
            }
        }

        function downloadDocument(docId, docName) {
            Documento.getDocSedutaContent(docId).then(function (result) {
                if (result) {
                    FileSaver.saveAs(new Blob([result.data], {}), docName);
                }
            }, function () {
                toastr.error('Impossibile scaricare il documento', 'Errore!');
            });
        }

        function transition(resetPage) {

            if(resetPage) {
                vm.page = 1;
            }
        
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                idOrganismo: vm.idOrganismo,
                tipoOrganismo: vm.tipoOrganismo,
                legislatura: vm.legislatura,
                anno: vm.anno
            });

        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];      
            return result;
        }

        function getOdgTitle(index) {
            if (index === 0) return "Ordine del giorno";
            return "ODG Aggiuntivo";
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaSelectWorkingController', SedutaSelectWorkingController);

    SedutaSelectWorkingController.$inject = ['$timeout', '$mdDialog', '$state', 'Seduta', 'legislature', 'legislatura', 'toastr', '$rootScope', 'TIPO_NUMERAZIONE_SEDUTA'];

    function SedutaSelectWorkingController ($timeout, $mdDialog, $state, Seduta, legislature, legislatura, toastr, $rootScope, TIPO_NUMERAZIONE_SEDUTA) {
        var vm = this;

        vm.workingBody = null;
        vm.clear = clear;
        vm.save = save;
        vm.legislatura = legislatura;
        vm.legislature = legislature;
        vm.TIPO_NUMERAZIONE_SEDUTA = TIPO_NUMERAZIONE_SEDUTA;
        vm.years = [];
        vm.selectedYear = null;

        initController();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function initController() {
            loadOrganismi();
            var currentYear = new Date().getFullYear();
            vm.selectedYear = currentYear;
            // Genera le opzioni degli anni dal 2022 all'anno attuale
            for (var year = currentYear + 1; year >= 2022; year--) {
                vm.years.push(year);
            }

        }

        function clear () {
            $mdDialog.cancel();
            $state.go('home');
        }

        function save () {
            vm.isSaving = true;

            if (validForm()) {
            //if (vm.workingBody !== null && vm.legislatura !== null) {
                $mdDialog.cancel();
                $state.go('seduta', {
                    idOrg: vm.workingBody.id, 
                    typeOrg : vm.workingBody.tipoOrganismo, 
                    nameOrg: vm.workingBody.nome,
                    legislatureOrg: vm.workingBody.legislature,
                    legislatura : vm.legislatura,
                    anno: vm.selectedYear} , {reload: false});
            } else {
                vm.isSaving = false;
                toastr.error("Parametri obbligatori non inseriti");
            }
            
        }

        function validForm() {

            if(vm.workingBody === null) return false;
            if(vm.workingBody.tipoNumerazioneSeduta === TIPO_NUMERAZIONE_SEDUTA.ANNO) {
                return !(vm.selectedYear === null || vm.selectedYear === undefined || vm.selectedYear === "");
            } else if (vm.workingBody.tipoNumerazioneSeduta === TIPO_NUMERAZIONE_SEDUTA.LEGISLATURA) {
                vm.selectedYear = null;
                return !(vm.legislatura === null || vm.legislatura === undefined);
            } else {
                vm.selectedYear = null;
                return !(vm.legislatura === null || vm.legislatura === undefined);
            }
        }

        function loadOrganismi() {
            Seduta.organismiUtente({legislature: vm.legislatura}, function(result) {
                vm.organismi = result;
            });
        }

        vm.legislaturaChanged = function() {
            vm.workingBody = null;
            vm.organismi = [];
            loadOrganismi();
        };

        
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaDialogController', SedutaDialogController);

    SedutaDialogController.$inject = ['$state', 'toastr', '$timeout', '$mdDialog', 'entity', 'Seduta', 'workingBody', 'nextNumeroSeduta', 'organismiSeduta', 'Commissione', 'SoggettoEsterno','SedutaCommonService', 'anno'];

    function SedutaDialogController ($state, toastr, $timeout, $mdDialog, entity, Seduta, workingBody, nextNumeroSeduta, organismiSeduta, Commissione, SoggettoEsterno, SedutaCommonService, anno) {
        var vm = this;

        vm.anno = anno;
        vm.seduta = entity;
        vm.workingBody = workingBody;
        vm.organismiSeduta = organismiSeduta;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.clear = clear;
        vm.workingBodyOrganismo = null;
        
        initController();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('seduta', vm.workingBody , {reload: false});
        }

        function save () {
            vm.isSaving = true;
            if(SedutaCommonService.checkAnnoSedutaDataConvocazione(vm.anno, vm.seduta)) {
                if(SedutaCommonService.fromSedutaViewToSedutaBE(vm.seduta, vm.workingBody)) {
                    if (vm.seduta.id !== null) {
                        Seduta.update({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                    } else {
                        Seduta.saveWithWB({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                    }
                } else {
                    vm.isSaving = false;
                }
            } else {
                var message = "Stai lavorando alle sedute dell'anno " + vm.anno + ", ma la data di convocazione è relativa ad un anno diverso. " +
                "\nImpossibile salvare la seduta. Tornare nella lista sedute e selezionare l'anno coerente con la data di convocazione.";
                toastr.error(message, "Errore nel salvataggio della seduta.");
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('seduta', vm.workingBody, {reload: true});
        }

        function onSaveError(error) {
            toastr.error("Errore nel salvataggio della seduta.");
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataDiConvocazione = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getWorkingBodyOrganismo() {
            if(vm.workingBody.tipoOrganismo === 'C') {
                Commissione.get({id: vm.workingBody.id}, {}, function(result) {
                    vm.workingBodyOrganismo = result;
                    vm.legislatureOrganismo = result.legislature;
                    vm.seduta.organizzatore = result.nome;
                });
            } else if(vm.workingBody.tipoOrganismo === 'E') {
                SoggettoEsterno.get({id: vm.workingBody.id}, {}, function(result) {
                    vm.workingBodyOrganismo = result;
                    vm.legislatureOrganismo = result.legislature;
                    vm.seduta.organizzatore = result.nome;
                });
            }
        }

        function initController(){

            vm.isSaving = false;

            vm.seduta.legislatura = workingBody.legislatura;
            // Informazioni organizzatore
            vm.seduta.idOrganizzatore = workingBody.id;
            vm.seduta.tipoOrganizzatore = workingBody.tipoOrganismo;
            // nextNumeroSeduta.numero viene chiesto al backend ed è il prossimo numero di seduta per l'organismo che sta creando la seduta (può essere modificato dall'utente)
            if(nextNumeroSeduta) {
                vm.numeroSeduta = nextNumeroSeduta.numero;
            } else {
                vm.numeroSeduta = SedutaCommonService.getNumeroSedutaOfWorkingBody(vm.seduta, workingBody);
            }
            vm.seduta.numeroSeduta = vm.numeroSeduta;
            
            loadOrganismiSedutaCongiunta();
            
            if(!vm.seduta.dataDiConvocazione) {
                vm.seduta.dataDiConvocazione = new Date();
            }
            vm.seduta.dataDiConvocazione.setSeconds(0);

            // In fase di edit seleziona solo i membri partecipanti
            if(!vm.seduta.membriSeduta) {
                vm.seduta.membriSeduta = [];
            } else {
                var adjMembri = [];
                for( var i in vm.seduta.membriSeduta) {
                    var membroCur = vm.seduta.membriSeduta[i];
                    if(!membroCur.isOrganizzatore){
                        for(var j in vm.organismiSeduta) {
                            var organismoCur = vm.organismiSeduta[j];
                            if(organismoCur.tipoOrganismo === membroCur.tipoMembro && organismoCur.id === membroCur.idMembro) {
                                adjMembri.push(organismoCur);
                            }
                        }
                       
                    }

                }
                vm.seduta.membriSeduta = adjMembri;
            }

            
            getWorkingBodyOrganismo();
        

        }

        function loadOrganismiSedutaCongiunta() {
            Seduta.organismiSeduta({legislature: vm.seduta.legislatura}, function(result) {
                vm.organismiSeduta = result;
                SedutaCommonService.removeWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
            });
        }

        vm.legislaturaChanged = function() {
            loadOrganismiSedutaCongiunta();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaDetailController', SedutaDetailController);

    SedutaDetailController.$inject = ['$scope', '$rootScope', '$state', '$timeout', 'toastr', 'previousState', 'entity', 'Seduta', 'SedutaCommonService', 'workingBody', 
        'organismiSeduta', 'docTypes', 'Commissione', 'SoggettoEsterno', 'OrdineDelGiorno', 'FileSaver', 'legislature', '$mdDialog', '$mdSidenav', 'editable', 'utente'];

    function SedutaDetailController($scope, $rootScope, $state, $timeout, toastr, previousState, entity, Seduta, SedutaCommonService, workingBody, 
        organismiSeduta, docTypes, Commissione, SoggettoEsterno, OrdineDelGiorno, FileSaver, legislature, $mdDialog, $mdSidenav, editable, utente) {
        var vm = this;

        vm.seduta = entity;
        vm.utente = utente;
        vm.previousState = previousState.name;
        vm.previousStateParams = previousState.params;
        vm.workingBody = workingBody;
        vm.legislature = legislature;
        vm.legislatureOrganismo = legislature;
        vm.showStateHistory;
        vm.isEditing = editable;
        vm.isNumberEditing = false;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.ordiniDelGiorno = [];
        vm.docsToUpdate = [];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dataDiConvocazioneEdit = false;
        vm.openCalendar = openCalendar;
        vm.prepareEditing = prepareEditing;
        vm.prepareNumberEditing = prepareNumberEditing;
        vm.saveSeduta = saveSeduta;
        vm.changeDocumentVisibility = changeDocumentVisibility;
        vm.changeDocumentType = changeDocumentType;
        vm.updateDocuments = updateDocuments;
        vm.performButtonAction = performButtonAction;
        vm.generateAffariTrattatiDocument = generateAffariTrattatiDocument;
        vm.generateAffariTrattatiPDFReport = generateAffariTrattatiPDFReport;
        vm.toggleEsitoPublish = toggleEsitoPublish;
        vm.legislaturaChanged = legislaturaChanged;
        vm.organismoWorkingBody = {};
        vm.canSeeEditButton = canSeeEditButton;
        vm.canSeeEditNumberButton = canSeeEditNumber;
        
        initController();

        var unsubscribe = $rootScope.$on('gestioneAttiApp:sedutaUpdate', function(event, result) {
            vm.seduta = result;
        });
        $scope.$on('$destroy', unsubscribe);

        var confirmTransitionDlg = $mdDialog.confirm()
                .title('Attenzione!')
                .textContent("L'operazione richiesta non è reversibile, sei sicuro di voler procedere?")
                .ariaLabel('conferma transizione di stato')
                .ok('Conferma')
                .cancel('Annulla');

        function initController(){

            vm.organismiSeduta = organismiSeduta;
            // Prima recupera l'organizzatore dagli organismi
            vm.organismoWorkingBody = SedutaCommonService.getOrganismoWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
            // Se non trovato, evita errori e prosegui con valori di fallback
            if(!vm.organismoWorkingBody) {
                console.log('Organismo working body non trovato. Procedo con fallback.');
                vm.organismoWorkingBody = {};
            }
            // Poi rimuove l'organizzatora dalla lista (per non presentarlo nella selezione dei partecipanti)
            if(SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody)) {
                SedutaCommonService.removeWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
            }

            if (vm.organismoWorkingBody.nome) {
                vm.workingBody.nome = vm.organismoWorkingBody.nome;
            }
            vm.legislatureOrganismo = vm.organismoWorkingBody.legislature || vm.legislature;
            vm.seduta.partecipantiSeduta = SedutaCommonService.getPartecipantiSeduta(vm.seduta);
            SedutaCommonService.fromSedutaBEToSedutaView(vm.seduta, vm.workingBody, vm.organismiSeduta);

            //Recupero ordini del giorno seduta
            OrdineDelGiorno.getAllByIdSeduta({idSeduta: vm.seduta.id},
                function (data) {
                    vm.ordiniDelGiorno = data;
                },
                onError);

            function onError(error) {
                toastr.error(error.data.message);
            }

            initButtons();

            vm.docTypes = docTypes;
            vm.docsToUpdate = [];
            
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function prepareEditing(){
            vm.isEditing = !vm.isEditing;
            initButtons();
        }

        function prepareNumberEditing(){
            vm.isNumberEditing = !vm.isNumberEditing;
        }

        function saveSeduta(){
            if(SedutaCommonService.fromSedutaViewToSedutaBE(vm.seduta, vm.workingBody)){
                if (vm.seduta.id !== null) {
                    Seduta.update({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                } else {
                    Seduta.saveWithWB({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                }

                vm.updateDocuments();
            }
            
        }

        function onSaveSuccess(result) {
            toastr.success("Seduta salvata con successo");
            vm.isEditing = false;
            vm.isNumberEditing = false;
            reloadPage();
        }

        function onSaveError(error) {
            toastr.error("Errore nel salvataggio della seduta.");
            vm.isEditing = false;
            vm.isNumberEditing = false;
        }

        function canSeeEditNumber(seduta){
            if (SedutaCommonService.canEditSedutaNumber(vm.utente, seduta, vm.workingBody)) {
                return SedutaCommonService.isSedutaEditable(seduta) && !vm.isEditing;
            } else {
                return false;
            }
        }

        function canSeeEditButton(seduta) {
            if (SedutaCommonService.canEditSeduta(vm.utente, seduta, vm.workingBody)) {
                return SedutaCommonService.isSedutaEditable(seduta) && !vm.isEditing;
            }
            return false;
        }

        function initButtons(){
            vm.visibleButtons = [];

            if(SedutaCommonService.canEditSeduta(vm.utente, vm.seduta, vm.workingBody)) {

                if(vm.seduta.statoCorrente.statoSeduta === 'A' && vm.isEditing) {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.publishAffariTrattati",
                            action: publishAffariTrattati,
                            iconClass: "glyphicon-send",
                            nextStateName : "PAT"
                        },
                        {
                            title: "entity.action.publishSeduta",
                            action: publishSeduta,
                            iconClass: "glyphicon-send",
                            nextStateName : "P"
                        },
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                } else if(vm.seduta.statoCorrente.statoSeduta === 'PAT' && vm.isEditing) {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.publishSeduta",
                            action: publishSeduta,
                            iconClass: "glyphicon-send",
                            nextStateName : "P"
                        },
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                } else if(vm.seduta.statoCorrente.statoSeduta === 'P') {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                }
            }

        }

        function publishAffariTrattati(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('PAT');
            });
        }

        function publishSeduta(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('P');
            });
        }

        function revokeSeduta(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('X');
            });
        }

        function transitionTo(newState) {
            Seduta.sedutaStateTransition({id: vm.seduta.id, nextStateName: newState} , null , function (success) {
                if(newState === 'P' || newState === 'PAT') {
                    toastr.success('Seduta <b>aggiornata</b> con successo', 'Okay!');
                } else if( newState === 'X') {
                    toastr.success('Seduta <b>revocata</b> con successo', 'Okay!');
                }
                reloadPage();
            }, function (error) {
                var labelStato;
                if(newState === 'PAT') labelStato = "Pubblicazione Affari Trattati";
                if(newState === 'P') labelStato = "Pubblicata";
                if(newState === 'X') labelStato = "Revocata";
                toastr.error('Impossibile eseguire il passaggo allo stato <b>' + labelStato + '</b>:<br/>' + error.data.description, 'Errore!');
            });
        }

        function performButtonAction(button){
            if(button.action){
                button.action( button.nextStateName);
            }
        }

        function reloadPage() {
            $timeout(function () {
                $state.reload();
            }, 0);
        }

        function generateAffariTrattatiDocument(){         
            vm.documentParams = {
                legislatura: vm.seduta.legislatura,
                numeroSeduta: vm.seduta.numeroSeduta,
                idSeduta: vm.seduta.id
            };

            Seduta.generateAffariTrattatiDocument({}, vm.documentParams, onSuccess, onError);

            function onSuccess(result) {
                toastr.success('Documento ODG scaricato con successo nella cartella Download!');
            }
            function onError(error) {
                console.log(error);
            }
        }

        function generateAffariTrattatiPDFReport() {
            Seduta.getAffariTrattatiPDFReport(vm.seduta.id).then(
                function(result) {
                    FileSaver.saveAs(new Blob([result.data], {}), "reportAffariTrattati.pdf");
                }, 
                function(error) {
                    var errorCode = error.headers('X-gestioneAttiApp-error');
                    var errorText = '';
                    if(errorCode === 'error.noContent') {
                        errorText = 'Nessun affare trattato e\' stato trovato per questa seduta';
                    } else if(errorCode === 'error.forbiddenOp') {
                        errorText = 'La tua utenza non e\' abilitata alla generazione di report. Si prega di contattare l\'amministratore'
                    } else {
                        errorText = 'Errore inaspettato. Si prega di riprovare o contattare l\'amministratore!'
                    }
                    toastr.error(errorText, "Errore!", {
                        timeOut: 60000,
                        extendedTimeOut: 0
                    });
                });
        }
        function toggleEsitoPublish () {
            $mdSidenav('sedutaEsitoPublish').toggle();
        }

        function legislaturaChanged() {
            Seduta.organismiSeduta({legislature: vm.seduta.legislatura}, function(result) {
                vm.organismiSeduta = result;
                // Prima recupera l'organizzatore dagli organismi
                vm.organismoWorkingBody = SedutaCommonService.getOrganismoWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
                if(!vm.organismoWorkingBody) {
                    console.log('Organismo working body non trovato dopo cambio legislatura. Fallback.');
                    vm.organismoWorkingBody = {};
                }
                if (vm.organismoWorkingBody.nome) {
                    vm.workingBody.nome = vm.organismoWorkingBody.nome;
                }
                vm.legislatureOrganismo = vm.organismoWorkingBody.legislature || vm.legislature;
                // Poi rimuove l'organizzatora dalla lista (per non presentarlo nella selezione dei partecipanti)
                if(SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody)) {
                    SedutaCommonService.removeWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
                }
            });
        }

        function changeDocumentVisibility(doc, newDocumentVisibility) {
            markDocumentForUpdate(doc);
        }

        function changeDocumentType(doc, newDocumentType) {
            markDocumentForUpdate(doc);
        }

        function markDocumentForUpdate(doc) {
            var foundIndex = -1;
        
            for (var i = 0; i < vm.docsToUpdate.length; i++) {
                if (vm.docsToUpdate[i].id === doc.id) {
                    foundIndex = i;
                    break;
                }
            }
        
            if (foundIndex === -1) {
                vm.docsToUpdate.push(doc);
            } else {
                vm.docsToUpdate[foundIndex] = doc;
            }
        }


        function updateDocuments() {
            
            if(vm.docsToUpdate) {
                angular.forEach(vm.docsToUpdate, function(doc) {
                    Seduta.updateDocument({id: vm.seduta.id, idDoc: doc.id }, doc, onSuccessDoc, onErrorDoc);
                });
            }
        }

        function onSuccessDoc(result) {
            toastr.success('Documento aggiornato!');
        }
        function onErrorDoc(error) {
            toastr.error('Impossibile salvare alcuni documenti: ' + ((error && error.data) ? error.data.message : 'Errore Sconosciuto'), 'Errore!');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaDeleteController',SedutaDeleteController);

    SedutaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Seduta', 'toastr'];

    function SedutaDeleteController($uibModalInstance, entity, Seduta, toastr) {
        var vm = this;

        vm.seduta = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Seduta.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaCopyController',SedutaCopyController);

    SedutaCopyController.$inject = ['$uibModalInstance', '$stateParams', 'puntiODG','toastr'];

    function SedutaCopyController($uibModalInstance, $stateParams, puntiODG, toastr) {
        var vm = this;

        vm.numeroSeduta = $stateParams.numeroSeduta;
        vm.legislatura = $stateParams.legislatura;
        vm.puntiODG = puntiODG;
        vm.title = "";
        vm.textToCopy = [];

        vm.clear = clear;
        vm.copyRichTextToClipboard = copyRichTextToClipboard;
        vm.generateRichTextToCopy = generateRichTextToCopy;

        generateTextToCopy();
        generateRichTextToCopy();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function generateTextToCopy() {
            vm.title = "Legislatura " + vm.legislatura 
                + " - Seduta n°" + vm.numeroSeduta;
            
            
            for (var i = 0; i < vm.puntiODG.length; i++) {
                vm.textToCopy[i] = {};
                vm.textToCopy[i].text = vm.puntiODG[i].testoPuntoODG;
                vm.textToCopy[i].esito = vm.puntiODG[i].descrizioneEsitoPuntoODG;
                //if(vm.puntiODG[i].idAtto) {
                    //vm.textToCopy[i].attachedActUrl = "https://iterlegis.consiglio.regione.toscana.it/#/atto/" + vm.puntiODG[i].idAtto + "/";
                //}

            }
        }

        function generateRichTextToCopy() {
            /*vm.richTextToCopy = 
                "<p style=\"text-align: center;\"><span style=\"font-size: large;\"><strong>" + vm.title + "</strong></span></p> \n";

            vm.richTextToCopy = vm.richTextToCopy + "<table> \n";*/
            vm.richTextToCopy = "<table> \n";

            for (var i = 0; i < vm.puntiODG.length; i++) {
                if(vm.puntiODG[i].descrizioneEsitoPuntoODG) {
                    vm.richTextToCopy = vm.richTextToCopy + "<tr> \n";
                
                    if(vm.textToCopy[i].attachedActUrl) {
                        vm.richTextToCopy = vm.richTextToCopy + "<td><a href=\"" + vm.textToCopy[i].attachedActUrl + "\">" + vm.puntiODG[i].testoPuntoODG + "</a></td> \n";
                    } else {
                        vm.richTextToCopy = vm.richTextToCopy + "<td>" + vm.puntiODG[i].testoPuntoODG + "</td> \n";
                    }
                    vm.richTextToCopy = vm.richTextToCopy + "<td>" + vm.puntiODG[i].descrizioneEsitoPuntoODG + "</td> \n";
                
                    vm.richTextToCopy = vm.richTextToCopy + "</tr> \n";
                }
            }      
            vm.richTextToCopy = vm.richTextToCopy + "</table> \n";
        }

        function copyRichTextToClipboard(textToCopy) {
            function listener(e) {
                e.clipboardData.setData("text/html", textToCopy);
                e.clipboardData.setData("text/plain", textToCopy);
                e.preventDefault();
            }
            document.addEventListener("copy", listener);
            document.execCommand("copy");
            document.removeEventListener("copy", listener);

            toastr.success("Affari trattati copiati nella clipboard!");

        }     

    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('seduta', {
            parent: 'entity',
            url: '/seduta/:typeOrg/:idOrg?page&sort&search&legislatura&anno&minNum&maxNum&minDataConv&maxDataConv&testoOdg',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.seduta.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seduta/sedutas.html',
                    controller: 'SedutaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dataDiConvocazione,desc',
                    squash: false
                },
                search: null,
                legislatura : {
                    value: null,
                    squash: false
                },
                anno : {
                    value: null,
                    squash: false
                },
                idOrg: {
                    value: null,
                    squash: false
                },
                typeOrg: {
                    value: null,
                    squash: false
                },
                nameOrg: {
                    value: null
                },
                minNum: {
                    value: null,
                    squash: true
                    
                },
                maxNum: {
                    value: null,
                    squash: true
                },
                minDataConv: {
                    value: null,
                    squash: true
                },
                maxDataConv: {
                    value: null,
                    squash: true
                },
                testoOdg: {
                    value: null,
                    squash: true
                },
                legislatureOrg : {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', 'defaultLegislatura', function ($stateParams, PaginationUtil, defaultLegislatura) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        legislatura: $stateParams.legislatura || defaultLegislatura.legislatura,
                        anno: $stateParams.anno,
                        minNum: $stateParams.minNum,
                        maxNum: $stateParams.maxNum,
                        minDataConv: $stateParams.minDataConv,
                        maxDataConv: $stateParams.maxDataConv,
                        testoOdg: $stateParams.testoOdg
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seduta');
                    $translatePartialLoader.addPart('tipoSeduta');
                    $translatePartialLoader.addPart('statoSeduta');
                    $translatePartialLoader.addPart('tipoOrganizzatore');
                    $translatePartialLoader.addPart('ordineDelGiorno');
                    $translatePartialLoader.addPart('addable-input');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                workingBody: ['$stateParams', function($stateParams) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nameOrg,
                        legislature: $stateParams.legislatureOrg
                    };
                }],
                utente: ['Principal', function (Principal) {
                    return Principal.identity();
                }]
            },
        })
        .state('seduta-detail', {
            parent: 'seduta',
            url: '/{id}/detail',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.seduta.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seduta/seduta-detail.html',
                    controller: 'SedutaDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                nameOrg: {
                    value: null,
                }
            },
            resolve: {
                editable: function () {
                    return false;
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('seduta');
                    $translatePartialLoader.addPart('tipoSeduta');
                    $translatePartialLoader.addPart('statoSeduta');
                    $translatePartialLoader.addPart('tipoOrganizzatore');
                    $translatePartialLoader.addPart('statoODGType');
                    $translatePartialLoader.addPart('document-toolbar');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                    return Seduta.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'seduta',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                legislature : [ 'Atto', function(Atto){
                    return Atto.queryLegislature({}).$promise;
                }],
                organismiSeduta: [ 'Seduta', 'entity', function(Seduta, entity) {
                    return Seduta.organismiSeduta({legislature: entity.legislatura}).$promise;
                }],
                docTypes : [ 'TipoDocumento', function(TipoDocumento) {
                    return TipoDocumento.tipiDocumentoSeduta({}).$promise;
                }],
                workingBody: ['$stateParams', 'SedutaCommonService', function($stateParams, SedutaCommonService) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nameOrg
                    };
                }],
                utente: ['Principal', function (Principal) {
                    return Principal.identity();
                }]
            }
        })
        .state('seduta-detail.edit', {
            parent: 'seduta-detail',
            url: '/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seduta/seduta-detail.html',
                    controller: 'SedutaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                editable: function () {
                    return true;
                },
                entity: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                    return Seduta.get({id : $stateParams.id}).$promise;
                }],
                workingBody: ['$stateParams', function($stateParams) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nome,
                        legislatura: $stateParams.legislatura
                    };
                }],
                anno: ['$stateParams', function($stateParams) {
                    return parseInt($stateParams.anno, 10);
                }],
                legislature : [ 'Atto', function(Atto){
                    return Atto.queryLegislature({}).$promise;
                }],
                nextNumeroSeduta : [ '$stateParams', 'Seduta', function( $stateParams, Seduta) {
                    return Seduta.nextNumeroSeduta({idOrg : $stateParams.idOrg, typeOrg : $stateParams.typeOrg, legislatura : $stateParams.legislatura, anno : $stateParams.anno}).$promise;
                }],
                organismiSeduta: [ 'Seduta', '$stateParams', function(Seduta, $stateParams) {
                    return Seduta.organismiSeduta({legislature: $stateParams.legislatura}).$promise;
                }],
                utente: ['Principal', function (Principal) {
                    return Principal.identity();
                }]
            }
        })
        .state('seduta.new', {
            parent: 'seduta',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
                idOrg: {
                    value: null
                },
                typeOrg: {
                    value: null
                },
                nameOrg: {
                    value : null
                },
                legislatura : {
                    value : null
                },
                anno: {
                    value: null
                }
            },
            onEnter: ['$mdDialog', function ($mdDialog) {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    fullscreen: true,
                    templateUrl: 'app/entities/seduta/seduta-dialog.html',
                    controller: 'SedutaDialogController',
                    controllerAs: 'vm',
                    bindToController: true,
                    locals: {
                        entity: {
                            id: null,
                            legislatura: null,
                            anno: null,
                            tipoSeduta: null,
                            modalitaSeduta: null,
                            statoCorrente: {statoSeduta : 'A'},
                            tipoOrganizzatore: null,
                            idOrganizzatore: null,
                            numeroSeduta: null,
                            dataDiConvocazione: null,
                            partecipanti: []
                        }
                    },
                    resolve: {
                        workingBody: ['$stateParams', function($stateParams) {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nameOrg,
                                legislatura: $stateParams.legislatura
                            };
                        }],
                        anno: ['$stateParams', function($stateParams) {
                            return parseInt($stateParams.anno, 10);
                        }],
                        legislature : [ 'Atto', function(Atto){
                            return Atto.queryLegislature({}).$promise;
                        }],
                        nextNumeroSeduta : [ '$stateParams', 'Seduta', function( $stateParams, Seduta) {
                            return Seduta.nextNumeroSeduta({idOrg : $stateParams.idOrg, typeOrg : $stateParams.typeOrg, legislatura : $stateParams.legislatura, annoSeduta : $stateParams.anno}).$promise;
                        }],
                        organismiSeduta: [ 'Seduta', '$stateParams', function(Seduta, $stateParams) {
                            return Seduta.organismiSeduta({legislature: $stateParams.legislatura}).$promise;
                        }]
                    }
                });
            }]
        })
        .state('seduta.edit', {
            parent: 'seduta',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$mdDialog', '$state', 'Seduta', function($stateParams, $mdDialog, $state, Seduta) {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    fullscreen: true,
                    templateUrl: 'app/entities/seduta/seduta-dialog.html',
                    controller: 'SedutaDialogController',
                    controllerAs: 'vm',
                    bindToController: true,
                    locals: {
                        entity: Seduta.get({id: $stateParams.id}).$promise,
                        nextNumeroSeduta : null
                    },
                    resolve: {
                        workingBody: ['$stateParams', function($stateParams) {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nome,
                                legislatura: $stateParams.legislatura
                            };
                        }],
                        legislature : [ 'Atto', function(Atto){
                            return Atto.queryLegislature({}).$promise;
                        }],
                        organismiSeduta: [ 'Seduta', '$stateParams', function(Seduta, $stateParams) {
                            return Seduta.organismiSeduta({legislature: $stateParams.legislatura}).$promise;
                        }]
                    }
                }).then(function (result) {
                    $state.go('seduta', null, {reload: true});
                },
                function () {
                    $state.go('seduta', null, {reload: false});
                });
            }]
        })
        .state('seduta.delete', {
            parent: 'seduta',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seduta/seduta-delete-dialog.html',
                    controller: 'SedutaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seduta', null, { reload: 'seduta' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('seduta.select-working', {
            parent: 'app',
            url: '/select-working?legislatura',
            data: {
                authorities: [],
                pageTitle: 'gestioneAttiApp.seduta.home.title'
            },
            resolve: {
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }]
            },
            onEnter: ['$mdDialog', 'defaultLegislatura', function ( $mdDialog, defaultLegislatura) {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    templateUrl: 'app/entities/seduta/seduta-select-working-dialog.html',
                    controller: 'SedutaSelectWorkingController',
                    controllerAs: 'vm',
                    bindToController: true,
                    params: {
                        legislatura : {
                            value : null,
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('seduta');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            return $translate.refresh();
                        }],
                        legislature : [ 'Atto', function(Atto){
                            return Atto.queryLegislature({}).$promise;
                        }],
                        legislatura : ['$stateParams', function($stateParams) {
                            return $stateParams.legislatura || defaultLegislatura.legislatura;
                        }]
                    }
                });
            }]
        }).state('seduta-detail.copy', {
            parent: 'seduta-detail',
            url: '/seduta-copy-dettaglio',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
                numeroSeduta: {
                    value: null
                },
                seduta : {
                    value : null
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seduta/seduta-copy-dialog.html',
                    controller: 'SedutaCopyController',
                    controllerAs: 'vm',
                    resolve: {
                        puntiODG: ['Seduta', function(Seduta) {
                            return Seduta.getPuntiAffariTrattatiSeduta({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seduta-detail', {
                        
                    }, { reload: 'seduta-detail' });
                }, function() {
                    $state.go('seduta-detail');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Seduta', Seduta);

    Seduta.$inject = ['$resource', 'Upload', 'DateUtils', '$http'];

    function Seduta ($resource, Upload, DateUtils, $http) {
        var resourceUrl =  'api/sedutas/:id/:typeOrg/:idOrg/:organismiUtente/:numero/:transizione/:nextStateName/:puntiAffariTrattati/:ordineDelGiorno/:idOdgDoc/:files/:protocolNow/:filingcode/:idDoc';

        var resource = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataDiConvocazione = DateUtils.convertDateTimeFromServer(data.dataDiConvocazione);
                    }
                    return data;
                }
            },
            'saveWithWB' : {
                method: 'POST'
            },
            'update': { method:'PUT' },
            'organismiUtente' : {
                method: 'GET',
                params: {organismiUtente: 'organismiUtente'},
                isArray: true
            },
            'organismiSeduta' : {
                method: 'GET',
                params: {organismiUtente: 'organismi'},
                isArray: true
            },
            'nextNumeroSeduta' : {
                method: 'GET',
                params: {
                    numero : 'numero'
                }
            },
            'sedutaStateTransition' : {
                method : 'PUT',
                params : {
                    transizione: 'transizione'
                }
            },
            'getPuntiAffariTrattatiSeduta': {
                method: 'GET',
                params : {
                    puntiAffariTrattati: 'punti-affari-trattati'
                },
                isArray : true
            },
            'getSedutaDocuments': {
                method: 'GET',
                params : {
                    files: 'files'                    
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var result = [];
                    var lastGroup = null;
                    if (data && (!data.status || data.status === 200)) {
                        angular.forEach(data, function (doc) {
                            if (lastGroup === null || lastGroup.name !== doc.gruppoProtocollo) {
                                lastGroup = {
                                    name: doc.gruppoProtocollo,
                                    protocolState: doc.statoProtocollo,
                                    mittenti: doc.mittentiProtocollo || [],
                                    destinatari: doc.destinatariProtocollo || [],
                                    documents: [],
                                    operatingOffice: doc.operatingOffice
                                };
                                result.push(lastGroup);
                            }
                            doc.name = doc.nome;
                            doc.public = doc.pubblico;
                            doc.frontpiece = doc.frontespizio;
                            doc.protocolState = doc.statoProtocollo;
                            doc.protocolGroup = doc.gruppoProtocollo;
                            doc.docType = doc.tipoDocumento.tipo;
                            lastGroup.documents.push(doc);
                        });
                    }
                    return { data: result };
                }
            },
            'protocolNow': {
                method: 'POST',
                params: {
                    ordineDelGiorno: 'ordine-del-giorno',
                    files: 'files',
                    protocolNow: 'protocolNow'
                },
                isArray: true
            },
            'getFilingCode': {
                method: 'GET',
                params: {
                    filingcode: 'filingcode',
                },
                transformResponse: function (data) {
                    return { data: data };
                }
            },
            'updateDocument' : {
                method : 'PUT',
                params : {
                    files: 'files'
                },
                isArray: true
            }
        });

        resource.uploadFileSeduta = function (idSeduta, file, params) {
            return Upload.upload({
                url: 'api/sedutas/' + idSeduta + '/files',
                method: 'POST',
                data: params || {},
                file: file,
            });
        };

        resource.updateFileProtocolData = function (idSeduta, idOdgPar, fileList) {
            var params = {idOdg : idOdgPar};
            return $http.put('api/sedutas/' + idSeduta + '/files', fileList, params).then(
                function (response) {
                    // success callback
                    console.log("Success: ", response);
                },
                function (response) {
                    // failure callback
                    console.log("Failure: ", response);
                });
        };

        resource.getAffariTrattatiPDFReport = function (idSeduta) {
            return $http.get('/api/sedutas/' + idSeduta + '/affariTrattatiReport',
                { responseType: 'arraybuffer' });
        };

        return resource;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaController', SedutaController);

    SedutaController.$inject = ['$scope','$state', 'Seduta', 'OrdineDelGiorno', 'utente', 'AlertService', 'paginationConstants', 'pagingParams', 'workingBody', 'SedutaCommonService', '$filter', '$timeout'];

    function SedutaController($scope, $state, Seduta, OrdineDelGiorno, utente, AlertService, paginationConstants, pagingParams, workingBody, SedutaCommonService, $filter, $timeout) {

        var vm = this;

        vm.sedutas = [];
        vm.odgSedute = {};
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.legislatura = pagingParams.legislatura;
        vm.years = [];
        vm.anno = pagingParams.anno;
        vm.minNum = pagingParams.minNum;
        vm.maxNum = pagingParams.maxNum;
        vm.minDataConv = pagingParams.minDataConv;
        vm.maxDataConv = pagingParams.maxDataConv;
        vm.testoOdg = pagingParams.testoOdg;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.workingBody = workingBody;
        vm.utente = utente;
        
        vm.canEdit = canEdit;
        vm.clearMinDataConvocazione = clearMinDataConvocazione;
        vm.clearMaxDataConvocazione = clearMaxDataConvocazione;
        vm.deleteSedutaDisabled = deleteSedutaDisabled;

        loadAll();

        function loadAll () {

            var currentYear = new Date().getFullYear();
            for (var year = currentYear + 1; year >= 2022; year--) {
                vm.years.push(year);
            }

            if(vm.workingBody.legislature && vm.workingBody.nome) {
                vm.legislatureOrganismo = vm.workingBody.legislature;
            } else {
                Seduta.organismiSeduta({}, function(result) {
                    var workingBodyFromList = result.filter(filterWorkingBody)[0];
                    if (workingBodyFromList) {
                        vm.workingBody.nome = vm.workingBody.nome || workingBodyFromList.nome;
                        vm.workingBody.legislature = vm.workingBody.legislature || workingBodyFromList.legislature;
                        vm.legislatureOrganismo = workingBodyFromList.legislature;
                    }
                });
            }

            Seduta.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                legislatura: pagingParams.legislatura,
                anno: vm.anno,
                minNum: pagingParams.minNum,
                maxNum: pagingParams.maxNum,
                minDataConv: vm.minDataConv,
                maxDataConv: vm.maxDataConv,
                testoOdg: pagingParams.testoOdg,
                typeOrg: vm.workingBody.tipoOrganismo,
                idOrg: vm.workingBody.id
            }, onSuccessSeduta, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccessSeduta(data, headers) {
                //vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                var sedute = data;
                
                for(var i = 0; i < sedute.length; i++) {
                    var seduta = sedute[i];
                    seduta.numeroSeduta = SedutaCommonService.getNumeroSedutaOfWorkingBody(seduta, vm.workingBody);
                    seduta.isOrganizzatore = SedutaCommonService.isOrganizzatore(seduta, vm.workingBody);
                    seduta.partecipantiSeduta =  SedutaCommonService.getPartecipantiSeduta(seduta);
                    seduta.organizzatoreSeduta = SedutaCommonService.getOrganizzatoreSeduta(seduta);
                }

                sedute.forEach(function(seduta){
                    OrdineDelGiorno.getAllByIdSeduta(
                        {idSeduta: seduta.id},
                        function (data) {vm.odgSedute[seduta.id] = data;},
                        onError);
                });

                vm.page = pagingParams.page;

                var ordered = $filter('orderBy')(sedute, vm.predicate, !vm.reverse);
                var start = (vm.page - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.sedutas = ordered.slice(start, end);

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(resetPage) {

            if(vm.workingBody !== null) {
                if(resetPage) {
                    vm.page = 1;
                }
            
                $state.transitionTo($state.$current, {
                    page: vm.page,
                    sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                    search: vm.currentSearch,
                    idOrg: vm.workingBody.id,
                    typeOrg: vm.workingBody.tipoOrganismo,
                    nameOrg: vm.workingBody.nome,
                    legislatureOrg: vm.workingBody.legislature,
                    legislatura: vm.legislatura,
                    anno: vm.anno,
                    minNum: vm.minNum,
                    maxNum: vm.maxNum,
                    minDataConv: getFormattedDate(vm.minDataConv),
                    maxDataConv: getFormattedDate(vm.maxDataConv),
                    testoOdg: vm.testoOdg

                });
            }
        }

        function getFormattedDate(date) {
            if (!date) {
                return null;
            }
            try {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0' + day;
                }              
                return year + '-' + month + '-' + day;
            } catch (err) {
                return date;
            }
        }

        // Filter for organismi that are the current working body (to get details not in stateParams)
        function filterWorkingBody(element){
            return element.id === vm.workingBody.id && element.tipoOrganismo === vm.workingBody.tipoOrganismo;
        }

        function clearMinDataConvocazione(){
            vm.minDataConv = null;
            vm.transition(true);
        }

        function clearMaxDataConvocazione(){
            vm.maxDataConv = null;
            vm.transition(true);
        }

        // $scope.$watch('vm.sedutas', function(sedute) {
        //     for(var i = 0; i < sedute.length; i++) {
        //       var seduta = sedute[i];
        //       seduta.numeroSeduta = SedutaCommonService.getNumeroSedutaOfWorkingBody(seduta, vm.workingBody);
        //       seduta.isOrganizzatore = SedutaCommonService.isOrganizzatore(seduta, vm.workingBody);
        //       seduta.partecipantiSeduta =  SedutaCommonService.getPartecipantiSeduta(seduta);
        //       seduta.organizzatoreSeduta = SedutaCommonService.getOrganizzatoreSeduta(seduta);
        //     }

        //  });

        function canEdit(seduta){
            if (SedutaCommonService.canEditSeduta(vm.utente, seduta, vm.workingBody, vm.legislatura)) {
                if(seduta) {
                    return SedutaCommonService.isSedutaEditable(seduta);
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        function deleteSedutaDisabled(seduta) {
            if(canEdit(null)) {
                return !seduta.isOrganizzatore || seduta.statoCorrente.statoSeduta === 'X';
            } else {
                return true;
            }
        }

    }
})();

(function () {

    'use strict';

    var SedutaCommonService = ['Commissione', 'SoggettoEsterno', 'User', 'toastr', 'Principal', 
        function (Commissione, SoggettoEsterno, User, toastr, Principal) {
            var service = this;

            service.getNumeroSedutaOfWorkingBody = function(seduta, workingBody) {
                var result;
                if(seduta.numeroSeduta) return seduta.numeroSeduta;
                service.workingBody = workingBody;
                if(workingBody !== null){
                    result = seduta.membriSeduta.filter(filterMembriSedutaByWorkingBody);
                    return result[0].numeroSeduta;
                }
                return -1;
            };

            // Return true if current working body is "organizzatore" for Seduta in input
            service.isOrganizzatore = function(seduta, workingBody) {
                var result;
                if(workingBody !== null){
                    if(seduta.idOrganizzatore === workingBody.id) {
                        return true;
                    }
                    var membriSedutaCopy = seduta.membriSeduta.slice();
                    result = membriSedutaCopy.filter(filterMembriSedutaByOrganizzatore);
                    if(result.length === 0) return false;
                    return result[0].tipoMembro === workingBody.tipoOrganismo && result[0].idMembro === workingBody.id;
                }
                return false;
            };

            service.getPartecipantiSeduta = function(seduta) {
                var membriSedutaCopy = seduta.membriSeduta.slice();
                var result = membriSedutaCopy.filter(filterMembriSedutaByNotOrganizzatore);
                return result;
            };

            service.getOrganizzatoreSeduta = function(seduta) {
                var membriSedutaCopy = seduta.membriSeduta.slice();
                var result = membriSedutaCopy.filter(filterMembriSedutaByOrganizzatore);
                return result;
            };

            service.getNomeWorkingBody = function(workingBody){
                if(workingBody.nome !== null) {
                    return workingBody.nome;
                } else {
                    if(workingBody.tipoOrganismo === 'C') {
                        Commissione.get({id: workingBody.id}, {}, function(result) {
                            return result.nome;
                        });
                    } else if(workingBody.tipoOrganismo === 'E') {
                        SoggettoEsterno.get({id: workingBody.id}, {}, function(result) {
                            return result.nome;
                        });
                    }
                }
            };

            service.fromSedutaViewToSedutaBE = function(seduta, workingBody){
                service.workingBody = workingBody;
                if(!prepareSedutaBE(seduta)) return false;
                return seduta;
            };

            service.fromSedutaBEToSedutaView = function(seduta, workingBody, organismiSeduta){
                prepareSedutaView(seduta, workingBody, organismiSeduta);
                return seduta;
            };

            service.removeWorkingBodyFromOrganismiSeduta = function(organismiSeduta, workingBody){
                // Rimuove l'organizzatore dagli organismi selezionabili come partecipanti
                for (var i = organismiSeduta.length - 1; i >= 0; --i) {
                    if (organismiSeduta[i].id === workingBody.id && organismiSeduta[i].tipoOrganismo === workingBody.tipoOrganismo) {
                        organismiSeduta.splice(i,1);
                    }
                }
                return organismiSeduta;
            };

            service.getOrganismoWorkingBodyFromOrganismiSeduta = function(organismiSeduta, workingBody){
                // Recupera l'organizzatore dagli organismi selezionabili come partecipanti
                for (var i = organismiSeduta.length - 1; i >= 0; --i) {
                    if (organismiSeduta[i].id === workingBody.id && organismiSeduta[i].tipoOrganismo === workingBody.tipoOrganismo) {
                        return organismiSeduta[i];
                    }
                }
                return null;
            };

            service.isSedutaEditable = function(seduta) {
                if (!seduta) return true;
                if (seduta.statoCorrente.statoSeduta === 'X') return false;
                if (seduta.statoCorrente.statoSeduta === 'P') return false;
                return true;
            };

            service.canEditSeduta = function(utente, seduta, workingBody, legislatura){

                if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
                    return true;
                }

                var idSoggetti = [];

                // seduta = null: Per capire se l'utente può creare una seduta
                if (!seduta) {
                    // Se l'utente ha ROLE_COMMISSIONE deve essere dipendente
                    if (isCommissione(workingBody)) {
                        return User.isCommissionRoleForCommissionId(utente, workingBody.id, 'Dipendente', legislatura);
                    } else {
                        idSoggetti.push(workingBody.id);
                        return User.hasAnyExternalSubject(utente, idSoggetti, legislatura);
                    }
                } else if (service.isOrganizzatore(seduta, workingBody)){
                    // Solo l'organizzatore può editare la seduta (Se ha ROLE_COMMISSIONE deve essere Dipendente)
                    if (isCommissione(workingBody)) {
                        return User.isCommissionRoleForCommissionId(utente, workingBody.id, 'Dipendente', seduta.legislatura);
                    } else {
                        idSoggetti.push(workingBody.id);
                        return User.hasAnyExternalSubject(utente, idSoggetti, seduta.legislatura);
                    }
                } else {
                    return false;
                }
            };

            service.canEditSedutaNumber = function(utente, seduta, workingBody){

                var idSoggetti = [];

                if(!service.isOrganizzatore(seduta, workingBody)){
                    if (isCommissione(workingBody)) {
                        return User.isCommissionRoleForCommissionId(utente, workingBody.id, 'Dipendente', seduta.legislatura);
                    } else {
                        idSoggetti.push(workingBody.id);
                        return User.hasAnyExternalSubject(utente, idSoggetti, seduta.legislatura);
                    }
                } else {
                    return false;
                }
            };

            function isCommissione(workingBody) {
                if(workingBody && workingBody.tipoOrganismo) {
                    return workingBody.tipoOrganismo === 'C';
                }
            }

            service.romanize = function(num) {
                if (!+num)
                    return false;
                var digits = String(+num).split(""),
                    key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
                        "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
                        "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
                    roman = "",
                    i = 3;
                while (i--)
                    roman = (key[+digits.pop() + (i * 10)] || "") + roman;
                return Array(+digits.join("") + 1).join("M") + roman;
            };

             // Filter for membri seduta that are the current working body
            function filterMembriSedutaByWorkingBody(membro){
                return membro.tipoMembro ===  service.workingBody.tipoOrganismo && membro.idMembro === service.workingBody.id;
            }

            // Filter for membri seduta that are NOT the current working body
            function filterMembriSedutaByNotWorkingBody(membro){
                return !(membro.tipoMembro ===  service.workingBody.tipoOrganismo && membro.idMembro === service.workingBody.id);
            }

            // Filter for membri seduta that are NOT Organizzatore of Seduta
            function filterMembriSedutaByNotOrganizzatore(membro){
                return membro.isOrganizzatore === false;
            }

            // Filter for membri seduta that ARE Organizzatore of Seduta
            function filterMembriSedutaByOrganizzatore(membro){
                return membro.isOrganizzatore === true;
            }

            // Convert a Seduta from view to Backend Object
            function prepareSedutaBE(seduta){

                if(!isValidSedutaMembers(seduta)) {
                    toastr.error("Nella seduta congiunta i partecipanti sono obbligatori");
                    return false;
                } else {
                    /* MEMBRO SEDUTA BE:
                    Boolean isOrganizzatore;
                    TipoOrganizzatore tipoMembro;
                    String idMembro;
                    String descrizione;
                    Integer numeroSeduta; */
                    var numeroOrganizzatore = seduta.numeroSeduta;
                    if(seduta.membriSeduta) {
                        for( var i in seduta.membriSeduta){
                            var current = seduta.membriSeduta[i];
                            if(current) {
                                if(current.id === service.workingBody.id && current.tipoOrganismo === service.workingBody.tipoOrganismo) {
                                    current.numeroSeduta = seduta.numeroSeduta;
                                    numeroOrganizzatore = null;
                                }
                                current.isOrganizzatore = false;
                                current.tipoMembro = current.tipoOrganismo;
                                current.idMembro = current.id;
                                current.descrizione = current.nome;
                            }
                        }
                    }
                    seduta.membriSeduta.push({
                        isOrganizzatore: true,
                        tipoMembro: seduta.tipoOrganizzatore,
                        idMembro: seduta.idOrganizzatore,
                        descrizione: seduta.organizzatore,
                        numeroSeduta: numeroOrganizzatore
                    });
                    return true;
                }
            }
    
            function isValidSedutaMembers(seduta){

                if(seduta.tipoSeduta === 'C') {
                    if(!seduta.membriSeduta && !seduta.partecipantiSeduta) return false;
                    if(seduta.membriSeduta.length === 0 && seduta.partecipantiSeduta.length === 0) return false;
                    if(seduta.membriSeduta.length === 1 && !seduta.membriSeduta[0]) {
                        if(!seduta.partecipantiSeduta || seduta.partecipantiSeduta.length === 0 ) {
                            return false;
                        }
                    } 
                }
                return true;
            }

            // Convert a Seduta from Backend Object to View
            function prepareSedutaView(seduta, workingBody, organismiSeduta){

                 // Informazioni organizzatore
                var organizzatore = service.getOrganizzatoreSeduta(seduta);
                if(organizzatore.length === 1) {
                    seduta.idOrganizzatore = organizzatore[0].idMembro;
                    seduta.tipoOrganizzatore = organizzatore[0].tipoMembro;
                    seduta.organizzatore = organizzatore[0].descrizione;
                }
                seduta.numeroSeduta = service.getNumeroSedutaOfWorkingBody(seduta, workingBody);

                if(!seduta.membriSeduta) {
                    seduta.membriSeduta = [];
                } else {
                    var adjMembri = [];
                    for (var i = 0; i < seduta.membriSeduta.length; i++) {
                        var membroCur = seduta.membriSeduta[i];
                        if(!membroCur.isOrganizzatore){
                            for (var j = 0; j < organismiSeduta.length; j++) {
                                var organismoCur = organismiSeduta[j];
                                if(organismoCur.tipoOrganismo === membroCur.tipoMembro && organismoCur.id === membroCur.idMembro) {
                                    organismoCur.numeroSeduta = membroCur.numeroSeduta;
                                    adjMembri.push(organismoCur);
                                }
                            }
                           
                        }
    
                    }
                    seduta.membriSeduta = adjMembri;
                }
            }

            // Restituisce true se l'anno selezionato nella tabella sedute corrisponde all'anno della data di convocazione.
            // Se l'anno non è stato selezionato ritorna true
            service.checkAnnoSedutaDataConvocazione = function(anno, seduta) {

                if(anno) {
                    var annoSeduta = seduta.dataDiConvocazione.getFullYear();
                    return annoSeduta === anno;
                }
                return true;
            };
        }];

    angular.module('gestioneAttiApp').service('SedutaCommonService', SedutaCommonService);
    
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('RegistrazioneUtenteDialogController', RegistrazioneUtenteDialogController);

        RegistrazioneUtenteDialogController.$inject = ['$state', 'toastr', '$mdDialog', 'attoId', 'RegistrazioneUtente', '$stateParams', 'ACT_TYPES'];

    function RegistrazioneUtenteDialogController($state, toastr, $mdDialog, attoId, RegistrazioneUtente, $stateParams, ACT_TYPES) {
        var vm = this;
        vm.mail = null;
        vm.attoId = attoId;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.atto = $stateParams.atto;
        vm.attoTypeName = ACT_TYPES[ACT_TYPES.findIndex(function(tipoAtto) {return tipoAtto.value === vm.atto.tipoAtto;})].name;

        function clear() {
            $mdDialog.cancel();
            $state.go('home', null, {reload: true});
        }

        function save() {
            vm.isSaving = true;

            if(vm.mail) {
                var configToSave = {
                    mail: vm.mail,
                    attoId: vm.attoId
                }
                RegistrazioneUtente.createOrUpdate(configToSave, onConfigSaveSuccess, onConfigSaveError);
            }
        }

        function onConfigSaveSuccess(result) {
            vm.isSaving = false;
            toastr.success('Salvataggio registrazione utente alle notifiche mail avvenuto con successo!');
            vm.clear();
        }

        function onConfigSaveError() {
            toastr.error('Errore durante il salvataggio della registrazione utente alle notifiche mail');
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registrazione-utente', {
            parent: 'app',
            url: '/registrazione-utente',
            data: {
                authorities: [],
                pageTitle: 'gestioneAttiApp.registrazione-utente.titolo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registrazione-utente/registrazione-utente.html',
                    controller: 'RegistrazioneUtenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('form');
                    $translatePartialLoader.addPart('registrazione-utente');
                    return $translate.refresh();
                }]
            }
        }).state('registrazione-utente.new', {
              parent: 'app',
              url: '/registrazioneUtenteAtto/{id}',
              data: {
                  authorities: [],
                  pageTitle: 'gestioneAttiApp.registrazione-utente.titolo'
              },
              params: {
                id: {
                    value: null,
                    squash: true
                },
                atto: {
                    value: null,
                    squash: true
                }
                },
               onEnter: ['$mdDialog', '$stateParams', 'Atto', function ($mdDialog, $stateParams, Atto) {
                              $mdDialog.show({
                                  clickOutsideToClose: false,
                                  fullscreen: true,
                                  templateUrl: 'app/entities/registrazione-utente/registrazione-utente-dialog.html',
                                  controller: 'RegistrazioneUtenteDialogController',
                                  controllerAs: 'vm',
                                  bindToController: true,
                                  resolve: {
                                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                              $translatePartialLoader.addPart('atto');
                                              $translatePartialLoader.addPart('registrazione-utente');
                                              $translatePartialLoader.addPart('global');
                                              $translatePartialLoader.addPart('form');
                                              return $translate.refresh();
                                          }],
                                      attoId: ['$stateParams', function ($stateParams) {
                                              return $stateParams.id;
                                          }]
                                  }
                              });
                          }]
        })
        .state('cancellazione-registrazione-utente', {
            parent: 'app',
            url: '/cancellazione-registrazione-utente?registrationId&attoType&attoNumber&attoId',
            data: {
                authorities: [],
                pageTitle: 'gestioneAttiApp.registrazione-utente.titolo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registrazione-utente/cancellazione-registrazione-utente.html',
                    controller: 'CancellazioneRegistrazioneUtenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                registrationId: {
                    value: null,
                    squash: true
                },
                attoType: {
                    value: null,
                    squash: true
                },
                attoNumber: {
                    value: null,
                    squash: true
                },
                attoId: {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('form');
                    $translatePartialLoader.addPart('registrazione-utente');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('RegistrazioneUtente', RegistrazioneUtente);

        RegistrazioneUtente.$inject = ['$resource'];

    function RegistrazioneUtente ($resource) {
        var resourceUrl =  'api/registrazioni-utente';

        var resource = $resource(resourceUrl, {}, {
            'createOrUpdate': {
                method: 'POST',
                url: 'api/public/registrazioni-utente/atto'
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {
                method: 'DELETE',
                url: resourceUrl + '/:id'
            },
            'deleteRegistrazioneAtto': {
                method: 'PUT',
                url: 'api/public/registrazioni-utente' + '/:id' + '/registrazioni-atto/remove'
            },
            'getDettaglioRegistrazioneUtenteByAttoIdAndTipoAtto': {
                method: 'GET',
                url: 'api/public/registrazioni-utente/dettaglio-registrazione' + '/:id'
            }
        });

        return resource;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('RegistrazioneUtenteController', RegistrazioneUtenteController);

        RegistrazioneUtenteController.$inject = ['$state', 'toastr', 'RegistrazioneUtente', 'ACT_TYPES'];

    function RegistrazioneUtenteController($state, toastr, RegistrazioneUtente, ACT_TYPES) {
        var vm = this;
        vm.mail = null;
        vm.selectedTipoAtto = [];
        vm.save = save;
        vm.actTypesPublished = ACT_TYPES;
        vm.isSavingConfig = false;

        function save() {
            vm.isSavingConfig = true;

            if(vm.mail) {
                var configToSave = {
                    mail: vm.mail,
                    tipoAttoList: vm.selectedTipoAtto
                }
                RegistrazioneUtente.createOrUpdate(configToSave, onConfigSaveSuccess, onConfigSaveError);
            }
        }

        function onConfigSaveSuccess(result) {
            vm.isSavingConfig = false;
            toastr.success('Salvataggio registrazione utente alle notifiche mail avvenuto con successo!');
        }

        function onConfigSaveError(error) {
            toastr.error('Errore durante il salvataggio della registrazione alle notifiche: inserire una mail valida!');
            vm.isSavingConfig = false;
        }

        vm.getTranslationString = function(item){
            return (ACT_TYPES.find(function(tipoAtto){return tipoAtto.value === item})).name;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CancellazioneRegistrazioneUtenteController', CancellazioneRegistrazioneUtenteController);

        CancellazioneRegistrazioneUtenteController.$inject = ['$state', 'toastr', 'ACT_TYPES', 'Atto', 'RegistrazioneUtente', '$stateParams'];

    function CancellazioneRegistrazioneUtenteController($state, toastr, ACT_TYPES, Atto, RegistrazioneUtente, $stateParams) {
        var vm = this;
        vm.loadingDettaglioRegistrazione = true;
        vm.dettaglioRegistrazione;
        vm.idAttoButtonClicked = false;
        vm.tipoAttoButtonClicked = false;
        
        if($stateParams.attoType && $stateParams.registrationId && $stateParams.attoId) {
            vm.registrationId = $stateParams.registrationId;
            vm.attoType = $stateParams.attoType;
            vm.attoId = $stateParams.attoId;
            vm.attoNumber = $stateParams.attoNumber;
            vm.attoTypeName = ACT_TYPES[ACT_TYPES.findIndex(function(tipoAtto) {return tipoAtto.value === vm.attoType;})].name;

            
            RegistrazioneUtente.getDettaglioRegistrazioneUtenteByAttoIdAndTipoAtto({id: vm.registrationId, attoId: vm.attoId, tipoAtto: vm.attoType},
                function(result) {
                    vm.dettaglioRegistrazione = result;
                    vm.loadingDettaglioRegistrazione = false;
                },
                function(error) {
                    toastr.error("Impossibile cancellare la registrazione: nessuna registrazione trovata.")
                    vm.loadingDettaglioRegistrazione = false;
                });
        } else {
            vm.loadingDettaglioRegistrazione = false;
        }
        
        vm.onConfirmClickIdAtto = function() {
            vm.idAttoButtonClicked = true;
            RegistrazioneUtente.deleteRegistrazioneAtto({id: vm.registrationId, idAtto: vm.attoId}, {},
                function(result) {
                    toastr.success('Registrazione cancellata con successo!');
                },
                function(error) {
                    toastr.error('Errore durante la cancellazione della registrazione. Si prega di riprovare.');
                    vm.idAttoButtonClicked = false;
                });
        }

        vm.onConfirmClickTipoAtto = function() {
            vm.tipoAttoButtonClicked = true;
            RegistrazioneUtente.deleteRegistrazioneAtto({id: vm.registrationId, tipoAtto: vm.attoType}, {},
                function(result) {
                    toastr.success('Registrazione cancellata con successo!');
                },
                function(error) {
                    toastr.error('Errore durante la cancellazione della registrazione. Si prega di riprovare.');
                    vm.tipoAttoButtonClicked = false;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PuntoODGDialogController', PuntoODGDialogController);

    PuntoODGDialogController.$inject = ['$timeout', '$scope', '$state', 'editingMode', '$mdDialog', 'toastr', 'entity', 'odg', 'seduta', 'workingBody', 'title', 'attoCollegato', 'PuntoODG', 'Atto', 'ACT_TYPES', 'SedutaCommonService', 'editODG'];

    function PuntoODGDialogController ($timeout, $scope, $state, editingMode, $mdDialog, toastr, entity, odg, seduta, workingBody, title, attoCollegato, PuntoODG, Atto, ACT_TYPES, SedutaCommonService, editODG) {
        var vm = this;

        vm.editODG = editODG;
        vm.workingBody = workingBody;
        vm.puntoODG = entity;
        vm.editingMode = editingMode;
        vm.odg = odg;
        vm.seduta = seduta;
        vm.title = title;
        vm.attoCollegato = attoCollegato;

        vm.numeroAttoSearchText = '';
        vm.attachedActsModel = [];
        vm.attachedActsReadOnlyListModel = [];
        vm.searchActs = searchActs;
        vm.getAllActs = getAllActs;
        vm.transformChip = transformChip;
        vm.completeFormByAct = completeFormByAct;
        vm.clearForm = clearForm;
        vm.clear = clear;
        vm.save = save;

        vm.acts = [];
        vm.actsTypeSelection = [];

        ACT_TYPES.forEach(function (actType) {
            vm.actsTypeSelection.push(actType);
        });
        vm.basicSearchType = attoCollegato ? attoCollegato.tipoAtto : null;
        vm.selectedAtto = vm.attoCollegato;

        getAllActs();

        calcolaProgressivoPuntoODG();
        
        function calcolaProgressivoPuntoODG() {
            if(vm.puntoODG.id === null) {
                if(vm.odg.idPuntiODG !== null) {
                    vm.puntoODG.progressivoPuntoODG = vm.odg.idPuntiODG.length + 1;
                }
                else vm.puntoODG.progressivoPuntoODG = 1;
            }
        }
        
        function clear () {
            $mdDialog.cancel();
            if(vm.editODG){
                $state.go('ordine-del-giorno.edit');
            } else {
                $state.go('ordine-del-giorno');
            }
        }

        function save () {
            if(vm.puntoODG.tipoEspressioneRichiesta === "") {
                vm.puntoODG = {
                    tipoPuntoODG: vm.puntoODG.tipoPuntoODG,
                    testoPuntoODG: vm.puntoODG.testoPuntoODG,
                    idAtto: vm.puntoODG.idAtto,
                    progressivoPuntoODG: vm.puntoODG.progressivoPuntoODG,
                    esitoPuntoODG: vm.puntoODG.esitoPuntoODG,
                    descrizioneEsitoPuntoODG: vm.puntoODG.descrizioneEsitoPuntoODG
                }
            }
            vm.isSaving = true;

            if(vm.puntoODG.id !== null) {
                vm.puntoODG = PuntoODG.update({idODG: vm.odg.id, idSeduta:vm.seduta.id}, vm.puntoODG, onSaveSuccess, onSaveError);
            } else {
                vm.puntoODG = PuntoODG.save({idODG: vm.odg.id}, vm.puntoODG, onSaveSuccess, onSaveError);
            }
        }

        function searchActs(tokenNumeroAtto) {
            var results = vm.acts;
            return tokenNumeroAtto ? results.filter(createFilterFor(tokenNumeroAtto)) : [];
        }

        function createFilterFor(tokenNumeroAtto) {
            return function filterFn(atto) {
                var numeroAtto = atto.numeroAtto;
                return (numeroAtto.includes(tokenNumeroAtto));
            };
        }

        function transformChip($chip) {
            //Qui scegliere cosa tenere dentro la chip!
            return { "id": $chip.id, "legislatura": $chip.legislatura, "numeroAtto": $chip.numeroAtto, "titolo": $chip.titolo, "tipoAtto": $chip.tipoAtto, "proponente": $chip.proponente};
        }

        function getAllActs () {
            vm.acts = [];
            if (!vm.basicSearchType) {
                return;
            }
            Atto.queryNonPaged({type: vm.basicSearchType, legislaturaSearch: vm.seduta.legislatura}, onSuccess, onError);
            function onSuccess(data) {
                vm.acts = data;
            };
            function onError(error) {
                console.log(error);
            }
        }

        function completeFormByAct($chip) {   
            vm.puntoODG.idAtto = $chip.id;

            var proponentiString = "";

            if($chip.proponente != null && $chip.proponente.proponenti != null) {
                $chip.proponente.proponenti.forEach(function (proponente) {
                    proponentiString = proponentiString + capitalizeFirstLetter(proponente.descrizione) + ", ";
                });
            }
            
            // vm.puntoODG.testoPuntoODG = translateTipoAtto($chip.tipoAtto) + " n." + $chip.numeroAtto + " - " + $chip.titolo + 
            //     " - proponenti: " + proponentiString.slice(0,-2);

            vm.puntoODG.testoPuntoODG = $chip.titolo + 
                 " - proponenti: " + proponentiString.slice(0,-2);
            
            
            Atto.getSezioneByIdAttoAndNomeSezione($chip.id, "ASSIGNMENT_LETTER").then(
                function onSuccess(data) {
                vm.assignmentLetter = data;
                }, 
                function onError(error) {
                    console.log(error);
                });

            setTimeout(function() {
                if(vm.assignmentLetter && vm.assignmentLetter.metadati) {
                    vm.puntoODG.tipoEspressioneRichiesta = getTipoEspressioneRichiesta(vm.assignmentLetter.metadati);               
                }
            },100);
        }

        function capitalizeFirstLetter(string) {
            const arr = string.split(" ");

            for (var i = 0; i < arr.length; i++) {
                arr[i] = angular.uppercase(arr[i].charAt(0)) + angular.lowercase(arr[i].slice(1));
            }

           return arr.join(" ");
        }

        function getTipoEspressioneRichiesta(metadati) {
            if(vm.assignmentLetter.metadati.parereReferente && metadati.parereReferente.length > 0) {
                var parereReferente = vm.assignmentLetter.metadati.parereReferente.indexOf(vm.workingBody.id);
                if(parereReferente >= 0 && metadati.parereReferente.length > 1) {
                    return "PARERE_REF_CONG";
                }
                else if(parereReferente >= 0) {
                    return "PARERE_REF";
                }
            } 
            if(vm.assignmentLetter.metadati.parereSecondario && metadati.parereSecondario.length > 0) {
                var parereSecondario = vm.assignmentLetter.metadati.parereSecondario.indexOf(vm.workingBody.id);
                if(parereSecondario >= 0) {
                    return "PARERE_SEC";
                }
            }
            if(vm.assignmentLetter.metadati.parereDiMerito && metadati.parereDiMerito.length > 0) {
                var parereDiMerito = vm.assignmentLetter.metadati.parereDiMerito.indexOf(vm.workingBody.id);
                if(parereDiMerito >= 0) {
                    return "PARERE_MER";
                }
            }
            if(vm.assignmentLetter.metadati.parereObbligatorio && metadati.parereObbligatorio.length > 0) {
                var parereObbligatorio = vm.assignmentLetter.metadati.parereObbligatorio.indexOf(vm.workingBody.id);
                if(parereObbligatorio >= 0) {
                    return "PARERE_OBB";
                }
            }
            if(vm.assignmentLetter.metadati.osservazioni && metadati.osservazioni.length > 0) {
                var osservazioni = vm.assignmentLetter.metadati.osservazioni.indexOf(vm.workingBody.id);
                if(osservazioni >= 0) {
                    return "OSSERVAZIONI";
                }
            }
            
        }

        function clearForm() {
            vm.puntoODG.testoPuntoODG = null;
            vm.puntoODG.tipoEspressioneRichiesta = null;
            vm.puntoODG.idAtto = null;
        }

        function onSaveSuccess (result) {
            toastr.success('Punto ODG salvato con successo!');
            $mdDialog.cancel();
            vm.isSaving = false;
            $state.go('ordine-del-giorno.edit', {odg: vm.odg, seduta: vm.seduta}, { reload: true });
        }

        function onSaveError (error) {
            toastr.error('Errore nel salvataggio del Punto ODG');
            console.log(error);
            vm.isSaving = false;
        }

        function translateTipoAtto(tipoAtto) {
            if(tipoAtto === "PDL") {
                return "Proposta di legge";
            }
            if(tipoAtto === "PDD") {
                return "Proposta di delibera";
            }
            if(tipoAtto === "PLIP") {
                return "Proposta di legge di iniziativa popolare";
            }
            if(tipoAtto === "PDLP") {
                return "Proposta di legge al parlamento";
            }
            if(tipoAtto === "PDLS") {
                return "Proposta di legge statutaria";
            }
            if(tipoAtto === "PDR") {
                return "Proposta di risoluzione";
            }
            if(tipoAtto === "ODG") {
                return "Ordine del giorno";
            }
            if(tipoAtto === "MOZIONE") {
                return "Mozione";
            }
            if(tipoAtto === "ODG") {
                return "Ordine del giorno";
            }
            if(tipoAtto === "PEA") {
                return "Pareri ex articolo 42";
            }
            if(tipoAtto === "IO") {
                return "Interrogazione orale";
            }
            if(tipoAtto === "IS") {
                return "Interrogazione scritta";
            }
            if(tipoAtto === "CDG") {
                return "Comunicazione di Giunta";
            }
            if(tipoAtto === "PEL") {
                return "Pareri ex lege";
            }
            if(tipoAtto === "IEA") {
                return "Informativa ex articolo 48";
            }
            if(tipoAtto === "REL") {
                return "Relazioni organismi esterni";
            }
            if(tipoAtto === "DEA") {
                return "Determinazione ex art 50";
            }
            if(tipoAtto === "PDRIS") {
                return "Proposta di risoluzione";
            }
            if(tipoAtto === "RINT") {
                return "Regolamenti interni";
            }
        }

        vm.isFormValid = function() {
            return vm.puntoODG.tipoPuntoODG && vm.puntoODG.testoPuntoODG;
        }

        vm.hasEsito = function()  {
            return vm.puntoODG.tipoPuntoODG && vm.puntoODG.tipoPuntoODG === 'E';
        }

        vm.canEdit = function() {
            return vm.editingMode && SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PuntoODGDeleteController',PuntoODGDeleteController);

    PuntoODGDeleteController.$inject = ['$uibModalInstance', '$stateParams', 'puntiODG', 'puntoODGToDelete', 'PuntoODG'];

    function PuntoODGDeleteController($uibModalInstance, $stateParams, puntiODG, puntoODGToDelete, PuntoODG) {
        var vm = this;

        vm.idODG = $stateParams.idODG;
        vm.idSeduta = $stateParams.idSeduta;
        vm.puntoODGToDelete = puntoODGToDelete;
        vm.puntiODG = puntiODG;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            vm.progressivoODGToDelete = puntoODGToDelete.progressivoPuntoODG;

            // Correggo i progressivi dei punti ODG successivi a quello eliminato
            /*vm.puntiODG.forEach(function (p) {
                if(p.progressivoPuntoODG > vm.progressivoODGToDelete) {
                    p.progressivoPuntoODG --;
                    PuntoODG.update({idODG: vm.idODG}, p);
                }
            });*/

            // Elimino il punto ODG (e riassegno i progressivi da BE)
            PuntoODG.delete(
                {idPuntoODG: vm.puntoODGToDelete.id, idODG: vm.idODG, idSeduta: vm.idSeduta}, 
                function () {$uibModalInstance.close(true);}
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PuntoODGCopyController',PuntoODGCopyController);

        PuntoODGCopyController.$inject = ['$uibModalInstance', '$stateParams', 'seduta', 'odg', 'puntiODG', 'toastr'];

    function PuntoODGCopyController($uibModalInstance, $stateParams, seduta, odg, puntiODG, toastr) {
        var vm = this;

        vm.numeroSeduta = $stateParams.numeroSeduta;
        vm.legislatura = seduta.legislatura;;
        vm.progressivoODG = odg.progressivoODG;
        vm.puntiODG = puntiODG;
        vm.title = "";
        vm.textToCopy = [];

        vm.clear = clear;
        vm.copyRichTextToClipboard = copyRichTextToClipboard;
        vm.generateRichTextToCopy = generateRichTextToCopy;

        generateTextToCopy();
        generateRichTextToCopy();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function generateTextToCopy() {
            vm.title = "Legislatura " + vm.legislatura 
                + " - Seduta n°" + vm.numeroSeduta 
                + " - Ordine del Giorno n°" + vm.progressivoODG;
            
            
            for (var i = 0; i < vm.puntiODG.length; i++) {
                vm.textToCopy[i] = {};
                // vm.textToCopy[i].text = vm.puntiODG[i].progressivoPuntoODG + ". " + vm.puntiODG[i].testoPuntoODG;

                if(vm.puntiODG[i].idAtto) {
                    //vm.textToCopy[i].textSplits = vm.puntiODG[i].testoPuntoODG.split(/ -(.*)/s);
                    vm.textToCopy[i].textSplits = [];
                    var stringToSplit = vm.puntiODG[i].testoPuntoODG;
                    if(stringToSplit.indexOf("-") === -1) {
                        vm.textToCopy[i].textSplits.push(stringToSplit);
                        vm.textToCopy[i].textSplits.push("");
                    } else {
                        vm.textToCopy[i].textSplits.push(stringToSplit.substr(0, stringToSplit.indexOf("-")));
                        vm.textToCopy[i].textSplits.push(stringToSplit.substr( stringToSplit.indexOf("-"), stringToSplit.length));
                    }
                    vm.textToCopy[i].attachedActUrl = "https://iterlegis.consiglio.regione.toscana.it/#/atto/" + vm.puntiODG[i].idAtto + "/";
                }
            }
        }

        function generateRichTextToCopy() {
            vm.richTextToCopy = "<ol> \n";

            for (var i = 0; i < vm.puntiODG.length; i++) {
                if(vm.textToCopy[i].attachedActUrl) {
                    vm.richTextToCopy = vm.richTextToCopy + "<li><a href=\"" + vm.textToCopy[i].attachedActUrl + "\">" 
                        + vm.textToCopy[i].textSplits[0] + "</a>" 
                        + vm.textToCopy[i].textSplits[1] + "</li> \n";
                }
                else {
                    vm.richTextToCopy = vm.richTextToCopy + "<li>" + vm.puntiODG[i].testoPuntoODG + "</li> \n";
                }
            }      
            vm.richTextToCopy = vm.richTextToCopy + "</ol> \n";
        }

        function copyRichTextToClipboard(textToCopy) {
            function listener(e) {
              e.clipboardData.setData("text/html", textToCopy);
              e.clipboardData.setData("text/plain", textToCopy);
              e.preventDefault();
            }
            document.addEventListener("copy", listener);
            document.execCommand("copy");
            document.removeEventListener("copy", listener);

            toastr.success("Punti dell'ordine del giorno copiati nella clipboard!");
        }     

    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('punto-odg-detail', {
            parent: 'ordine-del-giorno',
            url: '/punto-odg/{idPODG}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.puntoODG.detail.title'
            },
            params:  {
                idAttoCollegato: {
                    value: null
                },
                editODG: {
                    value: null
                }
            },
            onEnter: ['$stateParams', '$state', '$mdDialog', function($stateParams, $state, $mdDialog) {
                $mdDialog.show({
                    templateUrl: 'app/entities/punto-odg/punto-odg-dialog.html',
                    controller: 'PuntoODGDialogController',
                    controllerAs: 'vm',
                    bindToController: true,
                    fullscreen: true,
                    resolve: {
                        entity: ['PuntoODG', function(PuntoODG) {
                            return PuntoODG.get({idPODG : $stateParams.idPODG}).$promise;
                        }],
                        odg: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }],
                        editingMode: [function () {
                            return false;
                        }],
                        editODG: [function () {
                            return $stateParams.editODG;
                        }],
                        workingBody: [function() {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nameOrg
                            }
                        }],
                        title: [function() {
                            return "Visualizza il Punto ODG";
                        }],
                        attoCollegato: ['Atto', function(Atto) {
                            if($stateParams.idAttoCollegato) {
                                return Atto.get({id : $stateParams.idAttoCollegato}).$promise;
                            }
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'ordine-del-giorno',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('puntoODG');
                            $translatePartialLoader.addPart('tipoPuntoODG');
                            $translatePartialLoader.addPart('espressioneRichiesta');
                            $translatePartialLoader.addPart('esitoPuntoODG');
                            return $translate.refresh();
                        }]
                    }
                });
            }]
        })
        .state('punto-odg-detail.edit', {
            parent: 'ordine-del-giorno',
            url: '/punto-odg/{idPODG}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            params:  {
                idAttoCollegato: {
                    value: null
                },
                editODG: {
                    value: null
                }
            },
            onEnter: ['$stateParams', '$state', '$mdDialog', function($stateParams, $state, $mdDialog) {
                $mdDialog.show({
                    templateUrl: 'app/entities/punto-odg/punto-odg-dialog.html',
                    controller: 'PuntoODGDialogController',
                    controllerAs: 'vm',
                    bindToController: true,
                    fullscreen: true,
                    resolve: {
                        entity: ['PuntoODG', function(PuntoODG) {
                            return PuntoODG.get({idPODG : $stateParams.idPODG}).$promise;
                        }],
                        odg: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }],
                        editingMode: [function () {
                            return true;
                        }],
                        editODG: [function () {
                            return $stateParams.editODG;
                        }],
                        workingBody: ['$stateParams', function($stateParams) {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nameOrg
                            }
                        }],
                        title: [function() {
                            return "Modifica il Punto ODG";
                        }],
                        attoCollegato: ['Atto', function(Atto) {
                            if($stateParams.idAttoCollegato) {
                                return Atto.get({id : $stateParams.idAttoCollegato}).$promise;
                            }
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('puntoODG');
                            $translatePartialLoader.addPart('tipoPuntoODG');
                            $translatePartialLoader.addPart('espressioneRichiesta');
                            $translatePartialLoader.addPart('esitoPuntoODG');
                            return $translate.refresh();
                        }]
                    }
                }).then(function() {
                    $state.go('ordine-del-giorno.edit', {
                        odg: ['$stateParams', 'OrdineDelGiorno', function($stateParams, OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }]
                    }, { reload: 'ordine-del-giorno.edit' });
                }, function() {
                    $state.go('ordine-del-giorno.edit');
                });
            }]
        })
        .state('punto-odg-dialog', {
            parent: 'ordine-del-giorno',
            url: '/punto-odg-new',
            data: {
                authorities: ['ROLE_USER']
            },
            params:  {
                idAttoCollegato: {
                    value: null
                },
                editODG: {
                    value: null
                }
            },
            onEnter: ['$stateParams', '$state', '$mdDialog', function($stateParams, $state, $mdDialog) {
                $mdDialog.show({
                    templateUrl: 'app/entities/punto-odg/punto-odg-dialog.html',
                    controller: 'PuntoODGDialogController',
                    controllerAs: 'vm',
                    bindToController: true,
                    fullscreen: true,
                    locals: {
                        entity: {
                            tipoPuntoODG: null,
                            idAtto: null,
                            testoPuntoODG: null,
                            tipoEspressioneRichiesta: null,
                            progressivoPuntoODG: null,
                            esitoPuntoODG: null,
                            descrizioneEsitoPuntoODG: null,
                            id: null
                        }
                    },
                    resolve: {
                        odg: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }],
                        editingMode: [function () {
                            return true;
                        }],
                        editODG: [function () {
                            return $stateParams.editODG;
                        }],
                        attoCollegato: [ function() {
                            return null;
                        }],
                        workingBody: ['$stateParams', function($stateParams) {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nameOrg
                            }
                        }],
                        title: [function() {
                            return "Crea un nuovo Punto ODG";
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('puntoODG');
                            $translatePartialLoader.addPart('tipoPuntoODG');
                            $translatePartialLoader.addPart('espressioneRichiesta');
                            $translatePartialLoader.addPart('esitoPuntoODG');
                            return $translate.refresh();
                        }]
                    }
                }).then(function() {
                    $state.go('ordine-del-giorno.edit', {
                        odg: ['$stateParams', 'OrdineDelGiorno', function($stateParams, OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }]
                    }, { reload: true });
                }, function() {
                    $state.go('ordine-del-giorno.edit');
                });
            }]
        })
        .state('punto-odg-dialog.delete', {
            parent: 'ordine-del-giorno',
            url: '/punto-odg/{idPODG}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            params:  {
                idPODG: {
                    value: null
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/punto-odg/punto-odg-delete-dialog.html',
                    controller: 'PuntoODGDeleteController',
                    controllerAs: 'vm',
                    resolve: {
                        puntiODG: ['PuntoODG', function(PuntoODG) {
                            return PuntoODG.findAllByIdODG({idODG: $stateParams.idODG}).$promise;
                        }],
                        puntoODGToDelete: ['PuntoODG', function(PuntoODG) {
                            return PuntoODG.get({idPODG: $stateParams.idPODG}).$promise;
                        }] 
                    }
                }).result.then(function() {
                    $state.go('ordine-del-giorno.edit', {
                        odg: ['$stateParams', 'OrdineDelGiorno', function($stateParams, OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }]
                    }, { reload: 'ordine-del-giorno.edit' });
                }, function() {
                    $state.go('ordine-del-giorno.edit');
                });
            }]
        })
        .state('punto-odg-dialog.copy', {
            parent: 'ordine-del-giorno',
            url: '/punto-odg-copy-dettaglio',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
                numeroSeduta: {
                    value: null
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/punto-odg/punto-odg-copy-dialog.html',
                    controller: 'PuntoODGCopyController',
                    controllerAs: 'vm',
                    resolve: {
                        puntiODG: ['PuntoODG', function(PuntoODG) {
                            return PuntoODG.findAllByIdODG({idODG: $stateParams.idODG}).$promise;
                        }],
                        odg: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine-del-giorno.edit', {
                        odg: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                        }],
                        seduta: ['Seduta', function(Seduta) {
                            return Seduta.get({id : $stateParams.idSeduta}).$promise;
                        }]
                    }, { reload: 'ordine-del-giorno.edit' });
                }, function() {
                    $state.go('ordine-del-giorno.edit');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('PuntoODG', PuntoODG);

    PuntoODG.$inject = ['$resource'];

    function PuntoODG ($resource) {
        var resourceUrl =  'api/punto-odgs/:idPODG';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { 
                method:'PUT',
                url: 'api/ordine-del-giornos' + '/:idODG' + '/punto-odgs'
             },
             'updateAll': { 
                method:'PUT',
                url: 'api/ordine-del-giornos' + '/:idODG' + '/punto-odgs/all',
                isArray: true
             },
            'save': {
                method: 'POST',
                url: 'api/ordine-del-giornos' + '/:idODG' + '/punto-odgs'
            },
            'findAllByIdODG': {
                method: 'GET',
                url: 'api/ordine-del-giornos' + '/:idODG' + '/punto-odgs',
                isArray: true
            },
            'delete': {
                method: 'DELETE',
                url: 'api/ordine-del-giornos' + '/:idODG' + '/punto-odgs' + '/:idPuntoODG'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('PersonaDialogController', PersonaDialogController);

    PersonaDialogController.$inject = ['$timeout', '$scope', 'toastr', '$uibModalInstance', 'entity', 'Persona', '$q'];

    function PersonaDialogController($timeout, $scope, toastr, $uibModalInstance, entity, Persona, $q) {
        var vm = this;

        vm.persona = entity;
        vm.clear = clear;
        vm.save = save;
        
        vm.selectedItem = vm.persona.anagraficaProtocollo;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.persona.id !== null) {
                Persona.update(vm.persona, onSaveSuccess, onSaveError);
            } else {
                Persona.save(vm.persona, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:personaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.setAnagrafic = function (item) {
            if (item) {
                vm.persona.anagraficaProtocollo = item;
            }
        };

        vm.searchAnagrafics = function (text) {
            var deferred = $q.defer();
            Persona.listFromProtocol({'code': text}, function (data) {
                deferred.resolve(data);
                return deferred.promise;
            }, function (error) {
                toastr.error(error);
                deferred.reject(error);
            });
            return deferred.promise;
        };

        vm.getDisplayName = function (item) {
            return item.anagraficCode + ' - ' + item.anagraficDescription;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PersonaDetailController', PersonaDetailController);

    PersonaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Persona'];

    function PersonaDetailController($scope, $rootScope, $stateParams, previousState, entity, Persona) {
        var vm = this;

        vm.persona = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:personaUpdate', function(event, result) {
            vm.persona = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PersonaDeleteController',PersonaDeleteController);

    PersonaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Persona'];

    function PersonaDeleteController($uibModalInstance, entity, Persona) {
        var vm = this;

        vm.persona = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Persona.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('persona', {
            parent: 'entity',
            url: '/persona',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.persona.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/persona/personas.html',
                    controller: 'PersonaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('persona');
                    $translatePartialLoader.addPart('ruoloPersona');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('persona-detail', {
            parent: 'persona',
            url: '/persona/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.persona.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/persona/persona-detail.html',
                    controller: 'PersonaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('persona');
                    $translatePartialLoader.addPart('ruoloPersona');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Persona', function($stateParams, Persona) {
                    return Persona.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'persona',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('persona-detail.edit', {
            parent: 'persona-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('persona.new', {
            parent: 'persona',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                cognome: null,
                                ruolo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('persona');
                });
            }]
        })
        .state('persona.edit', {
            parent: 'persona',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-dialog.html',
                    controller: 'PersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('persona.delete', {
            parent: 'persona',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/persona/persona-delete-dialog.html',
                    controller: 'PersonaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Persona', function(Persona) {
                            return Persona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('persona', null, { reload: 'persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('Persona', Persona);

    Persona.$inject = ['$resource'];

    function Persona($resource) {
        var resourceUrl = 'api/:public/personas/:id/:roleEndpoint/:ruolo/:protocolloAnagrafic';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {public: 'public'}
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'listByRole': {method: 'GET', params: {public: 'public', roleEndpoint: 'ruolo'}, isArray: true},
            'listFromProtocol': {method: 'GET', params: {protocolloAnagrafic: 'protocolloAnagrafic'}, isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PersonaController', PersonaController);

    PersonaController.$inject = ['Persona'];

    function PersonaController(Persona) {

        var vm = this;

        vm.personas = [];

        loadAll();

        function loadAll() {
            Persona.query(function(result) {
                vm.personas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('OrdineDelGiornoDetailController', OrdineDelGiornoDetailController);

    OrdineDelGiornoDetailController.$inject = ['$scope', '$timeout', '$state', '$mdDialog', 'editingMode', 'previousState', 'toastr', 
        'entity', 'seduta', 'workingBody', 'docTypes', 'OrdineDelGiorno', 'Commissione', 'SoggettoEsterno', 'PuntoODG', 'utente',
        'Atto', 'SedutaCommonService','$mdSidenav', 'Principal'];
    function OrdineDelGiornoDetailController($scope, $timeout, $state, $mdDialog, editingMode, previousState, toastr, 
        entity, seduta, workingBody, docTypes, OrdineDelGiorno, Commissione, SoggettoEsterno, PuntoODG, utente,
        Atto, SedutaCommonService, $mdSidenav, Principal) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.previousStateParams = previousState.params;
        vm.showStateHistory;
        vm.workingBody = workingBody;
        vm.seduta = seduta;
        vm.odg = entity;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.organizzatoreSeduta = {};
        vm.puntiODG = [];

        vm.odg.idSeduta = seduta.id;
        vm.editingMode = editingMode;
        vm.isOrganizzatore = SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody);

        vm.save = save;
        vm.performButtonAction = performButtonAction;
        vm.toggleEsitoPublish = toggleEsitoPublish;
        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
        vm.isDuplicateProgressive = isDuplicateProgressive;

        vm.utente = utente;
        vm.canEditOdg = canEditOdg;
        vm.canSeeEditOdgButton = canSeeEditOdgButton;

        vm.docTypes = docTypes;

        vm.canEdit = function() {
            return vm.editingMode && SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody);
        };

        vm.changeOrder = function(direction, idx) {
            vm.elem1 = vm.puntiODG[idx];
            
            if((direction < 0 && idx > 0) || (direction >= 0 && idx >= 0 && idx < vm.puntiODG.length - 1)) {
                if(direction < 0 && idx > 0) {
                    vm.elem1.progressivoPuntoODG = idx;
                    vm.elem2 = vm.puntiODG[idx - 1];                
                } else if(direction >= 0 && idx >= 0 && idx < vm.puntiODG.length - 1) {
                    vm.elem1.progressivoPuntoODG = idx + 2;
                    vm.elem2 = vm.puntiODG[idx + 1];
                }
                vm.elem2.progressivoPuntoODG = idx + 1;

                /*
                PuntoODG.update({idODG: vm.odg.id}, vm.elem2).$promise;
                PuntoODG.update({idODG: vm.odg.id}, vm.elem1, onChangeSuccess, onChangeError).$promise;*/
                
                PuntoODG.updateAll({idODG: vm.odg.id}, vm.puntiODG, onChangeSuccess, onChangeError).$promise;

                reloadPage();
            }
        };

        var confirmTransitionDlg = $mdDialog.confirm()
            .title('Attenzione!')
            .textContent("L'operazione richiesta non è reversibile, sei sicuro di voler procedere?")
            .ariaLabel('conferma transizione di stato')
            .ok('Conferma')
            .cancel('Annulla');

        initButtons();
        findOrganizzatore(vm.seduta.membriSeduta);
        getPuntiODG();
        toTipoSeduta();


        function findOrganizzatore(membriSeduta) {
            membriSeduta.forEach(function (membro) {
                if(membro.isOrganizzatore) {
                    vm.organizzatoreSeduta.id = membro.idMembro;
                    vm.organizzatoreSeduta.numeroSeduta = membro.numeroSeduta;

                    if(membro.tipoMembro === "C") {
                        Commissione.get({id: membro.idMembro}, {}, function(result) {
                            vm.organizzatoreSeduta.nome = result.nome;
                        });           
                    }
                    else if (membro.tipoMembro === "E") {
                        SoggettoEsterno.get({id: membro.idMembro}, {}, function(result) {
                            vm.organizzatoreSeduta.nome = result.nome;
                        });
                    } 
                    vm.organizzatoreSeduta.tipo = membro.tipoMembro;
                }
            });
        }

        function toTipoSeduta() {
            if(vm.seduta.tipoSeduta === 'N') {
                vm.tipoSeduta = "Ordinaria";
            }
            else if(vm.seduta.tipoSeduta === 'C') {
                vm.tipoSeduta = "Congiunta";
            }
        }

        function getPuntiODG() {
            PuntoODG.findAllByIdODG(
                {idODG: vm.odg.id}, 
                function (data) {
                    if(data) {
                        vm.puntiODG = data;
                        getAttiCollegati();
                    }
                }, 
                function (error) {
                    toastr.error("Errore recuperando i Punto ODG :", error.data.message);
                }
            );
        }

        function initButtons(){
            vm.visibleButtons = [];

            if(SedutaCommonService.canEditSeduta(vm.utente, vm.seduta, vm.workingBody)) {
                if(vm.odg.statoCorrenteODG.statoODG === 'A' && vm.seduta.statoCorrente.statoSeduta !== 'P') {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.publishODG",
                            action: publishODG,
                            iconClass: "glyphicon-send",
                            nextStateName : "P"
                        },
                        {
                            title: "entity.action.deleteODG",
                            action: deleteODG,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                } else if(vm.odg.statoCorrenteODG.statoODG === 'P' && vm.seduta.statoCorrente.statoSeduta !== 'P') {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.deleteODG",
                            action: deleteODG,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                }
            }

        }

        function getAttiCollegati() {
            if(vm.puntiODG) {
                vm.puntiODG.forEach(function (p) {
                    if(p.idAtto) {
                        Atto.get(
                            {id: p.idAtto}, 
                            function (data) {p.atto = data;}, 
                            function (error) {toastr.error("Errore nel recuper dell'Atto collegato: ", error.data.message);}
                        );
                    }
                });
            }
        }

        function save () {
            vm.isSaving = true;
            if (vm.odg.id !== null) {
                vm.odg = OrdineDelGiorno.update({id: vm.odg.id}, vm.odg, onSaveSuccess("Ordine del Giorno salvato con successo!"), onSaveError);
            } else {
                vm.odg = OrdineDelGiorno.save(vm.odg, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (message) {
            $scope.$emit('gestioneAttiApp:ordineDelGiornoUpdate', message);
            toastr.success(message);
            vm.isSaving = false;
            reloadPage();
        }

        function onSaveError () {
            toastr.error('Errore durante il salvataggio dell\'\Ordine del Giorno');
            vm.isSaving = false;
        }

        function onChangeSuccess() {
            toastr.success('Punto ODG spostato con successo!');
            vm.isSaving = false;
        }

        function onChangeError () {
            toastr.error('Errore durante la modifica del Punto ODG');
            vm.isSaving = false;
        }

        function publishODG() {
            $mdDialog.show(confirmTransitionDlg).then(function () {
                OrdineDelGiorno.publish({}, vm.odg, onPublishSuccess, onPublishError);
            });
        }

        function onPublishSuccess (data) {
            toastr.success("Ordine del Giorno pubblicato con successo!");
            vm.odg = data.ordineDelGiornoPublished;
            vm.isSaving = false;
            reloadPage();
        }

        function onPublishError (data) {
            toastr.error('Errore durante la pubblicazione dell\'Ordine del Giorno. Accertarsi che sia stato caricato il documento Ordine del Giorno.');
            vm.isSaving = false;
        }

        function deleteODG() {
            $state.go('ordine-del-giorno.delete', {id: vm.odg.id, workingBody: vm.workingBody}, {reload: true});
        }

        function performButtonAction(button){
            if(button.action){
                button.action( button.nextStateName);
            }
        }

        function reloadPage() {
            $timeout(function () {
                $state.reload();
            }, 0);
        }

        function canEditOdg(seduta, odg) {
            if (isOdgPubblicato(odg)) return false;
            if (isAffariTrattatiPubblicati(seduta)) return false;
            return SedutaCommonService.canEditSeduta(vm.utente, seduta, vm.workingBody);
        }

        function isOdgPubblicato(odg) {
            if (odg && odg.statoCorrenteODG && odg.statoCorrenteODG.statoODG) {
                return odg.statoCorrenteODG.statoODG === 'X';
            } 
            return false;
        }

        function isAffariTrattatiPubblicati(seduta){
            if (seduta && seduta.statoCorrente && seduta.statoCorrente.statoSeduta) {
                return vm.seduta.statoCorrente.statoSeduta === 'PAT';
            }
            return false;
        }

        function canSeeEditOdgButton() {
            return canEditOdg(vm.seduta, vm.odg) && !vm.editingMode;
        }

        function toggleEsitoPublish () {
            $mdSidenav('esitoPublish').toggle();
        }

        function isDuplicateProgressive(index){
            var progToCheck = vm.puntiODG[index].progressivoPuntoODG;
            for(var i = 0; i < vm.puntiODG.length; i++){
                if (i !== index){
                    if(progToCheck === vm.puntiODG[i].progressivoPuntoODG) return true;
                }
            }
            return false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('OrdineDelGiornoDeleteController',OrdineDelGiornoDeleteController);

    OrdineDelGiornoDeleteController.$inject = ['$uibModalInstance', '$state', 'toastr', 'entity', 'workingBody', 'OrdineDelGiorno'];

    function OrdineDelGiornoDeleteController($uibModalInstance, $state, toastr, entity, workingBody, OrdineDelGiorno) {
        var vm = this;

        vm.ordineDelGiorno = entity;
        vm.workingBody = workingBody;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            OrdineDelGiorno.delete({id: vm.ordineDelGiorno.id}, vm.ordineDelGiorno, function () {
                toastr.success("Ordine del Giorno eliminato con successo!");
    
                $state.go('seduta', {idOrg: vm.workingBody.id, typeOrg: vm.workingBody.tipoOrganismo, nameOrg: vm.workingBody.nome}, {reload: true}).then(function () {
                    $uibModalInstance.close(true)
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('OrdineDelGiornoCreateController', OrdineDelGiornoCreateController);

    OrdineDelGiornoCreateController.$inject = ['toastr', '$scope', '$state', 'workingBody', 'seduta', 'OrdineDelGiorno', 'Commissione', 'SoggettoEsterno'];

    function OrdineDelGiornoCreateController (toastr, $scope, $state, workingBody, seduta, OrdineDelGiorno, Commissione, SoggettoEsterno) {
        var vm = this;

        vm.workingBody = workingBody;
        vm.seduta = seduta;
        vm.organizzatoreSeduta = {};
        vm.odg = {};
        vm.odg.idSeduta = seduta.id;

        vm.save = save;

        findOrganizzatore(vm.seduta.membriSeduta);
        calcolaProgressivoODG();
        toTipoSeduta();
        
        function findOrganizzatore(membriSeduta) {
            membriSeduta.forEach(function(membro) {
                if(membro.isOrganizzatore) {
                    vm.organizzatoreSeduta.numeroSeduta = membro.numeroSeduta;
                    if(membro.tipoMembro == "C") {
                        Commissione.get({id: membro.idMembro}, {}, function(result) {
                            vm.organizzatoreSeduta.nome = result.nome;
                            // Inizializzazione oggetto ODG
                            vm.odg.oggettoODG = "Convocazione seduta " + result.nome;
                        });           
                    }
                    else if (membro.tipoMembro == "E") {
                        SoggettoEsterno.get({id: membro.idMembro}, {}, function(result) {
                            vm.organizzatoreSeduta.nome = result.nome;
                        });
                    } 
                }
            });
        }

        function toTipoSeduta() {
            if(vm.seduta.tipoSeduta == 'N') {
                vm.tipoSeduta = "Ordinaria"
            }
            else if(vm.seduta.tipoSeduta == 'C') {
                vm.tipoSeduta = "Congiunta"
            }
        }

        function calcolaProgressivoODG() {
            OrdineDelGiorno.getAllByIdSeduta(
                {idSeduta: vm.seduta.id}, 
                function (data) {if(data) {vm.odg.progressivoODG = data.length + 1;}}, 
                function (error) {toastr.error("Errore: ", error.data.message);}
                );
        }

        function save () {
            vm.isSaving = true;
            if (vm.odg.id !== null) {
                OrdineDelGiorno.update(vm.odg, onSaveSuccess, onSaveError);
            } else {
                vm.odg.statoCorrenteODG.statoODG = "A";
                vm.odg = OrdineDelGiorno.save(vm.odg, onSaveSuccess, onSaveError);
            }
            $state.go('seduta', {
                idOrg: vm.workingBody.id, 
                typeOrg: vm.workingBody.tipoOrganismo, 
                nome: vm.workingBody.nameOrg
            }, {reload: true});
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:ordineDelGiornoUpdate', result);
            toastr.success('Ordine del Giorno salvato con successo!');
            vm.dettaglioVisibile = true;
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            toastr.error('Errore durante il salvataggio dell\'\Ordine del Giorno');
        }

        vm.isFirstFormValid = function() {
            return vm.odg.tipoODG && vm.odg.oggettoODG;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ordine-del-giorno', {
            parent: 'seduta',
            url: '/{idSeduta}/ordine-del-giorno/{idODG}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.ordineDelGiorno.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine-del-giorno/ordine-del-giorno-detail.html',
                    controller: 'OrdineDelGiornoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('ordineDelGiorno');
                    $translatePartialLoader.addPart('tipoODG');
                    $translatePartialLoader.addPart('puntoODG');
                    $translatePartialLoader.addPart('tipoPuntoODG');
                    $translatePartialLoader.addPart('espressioneRichiesta');
                    $translatePartialLoader.addPart('esitoPuntoODG');
                    $translatePartialLoader.addPart('seduta');
                    $translatePartialLoader.addPart('tipoSeduta');
                    $translatePartialLoader.addPart('statoSeduta');
                    $translatePartialLoader.addPart('tipoOrganizzatore');
                    $translatePartialLoader.addPart('statoODGType');
                    $translatePartialLoader.addPart('document-toolbar');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrdineDelGiorno', function($stateParams, OrdineDelGiorno) {
                    return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                }],
                seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                    return Seduta.get({id : $stateParams.idSeduta}).$promise;
                }],
                editingMode: [function () {
                    return false;
                }],
                docTypes : [ 'TipoDocumento', function(TipoDocumento) {
                    return TipoDocumento.tipiDocumentoOdg({}).$promise;
                }],
                workingBody: ['$stateParams', function($stateParams) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nameOrg
                    };
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ordine-del-giorno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ordine-del-giorno.edit', {
            parent: 'ordine-del-giorno',
            url: '/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine-del-giorno/ordine-del-giorno-detail.html',
                    controller: 'OrdineDelGiornoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('ordineDelGiorno');
                    $translatePartialLoader.addPart('tipoODG');
                    $translatePartialLoader.addPart('puntoODG');
                    $translatePartialLoader.addPart('tipoPuntoODG');
                    $translatePartialLoader.addPart('espressioneRichiesta');
                    $translatePartialLoader.addPart('esitoPuntoODG');
                    $translatePartialLoader.addPart('seduta');
                    $translatePartialLoader.addPart('tipoSeduta');
                    $translatePartialLoader.addPart('statoSeduta');
                    $translatePartialLoader.addPart('tipoOrganizzatore');
                    $translatePartialLoader.addPart('statoODGType');
                    $translatePartialLoader.addPart('document-toolbar');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrdineDelGiorno', function($stateParams, OrdineDelGiorno) {
                    return OrdineDelGiorno.get({id : $stateParams.idODG}).$promise;
                }],
                seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                    return Seduta.get({id : $stateParams.idSeduta}).$promise;
                }],
                editingMode: [function () {
                    return true;
                }],
                docTypes : [ 'TipoDocumento', function(TipoDocumento) {
                    return TipoDocumento.tipiDocumentoOdg({}).$promise;
                }],
                workingBody: ['$stateParams', function($stateParams) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nameOrg
                    };
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ordine-del-giorno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ordine-del-giorno.new', {
            parent: 'seduta',
            url: '/{idSeduta}/ordine-del-giorno-new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine-del-giorno/ordine-del-giorno-create.html',
                    controller: 'OrdineDelGiornoCreateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                seduta: ['$stateParams', 'Seduta', function($stateParams, Seduta) {
                    return Seduta.get({id : $stateParams.idSeduta}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('ordineDelGiorno');
                    $translatePartialLoader.addPart('tipoODG');
                    $translatePartialLoader.addPart('puntoODG');
                    $translatePartialLoader.addPart('tipoPuntoODG');
                    $translatePartialLoader.addPart('espressioneRichiesta');
                    $translatePartialLoader.addPart('esitoPuntoODG');
                    $translatePartialLoader.addPart('seduta');
                    $translatePartialLoader.addPart('tipoSeduta');
                    $translatePartialLoader.addPart('statoSeduta');
                    $translatePartialLoader.addPart('tipoOrganizzatore');
                    $translatePartialLoader.addPart('statoODGType');
                    return $translate.refresh();
                }],
                workingBody: ['$stateParams', function($stateParams) {
                    return {
                        id: $stateParams.idOrg,
                        tipoOrganismo: $stateParams.typeOrg,
                        nome: $stateParams.nameOrg
                    };
                }]
            }
        })
        .state('ordine-del-giorno.delete', {
            parent: 'ordine-del-giorno',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine-del-giorno/ordine-del-giorno-delete-dialog.html',
                    controller: 'OrdineDelGiornoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OrdineDelGiorno', function(OrdineDelGiorno) {
                            return OrdineDelGiorno.get({id : $stateParams.id}).$promise;
                        }],
                        workingBody: ['$stateParams', function($stateParams) {
                            return {
                                id: $stateParams.idOrg,
                                tipoOrganismo: $stateParams.typeOrg,
                                nome: $stateParams.nameOrg
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine-del-giorno', null, { reload: 'ordine-del-giorno' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('OrdineDelGiorno', OrdineDelGiorno);

    OrdineDelGiorno.$inject = ['$resource'];

    function OrdineDelGiorno ($resource) {
        var resourceUrl =  'api/ordine-del-giornos';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: resourceUrl + '/:id',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllByIdSeduta': {
                method: 'GET',
                url: resourceUrl + '/seduta' + '/:idSeduta',
                isArray: true
            },
            'update': { method:'PUT' },
            'publish': {
                method:'PUT',
                url: resourceUrl + "/publish",
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete': {
                method:'PUT',
                url: resourceUrl + "/delete/:id",
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('MateriaDialogController', MateriaDialogController);

            MateriaDialogController.$inject = ['$timeout', '$scope', 'toastr', '$mdDialog', 'entity', 'Materia', '$state'];

    function MateriaDialogController($timeout, $scope, toastr, $mdDialog, entity, Materia, $state) {
        var vm = this;
        vm.materia = vm.entity;
        vm.clear = clear;
        vm.save = save;
        vm.startMinDate = null;
        vm.startMaxDate = null;
        vm.endMinDate = null;
        vm.endMaxDate = null;
        vm.macroMateriaList = vm.macroMateriaList;

        if (vm.entity && vm.entity.id) {
            updateEndMinMaxDate();
            updateStartMinMaxDate();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.isFormValid = function() {
            return vm.materia.code && vm.materia.description && vm.materia.validityStartDate;
        }
        vm.startDateChanged = function() {
            if (vm.materia.validityStartDate && vm.materia.validityEndDate && vm.materia.validityStartDate >= vm.materia.validityEndDate ) {
                vm.materia.validityEndDate = null;
            }
            updateEndMinMaxDate(); 
        }
        function clear() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isSaving = true;
           if (vm.materia.id) {
                Materia.update(vm.materia, onSaveSuccess, onSaveError);
            } else {
                Materia.save(vm.materia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:materiaUpdate', result);
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('materia', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.macroMateriaChanged = function(macroMateria) {
            if (!macroMateria) {
                vm.materia.validityStartDate = null;
                vm.materia.validityEndDate = null;
            } else {
                var newMacroMateriaSelected = macroMateria;
                vm.materia.validityStartDate = new Date(newMacroMateriaSelected.validityStartDate);
                vm.materia.validityEndDate = newMacroMateriaSelected.validityEndDate ? new Date(newMacroMateriaSelected.validityEndDate) : null;
                vm.materia.macroMateria = newMacroMateriaSelected;
                updateStartMinMaxDate();
                updateEndMinMaxDate();
            }
        }

        function updateStartMinMaxDate() {
            
            if (vm.materia.macroMateria) {
                if (vm.materia.macroMateria.validityEndDate) {
                    vm.startMaxDate = new Date(vm.materia.macroMateria.validityEndDate);
                    vm.startMaxDate.setDate(vm.startMaxDate.getDate() - 1);
                } else {
                    vm.startMaxDate = null;
                }
                vm.startMinDate = new Date(vm.materia.macroMateria.validityStartDate);
            }
        }

        function updateEndMinMaxDate() {
            vm.endMinDate = new Date(vm.materia.validityStartDate);
            vm.endMinDate.setDate(vm.endMinDate.getDate() + 1);
            if (vm.materia.macroMateria) {
                vm.endMaxDate =  vm.materia.macroMateria.validityEndDate ? new Date(vm.materia.macroMateria.validityEndDate) : null;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('MateriaDeleteController', MateriaDeleteController);

            MateriaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Materia'];

    function MateriaDeleteController($uibModalInstance, entity, Materia) {
        var vm = this;

        vm.materia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Materia.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('materia', {
                    parent: 'app',
                    url: '/materia?page&code&description&macroMateriaId',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'materia.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/materia/materia.html',
                            controller: 'MateriaController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'descrizioneAnagrafica,desc',
                            squash: true
                        },
                        code: {
                            value: null,
                            squash: true
                        },
                        description: {
                            value: null,
                            squash: true
                        },
                        macroMateriaId: {
                            value: null,
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('materia');
                                return $translate.refresh();
                            }],
                        macroMateriaList: ['MacroMateria', function (MacroMateria) {
                            return MacroMateria.query().$promise
                        }],    
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                /* predicate: PaginationUtil.parsePredicate($stateParams.sort), */
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                code: $stateParams.code,
                                description: $stateParams.description,
                                macroMateriaId: $stateParams.macroMateriaId
                            }
                        }]
                    }
                }).state('materia.edit', {
                    parent: 'materia',
                    url: '/{id}/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$mdDialog', 'Materia', '$state', 'MacroMateria', function ($stateParams, $mdDialog, Materia, $state, MacroMateria) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/materia/materia-dialog.html',
                                controller: 'MateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: Materia.get({id: $stateParams.id}).$promise,
                                    macroMateriaList: MacroMateria.query().$promise
                                }
                            }).then(function (result) {
                                $state.go('materia', null, {reload: true});
                              },
                              function () {
                                $state.go('materia', null, {reload: false});
                              });
                        }]
                }).state('materia.new', {
                    parent: 'materia',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', '$state', 'MacroMateria', function ($mdDialog, $state, MacroMateria) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/materia/materia-dialog.html',
                                controller: 'MateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {},
                                    macroMateriaList: MacroMateria.query().$promise
                                }
                            }).then(function (result) {
                                $state.go('materia', null, {reload: true});
                              },
                              function () {
                                $state.go('materia', null, {reload: false});
                              });
                        }]
                }).state('materia.delete', {
                    parent: 'materia',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/materia/materia-delete-dialog.html',
                                controller: 'MateriaDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['Materia', function (Materia) {
                                            return Materia.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('materia', null, {reload: 'materia'});
                            },
                            function () {
                              $state.go('materia', null, {reload: false});
                            });
                        }]
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Materia', Materia);

        Materia.$inject = ['$resource', 'DateUtils'];

    function Materia ($resource, DateUtils) {
        var resourceUrl =  'api/:public/materie';

        var resource = $resource(resourceUrl, {}, {
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/paged'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {method: 'DELETE', url: resourceUrl + '/:id'},
            'query': {
                method: 'GET',
                isArray: true,
                url: resourceUrl
            },
            'save': {
                method: 'POST',
                url: resourceUrl,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validityStartDate = DateUtils.convertLocalDateToServer(data.validityStartDate);
                    copy.validityEndDate = DateUtils.convertLocalDateToServer(data.validityEndDate);
                    return angular.toJson(copy);
                }
            },
            'update': {
                method: 'PUT',
                url: resourceUrl,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validityStartDate = DateUtils.convertLocalDateToServer(data.validityStartDate);
                    copy.validityEndDate = DateUtils.convertLocalDateToServer(data.validityEndDate);
                    return angular.toJson(copy);
                }
            }
        });

        return resource;
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('MateriaController', MateriaController);

        MateriaController.$inject = ['$state','toastr', 'pagingParams', 'paginationConstants', 'ParseLinks', 'Materia', 'macroMateriaList'];

    function MateriaController($state, toastr, pagingParams, paginationConstants, ParseLinks, Materia, macroMateriaList) {
        var vm = this;
        vm.materiaList = [];
        vm.macroMateriaList = macroMateriaList;
        //Search default
        vm.pagingParams = pagingParams || {};

         // query stuff
         vm.predicate = vm.pagingParams.predicate;
         vm.reverse = vm.pagingParams.ascending;
         vm.code = vm.pagingParams.code;
         vm.description = vm.pagingParams.description;
         vm.itemsPerPage = paginationConstants.itemsPerPage;
         vm.macroMateriaId = vm.pagingParams.macroMateriaId;
         vm.macroMateriaSelected;

         if (vm.macroMateriaId) {
            vm.macroMateriaSelected = vm.macroMateriaList.find(function(mm){ return mm.id === vm.macroMateriaId}); 
         }

         vm.loading = false;

         loadAll();

         function loadAll() {
             vm.loading = true;
             Materia.queryPaged({
                page: vm.pagingParams.page - 1,
                sort: sort(),
                size: vm.itemsPerPage,
                code: vm.code,
                description: vm.description,
                macroMateriaId: vm.macroMateriaSelected ? vm.macroMateriaSelected.id : null
            }, onSuccess, onError);
         }

         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.materiaList = data;
             vm.page = vm.pagingParams.page;
             vm.loading = false;
         }

         function onError(error) {
             console.log("Failure!", error);
             toastr.error(error.data.message);
             vm.loading = false;
         }

         function sort() {
             var result = [ ('macro_materia.code' + ',asc'),  ('code' + ',asc')];
             return result;
         }

        vm.transition = function() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                code: vm.code,
                description: vm.description,
                macroMateriaId: vm.macroMateriaSelected ? vm.macroMateriaSelected.id : null
            });
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('MacroMateriaDialogController', MacroMateriaDialogController);

            MacroMateriaDialogController.$inject = ['$timeout', '$scope', 'toastr', '$mdDialog', 'entity', 'MacroMateria', '$state'];

    function MacroMateriaDialogController($timeout, $scope, toastr, $mdDialog, entity, MacroMateria, $state) {
        var vm = this;
        vm.macroMateria = vm.entity;
        vm.clear = clear;
        vm.save = save;
        vm.endMinDate = null;

        if (vm.entity && vm.entity.id) {
            updateEndMinDate();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.isFormValid = function() {
            return vm.macroMateria.code && vm.macroMateria.description && vm.macroMateria.validityStartDate;
        }
        vm.startDateChanged = function() {
            if (vm.macroMateria.validityStartDate && vm.macroMateria.validityEndDate && vm.macroMateria.validityStartDate >= vm.macroMateria.validityEndDate ) {
                vm.macroMateria.validityEndDate = null;
            }
            updateEndMinDate(); 
        }
        function clear() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isSaving = true;
           if (vm.macroMateria.id) {
                MacroMateria.update(vm.macroMateria, onSaveSuccess, onSaveError);
            } else {
                MacroMateria.save(vm.macroMateria, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:macroMateriaUpdate', result);
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('macro-materia', null, {reload: true});
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function updateEndMinDate() {
            vm.endMinDate = new Date(vm.macroMateria.validityStartDate);
            vm.endMinDate.setDate(vm.endMinDate.getDate() + 1);
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('MacroMateriaDeleteController', MacroMateriaDeleteController);

            MacroMateriaDeleteController.$inject = ['$uibModalInstance', 'entity', 'MacroMateria'];

    function MacroMateriaDeleteController($uibModalInstance, entity, MacroMateria) {
        var vm = this;

        vm.macroMateria = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MacroMateria.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('macro-materia', {
                    parent: 'app',
                    url: '/macro-materia?page&code&description',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'macro-materia.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/macro-materia/macro-materia.html',
                            controller: 'MacroMateriaController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'descrizioneAnagrafica,desc',
                            squash: true
                        },
                        code: {
                            value: null,
                            squash: true
                        },
                        description: {
                            value: null,
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('macro-materia');
                                return $translate.refresh();
                            }],
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                /* predicate: PaginationUtil.parsePredicate($stateParams.sort), */
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                code: $stateParams.code,
                                description: $stateParams.description
                            }
                        }]
                    }
                }).state('macro-materia.edit', {
                    parent: 'macro-materia',
                    url: '/{id}/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$mdDialog', 'MacroMateria', '$state', function ($stateParams, $mdDialog, MacroMateria, $state) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/macro-materia/macro-materia-dialog.html',
                                controller: 'MacroMateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: MacroMateria.get({id: $stateParams.id}).$promise
                                }
                            }).then(function (result) {
                                $state.go('macro-materia', null, {reload: true});
                              },
                              function () {
                                $state.go('macro-materia', null, {reload: false});
                              });
                        }]
                }).state('macro-materia.new', {
                    parent: 'macro-materia',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', '$state', function ($mdDialog, $state) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: false,
                                templateUrl: 'app/entities/macro-materia/macro-materia-dialog.html',
                                controller: 'MacroMateriaDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {}
                                }
                            }).then(function (result) {
                                $state.go('macro-materia', null, {reload: true});
                              },
                              function () {
                                $state.go('macro-materia', null, {reload: false});
                              });
                        }]
                }).state('macro-materia.delete', {
                    parent: 'macro-materia',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/macro-materia/macro-materia-delete-dialog.html',
                                controller: 'MacroMateriaDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['MacroMateria', function (MacroMateria) {
                                            return MacroMateria.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('macro-materia', null, {reload: 'macro-materia'});
                            },
                            function () {
                              $state.go('macro-materia', null, {reload: false});
                            });
                        }]
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('MacroMateria', MacroMateria);

        MacroMateria.$inject = ['$resource', 'DateUtils'];

    function MacroMateria ($resource, DateUtils) {
        var resourceUrl =  'api/:public/macro-materie';

        var resource = $resource(resourceUrl, {}, {
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/paged'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {method: 'DELETE', url: resourceUrl + '/:id'},
            'query': {
                method: 'GET',
                isArray: true,
                url: resourceUrl
            },
            'save': {
                method: 'POST',
                url: resourceUrl,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validityStartDate = DateUtils.convertLocalDateToServer(data.validityStartDate);
                    copy.validityEndDate = DateUtils.convertLocalDateToServer(data.validityEndDate);
                    return angular.toJson(copy);
                }
            },
            'update': {
                method: 'PUT',
                url: resourceUrl,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validityStartDate = DateUtils.convertLocalDateToServer(data.validityStartDate);
                    copy.validityEndDate = DateUtils.convertLocalDateToServer(data.validityEndDate);
                    return angular.toJson(copy);
                }
            }
        });

        return resource;
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('MacroMateriaController', MacroMateriaController);

        MacroMateriaController.$inject = ['$state','toastr', 'pagingParams', 'paginationConstants', 'ParseLinks', 'MacroMateria'];

    function MacroMateriaController($state, toastr, pagingParams, paginationConstants, ParseLinks, MacroMateria) {
        var vm = this;
        vm.macroMateriaList = [];
        //Search default
        vm.pagingParams = pagingParams || {};

         // query stuff
         vm.predicate = vm.pagingParams.predicate;
         vm.reverse = vm.pagingParams.ascending;
         vm.code = vm.pagingParams.code;
         vm.description = vm.pagingParams.description;
         vm.itemsPerPage = paginationConstants.itemsPerPage;

         vm.loading = false;


         loadAll();

         function loadAll() {
             vm.loading = true;
             MacroMateria.queryPaged({
                page: vm.pagingParams.page - 1,
                sort: sort(),
                size: vm.itemsPerPage,
                code: vm.code,
                description: vm.description
            }, onSuccess, onError);
         }

         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.macroMateriaList = data;
             vm.page = vm.pagingParams.page;
             vm.loading = false;
         }

         function onError(error) {
             console.log("Failure!", error);
             toastr.error(error.data.message);
             vm.loading = false;
         }

         function sort() {
            var result = [('code' + ',asc')];
            return result;
         }

        vm.transition = function() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                code: vm.code,
                description: vm.description
            });
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('ListaDiDistribuzioneDialogController', ListaDiDistribuzioneDialogController);

            ListaDiDistribuzioneDialogController.$inject = ['$timeout', '$scope', 'toastr', '$mdDialog', 'entity', 'ListaDiDistribuzione', '$state'];

    function ListaDiDistribuzioneDialogController($timeout, $scope, toastr, $mdDialog, entity, ListaDiDistribuzione, $state ) {
        var vm = this;
        vm.listaDiDistribuzione = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isSaving = true;
            if(!vm.listaDiDistribuzione.id) {
                ListaDiDistribuzione.create(vm.listaDiDistribuzione, onSaveSuccess, onSaveError);
            } else {
                ListaDiDistribuzione.update(vm.listaDiDistribuzione.id, vm.listaDiDistribuzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:listaDiDistribuzioneUpdate', result);
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('lista-di-distribuzione', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('ListaDiDistribuzioneDeleteController', ListaDiDistribuzioneDeleteController);

            ListaDiDistribuzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'ListaDiDistribuzione'];

    function ListaDiDistribuzioneDeleteController($uibModalInstance, entity, ListaDiDistribuzione) {
        var vm = this;

        vm.listaDiDistribuzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ListaDiDistribuzione.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('lista-di-distribuzione', {
                    parent: 'admin',
                    url: '/lista-di-distribuzione?page',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'lista-di-distribuzione.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/lista-di-distribuzione/lista-di-distribuzione.html',
                            controller: 'ListaDiDistribuzioneController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'nomeLista,desc',
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('lista-di-distribuzione');
                                return $translate.refresh();
                            }],
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort)
                            }
                        }]
                    }
                }).state('lista-di-distribuzione.new', {
                    parent: 'lista-di-distribuzione',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', function ($mdDialog) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: true,
                                templateUrl: 'app/entities/lista-di-distribuzione/lista-di-distribuzione-dialog.html',
                                controller: 'ListaDiDistribuzioneDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {
                                        nomeLista: null,
                                        mail: null,
                                        descrizione: null
                                    }
                                }
                            });
                        }]
                }).state('lista-di-distribuzione.edit', {
                    parent: 'lista-di-distribuzione',
                    url: '/edit/{id}',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['ListaDiDistribuzione', '$stateParams', '$mdDialog', function (ListaDiDistribuzione, $stateParams, $mdDialog) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: true,
                                templateUrl: 'app/entities/lista-di-distribuzione/lista-di-distribuzione-dialog.html',
                                controller: 'ListaDiDistribuzioneDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: ListaDiDistribuzione.get({id: $stateParams.id}).$promise
                                }
                            });
                        }]
                }).state('lista-di-distribuzione.delete', {
                    parent: 'lista-di-distribuzione',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/lista-di-distribuzione/lista-di-distribuzione-delete-dialog.html',
                                controller: 'ListaDiDistribuzioneDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['ListaDiDistribuzione', function (ListaDiDistribuzione) {
                                            return ListaDiDistribuzione.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('lista-di-distribuzione', null, {reload: 'lista-di-distribuzione'});
                            }, function () {
                                $state.go('^');
                            });
                        }]
                }).state('gestione-notifiche', {
                    parent: 'admin',
                    url: '/notification-management',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'gestione-notifiche.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/lista-di-distribuzione/gestione-notifiche.html',
                            controller: 'GestioneNotificheController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'nomeLista,desc',
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('lista-di-distribuzione');
                                return $translate.refresh();
                            }]
                    }
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('ListaDiDistribuzione', ListaDiDistribuzione);

        ListaDiDistribuzione.$inject = ['$resource'];

    function ListaDiDistribuzione ($resource) {
        var resourceUrl =  'api/liste-di-distribuzione';

        var resource = $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                url: resourceUrl
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:idListaDiDistribuzione'
            },
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/paged'
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {method: 'DELETE', url: resourceUrl + '/:id'},
            'query': {
                method: 'GET',
                isArray: true,
                url: resourceUrl
            }
        });

        return resource;
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('ListaDiDistribuzioneController', ListaDiDistribuzioneController);

        ListaDiDistribuzioneController.$inject = ['$state','toastr', 'pagingParams', 'paginationConstants', 'ParseLinks', 'ListaDiDistribuzione', '$translate'];

    function ListaDiDistribuzioneController($state, toastr, pagingParams, paginationConstants, ParseLinks, ListaDiDistribuzione, $translate) {
        var vm = this;
        vm.listaDiDistribuzioneList = [];
        //Search default
        vm.pagingParams = pagingParams || {};

         // query stuff
         vm.predicate = vm.pagingParams.predicate;
         vm.reverse = vm.pagingParams.ascending;
         vm.itemsPerPage = paginationConstants.itemsPerPage;

         vm.loading = false;


         loadAll();

         function loadAll() {
             vm.loading = true;
             ListaDiDistribuzione.queryPaged({
                page: vm.pagingParams.page - 1,
                sort: sort(),
                size: vm.itemsPerPage
            }, onSuccess, onError);
         }

         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.listaDiDistribuzioneList = data;
             vm.page = vm.pagingParams.page;
             vm.loading = false;
         }

         function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                console.log("Failure!", error);
                toastr.error(error.data.message);
                vm.loading = false;
            }
             
         }

         function sort() {
             var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
             if (vm.predicate !== 'id') {
                 result.push('id');
             }
             return result;
         }

        vm.transition = function() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('GestioneNotificheController', GestioneNotificheController);

        GestioneNotificheController.$inject = ['$state','toastr', 'ListaDiDistribuzione', 'ACT_TYPES', 'EVENTI_NOTIFICA_ATTO', 'Atto'];

    function GestioneNotificheController($state, toastr, ListaDiDistribuzione, ACT_TYPES, EVENTI_NOTIFICA_ATTO, Atto) {
        var vm = this;
        vm.loadingListe = false;
        vm.loadingConfiguration = false;
        vm.listeDiDistribuzione = [];
        vm.actTypes = ACT_TYPES;
        vm.listaEventi = EVENTI_NOTIFICA_ATTO;
        vm.selectedAtto = null;
        vm.selectedAttoConfig = null;
        vm.isSavingConfig = false;
        vm.autocompleteModelMap = {};
        vm.autocompleteSearchtextMap = {};

        loadAllListeDiDistribuzione();

        function loadAllListeDiDistribuzione() {
            vm.loadingListe = true;
            ListaDiDistribuzione.query(function (result) {
                vm.listeDiDistribuzione = result;
                vm.loadingListe = false;
            },
            function (error) {
                toastr.error('Si e\' verificato un errore durante il caricamento delle liste di distribuzione disponibili!' , error)
                vm.loadingListe = false;
            });
        }

        vm.loadConfigurazioneNotifiche = function() {
            vm.loadingConfiguration = true;
            if(vm.selectedAtto) {
                Atto.getConfigurazioneNotificheByTipoAtto({tipoAtto: vm.selectedAtto}, 
                    function (result) {
                        initConfig(result);
                        vm.loadingConfiguration = false;
                    },
                    function (error){
                        console.log('Errore durante il caricamento della configurazione del tipo atto ' + vm.selectedAtto, error);
                        vm.loadingConfiguration = false;
                    });
            }
        }

        function initConfig(attoConfig) {
            if(!attoConfig || !attoConfig.tipoAtto) {
                attoConfig = {tipoAtto: vm.selectedAtto, mappaNotifiche: {}};
            }  
            if(!attoConfig.mappaNotifiche) {
                attoConfig.mappaNotifiche = {};
            }
            initEventMap(attoConfig.mappaNotifiche);
            vm.listaEventi.forEach(function(evento) {
                if(attoConfig.mappaNotifiche[evento.value].length > 0) {
                    replaceIdsWithListe(attoConfig.mappaNotifiche[evento.value]);
                }
            });
            vm.selectedAttoConfig = attoConfig;
        }

        function initEventMap(map) {
            vm.listaEventi.forEach(function(eventObject) {
                var event = eventObject.value;
                if(!map[event]) {
                    map[event] = [];
                }
            });
        }

        function replaceIdsWithListe(listaIds) {
           for (var i = listaIds.length - 1; i >= 0; i--) {
               var indexLista = vm.listeDiDistribuzione.findIndex(function (lista) {return listaIds[i] === lista.id});
               if(indexLista >= 0) {
                    listaIds[i] = vm.listeDiDistribuzione[indexLista];  
               } else {
                   // Se non e' stato trovato probabilmente quella lista e' stata eliminata dal DB
                   listaIds.splice(i, 1);
               } 
            }
        }


        function getMapWithListeIds(mapWithListe) {
            var mapWithListeIds = {};
            vm.listaEventi.forEach(function(evento) {
                mapWithListeIds[evento.value] = getArrayListeIds(mapWithListe[evento.value]); 
            });
            return mapWithListeIds;
        }

        function getArrayListeIds(listeArray) {
            var ids = [];
            listeArray.forEach(function(lista){
                ids.push(lista.id);
            });
            return ids;
        }


        vm.searchLista = function (searchText) {
            return searchText ? vm.listeDiDistribuzione.filter(createFilterForLista(searchText)) : [];
        };

        function createFilterForLista(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(lista) {
                var nomeLista = lista.nomeLista ? lista.nomeLista.toLowerCase() : '';
                var mail = lista.mail ? lista.mail.toLowerCase() : ''
                return nomeLista.indexOf(lowercaseQuery) >= 0 || mail.indexOf(lowercaseQuery) >= 0;
            };
        }

        vm.saveConfig = function() {
            vm.isSavingConfig = true;
            var configToSave = {
                id: vm.selectedAttoConfig.id,
                tipoAtto: vm.selectedAttoConfig.tipoAtto,
                mappaNotifiche: getMapWithListeIds(vm.selectedAttoConfig.mappaNotifiche)
            }
            if(vm.selectedAttoConfig.id) {
                Atto.updateConfigurazioneNotifiche({idConfigurazione: configToSave.id}, configToSave, onConfigSaveSuccess, onConfigSaveError);
            } else {
                Atto.createConfigurazioneNotifiche(configToSave, onConfigSaveSuccess, onConfigSaveError);
            }
        }

        function onConfigSaveSuccess() {
            vm.isSavingConfig = false;
            toastr.success('Salvataggio configurazione notifiche per il tipo atto ' + vm.selectedAtto + ' avvenuto con successo!');
        }

        function onConfigSaveError() {
            vm.isSavingConfig = false;
            toastr.error('Errore durante il salvataggio della configurazione notifiche per il tipo atto ' + vm.selectedAtto);
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('importer-board-monitor', {
                    parent: 'app',
                    url: '/importer-board-monitor?page&protocolSystem&protocolNumber&importType&direction&errorType',
                    data: {
                        authorities: ['ROLE_ADMIN', 'ROLE_PROTOCOLLO'],
                        pageTitle: 'importer-board-monitor.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/importer-board-monitor/importer-board-monitor.html',
                            controller: 'ImporterBoardMonitorController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'latestImportDate,desc',
                            squash: true
                        },
                        protocolSystem: {
                            value: null,
                            squash:true
                        },
                        protocolNumber: {
                            value: null,
                            squash:true
                        },
                        importType: {
                            value: null,
                            squash:true
                        },
                        direction: {
                            value: null,
                            squash:true
                        },
                        errorType: {
                            value: null,
                            squash: true
                        },
                        year: {
                            value: null,
                            squash: true
                        },
                        attoNumber: {
                            value: null,
                            squash: true
                        },
                        legislatura: {
                            value: null,
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');

                                return $translate.refresh();
                            }],
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                protocolSystem: $stateParams.protocolSystem,
                                protocolNumber: $stateParams.protocolNumber,
                                importType: $stateParams.importType,
                                direction: $stateParams.direction,
                                errorType: $stateParams.errorType,
                                year: $stateParams.year,
                                attoNumber: $stateParams.attoNumber,
                                legislatura: $stateParams.legislatura
                            }
                        }]
                    }
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('ImporterBoardMonitor', ImporterBoardMonitor);

        ImporterBoardMonitor.$inject = ['$resource'];

    function ImporterBoardMonitor ($resource) {
        var resourceUrl =  'api/:public/sincronizzatore-anagrafiche/:id/:latest';

        var resource = $resource(resourceUrl, {}, {
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: 'api/public/paged/protocol-import-details'
            },
            'retryImport': {
                method: 'POST',
                url: 'api/protocol-import-details/retry-import'
            }
        });

        resource.errorCodeToString = function(errorCode, metadati) {
            switch(errorCode) {
                case 'PRATICA_ASSENTE': 
                    return 'Non è stata trovata nessuna pratica associata.';
                case 'DETTAGLI_DOSSIER_NON_RICEVUTI': 
                    return 'Nessun dettaglio della pratica ricevuto da protocollo.';
                case 'DATI_NON_COMPLETI': 
                    return 'I dati numero atto e/o legistlatura e/o anno sono incompleti.';
                case 'TIPO_PROPONENTE_SCONOSCIUTO':
                    var codiciAnagrafiche = 'Codici Anagrafiche ricevute: [';
                    if(!metadati || !metadati.recipientList || metadati.recipientList.length === 0){
                        return 'Tipo proponente non riconosciuto. ' + codiciAnagrafiche + ']';
                    }

                    for(var i = 0; i < metadati.recipientList.length; i++) {
                        codiciAnagrafiche = codiciAnagrafiche + metadati.recipientList[i].code;
                        if(i === metadati.recipientList.length - 1) {
                            codiciAnagrafiche = codiciAnagrafiche + ']';
                        } else {
                            codiciAnagrafiche = codiciAnagrafiche + ',';
                        }
                    }
                    return 'Tipo proponente non riconosciuto. ' + codiciAnagrafiche;
                case 'IMPOSSIBILE_RECUPERARE_PROPONENTE': 
                    return 'Impossibile recuperare i dati di anagrafica di uno dei proponenti.';
                case 'CODICE_SEZIONE_SCONOSCIUTO':
                    if(!metadati || !metadati.mnemonicList || !metadati.mnemonicList.length === 0) {
                        return 'Codice mnemonico di sezione non riconosciuto.';
                    }
                    var listaCodici = '[';
                    metadati.mnemonicList.forEach(function(mnemonic, index){
                        if(mnemonic.typeCode) {
                            listaCodici = listaCodici + mnemonic.typeCode;
                            if(index === metadati.mnemonicList.length - 1){
                                listaCodici = listaCodici + ']'
                            } else {
                                listaCodici = listaCodici + ',';
                            }
                        } else {
                            listaCodici = mnemonic; 
                        }
                    });
                    return 'Codice mnemonico di sezione non riconosciuto. ' + listaCodici;
                case 'CODICE_DOCUMENTO_SCONOSCIUTO':
                    return 'Codice mnemonico di documento non riconosciuto.';
                case 'SUCCESS': 
                    return '';
                case 'LISTA_DOSSIER_VUOTA':
                    return 'Lista dossier vuota.';
                case 'XML_PARSE_ERROR':
                    return 'Errore nel ricevimento del dettaglio di protocollo (Errore XML).';
                case 'CONTROLLO_IMPORT_DOCUMENTI_FALLITO':
                    return 'Errore generico di controllo presenza documenti.';
                case 'DOCUMENTO_NON_SALVATO_DB':
                    return 'Errore controllo presenza documenti - Documento non presente su DB';
                case 'DOCUMENTO_NON_SALVATO_FS':
                    return 'Errore controllo presenza documenti - Documento non presente su file system';
                case 'DOCUMENTO_NON_AGGIORNATO_FS':
                    return 'Errore controllo presenza documenti - Documento non aggiornato su file system';
                case 'IMPORT_STARTED':
                    return 'Importazione iniziata ma non ancora terminata.';
                case 'IMPORT_NOT_ENABLED':
                        return 'Flag di importazione non abilitato. Protocollo non elaborato.';
                case 'DETTAGLI_DOCUMENTO_NON_RICEVUTI':
                    return 'Nessun dettaglio del documento ricevuto da protocollo.';
                case 'PROPRIETA_AGGIUNTIVE_DOCUMENTO_NON_RICEVUTE':
                    return 'Proprietà aggiuntive DOCUMENTO non complete.';
                case 'DETTAGLI_FASCICOLO_NON_RICEVUTI':
                    return 'Nessun dettaglio del fascicolo ricevuto da protocollo.';
                case 'PROPRIETA_AGGIUNTIVE_FASCICOLO_NON_RICEVUTE':
                    return 'Proprietà aggiuntive FASCICOLO non complete.';
                case 'FILES_NON_RICEVUTI':
                        return 'Files allegati al documento non ricevuti da protocollo.';
                case 'ALTRO': 
                    return "Errore generico, contattare l'amministratore di sistema.";
            }

        }

        resource.getErrorTypeString = function (errorType) {
            switch(errorType) {
                case 'SUCCESS':
                    return 'IMPORTATO';
                case 'IMPORT_STARTED':
                    return 'IMPORT INIZIATO';
                default:
                    return 'ERRORE:'
            }
        }

        return resource;

    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('ImporterBoardMonitorController', ImporterBoardMonitorController);

        ImporterBoardMonitorController.$inject = ['$scope', '$state', '$mdDialog', 'toastr', 'pagingParams', 'paginationConstants', 'ImporterBoardMonitor', 'ParseLinks', 'ACT_TYPES','Atto'];

    function ImporterBoardMonitorController($scope, $state, $mdDialog, toastr, pagingParams, paginationConstants, ImporterBoardMonitor, ParseLinks, ACT_TYPES, Atto) {
        var vm = this;
        vm.ImporterBoardMonitor = ImporterBoardMonitor;
        vm.actTypes = ACT_TYPES;
        vm.protocolImportDetails = [];
        //Search default
        vm.pagingParams = pagingParams || {};
        vm.protocolSystem = vm.pagingParams.protocolSystem;
        vm.protocolNumber = Number(vm.pagingParams.protocolNumber) === 0 ? null : Number(vm.pagingParams.protocolNumber);
        vm.importType = vm.pagingParams.importType;
        vm.direction = vm.pagingParams.direction;
        vm.errorType = vm.pagingParams.errorType;
        vm.year = vm.pagingParams.year;
        vm.attoNumber = vm.pagingParams.attoNumber;
        vm.legislatura = vm.pagingParams.legislatura;
        
        vm.startProtocolImport = startProtocolImport;

         // query stuff
         vm.predicate = vm.pagingParams.predicate;
         vm.reverse = vm.pagingParams.ascending;
         vm.itemsPerPage = paginationConstants.itemsPerPage;

         vm.loading = false;
         vm.manualImportLoadingMap = {};

         vm.legislature = [];
         Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);
         function onSuccessLeg(data) {
             vm.legislature = data;
         }
         function onErrorLeg(error) {
             console.log('Error loading legisalture ', error);
         }

         loadAll();

         function loadAll() {
             vm.loading = true;
             ImporterBoardMonitor.queryPaged({
                 page: vm.pagingParams.page - 1,
                 sort: sort(),
                 size: vm.itemsPerPage,
                 protocolSystem: vm.protocolSystem,
                 protocolNumber: vm.protocolNumber,
                 importType: vm.importType,
                 direction: vm.direction,
                 errorType: vm.errorType,
                 year: vm.year,
                 attoNumber: vm.attoNumber,
                 legislatura: vm.legislatura
             }, onSuccess, onError);
         }

         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.protocolImportDetails = data;
             vm.page = vm.pagingParams.page;
             vm.loading = false;
         }

         function onError(error) {
             console.log("Failure!", error);
             toastr.error(error.data.message);
             vm.loading = false;
         }

         function sort() {
             var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
             if (vm.predicate !== 'id') {
                 result.push('id');
             }
             return result;
         }

        vm.transition = function() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                protocolSystem: vm.protocolSystem,
                protocolNumber: vm.protocolNumber,
                importType: vm.importType,
                direction: vm.direction,
                errorType: vm.errorType,
                year: vm.year,
                attoNumber: vm.attoNumber,
                legislatura: vm.legislatura
            });
        }

        vm.filterTotalDocuments = function(documentArray) {
            return documentArray.filter(function(doc) {
                return (doc["deleted"] == undefined || doc["deleted"] == false);
              });
        }

        vm.filterImportedDocuments = function(documentArray) {
            return documentArray.filter(function(doc) {
                return doc["imported"] == true && (doc["deleted"] == undefined || doc["deleted"] == false);
              });
        }

        vm.alertImportDocument = function(documentArray) {
            return documentArray.filter(function(doc) {
                return doc["imported"] == false && (doc["deleted"] == undefined || doc["deleted"] == false);
              }).length > 0;
        }

        vm.filterTechnicalDocuments = function(documentArray) {
            return documentArray.filter(function(doc) {
                return doc["technical"] == true && (doc["deleted"] == undefined || doc["deleted"] == false);
              });
        }

        function startProtocolImport(index, importDetail) {

            var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler procedere con l\'import manuale del protocollo?')
                    .textContent('La procedura ')
                    .ariaLabel('Import Manuale Protocollo')
                    .ok('Conferma')
                    .cancel('Annulla');

                $mdDialog.show(confirm).then(function () {
                    vm.manualImportLoadingMap[importDetail.id] = true;

                    ImporterBoardMonitor.retryImport( importDetail , 
                    function(data, headers) {
                        onSuccessManualImport(index, data)
                    }, function(error) {
                        onErrorManualImport(index, error, importDetail)
                    });
                }, function () {
                    
                });            
            
        }

        function onSuccessManualImport(index, data) {

            vm.protocolImportDetails[index] = data;
            vm.manualImportLoadingMap[data.id] = false;
        }

        function onErrorManualImport(index, error, importDetail) {


            vm.manualImportLoadingMap[importDetail.id] = false;
            console.log("Failure!", error);
            toastr.error("Errore nell'import manuale del protocollo " + importDetail.protocolNumber);
            
        }
        
          
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('DocumentoTreeController', DocumentoTreeController);

    DocumentoTreeController.$inject = ['Documento', 'Atto', 'toastr', 'entity', 'utente', 'FileSaver', '$window', '$stateParams', 'ArchiveTreeService'];

    function DocumentoTreeController(Documento, Atto, toastr, entity, utente, FileSaver, $window, $stateParams, ArchiveTreeService) {
        var vm = this;


        vm.atto = entity;

        vm.statoSezione = $stateParams.stato;
        vm.nomeSezione = $stateParams.sezione;

        vm.utente = utente;

        getArchiveTreeSection();

        vm.downloadFile = downloadFile;
        vm.getLink = ArchiveTreeService.getLink;


        function getArchiveTreeSection() {
            if (vm.statoSezione) {
                Atto.getArchiveTreeSection(vm.atto.id, vm.statoSezione, vm.nomeSezione, null).then(function (response) {
                    vm.archiveTree = [response.data];
                });
            } else {
                Atto.getArchiveTree(vm.atto.id, null).then(function (response) {
                    vm.archiveTree = [response.data];
                });
            }
        }

        function downloadFile(id, name) {

            vm.loading = true;
            Documento.get({id: id}, {}, function (doc) {
                Documento.getContent(id).then(function (response) {
                    if (response && response.data) {
                        var mimeType = doc.mimeType;

                        if (mimeType !== "") {
                            var file = new Blob([response.data], {
                                //type: mimeType
                            });
                            var fileURL = URL.createObjectURL(file);

                            $window.open(fileURL);

                        } else {
                            FileSaver.saveAs(new Blob([response.data], {}), name);
                        }
                    }

                    vm.loading = false;
                }, function (error) {
                    console.log('Impossibile scaricare il fascicolo');
                    toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                    vm.loading = false;
                });
            });
        }
        
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('DocumentoContentController', DocumentoContentController);

    DocumentoContentController.$inject = ['Documento', 'toastr', 'entity', 'utente', 'FileSaver', '$window', '$sce'];

    function DocumentoContentController(Documento, toastr, entity, utente, FileSaver, $window, $sce) {
        var vm = this;

        vm.doc = entity;

        vm.utente = utente;
        vm.response = null;

        vm.mimeType = vm.doc.mimeType;

        vm.error = false;
        vm.errorStatus = null;
        getPath();


        function getPath() {
            Documento.getContent(vm.doc.id).then(function (response) {
                if (response && response.data) {
                    vm.response = response;
                    //L'endsWith non e' supportato su IE quindi va fatto prima il controllo che non sia IE!
                    if ( !isIE() && !isIphone() && !isAndroid() && (vm.mimeType === "application/pdf" || (vm.doc.nome.toLowerCase()).endsWith(".pdf") )) {
                        var file = new Blob([response.data], {
                            type: "application/pdf"
                        });

                        var fileURL = URL.createObjectURL(file);
                        vm.path = $sce.trustAsResourceUrl(fileURL);
                    } else {
                        vm.download();
                    }
                }
            }, function (error) {
                console.log('Impossibile visualizzare il file');
                toastr.error('Impossibile visualizzare il file', error.data.message);
                vm.errorStatus = error && error.status ? error.status : null;

                vm.error = true;
                vm.loading = false;
            });
        }

        function isIE() {
            return (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1));
        }

        function isIphone() {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        }

        function isAndroid() {
            return !!navigator.platform && /android/i.test(navigator.platform);
        }

        vm.download = function() {
            var fileType = null;
            //L'endsWith non e' supportato su IE quindi va fatto prima il controllo che non sia IE!
            if(!isIE()){
                if(vm.mimeType === "application/pdf" || (vm.doc.nome.toLowerCase()).endsWith(".pdf") ){
                    fileType = 	'application/pdf';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".doc")) {
                    fileType = 	'application/msword';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".docx")){
                    fileType = 	'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".xls")){
                    fileType = 	'application/vnd.ms-excel';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".xlsx")){
                    fileType = 	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".ppt")){
                    fileType = 	'application/vnd.ms-powerpoint';
                } else if((vm.doc.nome.toLowerCase()).endsWith(".pptx")){
                    fileType = 	'application/vnd.openxmlformats-officedocument.presentationml.presentation';
                }  else if((vm.doc.nome.toLowerCase()).endsWith(".png")){
                    fileType = 	'image/png';
                }  else if((vm.doc.nome.toLowerCase()).endsWith(".jpeg")){
                    fileType = 	'image/jpeg';
                }  else if((vm.doc.nome.toLowerCase()).endsWith(".gif")){
                    fileType = 	'image/gif';
                }
            }
            if(fileType){
                FileSaver.saveAs(new Blob([vm.response.data], {type: fileType}), vm.doc.nome);
            } else {
                FileSaver.saveAs(new Blob([vm.response.data], {}), vm.doc.nome);
            }
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('view-document-tree', {
                    parent: 'entity',
                    url: '/document_tree/{legislatura}/{anno}/{tipoAtto}/{numeroAtto}/{stato}',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.documento-tree.title'
                    },
                    params: {
                        sezione: {
                            value: '',
                            squash: true
                        }
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/documento/documento-tree.html',
                            controller: 'DocumentoTreeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        entity: ['$stateParams', 'Atto', function ($stateParams, Atto) {
                                return Atto.getByPk({
                                    legislatura: $stateParams.legislatura,
                                    anno: $stateParams.anno,
                                    tipoAtto: $stateParams.tipoAtto,
                                    numeroAtto: $stateParams.numeroAtto,
                                }).$promise;
                            }],

                        utente: ['Principal', function (Principal) {
                                return Principal.identity();
                            }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('archive-tree');
                                return $translate.refresh();
                            }]
                    }
                })
                .state('view-document-tree-section', {
                    parent: 'view-document-tree',
                    url: '/?sezione'
                })
                .state('view-document-content', {
                    parent: 'entity',
                    url: '/document/{documentId}/content',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.documento-content.title'
                    },

                    views: {
                        'content@': {
                            templateUrl: 'app/entities/documento/documento-content.html',
                            controller: 'DocumentoContentController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        entity: ['$stateParams', 'Documento', function ($stateParams, Documento) {
                                return Documento.get({id: $stateParams.documentId}).$promise;
                            }],

                        utente: ['Principal', function (Principal) {
                                return Principal.identity();
                            }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                return $translate.refresh();
                            }]
                    }
                });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('Documento', Documento);

    Documento.$inject = ['$resource', '$http'];

    function Documento($resource, $http) {
        var resourceUrl = 'api/:public/documenti/:id/:content/:idSezione/:group/:retryProtocol';

        var resource = $resource(resourceUrl, {id: '@id'}, {
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'retryProtocol': {
                method: 'POST',
                params: {
                    retryProtocol: 'retryProtocol'
                }
            },
            'getDocumentiEmendamento': {
                url: 'api/public/documenti/emendamenti/:sezioneId',
                method: 'GET',
                isArray: true
            },
            'getDocumentiBySezioneId': {
                url: 'api/documenti/sezione/:sezioneId',
                method: 'GET',
                isArray: true
            },
            'getDocumentiDiRitiroAtto': {
                url: 'api/public/documenti/:idAtto/:mnemonic',
                method: 'GET',
                isArray: true
            },
            'addOrUpdateDocumentCandidaturaDesignazione': {
                url: 'api/documenti/:documentId/candidatureDesignazioni',
                method: 'PUT'
            },
        });

        resource.getContent = function (id) {
            return $http.get('api/public/documenti/' + id + '/content', {
                responseType: 'arraybuffer'
            });

        };

        resource.getDocSeduta = function (id) {
            return $http.get('api/public/documenti-seduta/' + id , {});
        };

        resource.getDocSedutaContent = function (id) {
            return $http.get('api/public/documenti-seduta/' + id + '/content', {
                responseType: 'arraybuffer'
            });

        };

        resource.deleteDocSedutaContent = function (id) {
            return $http.delete('api/documenti-seduta/' + id );
        };

        resource.getGroupArchive = function (idSezione, group, publicView) {
            return $http.get('api/public/documenti/' + idSezione + '/' + group + '/content', {
                responseType: 'arraybuffer',
                params: {publicView: publicView}
            });

        };

        resource.retryProtocolSedutaOdg = function(idSeduta, idOdgDoc){
            return $http.post('api/documenti-seduta/' + idSeduta + "/" + idOdgDoc + "/retryProtocol", {}, {});
        };

        return resource;
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('DirezioneDialogController', DirezioneDialogController);

    DirezioneDialogController.$inject = ['$timeout', '$scope', 'toastr', '$uibModalInstance', 'entity', 'Direzione', '$q'];

    function DirezioneDialogController($timeout, $scope, toastr, $uibModalInstance, entity, Direzione, $q) {
        var vm = this;

        vm.direzione = entity;
        vm.clear = clear;
        vm.save = save;

        vm.selectedItem = vm.direzione.anagraficaProtocollo;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.direzione.id !== null) {
                Direzione.update(vm.direzione, onSaveSuccess, onSaveError);
            } else {
                Direzione.save(vm.direzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:direzioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.setAnagrafic = function (item) {
            if (item) {
                vm.direzione.anagraficaProtocollo = item;
            }
        };

        vm.searchAnagrafics = function (text) {
            var deferred = $q.defer();
            Direzione.listFromProtocol({'code': text}, function (data) {
                deferred.resolve(data);
                return deferred.promise;
            }, function (error) {
                toastr.error(error);
                deferred.reject(error);
            });
            return deferred.promise;
        };

        vm.getDisplayName = function (item) {
            return item.anagraficCode + ' - ' + item.anagraficDescription;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('DirezioneDetailController', DirezioneDetailController);

    DirezioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Direzione'];

    function DirezioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Direzione) {
        var vm = this;

        vm.direzione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:direzioneUpdate', function(event, result) {
            vm.direzione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('DirezioneDeleteController',DirezioneDeleteController);

    DirezioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Direzione'];

    function DirezioneDeleteController($uibModalInstance, entity, Direzione) {
        var vm = this;

        vm.direzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Direzione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('direzione', {
            parent: 'entity',
            url: '/direzione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.direzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/direzione/direziones.html',
                    controller: 'DirezioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('direzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('direzione-detail', {
            parent: 'direzione',
            url: '/direzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.direzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/direzione/direzione-detail.html',
                    controller: 'DirezioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('direzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Direzione', function($stateParams, Direzione) {
                    return Direzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'direzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('direzione-detail.edit', {
            parent: 'direzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('direzione.new', {
            parent: 'direzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('direzione');
                });
            }]
        })
        .state('direzione.edit', {
            parent: 'direzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('direzione.delete', {
            parent: 'direzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-delete-dialog.html',
                    controller: 'DirezioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('Direzione', Direzione);

    Direzione.$inject = ['$resource'];

    function Direzione($resource) {
        var resourceUrl = 'api/:public/direziones/:id/:protocolloAnagrafic';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {public: 'public'},
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'listFromProtocol': {method: 'GET', params: {protocolloAnagrafic: 'protocolloAnagrafic'}, isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('DirezioneController', DirezioneController);

    DirezioneController.$inject = ['Direzione'];

    function DirezioneController(Direzione) {

        var vm = this;

        vm.direziones = [];

        loadAll();

        function loadAll() {
            Direzione.query(function(result) {
                vm.direziones = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneRuoloDialogController', CommissioneRuoloDialogController);

    CommissioneRuoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommissioneRuolo'];

    function CommissioneRuoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CommissioneRuolo) {
        var vm = this;

        vm.commissioneRuolo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.commissioneRuolo.id !== null) {
                CommissioneRuolo.update(vm.commissioneRuolo, onSaveSuccess, onSaveError);
            } else {
                CommissioneRuolo.save(vm.commissioneRuolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:commissioneRuoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneRuoloDetailController', CommissioneRuoloDetailController);

    CommissioneRuoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CommissioneRuolo'];

    function CommissioneRuoloDetailController($scope, $rootScope, $stateParams, previousState, entity, CommissioneRuolo) {
        var vm = this;

        vm.commissioneRuolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:commissioneRuoloUpdate', function(event, result) {
            vm.commissioneRuolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneRuoloDeleteController',CommissioneRuoloDeleteController);

    CommissioneRuoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommissioneRuolo'];

    function CommissioneRuoloDeleteController($uibModalInstance, entity, CommissioneRuolo) {
        var vm = this;

        vm.commissioneRuolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommissioneRuolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('commissione-ruolo', {
            parent: 'entity',
            url: '/commissione-ruolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissioneRuolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolos.html',
                    controller: 'CommissioneRuoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneRuolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('commissione-ruolo-detail', {
            parent: 'commissione-ruolo',
            url: '/commissione-ruolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissioneRuolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-detail.html',
                    controller: 'CommissioneRuoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneRuolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommissioneRuolo', function($stateParams, CommissioneRuolo) {
                    return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'commissione-ruolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('commissione-ruolo-detail.edit', {
            parent: 'commissione-ruolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione-ruolo.new', {
            parent: 'commissione-ruolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('commissione-ruolo');
                });
            }]
        })
        .state('commissione-ruolo.edit', {
            parent: 'commissione-ruolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione-ruolo.delete', {
            parent: 'commissione-ruolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-delete-dialog.html',
                    controller: 'CommissioneRuoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('CommissioneRuolo', CommissioneRuolo);

    CommissioneRuolo.$inject = ['$resource'];

    function CommissioneRuolo ($resource) {
        var resourceUrl =  'api/commissione-ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneRuoloController', CommissioneRuoloController);

    CommissioneRuoloController.$inject = ['CommissioneRuolo'];

    function CommissioneRuoloController(CommissioneRuolo) {

        var vm = this;

        vm.commissioneRuolos = [];

        loadAll();

        function loadAll() {
            CommissioneRuolo.query(function(result) {
                vm.commissioneRuolos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('commissione-atti-giacenti', {
            parent: 'app',
            url: '/commissione-atti/giacenti?page&sort&type&term&numeroAttoSearch&idCommissione&legislatura',
            data: {
                authorities: [],
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-atti/commissione-atti.html',
                    controller: 'CommissioneAttiController',
                    controllerAs: 'vm'
                },
                'navbar@' : {
                    templateUrl: 'app/layouts/navbar/navbar-commission-pages.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroAtto,desc',
                    squash: true
                },
                type: {
                    value: null,
                    squash:true
                },
                term: {
                    value: null,
                    squash:true
                },
                legislatura: {
                    value: null,
                    squash: true
                },
                numeroAttoSearch: {
                    value: null,
                    squash: true
                },
                idCommissione: {
                    value: null,
                    squash: true
                }
            },
            onEnter: ['$state', 'Principal', '$timeout', function ($state, Principal, $timeout) {
                // if (Principal.isAuthenticated()) {
                //     $timeout(function () {
                //         $state.go('home_logged', {}, {reload: true});
                //     }, 0);
                // }
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneAtti'); /* TODO */
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('tipoProponente');
                    $translatePartialLoader.addPart('form');
                    return $translate.refresh();
                }],
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }],
                pagingParams: ['PaginationUtil', '$stateParams', 'defaultLegislatura',function (PaginationUtil, $stateParams, defaultLegislatura) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        type: $stateParams.type,
                        term: $stateParams.term,
                        legislatura: $stateParams.legislatura || defaultLegislatura.legislatura,
                        numeroAttoSearch: $stateParams.numeroAttoSearch,
                        idCommissione: $stateParams.idCommissione,
                        tipoPaginaCommissione: '1'
                    };
                }]
            }
        })
        .state('commissione-atti-licenziati', {
            parent: 'app',
            url: '/commissione-atti/licenziati?page&sort&type&term&numeroAttoSearch&idCommissione&legislatura',
            data: {
                authorities: [],
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-atti/commissione-atti.html',
                    controller: 'CommissioneAttiController',
                    controllerAs: 'vm'
                },
                'navbar@' : {
                    templateUrl: 'app/layouts/navbar/navbar-commission-pages.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroAtto,desc',
                    squash: true
                },
                type: {
                    value: null,
                    squash:true
                },
                term: {
                    value: null,
                    squash:true
                },
                legislatura: {
                    value: null,
                    squash: true
                },
                numeroAttoSearch: {
                    value: null,
                    squash: true
                },
                idCommissione: {
                    value: null,
                    squash: true
                }
            },
            onEnter: ['$state', 'Principal', '$timeout', function ($state, Principal, $timeout) {
                // if (Principal.isAuthenticated()) {
                //     $timeout(function () {
                //         $state.go('home_logged', {}, {reload: true});
                //     }, 0);
                // }
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneAtti'); /* TODO */
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    $translatePartialLoader.addPart('tipoProponente');
                    $translatePartialLoader.addPart('form');
                    return $translate.refresh();
                }],
                defaultLegislatura: ['Atto', function(Atto) {
                    return Atto.defaultLegislatura({}).$promise;
                }],
                pagingParams: ['PaginationUtil', '$stateParams', 'defaultLegislatura', function (PaginationUtil, $stateParams, defaultLegislatura) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        type: $stateParams.type,
                        term: $stateParams.term,
                        legislatura: $stateParams.legislatura || defaultLegislatura.legislatura,
                        numeroAttoSearch: $stateParams.numeroAttoSearch,
                        idCommissione: $stateParams.idCommissione,
                        tipoPaginaCommissione: '2'
                    };
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneAttiController', CommissioneAttiController);

    CommissioneAttiController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', 'PaginationUtil', '$translate', 'pagingParams', 'Commissione', 'toastr', '$location', 'ATTI_TABLE_TYPE'];

    function CommissioneAttiController($scope, Principal, LoginService, $state, $stateParams, PaginationUtil, $translate, pagingParams, Commissione, toastr, $location, ATTI_TABLE_TYPE) {
        $translate.refresh();
        var vm = this;

        vm.pagingParams = pagingParams;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register () {
            $state.go('register');
        }

        //http://localhost:8081/#/commissione-atti/giacenti?idCommissione=5a534ec3546803124d2e9782
        //http://localhost:8081/#/commissione-atti/licenziati?idCommissione=5a534ec3546803124d2e9782

        var params = $location.search();

        vm.idCommissione = angular.isUndefined(params.idCommissione) ? 0 : params.idCommissione;
        vm.legislatura = pagingParams.legislatura;
        vm.tipoPaginaCommissione = vm.pagingParams.tipoPaginaCommissione;

        if (vm.idCommissione <= 0) {
            toastr.error('Identificativo commissione non valido');
            return; //TODO: Redirect 404?
        }

        if (vm.legislatura === '') {
            toastr.error('Numero legislatura non valido');
            return; //TODO: Redirect 404?
        }

        vm.commissione = {};
        loadCommissione();

        function loadCommissione() {
            Commissione.get({id: vm.idCommissione}, {}, function(result) {
                vm.commissione = result;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneDialogController', CommissioneDialogController);

    CommissioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Commissione', 'legislature'];

    function CommissioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Commissione, legislature) {
        var vm = this;

        vm.commissione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.legislature = legislature;
        vm.selectedLegislature = {};
        
        if (vm.commissione.legislature) {
            vm.commissione.legislature.forEach(function(legislatura) {
                vm.selectedLegislature[legislatura] = true;
            });
        }
        
        $scope.$watch('vm.selectedLegislature', function() {
            vm.commissione.legislature = Object.keys(vm.selectedLegislature)
                .filter(function(key) {
                    return vm.selectedLegislature[key];
                });
        }, true);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.commissione.id !== null) {
                Commissione.update(vm.commissione, onSaveSuccess, onSaveError);
            } else {
                Commissione.save(vm.commissione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:commissioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneDetailController', CommissioneDetailController);

    CommissioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Commissione'];

    function CommissioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Commissione) {
        var vm = this;

        vm.commissione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:commissioneUpdate', function(event, result) {
            vm.commissione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneDeleteController',CommissioneDeleteController);

    CommissioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Commissione'];

    function CommissioneDeleteController($uibModalInstance, entity, Commissione) {
        var vm = this;

        vm.commissione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Commissione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('commissione', {
            parent: 'entity',
            url: '/commissione?legislatura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione/commissiones.html',
                    controller: 'CommissioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('commissione-detail', {
            parent: 'commissione',
            url: '/commissione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione/commissione-detail.html',
                    controller: 'CommissioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Commissione', function($stateParams, Commissione) {
                    return Commissione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'commissione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                legislature: ['Atto', function(Atto) {
                    return Atto.queryLegislature().$promise;
                }]
            }
        })
        .state('commissione-detail.edit', {
            parent: 'commissione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione/commissione-dialog.html',
                    controller: 'CommissioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Commissione', function(Commissione) {
                            return Commissione.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione.new', {
            parent: 'commissione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione/commissione-dialog.html',
                    controller: 'CommissioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        },
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione', null, { reload: 'commissione' });
                }, function() {
                    $state.go('commissione');
                });
            }]
        })
        .state('commissione.edit', {
            parent: 'commissione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione/commissione-dialog.html',
                    controller: 'CommissioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Commissione', function(Commissione) {
                            return Commissione.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione', null, { reload: 'commissione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione.delete', {
            parent: 'commissione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione/commissione-delete-dialog.html',
                    controller: 'CommissioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Commissione', function(Commissione) {
                            return Commissione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione', null, { reload: 'commissione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Commissione', Commissione);

    Commissione.$inject = ['$resource'];

    function Commissione ($resource) {
        var resourceUrl =  'api/:public/commissiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', params: {public: 'public'}, isArray: true},
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneController', CommissioneController);

    CommissioneController.$inject = ['Commissione', 'Atto', '$stateParams', '$state'];

    function CommissioneController(Commissione, Atto, $stateParams, $state) {

        var vm = this;
        vm.basicSearchLegislatura = $stateParams.legislatura;

        vm.commissiones = [];
        vm.transition = transition;

        vm.legislature = [];
        Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);

        function onSuccessLeg(data){
            vm.legislature=data;
            if(vm.legislature && vm.legislature.indexOf(11) === -1) {
                vm.legislature.push(11);
            }
        }
        function onErrorLeg(error){
            console.log("Failure!", error);
            toastr.error(error.data.message);
        }

        loadAll();

        function loadAll() {
            Commissione.query({legislature: vm.basicSearchLegislatura, includeHidden: true}, function(result) {
                vm.commissiones = result;
                vm.searchQuery = null;
            });
        }


        function transition() {

            if(vm.basicSearchLegislatura && vm.basicSearchLegislatura !== 'ALL') {
                $state.transitionTo($state.$current, {
                    legislatura: vm.basicSearchLegislatura
                });
            }else {
                $state.transitionTo($state.$current, {
                    legislatura: null
                });
            }
        }
    }
})();


(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('atto-report-generator', {
                    parent: 'app',
                    url: '/atto-report-generator',
                    data: {
                        pageTitle: 'atto-report-generator.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto-report-generator/atto-report-generator.html',
                            controller: 'AttoReportGeneratorController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('commissione');
                                return $translate.refresh();
                            }]
                    }
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('AttoReportGenerator', AttoReportGenerator);

        AttoReportGenerator.$inject = ['$resource'];

    function AttoReportGenerator ($resource) {
        var resourceUrl =  'api/:public/sincronizzatore-anagrafiche/:id/:latest';

        var resource = $resource(resourceUrl, {}, {
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: 'api/public/paged/protocol-import-details'
            }
        });
        return resource;
    }
})();
(function() {
    "use strict";

    angular
        .module("gestioneAttiApp")
        .controller(
            "AttoReportGeneratorController",
            AttoReportGeneratorController
        );

    AttoReportGeneratorController.$inject = [
        "$state",
        "toastr",
        "ACT_TYPES",
        "SEARCH_STATES",
        "Commissione",
        "SoggettoEsterno",
        "AnagraficaProtocollo",
        "Direzione",
        "Atto",
        "FileSaver",
        "$mdDialog",
        "Principal"
    ];

    function AttoReportGeneratorController(
        $state,
        toastr,
        ACT_TYPES,
        SEARCH_STATES,
        Commissione,
        SoggettoEsterno,
        AnagraficaProtocollo,
        Direzione,
        Atto,
        FileSaver,
        $mdDialog,
        Principal
    ) {
        var vm = this;
        vm.loading = false;
        vm.searchParams = {};
        vm.isTipoGRselected = false;
        vm.cambioStatoAttoList = [];
        vm.clearSearch = clearSearch;
        vm.legislaturaChanged = legislaturaChanged;

        SEARCH_STATES.forEach(function(stato){
            if(stato.value !== 'PRESENTATO') {
                vm.cambioStatoAttoList.push(stato);
            }
        });
        vm.commissionsReportVisible = Principal.hasAnyAuthority(['ROLE_COMMISSIONE']) || Principal.hasAnyAuthority(['ROLE_ADMIN']);
        loadAll();

        function loadAll() {
            vm.clearSearch();
            vm.queryStates = SEARCH_STATES;
            vm.actTypes = ACT_TYPES;
            vm.Atto = Atto;
            vm.proponenti = [];

            Atto.defaultLegislatura({}, onSuccessDefLeg, onErrorLeg);

            function onSuccessDefLeg(data) {
                vm.searchParams.legislatura = data.legislatura;
                loadCommissioniAndSoggettiEsterni();
            }

            AnagraficaProtocollo.query({}, function(result) {
                vm.proponenti = result;
            });

            Direzione.query({}, function(result) {
                vm.direzione = result;
            });

            Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);
            function onSuccessLeg(data) {
                vm.legislature = data;
            }
            function onErrorLeg(error) {
                console.log("Failure!", error);
                toastr.error(error.data.message);
            }
        }

        function legislaturaChanged(){
            loadCommissioniAndSoggettiEsterni();
        }

        function loadCommissioniAndSoggettiEsterni(){
            Commissione.query({legislature: vm.searchParams.legislatura}, function(result) {
                vm.commissioni = result;
            });

            SoggettoEsterno.query({legislature: vm.searchParams.legislatura}, function(result) {
                vm.soggettiEsterni = result;
            });
        }

        function clearSearch() {
            vm.searchParams = {
                // Criteri entita Atto
                dataPresentazioneInizio: null,
                dataPresentazioneFine: null,
                legislatura: null,
                tipoProponenteList: [],
                proponenti: [],
                proponentiExclusionType: 'ALL_INCLUDED',
                numeroAtto: null,
                titoloAtto: null,
                statoAttoList: [],
                direzioneGRId: null,
                dataGR: null,
                tipoAttoList: [],
                statiCambioStato: [],
                dataCambioStatoInizio: null,
                dataCambioStatoFine: null,
                // Criteri entita Sezione
                parereReferente: [],
                parereSecondario: [],
                parereDiMerito: [],
                parereObbligatorio: [],
                osservazioni: [],
                parereIstituzionale: null,
                primiFirmatari: [],
                primiFirmatariExclusionType: 'ALL_INCLUDED',
                attiCollegati: [],
                attiCollegatiExclusionType: 'ALL_INCLUDED',
                testoSostitutivoPresentato: null,
                testoSostitutivoInizio: null,
                testoSostitutivoFine: null,
                dataBurtInizio: null,
                dataBurtFine: null,
                dataTrattazioneInizio: null,
                dataTrattazioneFine: null,
                ricorsoCostituzionale: null,
                impegnoCaricoGiunta: null,
                dataInvioRichiestaInizio: null,
                dataInvioRichiestaFine: null,
                dataRicezioneInizio: null,
                dataRicezioneFine: null,
                dataSollecitoInizio: null,
                dataSollecitoFine: null,
                attiGiacentiOrLicenziatiInCommissione: null,
                commissioneReport: null,
                dataEsitoCommissioneInizio: null,
                dataEsitoCommissioneFine: null,
                // Parametri custom per il report finale
                titoloReport: null,
                tipologiaReport: 'DEFAULT',
                showReportCriteria: null
            };
            vm.attachedActsReadOnlyListModel = [];
        }

        vm.search = function() {      
            var di = $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'app/entities/atto-report-generator/confirm-report-modal/confirm-report-modal.html',
                controller: ['$scope', '$mdDialog', 'searchParams', 'TIPOLOGIA_REPORT', function ($scope, $mdDialog, searchParams, TIPOLOGIA_REPORT) {
                        $scope.searchParams = searchParams;
                        $scope.TIPOLOGIA_REPORT = TIPOLOGIA_REPORT;
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };

                        $scope.confirm = function () {
                            $mdDialog.hide(true);
                        };
                    }],
                locals: {
                    searchParams: vm.searchParams
                }
            });
            di.then(
                function(result) {
                    // Dialog confirmed
                    vm.Atto.getPDFReport(vm.searchParams)
                        .then(
                            function(result) {
                                FileSaver.saveAs(new Blob([result.data], {}), "report.pdf");
                            }, 
                            function(error) {
                                var errorCode = error.headers('X-gestioneAttiApp-error');
                                var errorText = '';
                                if(errorCode === 'error.noContent') {
                                    errorText = 'La ricerca effettuata non ha trovato nessun atto come risultato, quindi non e\' stato possibile generare nessun report!';
                                } else if(errorCode === 'error.forbiddenOp') {
                                    errorText = 'La tua utenza non e\' abilitata alla generazione di report. Si prega di contattare l\'amministratore!'
                                } else if(errorCode === 'error.requiredParam') {
                                    errorText = 'Parametri mancanti per effettuare il report commissioni. Si prega di ricontrollare i dati inseriti!'
                                } else {
                                    errorText = 'Errore inaspettato. Si prega di riprovare o contattare l\'amministratore!'
                                }

                                toastr.error(errorText, "Errore!", {
                                    timeOut: 60000,
                                    extendedTimeOut: 0
                                });
                            });
                },
                function(cancel) {
                    // Dialog cancelled
                }
            );

        }

        vm.searchWithCommissionCheck = function() {
            // Controllo in caso di report commissioni con parametri obbligatori mancanti
            if(missingParameterCommissionReport(this.searchParams)){
                $('html, body').animate({scrollTop: 0}, 'medium');
                return toastr.error('Parametri "Legislatura" e "Commissione" necessari per il report commissioni. Si prega di ricontrollare i dati inseriti!');
            }

            // In caso di report generico richiama la search() standard
            if(!commissionReportWithOtherParams(this.searchParams)) {
                return vm.search();
            }

            // Se è stato selezionato il report commissioni con altri parametri mostra un dialog di conferma
            var confirmCommissionOtherParam = $mdDialog.confirm()
                  .title('Effettuare il Report Commissioni con parametri generici?')
                  .htmlContent("<p>Selezionando i parametri del report generalizzato, oltre a \"Legislatura\" e \"Commissione\", \
                  <br/> il Report degli atti giacenti/licenziati verra\' filtrato con quei parametri.</p> \
                  <p>Proseguire nella generazione del Report Commissioni?</p>")
                  .ariaLabel('')
                  .targetEvent()
                  .ok('Procedi')
                  .cancel('Annulla');
        
            $mdDialog.show(confirmCommissionOtherParam).then(function() {
                vm.search();
            }, function() {
              // Dialog cancelled
            });
          };


        function commissionReportWithOtherParams(searchParams){
            if( searchParams.attiGiacentiOrLicenziatiInCommissione != null ){

                // Esclusione dei parametri necessari al report commissioni
                var commissionReportKeys = ["legislatura", "commissioneReport", "attiGiacentiOrLicenziatiInCommissione"];
                // Esclusione dei parametri generici del report o di parametri dipendenti da altri parametri
                var exclusionKeys = ["proponentiExclusionType", "primiFirmatariExclusionType", "attiCollegatiExclusionType", "titoloReport", "tipologiaReport", "showReportCriteria"];
                
                for ( var key in searchParams) {
                    if (Object.prototype.hasOwnProperty.call(searchParams, key)) {
                        // Controllo soltanto i parametri non presenti nelle liste precedentemente definite
                        if(commissionReportKeys.indexOf(key) == -1 && exclusionKeys.indexOf(key) == -1){
                            var value = searchParams[key];
                            if(Array.isArray(value)){
                                if(value != null && value.length != 0) {
                                    return true;
                                }
                            } else {
                                if(value != null) {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
            return false;
        }

        function missingParameterCommissionReport(searchParams){
            if( searchParams.attiGiacentiOrLicenziatiInCommissione != null ){
                return searchParams.legislatura == null || searchParams.commissioneReport == null;
            }
            return false;
        }

        vm.addPersonToList = function (chip) {
            // Otherwise, create a new one
            if (angular.isObject(chip)) {
                return chip;
            }
            return {descrizione: chip};

        };

        vm.searchProponenti = function (searchText) {
            //console.log("SEARCH PROPONENTI- tutti i sistemi di protocollo e tutti i tipoAnagrafica");

            if(searchText.length < 3) {
                return [];
            }

            return AnagraficaProtocollo.search(
                { 
                    term: searchText,
                    protocolSystem: 'ALL',
                    tipoAnagrafica: '',
                    page: 0,
                    size: 20
                }).$promise.then(onSuccessAnag, onErrorAnag);

            //return searchText ? vm.proponenti.filter(createFilterForProponenti(searchText)) : [];
        };

        function onSuccessAnag(data, headers) {
            vm.proponenti = data;
            return data;
        }

        function onErrorAnag(error) {
            console.log("Errore nel recupero anagrafiche!", error);
        }


        function createFilterForProponenti(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(firmatario) {
                var codice = firmatario.codice.toLowerCase();
                var descrizione = firmatario.descrizione.toLowerCase();
                return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
            };
        }

        vm.tipoProponenteChange = function() {
            vm.isTipoGRselected = vm.searchParams.tipoProponenteList.includes('GR');
        }

        vm.toggleCheck = function (fieldName, value, dependentField) {
            var idx = vm.searchParams[fieldName].indexOf(value);
            if (idx > -1) {
                vm.searchParams[fieldName].splice(vm.searchParams[fieldName].indexOf(value), 1);
            } else {
                if (dependentField && vm.searchParams[dependentField] && vm.searchParams[dependentField].indexOf(value) > -1) {
                    vm.searchParams[dependentField].splice(vm.searchParams[dependentField].indexOf(value), 1);
                }
                vm.searchParams[fieldName].push(value);
            }
        };

        vm.searchParamExists = function(fieldName, value) {
            return vm.searchParams && vm.searchParams[fieldName] && vm.searchParams[fieldName].indexOf(value) > -1;
        };


        // ATTACHED ACTS
        vm.acts = [];
        vm.basicSearchType = null;
        vm.attachedActsModel = [];
        vm.attachedActsReadOnlyListModel = [];
        vm.numeroAttoSearchText = '';

        vm.onAddAttachedAct = function onAddAttachedAct($index, $chip) {
            if (isValidChip($chip)) {
                vm.searchParams.attiCollegati.push($chip.id);
                vm.attachedActsReadOnlyListModel.push($chip);
            }
            vm.attachedActsModel = [];
        }
        function isValidChip(chip) {
            return chip && chip.id && chip.numeroAtto && chip.titolo && chip.tipoAtto;
        }

        vm.onRemoveAttachedAct = function onRemoveAttachedAct($index, $chip) {
            for (var i in vm.searchParams.attiCollegati) {
                if ($chip.id === vm.searchParams.attiCollegati[i]) {
                    vm.searchParams.attiCollegati.splice(i, 1);
                    break;
                }
            }
        }

        vm.getAllActs = function () {
            vm.acts = [];
            if (!vm.basicSearchType) {
                return;
            }
            Atto.queryNonPaged({
                type: vm.basicSearchType
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.acts = data;
            };
            function onError(error) {
                console.log(error);
            }
        }

        vm.transformChip = function transformChip($chip) {
            //Qui scegliere cosa tenere dentro la chip!
            return { "id": $chip.id, "numeroAtto": $chip.numeroAtto, "titolo": $chip.titolo, "tipoAtto": $chip.tipoAtto };
        }

        vm.searchActs = function searchActs(tokenNumeroAtto) {
            var results = vm.acts;
            return tokenNumeroAtto ? results.filter(createFilterForAttiCollegati(tokenNumeroAtto)) : [];
        }

        function createFilterForAttiCollegati(tokenNumeroAtto) {
            return function filterFn(atto) {
                var numeroAtto = atto.numeroAtto;
                return (numeroAtto.includes(tokenNumeroAtto) && !alreadySelected(atto.id));
            };
        }
        function alreadySelected(idAtto) {
            for (var i in vm.searchParams.attiCollegati) {
                if (idAtto === vm.searchParams.attiCollegati[i]) {
                    return true;
                }
            }
            return false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('adempimenti-atti-indirizzo-report-generator', {
                    parent: 'app',
                    url: '/adempimenti-atti-indirizzo-report-generator',
                    data: {
                        pageTitle: 'atto-report-generator.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto-report-generator/adempimenti-atti-indirizzo-report-generator.html',
                            controller: 'AdempimentiAttiIndirizzoReportGeneratorController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('commissione');
                                $translatePartialLoader.addPart('materia');
                                return $translate.refresh();
                            }]
                    }
                })
            }
})();
(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller(
            'AdempimentiAttiIndirizzoReportGeneratorController', 
            AdempimentiAttiIndirizzoReportGeneratorController
        );

    AdempimentiAttiIndirizzoReportGeneratorController.$inject = [
        "$scope",
        "$state",
        "toastr",
        "ACT_TYPES",
        "SEARCH_STATES",
        'TIPOLOGIA_ORDINAMENTO_REPORT',
        "Commissione",
        "Atto",
        "FileSaver",
        "$mdDialog",
        "Principal",
        "$translate",
        "MacroMateria"
    ];

    function AdempimentiAttiIndirizzoReportGeneratorController(
        $scope,
        $state,
        toastr,
        ACT_TYPES,
        SEARCH_STATES,
        TIPOLOGIA_ORDINAMENTO_REPORT,
        Commissione,
        Atto,
        FileSaver,
        $mdDialog,
        Principal,
        $translate,
        MacroMateria
    ) {
        var vm = this;
        vm.loading = false;
        vm.searchParams = {};
        vm.clearSearch = clearSearch;
        vm.fulfillmentReportVisible = Principal.hasAnyAuthority(['ROLE_ADMIN']);
        loadAll();

        function loadAll() {
            vm.clearSearch();
            vm.queryStates = SEARCH_STATES;
            vm.actTypes = ACT_TYPES;
            vm.approvalSites = ["AULA", "COMMISSIONE"];
            vm.fulfillmentDelegates = ["GIUNTA", "CONSIGLIO", "ALTRO"];
            vm.fulfillmentRecipients = ["CONSIGLIO", "COMMISSIONE", "ALTRO"];
            vm.Atto = Atto;
            vm.proponenti = [];
            vm.macroMaterie = [];

            Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);
            function onSuccessLeg(data) {
                vm.legislature = data;
                Atto.defaultLegislatura({}, onSuccessDefLeg, onErrorDefLeg);
                function onSuccessDefLeg(data) {
                    vm.searchParams.legislatura = data.legislatura;
                    vm.fulfillmentReportVisible = vm.fulfillmentReportVisible || Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], data.legislatura);
                    vm.loadCommissioni();
                }
                function onErrorDefLeg(error) {
                    console.log('Error loading legislatura default', error);
                }
            }
            function onErrorLeg(error) {
                console.log("Failure!", error);
                toastr.error(error.data.message);
            }

            MacroMateria.query({}, 
                function (data){
                    vm.macroMaterie = data;
                },
                function (error) {
                    console.log("Failure!", error);
                    toastr.error(error.data.message);
                });
        }

        vm.loadCommissioni = function() {
            Commissione.query({legislature: vm.searchParams.legislatura}, function(result) {
                vm.commissioni = result;
            });
        };

        vm.changedReportType = function(tipoReport) {
            if (vm.searchParams.tipoReportAttiIndirizzo === tipoReport) {
                return;
            } else {
                vm.searchParams.tipoReportAttiIndirizzo = tipoReport;
            }
        };
        
        function clearSearch() {
            vm.searchParams = {
                // Criteri entita Atto
                legislatura: null,
                tipoReportAttiIndirizzo: "adempimenti",

                // Criteri entita Sezione
                dataApprovazioneInizio: null,
                dataApprovazioneFine: null,
                sedeApprovazione: [],
                commissioneApprovazione: [],
                macroMateria: null,
                incaricatoAdempimento: [],
                destinatarioAdempimento: [],
                commissioneDestinataria: [],
                flagAdempimentoEffettuato: null,
                // Parametri custom per il report finale
                titoloReport: null,
                
                tipologiaOrdinamento: TIPOLOGIA_ORDINAMENTO_REPORT[0],
                showReportCriteria: true
            };
            $scope.$broadcast("cleanMacroMateriaChip");
            $('html, body').animate({scrollTop: 0}, 'medium');
        }

        vm.toggleCheck = function(fieldName, value) {
            var idx = vm.searchParams[fieldName].indexOf(value);
            if (idx > -1) {
                vm.searchParams[fieldName].splice(vm.searchParams[fieldName].indexOf(value), 1);
            } else {
                vm.searchParams[fieldName].push(value);
            }

        };
    
        vm.searchParamExists = function(fieldName, value){
            return vm.searchParams && vm.searchParams[fieldName] && vm.searchParams[fieldName].indexOf(value) > -1;
        };
    
        vm.searchValidation = function() {
            // Controllo in caso di report commissioni con parametri obbligatori mancanti
            if(missingParameterForReport(vm.searchParams)){
                $('html, body').animate({scrollTop: 0}, 'medium');
                return  toastr.error($translate.instant('report-generator.errors.required-fields'), 'Errore!');
            }

            var di = $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'app/entities/atto-report-generator/confirm-report-modal/confirm-report-modal.html',
                controller: ['$scope', '$mdDialog', 'searchParams', 'TIPOLOGIA_ORDINAMENTO_REPORT', function ($scope, $mdDialog, searchParams, TIPOLOGIA_ORDINAMENTO_REPORT) {
                    if(searchParams.tipoReportAttiIndirizzo ) {
                        $scope.TIPOLOGIA_ORDINAMENTO_REPORT = searchParams.tipoReportAttiIndirizzo === 'adempimenti' ? TIPOLOGIA_ORDINAMENTO_REPORT : [TIPOLOGIA_ORDINAMENTO_REPORT[1], TIPOLOGIA_ORDINAMENTO_REPORT[2]];   
                        searchParams.tipologiaOrdinamento = $scope.TIPOLOGIA_ORDINAMENTO_REPORT[0];
                    }
                    $scope.searchParams = searchParams;
                    $scope.showOrdinamento = true;
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.confirm = function () {
                        $mdDialog.hide(true);
                    };
                }],
                locals: {
                    searchParams: vm.searchParams
                }
            });
            di.then(
                function(result) {
                    // Dialog confirmed
                    vm.Atto.getPDFReportAddressesActs(vm.searchParams)        
                        .then(
                            function(result) {
                                FileSaver.saveAs(new Blob([result.data], {}), "report.pdf");
                            }, 
                            function(error) {
                                var errorCode = error.headers('X-gestioneAttiApp-error');
                                var errorText = '';
                                if(errorCode === 'error.noContent') {
                                    errorText = 'La ricerca effettuata non ha trovato nessun atto come risultato, quindi non e\' stato possibile generare nessun report!';
                                } else if(errorCode === 'error.forbiddenOp') {
                                    errorText = 'La tua utenza non e\' abilitata alla generazione di report. Si prega di contattare l\'amministratore!';
                                } else if(errorCode === 'error.requiredParam') {
                                    errorText = 'Parametri mancanti per effettuare il report commissioni. Si prega di ricontrollare i dati inseriti!';
                                } else {
                                    errorText = 'Errore inaspettato. Si prega di riprovare o contattare l\'amministratore!';
                                }

                                toastr.error(errorText, "Errore!", {
                                    timeOut: 60000,
                                    extendedTimeOut: 0
                                });
                            });
                },
                function(cancel) {
                    // Dialog cancelled
                }
            );
        };

        function missingParameterForReport(searchParams){
            if( searchParams.legislatura === null ){
                return true;
            } else if((searchParams.dataApprovazioneInizio !== null && searchParams.dataApprovazioneFine === null)
                || (searchParams.dataApprovazioneFine !== null && searchParams.dataApprovazioneInizio === null)) {
                return true;
            }
            return false;
        }
    }

}());


(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Sezione', Sezione);

    Sezione.$inject = ['$resource'];

    function Sezione($resource) {
        
        var resourceUrl = 'api/:public/sezioni/:allNames'; // Modifica l'endpoint se necessario
        
        var resource = $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET',
                params: {
                    public: 'public',
                    allNames: 'all-names'
                },
                isArray: true 
            }
        });

        return resource;
    }
})();

(function () {
    'use strict';

    var candidatureDesignazioniComponent = {

        templateUrl: 'app/entities/atto/sezioni/candidatureDesignazioni.html',
        bindings: {
            'candidatureDesignazioni' : '=',
            'atto' : '=',
            'changeDocumentType' : '=',
            'changeDocumentVisibility' : '=',
            'changeDocumentFrontpiece': '=',
            'docTypes' : '=',
            'publicView' : '=',
            'utente' : '='
        },
        controller: ['Atto', 'ACT_TYPES', 'toastr', 'Principal', 'Documento', function (Atto, ACT_TYPES, toastr, Principal, Documento) {
            var vm = this;
            vm.candidatureDesignazioniList = [];
            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
            vm.isSettoreAtti = Principal.hasAnyAuthority(['ROLE_SETTORE']);
            vm.isProtocollo = Principal.hasAnyAuthority(['ROLE_PROTOCOLLO']);

            vm.documentiEmendamento = Documento.getDocumentiBySezioneId({sezioneId: vm.candidatureDesignazioni.id}, onDocumentSuccess, onDocumentFail);
            
            function onDocumentSuccess(data){                
                data.forEach(function(document){
                    if(!document.candidatureDesignazioni) {
                        document.candidatureDesignazioni = [];
                    }
                    vm.candidatureDesignazioniList = vm.candidatureDesignazioniList.concat(document.candidatureDesignazioni);
                    document.mittentiProtocollo.forEach(function (mittenteProtocollo) {
                        if(!isMittentePresentInCandidatureDesignazioni(mittenteProtocollo, document)) {
                            var newCandidatura = {anagraficaProtocollo: mittenteProtocollo, nuovaDescrizioneCandidato: mittenteProtocollo.descrizione, documentId: document.id};
                            Documento.addOrUpdateDocumentCandidaturaDesignazione({documentId: document.id}, newCandidatura, 
                                function (result) {
                                    vm.candidatureDesignazioniList.push(newCandidatura);
                                },
                                function(error) {
                                    console.log(error);
                                })
                        }
                    });
                });
            }
            
            function isMittentePresentInCandidatureDesignazioni(mittenteProtocollo, document) {
                if(!document.candidatureDesignazioni || document.candidatureDesignazioni.length === 0) {
                    return false;
                }
                var index = document.candidatureDesignazioni.findIndex(function (candidatura) {return candidatura.anagraficaProtocollo.id === mittenteProtocollo.id});
                return index < 0 ? false : true;
            }

            vm.updateCandidatoDesignazioneDescription = function(candidatura) {
                if(!candidatura.nuovaDescrizioneCandidato || candidatura.nuovaDescrizioneCandidato === '') {
                    toastr.error('Impossibile salvare candidatura o designazione vuota!');
                } else {
                    Documento.addOrUpdateDocumentCandidaturaDesignazione({documentId: candidatura.documentId}, candidatura, 
                        function (result) {
                            toastr.success('Candidatura o Designazione salvata con successo!');
                        },
                        function(error) {
                            toastr.error('Errore duranta salvataggio della candidatura o designazione:' + error);
                        })
                }
            }

            function onDocumentFail(error) {
                console.log("Error retriving candidature e designazioni documents: " + error.message);
            }
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('candidatureDesignazioniComponent', candidatureDesignazioniComponent);
})();

(function () {
    'use strict';

    var attachedActsComponent = {

        templateUrl: 'app/entities/atto/sezioni/attachedActs.html',
        bindings: {
            'attachedActs' : '=',
            'atto' : '=',
            'changeDocumentType' : '=',
            'changeDocumentVisibility' : '=',
            'changeDocumentFrontpiece': '=',
            'docTypes' : '=',
            'publicView' : '=',
            'utente' : '=',
            'headingPanelDisabled' : '=',
            'footerPanelDisabled' : '='
        },
        controller: ['Atto', 'ACT_TYPES', 'toastr', 'Principal', function (Atto, ACT_TYPES, toastr, Principal) {
            var vm = this;
            //ATTACHED ACTS
            if (vm.attachedActs) {
                vm.attachedActs.metadati.unifiedTexts = vm.attachedActs.metadati.unifiedTexts || [];
                vm.attachedActs.metadati.hasUnifiedTexts = vm.attachedActs.metadati.hasUnifiedTexts || false;

                vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
                vm.isSettoreAtti = Principal.hasAnyAuthority(['ROLE_SETTORE']);
                vm.isProtocollo = Principal.hasAnyAuthority(['ROLE_PROTOCOLLO']);
                vm.numeroAttoSearchText = '';
                vm.searchActs = searchActs;
                vm.attachedActsModel = [];
                vm.attachedActsReadOnlyListModel = [];
                resolveAttachedActs();
                vm.onAddAttachedAct = onAddAttachedAct;
                vm.onRemoveAttachedAct = onRemoveAttachedAct;
                vm.transformChip = transformChip;

                vm.acts = [];
                vm.basicSearchType = null;
                vm.actsTypeSelection = [];

                ACT_TYPES.forEach(function (actType) {
                    vm.actsTypeSelection.push(actType);
                });

                if (vm.atto.tipoAtto === 'ODG') {
                    removeTipoAtto(vm.actsTypeSelection, 'ODG');
                } else if (vm.atto.tipoAtto === 'PDRIS') {
                    removeTipoAtto(vm.actsTypeSelection, 'PDRIS');
                } else if(vm.atto.tipoAtto === 'CDG') {
                    vm.actsTypeSelection = []
                    vm.actsTypeSelection.push(getTipoAtto('PDRIS'));
                    vm.actsTypeSelection.push(getTipoAtto('ODG'));
                    vm.actsTypeSelection.push(getTipoAtto('MOZIONE'));
                    vm.actsTypeSelection.push(getTipoAtto('IO'));
                    vm.actsTypeSelection.push(getTipoAtto('IS'));
                }
                else if(vm.atto.tipoAtto === 'IEA'){
                    vm.actsTypeSelection = []
                    vm.actsTypeSelection.push(getTipoAtto('MOZIONE'));
                    vm.actsTypeSelection.push(getTipoAtto('ODG'));
                    vm.actsTypeSelection.push(getTipoAtto('PDRIS'));
                }
                else if(vm.atto.tipoAtto === 'REL'){
                    vm.actsTypeSelection = []
                    vm.actsTypeSelection.push(getTipoAtto('PDRIS'));
                }
            }

            function removeTipoAtto(listaTipi, tipoAtto) {
                for (var i = 0; i < listaTipi.length; i++) {
                    if (listaTipi[i].value === tipoAtto) {
                        listaTipi.splice(i, 1);
                        break;
                    }
                }
            }

            function getTipoAtto(tipoAtto) {
                for(var i = 0; i < ACT_TYPES.length; i++){
                    if(ACT_TYPES[i].value === tipoAtto) {
                        return ACT_TYPES[i];
                    }
                }
            }

            function transformChip($chip) {
                //Qui scegliere cosa tenere dentro la chip!
                return { "id": $chip.id, "legislatura": $chip.legislatura, "numeroAtto": $chip.numeroAtto, "titolo": $chip.titolo, "tipoAtto": $chip.tipoAtto, "statoAtto": $chip.statoCorrente.statoAtto.name };
            }

            function searchActs(tokenNumeroAtto) {
                var results = vm.acts;
                return tokenNumeroAtto ? results.filter(createFilterFor(tokenNumeroAtto)) : [];
            }

            function createFilterFor(tokenNumeroAtto) {
                return function filterFn(atto) {
                    var numeroAtto = atto.numeroAtto;
                    return (numeroAtto.includes(tokenNumeroAtto) && !alreadySelected(atto.id));
                };
            }
            function alreadySelected(idAtto) {
                for (var i in vm.attachedActs.metadati.unifiedTexts) {
                    if (idAtto === vm.attachedActs.metadati.unifiedTexts[i].id) {
                        return true;
                    }
                }
                return false;
            }

            function onAddAttachedAct($index, $chip) {
                if (isValidChip($chip)) {
                    vm.attachedActs.metadati.unifiedTexts.push({ id: $chip.id });
                    vm.attachedActsReadOnlyListModel.push($chip);
                    sortAttachedActs();
                }
                vm.attachedActsModel = [];
            }
            function isValidChip(chip) {
                return chip && chip.id && chip.legislatura && chip.numeroAtto && chip.titolo && chip.tipoAtto;
            }

            function onRemoveAttachedAct($index, $chip) {
                for (var i in vm.attachedActs.metadati.unifiedTexts) {
                    if ($chip.id === vm.attachedActs.metadati.unifiedTexts[i].id) {
                        vm.attachedActs.metadati.unifiedTexts.splice(i, 1);
                        break;
                    }
                }
            }

            vm.getAllActs = function () {
                vm.acts = [];
                if (!vm.basicSearchType) {
                    return;
                }
                Atto.queryNonPaged({
                    type: vm.basicSearchType
                }, onSuccess, onError);
                function onSuccess(data) {
                    vm.acts = data;
                };
                function onError(error) {
                    console.log(error);
                }
            }


            function resolveAttachedActs() {
                if (!vm.attachedActs.metadati.unifiedTexts)
                    return [];

                for (var i in vm.attachedActs.metadati.unifiedTexts) {
                    Atto.get({
                        id: vm.attachedActs.metadati.unifiedTexts[i].id
                    }, onRetrieveSuccess, onError)
                }
                function onRetrieveSuccess(data, headers) {
                    vm.attachedActsReadOnlyListModel.push({ id: data.id, legislatura: data.legislatura, numeroAtto: data.numeroAtto, titolo: data.titolo, tipoAtto: data.tipoAtto, statoAtto: data.statoCorrente.statoAtto.name });
                    sortAttachedActs();
                }
                function onError(error) {
                    console.log(error);
                }
            }

            function sortAttachedActs(){
                vm.attachedActsReadOnlyListModel.sort(function(a,b){
                    if(a.legislatura !== b.legislatura) {
                        if( a.legislatura > b.legislatura ) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                    if(a.tipoAtto !== b.tipoAtto) {
                        if ( a.tipoAtto > b.tipoAtto ) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                    if(a.numeroAtto !== b.numeroAtto) {
                        if ( a.numeroAtto > b.numeroAtto) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                    return 0;
                })
            }
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('attachedActsComponent', attachedActsComponent);
})();

(function(){

    angular.module('gestioneAttiApp').factory('ValidatorFactory', ['BasicValidator', 'PdlValidator', 'PddValidator', 'PdlpValidator', 'MinorBasicValidator','OdgValidator','MozioneValidator', 'PeaValidator', 'IoValidator','IeaValidator', 'RelValidator', 'PdrisValidator', 'RintValidator', 'PdlsValidator',
        function(BasicValidator, PdlValidator, PddValidator, PdlpValidator, MinorBasicValidator, OdgValidator, MozioneValidator, PeaValidator, IoValidator, IeaValidator, RelValidator, PdrisValidator, RintValidator, PdlsValidator) {

            var validators = {
                'PDL': PdlValidator,
                'PDD': PddValidator,
                'PLIP': PdlValidator,
                'PDLP': PdlpValidator,
                'PDLS': PdlsValidator,
                'BASIC': BasicValidator,
                'ODG': OdgValidator,
                'PDR': MinorBasicValidator,
                'MOZIONE': MozioneValidator,
                'PEA': PeaValidator,
                'IO': IoValidator,
                'IS': IoValidator,
                'CDG': IoValidator,
                'PEL': PeaValidator,
                'IEA': IeaValidator,
                'DEA': IoValidator,
                'REL': RelValidator,
                'PDRIS': PdrisValidator,
                'RINT': RintValidator
            };

            return {
                getValidator : function(param) {
                    if (validators[param])
                        return validators[param];
                    return BasicValidator;
                }
            };
        }
    ]);

})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('RintValidator', ['BasicValidator', '$location','$anchorScroll', 'PdlService', function (BasicValidator, $location, $anchorScroll, PdlService) {

        this.validatePresentation = BasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            if (userRolesMap.isAdmin) {

                var result = validateSectorSections(invalidFields, idPrimaCommissione);

                if (result.valid) {
                    if (!BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                        result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission);
                    }
                    if (result.valid) {
                        result = BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    }
                }
                return result;
            } else {
                switch (state) {
                    case "PRESENTATO":
                        return validateSectorSections(invalidFields, idPrimaCommissione);
                    case "COMMISSIONE":
                        return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission);
                    case "AULA":
                        return BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    case "APPROVATO":
                        return {valid: true};
                    default:
                        console.error("STATO SCONOSCIUTO: " + state);
                        return {valid: false, message: "STATO SCONOSCIUTO: " + state, invalidFields: invalidFields};
                }
            }
        };

        function validateSectorSections(invalidFields, idPrimaCommissione) {
            var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);

            var openListTagMessage = result.message.slice(0, -5);
            result.message = openListTagMessage;

            result = validateAssignmentLetter(result.invalidFields, idPrimaCommissione, result.valid, result.message);

            return result;
        }

        function validateAssignmentLetter(invalidFields, idPrimaCommissione, valid, message) {
          var metadata = BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

          var message = '<ul>';

          if (typeof (metadata.aulaDiretta) === 'undefined' || metadata.aulaDiretta === null) {
              message += '<li><i>Direttamente in Aula</i> è un campo obbligatorio</li>';
              invalidFields.push('aulaDiretta');
          } else if (metadata.aulaDiretta) {
/*                     if (!metadata.dataSedutaUp) {
                  message += '<li><i>Data Seduta UP</i> è un campo obbligatorio</li>';
                  invalidFields.push('dataSedutaUp');
              } */
          } else {
              if (!metadata.dataAssegnazione) {
                  message += '<li><i>Data assegnazione</i> è un campo obbligatorio</li>';
                  invalidFields.push('dataAssegnazione');
              }
              if (!metadata.parereReferente || !metadata.parereReferente.length) {
                  message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                  invalidFields.push('parereReferente');
              } else if (metadata.parereReferente.indexOf(idPrimaCommissione) > -1 && metadata.parereIstituzionale) {
                  message += '<li><i>Parere Istituzionale</i> non può essere impostato a Sì se la Prima Commissione è stata selezionata in Parere Referente</li>';
                  invalidFields.push('parereIstituzionale');
              }
          }

          message += '</ul>';

          var valid = invalidFields.length === 0;
          if (!valid) {
              $location.hash('assignmentLetter');
              $anchorScroll();
              PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
          }

          return {valid: valid, message: message, invalidFields: invalidFields};
        }

        function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission) {
            var result = null;
            for (var i = 0; i <= numeroRinvio; i++) {
                result = BasicValidator.validateLegitimacy(invalidFields, userRolesMap, i);
                if (result.valid) {
                    result = BasicValidator.validateCommissionEmendments(invalidFields, i, primaryCommission);
                    if (result.valid) {
                        //result = BasicValidator.validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione);
                        if (result.valid) {
                            result = BasicValidator.validateFinancialCoverage(invalidFields, i, primaryCommission);
                            if (result.valid) {
                                result = BasicValidator.validateCommissionMessage(invalidFields, i, primaryCommission);
                            } else {
                                break;
                            }
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                } else {
                    break;
                }
            }
            return result;
        }
    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('RelValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;
            this.validateAssignmentLetter = validateAssignmentLetter;

            // Commissione

            // Aula
            this.validateEsitoRispostaScritta = validateEsitoRispostaScritta;
            this.validateSectorSections = validateSectorSections;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    var result = validateSectorSections(invalidFields, idPrimaCommissione);
                    if (result.valid) {
                        if (PdlService.sezioniMap.ASSIGNMENT_LETTER && !PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                            result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        }
                        if (result.valid) {
                            result = validateCourtroomSections(invalidFields, numeroRinvio);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                        case "PRESENTATO":
                            return validateSectorSections(invalidFields, idPrimaCommissione);
                        case "COMMISSIONE":
                            return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        case "AULA":
                            return validateCourtroomSections(invalidFields, numeroRinvio);
                        case "APPROVATO":
                            return validatePostCourtroomSections(invalidFields, numeroRinvio);
                        default:
                            console.error("STATO SCONOSCIUTO: " + state);
                            return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
                //CASO Interrogazione scritta
                if(!PdlService.sezioniMap.ASSIGNMENT_LETTER) {
                    return {valid: true};
                }
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';

                if (typeof (metadata.aulaDiretta) === 'undefined' || metadata.aulaDiretta === null) {
                    message += '<li><i>Direttamente in Aula</i> è un campo obbligatorio</li>';
                    invalidFields.push('aulaDiretta');
                } else if (metadata.aulaDiretta) {
/*                     if (!metadata.dataSedutaUp) {
                        message += '<li><i>Data Seduta UP</i> è un campo obbligatorio</li>';
                        invalidFields.push('dataSedutaUp');
                    } */
                } else {
                    if (!metadata.dataAssegnazione || metadata.dataAssegnazione === "") {
                        message += '<li><i>Data assegnazione</i> è un campo obbligatorio</li>';
                        invalidFields.push('dateAssegnazione');
                    }
                    if (!metadata.parereReferente || !metadata.parereReferente.length) {
                        message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                        invalidFields.push('parereReferente');
                    } else if (metadata.parereReferente.indexOf(idPrimaCommissione) > -1 && metadata.parereIstituzionale) {
                        message += '<li><i>Parere Istituzionale</i> non può essere impostato a Sì se la Prima Commissione è stata selezionata in Parere Referente</li>';
                        invalidFields.push('parereIstituzionale');
                    }

                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateSectorSections(invalidFields, idPrimaCommissione) {
                var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
                return result;
            }

            function validateEsitoRispostaScritta(invalidFields) {
                var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', 0);
                if(!invalidFields) {
                    invalidFields = [];
                }
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (!metadata.rispostaScrittaIn3Giorni && !metadata.rispostaScrittaIn15Giorni && !metadata.rispostaScrittaConsegnata) {
                    message += '<li><i>Esisto:</i> inserire almeno una risposta scritta nell\'esito!</li>';
                    invalidFields.push('rispostaScritta');
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome');
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                return {valid: true, invalidFields: invalidFields};
            }


            function validateCourtroomSections(invalidFields, numeroRinvio) {
                return {valid: true, invalidFields: invalidFields};
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;
            
                return {valid: true, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if(atto.tipoAtto === 'PLIP'){
                    if (!atto.proponentiText || atto.proponentiText.length === 0 || atto.proponentiText[0] === '') {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                } else {
                    if (!atto.tipoProponente) {
                        message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                        invalidFields.push('tipoProponente');
                    } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }
        }]);
})();

//(function validateCommissionSections () {
(function () {
    'use strict';

    angular.module('gestioneAttiApp').service('PeaValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;
            this.validateAssignmentLetter = validateAssignmentLetter;

            // Commissione

            // Stato Approvato
            this.validatePostCourtroomSections = validatePostCourtroomSections;
            this.validatePostCourtroom = validatePostCourtroom;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    var result = validateSectorSections(invalidFields, idPrimaCommissione);
                    if (result.valid) {
                        if (!PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                            // result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                            //         idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                        case "PRESENTATO":
                            return validateSectorSections(invalidFields, idPrimaCommissione);
                        case "COMMISSIONE":
                            return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        case "APPROVATO":
                            return {valid: true};/* validatePostCourtroomSections(invalidFields, numeroRinvio); */
                        default:
                            console.error("STATO SCONOSCIUTO: " + state);
                            return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';
                if (!metadata.dateAssegnazione || metadata.dateAssegnazione.length === 0 || metadata.dateAssegnazione[0] === "") {
                    message += '<li><i>Data assegnazione</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataAssegnazione');
                }
                if (!metadata.parereReferente || !metadata.parereReferente.length) {
                    message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                    invalidFields.push('parereReferente');
                }
                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateSectorSections(invalidFields, idPrimaCommissione) {
                var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
                return result;
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;

                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validatePostCourtroom(invalidFields, i);
                    if (!result.valid) {
                        break;
                    }
                }

                return result;
            }

            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                return {valid: true, invalidFields: invalidFields};
            }

            function validatePostCourtroom(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('POST_COURT', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                if (!metadata.numeroLeggeAC || metadata.numeroLeggeAC.trim().length === 0) {
                    message += '<li><i>Numero legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroLeggeAC' + suffix);
                }
                if (!metadata.dataLeggeAC) {
                    message += '<li><i>Data legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataLeggeAC' + suffix);
                }
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('postCourtroom' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if(atto.tipoAtto === 'PLIP'){
                    if (!atto.proponentiText || atto.proponentiText.length === 0 || atto.proponentiText[0] === '') {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                } else {
                    if (!atto.tipoProponente) {
                        message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                        invalidFields.push('tipoProponente');
                    } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

        }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('PdrisValidator', ['PdlService', 'MinorBasicValidator', '$location', '$anchorScroll',
        function (PdlService, MinorBasicValidator, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;

            // Aula
            this.validateCourtroomMeeting = validateCourtroomMeeting;
            this.validateSectorSections = validateSectorSections;
            this.validateCourtroomOutcome = validateCourtroomOutcome;

            // Stato Approvato
            this.validatePostCourtroomSections = validatePostCourtroomSections;
            this.validatePostCourtroom = validatePostCourtroom;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];
                switch (state) {
                    case "PRESENTATO":
                        return validateSectorSections(invalidFields);
                    case "COMMISSIONE":
                        return MinorBasicValidator.validateCommissionSections(invalidFields, utente, userRolesMap,
                            numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                    case "AULA":
                        // return validateCourtroomSections(invalidFields, numeroRinvio);
                        return MinorBasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    case "APPROVATO":
                        // return validatePostCourtroomSections(invalidFields, numeroRinvio);
                        return MinorBasicValidator.validatePostCourtroomSections(invalidFields, numeroRinvio);
                    default:
                        console.error("STATO SCONOSCIUTO: " + state);
                        return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                }
            };

            function validateSectorSections(invalidFields){
                return {valid: true, message: 'ok', invalidFields: invalidFields};                
            }

            function validateCourtroomSections(invalidFields, numeroRinvio) {
                var result;
                result = validateAssignmentLetter(invalidFields, 0);
                if(!result.valid) {
                    return result;
                }
                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validateCourtroomEmendments(invalidFields, i);
                    if (result.valid) {
                        result = validateCourtroomMeeting(invalidFields, i);
                        if (result.valid) {
                            result = validateCourtroomOutcome(invalidFields, i);
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                return result;
            }

            function validatePostCourtroom(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('POST_COURT', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                if (!metadata.numeroLeggeAC || metadata.numeroLeggeAC.trim().length === 0) {
                    message += '<li><i>Numero legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroLeggeAC' + suffix);
                }
                if (!metadata.dataLeggeAC) {
                    message += '<li><i>Data legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataLeggeAC' + suffix);
                }
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('postCourtroom' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }


            //nel caso della lettera di assegnazione i e' sempre 0!
            function validateAssignmentLetter(invalidFields, i) {
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';


                if (!metadata.parereReferente || !metadata.parereReferente.length) {
                    message += '<li><i>Assegnazione commissioni:</i> devi selezionare almeno una commissione </li>';
                    invalidFields.push('parereReferente');
                }           
                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;

                for (var i = 0; i <= numeroRinvio; i++) {
                    //result = validatePostCourtroom(invalidFields, i);
                    result = {valid: true};
                    if (result.valid) {
                        result = validateActuationNotes(invalidFields,i);
                        if(!result.valid){
                            break;
                        }
                    } else {
                        break;
                    }
                }

                return result;
            }

            //Da sapere quali campi sono obbligatori!
            function validateActuationNotes(invalidFields, i){
                return {valid: true, message: '', invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if (!atto.tipoProponente) {
                    message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoProponente');
                } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                    message += '<li>Devi specificare almeno un proponente</li>';
                    invalidFields.push('proponenti');
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomMeeting(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_MEETING', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (!metadata.sedute || !metadata.sedute[0]) {
                    message += '<li><i>Date sedute:</i> inserire almeno una data</li>';
                    invalidFields.push('sessionsDate' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomOutcome(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                //Non sono piu' obbligatori: richiesta del Caldini in data 27/5/2019
/*                 if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitoloAula' + suffix);
                } else */ 
                if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitoloAula' + suffix);
                }
/*                 if (typeof (metadata.coordinamentoTesto) === 'undefined' || metadata.coordinamentoTesto === null) {
                    message += '<li><i>Coordinamento formale testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('coordinamentoTesto' + suffix);
                } */

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }
        }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('PdlsValidator', ['BasicValidator', function (BasicValidator) {

        this.validatePresentation = BasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

                switch (state) {
                    case "PRESENTATO":
                        return BasicValidator.validateSectorSections(invalidFields, idPrimaCommissione);
                    case "COMMISSIONE":
                        return validateCommissionSections(invalidFields, utente, userRolesMap,
                                numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                    case "AULA":
                        return BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    case "APPROVATO":
                        return BasicValidator.validatePostCourtroomSections(invalidFields, numeroRinvio);
                    default:
                        console.error("STATO SCONOSCIUTO: " + state);
                        return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                }
        };

        function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
            var result = null;
            for (var i = 0; i <= numeroRinvio; i++) {
                result = BasicValidator.validateLegitimacy(invalidFields, userRolesMap, i);
                if (result.valid) {
                    result = BasicValidator.validateFeasibility(invalidFields, userRolesMap, i);
                    if (result.valid) {
                        result = BasicValidator.validateCommissionEmendments(invalidFields, i, primaryCommission);
                        if (result.valid) {
                            //result = BasicValidator.validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione, primaryCommission);
                            if (result.valid) {
                                //result = BasicValidator.validateFinancialCoverage(invalidFields, i, primaryCommission);
                                if (result.valid) {
                                    result = BasicValidator.validateCommissionMessage(invalidFields, i, primaryCommission);
                                    if (result.valid) {
                                        result = validateUnifiedText(invalidFields, i, primaryCommission);
                                    } else {
                                        break;
                                    }
                                } else {
                                    break;
                                }
                            } else {
                                break;
                            }
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                } else {
                    break;
                }
            }
            return result;
        }

        function validateUnifiedText(invalidFields, idx, primaryCommission) {
            var sezione = BasicValidator.PdlService.getSezioniFromMap('UNIFIED_TEXT', idx);

            if (!sezione || !primaryCommission) {
                return {valid: true, message: message, invalidFields: invalidFields};
            }

            var suffix = "";
            if (idx > 0) {
                suffix += "_" + idx;
            }

            var metadata = sezione.metadati;

            var message = '<ul>';

            if (typeof (metadata.hasUnifiedTexts) === 'undefined' || metadata.hasUnifiedTexts === null) {
                throw "Has unified text does not exist";
            } else if (metadata.hasUnifiedTexts === true && metadata.unifiedTexts.length === 0) {
                message += '<li><i>Specificare</i> almeno un testo unificato</li>';
                invalidFields.push('hasUnifiedTexts' + suffix);
            }

            message += '</ul>';

            var valid = invalidFields.length === 0;
            if (!valid) {
                BasicValidator.$location.hash('unifiedText' + suffix);
                BasicValidator.$anchorScroll();
                sezione.visible = true;
            }

            return {valid: valid, message: message, invalidFields: invalidFields};
        }

    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('PdlpValidator', ['BasicValidator', function (BasicValidator) {

        this.validatePresentation = BasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            switch (state) {
                case "PRESENTATO":
                    return BasicValidator.validateSectorSections(invalidFields, idPrimaCommissione);
                case "COMMISSIONE":
                    return BasicValidator.validateCommissionSections(invalidFields, utente, userRolesMap,
                        numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                case "AULA":
                    return BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                case "APPROVATO":
                    return validatePostCourtroomSections(invalidFields, numeroRinvio);
                default:
                    console.error("STATO SCONOSCIUTO: " + state);
                    return {valid: false, message: "STATO SCONOSCIUTO: " + state};
            }
            // }
        };

        function validatePostCourtroomSections(invalidFields, numeroRinvio) {
            var result;

            for (var i = 0; i <= numeroRinvio; i++) {
                result = validatePostCourtroom(invalidFields, i);
                if (!result.valid) {
                    break;
                }
            }

            return result;
        }

        function validatePostCourtroom(invalidFields, idx) {
            var sezione = BasicValidator.PdlService.getSezioniFromMap('POST_COURT', idx);

            if (!sezione) {
                return {valid: true, message: message, invalidFields: invalidFields};
            }

            var suffix = "";
            if (idx > 0) {
                suffix += "_" + idx;
            }

            var metadata = sezione.metadati;

            var message = '<ul>';

            message += '</ul>';
            var valid = invalidFields.length === 0;
            if (!valid) {
                BasicValidator.$location.hash('postCourtroom' + suffix);
                BasicValidator.$anchorScroll();
                sezione.visible = true;
            }
            return {valid: valid, message: message, invalidFields: invalidFields};
        }


    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('PdlValidator', ['BasicValidator', function (BasicValidator) {

        this.validatePresentation = BasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            // if (userRolesMap.isAdmin) {
            //     var result = BasicValidator.validateSectorSections(invalidFields, idPrimaCommissione);
            //     if (result.valid) {
            //         if (!BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
            //             result = BasicValidator.validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
            //                 idPrimaCommissione, action && action.name === 'assignToCourtRoom');
            //         }
            //         if (result.valid) {
            //             result = BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
            //         }
            //     }
            //     return result;
            // } else {
            switch (state) {
            case "PRESENTATO":
                return BasicValidator.validateSectorSections(invalidFields, idPrimaCommissione);
            case "COMMISSIONE":
                return validateCommissionSections(invalidFields, utente, userRolesMap,
                        numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
            case "AULA":
                return BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
            case "APPROVATO":
                return BasicValidator.validatePostCourtroomSections(invalidFields, numeroRinvio);
            default:
                console.error("STATO SCONOSCIUTO: " + state);
                return {valid: false, message: "STATO SCONOSCIUTO: " + state};
            }
        };

        function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
            var result = null;
            for (var i = 0; i <= numeroRinvio; i++) {
                result = BasicValidator.validateLegitimacy(invalidFields, userRolesMap, i);
                if (result.valid) {
                    result = BasicValidator.validateFeasibility(invalidFields, userRolesMap, i);
                    if (result.valid) {
                        result = BasicValidator.validateCommissionEmendments(invalidFields, i, primaryCommission);
                        if (result.valid) {
                            //result = BasicValidator.validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione, primaryCommission);
                            if (result.valid) {
                                result = BasicValidator.validateFinancialCoverage(invalidFields, i, primaryCommission);
                                if (result.valid) {
                                    result = BasicValidator.validateCommissionMessage(invalidFields, i, primaryCommission);
                                    if (result.valid) {
                                        result = validateUnifiedText(invalidFields, i, primaryCommission);
                                    } else {
                                        break;
                                    }
                                } else {
                                    break;
                                }
                            } else {
                                break;
                            }
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                } else {
                    break;
                }
            }
            return result;
        }

        function validateUnifiedText(invalidFields, idx, primaryCommission) {
            var sezione = BasicValidator.PdlService.getSezioniFromMap('UNIFIED_TEXT', idx);

            if (!sezione || !primaryCommission) {
                return {valid: true, message: message, invalidFields: invalidFields};
            }

            var suffix = "";
            if (idx > 0) {
                suffix += "_" + idx;
            }

            var metadata = sezione.metadati;

            var message = '<ul>';

            if (typeof (metadata.hasUnifiedTexts) === 'undefined' || metadata.hasUnifiedTexts === null) {
                throw "Has unified text does not exist";
            } else if (metadata.hasUnifiedTexts === true && metadata.unifiedTexts.length === 0) {
                message += '<li><i>Specificare</i> almeno un testo unificato</li>';
                invalidFields.push('hasUnifiedTexts' + suffix);
            }

            message += '</ul>';

            var valid = invalidFields.length === 0;
            if (!valid) {
                BasicValidator.$location.hash('unifiedText' + suffix);
                BasicValidator.$anchorScroll();
                sezione.visible = true;
            }

            return {valid: valid, message: message, invalidFields: invalidFields};
        }

    }]);
})();

(function () {

    'use strict';

    var PdlService = ['Atto', 'Principal', 'User', 'toastr',
        function (Atto, Principal, User, toastr) {
            var service = this;

            service.datiPubblici = false;
            service.primaryCommission = false;
            service.sezioniMap = {};
            service.workDocumentsMap = {};
            service.dateRinvio = {};

            var MetadataUtilService = {
                initMetadati: function(sezione) {
                    sezione.metadati = sezione.metadati || {};
                    sezione.metadati.links = sezione.metadati.links || [];
                }
            };

            /**
             * Carica e inizializza le sezioni della PDL.
             *
             * @param {type} atto
             * @param {type} sezioniAtto
             * @param {type} numeroRinvii
             * @param {type} userRolesMap
             * @param {type} editable
             * @param {type} utente
             * @param {type} idPrimaCommissione
             * @returns {undefined}
             */
            service.loadSezioni = function (atto, sezioniAtto, numeroRinvii, userRolesMap, editable, utente, idPrimaCommissione, publicView, userSoggettiEsterniMap) {
                service.atto = atto;
                // Put assignment letter in first position if not already there!
                changeAssignmentLetterPosition(sezioniAtto);
                service.sezioniMap = {};
                service.workDocumentsMap = {};
                angular.forEach(sezioniAtto, function (sezione) {

                    MetadataUtilService.initMetadati(sezione);
                    // sezione.metadati = sezione.metadati || {};

                    // sezione.metadati.links = sezione.metadati.links || [];

                    var authorities = sezione.ruoli;
                    if (sezione.nomeSezione === 'COMMISSION_OPINIONS') {
                        if(authorities.indexOf("ROLE_EXTERNAL") === -1) {
                            authorities.push('ROLE_EXTERNAL');
                        }
                    } else if (sezione.nomeSezione === 'COMMISSION_ASSIGNED_EMENDMENTS' || sezione.nomeSezione === 'COMMISSION_EMENDMENTS'
                            || sezione.nomeSezione === 'COURT_EMENDMENTS') {
                        authorities = ['ROLE_ADMIN', 'ROLE_PROTOCOLLO'];

                        /* MODIFICHE TEMPORANEE DA RIMUOVERE A INTEGRAZIONE CON PROTOCOLLO COMPLETATA */
                        if (sezione.nomeSezione === 'COMMISSION_ASSIGNED_EMENDMENTS' || sezione.nomeSezione === 'COMMISSION_EMENDMENTS') {
                            authorities.push('ROLE_COMMISSIONE');
                        } else if (sezione.nomeSezione === 'COURT_EMENDMENTS') {
                            authorities.push('ROLE_AULA');
                        }
                        /* FINE */

                        sezione.ruoli = authorities;
                    } else if (sezione.nomeSezione === 'WORK_DOCUMENTS') {
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, sezione.metadati.numeroRinvio, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative ai documenti di lavoro');
                        });
                    } else if (sezione.nomeSezione === 'POST_COURT') {
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            if(documenti.length > 0) service.workDocumentsMap['ADEMPIMENTI'] = true;
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, sezione.metadati.numeroRinvio, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative agli adempimenti');
                        });
                    }else if (sezione.nomeSezione === 'LEGITIMACY') {
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, sezione.metadati.numeroRinvio, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative ai documenti di legittimità');
                        });
                    } else if (sezione.nomeSezione === 'FEASIBILITY') {
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, sezione.metadati.numeroRinvio, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative ai documenti di fattibilità');
                        });
                    } else if(atto.tipoAtto === 'IO' && sezione.nomeSezione === 'ASSIGNMENT_LETTER') {
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, 0, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative ai documenti della lettera di assegnazione per questa interrogazione orale!');
                        });
                    } else if((atto.tipoAtto === 'DEA' || atto.tipoAtto === 'PEA') && sezione.nomeSezione === 'GIUNTA_TRASMISSION') {
                        if(authorities.indexOf("ROLE_COMMISSIONE") === -1) {
                            authorities.push('ROLE_COMMISSIONE');
                        }
                        Atto.sezioniFiles({id: sezione.idAtto, idSezione: sezione.id, publicView: publicView}, {}, function (documenti) {
                            angular.forEach(documenti, function (documento) {
                                service.initDocumentsCheck(documento, 0, service.workDocumentsMap);
                            });
                        }, function () {
                            toastr.error('Impossibile recuperare le informazioni relative ai documenti della lettera di trasmissione!');
                        });
                    } else if (atto.tipoAtto === 'PDD' && sezione.nomeSezione === 'PROCEDIMENTO') {
                        if(authorities.indexOf("ROLE_COMMISSIONE") === -1) {
                            authorities.push('ROLE_COMMISSIONE');
                        }
                    } else if (sezione.nomeSezione === 'RETIRED') {
                        if(authorities.indexOf("ROLE_COMMISSIONE") === -1) {
                            authorities.push('ROLE_COMMISSIONE');
                        }
                    }

                    if (editable) {
                        sezione.editable = userRolesMap.isAdmin;

                        if (sezione.nomeSezione === 'PRESENTATION') {
                            sezione.skipCurrentStateCheck = true;
                        } else if (atto.statoCorrente.statoAtto.name === 'COMMISSIONE' && sezione.statoAttoAssociato.name === atto.statoCorrente.statoAtto.name) {
                            service.datiPubblici = sezione.semprePubblica;
                        } else if (atto.statoCorrente.statoAtto.name === 'AULA' && sezione.nomeSezione === 'COURT_MEETING') {
                            service.datiPubblici = sezione.semprePubblica;
                        }

                        if (!sezione.editable) {
                            if (User.isSectionRoleEnabledForSection(utente, sezione.nomeSezione)) {
                                sezione.editable = true;
                            } else if (sezione.nomeSezione === 'PRESENTATION') {
                                sezione.editable = userRolesMap.isSettoreAtti;
                            } else if(sezione.nomeSezione === 'GIUNTA_TRASMISSION'){
                                // Ticket-2481 Per le PEA, la sezione TRASMISSIONE GIUNTA, quando lo stato dell'atto è "TRASMISSIONE GIUNTA", deve essere gestita dai ruoli previsti come uno stato non finale
                                if (atto.tipoAtto === "PEA" && atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA'){
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura) && (userRolesMap.isSettoreAtti || User.hasAnyCommission(utente, service.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente, atto.legislatura));
                                } else if (atto.tipoAtto === "DEA" && atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA'){
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura) && (userRolesMap.isSettoreAtti || User.hasAnyCommission(utente, service.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente, atto.legislatura));
                                }
                            } else if(sezione.nomeSezione === 'PROCEDIMENTO'){
                                if (atto.tipoAtto === "PDD" && atto.statoCorrente.statoAtto.name === 'APPROVATO'){
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura); 
                                }
                            } else {
                                if (atto.statoCorrente.statoAtto.name === 'COMMISSIONE' && sezione.nomeSezione !== 'ATTACHED_ACTS') {
                                    if (sezione.nomeSezione === 'ASSIGNMENT_LETTER') {
                                        sezione.editable = userRolesMap.isSettoreAtti || userRolesMap.isProtocollo;
                                        sezione.skipCurrentStateCheck = true;
                                    } else if (sezione.nomeSezione === 'PARERE_CAL') {
                                        sezione.editable = userSoggettiEsterniMap.isCAL || userRolesMap.isProtocollo;
                                    } else if (sezione.nomeSezione === 'LEGITIMACY') {
                                        sezione.editable = userRolesMap.isLegitimacy;
                                    } else if (sezione.nomeSezione === 'FEASIBILITY') {
                                        sezione.editable = userRolesMap.isFeasibility;
                                    } else if (sezione.nomeSezione === 'REFERENDUM_REPORT') {
                                        sezione.editable = userRolesMap.isProtocollo;
                                    } else if (sezione.nomeSezione === 'UNION_PROPOSAL') {
                                        sezione.editable = User.hasAnyCommission(utente, service.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente, atto.legislatura);
                                    } else {
                                        sezione.editable = User.isCommissionRole(utente, 'Dipendente', atto.legislatura)
                                            || (sezione.nomeSezione === 'COMMISSION_OPINIONS' && userRolesMap.isExternalSubject);
                                        if (sezione.editable) {
                                            var assignmentMetadata = service.getSezioniFromMap('ASSIGNMENT_LETTER', 0).metadati;
                                            var isReferente = User.hasAnyCommission(utente, assignmentMetadata.parereReferente, atto.legislatura);

                                            if (sezione.nomeSezione === 'COMMISSION_OPINIONS') {
                                                //devi essere tra gli esprimenti parere
                                                sezione.editable = isReferente
                                                    || User.hasAnyCommission(utente, assignmentMetadata.parereSecondario, atto.legislatura)
                                                    || (assignmentMetadata.parereDiMerito && User.hasAnyCommission(utente, assignmentMetadata.parereDiMerito, atto.legislatura))
                                                    || User.hasAnyExternalSubject(utente, assignmentMetadata.parereObbligatorio, atto.legislatura)
                                                    || User.hasAnyExternalSubject(utente, assignmentMetadata.osservazioni, atto.legislatura)
                                                    || (assignmentMetadata.parereIstituzionale && User.hasAnyCommission(utente, [idPrimaCommissione], atto.legislatura));
                                            } else {
                                                //devi essere referente
                                                sezione.editable = isReferente;
                                            }
                                        }
                                    }
                                } else if (atto.statoCorrente.statoAtto.name === 'APPROVATO' && (sezione.nomeSezione === 'ADEMPIMENTI' || sezione.nomeSezione === 'MATERIE')) {
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura);
                                } else if (atto.tipoAtto === "PEA" && atto.statoCorrente.statoAtto.name === 'APPROVATO' && (sezione.nomeSezione === 'EMANAZIONE' || sezione.nomeSezione === 'POST_COURT')) {
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura);
                                } else if (atto.statoCorrente.statoAtto.name === 'TRASFERITA COMPETENZA') {
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura);
                                } else if (sezione.nomeSezione === 'COURT_OUTCOME' || (sezione.statoAttoAssociato.finalState && sezione.statoAttoAssociato.name !== 'RITIRATO')) {
                                    sezione.editable = userRolesMap.isSettoreAtti || userRolesMap.isAula;
                                } else {
                                    sezione.editable = Principal.hasAnyAuthority(authorities, atto.legislatura);
                                }

                                sezione.editable = sezione.editable
                                    && (sezione.skipCurrentStateCheck || sezione.statoAttoAssociato.name === atto.statoCorrente.statoAtto.name || sezione.nomeSezione === 'COURT_OUTCOME' || sezione.statoAttoAssociato.finalState)
                                    && (numeroRinvii === 0 || sezione.metadati.numeroRinvio === numeroRinvii || sezione.nomeSezione === 'PROCEDIMENTO' || sezione.nomeSezione === 'ASSIGNMENT_LETTER');
                            }
                        }
                    } else {
                        sezione.editable = false;
                    }

                    // sezione è visibile solo se quella da editare correntemente, oppure siamo in view
                    sezione.visible = !editable || sezione.editable;

                    if (sezione.nomeSezione === 'COMMISSION_EMENDMENTS' && (sezione.metadati.firmatari === null || angular.isUndefined(sezione.metadati.firmatari))) {
                        sezione.metadati.firmatari = [];
                    } else if (sezione.nomeSezione === 'COMMISSION_OPINIONS') {
                        sezione.metadati.parereReferente = sezione.metadati.parereReferente || {};
                        sezione.metadati.parereSecondario = sezione.metadati.parereSecondario || {};
                        sezione.metadati.parereIstituzionale = sezione.metadati.parereIstituzionale || {};
                        sezione.metadati.parereObbligatorio = sezione.metadati.parereObbligatorio || {};
                        sezione.metadati.osservazioni = sezione.metadati.osservazioni || {};
                    } else if (sezione.nomeSezione === 'ASSIGNMENT_LETTER') {
                        sezione.metadati.aulaDiretta = sezione.metadati.aulaDiretta || false;
                        sezione.metadati.riduzioneTermineParere = sezione.metadati.riduzioneTermineParere || 'false';
                    }

                    service.sezioniMap[service.getSezioniMapKey(sezione.nomeSezione, sezione.metadati.numeroRinvio)] = sezione;

                    if (sezione.nomeSezione === 'ASSIGNMENT_LETTER') {
                        service.primaryCommission = User.isPrimaryCommission(utente, service.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente, atto.legislatura);
                    }
                });
            };


            function changeAssignmentLetterPosition(sezioniAtto) {
                if(sezioniAtto && sezioniAtto.length > 0) {
                    for(var i = 0 ; i < sezioniAtto.length; i++) {
                        if(i >= 1 && sezioniAtto[i].nomeSezione === "ASSIGNMENT_LETTER") {
                            var sezioneAssignment = sezioniAtto.splice(i, 1);
                            sezioniAtto.splice(0,0,sezioneAssignment[0]);
                            break;
                        }
                    }
                }
            }

            /**
             * Inizializza la sezione "Documenti di lavoro", "Legittimità" e "Fattibilità" predispondendo la
             * mappa che rappresenta la selezione dei checkbox.
             *
             * @param {type} documento
             * @param {type} numeroRinvio
             * @returns {undefined}
             */
            service.initDocumentsCheck = function (documento, numeroRinvio) {
                var suffix = "";
                if (numeroRinvio > 0) {
                    suffix += "_" + numeroRinvio;
                }

                var tipoDoc = documento.tipoDocumento || documento.docType;
                switch (tipoDoc.tipo) {
                case 'Scheda istruttoria':
                    service.workDocumentsMap['SCHEDA_ISTRUTTORIA' + suffix] = true;
                    break;
                case 'Testo a fronte':
                    service.workDocumentsMap['TESTI_FRONTE' + suffix] = true;
                    break;
                case 'Ipotesi testo riformulato':
                    service.workDocumentsMap['IPOTESI_TESTO' + suffix] = true;
                    break;
                case 'Rassegna stampa':
                case 'Articoli di interesse':
                    service.workDocumentsMap['RASSEGNA_STAMPA' + suffix] = true;
                    break;
                case 'Scheda di legittimità (parere referente)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_REF' + suffix] = true;
                    break;
                case 'Scheda di legittimità (parere secondario)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_SEC' + suffix] = true;
                    break;
                case 'Scheda di legittimità (parere istituzionale)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_IST' + suffix] = true;
                    break;
                case 'Scheda di analisi di fattibilità':
                    service.workDocumentsMap['SCHEDA_FATTIBILITA' + suffix] = true;
                    break;
                case 'Richiesta di risposta interrogazione':
                    service.workDocumentsMap['RISPOSTA_INTERROGAZIONE'] = true;
                    break;
                case 'Lettera di assegnazione':
                    service.workDocumentsMap['LETTERA_ASSEGNAZIONE'] = true;
                    break;
                case 'Lettera trasmissione':
                    service.workDocumentsMap['LETTERA_TRASMISSIONE'] = true;
                    break;
                case 'Lettera trasmissione atti collegati':
                    service.workDocumentsMap['LETTERA_TRASMISSIONE_ATTI_COLLEGATI'] = true;
                    break;
                case 'Lettera trasmissione giunta':
                    service.workDocumentsMap['LETTERA_TRASMISSIONE_GIUNTA'] = true;
                    break;
                case 'Lettera trasmissione consiglieri':
                    service.workDocumentsMap['LETTERA_TRASMISSIONE_CONSIGLIERI'] = true;
                    break;
                case 'Comunicazione Giunta Regionale':
                    service.workDocumentsMap['COMUNICAZIONE_GIUNTA_REGIONALE'] = true;
                    break;
                case 'Corrispondenza Varia':
                    service.workDocumentsMap['CORRISPONDENZA_VARIA' + suffix] = true;
                    break;   
                }
            };

            /**
             * Resetta la sezione "Legittimità" e "Fattibilità" predispondendo la
             * mappa che rappresenta la deselezione dei checkbox.
             *
             * @param {type} documento
             * @param {type} numeroRinvio
             * @returns {undefined}
             */
            service.removeDocumentsCheck = function (documento, numeroRinvio) {
                var suffix = "";
                if (numeroRinvio > 0) {
                    suffix += "_" + numeroRinvio;
                }

                var tipoDoc = documento.tipoDocumento || documento.docType;
                switch (tipoDoc.tipo) {
                case 'Scheda istruttoria':
                    service.workDocumentsMap['SCHEDA_ISTRUTTORIA' + suffix] = false;
                    break;
                case 'Testo a fronte':
                    service.workDocumentsMap['TESTI_FRONTE' + suffix] = false;
                    break;
                case 'Ipotesi testo riformulato':
                    service.workDocumentsMap['IPOTESI_TESTO' + suffix] = false;
                    break;
                case 'Rassegna stampa':
                case 'Articoli di interesse':
                    service.workDocumentsMap['RASSEGNA_STAMPA' + suffix] = false;
                    break;
                case 'Scheda di legittimità (parere referente)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_REF' + suffix] = false;
                    break;
                case 'Scheda di legittimità (parere secondario)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_SEC' + suffix] = false;
                    break;
                case 'Scheda di legittimità (parere istituzionale)':
                    service.workDocumentsMap['SCHEDA_LEGITTIMITA_IST' + suffix] = false;
                    break;
                case 'Scheda di analisi di fattibilità':
                    service.workDocumentsMap['SCHEDA_FATTIBILITA' + suffix] = false;
                    break;
                }
            };


            /**
             * Restituisce la sezione corrispondente al rinvio fornito.
             *
             * @param {type} nomeSezione
             * @param {type} numeroRinvio
             * @returns {pdl.serviceL#1.pdl.serviceL#1#PdlService.service.getSezioniFromMap.sezioniMap}
             */
            service.getSezioniFromMap = function (nomeSezione, numeroRinvio) {
                return service.sezioniMap[service.getSezioniMapKey(nomeSezione, numeroRinvio)];
            };

            /**
             * Restituisce la chiave univoca che identifica una sezione relativa
             * ad un dato rinvio.
             * @param {type} nomeSezione
             * @param {type} numeroRinvio
             * @returns {String}
             */
            service.getSezioniMapKey = function (nomeSezione, numeroRinvio) {
                if (numeroRinvio && numeroRinvio > 0) {
                    return nomeSezione + '_' + numeroRinvio;
                }
                return nomeSezione;
            };

            /**
             * Restituisce l'array delle sezioni presenti nei vari rinvii, dalla
             * prima fase fino al rinvio specificato compreso.
             * @param {type} nomeSezione
             * @param {type} numeroRinvio
             * @returns {pdl.serviceL#1.pdl.serviceL#1#PdlService.service.getAllRepeatableSectionsByName.result}
             */
            service.getAllRepeatableSectionsByName = function (nomeSezione, numeroRinvio) {
                var result = [];
                if (!numeroRinvio) {
                    var sezione = service.sezioniMap[service.getSezioniMapKey(nomeSezione, 0)];
                    if (sezione) {
                        result.push(sezione);
                    }
                } else {
                    for (var i = 0; i <= numeroRinvio; i++) {
                        var sezione = service.sezioniMap[service.getSezioniMapKey(nomeSezione, i)];
                        if (sezione) {
                            result.push(sezione);
                        }
                    }
                }
                return result;
            };

            /**
             * Inizializza le date di rinvio.
             *
             * @param {type} atto
             * @returns {undefined}
             */
            service.initDateRinvio = function (atto) {
                service.dateRinvio = {};
                if (atto.numeroRinvii && atto.numeroRinvii > 0) {
                    var commissionStatesCount = 0;
                    angular.forEach(atto.storico, function (state) {
                        if (state.statoAtto.name === 'COMMISSIONE') {
                            if (commissionStatesCount > 0) {
                                state.statoAtto.dataRinvio = service.getSezioniFromMap('COURT_OUTCOME', commissionStatesCount - 1).metadati.dataRinvio;
                                service.dateRinvio[commissionStatesCount] = state.statoAtto.dataRinvio;
                            }
                            commissionStatesCount++;
                        }
                    });
                }
            };

            /**
             * Restituisce true se l'utente può modificare l'opinione relativa
             * alle commissioni specificate in subjects, false altrimenti.
             *
             * @param {type} utente
             * @param {type} subjects
             * @param {type} idx
             * @param {type} isAdmin
             * @returns {Boolean}
             */
            service.isCommissionOpinionEditable = function (utente, subjects, idx, isAdmin) {
                var sezione = service.getSezioniFromMap('COMMISSION_OPINIONS', idx);
                return sezione.editable && (isAdmin || User.hasAnyCommission(utente, subjects));
            };

            /**
             * Restituisce true se l'utente può modificare l'osservazione
             * relativa al soggetto esternospecificate in subjects, false
             * altrimenti.
             *
             * @param {type} utente
             * @param {type} subjects
             * @param {type} idx
             * @param {type} isAdmin
             * @returns {Boolean}
             */
            service.isExternalSubjectOpionionEditable = function (utente, subjects, idx, isAdmin) {
                var sezione = service.getSezioniFromMap('COMMISSION_OPINIONS', idx);
                return sezione.editable && (isAdmin || User.hasAnyExternalSubject(utente, subjects, service.atto.legislatura));
            };
            
            service.clearRadio = function(disabled, section, metadataName) {
                if (!disabled) {
                    section.metadati[metadataName] = null;
                }  
            };

        }];

    angular.module('gestioneAttiApp').service('PdlService', PdlService);

})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('PddValidator', ['BasicValidator', function (BasicValidator) {

        this.validatePresentation = BasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            if (userRolesMap.isAdmin) {

                var result = validateSectorSections(invalidFields, idPrimaCommissione);

                if (result.valid) {
                    if (!BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                        result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission);
                    }
                    if (result.valid) {
                        result = BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    }
                }
                return result;
            } else {
                switch (state) {
                    case "PRESENTATO":
                        return validateSectorSections(invalidFields, idPrimaCommissione);
                    case "COMMISSIONE":
                        return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission);
                    case "AULA":
                        return BasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                    case "APPROVATO":
                        return {valid: true};
                    default:
                        console.error("STATO SCONOSCIUTO: " + state);
                        return {valid: false, message: "STATO SCONOSCIUTO: " + state, invalidFields: invalidFields};
                }
            }
        };

        function validateSectorSections(invalidFields, idPrimaCommissione) {
            var result = BasicValidator.validateAssignmentLetter(invalidFields, idPrimaCommissione);

            var openListTagMessage = result.message.slice(0, -5);
            result.message = openListTagMessage;

            result = validateAssignmentLetter(result.invalidFields, idPrimaCommissione, result.valid, result.message);

            return result;
        }

        function validateAssignmentLetter(invalidFields, idPrimaCommissione, valid, message) {
            var metadata = BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

            if (metadata.parereDiMerito && metadata.parereDiMerito.length) {
                for (var i = 0; i < metadata.parereDiMerito.length; i++) {
                    if (metadata.parereReferente && metadata.parereReferente.indexOf(metadata.parereDiMerito[i]) > -1) {

                        result.message += '<li><i>Parere di merito</i> non può contenere valori già specificati in Parere Referente</li>';
                        invalidFields.push('parereDiMerito');

                        break;
                    }
                }
            }

            message += '</ul>';
            valid = invalidFields.length === 0;
            if (!valid) {
                BasicValidator.$location.hash('assignmentLetter');
                BasicValidator.$anchorScroll();
                BasicValidator.PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
            }
            return {valid: valid, message: message, invalidFields: invalidFields};
        }

        function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, primaryCommission) {
            var result = null;
            for (var i = 0; i <= numeroRinvio; i++) {
                result = BasicValidator.validateLegitimacy(invalidFields, userRolesMap, i);
                if (result.valid) {
                    result = BasicValidator.validateCommissionEmendments(invalidFields, i, primaryCommission);
                    if (result.valid) {
                        //result = BasicValidator.validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione);
                        if (result.valid) {
                            result = BasicValidator.validateFinancialCoverage(invalidFields, i, primaryCommission);
                            if (result.valid) {
                                result = BasicValidator.validateCommissionMessage(invalidFields, i, primaryCommission);
                            } else {
                                break;
                            }
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                } else {
                    break;
                }
            }
            return result;
        }
    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('OdgValidator', ['PdlService','MinorBasicValidator', function (PdlService, MinorBasicValidator) {

        this.PdlService = PdlService;
        this.validatePresentation = MinorBasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            switch (state) {
            case "PRESENTATO":
                return validateSectorSections(invalidFields);
            case "COMMISSIONE":
                return MinorBasicValidator.validateCommissionSections(invalidFields, utente, userRolesMap,
                    numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
            case "AULA":
                return MinorBasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
            case "APPROVATO":
                return MinorBasicValidator.validatePostCourtroomSections(invalidFields, numeroRinvio);
            default:
                console.error("STATO SCONOSCIUTO: " + state);
                return {valid: false, message: "STATO SCONOSCIUTO: " + state};
            }


            function validateSectorSections(invalidFields){
                var result = MinorBasicValidator.validateSectorSections(invalidFields);
                // Richiesta Caldini via mail 21/10/19
/*                 if(result.valid){ 
                    result = validateAttachedActs(invalidFields);
                } */
                return result;
                
            }

            function validateAttachedActs(invalidFields) {
                var valid = true;
                var message = '<ul>';
                var sezioneAttachedActs = PdlService.getSezioniFromMap('ATTACHED_ACTS', 0);
                if(!sezioneAttachedActs.metadati.unifiedTexts || sezioneAttachedActs.metadati.unifiedTexts.length === 0 ) {
                    message += '<li><i>Atti Collegati</i> deve contenere almeno un atto collegato</li>';
                    invalidFields.push('attiCollegati');
                    valid = false;
                }
                message += '</ul>';
                return {valid: valid, message: message, invalidFields: invalidFields};
            }


            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                var result = null;
                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validateCommissionEmendments(invalidFields, i, primaryCommission);//se sono referente
                    if (result.valid) {//Vedere se siamo in aula diretta!
                        //result = validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione);
                        if (result.valid) {
                            result = validateCommissionMessage(invalidFields, i, primaryCommission);//se sono referente
                        } else {
                            break;
                        }

                    } else {
                        break;
                    }

                }
                return result;
            }
            // }
        };


    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('MozioneValidator', ['PdlService','MinorBasicValidator', '$location', '$anchorScroll', function (PdlService, MinorBasicValidator, $location, $anchorScroll) {
        this.PdlService = PdlService;
        this.validatePresentation = MinorBasicValidator.validatePresentation;

        this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
            var invalidFields = [];

            switch (state) {
                case "PRESENTATO":
                    return validateSectorSections(invalidFields, idPrimaCommissione)
                case "COMMISSIONE":
                    return MinorBasicValidator.validateCommissionSections(invalidFields, utente, userRolesMap,
                        numeroRinvio, idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                case "AULA":
                    return MinorBasicValidator.validateCourtroomSections(invalidFields, numeroRinvio);
                case "APPROVATO":
                    return MinorBasicValidator.validatePostCourtroomSections(invalidFields, numeroRinvio);
                default:
                    console.error("STATO SCONOSCIUTO: " + state);
                    return {valid: false, message: "STATO SCONOSCIUTO: " + state};
            }

        };

        function validateSectorSections(invalidFields, idPrimaCommissione) {
            var result = MinorBasicValidator.validateSectorSections(invalidFields, idPrimaCommissione);
            if(result.valid) {
                result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
            }
            return result;
        }



        function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
            var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

            var message = '<ul>';

            if (typeof (metadata.aulaDiretta) === 'undefined' || metadata.aulaDiretta === null) {
                message += '<li><i>Direttamente in Aula</i> è un campo obbligatorio</li>';
                invalidFields.push('aulaDiretta');
            } else if (metadata.aulaDiretta) {

            } else {
                if (!metadata.parereReferente || !metadata.parereReferente.length) {
                    message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                    invalidFields.push('parereReferente');
                }

            }

            message += '</ul>';

            var valid = invalidFields.length === 0;
            if (!valid) {
                $location.hash('assignmentLetter');
                $anchorScroll();
                PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
            }

            return {valid: valid, message: message, invalidFields: invalidFields};
        }



    }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('MinorBasicValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;

            // Commissione
            this.validateCommissionEmendments = validateCommissionEmendments;
            this.validateCommissionSections = validateCommissionSections;
            this.validateCommissionMessage = validateCommissionMessage;
            this.validateCommissionOpinions = validateCommissionOpinions;
            this.validateCommissionOpinion = validateCommissionOpinion;
            this.validateCourtroomSections = validateCourtroomSections; 

            // Aula
            this.validateCourtroomEmendments = validateCourtroomEmendments;
            this.validateCourtroomMeeting = validateCourtroomMeeting;
            this.validateSectorSections = validateSectorSections;
            this.validateCourtroomOutcome = validateCourtroomOutcome;

            // Stato Approvato
            this.validatePostCourtroomSections = validatePostCourtroomSections;
            this.validatePostCourtroom = validatePostCourtroom;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    /* var result = validateSectorSections(invalidFields, idPrimaCommissione); */
                    var result = {};
                    result.valid = true;
                    if (result.valid) {
/*                             result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission); */
                        if (result.valid) {
                            //result = validateCourtroomSections(invalidFields, numeroRinvio);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                        case "PRESENTATO":
                            return validateSectorSections(invalidFields);
                        case "COMMISSIONE":
                            return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        case "AULA":
                            return validateCourtroomSections(invalidFields, numeroRinvio);
                        case "APPROVATO":
                            return validatePostCourtroomSections(invalidFields, numeroRinvio);
                        default:
                            console.error("STATO SCONOSCIUTO: " + state);
                            return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                var result = null;
                var i = 0;
                if(numeroRinvio > 1) {
                    i = 1;
                } else {
                    return {valid: true, message: 'ok', invalidFields: invalidFields};
                }
                for (i; i <= numeroRinvio; i++) {
                    result = validateCommissionEmendments(invalidFields, i, primaryCommission);//se sono referente
                    if (result.valid) {
                        //result = validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione); //Commission Opinions validation disabled as requested by mail from @Caldini in 18/06/19
                        if (result.valid) {
                            result = validateCommissionMessage(invalidFields, i, primaryCommission);//se sono referente
                        } else {
                            break;
                        }

                    } else {
                        break;
                    }

                }
                return result;
            }

            function validateSectorSections(invalidFields){
                return {valid: true, message: 'ok', invalidFields: invalidFields};                
            }

            function validateCourtroomSections(invalidFields, numeroRinvio) {
                var result;
                result = validateAssignmentLetter(invalidFields, 0);
                if(!result.valid) {
                    return result;
                }
                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validateCourtroomEmendments(invalidFields, i);
                    if (result.valid) {
                        result = validateCourtroomMeeting(invalidFields, i);
                        if (result.valid) {
                            result = validateCourtroomOutcome(invalidFields, i);
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                return result;
            }

            //nel caso della lettera di assegnazione i e' sempre 0!
            function validateAssignmentLetter(invalidFields, i) {
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';


                if (!metadata.parereReferente || !metadata.parereReferente.length) {
                    message += '<li><i>Assegnazione commissioni:</i> devi selezionare almeno una commissione </li>';
                    invalidFields.push('parereReferente');
                }           
                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;

                for (var i = 0; i <= numeroRinvio; i++) {
                    //result = validatePostCourtroom(invalidFields, i);
                    result = {valid: true};
                    if (result.valid) {
                        result = validateActuationNotes(invalidFields,i);
                        if(!result.valid){
                            break;
                        }
                    } else {
                        break;
                    }
                }

                return result;
            }

            //Da sapere quali campi sono obbligatori!
            function validateActuationNotes(invalidFields, i){
                return {valid: true, message: '', invalidFields: invalidFields};
            }

            function validateCommissionMessage(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_MESSAGE', idx);
                if (!sezione || !primaryCommission) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitolo' + suffix);
                } else if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitolo' + suffix);
                }

                if (typeof (metadata.modificaTesto) === 'undefined' || metadata.modificaTesto === null) {
                    message += '<li><i>Modifiche al testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaTesto' + suffix);
                } else if (metadata.modificaTesto && !metadata.tipoModifica) {
                    message += '<li><i>Tipo di modifica</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoModifica' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('commissionMessage' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionEmendments(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_EMENDMENTS', idx);

                if (!sezione || !primaryCommission) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

               
                var message = '<ul>';

                if (metadata.emendamentiPresentatiCommissione) {
                    var i = 0;

                    angular.forEach(metadata.emendamentiPresentati, function (emendment) {
                        if (i > 0
                                //&& (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0)
                                && !emendment.dataProtocollo
                                // && (!emendment.protocollo || emendment.protocollo.trim().length === 0) // Validazione su protocollo rimossa. @See MAIL 16/07/2018 09.09 FROM Caldini Marco.
                                && (!emendment.firmatari || emendment.firmatari.length === 0)) {
                            //rimuovo eventuali emendamenti lasciati vuoti se sono in più al primo (che deve essere compilato)
                            metadata.emendamentiPresentati.splice(metadata.emendamentiPresentati.indexOf(emendment), 1);
                        } else {
/*                             if (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0) {
                                invalidFields.push('numeroEmendamento' + suffix + '_' + i);
                            } */
                            if (!emendment.dataProtocollo) {
                                invalidFields.push('dataProtocollo' + suffix + '_' + i);
                            }
                            /* Validazione su protocollo rimossa. @See MAIL 16/07/2018 09.09 FROM Caldini Marco. */
                            /*if (!emendment.protocollo || emendment.protocollo.trim().length === 0) {
                             invalidFields.push('protocollo' + suffix + '_' + i);
                             }*/
                            if (!emendment.firmatari || emendment.firmatari.length === 0) {
                                invalidFields.push('firmatari' + suffix + '_' + i);
                            }
                        }
                        i++;
                    });
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    message += '<li>Uno o più <i>Emendamenti presentati in commissione</i> non sono stati compilati correttamente</li>';
                    $location.hash('commissionEmendments');
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }
            
            function validateCommissionOpinions(invalidFields, utente, userRolesMap, idx, idPrimaCommissione) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_OPINIONS', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                //Perche' la prima volta va direttamente in aula, quindi la prima non deve essere considerata!
                if(idx === 0) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var assignmentLetterMetadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var metadatiSezione = sezione.metadati;
                var message = '<ul>';

                if (assignmentLetterMetadata.parereReferente && assignmentLetterMetadata.parereReferente.length
                        && PdlService.isCommissionOpinionEditable(utente, assignmentLetterMetadata.parereReferente, idx, userRolesMap.isAdmin)) {
                    message = validateCommissionOpinion(invalidFields, assignmentLetterMetadata.parereReferente, metadatiSezione.parereReferente, true, message, suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('commissionOpinions' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionOpinion(invalidFields, opinionAssignment, opinionMetadata, isJoinedOpinion, message, fieldSuffix) {
                var messageItem = '<li>Ci sono <i>Pareri/Osservazioni</i> non completamente compilati</i>';
                if (!opinionMetadata) {
                    if (isJoinedOpinion) {
                        var subjectCompositeId = '';
                        if (opinionAssignment.length === 1) {
                            subjectCompositeId = opinionAssignment[0];
                        } else {
                            angular.forEach(opinionAssignment, function (subjectId) {
                                subjectCompositeId += '_' + subjectId;
                                message += messageItem;
                                messageItem = '';
                            });
                        }
                        invalidFields.push('data' + fieldSuffix + subjectCompositeId);
                        invalidFields.push('parere' + fieldSuffix + subjectCompositeId);
                        invalidFields.push('tipoFavorevolezza' + fieldSuffix + subjectCompositeId);
                    } else {
                        angular.forEach(opinionAssignment, function (subjectId) {
                            invalidFields.push('data' + fieldSuffix + subjectId);
                            invalidFields.push('parere' + fieldSuffix + subjectId);
                            invalidFields.push('tipoFavorevolezza' + fieldSuffix + subjectId);
                            message += messageItem;
                            messageItem = '';
                        });
                    }
                } else {
                    if (isJoinedOpinion) {
                        var subjectCompositeId = '';
                        if (opinionAssignment.length === 1) {
                            subjectCompositeId = opinionAssignment[0];
                        } else {
                            angular.forEach(opinionAssignment, function (subjectId) {
                                subjectCompositeId += '_' + subjectId;
                                message += messageItem;
                                messageItem = '';
                            });
                        }
                        if (!opinionMetadata.data || !opinionMetadata.data[subjectCompositeId]) {
                            invalidFields.push('data' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                        if (!opinionMetadata.parere || !opinionMetadata.parere[subjectCompositeId]) {
                            invalidFields.push('parere' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                        if (!opinionMetadata.tipoFavorevolezza || !opinionMetadata.tipoFavorevolezza[subjectCompositeId]) {
                            invalidFields.push('tipoFavorevolezza' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                    } else {
                        angular.forEach(opinionAssignment, function (subjectId) {
                            if (!opinionMetadata.data || !opinionMetadata.data[subjectId]) {
                                invalidFields.push('data' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                            if (!opinionMetadata.parere || !opinionMetadata.parere[subjectId]) {
                                invalidFields.push('parere' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                            if (!opinionMetadata.tipoFavorevolezza || !opinionMetadata.tipoFavorevolezza[subjectId]) {
                                invalidFields.push('tipoFavorevolezza' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                        });
                    }
                }
                return message;
            }

            function validateCourtroomEmendments(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_EMENDMENTS', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                var i = 0;
                angular.forEach(metadata.emendamenti, function (emendment) {
                    if ( //(!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0)
                            !emendment.dataProtocollo
                            //&& (!emendment.protocollo || emendment.protocollo.trim().length === 0)
                            && (!emendment.firmatari || emendment.firmatari.length === 0)
                            /* && !emendment.state */) {
                        //rimuovo eventuali emendamenti lasciati vuoti se sono in più al primo (che deve essere compilato)
                        if (i > 0) {
                            metadata.emendamenti.splice(metadata.emendamenti.indexOf(emendment), 1);
                        }
                    } else {
/*                         if (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0) {
                            invalidFields.push('numeroEmendamento' + suffix + '_' + i);
                        } */
                        if (!emendment.dataProtocollo) {
                            invalidFields.push('dataProtocollo' + suffix + '_' + i);
                        }
/*                         if (!emendment.protocollo || emendment.protocollo.trim().length === 0) {
                            invalidFields.push('protocollo' + suffix + '_' + i);
                        } */
                        if (!emendment.firmatari || emendment.firmatari.length === 0) {
                            invalidFields.push('firmatari' + suffix + '_' + i);
                        }
/*                         if (!emendment.state) {
                            invalidFields.push('state' + suffix + '_' + i);
                        } */
                    }
                    i++;
                });
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    message += '<li>Uno o più <i>Emendamenti presentati in aula</i> non sono stati compilati correttamente</li>';
                    $location.hash('courtroomEmendments' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePostCourtroom(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('POST_COURT', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                if (!metadata.numeroLeggeAC || metadata.numeroLeggeAC.trim().length === 0) {
                    message += '<li><i>Numero legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroLeggeAC' + suffix);
                }
                if (!metadata.dataLeggeAC) {
                    message += '<li><i>Data legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataLeggeAC' + suffix);
                }
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('postCourtroom' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if (!atto.tipoProponente) {
                    message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoProponente');
                } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                    message += '<li>Devi specificare almeno un proponente</li>';
                    invalidFields.push('proponenti');
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomMeeting(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_MEETING', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (!metadata.sedute || !metadata.sedute[0]) {
                    message += '<li><i>Date sedute:</i> inserire almeno una data</li>';
                    invalidFields.push('sessionsDate' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomOutcome(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                //Non sono piu' obbligatori: richiesta del Caldini in data 27/5/2019
/*                 if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitoloAula' + suffix);
                } else */ 
                if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitoloAula' + suffix);
                }
/*                 if (typeof (metadata.coordinamentoTesto) === 'undefined' || metadata.coordinamentoTesto === null) {
                    message += '<li><i>Coordinamento formale testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('coordinamentoTesto' + suffix);
                } */

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }
        }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('IoValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;
            this.validateAssignmentLetter = validateAssignmentLetter;

            // Commissione

            // Aula
            this.validateEsitoRispostaScritta = validateEsitoRispostaScritta;
            this.validateSectorSections = validateSectorSections;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    var result = validateSectorSections(invalidFields, idPrimaCommissione);
    
                    if (result.valid) {
                        if (PdlService.sezioniMap.ASSIGNMENT_LETTER && !PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                            result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        }
                        if (result.valid) {
                            result = validateCourtroomSections(invalidFields, numeroRinvio);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                        case "PRESENTATO":
                            return validateSectorSections(invalidFields, idPrimaCommissione);
                        case "COMMISSIONE":
                            return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        case "AULA":
                            return validateCourtroomSections(invalidFields, numeroRinvio);
                        case "APPROVATO":
                            return validatePostCourtroomSections(invalidFields, numeroRinvio);
                        default:
                            console.error("STATO SCONOSCIUTO: " + state);
                            return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
                //CASO Interrogazione scritta
                if(!PdlService.sezioniMap.ASSIGNMENT_LETTER) {
                    return {valid: true};
                }
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';

                if (typeof (metadata.aulaDiretta) === 'undefined' || metadata.aulaDiretta === null) {
                    message += '<li><i>Direttamente in Aula</i> è un campo obbligatorio</li>';
                    invalidFields.push('aulaDiretta');
                } else if (metadata.aulaDiretta) {
/*                     if (!metadata.dataSedutaUp) {
                        message += '<li><i>Data Seduta UP</i> è un campo obbligatorio</li>';
                        invalidFields.push('dataSedutaUp');
                    } */
                } else {
                    if (!metadata.dateAssegnazione || metadata.dateAssegnazione.length === 0 || metadata.dateAssegnazione[0] === "") {
                        message += '<li><i>Data assegnazione</i> è un campo obbligatorio</li>';
                        invalidFields.push('dateAssegnazione');
                    }
                    if (!metadata.parereReferente || !metadata.parereReferente.length) {
                        message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                        invalidFields.push('parereReferente');
                    } else if (metadata.parereReferente.indexOf(idPrimaCommissione) > -1 && metadata.parereIstituzionale) {
                        message += '<li><i>Parere Istituzionale</i> non può essere impostato a Sì se la Prima Commissione è stata selezionata in Parere Referente</li>';
                        invalidFields.push('parereIstituzionale');
                    }

                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateSectorSections(invalidFields, idPrimaCommissione) {
                var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
                return result;
            }

            function validateEsitoRispostaScritta(invalidFields) {
                var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', 0);
                if(!invalidFields) {
                    invalidFields = [];
                }
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (!metadata.rispostaScrittaIn3Giorni && !metadata.rispostaScrittaIn15Giorni && !metadata.rispostaScrittaConsegnata) {
                    message += '<li><i>Esisto:</i> inserire almeno una risposta scritta nell\'esito!</li>';
                    invalidFields.push('rispostaScritta');
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome');
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                return {valid: true};
            }


            /* function validateCourtroomSections(invalidFields, numeroRinvio) {
                return {valid: true};
            }*/

            function validateCourtroomSections(invalidFields, numeroRinvio) {

                if(!invalidFields) {
                    invalidFields = [];
                }

                var sezione = PdlService.getSezioniFromMap('COURT_MEETING', numeroRinvio);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (numeroRinvio > 0) {
                    suffix += "_" + numeroRinvio;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';

                // Date sedute iscrizione
                if(!metadata.sedute || !metadata.sedute[0]) {
                    message += '<li><i>Date sedute iscrizione</i> è un campo obbligatorio</li>';
                    invalidFields.push('sedute' + suffix);
                }
                // Date sedute trattazione
                if(!metadata.seduteTrattazione || !metadata.seduteTrattazione[0]) {
                    message += '<li><i>Date sedute trattazione</i> è un campo obbligatorio</li>';
                    invalidFields.push('seduteTrattazione' + suffix);
                }

                message += '</ul>';
                
                var valid = invalidFields.length === 0;

                return {valid: valid, message: message, invalidFields: invalidFields};
            }


            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;
            
                return {valid: true, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if(atto.tipoAtto === 'PLIP'){
                    if (!atto.proponentiText || atto.proponentiText.length === 0 || atto.proponentiText[0] === '') {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                } else {
                    if (!atto.tipoProponente) {
                        message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                        invalidFields.push('tipoProponente');
                    } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }
        }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('IeaValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;
            this.validateAssignmentLetter = validateAssignmentLetter;

            // Commissione
           
            this.validateCommissionMessage = validateCommissionMessage;


            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    var result = validateSectorSections(invalidFields, idPrimaCommissione);
                    if (result.valid) {
                        if (!PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                            // result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                            //         idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                    case "PRESENTATO":
                        return validateSectorSections(invalidFields, idPrimaCommissione);
                    case "COMMISSIONE":
                        return validateCommissionSections(invalidFields, numeroRinvio, primaryCommission);
                    case "APPROVATO":
                        return {valid: true};/* validatePostCourtroomSections(invalidFields, numeroRinvio); */
                    default:
                        console.error("STATO SCONOSCIUTO: " + state);
                        return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';
               
                if ((!metadata.parereReferente || !metadata.parereReferente.length) && !metadata.aulaDiretta) {
                    message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                    invalidFields.push('parereReferente');
                }
                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateSectorSections(invalidFields, idPrimaCommissione) {
                var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
                return result;
            }

            function validateCommissionSections(invalidFields, numeroRinvio, primaryCommission) {
                return validateCommissionMessage(invalidFields, 0, primaryCommission);//se sono referente 
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result;

                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validatePostCourtroom(invalidFields, i);
                    if (!result.valid) {
                        break;
                    }
                }

                return result;
            }


            function validateCommissionMessage(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_MESSAGE', idx);
                if (!sezione || !primaryCommission) {
                    return {valid: true, message: '', invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitolo' + suffix);
                } else if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitolo' + suffix);
                }

                if (typeof (metadata.modificaTesto) === 'undefined' || metadata.modificaTesto === null) {
                    message += '<li><i>Modifiche al testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaTesto' + suffix);
                } else if (metadata.modificaTesto && !metadata.tipoModifica) {
                    message += '<li><i>Tipo di modifica</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoModifica' + suffix);
                }

                if (typeof (metadata.propostaRisoluzione) === 'undefined' || metadata.propostaRisoluzione === null) {
                    message += '<li><i>Proposta di risoluzione collegata con riferimento alla commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('propostaRisoluzione' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('commissionMessage' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePostCourtroom(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('POST_COURT', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                if (!metadata.numeroLeggeAC || metadata.numeroLeggeAC.trim().length === 0) {
                    message += '<li><i>Numero legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroLeggeAC' + suffix);
                }
                if (!metadata.dataLeggeAC) {
                    message += '<li><i>Data legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataLeggeAC' + suffix);
                }
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('postCourtroom' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if(atto.tipoAtto === 'PLIP'){
                    if (!atto.proponentiText || atto.proponentiText.length === 0 || atto.proponentiText[0] === '') {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                } else {
                    if (!atto.tipoProponente) {
                        message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                        invalidFields.push('tipoProponente');
                    } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

        }]);
})();

(function () {

    'use strict';

    angular.module('gestioneAttiApp').service('BasicValidator', ['PdlService', '$location', '$anchorScroll',
        function (PdlService, $location, $anchorScroll) {

            this.PdlService = PdlService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;

            // Presentato
            this.validatePresentation = validatePresentation;
            this.validateAssignmentLetter = validateAssignmentLetter;

            // Commissione
            this.validateLegitimacy = validateLegitimacy;
            this.validateFeasibility = validateFeasibility;
            this.validateCommissionEmendments = validateCommissionEmendments;
            this.validateCommissionSections = validateCommissionSections;
            this.validateCommissionMessage = validateCommissionMessage;
            this.validateCommissionOpinions = validateCommissionOpinions;
            this.validateCommissionOpinion = validateCommissionOpinion;
            this.validateFinancialCoverage = validateFinancialCoverage;
            this.validateCourtroomSections = validateCourtroomSections;

            // Aula
            this.validateCourtroomEmendments = validateCourtroomEmendments;
            this.validateCourtroomMeeting = validateCourtroomMeeting;
            this.validateSectorSections = validateSectorSections;
            this.validateCourtroomOutcome = validateCourtroomOutcome;

            // Stato Approvato
            this.validatePostCourtroomSections = validatePostCourtroomSections;
            this.validatePostCourtroom = validatePostCourtroom;

            this.validate = function (state, numeroRinvio, utente, userRolesMap, idPrimaCommissione, action, primaryCommission) {
                var invalidFields = [];

                if (userRolesMap.isAdmin) {
                    var result = validateSectorSections(invalidFields, idPrimaCommissione);
                    if (result.valid) {
                        if (!PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta) {
                            result = validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        }
                        if (result.valid) {
                            result = validateCourtroomSections(invalidFields, numeroRinvio);
                        }
                    }
                    return result;
                } else {
                    switch (state) {
                        case "PRESENTATO":
                            return validateSectorSections(invalidFields, idPrimaCommissione);
                        case "COMMISSIONE":
                            return validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio,
                                    idPrimaCommissione, action && action.name === 'assignToCourtRoom', primaryCommission);
                        case "AULA":
                            return validateCourtroomSections(invalidFields, numeroRinvio);
                        case "APPROVATO":
                            return validatePostCourtroomSections(invalidFields, numeroRinvio);
                        default:
                            console.error("STATO SCONOSCIUTO: " + state);
                            return {valid: false, message: "STATO SCONOSCIUTO: " + state};
                    }
                }
            };

            function validateAssignmentLetter(invalidFields, idPrimaCommissione) {
                var metadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var message = '<ul>';

                if (typeof (metadata.aulaDiretta) === 'undefined' || metadata.aulaDiretta === null) {
                    message += '<li><i>Direttamente in Aula</i> è un campo obbligatorio</li>';
                    invalidFields.push('aulaDiretta');
                } else if (metadata.aulaDiretta) {
/*                     if (!metadata.dataSedutaUp) {
                        message += '<li><i>Data Seduta UP</i> è un campo obbligatorio</li>';
                        invalidFields.push('dataSedutaUp');
                    } */
                } else {
                    if (!metadata.dataAssegnazione) {
                        message += '<li><i>Data assegnazione</i> è un campo obbligatorio</li>';
                        invalidFields.push('dataAssegnazione');
                    }
                    if (typeof (metadata.riduzioneTermineParere) === 'undefined' || metadata.riduzioneTermineParere === null) {
                        message += '<li><i>Riduzione termine parere</i> è un campo obbligatorio</li>';
                        invalidFields.push('riduzioneTermineParere');
                    }
                    if (typeof (metadata.parereIstituzionale) === 'undefined' || metadata.parereIstituzionale === null) {
                        message += '<li><i>Parere Istituzionale</i> è un campo obbligatorio</li>';
                        invalidFields.push('parereIstituzionale');
                    }
                    if (!metadata.parereReferente || !metadata.parereReferente.length) {
                        message += '<li><i>Parere Referente</i> è un campo obbligatorio</li>';
                        invalidFields.push('parereReferente');
                    } else if (metadata.parereReferente.indexOf(idPrimaCommissione) > -1 && metadata.parereIstituzionale) {
                        message += '<li><i>Parere Istituzionale</i> non può essere impostato a Sì se la Prima Commissione è stata selezionata in Parere Referente</li>';
                        invalidFields.push('parereIstituzionale');
                    }

                    if (metadata.parereSecondario && metadata.parereSecondario.length) {
                        if (metadata.parereSecondario.indexOf(idPrimaCommissione) > -1 && metadata.parereIstituzionale) {
                            message += '<li><i>Parere Istituzionale</i> non può essere impostato a Sì se la Prima Commissione è stata selezionata in Parere Secondario</li>';
                            invalidFields.push('parereIstituzionale');
                        }
                        for (var i = 0; i < metadata.parereSecondario.length; i++) {
                            if (metadata.parereReferente && metadata.parereReferente.indexOf(metadata.parereSecondario[i]) > -1) {
                                message += '<li><i>Parere Secondario</i> non può contenere valori già specificati in Parere Referente</li>';
                                invalidFields.push('parereSecondario');
                                break;
                            }
                        }
                    }

                    if (metadata.parereObbligatorio && metadata.parereObbligatorio.length && metadata.osservazioni && metadata.osservazioni.length) {
                        for (var j = 0; j < metadata.osservazioni.length; j++) {
                            if (metadata.parereObbligatorio.indexOf(metadata.osservazioni[j]) > -1) {
                                message += '<li><i>Osservazioni</i> non può contenere valori già specificati in Parere Obbligatorio</li>';
                                invalidFields.push('osservazioni');
                                break;
                            }
                        }
                    }

                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('assignmentLetter');
                    $anchorScroll();
                    PdlService.sezioniMap.ASSIGNMENT_LETTER.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateSectorSections(invalidFields, idPrimaCommissione) {
                var result = validateAssignmentLetter(invalidFields, idPrimaCommissione);
                return result;
            }

            function validateCommissionSections(invalidFields, utente, userRolesMap, numeroRinvio, idPrimaCommissione, action, primaryCommission) {
                var result = null;
                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validateLegitimacy(invalidFields, userRolesMap, i);
                    if (result.valid) {
                        result = validateFeasibility(invalidFields, userRolesMap, i);
                        if (result.valid) {
                            result = validateCommissionEmendments(invalidFields, i, primaryCommission);//se sono referente
                            if (result.valid) {
                                //result = validateCommissionOpinions(invalidFields, utente, userRolesMap, i, idPrimaCommissione); //Commission Opinions validation disabled as requested by mail from @Caldini in 18/06/19
                                if (result.valid) {
                                    result = validateFinancialCoverage(invalidFields, i, primaryCommission);//se sono referente
                                    if (result.valid) {
                                        result = validateCommissionMessage(invalidFields, i, primaryCommission);//se sono referente
                                    } else {
                                        break;
                                    }
                                } else {
                                    break;
                                }
                            } else {
                                break;
                            }
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                return result;
            }

            function validateCourtroomSections(invalidFields, numeroRinvio) {
                var result;

                for (var i = 0; i <= numeroRinvio; i++) {
                    result = validateCourtroomEmendments(invalidFields, i);
                    if (result.valid) {
                        result = validateCourtroomMeeting(invalidFields, i);
                        if (result.valid) {
                            result = validateCourtroomOutcome(invalidFields, i);
                        } else {
                            break;
                        }
                    } else {
                        break;
                    }
                }
                return result;
            }

            function validatePostCourtroomSections(invalidFields, numeroRinvio) {
                var result = {valid: true, message: '', invalidFields: []};

                for (var i = 0; i <= numeroRinvio; i++) {
                    // result = validatePostCourtroom(invalidFields, i);
                    if (!result.valid) {
                        break;
                    }
                }

                return result;
            }

            function validateLegitimacy(invalidFields, userRolesMap, idx) {
                var sezione = PdlService.getSezioniFromMap('LEGITIMACY', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (userRolesMap.isAdmin || userRolesMap.isLegitimacy) {
                    /*if (metadata.legittimita === null || typeof (metadata.legittimita) === 'undefined') {
                        message += '<li><i>Scheda di legittimità</i> è un campo obbligatorio</li>';
                        invalidFields.push('legittimita' + suffix);
                    } else */if (metadata.legittimita && (metadata.rilieviLegittimita === null || typeof (metadata.rilieviLegittimita) === 'undefined')) {
                        message += '<li><i>Rilievi</i> per scheda di leggittimità è un campo obbligatorio</li>';
                        invalidFields.push('rilieviLegittimita' + suffix);
                    }
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('legitimacy' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateFeasibility(invalidFields, userRolesMap, idx) {
                var sezione = PdlService.getSezioniFromMap('FEASIBILITY', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (userRolesMap.isAdmin || userRolesMap.isFeasibility) {
                    /*if (typeof (metadata.fattibilita) === 'undefined' || metadata.fattibilita === null) {
                        message += '<li><i>Scheda di fattibilità</i> è un campo obbligatorio</li>';
                        invalidFields.push('fattibilita' + suffix);
                    } else */if (metadata.fattibilita && (typeof (metadata.rilieviFattibilita) === 'undefined' || metadata.rilieviFattibilita === null)) {
                        message += '<li><i>Rilievi</i> per scheda di fattibilità è un campo obbligatorio</li>';
                        invalidFields.push('rilieviFattibilita' + suffix);
                    }
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('feasibility' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionMessage(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_MESSAGE', idx);
                if (!sezione || !primaryCommission) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitolo' + suffix);
                } else if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitolo' + suffix);
                }

                if (typeof (metadata.modificaTesto) === 'undefined' || metadata.modificaTesto === null) {
                    message += '<li><i>Modifiche al testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaTesto' + suffix);
                } else if (metadata.modificaTesto && !metadata.tipoModifica) {
                    message += '<li><i>Tipo di modifica</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoModifica' + suffix);
                }

                if (typeof (metadata.propostaRisoluzione) === 'undefined' || metadata.propostaRisoluzione === null) {
                    message += '<li><i>Proposta di risoluzione collegata con riferimento alla commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('propostaRisoluzione' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('commissionMessage' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateFinancialCoverage(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('FINANCIAL_COVERAGE', idx);
                if (!sezione || !primaryCommission) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (typeof (metadata.coperturaRichiesta) === 'undefined' || metadata.coperturaRichiesta === null) {
                    message += '<li><i>Attestazione Copertura Finanziaria - Richiesta</i> è un campo obbligatorio</li>';
                    invalidFields.push('coperturaRichiesta' + suffix);
                } else if (metadata.coperturaRichiesta && (typeof (metadata.coperturaAcquisita) === 'undefined' || metadata.coperturaAcquisita === null)) {
                    message += '<li><i>Attestazione Copertura Finanziaria - Acquisita</i> è un campo obbligatorio</li>';
                    invalidFields.push('coperturaAcquisita' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('financialCoverage' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionEmendments(invalidFields, idx, primaryCommission) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_EMENDMENTS', idx);

                if (!sezione || !primaryCommission) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (metadata.emendamentiPresentatiCommissione) {
                    var i = 0;

                    angular.forEach(metadata.emendamentiPresentati, function (emendment) {
                        if (i > 0
                                //&& (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0) // Validazione eliminata poiche' non e' un metadato piu' trattato: @Caldini richieste data 06/19
                                && !emendment.dataProtocollo
                                // && (!emendment.protocollo || emendment.protocollo.trim().length === 0) // Validazione su protocollo rimossa. @See MAIL 16/07/2018 09.09 FROM Caldini Marco.
                                && (!emendment.firmatari || emendment.firmatari.length === 0)) {
                            //rimuovo eventuali emendamenti lasciati vuoti se sono in più al primo (che deve essere compilato)
                            metadata.emendamentiPresentati.splice(metadata.emendamentiPresentati.indexOf(emendment), 1);
                        } else {
                           /*if (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0) {
                                invalidFields.push('numeroEmendamento' + suffix + '_' + i); // Validazione eliminata poiche' non e' un metadato piu' trattato: @Caldini richieste data 06/19
                            } */
                            if (!emendment.dataProtocollo) {
                                invalidFields.push('dataProtocollo' + suffix + '_' + i);
                            }
                            /* Validazione su protocollo rimossa. @See MAIL 16/07/2018 09.09 FROM Caldini Marco. */
                            /*if (!emendment.protocollo || emendment.protocollo.trim().length === 0) {
                             invalidFields.push('protocollo' + suffix + '_' + i);
                             }*/
                            if (!emendment.firmatari || emendment.firmatari.length === 0) {
                                invalidFields.push('firmatari' + suffix + '_' + i);
                            }
                        }
                        i++;
                    });
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    message += '<li>Uno o più <i>Emendamenti presentati in commissione</i> non sono stati compilati correttamente</li>';
                    $location.hash('commissionEmendments');
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionOpinions(invalidFields, utente, userRolesMap, idx, idPrimaCommissione) {
                var sezione = PdlService.getSezioniFromMap('COMMISSION_OPINIONS', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var assignmentLetterMetadata = PdlService.sezioniMap.ASSIGNMENT_LETTER.metadati;

                var metadatiSezione = sezione.metadati;
                var message = '<ul>';

                if (assignmentLetterMetadata.parereReferente && assignmentLetterMetadata.parereReferente.length
                        && PdlService.isCommissionOpinionEditable(utente, assignmentLetterMetadata.parereReferente, idx, userRolesMap.isAdmin)) {
                    message = validateCommissionOpinion(invalidFields, assignmentLetterMetadata.parereReferente, metadatiSezione.parereReferente, true, message, suffix);
                }

                if (assignmentLetterMetadata.parereSecondario) {
                    for (var i = 0; i < assignmentLetterMetadata.parereSecondario.length; i++) {
                        var opinion = assignmentLetterMetadata.parereSecondario[i];
                        if (PdlService.isCommissionOpinionEditable(utente, [opinion], idx, userRolesMap.isAdmin)) {
                            message = validateCommissionOpinion(invalidFields, [opinion], metadatiSezione.parereSecondario, false, message, suffix);
                        }
                    }
                }

                if (assignmentLetterMetadata.parereObbligatorio) {
                    for (var i = 0; i < assignmentLetterMetadata.parereObbligatorio.length; i++) {
                        var opinion = assignmentLetterMetadata.parereObbligatorio[i];
                        if (PdlService.isExternalSubjectOpionionEditable(utente, [opinion], idx, userRolesMap.isAdmin)) {
                            message = validateCommissionOpinion(invalidFields, [opinion], metadatiSezione.parereObbligatorio, false, message, suffix);
                        }
                    }
                }

                if (assignmentLetterMetadata.osservazioni) {
                    for (var i = 0; i < assignmentLetterMetadata.osservazioni.length; i++) {
                        var opinion = assignmentLetterMetadata.osservazioni[i];
                        if (PdlService.isExternalSubjectOpionionEditable(utente, [opinion], idx, userRolesMap.isAdmin)) {
                            message = validateCommissionOpinion(invalidFields, [opinion], metadatiSezione.osservazioni, false, message, suffix);
                        }
                    }
                }

                if (assignmentLetterMetadata.parereIstituzionale && PdlService.isCommissionOpinionEditable(utente, [idPrimaCommissione], idx, userRolesMap.isAdmin)) {
                    message = validateCommissionOpinion(invalidFields, [idPrimaCommissione], metadatiSezione.parereIstituzionale, false, message, suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('commissionOpinions' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCommissionOpinion(invalidFields, opinionAssignment, opinionMetadata, isJoinedOpinion, message, fieldSuffix) {
                var messageItem = '<li>Ci sono <i>Pareri/Osservazioni</i> non completamente compilati</i>';
                if (!opinionMetadata) {
                    if (isJoinedOpinion) {
                        var subjectCompositeId = '';
                        if (opinionAssignment.length === 1) {
                            subjectCompositeId = opinionAssignment[0];
                        } else {
                            angular.forEach(opinionAssignment, function (subjectId) {
                                subjectCompositeId += '_' + subjectId;
                                message += messageItem;
                                messageItem = '';
                            });
                        }
                        invalidFields.push('data' + fieldSuffix + subjectCompositeId);
                        invalidFields.push('parere' + fieldSuffix + subjectCompositeId);
                        invalidFields.push('tipoFavorevolezza' + fieldSuffix + subjectCompositeId);
                    } else {
                        angular.forEach(opinionAssignment, function (subjectId) {
                            invalidFields.push('data' + fieldSuffix + subjectId);
                            invalidFields.push('parere' + fieldSuffix + subjectId);
                            invalidFields.push('tipoFavorevolezza' + fieldSuffix + subjectId);
                            message += messageItem;
                            messageItem = '';
                        });
                    }
                } else {
                    if (isJoinedOpinion) {
                        var subjectCompositeId = '';
                        if (opinionAssignment.length === 1) {
                            subjectCompositeId = opinionAssignment[0];
                        } else {
                            angular.forEach(opinionAssignment, function (subjectId) {
                                subjectCompositeId += '_' + subjectId;
                                message += messageItem;
                                messageItem = '';
                            });
                        }
                        if (!opinionMetadata.data || !opinionMetadata.data[subjectCompositeId]) {
                            invalidFields.push('data' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                        if (!opinionMetadata.parere || !opinionMetadata.parere[subjectCompositeId]) {
                            invalidFields.push('parere' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                        if (!opinionMetadata.tipoFavorevolezza || !opinionMetadata.tipoFavorevolezza[subjectCompositeId]) {
                            invalidFields.push('tipoFavorevolezza' + fieldSuffix + '_' + subjectCompositeId);
                            message += messageItem;
                            messageItem = '';
                        }
                    } else {
                        angular.forEach(opinionAssignment, function (subjectId) {
                            if (!opinionMetadata.data || !opinionMetadata.data[subjectId]) {
                                invalidFields.push('data' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                            if (!opinionMetadata.parere || !opinionMetadata.parere[subjectId]) {
                                invalidFields.push('parere' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                            if (!opinionMetadata.tipoFavorevolezza || !opinionMetadata.tipoFavorevolezza[subjectId]) {
                                invalidFields.push('tipoFavorevolezza' + fieldSuffix + '_' + subjectId);
                                message += messageItem;
                                messageItem = '';
                            }
                        });
                    }
                }
                return message;
            }

            function validateCourtroomEmendments(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_EMENDMENTS', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                var i = 0;
                angular.forEach(metadata.emendamenti, function (emendment) {
                    if ( //(!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0)
                            !emendment.dataProtocollo
                            //&& (!emendment.protocollo || emendment.protocollo.trim().length === 0)
                            && (!emendment.firmatari || emendment.firmatari.length === 0)
                            /* && !emendment.state */) {
                        //rimuovo eventuali emendamenti lasciati vuoti se sono in più al primo (che deve essere compilato)
                        if (i > 0) {
                            metadata.emendamenti.splice(metadata.emendamenti.indexOf(emendment), 1);
                        }
                    } else {
/*                         if (!emendment.numeroEmendamento || emendment.numeroEmendamento.trim().length === 0) {
                            invalidFields.push('numeroEmendamento' + suffix + '_' + i);
                        } */
                        if (!emendment.dataProtocollo) {
                            invalidFields.push('dataProtocollo' + suffix + '_' + i);
                        }
/*                         if (!emendment.protocollo || emendment.protocollo.trim().length === 0) {
                            invalidFields.push('protocollo' + suffix + '_' + i);
                        } */
                        if (!emendment.firmatari || emendment.firmatari.length === 0) {
                            invalidFields.push('firmatari' + suffix + '_' + i);
                        }
/*                         if (!emendment.state) {
                            invalidFields.push('state' + suffix + '_' + i);
                        } */
                    }
                    i++;
                });
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    message += '<li>Uno o più <i>Emendamenti presentati in aula</i> non sono stati compilati correttamente</li>';
                    $location.hash('courtroomEmendments' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePostCourtroom(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('POST_COURT', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }
                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;
                var message = '<ul>';
                if (!metadata.numeroLeggeAC || metadata.numeroLeggeAC.trim().length === 0) {
                    message += '<li><i>Numero legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroLeggeAC' + suffix);
                }
                if (!metadata.dataLeggeAC) {
                    message += '<li><i>Data legge AC</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataLeggeAC' + suffix);
                }
                message += '</ul>';
                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('postCourtroom' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }
                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validatePresentation(invalidFields, atto) {
                if (!invalidFields)
                    invalidFields = [];

                var message = '<ul>';

                if (!atto.legislatura) {
                    message += '<li><i>Legislatura</i> è un campo obbligatorio</li>';
                    invalidFields.push('legislatura');
                } else if (isNaN(atto.legislatura)) {
                    message += '<li><i>Legislatura</i> contiene un valore non valido</li>';
                    invalidFields.push('legislatura');
                }

                if (!atto.numeroAtto) {
                    message += '<li><i>Numero Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroAtto');
                }

                if (!atto.tipoAtto) {
                    message += '<li><i>Tipo Atto</i> è un campo obbligatorio</li>';
                    invalidFields.push('tipoAtto');
                }

                if (!atto.titolo) {
                    message += '<li><i>Titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('titolo');
                }

                if (!atto.numeroProtocollo) {
                    message += '<li><i>Numero Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('numeroProtocollo');
                } else if (isNaN(atto.numeroProtocollo)) {
                    message += '<li><i>Numero Protocollo</i> contiene un valore non valido</li>';
                    invalidFields.push('numeroProtocollo');
                }

                if (!atto.dataProtocollo) {
                    message += '<li><i>Data Protocollo</i> è un campo obbligatorio</li>';
                    invalidFields.push('dataProtocollo');
                }

                if(atto.tipoAtto === 'PLIP'){
                    if (!atto.proponentiText || atto.proponentiText.length === 0 || atto.proponentiText[0] === '') {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                } else {
                    if (!atto.tipoProponente) {
                        message += '<li><i>Tipo Proponente</i> è un campo obbligatorio</li>';
                        invalidFields.push('tipoProponente');
                    } else if (!atto.proponente.proponenti || atto.proponente.proponenti.length === 0) {
                        message += '<li>Devi specificare almeno un proponente</li>';
                        invalidFields.push('proponenti');
                    }
                }


                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('presentation');
                    $anchorScroll();
                    if (PdlService.sezioniMap.PRESENTATION) {
                        PdlService.sezioniMap.PRESENTATION.visible = true;
                    }
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomMeeting(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_MEETING', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                if (!metadata.sedute || !metadata.sedute[0]) {
                    message += '<li><i>Date sedute:</i> inserire almeno una data</li>';
                    invalidFields.push('sessionsDate' + suffix);
                }

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            function validateCourtroomOutcome(invalidFields, idx) {
                var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', idx);
                if (!sezione) {
                    return {valid: true, message: message, invalidFields: invalidFields};
                }

                var suffix = "";
                if (idx > 0) {
                    suffix += "_" + idx;
                }

                var metadata = sezione.metadati;

                var message = '<ul>';

                //Non sono piu' obbligatori: richiesta del Caldini in data 27/5/2019
/*                 if (typeof (metadata.modificaOggettoTitolo) === 'undefined' || metadata.modificaOggettoTitolo === null) {
                    message += '<li><i>Modifica a titolo della Commissione</i> è un campo obbligatorio</li>';
                    invalidFields.push('modificaOggettoTitoloAula' + suffix);
                } else */ 
                if (metadata.modificaOggettoTitolo && (!metadata.nuovoOggettoTitolo || metadata.nuovoOggettoTitolo.trim().length === 0)) {
                    message += '<li><i>Nuovo titolo</i> è un campo obbligatorio</li>';
                    invalidFields.push('nuovoOggettoTitoloAula' + suffix);
                }
/*                 if (typeof (metadata.coordinamentoTesto) === 'undefined' || metadata.coordinamentoTesto === null) {
                    message += '<li><i>Coordinamento formale testo</i> è un campo obbligatorio</li>';
                    invalidFields.push('coordinamentoTesto' + suffix);
                } */

                message += '</ul>';

                var valid = invalidFields.length === 0;
                if (!valid) {
                    $location.hash('courtroomOutcome' + suffix);
                    $anchorScroll();
                    sezione.visible = true;
                }

                return {valid: valid, message: message, invalidFields: invalidFields};
            }

            // function validateConstitutionalAppeal(invalidFields, idx) {
            //    var sezione = PdlService.getSezioniFromMap('CONSTITUTIONAL_APPEAL', idx);
            //    if (!sezione) {
            //        return {valid: true, message: message};
            //    }
            //    var suffix = "";
            //    if (idx > 0) {
            //        suffix += "_" + idx;
            //    }
            //
            //    var metadata = sezione.metadati;
            //    var message = '<ul>';
            //    if (typeof (metadata.ricorso) === 'undefined' || metadata.ricorso === null) {
            //        message += '<li><i>Ricorso costituzionale</i> è un campo obbligatorio</li>';
            //        invalidFields.push('ricorso' + suffix);
            //    } else if (metadata.ricorso && (!metadata.esitoRicorso || metadata.esitoRicorso.trim().length === 0)) {
            //        message += '<li><i>Esito ricorso istituzionale</i> è un campo obbligatorio</li>';
            //        invalidFields.push('esitoRicorso' + suffix);
            //    }
            //    message += '</ul>';
            //    var valid = invalidFields.length === 0;
            //    if (!valid) {
            //        $location.hash('constitutionalAppeal' + suffix);
            //        $anchorScroll();
            //        sezione.visible = true;
            //    }
            //    return {valid: valid, message: message, invalidFields: invalidFields};
            // }
        }]);
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoLandingPageController', AttoLandingPageController);

        AttoLandingPageController.$inject = ['$state', '$stateParams', '$translate', 'attoParams', 'Atto', 'Principal'];

    /**
     * Landing page created for the integration with Raccolta Normativa
     * They are going to be able to dynamically generate links to Iterlegis atto's
     * by using <NumeroAtto, Data (formato aaaa-mm-gg), TipoAtto>
     * The generated link will be [iterlegis-static-url]/atto-lp?numeroAtto={numeroAtto}&data={data}&tipoAtto={tipoAtto}
     * To identify an Atto all 3 fields are REQUIRED
     * Localhost example: 
     * http://localhost:8081/#/atto-lp?numeroAtto=97&data=2020-12-29&tipoAtto=LR --> 1 result
     * http://localhost:8081/#/atto-lp?numeroAtto=82&data=2020-08-07&tipoAtto=LR --> 2 result
     * @param {*} $state 
     * @param {*} $stateParams 
     * @param {*} $translate 
     */
    function AttoLandingPageController ($state, $stateParams, $translate, attoParams, Atto, Principal) {
        $translate.refresh();

        var vm = this;
        vm.notFound = !attoParams.data || !attoParams.numeroAtto;
        vm.attoParams = attoParams;
        Atto.getLandingPageAtto({data: attoParams.data, tipoAtto: attoParams.tipoAtto, numeroAtto: attoParams.numeroAtto}, 
            function(result) {
                if( result && result.length > 0) {
                    if (result.length === 1) {
                        $state.go('atto-public-detail', {id: result[0].id});
                    } else {
                        var nextState = Principal.isAuthenticated() ? 'home_logged' : 'home'; 
                        $state.go(nextState, {numeroLegge: attoParams.numeroAtto, dataPromulgazione: attoParams.data, legislatura: 'ALL'})
                    }
                    
                } else {
                    vm.notFound = true;
                }
            }, 
            function(error) {
                console.log('Error occurred!');
                vm.notFound = true;
            });

    }
})();
(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AttoInsertController', AttoInsertController);

    AttoInsertController.$inject = ['toastr', 'previousState', 'Atto', 'anagrafiche', '$state', 'direzioni', 'ValidatorFactory', 'ACT_TYPES'];

    function AttoInsertController(toastr, previousState, Atto, anagrafiche, $state, direzioni, ValidatorFactory, ACT_TYPES) {
        var vm = this;
        vm.actTypes = ACT_TYPES;
        vm.assessori = [];
        vm.consiglieri = [];
        vm.direzioni = direzioni;
        vm.gruppiPolitici = [];
        vm.isInsert = true;
        vm.previousState = previousState;
        vm.showConsiglieri = false;

        // Carica gruppi politici per combobox
        Atto.getGruppiPolitici({}, function (data) {
            vm.gruppiPolitici = data || [];
        }, function (error) {
            console.log('Errore nel recupero gruppi politici', error);
        });

        // default
        vm.atto = {
            legislatura: 10,
            tipoAtto: "",
            proponente: {
                proponenti: []
            }
        };

        // If it is an object, it's already a known chip
        vm.sezioniMap = {
            PRESENTATION: {
                visible: true,
                editable: true,
                insert: true
            }
        };

        angular.forEach(anagrafiche, function (anagrafica) {
            if (anagrafica.tipoProponente === "GR") {
                vm.assessori.push(anagrafica);
            } else {
                vm.consiglieri.push(anagrafica);
            }
        });

        vm.searchFirmatari = function (searchText) {
            var lista = null;
            if (vm.atto.tipoProponente === 'GR') {
                lista = vm.assessori;
            } else {
                lista = vm.consiglieri;
            }
            return searchText ? lista.filter(createFilterFor(searchText)) : [];
        };

        vm.searchAssessori = function (searchText) {
            return searchText ? vm.assessori.filter(createFilterFor(searchText)) : [];
        };

        vm.searchConsiglieri = function (searchText) {
            return searchText ? vm.consiglieri.filter(createFilterFor(searchText)) : [];
        };

        vm.addPersonToList = function (chip) {
            // Otherwise, create a new one
            if (angular.isObject(chip)) {
                return chip;
            }
            return {descrizione: chip};

        };

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(firmatario) {
                var codice = firmatario.codice.toLowerCase();
                var descrizione = firmatario.descrizione.toLowerCase();
                return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
            };
        }

        vm.createAtto = function () {
            vm.Validator = ValidatorFactory.getValidator(vm.atto.tipoAtto);
            vm.validating = true;
            var outcome = vm.Validator.validatePresentation([], vm.atto);
            vm.invalidFields = outcome.invalidFields;
            if (outcome.valid) {
                vm.validating = false;
                Atto.save({}, vm.atto, function (result) {
                    toastr.success('Atto creato con successo');
                    vm.atto.id = result.id;
                    Atto.updateProponente({id: vm.atto.id, tipoProponente: vm.atto.tipoProponente}, vm.atto.proponente, function (result) {
                        $state.go('atto-edit', {id: vm.atto.id})
                    }, function (error) {
                        toastr.error('Impossibile effettuare salvataggio atto proponente', 'Errore!', error);
                    });
                }, function (error) {
                    toastr.error('Impossibile creare l\'atto', 'Errore!', error);
                });
            } else {
                toastr.error('Ricontrollare i dati inseriti: ' + outcome.message, "Errore di Validazione!", {
                    timeOut: 60000,
                    extendedTimeOut: 0
                });
            }
        };

        vm.isInvalidField = function (fieldName) {
            if (vm.invalidFields && vm.invalidFields.length > 0) {
                return vm.exists(fieldName, vm.invalidFields);
            }
            return false;
        };

        vm.exists = function (item, list) {
            if (!list || !angular.isArray(list)) {
                list = [];
            }
            return list.indexOf(item) > -1;
        };

        vm.tipoAttoChange = function () {
            if (vm.atto.tipoAtto === 'PDR') {
                vm.tipiProponente = ['GR', 'CR', 'COMMISSIONE'];
            } else if (vm.atto.tipoAtto === 'ODG' || vm.atto.tipoAtto === 'PDRIS') {
                vm.tipiProponente = ['CR', 'COMMISSIONE'];
            } else if (vm.atto.tipoAtto === 'MOZIONE') {
                vm.tipiProponente = ['CR'];
            }
            else if (vm.atto.tipoAtto === 'RINT') {
                vm.tipiProponente = ['CR', 'UP'];
            } else if(vm.atto.tipoAtto === 'REL') {
                vm.tipiProponente = ['ORGANISMI'];
            } else {
                vm.tipiProponente = ['GR', 'CR', 'UP'];
            }
        };

        vm.tipoProponenteChange = function () {
            vm.atto.proponente.proponenti = [];
            if (vm.atto.tipoProponente === 'GR') {
                vm.showConsiglieri = false;
            } else {
                vm.showConsiglieri = true;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoDialogController', AttoDialogController);

    AttoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atto'];

    function AttoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atto) {
        var vm = this;

        vm.atto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.atto.id !== null) {
                Atto.update(vm.atto, onSaveSuccess, onSaveError);
            } else {
                Atto.save(vm.atto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:attoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataProtocollo = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular.module('gestioneAttiApp').controller('AttoDetailController', AttoDetailController);

    AttoDetailController.$inject = ['$rootScope', '$timeout', '$state', 'toastr', 'previousState', 'entity', 'sezioniAtto', 'editable', 'Atto',
        'Principal', 'utente', 'commissioni', 'soggettiEsterni', 'settori', 'gruppiPolitici', 'FileSaver', '$mdDialog', '$mdSidenav', 'docTypes', 'direzioni',
        'User', 'PdlService', 'ValidatorFactory', 'Documento', 'publicView', 'ACT_TYPES', 'enti', 'organi', '$stateParams', '$location', 'AnagraficaProtocollo', 'attoAdditionalMetadata'];

    function AttoDetailController($rootScope, $timeout, $state, toastr, previousState, entity, sezioniAtto, editable, Atto,
            Principal, utente, commissioni, soggettiEsterni, settori, gruppiPolitici, FileSaver, $mdDialog, $mdSidenav, docTypes, direzioni, User, PdlService,
            ValidatorFactory, Documento, publicView, ACT_TYPES, enti, organi, $stateParams, $location, AnagraficaProtocollo, attoAdditionalMetadata) {

        var vm = this;
        //Gestione Esito atto in presentazione per IS
        vm.hideEsitoAttoMedatati = true;
        vm.isCourtOutcomeInPresentationSection = true;
        var opinionTypes = ["REFERENTE", "SECONDARIO", "ISTITUZIONALE", "OBBLIGATORIO", "OSSERVAZIONI"];
        if (entity.tipoAtto === 'PDD') {
            opinionTypes.push("DI_MERITO");
        }

        initController();

        vm.addPersonToList = function (chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {descrizione: chip};
        };

        var confirmTransitionDlg = $mdDialog.confirm()
                .title('Attenzione!')
                .textContent("L'operazione richiesta non è reversibile, sei sicuro di voler procedere?")
                .ariaLabel('conferma transizione di stato')
                .ok('Conferma')
                .cancel('Annulla');

        var statoAuthorities = vm.atto.statoCorrente.statoAtto.roles;
        if (vm.atto.statoCorrente.statoAtto.name === 'COMMISSIONE') {
            statoAuthorities.push('ROLE_EXTERNAL');
        }

        vm.searchFirmatari = function (searchText) {

            if(searchText.length < 3) {
                return [];
            }

            return AnagraficaProtocollo.search(
                {
                    term: searchText,
                    protocolSystem: vm.atto.protocolSystem,
                    tipoAnagrafica: vm.atto.tipoProponente,
                    page: 0,
                    size: 20
                }).$promise.then(onSuccessAnag, onErrorAnag);

/*             if (vm.atto.tipoProponente === 'GR') {
                lista = vm.assessori;
            } else if (vm.atto.tipoProponente === 'COMMISSIONE') {
                lista = vm.commissioni;
            } else {
                lista = vm.consiglieri;
            } */
            /*var lista = vm.anagraficheProtocollo;
            return searchText ? lista.filter(createFilterFor(searchText)) : [];*/
        };

        function onSuccessAnag(data, headers) {
            vm.anagraficheProtocollo = data;
            return vm.anagraficheProtocollo;
        }

        function onErrorAnag(error) {
            console.log("Errore nel recupero anagrafiche!", error);
        }

        vm.searchEnti = function (searchText) {
            return searchText ? vm.enti.filter(createFilterForAnagraficaIterlegis(searchText)) : [];
        };

        vm.searchOrgani = function (searchText) {
            return searchText ? vm.organi.filter(createFilterForAnagraficaIterlegis(searchText)) : [];
        };

        // Se il gruppo è già presente e non è uno di quelli registrati sul backend -> CUSTOM = TRUE
        vm.isGruppoPoliticoCustom = function (idProponente) {
            if(!vm.sezioniMap.PRESENTATION || 
                !vm.sezioniMap.PRESENTATION.metadati || 
                !vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap || 
                !vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[idProponente]) {
                return false;
            }
            var gruppoPresente = vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[idProponente].gruppo;
            var isCustom = true;
            angular.forEach(vm.gruppiPolitici, function(gruppo) {
                if(gruppo.id === gruppoPresente) {
                    isCustom = false;
                }
            });
            return isCustom;
        };

        function createFilterForAnagraficaIterlegis(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(anagrafica) {
                var descrizioneAnagrafica = anagrafica.descrizioneAnagrafica ? anagrafica.descrizioneAnagrafica.toLowerCase() : '';
                return descrizioneAnagrafica.indexOf(lowercaseQuery) >= 0;
            };
        }

        vm.isSectorUserEnabled = function (actions) {
            if (!angular.isArray(actions)) {
                actions = [actions];
            }
            return User.isSectorUserEnabled(vm.utente, actions, vm.azioniSettoriById);
        };

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(firmatario) {
                var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
            };
        }

        // Logica per visualizzare il bottone "Modifica" in alto nel dettaglio atto
        vm.canSeeEditButton = function () {

            // L'amministratore -> VISUALIZZA EDIT BUTTON solo quando è in viewMode (se è già in edit non lo visualizza)
            if (vm.isAdmin || Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'])) return vm.viewMode;
            // Utente cittadino (autenticato con ARPA ma non registrato in Iterlegis) -> NON VISUALIZZARE EDIT BUTTON
            if (Principal.isCitizenUser()) return false;
            // Controlli di base - Se non è viewMode(sono già in editMode) oppure l'utente non è autenticato -> NON VISUALIZZARE EDIT BUTTON
            if (!vm.viewMode || !vm.isAuthenticated) return false;
            // Se l'utente è ENTE_USER -> NON VISUALIZZARE EDIT BUTTON
            if (Principal.isEnteUser(vm.utente, vm.atto.legislatura)) return false;
            // Se l'utente ha solo ROLE_SECTION (oltre ai ruoli ENTE_USER) -> NON VISUALIZZARE EDIT BUTTON
            if (Principal.isOnlyRoleSectionUser(vm.utente, vm.atto.legislatura)) return false;

            // Controllo specifico per commissione
            // Se lo stato è COMMISSIONE e l'utente ha ROLE_COMMISSION ma non è dipendente -> NON VISUALIZZARE EDIT BUTTON
            if (!vm.canCommissionSeeEditButton()) return false;

            // Se non è stato finale -> VISUALIZZA EDIT BUTTON
            if (!vm.atto.statoCorrente.statoAtto.finalState) return true;

            var currentState = vm.atto.statoCorrente.statoAtto.name;
            var tipoAtto = vm.atto.tipoAtto;
            var roles = vm.userRolesMap;

            var result = vm.canSeeEditButtonInFinalState(currentState, tipoAtto, roles);

            return result;

        };

        // Funzione helper per visualizzare il bottone "Modifica" per utenti commissioni
        vm.canCommissionSeeEditButton = function() {
            var isCommissionState = vm.atto.statoCorrente.statoAtto.name === 'COMMISSIONE';
            var isCommissionUser = vm.userRolesMap.isCommissione;
            var isEmployeeRole = User.isCommissionRole(vm.utente, 'Dipendente', vm.atto.legislatura);
            
            // Se non è stato commissione o non è utente commissione -> VISUALIZZA EDIT BUTTON
            if (!isCommissionState || !isCommissionUser) return true;
            
            // Se è stato commissione e utente commissione -> VISUALIZZA EDIT BUTTON (solo se è dipendente)
            return isEmployeeRole;
        };

        // Funzione helper per visualizzare il bottone "Modifica" in stati finali
        vm.canSeeEditButtonInFinalState = function(currentState, tipoAtto, roles) {
            // Utente Aula e Stato APPROVATO -> VISUALIZZA EDIT BUTTON
            if (roles.isAula) {
                if (currentState === 'APPROVATO') return true;
            }
            
            // Settore atti 
            if (roles.isSettoreAtti) {
                // Stato TRASMISSIONE_GIUNTA -> VISUALIZZA EDIT BUTTON
                if (currentState === 'TRASMISSIONE GIUNTA') return true;
                // Stato TRASMISSIONE_GIUNTA -> VISUALIZZA EDIT BUTTON
                if (currentState === 'RITIRATO') return true;
                // Stato TRASFERITA COMPETENZA -> VISUALIZZA EDIT BUTTON
                if (currentState === 'TRASFERITA COMPETENZA') return true;
            } 
            
            // Commissione
            if (roles.isCommissione) {
                // Tipo atto PEA/DEA in Stato TRASMISSIONE_GIUNTA o APPROVATO -> VISUALIZZA EDIT BUTTON
                if (tipoAtto === 'PEA' || tipoAtto === 'DEA') {
                    return currentState === 'TRASMISSIONE GIUNTA' || currentState === 'APPROVATO';
                }
            
                // Tipo atto PDD in Stato APPROVATO -> VISUALIZZA EDIT BUTTON
                if (tipoAtto === 'PDD' && currentState === 'APPROVATO') return true;
            
                // Stato RITIRATO -> VISUALIZZA EDIT BUTTON
                if (currentState === 'RITIRATO') return true;
            }
            
            return false;
        };

        toggleParereSecondario();
        toggleParereDiMerito();

        function canSeeButton(button) {


            // Se non siamo in "Edit mode" -> NON VISIBILE
            if (!editable) {
                return false;
            }

            // Bottone forzatamente nascosto -> NON VISIBILE
            if (button.forceHide) {
                return false;
            }

            // Se è admin lo visualizza sempre
            if (vm.isAdmin) {
                return true;
            }

            // Se il bottone ha una funzione personalizzata per la visibilità -> USA LA FUNZIONE PERSONALIZZATA
            if (button.showFunction) {
                return button.showFunction();
            }

            // Se il bottone è "solo commissione primaria" verifica che l'utente appartenga a quella commissione
            // [ECCEZIONE] Oppure che abbia almeno una delle authority del bottone e l'utente sia SettoreAtti
            if (button.onlyPrimaryCommission) {
                return isVisibleForPrimaryCommission(button);
            } 
            
            // Se il bottone è "solo per soggetti coinvolti" verifica che l'utente appartenga a commissioni o seggetti esterni
            // coinvolti nei pareri della lettera di assegnazione.
            if (button.onlyInvolvedSubjects && vm.sezioniMap.ASSIGNMENT_LETTER) {
                return isVisibleForInvolvedSubjects();
            } 

            return isVisibleForStandardButton(button);
            
        }

        function isVisibleForPrimaryCommission(button) {
            return vm.primaryCommission || 
                (button.authorities && Principal.hasAnyAuthority(button.authorities, vm.atto.legislatura) && vm.userRolesMap.isSettoreAtti);
        }

        function isVisibleForInvolvedSubjects() {
            var assignmentMetadata = vm.sezioniMap.ASSIGNMENT_LETTER.metadati;
            var hasAnyInvolvedCommission = User.hasAnyCommission(vm.utente, assignmentMetadata.parereReferente, vm.atto.legislatura) ||
                                        User.hasAnyCommission(vm.utente, assignmentMetadata.parereSecondario, vm.atto.legislatura) || 
                                        (assignmentMetadata.parereDiMerito && User.hasAnyCommission(vm.utente, assignmentMetadata.parereDiMerito, vm.atto.legislatura));
                                        
            var hasAnyInvolvedExternalSubject = User.hasAnyExternalSubject(vm.utente, assignmentMetadata.parereObbligatorio, vm.atto.legislatura) ||
                                            User.hasAnyExternalSubject(vm.utente, assignmentMetadata.osservazioni, vm.atto.legislatura) || 
                                            (assignmentMetadata.parereIstituzionale && User.hasAnyCommission(vm.utente, [vm.idPrimaCommissione], vm.atto.legislatura));
            
            return hasAnyInvolvedCommission || hasAnyInvolvedExternalSubject;
        }

        function isVisibleForStandardButton(button) {

            var authorities = button.authorities || [];

            var hasRequiredAuthorities = !button.authorities || Principal.hasAnyAuthority(authorities, vm.atto.legislatura);

            var hasSectorCapabilities = !button.sectorCapabilities || User.isSectorUserEnabled(vm.utente, button.sectorCapabilities, vm.azioniSettoriById);
            // Visibile se il bottone non ha restrizioni oppure l'utente ha uno di quei ruoli
            // E si verifica una delle seguenti:
            //      Il Bottone non ha "sectorCapabilities"
            //      L'Utente ha ruolo "ROLE_SETTORE" e ha i permessi presenti in button.sectorCapabilities
            return hasRequiredAuthorities && hasSectorCapabilities;
                        
        }

        function isLegitimacy() {
            return vm.atto.statoCorrente.statoAtto.name === 'COMMISSIONE' && vm.userRolesMap.isLegitimacy;
        }

        function isFeasibility() {
            return vm.atto.statoCorrente.statoAtto.name === 'COMMISSIONE' && vm.userRolesMap.isFeasibility;
        }

        function getOpinionsSubjects(opinionType) {
            if (!vm.sezioniMap.ASSIGNMENT_LETTER) {
                return;
            }

            var selectedSubjectsIds = null;
            var subjects = null;
            var result = [];
            switch (opinionType) {
                case "REFERENTE":
                    selectedSubjectsIds = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente;
                    subjects = vm.commissioni;
                    break;
                case "SECONDARIO":
                    selectedSubjectsIds = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario;
                    subjects = vm.commissioni;
                    break;
                case "ISTITUZIONALE":
                    if (vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereIstituzionale) {
                        selectedSubjectsIds = [vm.idPrimaCommissione];
                        subjects = vm.commissioni;
                    }
                    break;
                case "OBBLIGATORIO":
                    selectedSubjectsIds = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereObbligatorio;
                    subjects = vm.soggettiEsterni;
                    break;
                case "OSSERVAZIONI":
                    selectedSubjectsIds = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.osservazioni;
                    subjects = vm.soggettiEsterni;
                    break;
                case "DI_MERITO":
                    selectedSubjectsIds = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereDiMerito;
                    subjects = vm.commissioni;
                    break;
            }

            if (selectedSubjectsIds && selectedSubjectsIds.length > 0) {
                angular.forEach(subjects, function (subject) {
                    if (selectedSubjectsIds.indexOf(subject.id) > -1) {
                        result.push(subject);
                    }
                });
            }

            return result;
        }

        function draft(state, section) {
            var isArray = section instanceof Array;
            var promise;
            vm.isSaving = true;
            if (vm.isAdmin || vm.userRolesMap.isSettoreAtti) {
                Atto.update(vm.atto, function () {
                    toastr.success('Update atto con successo');
                    if (vm.atto.proponente) {
                        Atto.updateProponente({id: vm.atto.id, tipoProponente: vm.atto.tipoProponente}, vm.atto.proponente, function () {
                            toastr.success('Update atto proponente con successo');
                        }, function (error) {
                            if (vm.atto.tipoAtto !== 'PLIP') {
                                toastr.error('Impossibile effettuare update atto proponente', 'Errore!', error);
                            }
                        });
                    }
                }, function (error) {
                    toastr.error('Impossibile effettuare update atto', 'Errore!', error);
                });
            }

            if (isArray) {
                for (var i = 0; i < section.length; i++) {

                    if (!promise) {
                        promise = Atto.updateSezione(section[i], terminalFunction, terminalFunction).$promise;
                    } else {
                        var funcToApply = function (index) {
                            return function (result) {
                                Atto.updateSezione(section[index], terminalFunction, terminalFunction);
                            };
                        };
                        promise = promise.then(funcToApply(i));
                    }
                }
            } else {
                promise = Atto.updateSezione(section, terminalFunction, terminalFunction).$promise;
            }
            promise = promise.then(function (successData) {
                toastr.success('Sezioni salvate correttamente', 'Okay!');
            }, function (error) {
                toastr.error('Impossibile salvare alcune sezioni: ' + (error ? error.message : 'Errore Sconosciuto'), 'Errore!');

            });

            vm.updateDocuments();

            return promise;
        }

        function terminalFunction(payload) {
            vm.isSaving = false;
        }

        /**
         * From PRESENTATO to COMMISSIONE or AULA (depending on a flag)
         */
        function assign(state, sections) {
            draft(state, sections).then(function (sezione) {
                if(vm.atto.tipoAtto !== 'ODG' && vm.atto.tipoAtto !== 'PDR'){
                    var inAula = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta;
                } else {
                    var inAula = true;
                }
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo(inAula ? 'AULA' : 'COMMISSIONE').then(function (success) {
                        toastr.success('Atto assegnato correttamente', 'Okay!');
                        reloadPage();
                    });
                });
            });

        }

        function saveAndTogglePublish(state, sections) {
            vm.datiPubblici = !vm.datiPubblici;
            angular.forEach(sections, function (sezione) {
                sezione.semprePubblica = vm.datiPubblici;
            });
            draft(state, sections).then(function (sezione) {
                var toastrMsg = 'Dati correttamente ' + (vm.datiPubblici ? 'pubblicati' : 'rimossi dalla pubblicazione');
                toastr.success(toastrMsg, 'Okay!');
                reloadPage();
            });
        }

        function assignToCourtRoom(state, sections) {
            if (!vm.isAdmin && !vm.primaryCommission && !vm.userRolesMap.isSettoreAtti) {
                return;
            }

            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('AULA').then(function (success) {
                        toastr.success('Atto passato correttamente in <b>AULA</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function approve(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('APPROVATO').then(function (success) {
                        toastr.success('Atto <b>approvato</b> con successo', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function decay(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('DECADUTO').then(function (success) {
                        toastr.success('Atto concluso come <b>decaduto</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function toInammissibile(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('INAMMISSIBILE').then(function (success) {
                        toastr.success('Atto concluso come <b>inammissibile</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function unprocessable(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('IMPROCEDIBILE').then(function (success) {
                        toastr.success('Atto concluso come <b>improcedibile</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function withdrawn(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('RITIRATO').then(function (success) {
                        toastr.success('Atto concluso come <b>ritirato</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function toTrasmissioneGiunta(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('TRASMISSIONE_GIUNTA').then(function (success) {
                        toastr.success('Atto concluso come <b>trasmissione giunta</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function toSvolta(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('SVOLTA').then(function (success) {
                        toastr.success('Atto concluso come <b>svolta</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function toRispostaScritta(state, sections) {
            if(vm.atto.statoCorrente.statoAtto.name === 'AULA' && vm.atto.tipoAtto !== 'IO') {
                // var result = vm.Validator.validateEsitoRispostaScritta();
                var result = vm.Validator.validate(state, vm.numeroRinvii, vm.utente, vm.userRolesMap, vm.idPrimaCommissione, null, vm.primaryCommission);
                if(!result.valid){
                    vm.invalidFields = result.invalidFields;
                    toastr.error('Ricontrollare i dati inseriti: ' + result.message, "Errore di Validazione!", {
                        timeOut: 60000,
                        extendedTimeOut: 0
                    });
                    return;
                }
            }
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('RISPOSTA_SCRITTA').then(function (success) {
                        toastr.success('Atto concluso come <b>risposta scritta</b>', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function sendBackToCommission(state, sections) {
            sendBackWithDialog(state, sections, "AULA", "COMMISSIONE");
        }

        function sendToSecondaCommission(state, sections) {
            sendBack(state, sections, "AULA", "COMMISSIONE");
        }

        function saveAndTogglePublicMeeting(state, sections) {
            vm.datiPubblici = !vm.datiPubblici;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].nomeSezione === 'COURT_MEETING') {
                    sections[i].semprePubblica = vm.datiPubblici;
                    break;
                }
            }
            draft(state, sections).then(function (sezione) {
                toastr.success('Date di iscrizione/trattazione correttamente ' + vm.datiPubblici ? 'pubblicate' : 'rimosse dalla pubblicazione', 'Okay!');
                reloadPage();
            });
        }

        function sendBackWithDialog(state, sections, currentState, nextState) {
            $mdDialog.show({
                clickOutsideToClose: false,
                templateUrl: 'app/entities/atto/sezioni/sendBackDate.html',
                controller: ['$scope', '$mdDialog', 'editable', function ($scope, $mdDialog, editable) {
                    $scope.editable = editable;

                    var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', vm.numeroRinvii);
                    if(sezione.metadati.dataRinvio) {
                        $scope.dataRinvio = sezione.metadati.dataRinvio;
                    }

                    $scope.cancel = function () {
                        sezione.metadati.dataRinvio = null;
                        $mdDialog.cancel();
                    };

                    $scope.confirm = function () {
                        if (!$scope.dataRinvio) {
                            toastr.error('Devi specificare la data di rinvio');
                            return;
                        }
                        vm.validating = true;
                        var outcome = vm.Validator.validate(currentState, vm.numeroRinvii, vm.utente, vm.userRolesMap, vm.idPrimaCommissione, null, vm.primaryCommission);
                        vm.invalidFields = outcome.invalidFields;
                        if (!outcome.valid) {
                            toastr.error('Ricontrollare i dati inseriti: ' + outcome.message, "Errore di Validazione!", {
                                timeOut: 60000,
                                extendedTimeOut: 0
                            });
                            return;
                        }
                        vm.validating = false;

                        sezione.metadati.dataRinvio = $scope.dataRinvio;
                        draft(state, sections).then(function (sezione) {
                            $mdDialog.show(confirmTransitionDlg).then(function () {
                                transitionTo(nextState).then(function (success) {
                                    $mdDialog.cancel();
                                    toastr.success('Atto <b>rinviato</b> con successo', 'Okay!');
                                    reloadPage();
                                });
                            });
                        });
                    };

                    $scope.removeDataRinvio = function () {
                        sezione.metadati.dataRinvio = null;
                        $scope.dataRinvio = null;
                    };
                }],
                locals: {
                    editable: editable && (Principal.hasAnyAuthority(statoAuthorities, vm.atto.legislatura) && !vm.atto.statoCorrente.statoAtto.finalState)
                }
            });
        }

        function sendBack(state, sections, currentState, nextState) {
            var sezione = PdlService.getSezioniFromMap('COURT_OUTCOME', vm.numeroRinvii);
            vm.validating = true;
            var outcome = vm.Validator.validate(currentState, vm.numeroRinvii, vm.utente, vm.userRolesMap, vm.idPrimaCommissione, null, vm.primaryCommission);
            vm.invalidFields = outcome.invalidFields;
            if (!outcome.valid) {
                toastr.error('Ricontrollare i dati inseriti: ' + outcome.message, "Errore di Validazione!", {
                    timeOut: 60000,
                    extendedTimeOut: 0
                });
                return;
            }
            vm.validating = false;

            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo(nextState).then(function (success) {
                        $mdDialog.cancel();
                        toastr.success('Atto <b>inviato</b>in seconda lettura con successo', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function reject(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('RESPINTO').then(function (success) {
                        toastr.success('Atto <b>respinto</b> con successo', 'Okay!');
                        reloadPage();
                    });
                });
            });
        }

        function toWithdrawnState(state, sections) {
/*             if(vm.atto.statoCorrente.statoAtto.name === 'AULA'){
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('RITIRATO').then(function (success) {
                        toastr.success('Atto <b>ritirato</b> con successo', 'Okay!');
                        reloadPage();
                    });
                });
            }
            else {*/
            // 2023-10 - Modifica per rimozione data ritiro (non più necessaria)
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('RITIRATO').then(function (success) {
                        toastr.success('Atto <b>ritirato</b> con successo', 'Okay!');
                        reloadPage();
                    });
                });
            });
            /*} 
            withdrawnWithDialog(state, sections, "RITIRATO");*/
        }

        function withdrawnWithDialog(state, sections, nextState) {
            $mdDialog.show({
                clickOutsideToClose: false,
                templateUrl: 'app/components/retiredBlock/ritirato-date-dialog.html',
                controller: ['$scope', '$mdDialog', 'editable', function ($scope, $mdDialog, editable) {
                        $scope.editable = editable;

                        var sezione = PdlService.getSezioniFromMap('PRESENTATION', 0);

                        $scope.cancel = function () {
                            sezione.metadati.dataRitiro = null;
                            $mdDialog.cancel();
                        };

                        $scope.confirm = function () {
                            sezione.metadati.dataRitiro = $scope.dataRitiro;
                            draft(state, sections).then(function (sezione) {
                                $mdDialog.show(confirmTransitionDlg).then(function () {
                                    transitionTo(nextState).then(function (success) {
                                        $mdDialog.cancel();
                                        toastr.success('Atto <b>ritirato</b> con successo', 'Okay!');
                                        reloadPage();
                                    });
                                });
                            });
                        };
                    }],
                locals: {
                    editable: editable && (Principal.hasAnyAuthority(statoAuthorities, vm.atto.legislatura) && !vm.atto.statoCorrente.statoAtto.finalState)
                }
            });
        }

        function toTransferCompetence(state, sections) {
            draft(state, sections).then(function (sezione) {
                $mdDialog.show(confirmTransitionDlg).then(function () {
                    transitionTo('TRASFERITA_COMPETENZA').then(function (success) {
                        toastr.success('Atto passato in fase <b>trasferita competenza</b> con successo', 'Okay!');
                        reloadPage();
                    }, function (error) {
                        toastr.error('Impossibile eseguire il passaggo allo stato <b>TRASFERITA COMPETENZA</b>:<br/>' + error.data.message, 'Errore!');
                    });
                });
            });
        }

        function transitionTo(newState) {
            return Atto.transition({id: vm.atto.id, nextState: newState}, function (outcome) {
            }, function (error) {
                toastr.error('Impossibile eseguire il passaggo allo stato <b>' + newState + '</b>:<br/>' + error.data.message, 'Errore!');
            }).$promise;
        }

        function reloadPage() {
            $timeout(function () {
                $state.reload();
            }, 0);
        }

        function toggle(item, metadata, fieldName, selectionLimit) {
            var list = metadata[fieldName];
            if (!list || !angular.isArray(list)) {
                metadata[fieldName] = [];
                list = metadata[fieldName];
            }

            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                if (selectionLimit && list.length === selectionLimit) {
                    toastr.warning('Sono consentite al massimo ' + selectionLimit + ' scelte');
                } else {
                    list.push(item);
                }
            }
        }

        function toggleParereSecondario() {
            vm.parereSecondarioDisableMap = {};
            toggleMasterSlaveChecks('parereReferente', 'parereSecondario', vm.parereSecondarioDisableMap);
        }

        function toggleParereDiMerito(masterCheck) {
            vm.parereDiMeritoDisableMap = {};
            toggleMasterSlaveChecks(masterCheck, 'parereDiMerito', vm.parereDiMeritoDisableMap);
        }

        function toggleOsservazioni() {
            vm.osservazioniDisableMap = {};
            vm.parereSecondarioDisableMap = {};
            toggleMasterSlaveChecks('parereObbligatorio', 'osservazioni', vm.osservazioniDisableMap);
        }

        function toggleMasterSlaveChecks(masterMetadata, slaveMetadata, disableMap) {
            if (vm.sezioniMap.ASSIGNMENT_LETTER && vm.sezioniMap.ASSIGNMENT_LETTER.metadati[masterMetadata]) {
                angular.forEach(vm.sezioniMap.ASSIGNMENT_LETTER.metadati[masterMetadata], function (entityId) {
                    if (vm.sezioniMap.ASSIGNMENT_LETTER.metadati[slaveMetadata]) {
                        var idx = vm.sezioniMap.ASSIGNMENT_LETTER.metadati[slaveMetadata].indexOf(entityId);
                        if (idx > -1) {
                            vm.sezioniMap.ASSIGNMENT_LETTER.metadati[slaveMetadata].splice(idx, 1);
                        }
                    }
                    disableMap[entityId] = true;
                });
            }
        }

        function toggleParereIstituzionale() {
            if ((vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente.indexOf(vm.idPrimaCommissione) > -1) ||
                    (vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario.indexOf(vm.idPrimaCommissione) > -1)) {
                vm.parereIstituzionaleDisabled = true;
                vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereIstituzionale = false;
            } else if ((!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente || vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente.indexOf(vm.idPrimaCommissione) === -1) &&
                    (!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario || vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario.indexOf(vm.idPrimaCommissione) === -1)) {
                vm.parereIstituzionaleDisabled = false;
            }
        }

        function exists(item, list) {

            if (!list || !angular.isArray(list)) {
                list = [];
            }

            return list.indexOf(item) > -1;
        }

        function performButtonAction(button) {
            var state = button.state;
            if (!state || !button) {
                return;
            }

            toastr.clear();

            var sections = [];

            if (isLegitimacy()) {
                sections = sections.concat(PdlService.getAllRepeatableSectionsByName('LEGITIMACY'));
            } else if (isFeasibility()) {
                sections = sections.concat(PdlService.getAllRepeatableSectionsByName('FEASIBILITY'));
            } else {
                angular.forEach(vm.sezioniMap, function (sezione) {
                    if (vm.isAdmin) {
                        sections.push(sezione);
                    } else if (vm.numeroRinvii === 0 || (sezione.metadati && vm.numeroRinvii === sezione.metadati.numeroRinvio)) {
                        if (sezione.statoAttoAssociato.name === state.name
                                && sezione.nomeSezione !== 'LEGITIMACY'
                                && sezione.nomeSezione !== 'FEASIBILITY') {
                            if (state.name === 'COMMISSIONE') {
                                if (vm.primaryCommission) {
                                    sections.push(sezione);
                                } else if (sezione.nomeSezione === 'COMMISSION_OPINIONS') {
                                    sections.push(sezione);
                                }
                            } else {
                                sections.push(sezione);
                            }
                        } else if (state.name === 'COMMISSIONE'
                                && (sezione.nomeSezione === 'ASSIGNMENT_LETTER' || sezione.nomeSezione === 'PRESENTATION')
                                && vm.userRolesMap.isSettoreAtti) {
                            sections.push(sezione);
                        }  else if(state.name === 'AULA' && sezione.nomeSezione === "ASSIGNMENT_LETTER" && vm.userRolesMap.isAula && vm.atto.tipoAtto === 'MOZIONE' && vm.assignmentLetter.metadati && vm.assignmentLetter.metadati.aulaDiretta) {
                            sections.push(sezione);
                        } else if ((state.name === 'AULA' && sezione.nomeSezione === 'PRESENTATION' && vm.userRolesMap.isSettoreAtti) || (state.name === 'RITIRATO' && sezione.nomeSezione === 'PRESENTATION')) { //ADDED FOR RITIRATO STATE!
                            sections.push(sezione);
                        } else if (((sezione.statoAttoAssociato.finalState && vm.atto.statoCorrente.statoAtto.name === sezione.statoAttoAssociato.name) || (vm.atto.statoCorrente.statoAtto.finalState && sezione.nomeSezione) === "COURT_OUTCOME")  && sezione.editable) {
                            sections.push(sezione);
                        }
                    } else if (state.name === 'COMMISSIONE'
                            && sezione.nomeSezione === 'ASSIGNMENT_LETTER'
                            && (vm.userRolesMap.isSettoreAtti || vm.isAdmin) && (vm.atto.tipoAtto === 'MOZIONE' || vm.atto.tipoAtto === 'ODG' || vm.atto.tipoAtto === 'PDRIS')) {
                        sections.push(sezione);
                    } else if(state.name === 'AULA' && sezione.nomeSezione === "ATTACHED_ACTS_COURTROOM") {
                        sections.push(sezione);
                    } else if(state.name === 'AULA' && sezione.nomeSezione === "ASSIGNMENT_LETTER" && vm.userRolesMap.isAula && vm.atto.tipoAtto === 'MOZIONE') {
                        sections.push(sezione);
                    } else if(sezione.nomeSezione === "PROCEDIMENTO" && vm.atto.statoCorrente.statoAtto.name === 'APPROVATO') {
                        sections.push(sezione);
                    } else if (((sezione.statoAttoAssociato.finalState && vm.atto.statoCorrente.statoAtto.name === sezione.statoAttoAssociato.name) || (vm.atto.statoCorrente.statoAtto.finalState && sezione.nomeSezione) === "COURT_OUTCOME")  && sezione.editable) {
                        sections.push(sezione);
                    }
                });
            }
            // Se stato finale saltiamo la validazione
            if (!button.skipValidation && !vm.atto.statoCorrente.statoAtto.finalState) {
                vm.validating = true;
                var outcome;
                if (vm.userRolesMap.isAdmin || vm.userRolesMap.isSettoreAtti) { // rimuovere settore atti quando sarà presente funzionalità completa import da protocollo
                    outcome = vm.Validator.validatePresentation([], vm.atto);
                    vm.invalidFields = outcome.invalidFields;
                    if (!outcome.valid) {
                        toastr.error('Ricontrollare i dati inseriti: ' + outcome.message, "Errore di Validazione!", {
                            timeOut: 60000,
                            extendedTimeOut: 0
                        });
                        return;
                    }
                }

                outcome = vm.Validator.validate(state.name, vm.numeroRinvii, vm.utente, vm.userRolesMap, vm.idPrimaCommissione, button.action, vm.primaryCommission);
                vm.invalidFields = outcome.invalidFields;
                if (!outcome.valid) {
                    toastr.error('Ricontrollare i dati inseriti: ' + outcome.message, "Errore di Validazione!", {
                        timeOut: 60000,
                        extendedTimeOut: 0
                    });
                    return;
                }

                vm.validating = false;
            }

            if (button.action) {
                button.action(null, sections);
            }

        }

        vm.changeDocumentType = function (doc, newDocumentType) {
            if (!vm.updatedDocsMap) {
                vm.updatedDocsMap = {};
            }
            if (vm.updatedDocsMap[doc.id]) {
                vm.updatedDocsMap[doc.id].newDocumentType = newDocumentType;
            } else {
                vm.updatedDocsMap[doc.id] = {};
                vm.updatedDocsMap[doc.id].document = doc;
                vm.updatedDocsMap[doc.id].newDocumentType = newDocumentType;
            }
        };

        vm.changeDocumentVisibility = function (doc, newDocumentVisibility) {
            if (!vm.updatedDocsMap) {
                vm.updatedDocsMap = {};
            }
            if (vm.updatedDocsMap[doc.id]) {
                vm.updatedDocsMap[doc.id].newDocumentVisibility = newDocumentVisibility;
            } else {
                vm.updatedDocsMap[doc.id] = {};
                vm.updatedDocsMap[doc.id].document = doc;
                vm.updatedDocsMap[doc.id].newDocumentVisibility = newDocumentVisibility;
            }
        };

        vm.changeDocumentFrontpiece = function (doc, frontpiece) {
            if (!vm.updatedDocsMap) {
                vm.updatedDocsMap = {};
            }
            if (vm.updatedDocsMap[doc.id]) {
                vm.updatedDocsMap[doc.id].frontespizio = frontpiece;
            } else {
                vm.updatedDocsMap[doc.id] = {};
                vm.updatedDocsMap[doc.id].document = doc;
                vm.updatedDocsMap[doc.id].frontespizio = frontpiece;
            }
        };

        vm.updateDocuments = function () {
            if (vm.updatedDocsMap) {
                var promise;
                vm.isSaving = true;
                angular.forEach(vm.updatedDocsMap, function (value, key) {
                    // Rinominato per chiarezza e per evitare conflitti con la parola chiave 'document'
                    var documentToUpdate = angular.copy(value.document); 
                    
                    if (value.newDocumentType) {
                        documentToUpdate.tipoDocumento = value.newDocumentType;
                    }
                    if (value.newDocumentVisibility) {
                        documentToUpdate.visibilita = value.newDocumentVisibility;
                    }
                    
                    if (angular.isDefined(value.frontespizio)) {
                        documentToUpdate.frontespizio = value.frontespizio;
                    }
                    if (!promise) {
                        promise = Documento.update(documentToUpdate, terminalFunction, terminalFunction).$promise;
                    } else {
                        var updateDocFuncToApply = function () {
                            return function (result) {
                                Documento.update(documentToUpdate, terminalFunction, terminalFunction);
                            };
                        };
                        promise = promise.then(updateDocFuncToApply());
                    }
                });

                promise = promise.then(function (successData) {
                    toastr.success('Documenti aggiornati', 'Okay!');
                    vm.updateDocsTypeMap = null;
                }, function (error) {
                    toastr.error('Impossibile salvare alcuni documenti: ' + (error ? error.message : 'Errore Sconosciuto'), 'Errore!');

                });
            }
        };

        vm.performProtocolloSave = function () {
            Atto.updateFirmatariProponente({idAtto: vm.atto.id}, vm.atto.proponente.proponenti, function (result) {
                //ignore
            }, function (error) {
                toastr.error('Impossibile aggiornare firmatari atto: ' + (error ? error.message || error.statusText : 'Errore Sconosciuto'), 'Errore!');
            });

            var sections = [];
            if (vm.sezioniMap['COMMISSION_ASSIGNED_EMENDMENTS']) {
                sections.push(vm.sezioniMap['COMMISSION_ASSIGNED_EMENDMENTS']);
            }
            if (vm.sezioniMap['PRESENTATION']) {
                sections.push(vm.sezioniMap['PRESENTATION']);
            }
            sections = sections.concat(PdlService.getAllRepeatableSectionsByName('COMMISSION_EMENDMENTS'));
            sections = sections.concat(PdlService.getAllRepeatableSectionsByName('COURT_EMENDMENTS'));

            return draft(null, sections);
        };

        function downloadArchive(attoId) {
            if (!attoId)
                return;
            vm.loading = true;
            Atto.getArchive(attoId, vm.publicView).then(function (response) {
                if (response && response.data) {
                    FileSaver.saveAs(new Blob([response.data], {}), 'Fascicolo-' + attoId + '.zip');
                }
                vm.loading = false;
            }, function (error) {
                console.log('Impossibile scaricare il fascicolo');
                toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                vm.loading = false;
            });
        }

        vm.isInvalidField = function (fieldName) {
            if (vm.invalidFields && vm.invalidFields.length > 0) {
                return vm.exists(fieldName, vm.invalidFields);
            }
            return false;
        };

        vm.setAttoIdForArchiveTree = function () {
            $rootScope.attoIdForArchiveTree = vm.atto.id;
            vm.attoIdForArchiveTree = vm.atto.id;
            if (!$mdSidenav('right').isOpen()) {
                $mdSidenav('right').open();
            }
        };

        vm.checkShowSection = function (section) {
            var show = false;
            if (section) {
                if (section.nomeSezione === "PRESENTATION" || section.statoAttoAssociato.name === vm.atto.statoCorrente.statoAtto.name) {
                    show = true;
                } else {
                    angular.forEach(section.metadati, function (metadato) {
                        if (metadato) {
                            show = true;
                        } else {
                            for (var key in metadato) {
                                if (!metadato.hasOwnProperty(key)) {
                                    continue;
                                }

                                if (metadato[key]) {
                                    show = true;
                                }
                            }
                        }
                    });
                }
            }

            return show;
        };

        vm.isPddNomina = function() {
            if (vm.sezioniMap.ASSIGNMENT_LETTER && vm.sezioniMap.ASSIGNMENT_LETTER.metadati ) {
                return vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd;
            } else {
                return vm.attoAdditionalMetadata.nominaPdd;
            }
        };

        vm.isAulaDiretta = function() {
            if (vm.sezioniMap.ASSIGNMENT_LETTER && vm.sezioniMap.ASSIGNMENT_LETTER.metadati ) {
                return vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta === true;
            } else {
                return vm.attoAdditionalMetadata.aulaDiretta;
            }
        };

        vm.getIteratoreSezioniRipetibili = function () {
            return new Array(vm.numeroRinvii + 1);
        };


        vm.tipoProponenteChange = function () {
            vm.atto.proponente.proponenti = [];
            if(vm.atto.tipoProponente === 'CR') {
                initProponentiDetails();
            } else {
                clearProponentiDetails();
            }
        };

        vm.openMobileButtons = function () {
            if (!$mdSidenav('buttons-mobile').isOpen()) {
                $mdSidenav('buttons-mobile').open();
            }
        };

        vm.closeMobileButtons = function () {
            $mdSidenav('buttons-mobile').close();
        };

        function isResendableToCommission() {
            var sezione = PdlService.getSezioniFromMap('POST_COURT', vm.numeroRinvii);
            return sezione.metadati.collegioGaranzia === true
                    && sezione.metadati.manifestaInfondatezza === false
                    && sezione.metadati.conformita === false;
        }

        function showTrasferCompetence() {
            var button = this;
            var sezione = PdlService.getSezioniFromMap('ASSIGNMENT_LETTER', 0);
            if (sezione && sezione.metadati && sezione.metadati.isNominaPdd) {
                return showButtonSectorOrCommission(button);
            } else {
                return false;
            }
        }

        function showButtonSectorOrCommission(button) {
            var button;
            if(!button) {
                button = this;
            }
            if (vm.isAdmin) return true;
            // Se i ruoli non sono specificati si ritorna true
            if (!button.authorities) return true;
            // I ruoli sono specificati e l'utente ne ha almeno uno
            if (button.authorities && Principal.hasAnyAuthority(button.authorities, vm.atto.legislatura)) {
                // Se è settore atti
                if(vm.userRolesMap.isSettoreAtti) {
                    // SectorCapabilities non impostati -> true
                    // SectorCapabilities impostati e l'utente ha quei ruoli ->
                    // altrimenti -> false
                    return (!button.sectorCapabilities || User.isSectorUserEnabled(vm.utente, button.sectorCapabilities, vm.azioniSettoriById));

                } else if (vm.userRolesMap.isCommissione){
                    // Se l'utente è di una commissione
                    // Se è abilitato il controllo sulle commissioni "onlyInvolvedSubject" e l'utente appartiene ad una delle commisisoni presenti nella lettera di assegnazione -> true
                    if (button.onlyInvolvedSubjects && vm.sezioniMap.ASSIGNMENT_LETTER) {
                        var assignmentMetadata = vm.sezioniMap.ASSIGNMENT_LETTER.metadati;
                        return User.hasAnyCommission(vm.utente, assignmentMetadata.parereReferente, vm.atto.legislatura)
                                || User.hasAnyCommission(vm.utente, assignmentMetadata.parereSecondario, vm.atto.legislatura)
                                || (assignmentMetadata.parereDiMerito && User.hasAnyCommission(vm.utente, assignmentMetadata.parereDiMerito, vm.atto.legislatura))
                                || User.hasAnyExternalSubject(vm.utente, assignmentMetadata.parereObbligatorio, vm.atto.legislatura)
                                || User.hasAnyExternalSubject(vm.utente, assignmentMetadata.osservazioni, vm.atto.legislatura)
                                || (assignmentMetadata.parereIstituzionale && User.hasAnyCommission(vm.utente, [vm.idPrimaCommissione], vm.atto.legislatura));
                    } else if(!button.onlyInvolvedSubjects) {
                        // Non c'è controllo stretto nelle commissioni -> true
                        return true;
                    } else {
                        // C'è il controllo "onlyInvolvedSubject" ma non c'è la lettera di assegnazione, non si mostra il bottone
                        return false;
                    }
                }

            }
            // Default non si mostra il bottone
            return false;

        }

        function showButtonSectorOrCommissionOrAula(button) {
            var button;
            if(!button) {
                button = this;
            }
            // Verifica i casi Commissione, Settore (include Admin)
            var showButton = showButtonSectorOrCommission(button);
            // Se false prova a valutare il caso "Aula"
            if(!showButton) {
                if(vm.userRolesMap.isAula) {
                    showButton = Principal.hasAnyAuthority(button.authorities, vm.atto.legislatura);
                }
            }
            return showButton;
        }


        function loadButtons() {
            vm.visibleButtons = [];
            angular.forEach(vm.stati, function (stato) {
                if (vm.atto.statoCorrente.statoAtto.name === stato.name) {
                    angular.forEach(stato.buttons, function (button) {
                        if (canSeeButton(button)) {
                            vm.visibleButtons.push(button);
                        }
                        button.state = stato;
                    });
                }
            });
        }

        vm.back = function () {
            var type = "";
            var state = "";
            var term = "";
            var page = "";
            var numeroAttoSearch = "";
            var legislatura = "";
            var idCommissione = "";

            if (sessionStorage.getItem('type') !== "null") {
                type = sessionStorage.getItem('type');
            }
            if (sessionStorage.getItem('state') !== "null") {
                state = sessionStorage.getItem('state');
            }
            if (sessionStorage.getItem('term') !== "null") {
                term = sessionStorage.getItem('term');
            }
            if (sessionStorage.getItem('page') !== "null") {
                page = sessionStorage.getItem('page');
            }
            if (sessionStorage.getItem('numeroAttoSearch') !== "null") {
                numeroAttoSearch = sessionStorage.getItem('numeroAttoSearch');
            }
            if (sessionStorage.getItem('legislatura') !== "null") {
                legislatura = sessionStorage.getItem('legislatura');
            }
            if (sessionStorage.getItem('idCommissione') !== "null") {
                idCommissione = sessionStorage.getItem('idCommissione');
            }
            $state.go(vm.previousState, {type: type, state: state, term: term, page: page, legislatura: legislatura, numeroAttoSearch: numeroAttoSearch, idCommissione: idCommissione});
        };


        function getSoggettoEsternoId(soggettoEsternoName) {
            if(!vm.soggettiEsterni  || vm.soggettiEsterni.length === 0 ) {
                return -1;
            }
            for(var i = 0; i < vm.soggettiEsterni.length; i++) {
                if(soggettiEsterni[i].nome === soggettoEsternoName){
                    return soggettiEsterni[i];
                }
            }
            return -1;
        }

        // ogni volta che viene aggiunto o eliminato un consigliere aggiungerlo/toglierlo dalla tabella!
        function initProponentiDetails() {
            if(!vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap) {
                vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap = {};
            }
            if(vm.atto.proponente && vm.atto.proponente.proponenti) {
                vm.atto.proponente.proponenti.forEach(function(proponente) {
                    var oldProponenteDetail = vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id];
                    if(!oldProponenteDetail) {
                        vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id] = {};
                    }
                });
            }
        }

        function clearProponentiDetails() {
            delete vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap;
        }

        vm.onAddProponente = function($index, $chip){
            if(vm.atto.tipoProponente !== 'CR') {
                return;
            }
            var oldProponenteDetail = vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[$chip.id];
            if(!oldProponenteDetail) {
                vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[$chip.id] = {};
            }
        };

        vm.onRemoveProponente = function($index, $chip, $event) {
            if(vm.atto.tipoProponente !== 'CR') {
                return;
            }
            delete vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[$chip.id];
        };

        function initController() {
            vm.atto = entity;
            vm.attoAdditionalMetadata = attoAdditionalMetadata;
            // Uno dei casi di data 1/1/1000 eliminato
            if(vm.atto.proponente && vm.atto.proponente.dataTrasmissioneGR !== null) {
                var dataGR = new Date(vm.atto.proponente.dataTrasmissioneGR);
                if(dataGR.getFullYear() === 1000) {
                    vm.atto.proponente.dataTrasmissioneGR = null;
                }
            }
            vm.parereSecondarioDisableMap = {};
            vm.parereDiMeritoDisableMap = {};
            if (vm.atto.tipoAtto === 'PDR') {
                vm.tipiProponente = ['GR', 'CR', 'COMMISSIONE'];
            } else if (vm.atto.tipoAtto === 'ODG') {
                vm.tipiProponente = ['CR', 'COMMISSIONE'];
            } else if (vm.atto.tipoAtto === 'MOZIONE' || vm.atto.tipoAtto === 'IO' ||  vm.atto.tipoAtto === 'IS') {
                vm.tipiProponente = ['CR'];
            } else if(vm.atto.tipoAtto === 'CDG' || vm.atto.tipoAtto === 'PEA' || vm.atto.tipoAtto === 'PEL' || vm.atto.tipoAtto === 'IEA' || vm.atto.tipoAtto === 'DEA'){
                vm.tipiProponente = ['GR'];
            } else if(vm.atto.tipoAtto === 'REL'){
                vm.tipiProponente = ['ORGANISMI'];
            } else {
                vm.tipiProponente = ['GR', 'CR', 'UP'];
            }
            vm.organi = organi;
            vm.enti = enti;
            vm.actTypes = ACT_TYPES;
            vm.anagraficheProtocollo = [];
            vm.assessori = [];
            vm.azioniSettoriById = {};
            vm.commissioni = commissioni;
            vm.consiglieri = [];
            vm.direzioni = direzioni;
            vm.docTypes = docTypes;
            vm.gruppiPolitici = gruppiPolitici;
            vm.downloadArchive = downloadArchive;
            vm.exists = exists;
            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.idCommissioneControllo = null;
            vm.idPrimaCommissione = null;
            vm.initDocumentsCheck = PdlService.initDocumentsCheck;
            vm.removeDocumentsCheck = PdlService.removeDocumentsCheck;
            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
            vm.isAuthenticated = Principal.isAuthenticated();
            vm.numeroRinvii = vm.atto.numeroRinvii || 0;
            vm.performButtonAction = performButtonAction;
            //vm.anagrafiche = anagrafiche;
            vm.primaryCommission = false;
            vm.publicView = publicView;
            vm.selectedItem = null;
            vm.selectedProponenteFirmatarioSearchText = '';
            vm.selectedEnteSearchText = '';
            // IO assessore risponde
            vm.selectedAssessoreRisponde = null;
            vm.selectedAssessoreRispondeSearchText = '';
            vm.soggettiEsterni = soggettiEsterni;
            vm.toggle = toggle;
            vm.toggleOsservazioni = toggleOsservazioni;
            vm.toggleParereDiMerito = toggleParereDiMerito;
            vm.toggleParereIstituzionale = toggleParereIstituzionale;
            vm.toggleParereSecondario = toggleParereSecondario;
            vm.utente = utente;
            vm.viewMode = !editable;
            vm.clearRadio = PdlService.clearRadio;

            // probabilmente da rinominare
            vm.isAttoMinore = vm.atto.tipoAtto === 'ODG' || vm.atto.tipoAtto === 'PDRIS' || vm.atto.tipoAtto === 'PDR' || vm.atto.tipoAtto === 'MOZIONE' ? true : false;

            vm.stato = {
                presentato: {
                    isCollapsed: vm.atto.statoCorrente.statoAtto.name === 'PRESENTATO' || vm.viewMode
                }
            };

            vm.Validator = ValidatorFactory.getValidator(entity.tipoAtto);

            angular.forEach(settori, function (settore) {
                vm.azioniSettoriById[settore.id] = settore.azioniAbilitate;
            });

            vm.userSoggettiEsterniMap = {
                isCAL: User.hasAnyExternalSubject(vm.utente, [getSoggettoEsternoId('CAL')], vm.atto.legislatura),
                isCOPAS: User.hasAnyExternalSubject(vm.utente, [getSoggettoEsternoId('COPAS')], vm.atto.legislatura),
                isCRPO: User.hasAnyExternalSubject(vm.utente, [getSoggettoEsternoId('CRPO')], vm.atto.legislatura),
                isCommControllo: User.hasAnyExternalSubject(vm.utente, [getSoggettoEsternoId('Comm. controllo')], vm.atto.legislatura)
            };

            vm.userRolesMap = {
                isAdmin: vm.isAdmin,
                isProtocollo: !vm.isAdmin && Principal.hasAnyAuthority(['ROLE_PROTOCOLLO']),
                isLegitimacy: !vm.isAdmin && User.isSectorUserEnabled(vm.utente, ['LEGITIMACY'], vm.azioniSettoriById),
                isFeasibility: !vm.isAdmin && User.isSectorUserEnabled(vm.utente, ['FEASIBILITY'], vm.azioniSettoriById),
                isSettoreAtti: !vm.isAdmin && User.isSectorUserEnabled(vm.utente, ['GENERAL_SECTIONS'], vm.azioniSettoriById),
                isExternalSubject: !vm.isAdmin && Principal.hasAnyAuthority(['ROLE_EXTERNAL'], vm.atto.legislatura),
                isCommissione: !vm.isAdmin && Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], vm.atto.legislatura),
                isAula: !vm.isAdmin && Principal.hasAnyAuthority(['ROLE_AULA'], vm.atto.legislatura)
            };

            vm.displayProtocolloSaveButton = editable && vm.userRolesMap.isProtocollo;

            /*angular.forEach(anagrafiche, function (anagrafica) {
                if (anagrafica.codice && (!publicView || (publicView && anagrafica.pubblica))) {
                    vm.anagraficheProtocollo.push(anagrafica);
                    if (anagrafica.tipoProponente === "GR") {
                        vm.assessori.push(anagrafica);
                    } else {
                        vm.consiglieri.push(anagrafica);
                    }
                }
            });*/

            for (var i = 0; i < commissioni.length; i++) {
                var commissione = commissioni[i];
                if (commissione.primaCommissione || commissione.nome.toString().trim().toUpperCase() === "PRIMA COMMISSIONE") {
                    vm.idPrimaCommissione = commissione.id;
                } else if (commissione.commissioneDiControllo ||commissione.nome.toString().trim().toUpperCase() === "COMMISSIONE DI CONTROLLO") {
                    vm.idCommissioneControllo = commissione.id;
                }
            }

            if (previousState !== false) {
                if (!previousState.name || previousState.name === $state.name) {
                    vm.previousState = 'home';
                } else {
                    //vm.previousState = previousState.name;
                    vm.previousState = sessionStorage.getItem('fromState');
                }
            }

            vm.sezioni = {
                PRESENTATION: {
                    form: getPresentationForm()
                },
                ASSIGNMENT_LETTER: {
                    form: getAssignmentLetterForm()
                },
                COMMISSION_ASSIGNED_EMENDMENTS: {
                    form: 'app/entities/atto/sezioni/commissionAssignedEmendments.html'
                },
                ISCRIZIONE: {
                    form: 'app/entities/atto/sezioni/iscrizione.html'
                },
                COURT_OUTCOME: {
                    form:  'app/components/courtroomBlock/io.courtroomOutcome.html'
                },
            };

            function getPresentationForm() {
                if(vm.atto.tipoAtto === 'CDG'){
                    return 'app/entities/atto/sezioni/cdg.presentation.html';
                } else if(vm.atto.tipoAtto === 'DEA'){
                    return 'app/entities/atto/sezioni/dea.presentation.html';
                }
                return 'app/entities/atto/sezioni/presentation.html';
            }

            function getAssignmentLetterForm() {
                if(vm.atto.tipoAtto === 'PDLS') {
                    return 'app/entities/atto/sezioni/pdls.assignmentLetter.html';
                } else if(vm.atto.tipoAtto === 'ODG' || vm.atto.tipoAtto === 'PDR' || vm.atto.tipoAtto === "MOZIONE"  || vm.atto.tipoAtto === 'PDRIS'){
                    vm.actType = vm.atto.tipoAtto;
                    return 'app/entities/atto/sezioni/onlyReferente.assignmentLetter.html';
                }else if(vm.atto.tipoAtto === 'PEA' || vm.atto.tipoAtto === 'PEL' || vm.atto.tipoAtto === 'DEA'){
                    return 'app/entities/atto/sezioni/pea.assignmentLetter.html';
                } else if(vm.atto.tipoAtto === 'IO'){
                    return 'app/entities/atto/sezioni/io.assignmentLetter.html';
                }else if(vm.atto.tipoAtto === 'IEA'){
                    return 'app/entities/atto/sezioni/iea.assignmentLetter.html';
                } else if(vm.atto.tipoAtto === 'REL') {
                    return 'app/entities/atto/sezioni/rel.assignmentLetter.html';
                }
                else if(vm.atto.tipoAtto === 'RINT') {
                    return 'app/entities/atto/sezioni/rint.assignmentLetter.html';
                }
                else {
                    return 'app/entities/atto/sezioni/assignmentLetter.html';
                }
            }

            vm.getAssignmentLetter = function() {
                if(vm.atto.tipoAtto === 'ODG' || vm.atto.tipoAtto === 'PDR' || vm.atto.tipoAtto === "MOZIONE" || vm.atto.tipoAtto === 'PDRIS') {
                    return vm.getSezioniFromMap('ASSIGNMENT_LETTER', 0);
                }
            };

            if (!vm.atto.proponente) {
                vm.atto.proponente = {
                    proponenti: []
                };
            } else if (!vm.atto.proponente.proponenti) {
                vm.atto.proponente.proponenti = [];
            }

            // load sezioni of atto
            PdlService.loadSezioni(vm.atto, sezioniAtto, vm.numeroRinvii, vm.userRolesMap, editable, vm.utente, vm.idPrimaCommissione, vm.publicView, vm.userSoggettiEsterniMap);
            PdlService.initDateRinvio(vm.atto);

            vm.datiPubblici = PdlService.datiPubblici;
            vm.primaryCommission = PdlService.primaryCommission;
            vm.sezioniMap = PdlService.sezioniMap;
            vm.assignmentLetter = vm.sezioniMap.ASSIGNMENT_LETTER;
            vm.workDocumentsMap = PdlService.workDocumentsMap;
            vm.dateRinvio = PdlService.dateRinvio;

            if(vm.atto.tipoAtto === 'PDD' && vm.sezioniMap.ASSIGNMENT_LETTER && vm.sezioniMap.ASSIGNMENT_LETTER.metadati && !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.enti) {
                vm.sezioniMap.ASSIGNMENT_LETTER.metadati.enti = [];
            }
            if(vm.atto.tipoAtto === 'PDD' && vm.sezioniMap.ASSIGNMENT_LETTER && vm.sezioniMap.ASSIGNMENT_LETTER.metadati &&  !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.organi) {
                vm.sezioniMap.ASSIGNMENT_LETTER.metadati.organi = [];
            }
            if(vm.atto.tipoAtto === 'IO' || vm.atto.tipoAtto === 'IS') {
                setDataDecadenza();
            }

            vm.soggettiOpinioni = {};
            angular.forEach(opinionTypes, function (opinionType) {
                vm.soggettiOpinioni[opinionType] = getOpinionsSubjects(opinionType);
            });


            vm.stati = initializaButtons(entity.tipoAtto);
            loadButtons();

            // Tabella firmatari
            if(vm.atto.tipoProponente === 'CR') {
                //Se non lo sono, inizializzo i dettagli dei proponenti
                initProponentiDetails();
            }

            manageDocumentAnchor();
        }


        function manageDocumentAnchor() {
            var sectionId = $stateParams.sectionId;
            if(!sectionId || sectionId === '') {
                console.log('Nessun sectionId trovato nei parametri');
                return;
            }
            // pulisco l'url dai paramentri di anchor
            $location.search('sectionId', null);
            var targetSectionId = sectionId;
            var sectionkeys = Object.keys(vm.sezioniMap);
            var targetSection = null;
            for(var i = 0; i < sectionkeys.length; i++) {
                if(vm.sezioniMap[sectionkeys[i]].id === targetSectionId) {
                    targetSection = vm.sezioniMap[sectionkeys[i]];
                    break;
                }
            }
            if(!targetSection) {
                console.log('Some error occurred during anchoring to a document');
                return;
            }
            // Setting up a flag so in the documentToolbar we can anchor to the documents
            targetSection.anchorToDocuments = true;
        }

        function getSendBackToCommissionTitle() {
            if(!vm.isAttoMinore) {
                return 'entity.action.sendBackToCommission';
            } else {
                if(!entity.numeroRinvii || entity.numeroRinvii === 0){
                    return 'entity.action.sendToCommission';
                } else {
                    return 'entity.action.sendBackToCommission';
                }
            }
        }


        function initializaButtons(tipoAtto) {
            var buttons = [];

            buttons.push({
                name: 'PRESENTATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.assignment.inviaCommissione',
                        action: assign,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });

            buttons.push({
                name: 'COMMISSIONE',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.save',
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['LEGITIMACY', 'FEASIBILITY', 'GENERAL_SECTIONS']
                    },
                    {
                        title: vm.datiPubblici ? 'gestioneAttiApp.form.commission.salvaDepubblica' : 'gestioneAttiApp.form.commission.salvaPubblica',
                        action: saveAndTogglePublish,
                        skipValidation: true, //vm.datiPubblici,
                        iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                        onlyPrimaryCommission: true,
                        authorities: ['ROLE_COMMISSIONE']
                    },
                    {
                        title: 'gestioneAttiApp.form.commission.inviaAula',
                        action: assignToCourtRoom,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_COMMISSIONE', 'ROLE_SETTORE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE', 'ROLE_COMMISSIONE'],
                        sectorCapabilities: ['GENERAL_SECTIONS'],
                        onlyInvolvedSubjects: true
                    }
                ]
            });



            if (tipoAtto === "PDLS") {

                buttons.push({
                    name: 'AULA',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            skipValidation: true,
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.reject',
                            action: reject,
                            skipValidation: true,
                            iconClass: 'glyphicon-remove-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: (entity.numeroRinvii % 2) ? 'entity.action.approve' : 'entity.action.sendToSecondaCommissione',
                            action: (entity.numeroRinvii % 2) ? approve : sendToSecondaCommission,
                            iconClass: 'glyphicon-ok-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.decayed',
                            action: decay,
                            skipValidation: true,
                            iconClass: 'glyphicon-thumbs-down',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.unprocessable',
                            action: unprocessable,
                            skipValidation: true,
                            iconClass: 'glyphicon-ban-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.withdrawn',
                            action: withdrawn,
                            skipValidation: true,
                            iconClass: 'glyphicon-paperclip',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.withdrawn',
                            action: toWithdrawnState,
                            iconClass: 'glyphicon-inbox',
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE'],
                            sectorCapabilities: ['GENERAL_SECTIONS']
                        }
                    ]
                });

                if (entity.numeroRinvii % 2) {
                    buttons[buttons.length - 1].buttons.push(
                        {
                            title: 'entity.action.sendBackToFirstLevelCommission',
                            action: sendBackToCommission,
                            iconClass: 'glyphicon-ok-circle',
                            authorities: ['ROLE_AULA']
                        }
                    );
                }
            } else {

                buttons.push({
                    name: 'AULA',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            skipValidation: true,
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.reject',
                            action: reject,
                            skipValidation: true,
                            iconClass: 'glyphicon-remove-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.approve',
                            action: approve,
                            skipValidation: true,
                            iconClass: 'glyphicon-ok-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: vm.datiPubblici ? 'entity.action.depublishMeeting' : 'entity.action.publishMeeting',
                            action: saveAndTogglePublicMeeting,
                            skipValidation: true,
                            iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.decayed',
                            action: decay,
                            skipValidation: true,
                            iconClass: 'glyphicon-thumbs-down',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.unprocessable',
                            action: unprocessable,
                            skipValidation: true,
                            iconClass: 'glyphicon-ban-circle',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: getSendBackToCommissionTitle(),
                            action: sendBackToCommission,
                            iconClass: 'glyphicon-paperclip',
                            authorities: ['ROLE_AULA']
                        },
                        {
                            title: 'entity.action.withdrawn',
                            action: toWithdrawnState,
                            iconClass: 'glyphicon-inbox',
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE', 'ROLE_AULA'],
                        }
                    ]
                });
            }

            buttons.push({
                name: 'APPROVATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.sendBackToCommission',
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA'],
                        showFunction: isResendableToCommission
                    }]
            });

            //ODG BUTTONS
            if(vm.atto.tipoAtto === 'ODG'){
                buttons = getOdgButtons();
            }
            //MOZIONE BUTTONS
            if(vm.atto.tipoAtto === 'MOZIONE'){
                buttons = getMozioneButtons();
            }
            //PEA BUTTONS
            if(vm.atto.tipoAtto === 'PEA'){
                buttons = getPeaButtons();
            }
            //IEA BUTTONS
            if(vm.atto.tipoAtto === 'IEA'){
                buttons = getIeaButtons();
            }
            //PEL/DEA BUTTONS
            if(vm.atto.tipoAtto === 'PEL' || vm.atto.tipoAtto === 'DEA'){
                buttons = getPelButtons();
            }
            //IS BUTTONS
            if(vm.atto.tipoAtto === 'IS'){
                buttons = getIsButtons();
            }
            //CDG BUTTONS
            if(vm.atto.tipoAtto === 'CDG'){
                buttons = getCdgButtons();
            }
            //PDRIS BUTTONS
            if(vm.atto.tipoAtto === 'PDRIS'){
                buttons = getPdrisButtons();
            }
            //IO BUTTONS
            if(vm.atto.tipoAtto === 'IO') {
                buttons = getIOButtons();
            }
            //REL BUTTONS
            if(vm.atto.tipoAtto === 'REL') {
                buttons = getRELButtons();
            }
            //PDD BUTTONS
            if(tipoAtto === 'PDD') {
                buttons = getPDDButtons();
                // 2023-11-03- Spostato in getPDDButtons();
                // Ticket#943867: Nella fase APPROVATO, anche un utente con ROLE_COMMISSIONE, oltre a ROLE_AULA deve poter salvare la sezione PROCEDIMENTO
                // var buttonApprovato = buttons.find(function(buttonStato){return buttonStato.name === 'APPROVATO'});
                // buttonApprovato.buttons = buttonApprovato.buttons.filter(function(button){return button.title !== 'entity.action.save'});
                // buttonApprovato.buttons.push(
                //     {
                //         title: 'entity.action.save',
                //         action: draft,
                //         authorities: ['ROLE_AULA', 'ROLE_COMMISSIONE']
                //     }
                // );
            }

            addFinalStateButtons(buttons);
            return buttons;
        }

        function addFinalStateButtons(buttons) {
            var finalStates = ['IMPROCEDIBILE', 'DECADUTO', 'INAMMISSIBILE', 'RESPINTO', 'RITIRATO'];

            for(var i = 0 ; i < finalStates.length; i++) {
                if(finalStates[i] === "RITIRATO") {
                    buttons.push({
                        name: finalStates[i],
                        buttons: [
                            {
                                title: 'entity.action.save',
                                action: draft,
                                showFunction: showButtonSectorOrCommissionOrAula,
                                skipValidation: true,
                                authorities: ['ROLE_SETTORE', 'ROLE_AULA', 'ROLE_COMMISSIONE'],
                                sectorCapabilities: ['GENERAL_SECTIONS']
                            }
                        ]
                    });
                } else {
                    buttons.push({
                        name: finalStates[i],
                        buttons: [
                            {
                                title: 'entity.action.save',
                                action: draft,
                                skipValidation: true,
                                authorities: ['ROLE_SETTORE', 'ROLE_AULA'],
                                sectorCapabilities: ['GENERAL_SECTIONS']
                            }
                        ]
                    });
                }
            }
        }

        function getOdgButtons() {
            var buttons = [];
            buttons.push({
                name: 'PRESENTATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.assignment.inviaCommissione',
                        action: assign,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'entity.action.inammissibile',
                        action: toInammissibile,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });

            buttons.push({
                name: 'COMMISSIONE',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.save',
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['LEGITIMACY', 'FEASIBILITY', 'GENERAL_SECTIONS']
                    },
                    {
                        title: vm.datiPubblici ? 'gestioneAttiApp.form.commission.salvaDepubblica' : 'gestioneAttiApp.form.commission.salvaPubblica',
                        action: saveAndTogglePublish,
                        skipValidation: true, //vm.datiPubblici,
                        iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                        onlyPrimaryCommission: true,
                        authorities: ['ROLE_COMMISSIONE']
                    },
                    {
                        title: 'gestioneAttiApp.form.commission.inviaAula',
                        action: assignToCourtRoom,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_COMMISSIONE', 'ROLE_SETTORE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.approve",
                        action: approve,
                        iconClass: "glyphicon-ok-circle",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE', 'ROLE_COMMISSIONE'],
                        sectorCapabilities: ['GENERAL_SECTIONS'],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.decayed',
                        action: decay,
                        skipValidation: true,
                        iconClass: 'glyphicon-thumbs-down',
                        authorities: ['ROLE_COMMISSIONE'],
                        onlyInvolvedSubjects: true
                    }
                ]
            });

            buttons.push({
                name: 'AULA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.reject',
                        action: reject,
                        skipValidation: true,
                        iconClass: 'glyphicon-remove-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.approve',
                        action: approve,
                        skipValidation: true,
                        iconClass: 'glyphicon-ok-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: vm.datiPubblici ? 'entity.action.depublishMeeting' : 'entity.action.publishMeeting',
                        action: saveAndTogglePublicMeeting,
                        skipValidation: true,
                        iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.decayed',
                        action: decay,
                        skipValidation: true,
                        iconClass: 'glyphicon-thumbs-down',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.unprocessable',
                        action: unprocessable,
                        skipValidation: true,
                        iconClass: 'glyphicon-ban-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: getSendBackToCommissionTitle(),
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE', 'ROLE_AULA'],
                    }
                ]
            });

            buttons.push({
                name: 'APPROVATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_COMMISSIONE']
                    },
                    {
                        title: 'entity.action.sendBackToCommission',
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA'],
                        showFunction: isResendableToCommission
                    }]
            });
            return buttons;
        }

        function getCdgButtons() {
            var buttons = [];
                buttons.push({
                    name: 'PRESENTATO',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE'],
                            sectorCapabilities: ['GENERAL_SECTIONS']
                        },
                        {
                            title: 'gestioneAttiApp.form.commission.inviaAula',
                            action: assignToCourtRoom,
                            iconClass: 'glyphicon-send',
                            authorities: ['ROLE_SETTORE'],
                            sectorCapabilities: ['GENERAL_SECTIONS']
                        },
                        {
                            title: 'entity.action.withdrawn',
                            action: toWithdrawnState,
                            iconClass: 'glyphicon-inbox',
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE'],
                            sectorCapabilities: ['GENERAL_SECTIONS']
                        },
                        {
                            title: 'entity.action.decayed',
                            action: decay,
                            skipValidation: true,
                            iconClass: 'glyphicon-thumbs-down',
                            authorities: ['ROLE_SETTORE']
                        }
                    ]
                });
                buttons.push({
                    name: 'AULA',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            skipValidation: true,
                            authorities: ['ROLE_AULA']
                        },
/*                         {
                            title: 'entity.action.decayed',
                            action: decay,
                            skipValidation: true,
                            iconClass: 'glyphicon-thumbs-down',
                            authorities: ['ROLE_AULA']
                        }, */
                        {
                            title: 'entity.action.withdrawn',
                            action: toWithdrawnState,
                            iconClass: 'glyphicon-inbox',
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE', 'ROLE_AULA'],
                            // sectorCapabilities: ['GENERAL_SECTIONS']
                        },
                        {
                            title: 'entity.action.svolta',
                            action: toSvolta,
                            iconClass: 'glyphicon-remove-circle',
                            authorities: ['ROLE_AULA']
                        }
                    ]
                });
                buttons.push({
                    name: 'TRASMISSIONE GIUNTA',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            skipValidation: true,
                            authorities: ['ROLE_SETTORE'],
                            sectorCapabilities: ['GENERAL_SECTIONS']
                        }
                    ]
                });
                buttons.push({
                    name: 'SVOLTA',
                    buttons: [
                        {
                            title: 'entity.action.save',
                            action: draft,
                            authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                        }
                    ]});
            return buttons;
        }
        function getPdrisButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "gestioneAttiApp.form.commission.inviaAula",
                        action: assignToCourtRoom,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    }
                ]
            });
            buttons.push({
                name: 'COMMISSIONE',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.save',
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['LEGITIMACY', 'FEASIBILITY', 'GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.commission.inviaAula',
                        action: assignToCourtRoom,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.reject',
                        action: reject,
                        skipValidation: true,
                        iconClass: 'glyphicon-remove-circle',
                        authorities: ['ROLE_COMMISSIONE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.approve',
                        action: approve,
                        iconClass: 'glyphicon-ok-circle',
                        authorities: ['ROLE_COMMISSIONE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.decayed',
                        action: decay,
                        iconClass: 'glyphicon-thumbs-down',
                        authorities: ['ROLE_COMMISSIONE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS'],
                        onlyPrimaryCommission: true
                    }
                ]
            });
            buttons.push({
                name: "AULA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: getSendBackToCommissionTitle(),
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: "entity.action.approve",
                        action: approve,
                        skipValidation: true,
                        iconClass: "glyphicon-ok-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE", "ROLE_AULA"]
                    },
                    {
                        title: "entity.action.reject",
                        action: reject,
                        skipValidation: true,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    }
                ]
            });
            buttons.push({
                name: "APPROVATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE", "ROLE_AULA", 'ROLE_COMMISSIONE']
                    }
                ]
            });
            return buttons;
        }
        function getIsButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.commission.inviaAula",
                        action: assignToCourtRoom,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_SETTORE"]
                    },
                    {
                        title: "entity.action.rispostaScritta",
                        action: toRispostaScritta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_SETTORE"]
                    },
                    {
                        title: 'entity.action.inammissibile',
                        action: toInammissibile,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });

            buttons.push({
                name: "AULA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.rispostaScritta",
                        action: toRispostaScritta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    }
                ]
            });

            buttons.push({
                name: 'RISPOSTA_SCRITTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            buttons.push({
                name: 'SVOLTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            return buttons;
        }

        function getIOButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.assignment.inviaCommissione",
                        action: assign,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        skipValidation: true,
                        iconClass: "glyphicon-inbox",
                        //skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    },
                    {
                        title: 'entity.action.inammissibile',
                        action: toInammissibile,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });
            buttons.push({
                name: "COMMISSIONE",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation:
                            vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.save",
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: [
                            "LEGITIMACY",
                            "FEASIBILITY",
                            "GENERAL_SECTIONS"
                        ]
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.rispostaScritta",
                        action: toRispostaScritta,
                        iconClass: "glyphicon-remove-circle",
                        skipValidation: true,
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "gestioneAttiApp.form.commission.inviaAula",
                        action: assignToCourtRoom,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: [
                            "ROLE_SETTORE",
                            "ROLE_COMMISSIONE"
                        ],
                        sectorCapabilities: ["GENERAL_SECTIONS"],
                        onlyInvolvedSubjects: true
                    }
                ]
            });
            buttons.push({
                name: "AULA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.rispostaScritta",
                        action: toRispostaScritta,
                        skipValidation: true,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    }
                ]
            });

            buttons.push({
                name: "APPROVATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.sendBackToCommission",
                        action: sendBackToCommission,
                        iconClass: "glyphicon-paperclip",
                        authorities: ["ROLE_AULA"],
                        showFunction: isResendableToCommission
                    }
                ]
            });
            buttons.push({
                name: 'RISPOSTA_SCRITTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            buttons.push({
                name: 'SVOLTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            return buttons;
        }

        function getPelButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.assignment.inviaCommissione",
                        action: assign,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    }
                ]
            });
            buttons.push({
                name: "COMMISSIONE",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation:
                            vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.save",
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: [
                            "LEGITIMACY",
                            "FEASIBILITY",
                            "GENERAL_SECTIONS"
                        ]
                    },
                    {
                        title: "entity.action.trasmissioneGiunta",
                        action: toTrasmissioneGiunta,
                        iconClass: "glyphicon-send",
                        //skipValidation: true,
                        authorities: [
                            "ROLE_COMMISSIONE",
                            "ROLE_SETTORE"
                        ],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: [
                            "ROLE_SETTORE",
                            "ROLE_COMMISSIONE"
                        ],
                        sectorCapabilities: ["GENERAL_SECTIONS"],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    }
                ]
            });
            if(vm.atto.tipoAtto === 'DEA') {
                buttons.push({
                    name: "TRASMISSIONE GIUNTA",
                    buttons: [
                        {
                            title: "entity.action.save",
                            action: draft,
                            skipValidation: true,
                            showFunction: showButtonSectorOrCommission,
                            authorities: ["ROLE_SETTORE", "ROLE_COMMISSIONE"],
                            sectorCapabilities: ["GENERAL_SECTIONS"],
                            onlyInvolvedSubjects: true
                        }
                    ]
                });
            } else {
                buttons.push({
                    name: "TRASMISSIONE GIUNTA",
                    buttons: [
                        {
                            title: "entity.action.save",
                            action: draft,
                            skipValidation: true,
                            authorities: ["ROLE_SETTORE"],
                            sectorCapabilities: ["GENERAL_SECTIONS"]
                        }
                    ]
                });
            }
            return buttons;
        }

        function getIeaButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.assignment.inviaCommissione",
                        action: assign,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    }
                ]
            });
            buttons.push({
                name: "COMMISSIONE",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation:
                            vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.save",
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: [
                            "LEGITIMACY",
                            "FEASIBILITY",
                            "GENERAL_SECTIONS"
                        ]
                    },
                    {
                        title: "entity.action.trasmissioneGiunta",
                        action: toTrasmissioneGiunta,
                        iconClass: "glyphicon-send",
                        //skipValidation: true,
                        authorities: [
                            "ROLE_COMMISSIONE",
                            "ROLE_SETTORE"
                        ],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: [
                            "ROLE_SETTORE",
                            "ROLE_COMMISSIONE"
                        ],
                        sectorCapabilities: ["GENERAL_SECTIONS"],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        iconClass: "glyphicon-remove-circle",
                        skipValidation: true,
                        authorities: [
                            "ROLE_SETTORE",
                            "ROLE_COMMISSIONE"
                        ],
                        onlyInvolvedSubjects: true
                    }
                ]
            });
            buttons.push({
                name: "AULA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_AULA"]
                    },
                    /*                         {
                            title: 'entity.action.reject',
                            action: reject,
                            skipValidation: true,
                            iconClass: 'glyphicon-remove-circle',
                            authorities: ['ROLE_AULA']
                        }, */
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE", "ROLE_AULA"]
                    },
                    {
                        title: "entity.action.trasmissioneGiunta",
                        action: toTrasmissioneGiunta,
                        iconClass: "glyphicon-send",
                        //skipValidation: true,
                        authorities: [
                            "ROLE_COMMISSIONE",
                            "ROLE_SETTORE"
                        ],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.svolta",
                        action: toSvolta,
                        skipValidation: true,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_SETTORE", "ROLE_AULA"]
                    }
                ]
            });
            buttons.push({
                name: "TRASMISSIONE GIUNTA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    }
                ]
            });
            return buttons;
        }

        function getPeaButtons() {
            var buttons = [];
            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.assignment.inviaCommissione",
                        action: assign,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_SETTORE"]
                    }
                ]
            });
            buttons.push({
                name: "COMMISSIONE",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation:
                            vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.save",
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: [
                            "LEGITIMACY",
                            "FEASIBILITY",
                            "GENERAL_SECTIONS"
                        ]
                    },
                    {
                        title: "entity.action.trasmissioneGiunta",
                        action: toTrasmissioneGiunta,
                        iconClass: "glyphicon-send",
                        //skipValidation: true,
                        authorities: [
                            "ROLE_COMMISSIONE",
                            "ROLE_SETTORE"
                        ],
                        onlyInvolvedSubjects: true
                    }
                    /*                         {
                        title: 'entity.action.chiusuraProcedimento',
                        action: approve,
                        skipValidation: true,
                        iconClass: 'glyphicon-ok-circle',
                        authorities: ['ROLE_COMMISSIONE'],
                        onlyInvolvedSubjects: true
                    } */
                ]
            });
            buttons.push({
                name: "TRASMISSIONE GIUNTA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE",
                        "ROLE_COMMISSIONE"]
                        //sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.chiusuraProcedimento",
                        action: approve,
                        skipValidation: true,
                        iconClass: "glyphicon-ok-circle",
                        authorities: ["ROLE_SETTORE",
                                    "ROLE_COMMISSIONE"]
                    }
                ]
            });
            buttons.push({
                name: "APPROVATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        authorities: ["ROLE_SETTORE",
                                    "ROLE_COMMISSIONE"]
                    }
                ]
            });
            return buttons;
        }

        function getMozioneButtons() {
            var buttons = [];

            buttons.push({
                name: "PRESENTATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.assignment.inviaCommissione",
                        action: assign,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        skipValidation: true,
                        iconClass: "glyphicon-inbox",
                        //skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"]
                    },
                    {
                        title: 'entity.action.inammissibile',
                        action: toInammissibile,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        //skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });

            buttons.push({
                name: "COMMISSIONE",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation:
                            vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: "entity.action.save",
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: [
                            "LEGITIMACY",
                            "FEASIBILITY",
                            "GENERAL_SECTIONS"
                        ]
                    },
                    {
                        title:
                            "gestioneAttiApp.form.commission.inviaAula",
                        action: assignToCourtRoom,
                        iconClass: "glyphicon-send",
                        authorities: ["ROLE_SETTORE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.reject",
                        action: reject,
                        skipValidation: true,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.approve",
                        action: approve,
                        iconClass: "glyphicon-ok-circle",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_COMMISSIONE"],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE"],
                        sectorCapabilities: ["GENERAL_SECTIONS"],
                        onlyPrimaryCommission: true
                    }
                ]
            });

            buttons.push({
                name: "AULA",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        skipValidation: true,
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.reject",
                        action: reject,
                        skipValidation: true,
                        iconClass: "glyphicon-remove-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.approve",
                        action: approve,
                        skipValidation: true,
                        iconClass: "glyphicon-ok-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: vm.datiPubblici
                            ? "entity.action.depublishMeeting"
                            : "entity.action.publishMeeting",
                        action: saveAndTogglePublicMeeting,
                        skipValidation: true,
                        iconClass: vm.datiPubblici
                            ? "glyphicon-alert"
                            : "glyphicon-bullhorn",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.decayed",
                        action: decay,
                        skipValidation: true,
                        iconClass: "glyphicon-thumbs-down",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.unprocessable",
                        action: unprocessable,
                        skipValidation: true,
                        iconClass: "glyphicon-ban-circle",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: getSendBackToCommissionTitle(),
                        action: sendBackToCommission,
                        iconClass: "glyphicon-paperclip",
                        authorities: ["ROLE_AULA"]
                    },
                    {
                        title: "entity.action.withdrawn",
                        action: toWithdrawnState,
                        iconClass: "glyphicon-inbox",
                        skipValidation: true,
                        authorities: ["ROLE_SETTORE", "ROLE_AULA"]
                    }
                ]
            });

            buttons.push({
                name: "APPROVATO",
                buttons: [
                    {
                        title: "entity.action.save",
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_COMMISSIONE']
                    },
                    {
                        title: "entity.action.sendBackToCommission",
                        action: sendBackToCommission,
                        iconClass: "glyphicon-paperclip",
                        authorities: ["ROLE_AULA"],
                        showFunction: isResendableToCommission
                    }
                ]
            });

            buttons.push({
                name: 'SVOLTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            return buttons;
        }

        function getRELButtons() {
            var buttons = [];
            buttons.push({
                name: 'PRESENTATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.assignment.inviaCommissione',
                        action: assign,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });
            buttons.push({
                name: 'COMMISSIONE',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.save',
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['LEGITIMACY', 'FEASIBILITY', 'GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.commission.inviaAula',
                        action: assignToCourtRoom,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        onlyPrimaryCommission: true
                    }
                ]
            });
            buttons.push({
                name: 'AULA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.svolta',
                        action: toSvolta,
                        iconClass: 'glyphicon-remove-circle',
                        authorities: ['ROLE_AULA']
                    }
                ]
            });

            buttons.push({
                name: 'APPROVATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA']
                    }
                ]
            });
            buttons.push({
                name: 'RISPOSTA_SCRITTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            buttons.push({
                name: 'SVOLTA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_SETTORE']
                    }
                ]});
            return buttons;
        }

        function getPDDButtons() {
            var buttons = [];
            buttons.push({
                name: 'PRESENTATO',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'gestioneAttiApp.form.assignment.inviaCommissione',
                        action: assign,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        skipValidation: true,
                        iconClass: 'glyphicon-inbox',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    },
                    {
                        title: 'entity.action.transferCompetence',
                        action: toTransferCompetence,
                        showFunction: showTrasferCompetence,
                        skipValidation: true,
                        iconClass: 'glyphicon-share',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });
            buttons.push({
                name: 'COMMISSIONE',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: vm.primaryCommission || vm.isAdmin,
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.save',
                        action: draft,
                        forceHide: vm.isAdmin,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['LEGITIMACY', 'FEASIBILITY', 'GENERAL_SECTIONS']
                    },
                    {
                        title: vm.datiPubblici ? 'gestioneAttiApp.form.commission.salvaDepubblica' : 'gestioneAttiApp.form.commission.salvaPubblica',
                        action: saveAndTogglePublish,
                        skipValidation: true, //vm.datiPubblici,
                        iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                        onlyPrimaryCommission: true,
                        authorities: ['ROLE_COMMISSIONE']
                    },
                    {
                        title: 'gestioneAttiApp.form.commission.inviaAula',
                        action: assignToCourtRoom,
                        iconClass: 'glyphicon-send',
                        authorities: ['ROLE_COMMISSIONE', 'ROLE_SETTORE'],
                        onlyPrimaryCommission: true
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE', 'ROLE_COMMISSIONE'],
                        sectorCapabilities: ['GENERAL_SECTIONS'],
                        onlyInvolvedSubjects: true
                    },
                    {
                        title: 'entity.action.transferCompetence',
                        action: toTransferCompetence,
                        showFunction: showTrasferCompetence,
                        skipValidation: true,
                        iconClass: 'glyphicon-share',
                        authorities: ['ROLE_SETTORE', 'ROLE_COMMISSIONE'],
                        sectorCapabilities: ['GENERAL_SECTIONS'],
                        onlyInvolvedSubjects: true
                    }
                ]
            });
            buttons.push({
                name: 'AULA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        skipValidation: true,
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.reject',
                        action: reject,
                        skipValidation: true,
                        iconClass: 'glyphicon-remove-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.approve',
                        action: approve,
                        skipValidation: true,
                        iconClass: 'glyphicon-ok-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: vm.datiPubblici ? 'entity.action.depublishMeeting' : 'entity.action.publishMeeting',
                        action: saveAndTogglePublicMeeting,
                        skipValidation: true,
                        iconClass: vm.datiPubblici ? 'glyphicon-alert' : 'glyphicon-bullhorn',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.decayed',
                        action: decay,
                        skipValidation: true,
                        iconClass: 'glyphicon-thumbs-down',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.unprocessable',
                        action: unprocessable,
                        skipValidation: true,
                        iconClass: 'glyphicon-ban-circle',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: getSendBackToCommissionTitle(),
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA']
                    },
                    {
                        title: 'entity.action.withdrawn',
                        action: toWithdrawnState,
                        iconClass: 'glyphicon-inbox',
                        skipValidation: true,
                        authorities: ['ROLE_SETTORE', 'ROLE_AULA'],
                    },
                    {
                        title: 'entity.action.transferCompetence',
                        action: toTransferCompetence,
                        showFunction: showTrasferCompetence,
                        skipValidation: true,
                        iconClass: 'glyphicon-share',
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });
            buttons.push({
                name: 'APPROVATO',
                buttons: [
                    // Ticket#943867: Nella fase APPROVATO, anche un utente con ROLE_COMMISSIONE, oltre a ROLE_AULA deve poter salvare la sezione PROCEDIMENTO
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_AULA', 'ROLE_COMMISSIONE']
                    },
                    {
                        title: 'entity.action.sendBackToCommission',
                        action: sendBackToCommission,
                        iconClass: 'glyphicon-paperclip',
                        authorities: ['ROLE_AULA'],
                        showFunction: isResendableToCommission
                    }]
            });
            buttons.push({
                name: 'TRASFERITA COMPETENZA',
                buttons: [
                    {
                        title: 'entity.action.save',
                        action: draft,
                        authorities: ['ROLE_SETTORE'],
                        sectorCapabilities: ['GENERAL_SECTIONS']
                    }
                ]
            });
            return buttons;

        }


        function setDataDecadenza() {
            var dataIniziale;
            if(vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo && vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo.length > 0 && vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo[0] !== "") {
                dataIniziale = vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo[vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo.length - 1];
            } else {
                dataIniziale = vm.atto.dataProtocollo;
            }
            dataIniziale = new Date(dataIniziale);
            dataIniziale = dataIniziale.setMonth(dataIniziale.getMonth() + 6);
            vm.dataDecadenza = new Date(dataIniziale);
        }

        $rootScope.$on('conformitaChange', function () {
            loadButtons();
        });

        vm.showCommissionBlock = function(index){
            if(vm.atto.tipoAtto === 'IS'){
                return false;
            }

            if(vm.atto.tipoAtto === 'PEA' && vm.userSoggettiEsterniMap.isCAL && (vm.atto.statoCorrente.statoAtto.name !== 'PRESENTATO')) {
                return true;
            }

            if( vm.atto.tipoAtto !== 'ODG' && vm.atto.tipoAtto !== 'PDR' && vm.atto.tipoAtto !== 'CDG' && vm.atto.tipoAtto !== 'PDRIS') {
                var isAulaDiretta = !vm.sezioniMap.ASSIGNMENT_LETTER || !vm.sezioniMap.ASSIGNMENT_LETTER.metadati || vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta;
                if (index === 0 && isAulaDiretta) {
                    return false;
                }
                return vm.wasAttoInState('COMMISSIONE', index, vm.atto, isAulaDiretta);
            } else {
                return index > 0;
            }
        }



        vm.showCourtroomBlock = function(index){
            if(vm.atto.tipoAtto === 'IEA' && !vm.assignmentLetter.metadati.aulaDiretta){
                return false;
            }
            if(vm.atto.tipoAtto === 'IS' && vm.atto.statoCorrente.statoAtto.name === 'PRESENTATO') {
                return false;
            }
            else if(vm.atto.tipoAtto === 'IO' || vm.atto.tipoAtto === 'IS') {
                var sezioneGestioneSedute = vm.getSezioniFromMap('COURT_MEETING', index);
                return sezioneGestioneSedute && (vm.atto.statoCorrente.statoAtto.name === 'AULA' || (sezioneGestioneSedute.metadati.seduteTrattazione && sezioneGestioneSedute.metadati.seduteTrattazione.length > 0) );
            } else {
                return vm.wasAttoInState('AULA', index, vm.atto, false);
            }
        }

        vm.showTrasmissioneGiuntaBlock = function() {
            if(!vm.sezioniMap['GIUNTA_TRASMISSION']) {
                return false;
            }

            if(vm.atto.tipoAtto === 'PEA') {
                return vm.atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA' || vm.atto.statoCorrente.statoAtto.finalState;
            } else {
                return vm.atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA';
            }
        }

        vm.showTrasmissioneGiuntaBeforeCourtroom = function() {
            if(vm.atto.tipoAtto === 'CDG') {
                return false;
            } else {
                return true;
            }
        }

        vm.showAssignmentLetter = function() {
            if(vm.atto.tipoAtto !== 'ODG' && vm.atto.tipoAtto !== 'PDR' && vm.atto.tipoAtto !== 'MOZIONE' && vm.atto.tipoAtto !== 'PDRIS'){
                return vm.checkShowSection(vm.sezioniMap.ASSIGNMENT_LETTER);
            } else if(vm.atto.tipoAtto === 'MOZIONE'){
                if (!vm.assignmentLetter || !vm.assignmentLetter.metadati) {
                    return false;
                }
                return !vm.assignmentLetter.metadati.aulaDiretta;
            } else {
                return false;
            }
        }

        /**
         *
         * @param {*} stateName name of the state to check in the atto history
         * @param {*} stateIndex index by the type of state depending of the block of sections.
         * @param {*} atto
         * @param {*} isAulaDiretta flag to know if the aulaDiretta is true or false
         * @returns
         */
        vm.wasAttoInState = function(stateName, stateIndex, atto, isAulaDiretta) {
            // numero che rappresenta la posizione in ordine per tipo di stato
            // Es: se abbiamo 2 stati aulee nello storico, avremo AULA con index 0 (con sectionNumberByType = 1)
            // e avremo AULA con index 1 (con sectionNumberByType = 2)
            var sectionNumberByType = stateIndex ? stateIndex + 1 : 1;
            // quante volte viene trovato questo stato nello storico
            // Tutti gli stati che sono nello stato attuale, sono gia' inseriti nello storico!
            var stateFoundInAttoHistory = 0;
            // We manage the aulaDiretta flag by ignoring the 1st commission block
            if (stateName === 'COMMISSIONE' && isAulaDiretta) {
                stateFoundInAttoHistory++;
            }
            // Attenzione se siamo in presentato lo storico e' vuoto!
            if (!atto.storico || atto.storico.length === 0) {
                return false;
            }

            for(var i = 0; i < atto.storico.length; i++) {
                if (atto.storico[i].statoAtto.name === stateName) {
                    stateFoundInAttoHistory++;
                }
            }
            return stateFoundInAttoHistory >= sectionNumberByType;
        }

/*         if((vm.atto.tipoAtto === 'PDR' || vm.atto.tipoAtto === "MOZIONE") && vm.utente && vm.atto.decaduto) {
            toastr.info('PROPOSTA DECADUTA', {
                timeOut: 60000,
                extendedTimeOut: 60000,
                progressBar: false
            });
        } */

        // Direction < 0 --> pull right, Direction >= 0 pull left
        vm.changeOrder = function($event, direction, chip) {
            var chipIdx = vm.atto.proponente.proponenti.findIndex(function(c){return c.id === chip.id});
            if(direction < 0 && chipIdx > 0) {
                vm.atto.proponente.proponenti.splice(chipIdx, 1);
                vm.atto.proponente.proponenti.splice(chipIdx - 1, 0, chip);
            } else if(direction >= 0 && chipIdx >= 0 && chipIdx < vm.atto.proponente.proponenti.length - 1) {
                vm.atto.proponente.proponenti.splice(chipIdx, 1);
                vm.atto.proponente.proponenti.splice(chipIdx + 1, 0, chip);
            }
            $event.stopPropagation();
        }

        vm.cancelCurrentState = function(atto){

            var statoPrecedenteString = atto.storico.length >= 2 ? atto.storico[atto.storico.length - 2].statoAtto.name : 'PRESENTAZIONE';

            var confirm = $mdDialog.confirm()
                .title('Sei sicuro di annullare lo stato attuale ' + atto.statoCorrente.statoAtto.name + "?")
                .textContent('Annullando lo stato corrente l\'atto ritornerà allo stato precedente ' +
                statoPrecedenteString + '. Eventuali modifiche verranno perse. Procedere?')
                .ariaLabel('Annulla Stato Corrente')
                .ok('Procedi')
                .cancel('Annulla');

            $mdDialog.show(confirm).then(function () {
                return Atto.cancelCurrentState({id: vm.atto.id},
                    function(success){
                        toastr.success('Atto correttamente aggiornato', 'Okay!');
                        reloadPage();
                    }, function(error){
                        toastr.error('Impossibile eseguire il passaggo allo stato precedente<br/>' + error.data.description, 'Errore!');
                    });
            }, function () {

            });
        }

        if(vm.atto.tipoAtto === 'IO') {
            // Gestione Assessore che risponde per IO nei metadata della lettera di assegnazione
            if(!vm.assignmentLetter.metadati.assessoreRispondeDetailsMap) {
                vm.assignmentLetter.metadati.assessoreRispondeDetailsMap = {};
            }
            if (!vm.assignmentLetter.metadati.assessoreRisponde) {
                vm.assignmentLetter.metadati.assessoreRisponde = {
                    assessori: []
                };
            } else if (!vm.assignmentLetter.metadati.assessoreRisponde.assessori) {
                vm.assignmentLetter.metadati.assessoreRisponde.assessori = [];
            }

            vm.onAddAssessoreRisponde = function($index, $chip){
                if(vm.atto.tipoProponente !== 'CR') {
                    return;
                }
                var oldAssessoreDetail = vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRispondeDetailsMap[$chip.id];
                if(!oldAssessoreDetail) {
                    vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRispondeDetailsMap[$chip.id] = {};
                }
            }

            vm.onRemoveAssessoreRisponde = function($index, $chip, $event) {
                if(vm.atto.tipoProponente !== 'CR') {
                    return;
                }
                delete vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRispondeDetailsMap[$chip.id];
            }
        }

        // Direction < 0 --> pull right, Direction >= 0 pull left
        vm.changeOrder1 = function(array, $event, direction, chip) {
            var chipIdx = array.findIndex(function(c){return c.id === chip.id});
            if(direction < 0 && chipIdx > 0) {
                array.splice(chipIdx, 1);
                array.splice(chipIdx - 1, 0, chip);
            } else if(direction >= 0 && chipIdx >= 0 && chipIdx < array.length - 1) {
                array.splice(chipIdx, 1);
                array.splice(chipIdx + 1, 0, chip);
            }
            $event.stopPropagation();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoDeleteController',AttoDeleteController);

    AttoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atto'];

    function AttoDeleteController($uibModalInstance, entity, Atto) {
        var vm = this;

        vm.atto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Atto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('atto', {
                    parent: 'entity',
                    url: '/atto?page&sort&search',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.atto.home.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/attos.html',
                            controller: 'AttoController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('addable-input');
                            $translatePartialLoader.addPart('document-toolbar');
                            $translatePartialLoader.addPart('archive-tree');
                            $translatePartialLoader.addPart('commission-opinion');
                            $translatePartialLoader.addPart('commission-observation');
                            $translatePartialLoader.addPart('emendments');
                            $translatePartialLoader.addPart('sectionNotes');

                            return $translate.refresh();
                        }]
                    }
                }) // Questo e' lo stato da cambiare
                .state('atto-view', {
                    parent: 'entity',
                    url: '/atto/{id}',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('addable-input');
                            $translatePartialLoader.addPart('document-toolbar');
                            $translatePartialLoader.addPart('archive-tree');
                            $translatePartialLoader.addPart('commission-opinion');
                            $translatePartialLoader.addPart('commission-observation');
                            $translatePartialLoader.addPart('emendments');
                            $translatePartialLoader.addPart('sectionNotes');
                            $translatePartialLoader.addPart('section-links');
                            return $translate.refresh();
                        }],
                        entity: ['$stateParams', 'Atto', function ($stateParams, Atto) {
                            return Atto.get({id: $stateParams.id}).$promise;
                        }],
                        commissioni: ['Commissione', 'entity', function (Commissione, entity) {
                            return Commissione.query({legislature: entity.legislatura}).$promise;
                        }],
                        soggettiEsterni: ['SoggettoEsterno', 'entity', function (SoggettoEsterno, entity) {
                            return SoggettoEsterno.query({legislature: entity.legislatura}).$promise;
                        }],
                        settori: ['Settore', function (Settore) {
                            return Settore.query({}).$promise;
                        }],
                        gruppiPolitici: ['Atto', function (Atto) {
                            return Atto.getGruppiPolitici().$promise;
                        }],
                        utente: ['Principal', function (Principal) {
                            return Principal.identity();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'home',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }],
                        // anagrafiche: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                        //         return AnagraficaProtocollo.query({}).$promise;
                        //     }],
                        enti: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ENTE'}).$promise;
                        }],
                        organi: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ORGANO'}).$promise;
                        }],
                        direzioni: ['Direzione', function (Direzione) {
                            return Direzione.query({}).$promise;
                        }],
                        attoAdditionalMetadata : ['entity', 'Atto', function (entity, Atto) {
                            return Atto.additionalMetadata({id: entity.id}).$promise;
                        }],
                        publicView: function () {
                            return false;
                        }
                    }
                })
                .state('atto-detail', {
                    parent: 'atto-view',
                    url: '/?sectionId',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.atto.detail.title'
                    },
                    reloadOnSearch: false,
                    params: {
                        sectionId: {
                            value: null,
                        }
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-detail.html',
                            controller: 'AttoDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        editable: function () {
                            return false;
                        },
                        docTypes: function () {
                            return null;
                        },
                        sezioniAtto: ['entity', 'Atto', function (entity, Atto) {
                            return Atto.getSezioni({id: entity.id}).$promise;
                        }]
                    }
                })
                .state('atto-public-detail', {
                    parent: 'atto-view-public',
                    url: '/publicView',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.atto.detail.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-detail.html',
                            controller: 'AttoDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        sezioniAtto: ['entity', 'Atto', function (entity, Atto) {
                            return Atto.getSezioni({id: entity.id, publicView: true}).$promise;
                        }],
                        editable: function () {
                            return false;
                        },
                        docTypes: function () {
                            return null;
                        },
                        gruppiPolitici: ['Atto', function (Atto) {
                            return Atto.getGruppiPolitici().$promise;
                        }]                        
                    }
                })
                .state('atto-view-public', {
                    parent: 'entity',
                    url: '/atto/{id}',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('addable-input');
                            $translatePartialLoader.addPart('document-toolbar');
                            $translatePartialLoader.addPart('archive-tree');
                            $translatePartialLoader.addPart('commission-opinion');
                            $translatePartialLoader.addPart('commission-observation');
                            $translatePartialLoader.addPart('emendments');
                            $translatePartialLoader.addPart('sectionNotes');
                            $translatePartialLoader.addPart('section-links');
                            return $translate.refresh();
                        }],
                        entity: ['$stateParams', 'Atto', function ($stateParams, Atto) {
                            return Atto.get({id: $stateParams.id, publicView: true}).$promise;
                        }],
                        commissioni: ['Commissione', 'entity', function (Commissione, entity) {
                            return Commissione.query({legislature: entity.legislatura}).$promise;
                        }],
                        soggettiEsterni: ['SoggettoEsterno', 'entity', function (SoggettoEsterno, entity) {
                            return SoggettoEsterno.query({legislature: entity.legislatura}).$promise;
                        }],
                        settori: ['Settore', function (Settore) {
                            return Settore.query({}).$promise;
                        }],
                        gruppiPolitici: ['Atto', function (Atto) {
                            return Atto.getGruppiPolitici().$promise;
                        }],
                        utente: ['Principal', function (Principal) {
                            return Principal.identity();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'home',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }],
                        anagrafiche: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                            return AnagraficaProtocollo.query({}).$promise;
                        }],
                        enti: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ENTE'}).$promise;
                        }],
                        organi: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ORGANO'}).$promise;
                        }],
                        direzioni: ['Direzione', function (Direzione) {
                            return Direzione.query({}).$promise;
                        }],
                        attoAdditionalMetadata : ['entity', 'Atto', function (entity, Atto) {
                            return Atto.additionalMetadata({id: entity.id}).$promise;
                        }],
                        publicView: function () {
                            return true;
                        }
                    }
                })
                .state('atto-edit', {
                    parent: 'atto-view',
                    url: '/edit',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'gestioneAttiApp.atto.edit.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-detail.html',
                            controller: 'AttoDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    onEnter: ['$state', 'utente', '$timeout', function ($state, utente, $timeout) {
                        if (utente.commissioneRuolo && utente.commissioneRuolo.nome !== 'Dipendente') {
                            $timeout(function () {
                                $state.go('home', {}, {reload: true});
                            }, 0);
                        }
                    }],
                    resolve: {
                        editable: function () {
                            return true;
                        },
                        docTypes: ['TipoDocumento', function (TipoDocumento) {
                            return TipoDocumento.query({}).$promise;
                        }],
                        sezioniAtto: ['entity', 'Atto', function (entity, Atto) {
                            return Atto.getSezioni({id: entity.id}).$promise;
                        }]
                    }
                })
                .state('atto-insert', {
                    parent: 'entity',
                    url: '/insert',
                    data: {
                        authorities: ['ROLE_ADMIN', 'ROLE_PROTOCOLLO', 'ROLE_SETTORE'],
                        pageTitle: 'gestioneAttiApp.atto.edit.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-insert.html',
                            controller: 'AttoInsertController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        utente: ['Principal', function (Principal) {
                            return Principal.identity();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'home',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }],
                        anagrafiche: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                            return AnagraficaProtocollo.query({}).$promise;
                        }],
                        enti: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ENTE'}).$promise;
                        }],
                        organi: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ORGANO'}).$promise;
                        }],
                        direzioni: ['Direzione', function (Direzione) {
                            return Direzione.query({}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('addable-input');
                            $translatePartialLoader.addPart('document-toolbar');
                            $translatePartialLoader.addPart('archive-tree');
                            $translatePartialLoader.addPart('emendments');
                            $translatePartialLoader.addPart('sectionNotes');
                            $translatePartialLoader.addPart('section-links');

                            return $translate.refresh();
                        }]
                    }
                })
                .state('atto-view-by-pk', {
                    parent: 'entity',
                    url: '/atto/{legislatura}/{anno}/{tipoAtto}/{numeroAtto}',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.atto.detail.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-detail.html',
                            controller: 'AttoDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('section-links');
                            return $translate.refresh();
                        }],
                        entity: ['$stateParams', 'Atto', function ($stateParams, Atto) {
                            return Atto.getByPk({
                                legislatura: $stateParams.legislatura,
                                anno: $stateParams.anno,
                                tipoAtto: $stateParams.tipoAtto,
                                numeroAtto: $stateParams.numeroAtto,
                            }).$promise;
                        }],
                        sezioniAtto: ['entity', 'Atto', function (entity, Atto) {
                            return Atto.getSezioni({id: entity.id}).$promise;
                        }],
                        commissioni: ['Commissione','entity', function (Commissione, entity) {
                            return Commissione.query({legislature: entity.legislatura}).$promise;
                        }],
                        soggettiEsterni: ['SoggettoEsterno', 'entity', function (SoggettoEsterno, entity) {
                            return SoggettoEsterno.query({legislature: entity.legislatura}).$promise;
                        }],
                        settori: ['Settore', function (Settore) {
                            return Settore.query({}).$promise;
                        }],
                        gruppiPolitici: ['Atto', function (Atto) {
                            return Atto.getGruppiPolitici().$promise;
                        }],
                        utente: ['Principal', function (Principal) {
                            return Principal.identity();
                        }],
                        anagrafiche: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                            return AnagraficaProtocollo.query({}).$promise;
                        }],
                        enti: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ENTE'}).$promise;
                        }],
                        organi: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ORGANO'}).$promise;
                        }],
                        docTypes: function () {
                            return null;
                        },
                        direzioni: ['Direzione', function (Direzione) {
                            return Direzione.query({}).$promise;
                        }],
                        attoAdditionalMetadata : ['entity', 'Atto', function (entity, Atto) {
                            return Atto.additionalMetadata({id: entity.id}).$promise;
                        }],
                        previousState: function () {
                            return false;
                        },
                        editable: function () {
                            return false;
                        },
                        publicView: function () {
                            return false;
                        }
                    }
                })
                .state('atto-view-by-numeroLeggeDef', {
                    parent: 'entity',
                    url: '/atto/{legislatura}/{numeroLeggeDef}',
                    data: {
                        authorities: [],
                        pageTitle: 'gestioneAttiApp.atto.detail.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-detail.html',
                            controller: 'AttoDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('form');
                            $translatePartialLoader.addPart('section-links');
                            return $translate.refresh();
                        }],
                        entity: ['$stateParams', 'Atto', function ($stateParams, Atto) {
                            return Atto.getByNumeroLeggeDef($stateParams.legislatura, $stateParams.numeroLeggeDef);
                        }],
                        sezioniAtto: ['entity', 'Atto', function (entity, Atto) {
                            return Atto.getSezioni({id: entity.id}).$promise;
                        }],
                        commissioni: ['Commissione', 'entity', function (Commissione, entity) {
                            return Commissione.query({legislature: entity.legislatura}).$promise;
                        }],
                        soggettiEsterni: ['SoggettoEsterno', 'entity', function (SoggettoEsterno, entity) {
                            return SoggettoEsterno.query({legislature: entity.legislatura}).$promise;
                        }],
                        settori: ['Settore', function (Settore) {
                            return Settore.query({}).$promise;
                        }],
                        gruppiPolitici: ['Atto', function (Atto) {
                            return Atto.getGruppiPolitici().$promise;
                        }],
                        utente: ['Principal', function (Principal) {
                            return Principal.identity();
                        }],
                        anagrafiche: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                            return AnagraficaProtocollo.query({}).$promise;
                        }],
                        enti: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ENTE'}).$promise;
                        }],
                        organi: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                            return AnagraficaIterlegis.query({'type': 'ORGANO'}).$promise;
                        }],
                        docTypes: function () {
                            return null;
                        },
                        direzioni: ['Direzione', function (Direzione) {
                            return Direzione.query({}).$promise;
                        }],
                        attoAdditionalMetadata : ['entity', 'Atto', function (entity, Atto) {
                            return Atto.additionalMetadata({id: entity.id}).$promise;
                        }],
                        previousState: function () {
                            return false;
                        },
                        editable: function () {
                            return false;
                        },
                        publicView: function () {
                            return true;
                        }
                    }
                }).state('atto-landing-page', {
                    parent: 'entity',
                    url: '/atto-lp?numeroAtto&data&tipoAtto',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/atto/atto-landing-page/atto-landing-page.html',
                            controller: 'AttoLandingPageController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        data: {
                            value: null,
                            squash: true
                        },
                        tipoAtto: {
                            value: null,
                            squash: true
                        },
                        numeroAtto: {
                            value: null,
                            squash:true
                        }
                    },
/*                     onEnter: ['$state', 'Principal', '$timeout', function ($state, Principal, $timeout) {
                        if (Principal.isAuthenticated()) {
                            $timeout(function () {
                                $state.go('home_logged', {}, {reload: true});
                            }, 0);
                        }
                    }], */
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            $translatePartialLoader.addPart('atto');
                            $translatePartialLoader.addPart('tipoAtto');
                            $translatePartialLoader.addPart('tipoProponente');
                            $translatePartialLoader.addPart('form');
                            return $translate.refresh();
                        }],
                        attoParams: ['$stateParams', function ($stateParams) {
                            return {
                                data: $stateParams.data,
                                tipoAtto: $stateParams.tipoAtto,
                                numeroAtto: $stateParams.numeroAtto
                            };
                        }],
                    }
                });
    }
})();

(function () {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Atto', Atto);

    Atto.$inject = ['$resource', 'Upload', 'DateUtils', '$http'];

    function Atto($resource, Upload, DateUtils, $http) {
        var resourceUrl = 'api/:public/attos/:id/:sezioni/:idSezione/:files/:protocolNow/:legislatura/:anno/:tipoAtto/:numeroAtto/:proponente/:tipoProponente/:advancedSearch/:legislature/:filingcode/:commissione/:idCommissione/:tipoPaginaCommissione/:default';

        var resource = $resource(resourceUrl, { id: '@id', idSezione: '@idSezione' }, {
            'query': {
                method: 'GET',
                params: { public: 'public' },
                isArray: true
            },
            'queryLite': {
                method: 'GET',
                url: 'api/public/lite/attos',
                isArray: true
            },
            'queryNonPaged': {
                method: 'GET',
                url: 'api/public/non-paged/attos',
                isArray: true
            },
            'advancedSearch': {
                method: 'GET',
                params: {
                    public: 'public',
                    advancedSearch: 'advancedSearch'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                params: { public: 'public' },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataProtocollo = DateUtils.convertLocalDateFromServer(data.dataProtocollo);
                    }
                    return data;
                }
            },
            'getByPk': {
                method: 'GET',
                params: { public: 'public' },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataProtocollo = DateUtils.convertLocalDateFromServer(data.dataProtocollo);
                    }
                    return data;
                }
            },
            'getSezioni': {
                method: 'GET',
                url: resourceUrl + '/sezioni',
                params: { public: 'public' },
                isArray: true
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    // salvataggio del proponente a parte
                    copy.proponente = null;

                    copy.dataProtocollo = DateUtils.convertLocalDateToServer(copy.dataProtocollo);
                    return angular.toJson(copy);
                }
            },
            'updateFirmatariProponente': {
                method: 'PUT',
                url: '/api/attos/:idAtto/proponente/firmatari',
                params: { 'idAtto': '@idAtto' }
            },
            'updateSezione': {
                method: 'PUT',
                url: '/api/attos/:idAtto/sezioni/:idSezione',
                params: { 'idAtto': '@idAtto', 'idSezione': '@id' }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    // salvataggio del proponente a parte
                    copy.proponente = null;

                    copy.dataProtocollo = DateUtils.convertLocalDateToServer(copy.dataProtocollo);
                    return angular.toJson(copy);
                }
            },
            'transition': {
                method: 'PUT',
                url: '/api/attos/:id/transizione/:nextState',
                params: { 'nextState': '@nextState' },
                responseType: 'string'
            },
            'sezioni': {
                method: 'GET',
                params: {
                    public: 'public',
                    sezioni: 'sezioni'
                },
                isArray: true
            },
            'sezioniFiles': {
                method: 'GET',
                params: {
                    public: 'public',
                    sezioni: 'sezioni',
                    files: 'files'
                },
                isArray: true
            },
            'sezioniFilesGrouped': {
                method: 'GET',
                params: {
                    public: 'public',
                    sezioni: 'sezioni',
                    files: 'files'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var result = [];
                    var lastGroup = null;
                    if (data && (!data.status || data.status === 200)) {
                        angular.forEach(data, function (document) {
                            if (lastGroup === null || lastGroup.name !== document.gruppoProtocollo) {
                                lastGroup = {
                                    name: document.gruppoProtocollo,
                                    protocolState: document.statoProtocollo,
                                    mittenti: document.mittentiProtocollo || [],
                                    destinatari: document.destinatariProtocollo || [],
                                    documents: [],
                                    operatingOffice: document.operatingOffice
                                };
                                result.push(lastGroup);
                            }
                            document.name = document.nome;
                            document.public = document.pubblico;
                            document.frontpiece = document.frontespizio;
                            document.protocolState = document.statoProtocollo;
                            document.protocolGroup = document.gruppoProtocollo;
                            document.docType = document.tipoDocumento.tipo;
                            lastGroup.documents.push(document);
                        });
                    }
                    return { data: result };
                }
            },
            'protocolNow': {
                method: 'POST',
                params: {
                    sezioni: 'sezioni',
                    files: 'files',
                    protocolNow: 'protocolNow'
                },
                isArray: true
            },
            'updateProponente': {
                method: 'PUT',
                params: {
                    proponente: 'proponente'
                }
            },
            'queryLegislature': {
                method: 'GET',
                params: {
                    public: 'public',
                    legislature: 'legislature'
                },
                isArray: true
            },
            'queryCommissioniAtti': {
                method: 'GET',
                params: {
                    public: 'public',
                    commissione: 'commissione'
                },
                isArray: true
            },
            'getFilingCode': {
                method: 'GET',
                params: {
                    public: 'public',
                    filingcode: 'filingcode',
                },
                transformResponse: function (data) {
                    return { data: data };
                }
            },
            'getAllTipoAtto': {
                method: 'GET',
                url: '/api/visibilita-tipo-atto',
                isArray: true
            },
            'getTipoAttoForNonAuth': {
                method: 'GET',
                url: '/api/public/visibilita-tipo-atto',
                isArray: true
            },
            'getGruppiPolitici': {
                method: 'GET',
                url: '/api/public/gruppi-politici',
                isArray: true
            },
            'saveTipoAtto': {
                method: 'POST',
                url: '/api/visibilita-tipo-atto'
            },
            'updateTipoAtto': {
                method: 'PUT',
                url: '/api/visibilita-tipo-atto'
            },
            'getTipoAtto': {
                method: 'GET',
                url: '/api/visibilita-tipo-atto/get-one/:id'
            },
            'deleteTipoAtto': {
                method: 'DELETE',
                url: '/api/visibilita-tipo-atto/:id'
            },
            'createConfigurazioneNotifiche': {
                method: 'POST',
                url: '/api/attos/configurazione-notifiche'
            },
            'updateConfigurazioneNotifiche': {
                method: 'PUT',
                url: '/api/attos/configurazione-notifiche/:idConfigurazione'
            },
            'getConfigurazioneNotifiche': {
                method: 'GET',
                url: '/api/attos/configurazione-notifiche/:idConfigurazione'
            },
            'getConfigurazioneNotificheByTipoAtto': {
                method: 'GET',
                url: '/api/attos/configurazione-notifiche/tipo-atto/:tipoAtto'
            },
            'sendAttoNotificationByEmail': {
                method: 'PUT',
                url: '/api/attos/notifications/send/:idAtto'
            },
            'getPDFReport': {
                method: 'POST',
                url: '/api/attos/report',
                responseType: 'arraybuffer'
            },
            'getPDFReportAddressesActs': {
                method: 'POST',
                url: '/api/attos/report-atti-indirizzo',
                responseType: 'arraybuffer'
            },
            'getLandingPageAtto': {
                method: 'GET',
                url: '/api/public/attos-lp',
                isArray: true
            },
            'cancelCurrentState': {
                method: 'PUT',
                url: '/api/attos/:id/annulla-stato-corrente',
                responseType: 'string'
            },
            'defaultLegislatura': {
                method: 'GET',
                params: { 
                    public: 'public', 
                    legislatura: 'legislature', 
                    default: 'default'
                }
            },
            'legislatura': {
                method: 'GET',
                params: { 
                    public: 'public', 
                    legislatura: 'legislature'
                }
            },
            'additionalMetadata': {
                method: 'GET',
                url: '/api/public/attos/:id/additional-metadata'
            },
        });

        resource.getPDFReport = function (body) {
            return $http.post('/api/public/attos/report',
                body,
                { responseType: 'arraybuffer' });
        };

        resource.getPDFReportAddressesActs = function (body) {
            return $http.post('/api/public/attos/report-atti-indirizzo',
                body,
                { responseType: 'arraybuffer' });
        };

        resource.getEmendamentiPDFReport = function (sezioneId) {
            return $http.get('/api/public/attos/' + sezioneId + '/emendamentiReport',
                { responseType: 'arraybuffer' });
        };

        resource.uploadFileSezione = function (idAtto, idSezione, file, params) {
            return Upload.upload({
                url: 'api/attos/' + idAtto + '/sezioni/' + idSezione + '/files',
                method: 'POST',
                data: params || {},
                file: file,
            });
        };

        resource.updateFileProtocolData = function (idAtto, idSezione, fileList) {
            return $http.put('api/public/attos/' + idAtto + '/sezioni/' + idSezione + '/files', fileList).then(
                function (response) {
                    // success callback
                    console.log("Success: ", response);
                },
                function (response) {
                    // failure callback
                    console.log("Failure: ", response);
                });
        };



        resource.getArchive = function (id, publicView) {
            return $http.get('api/public/attos/' + id + '/fascicolo', {
                responseType: 'arraybuffer',
                params: { publicView: publicView }
            });

        };

        resource.getArchiveTree = function (id, publicView) {
            return $http.get('api/public/attos/' + id + '/fascicolo/tree', {
                params: { publicView: publicView }
            });

        };

        resource.getArchiveTreeSection = function (id, stato, sezione, publicView) {
            var sezioneParam = "";
            if (sezione && sezione !== "") {
                sezioneParam = "?sezione=" + sezione;
            }
            return $http.get('api/public/attos/' + id + '/fascicolo/tree/section/' + stato + sezioneParam, {
                params: { publicView: publicView }
            });

        };

        resource.getByNumeroLeggeDef = function (legislatura, numeroLeggeDf) {
            return $http.get('api/public/attos/legislatura/' + legislatura + '/numeroLeggeDef/' + numeroLeggeDf).then(
                function (response) {
                    return response.data;
                },
                function (response) {
                    // failure callback
                    console.log("Failure: ", response);
                });
        };


        resource.getSezioneByIdAttoAndNomeSezione = function (idAtto, nomeSezione) {
            return $http.get('api/public/attos/' + idAtto + '/sezioni/' + nomeSezione).then(
                function (response) {
                    return response.data;
                },
                function (response) {
                    console.log("Failure: ", response);
                });
        };

        return resource;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoController', AttoController);

    AttoController.$inject = ['$state', 'Atto', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AttoController($state, Atto, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Atto.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaProtocolloDialogController', AnagraficaProtocolloDialogController);

    AnagraficaProtocolloDialogController.$inject = ['$timeout', '$scope', 'toastr', '$mdDialog', 'entity', 'AnagraficaProtocollo', '$q', '$state'];

    function AnagraficaProtocolloDialogController($timeout, $scope, toastr, $mdDialog, entity, AnagraficaProtocollo, $q, $state) {
        var vm = this;

        vm.anagraficaProtocollo = vm.entity;
        vm.clear = clear;
        vm.save = save;

        vm.selectedItem = vm.anagraficaProtocollo.anagraficaProtocollo;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isSaving = true;
            if (vm.anagraficaProtocollo.id !== null) {
                AnagraficaProtocollo.update(vm.anagraficaProtocollo, onSaveSuccess, onSaveError);
            } else {
                AnagraficaProtocollo.save(vm.anagraficaProtocollo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:anagraficaProtocolloUpdate', result);
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('anagrafica-protocollo', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.setAnagrafic = function (item) {
            if (item) {
                vm.anagraficaProtocollo.anagraficaProtocollo = item;
                vm.anagraficaProtocollo.codice = item.anagraficCode;
                vm.anagraficaProtocollo.descrizione = item.anagraficDescription;
            }
        };

        vm.searchAnagrafics = function (text) {
            var deferred = $q.defer();
            AnagraficaProtocollo.listFromProtocol({'code': text}, function (data) {
                deferred.resolve(data);
                return deferred.promise;
            }, function (error) {
                toastr.error(error);
                deferred.reject(error);
            });
            return deferred.promise;
        };

        vm.getDisplayName = function (item) {
            return item.anagraficCode + ' - ' + item.anagraficDescription;
        };
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaProtocolloDetailController', AnagraficaProtocolloDetailController);

    AnagraficaProtocolloDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function AnagraficaProtocolloDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.anagraficaProtocollo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:anagraficaProtocolloUpdate', function (event, result) {
            vm.anagraficaProtocollo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaProtocolloDeleteController', AnagraficaProtocolloDeleteController);

    AnagraficaProtocolloDeleteController.$inject = ['$uibModalInstance', 'entity', 'AnagraficaProtocollo'];

    function AnagraficaProtocolloDeleteController($uibModalInstance, entity, AnagraficaProtocollo) {
        var vm = this;

        vm.anagraficaProtocollo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AnagraficaProtocollo.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('anagrafica-protocollo', {
                    parent: 'entity',
                    url: '/anagrafica-protocollo?term&page&protocolSystem',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'gestioneAttiApp.anagraficaProtocollo.home.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollos.html',
                            controller: 'AnagraficaProtocolloController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        protocolSystem : {
                            value: '',
                            squash: true
                        },
                        term : {
                            value: ''
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('anagrafica-protocollo');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page),
                                };
                            }]
                    }
                })
                .state('anagrafica-protocollo-detail', {
                    parent: 'anagrafica-protocollo',
                    url: '/anagrafica-protocollo/{id}',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'gestioneAttiApp.anagraficaProtocollo.detail.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollo-detail.html',
                            controller: 'AnagraficaProtocolloDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('anagrafica-protocollo');
                                return $translate.refresh();
                            }],
                        entity: ['$stateParams', 'AnagraficaProtocollo', function ($stateParams, AnagraficaProtocollo) {
                                return AnagraficaProtocollo.get({id: $stateParams.id}).$promise;
                            }],
                        previousState: ["$state", function ($state) {
                                var currentStateData = {
                                    name: $state.current.name || 'anagrafica-protocollo',
                                    params: $state.params,
                                    url: $state.href($state.current.name, $state.params)
                                };
                                return currentStateData;
                            }]
                    }
                })
                .state('anagrafica-protocollo-detail.edit', {
                    parent: 'anagrafica-protocollo-detail',
                    url: '/detail/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['AnagraficaProtocollo', '$stateParams', '$mdDialog', function (AnagraficaProtocollo, $stateParams, $mdDialog) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                size: 'lg',
                                templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollo-dialog.html',
                                controller: 'AnagraficaProtocolloDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: AnagraficaProtocollo.get({id: $stateParams.id}).$promise
                                }
                            });
                        }]
                })
                .state('anagrafica-protocollo.new', {
                    parent: 'anagrafica-protocollo',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', function ($mdDialog) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: true,
                                templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollo-dialog.html',
                                controller: 'AnagraficaProtocolloDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {
                                        codice: null,
                                        descrizione: null,
                                        id: null,
                                        anagraficaProtocollo: null
                                    }
                                }
                            });
                        }]
                })
                .state('anagrafica-protocollo.edit', {
                    parent: 'anagrafica-protocollo',
                    url: '/{id}/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$mdDialog', 'AnagraficaProtocollo', function ($stateParams, $mdDialog, AnagraficaProtocollo) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: true,
                                templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollo-dialog.html',
                                controller: 'AnagraficaProtocolloDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: AnagraficaProtocollo.get({id: $stateParams.id}).$promise
                                }
                            });
                        }]
                })
                .state('anagrafica-protocollo.delete', {
                    parent: 'anagrafica-protocollo',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/anagrafica-protocollo/anagrafica-protocollo-delete-dialog.html',
                                controller: 'AnagraficaProtocolloDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['AnagraficaProtocollo', function (AnagraficaProtocollo) {
                                            return AnagraficaProtocollo.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('anagrafica-protocollo', null, {reload: 'anagrafica-protocollo'});
                            }, function () {
                                $state.go('^');
                            });
                        }]
                });
    }

})();

(function () {
    'use strict';
    angular
            .module('gestioneAttiApp')
            .factory('AnagraficaProtocollo', AnagraficaProtocollo);

    AnagraficaProtocollo.$inject = ['$resource'];

    function AnagraficaProtocollo($resource) {
        var resourceUrl = 'api/:public/anagrafiche-protocollo/:id/:search/:protocolAnagrafic/:offices/:userOperatingOffices';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {public: 'public'}
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'search': {method: 'GET', params: {search: 'search', public: 'public'}, isArray: true},
            'listOffices': {method: 'GET', params: {offices: 'offices'}, isArray: true},
            'listFromProtocol': {method: 'GET', params: {protocolAnagrafic: 'protocolAnagrafic'}, isArray: true},
            'userOperatingOffices': {method: 'GET', params: {userOperatingOffices: 'user-operating-offices'}}
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaProtocolloController', AnagraficaProtocolloController);

    AnagraficaProtocolloController.$inject = ['$state', 'ParseLinks', 'paginationConstants', 'pagingParams', 'AnagraficaProtocollo', '$stateParams'];

    function AnagraficaProtocolloController($state, ParseLinks, paginationConstants, pagingParams, AnagraficaProtocollo, $stateParams) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.paging = pagingParams;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.protocolSystem = $stateParams.protocolSystem;
        vm.searchTerm = $stateParams.term;

        vm.onChangeProtocolSystem = onChangeProtocolSystem;

        vm.anagraficaProtocollos = [];

        loadAll();

        function loadAll() {
            if(!vm.protocolSystem) {
                vm.protocolSystem = 'INSIEL';
            }
            AnagraficaProtocollo.search({
                protocolSystem: vm.protocolSystem,
                term: vm.searchTerm,
                page: vm.paging.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

        }

        vm.search = function () {
            vm.paging.page = 1;
            AnagraficaProtocollo.search({
                protocolSystem: vm.protocolSystem,
                term: vm.searchTerm,
                page: vm.paging.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                protocolSystem: vm.protocolSystem,
                term: vm.searchTerm,
                page: vm.page,
                size: vm.itemsPerPage
            });
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.anagraficaProtocollos = data;
            vm.page = vm.paging.page;
            vm.loading = false;
        }

        function onError(error) {
            console.log("Failure!", error);
            vm.loading = false;
        }

        function onChangeProtocolSystem(){
            $state.transitionTo($state.$current, {
                protocolSystem: vm.protocolSystem,
                term: vm.searchTerm,
                page: 1,
                size: vm.itemsPerPage
            }, {reload : true});
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaIterlegisDialogController', AnagraficaIterlegisDialogController);

            AnagraficaIterlegisDialogController.$inject = ['$timeout', '$scope', 'toastr', '$mdDialog', 'entity', 'AnagraficaIterlegis', '$state', 'TIPO_ANAGRAFICA_ITERLEGIS'];

    function AnagraficaIterlegisDialogController($timeout, $scope, toastr, $mdDialog, entity, AnagraficaIterlegis, $state, TIPO_ANAGRAFICA_ITERLEGIS) {
        var vm = this;
        this.tipoAnagraficaList = TIPO_ANAGRAFICA_ITERLEGIS;
        vm.anagraficaIterlegis = vm.entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isSaving = true;
/*             if (vm.anagraficaIterlegis.id !== null) {
                AnagraficaIterlegis.update(vm.anagraficaIterlegis, onSaveSuccess, onSaveError);
            } else { */
            AnagraficaIterlegis.save(vm.anagraficaIterlegis, onSaveSuccess, onSaveError);
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('gestioneAttiApp:anagraficaIterlegisUpdate', result);
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('anagrafica-iterlegis', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaIterlegisDeleteController', AnagraficaIterlegisDeleteController);

            AnagraficaIterlegisDeleteController.$inject = ['$uibModalInstance', 'entity', 'AnagraficaIterlegis'];

    function AnagraficaIterlegisDeleteController($uibModalInstance, entity, AnagraficaIterlegis) {
        var vm = this;

        vm.anagraficaIterlegis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AnagraficaIterlegis.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('anagrafica-iterlegis', {
                    parent: 'admin',
                    url: '/anagrafica-iterlegis?page',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'anagrafica-iterlegis.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/anagrafica-iterlegis/anagrafica-iterlegis.html',
                            controller: 'AnagraficaIterlegisController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'descrizioneAnagrafica,desc',
                            squash: true
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('atto');
                                $translatePartialLoader.addPart('tipoAtto');
                                $translatePartialLoader.addPart('tipoProponente');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('form');
                                $translatePartialLoader.addPart('addable-input');
                                $translatePartialLoader.addPart('document-toolbar');
                                $translatePartialLoader.addPart('archive-tree');
                                $translatePartialLoader.addPart('commission-opinion');
                                $translatePartialLoader.addPart('emendments');
                                $translatePartialLoader.addPart('sectionNotes');
                                $translatePartialLoader.addPart('anagrafica-iterlegis');
                                return $translate.refresh();
                            }],
                        pagingParams: ['PaginationUtil', '$stateParams', function (PaginationUtil, $stateParams) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort)
                            }
                        }]
                    }
                }).state('anagrafica-iterlegis.new', {
                    parent: 'anagrafica-iterlegis',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', function ($mdDialog) {
                            $mdDialog.show({
                                clickOutsideToClose: false,
                                fullscreen: true,
                                templateUrl: 'app/entities/anagrafica-iterlegis/anagrafica-iterlegis-dialog.html',
                                controller: 'AnagraficaIterlegisDialogController',
                                controllerAs: 'vm',
                                bindToController: true,
                                locals: {
                                    entity: {
                                        tipoAtto: null,
                                        descrizioneAnagrafica: null,
                                        id: null
                                    }
                                }
                            });
                        }]
                }).state('anagrafica-iterlegis.delete', {
                    parent: 'anagrafica-iterlegis',
                    url: '/{id}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/entities/anagrafica-iterlegis/anagrafica-iterlegis-delete-dialog.html',
                                controller: 'AnagraficaIterlegisDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['AnagraficaIterlegis', function (AnagraficaIterlegis) {
                                            return AnagraficaIterlegis.get({id: $stateParams.id}).$promise;
                                        }]
                                }
                            }).result.then(function () {
                                $state.go('anagrafica-iterlegis', null, {reload: 'anagrafica-iterlegis'});
                            }, function () {
                                $state.go('^');
                            });
                        }]
                })
            }
})();
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('AnagraficaIterlegis', AnagraficaIterlegis);

        AnagraficaIterlegis.$inject = ['$resource'];

    function AnagraficaIterlegis ($resource) {
        var resourceUrl =  'api/:public/anagrafiche-iterlegis';

        var resource = $resource(resourceUrl, {}, {
            'queryPaged': {
                method: 'GET',
                params: { public: 'public'},
                isArray: true,
                url: resourceUrl + '/paged'
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {method: 'DELETE', url: resourceUrl + '/:id'},
            'query': {
                params: {public: 'public'},
                method: 'GET',
                isArray: true,
                url: resourceUrl
            }
        });

        return resource;
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AnagraficaIterlegisController', AnagraficaIterlegisController);

        AnagraficaIterlegisController.$inject = ['$state','toastr', 'pagingParams', 'paginationConstants', 'ParseLinks', 'AnagraficaIterlegis','$translate'];

    function AnagraficaIterlegisController($state, toastr, pagingParams, paginationConstants, ParseLinks, AnagraficaIterlegis, $translate) {
        var vm = this;
        vm.anagraficaIterlegisList = [];
        //Search default
        vm.pagingParams = pagingParams || {};

         // query stuff
         vm.predicate = vm.pagingParams.predicate;
         vm.reverse = vm.pagingParams.ascending;
         vm.itemsPerPage = paginationConstants.itemsPerPage;

         vm.loading = false;


         loadAll();

         function loadAll() {
             vm.loading = true;
             AnagraficaIterlegis.queryPaged({
                page: vm.pagingParams.page - 1,
                sort: sort(),
                size: vm.itemsPerPage
            }, onSuccess, onError);
         }

         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.anagraficaIterlegisList = data;
             vm.page = vm.pagingParams.page;
             vm.loading = false;
         }

         function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                console.log("Failure!", error);
                toastr.error(error.data.message);
                vm.loading = false;
            }
         }

         function sort() {
             var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
             if (vm.predicate !== 'id') {
                 result.push('id');
             }
             return result;
         }

        vm.transition = function() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                protocolNumber: vm.protocolNumber,
                importType: vm.importType,
                direction: vm.direction,
                errorType: vm.errorType
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('gestioneAttiApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('AdempimentoUtil', AdempimentoUtil);

    function AdempimentoUtil () {

        var service = {
            isAdempimentoValid : isAdempimentoValid
        };

        return service;

        function isAdempimentoValid (adempimento) {
            return (adempimento.incaricatiAdempimento && adempimento.incaricatiAdempimento.length > 0) && 
                (adempimento.destinatariAdempimento && adempimento.destinatariAdempimento.length > 0) &&
                (!adempimento.destinatariAdempimento.includes('COMMISSIONE') || (adempimento.commissioniDestinatarie && adempimento.commissioniDestinatarie.length > 0)) &&
                (adempimento.descrizioneAdempimento && adempimento.descrizioneAdempimento.trim().length > 0)
        }
    }
})();

/**
 * Created by Michele Romani on 26/06/2017.
 */

angular.module('gestioneAttiApp').directive('uploadDialog',  function () {
    return {
        restrict: "E",
        scope: {
            dialogId: "=dialogId"
        },
        controller: ["$scope",
            function ($scope) {
                var vm = this;
            }],
        templateUrl: 'app/components/uploadDialog/uploadDialog.html'
    }
});

angular.module('gestioneAttiApp').directive('transferCompetenceBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/transferCompetenceBlock/transferCompetenceBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            decree: '=',
            noticeOfRectification: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.actType = vm.atto.tipoAtto;
            vm.decree.visible = true;
            vm.noticeOfRectification.visible = true;

            vm.sezioni = {
                DECREE: {
                    form: 'app/components/transferCompetenceBlock/decree.html'
                },
                NOTICE_OF_RECTIFICATION_TRANSFER_COMPETENCE : {
                    form: 'app/components/courtroomBlock/noticeOfRectification.html'
                }
                
            };

            vm.stato = {
                transferCompetence: {
                    isCollapsed: vm.statoAttoCorrente === 'TRASFERITA COMPETENZA' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];

        }]
    };
});

angular.module('gestioneAttiApp').directive('svoltaBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/svoltaBlock/svoltaBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            courtOutcome: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.clearRadio = PdlService.clearRadio;
            vm.attoRitiratoDocs = [];
            vm.sezioni = {
                COURT_OUTCOME: {
                    form: (vm.atto.tipoAtto === 'IO' || vm.atto.tipoAtto === 'IS' || vm.atto.tipoAtto === 'REL')
                            ? 'app/components/courtroomBlock/io.courtroomOutcome.html'
                            : 'app/components/courtroomBlock/courtroomOutcome.html'
                }
            };

            vm.stato = {
                svolta: {
                    isCollapsed: vm.statoAttoCorrente === 'SVOLTA' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
        }]
    };
});

angular.module('angularSlideables', [])
        .directive('slideable', function () {
            return {
                restrict: 'C',
                compile: function (element, attr) {
                    // wrap tag
                    var contents = element.html();
                    element.html('<div class="slideable_content" style="margin:0 !important; padding: 20px;" >' + contents + '</div>');

                    return function postLink(scope, element, attrs) {
                        // default properties
                        attrs.expand = (!attrs.expand) ? false : attrs.expand === "true";
                        attrs.duration = (!attrs.duration) ? '0.2s' : attrs.duration;
                        attrs.easing = (!attrs.easing) ? 'ease-out' : attrs.easing;
                        element.css({
                            'overflow': 'hidden',
                            'transitionProperty': 'height',
                            'transitionDuration': attrs.duration,
                            'transitionTimingFunction': attrs.easing
                        });
                        if (!attrs.expand) {
                            element.css({
                                'height': '0px'
                            });
                        }
                    };
                }
            };
        })
        .directive('slideToggle', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var target, content;

                    attrs.expand = (!attrs.expand) ? false : attrs.expand === "true";
                    attrs.expanded = (!attrs.expanded) ? attrs.expand : false;

//                    if (attrs.expanded) {
//                        var slideable = document.querySelector(attrs.slideToggle + ' .slideable_content');
//                        if (!slideable.style.height || slideable.style.height === "") {
//                            document.querySelector(attrs.slideToggle).style.height = slideable.clientHeight + 'px';
//                        }
//                    }

                    element.bind('click', function () {
                        if (!target)
                            target = document.querySelector(attrs.slideToggle);
                        if (!content)
                            content = target.querySelector('.slideable_content');

                        if (!attrs.expanded) {
                            target.style.height = content.clientHeight + 'px';
                        } else {
                            target.style.height = '0px';
                        }
                        attrs.expanded = !attrs.expanded;
                    });
                }
            }
        });

angular.module('gestioneAttiApp').directive('sedutaDocumentToolbar', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.directive.html',
        scope: {
            changeDocumentTypeCallback: '&?',
            changeDocumentVisibilityCallback: '&?',
            removeDocumentCallback: '&?',
            documentTypes: '=?',
            editable: '=',
            publicView: '=?',
            seduta: '=',
            ordineDelGiorno: "=?",
            uploadedFileCallback: '&',
            user: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Seduta', 'Documento', 'AnagraficaProtocollo', 'toastr', 'FileSaver', '$timeout', '$uibModal', 'Principal', 'GESTIONE_ATTI_DOC_VISIBILITIES', 'MAX_UPLOAD_SIZE', '$mdDialog', 'User', '$anchorScroll','$state', 'PROTOCOLLAZIONE_DISABILITATA',
            function (Seduta, Documento, AnagraficaProtocollo, toastr, FileSaver, $timeout, $uibModal, Principal, GESTIONE_ATTI_DOC_VISIBILITIES, MAX_UPLOAD_SIZE, $mdDialog, User, $anchorScroll, $state, PROTOCOLLAZIONE_DISABILITATA) {
                var vm = this;

                vm.instantProtocolEnabled = vm.user && vm.user.instantProtocolEnabled;

                initUserRoles();
                initDocVisibilities();
                initToolbarSectionVisibilities();

                vm.commissionPresidentOrMember = false;

                vm.uploadPanel = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.uploadPanel.html';
                vm.documentsPanel = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.documentsPanel.html';
                vm.documentTableBody = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.documentTableBody.html';

                vm.docTypes = vm.documentTypes || [];
                vm.odg = vm.ordineDelGiorno || {'id': null};

                vm.files = [];
                vm.uploading = false;
                vm.protocolGroups = [];
                vm.singleFilesCount = 0;
                vm.singleDocumentsCount = 0;

                vm.defaultVisibility = "INTRANET";

                vm.frontespieceAllowedExtensions = ['pdf'];

                vm.canChangeDocumentType = canChangeDocumentType;
                vm.canChangeDocumentVisibility = canChangeDocumentVisibility;
                vm.changeDocumentType = changeDocumentType;
                vm.changeDocumentVisibility = changeDocumentVisibility;
                vm.closeDocumentToolbarPanels = closeDocumentToolbarPanels;
                vm.deleteDocument = deleteDocument;
                vm.downloadDocument = downloadDocument;
                vm.downloadGroupDocuments = downloadGroupDocuments;
                vm.dragOverClass = dragOverClass;
                vm.isDeletable = isDeletable;
                vm.isRealGroup = isRealGroup;
                vm.isSingleFileGroup = isSingleFileGroup;
                vm.loadDocuments = loadDocuments;
                vm.onFileSelect = onFileSelect;
                vm.openProtocolDataDialog = openProtocolDataDialog;
                vm.openSenderReceiverDialog = openSenderReceiverDialog;
                vm.removeGroupUpload = removeGroupUpload;
                vm.removeSingleUpload = removeSingleUpload;
                vm.resetUploads = resetUploads;
                vm.retryProcolAction = retryProcolAction;
                vm.setDefaultVisibility = setDefaultVisibility;
                vm.setPrimaryDoc = setPrimaryDoc;
                vm.setProtocolStateForGroup = setProtocolStateForGroup;
                vm.setProtocolStateForSingle = setProtocolStateForSingle;
                vm.uploadFiles = uploadFiles;

                vm.loadDocuments(false);

                vm.setProtocolStateForAllFilesOfGroup = function(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState;
                    });
                };

                vm.protocolOptions = [
                    {
                        'value': 'NO_ARCHIVE',
                        'textKey': 'documentToolbar.noArchive'
                    }
                ];
                
                if(vm.odg.id || vm.seduta.id) {
                    vm.protocolOptions.push({
                        'value': 'ALREADY_ARCHIVED',
                        'textKey': 'documentToolbar.alreadyArchived'
                    });
                    if (!PROTOCOLLAZIONE_DISABILITATA) {
                        vm.protocolOptions.push({
                            'value': 'ARCHIVE_NOW',
                            'textKey': 'documentToolbar.toBeImmediatelyArchived'
                        });
                    }
                }

                // by Anno too
                vm.orderByNumeroProtocolloConsiglio = function(v1, v2){
                    if(!v2) {
                        return 1;
                    }
                    var doc1 = v1.value.documents[0];
                    var doc2 = v2.value.documents[0];
                    if(!doc1 || !doc1.datiProtocollo || !doc1.datiProtocollo.numeroProtocolloConsiglio) {
                        return -1;
                    } else if(!doc2 || !doc2.datiProtocollo || !doc2.datiProtocollo.numeroProtocolloConsiglio) {
                        return 1;
                    } else {
                        var dataProtCons1 = new Date(doc1.datiProtocollo.dataProtocolloConsiglio);
                        var dataProtCons2 = new Date(doc2.datiProtocollo.dataProtocolloConsiglio);
                        // Protocolli di anno differente possono avere un numero uguale o inferiori, quindi prima si ordina per anno
                        if (dataProtCons1 && dataProtCons2 && dataProtCons1.getFullYear() !== dataProtCons2.getFullYear()) {
                            if (dataProtCons1.getFullYear() < dataProtCons2.getFullYear()) {
                                return 1;    
                            } else {
                                return -1;
                            }
                        }
                        if(doc1.datiProtocollo.numeroProtocolloConsiglio <= doc2.datiProtocollo.numeroProtocolloConsiglio){
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                };

                vm.toggleUpload = function () {
                    if (vm.showUpload) {
                        vm.showUpload = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showUpload = true;
                        vm.showCloseAll = true;
                        vm.showDocuments = false;
                    }
                };

                vm.toggleDocuments = function () {
                    if (vm.showDocuments) {
                        vm.showDocuments = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showDocuments = true;
                        vm.showCloseAll = true;
                        vm.showUpload = false;
                    }
                };

                // vm.section.showDocuments = function(){
                //     vm.showDocuments = true;
                //     vm.showCloseAll = true;
                //     vm.showUpload = false;
                // };

                vm.cancelUpload = function () {
                    vm.resetUploads();
                    vm.uploading = false;
                    vm.showUpload = false;
                    vm.protocolGroups = [];
                    vm.singleFilesCount = 0;
                    vm.singleDocumentsCount = 0;
                };

                function loadDocuments(pollForProtocolUpdates) {
                    vm.existingDocs = [];
                    vm.groupedDocs = {};
                    if (vm.seduta) {
                        Seduta.getSedutaDocuments({id: vm.seduta.id, idOdg: vm.odg.id}, function (result) {
                            vm.groupedDocs = result.data;
                            calculateSingleDocGroups(vm.groupedDocs);
                            if (pollForProtocolUpdates) {
                                updateArchiveNowProtocolState(vm.groupedDocs);
                            }
                        }, function () {
                            toastr.error('Impossibile ottenere la lista dei documenti caricati', 'Errore!');
                        });
                    }
                }

                function openProtocolDataDialog(group) {
                    var doc = group.documents[0];
                    doc.protocoldDataOpen = true;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-dialog-editable.html',
                        controller: ['$scope', '$mdDialog', 'Seduta', 'entity', 'protocolState', 'editable', 'idSeduta', 'idOdg', 'documents', 'documento', 'group', 'anagrafiche',
                            function ($scope, $mdDialog, Seduta, entity, protocolState, editable, idSeduta, idOdg, documents, documento, group, anagrafiche) {
                                var vm = this;
                                vm.protocolData = entity || {};
                                vm.protocolState = protocolState;
                                vm.editable = editable;
                                vm.documents = documents;
                                vm.documento = documento;
                                vm.anagrafiche = anagrafiche;
                                vm.selectedSenderSearchText = '';
                                vm.selectedReceiverSearchText = '';
                                vm.group = group;
                                Seduta.getFilingCode({'id': idSeduta}, {}, function (value) {
                                    vm.protocolData.classificazioneArchivistica = value.data;
                                }, function (reason) {
                                    toastr.error('Impossibile Recuperare il Codice Classificazione ', 'Errore!');
                                });

                                vm.dataProtocolloMittenteAusiliare;

                                vm.dataProtocolloMittenteAusiliareChanged = function() {
                                    vm.protocolData.dataProtocolloMittente = vm.dataProtocolloMittenteAusiliare;
                                };
                                
                                vm.isDataProtocolloMittentiWrong = function(){
                                    if(!vm.protocolData || !vm.protocolData.dataProtocolloMittente){
                                        return true;
                                    }
                                    var data = new Date(vm.protocolData.dataProtocolloMittente);
                                    if(data.getFullYear() == 1000) {
                                        return true;
                                    }
                                    return false;
                                };

                                vm.clear = function () {
                                    $mdDialog.cancel();
                                };

                                vm.checkProtocolState = function (protocolState) {
                                    return protocolState === 'ALREADY_ARCHIVED';
                                };

                                vm.saveProtocolData = function () {
                                    // Non è possibile salvare i dettagli se è presente solo uno tra "dataProtocolloConsiglio" e "numeroProtocolloConsiglio"
                                    if(vm.protocolData.dataProtocolloConsiglio && !vm.protocolData.numeroProtocolloConsiglio 
                                        || !vm.protocolData.dataProtocolloConsiglio && vm.protocolData.numeroProtocolloConsiglio) {
                                        toastr.error('Inserire sia il numero di protocollo che la data di protocollo', 'Errore!');
                                        return;
                                    }
                                    if(vm.protocolData && vm.protocolData.dataProtocolloConsiglio && vm.protocolData.dataProtocolloConsiglio instanceof Date) {
                                        // Quando la data è impostata dal datepicker è di tipo Date
                                        //Converte la data in UTC altrimenti da BE viene fatto un parsing errato
                                        var newDataProtCons = new Date(Date.UTC(vm.protocolData.dataProtocolloConsiglio.getFullYear(), 
                                        vm.protocolData.dataProtocolloConsiglio.getMonth(),
                                        vm.protocolData.dataProtocolloConsiglio.getDate()));
                                        vm.protocolData.dataProtocolloConsiglio = newDataProtCons;
                                    } // Altrimenti La data è in formato stringa "dd-MM-yyyy" quindi non è stata modificata
                                    angular.forEach(vm.documents, function (doc) {
                                        doc.datiProtocollo = vm.protocolData;
                                    });
                                    Seduta.updateFileProtocolData(idSeduta, idOdg, documents).then(
                                            function (response) {
                                                toastr.success('Dati di protocollazione salvati', 'Successo!');
                                            },
                                            function (response) {
                                                toastr.error('Impossibile salvare i dati di protocollazione', 'Errore!');
                                            });
                                    vm.clear();
                                };

                                vm.addPersonToList = function (chip) {
                                    // If it is an object, it's already a known chip
                                    if (angular.isObject(chip)) {
                                        return chip;
                                    }
                                    // Otherwise, create a new one
                                    return {descrizione: chip};
                                };


                                vm.searchFirmatari = function (searchText) {

                                    if(searchText.length < 3) {
                                        return [];
                                    }
                            
                                    return AnagraficaProtocollo.search(
                                        { 
                                            term: searchText,
                                            protocolSystem: vm.documento.protocolSystem,
                                            page: 0,
                                            size: 20
                                        }).$promise.then(onSuccessAnag, onErrorAnag);
                        
                                    //var lista = vm.anagrafiche;
                                    //return searchText ? lista.filter(createFilterFor(searchText)) : [];
                                };

                                function onSuccessAnag(data, headers) {
                                    vm.anagrafiche = data;
                                    return data;
                                }
                        
                                function onErrorAnag(error) {
                                    console.log("Errore nel recupero anagrafiche!", error);
                                }

                                function createFilterFor(query) {
                                    var lowercaseQuery = angular.lowercase(query);

                                    return function filterFn(firmatario) {
                                        var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                                        var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                                        return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                                    };
                                }
                            }],
                        controllerAs: 'vm',
                        size: 'lg',
                        locals: {
                            entity: doc.datiProtocollo || doc.protocolData,
                            protocolState: doc.statoProtocollo || doc.protocolState,
                            editable: vm.isAdmin || vm.isProtocollo || vm.editable,
                            idSeduta: vm.seduta.id,
                            idOdg: vm.odg.id,
                            documents: group.documents,
                            documento: doc,
                            group: group,
                            anagrafiche: AnagraficaProtocollo.query({}).$promise,
                        }
                    });
                }

                function openSenderReceiverDialog(group, docIdx) {
                    var currDoc = group.documents[docIdx];
                    var currGroup = group;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-sender-receiver-dialog.html',
                        controller: 'SenderReceiverDialogController',
                        //size: 'lg',
                        fullscreen: true,
                        controllerAs: 'vm',
                        locals: {
                            $mdDialog: $mdDialog,
                            anagrafiche: AnagraficaProtocollo.query({}).$promise,
                            uffici: AnagraficaProtocollo.query({}).$promise,//AnagraficaProtocollo.listOffices({}).$promise,
                            document: currDoc,
                            group: currGroup
                        }
                    });
                }

                function calculateSingleDocGroups(groupedDocs) {
                    var single = 0;
                    angular.forEach(groupedDocs, function (group) {
                        if (group.documents.length === 1) {
                            single++;
                        }
                    });
                    vm.singleDocumentsCount = single;
                }

                function updateArchiveNowProtocolState(groupedDocs) {
                    var archiveNowCounts = 0;
                    angular.forEach(groupedDocs, function (group) {
                        angular.forEach(group.documents, function (sedutaDoc) {
                            if (sedutaDoc.protocolState === 'ARCHIVE_NOW') {
                                archiveNowCounts++;
                                Documento.getDocSeduta(sedutaDoc.id).then(function (result) {
                                    var resultDoc = result.data;
                                    if (resultDoc.statoProtocollo === 'ARCHIVED' || resultDoc.statoProtocollo === 'ERROR') {
                                        sedutaDoc.protocolData = resultDoc.datiProtocollo;
                                        sedutaDoc.protocolState = resultDoc.statoProtocollo;

                                        sedutaDoc.datiProtocollo = resultDoc.datiProtocollo;

                                        group.protocolState = resultDoc.statoProtocollo;
                                        archiveNowCounts--;
                                    }
                                });
                            }
                        });
                    });

                    if (archiveNowCounts > 0) {
                        $timeout(function () {
                            updateArchiveNowProtocolState(groupedDocs);
                        }, 5000);
                    }
                }

                function validate() {
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var primaryFound = false;
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            primaryFound = primaryFound || file.primary;
                            if (!file.docType || !file.protocolState || !file.visibility) {
                                return false;
                            } else if ((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED')
                                    && (!vm.protocolGroups[j].mittenti || vm.protocolGroups[j].mittenti.length <= 0
                                            || !vm.protocolGroups[j].destinatari || vm.protocolGroups[j].destinatari.length <= 0)) {
                                return false;
                            } else if((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED') && !vm.protocolGroups[j].operatingOfficeSelected) {
                                return false;
                            }
                        }
                        if (!primaryFound) {
                            return false;
                        }
                    }
                    return true;
                }


                function closeDocumentToolbarPanels() {
                    vm.showUpload = false;
                    vm.showDocuments = false;
                    vm.showCloseAll = false;
                }

                function onFileSelect($files) {
                    if($files.length === 0) {
                        return;
                    }
                    var tooBigFiles = [];

                    angular.forEach($files, function (file) {
                        var lastIterator = getAlreadyUploadedGreaterGroupNumber(vm.groupedDocs) + vm.protocolGroups.length;
                    // var lastIterator = vm.groupedDocs.length + vm.protocolGroups.length;
                        if (file.size > MAX_UPLOAD_SIZE) {
                            tooBigFiles.push(file.name);
                        } else {
                            var newSingleUpload = {
                                documents: [],
                                name: lastIterator + 1,
                                protocolState: null,
                                isGroup: false,
                            };

                            file.frontpieceDisabled = isFrontpieceDisabled(file);

                            newSingleUpload.documents.push({
                                name: file.name,
                                type: file.type,
                                size: file.size,
                                protocolGroup: newSingleUpload.name,
                                protocolState: null,
                                protocolOptions: vm.protocolOptions,
                                visibilityStates: vm.visibilityStates,
                                docType: null,
                                frontpiece: false,
                                notArchive: true,
                                frontpieceDisabled: file.frontpieceDisabled,
                                progress: 0,
                                file: file,
                                primary: true,
                                protocolSystem: "JOSH_PROTOCOL"
                            });
                            vm.protocolGroups.push(newSingleUpload);
                            vm.singleFilesCount++;
                        }
                    });
                    

                    displayTooBigFilesWarning(tooBigFiles);
                    $files = [];
                }

                function getAlreadyUploadedGreaterGroupNumber(groupList) {
                    var maxValue = 0;
                    angular.forEach(groupList, function(group) {
                        if(group.name > maxValue) {
                            maxValue = group.name;
                        }        
                    });
                    return maxValue;
                }

                function changeDocumentType(sedutaDoc) {
                    if (!vm.docTypesById) {
                        initDocTypesById();
                    }
                    var newDocumentType = vm.docTypesById[sedutaDoc.tipoDocumento.id];
                    vm.changeDocumentTypeCallback({document: sedutaDoc, newDocumentType: newDocumentType});
                }

                function changeDocumentVisibility(sedutaDoc) {
                    vm.changeDocumentVisibilityCallback({document: sedutaDoc, newDocumentVisibility: sedutaDoc.visibilita});
                }

                function uploadFiles() {
                    var valid = validate();
                    if (!valid) {
                        toastr.error('Per ogni file o gruppo che carichi devi specificare:<ul><li>Tipo Documento</li><li>Tipo Protocollazione</li><li>Visibilità</li></ul>', {
                            timeOut: 60000,
                            extendedTimeOut: 0
                        });
                        return;
                    }

                    vm.uploading = true;

                    //files: an array of files selected, each file has name, size, and type.
                    vm.resetUploads();
                    var totalFiles = 0;
                    var uploadCounter = 0;
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var mittentiId = [];
                        var destinatariId = [];
                        if (vm.protocolGroups[j].documents.length > 0) {
                            angular.forEach(vm.protocolGroups[j].mittenti, function (mittente) {
                                mittentiId.push(mittente.id);
                            });

                            angular.forEach(vm.protocolGroups[j].destinatari, function (destinatario) {
                                destinatariId.push(destinatario.id);
                            });
                        }
                        setProtocolStateForGroup(vm.protocolGroups[j]);
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            totalFiles++;
                            var params = {
                                protocolSystem: file.protocolSystem,
                                idTipoDocumento: file.docType.id,
                                visibilita: file.visibility,
                                frontespizio: file.frontpiece,
                                gruppoProtocollo: file.protocolGroup,
                                statoProtocollo: file.protocolState,
                                primario: file.primary,
                                operatingOffice: vm.protocolGroups[j].operatingOfficeSelected                                
                            };

                            function updateProgress(fileRef) {
                                return function (evt) {
                                    fileRef.progress = parseInt(100.0 * evt.loaded / evt.total);
                                    fileRef.progress = 'info';
                                };
                            }

                            function uploadOutcomeHandler(fileRef, success, iterator) {
                                return function (status) {
                                    fileRef.progress = success ? 100 : fileRef.progress;
                                    fileRef.progressClass = success ? 'success' : 'danger';
                                    uploadCounter++;

                                    if (success) {
                                        if (vm.uploadedFileCallback) {
                                            vm.uploadedFileCallback({documento: fileRef});
                                        }
                                    } else {
                                        var message = 'Impossibile caricare il file: ' + fileRef.name;
                                        if (status && status.message) {
                                            message += '. ERRORE: ' + status.message;
                                        }
                                        toastr.error(message, 'Errore!');
                                    }

                                    if (uploadCounter === totalFiles) {
                                        if(vm.odg.id){
                                            Seduta.protocolNow({id: vm.seduta.id, idOdgDoc: vm.odg.id}, {}, function (result) {
                                            }, function () {
                                                toastr.error('Impossibile completare la protocollazione', 'Errore!');
                                            });
                                            vm.loadDocuments(true);
                                        } else {
                                            vm.loadDocuments(false);
                                        }
                                        vm.uploads = [];

                                        if (success) {
                                            var p1 = $timeout(vm.cancelUpload, 2000);
                                            p1.then(function(){
                                                return $timeout(vm.toggleDocuments);
                                            });
                                        }
                                    }
                                };
                            }
                            //params.mittenti = params.mittenti || [];
                            //params.destinatari = params.mittenti || [];
                            //if(file.primary) {
                            params.mittenti = JSON.stringify(mittentiId);
                            params.destinatari = JSON.stringify(destinatariId);
                            //}
                            if(vm.odg.id) {
                                params.idOdg = vm.odg.id;
                            }
                            var currUpload = Seduta.uploadFileSeduta(vm.seduta.id, file.file, params)
                                    .progress(updateProgress(file))
                                    .success(uploadOutcomeHandler(file, true, j))
                                    .error(uploadOutcomeHandler(file, false));

                            vm.uploads.push(currUpload);
                        }
                    }
                }

                function dragOverClass($event) {
                    var items = $event.dataTransfer.items;
                    var hasFile = false;
                    if (items !== null) {
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].kind === 'file') {
                                hasFile = true;
                                break;
                            }
                        }
                    } else {
                        hasFile = true;
                    }
                    return hasFile ? "dragover" : "dragover-err";
                }

                function resetUploads() {
                    if (vm.uploads) {
                        angular.forEach(vm.uploads, function (upload) {
                            upload.abort();
                        });
                    }
                    vm.uploads = [];
                }

                function downloadDocument(docId, docName) {
                    Documento.getDocSedutaContent(docId).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), docName);
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare il documento', 'Errore!');
                    });
                }

                function downloadGroupDocuments(group) {
                    Documento.getGroupArchive(vm.section.id, group, publicView).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), 'Sezione-' + vm.section.id + '_' + group + '.zip');
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare i documenti', 'Errore!');
                    });
                }

                function removeSingleUpload(group, docIdx) {
                    angular.forEach(group.documents, function (document, iterator) {
                        var currDoc = document;
                        if (currDoc.id === docIdx) {
                            if (vm.removeDocumentCallback) {
                                vm.removeDocumentCallback({documento: currDoc});
                            }
                        }
                    });
                    group.documents.splice(docIdx, 1);
                    if (!group.isGroup) {
                        vm.singleFilesCount--;
                    } else if (group.documents && group.documents.length === 1) {
                        vm.singleFilesCount++;
                    }
                }

                function removeGroupUpload(group) {
                    for (var idx = 0; idx < vm.protocolGroups.length; idx++) {
                        if (vm.protocolGroups[idx].name === group.name) {
                            break;
                        }
                    }
                    vm.protocolGroups.splice(idx, 1);
                }

                function deleteDocument(docId) {
                    $uibModal.open({
                        template: '<div class="modal-header">\
                            <h4 class="modal-title" ng-bind="title"></h4>\
                        </div>\
                        <div class="modal-body" ng-bind="::modalVm.deleteConfirmMsg"></div>\
                        <div class="modal-footer">\
                            <button class="btn btn-default" ng-click="modalVm.deleteDoc()" ng-bind="::modalVm.confirmBtnText"></button>\
                            <button class="btn btn-primary" ng-click="modalVm.cancel()" ng-bind="::modalVm.cancelBtnText"></button>\
                        </div>',
                        controller: ['$uibModalInstance', '$translate', function ($uibModalInstance, $translate) {
                            var modalVm = this;
                            modalVm.deleteConfirmMsg = $translate.instant('documentToolbar.deleteConfirmMsg');
                            modalVm.confirmBtnText = $translate.instant('entity.action.delete');
                            modalVm.cancelBtnText = $translate.instant('entity.action.cancel');

                            modalVm.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                            modalVm.deleteDoc = function () {
                                Documento.deleteDocSedutaContent(docId).then(function () {
                                    for (var i = 0; i < vm.groupedDocs.length; i++) {
                                        var currentGroup = vm.groupedDocs[i];
                                        var isSingleDoc = currentGroup.documents.length === 1;
                                        angular.forEach(vm.groupedDocs[i].documents, function (document, iterator) {
                                            var currDoc = document;
                                            if (currDoc.id === docId) {
                                                if (vm.removeDocumentCallback) {
                                                    vm.removeDocumentCallback({documento: currDoc});
                                                }
                                                currentGroup.documents.splice(iterator, 1);
                                                if (currentGroup.documents.length === 0) {
                                                    if (isSingleDoc) {
                                                        vm.singleDocumentsCount--;
                                                    }
                                                    vm.groupedDocs.splice(i, 1);
                                                } else if (currentGroup.documents.length === 1) {
                                                    vm.singleDocumentsCount++;
                                                }
                                            }
                                        });
                                    }
                                    toastr.success('Eliminazione documento completata');
                                    $uibModalInstance.close();
                                }, function (error) {
                                    console.error(error);
                                    toastr.error('Impossibile eliminare il documento', 'Errore!');
                                });
                            };
                        }],
                        controllerAs: 'modalVm',
                        backdrop: 'static',
                        size: 'lg',
                    });
                }

                function setDefaultVisibility(sedutaDoc) {
                    if (sedutaDoc.docType ) {
                        if(isPublicSedutaDocument(sedutaDoc)) {
                            sedutaDoc.visibility = "PUBLIC";
                        } else if (sedutaDoc.docType.defaultVisibility) {
                            sedutaDoc.visibility = sedutaDoc.docType.defaultVisibility;
                        }
                    } else {
                        sedutaDoc.visibility = vm.defaultVisibility;
                    }
                }

                function isPublicSedutaDocument(sedutaDoc) {
                    return sedutaDoc.docType && 
                    (sedutaDoc.docType.codiceMnemonicoProtocollo === "X0005" || sedutaDoc.docType.codiceMnemonicoProtocollo === "X0510");
                }

                function setPrimaryDoc(documents, primaryDocIdx) {
                    var i = 0;
                    angular.forEach(documents, function (sedutaDoc) {
                        if (i === primaryDocIdx) {
                            sedutaDoc.primary = true;
                        } else {
                            sedutaDoc.primary = false;
                        }
                        i++;
                    });
                }

                function retryProcolAction(group) {
                    group.protocolState = 'ARCHIVE_NOW';
                    angular.forEach(group.documents, function (sedutaDoc) {
                        sedutaDoc.protocolState = 'ARCHIVE_NOW';
                    });
                    Documento.retryProtocolSedutaOdg( vm.seduta.id, vm.odg.id).then(function (result) {
                        if (angular.isArray(group)) {
                            updateArchiveNowProtocolState(group);
                        } else {
                            updateArchiveNowProtocolState([group]);
                        }
                    });
                }

                function canChangeDocumentType(sedutaDoc) {
                    if ($state.current.name !== 'seduta-detail.edit') {
                        return false;
                    }
                    // if (!vm.isProtocollo) {
                    //     return false;
                    // }

                    if (sedutaDoc.owner.id === 'SYSTEM') {
                        return true;
                    }

                    // if (document.owner.authorities) {
                    //     for (var i = 0; i < document.owner.authorities.length; i++) {
                    //         var auth = document.owner.authorities[i];
                    //         if (auth.name === 'ROLE_PROTOCOLLO') {
                    //             return true;
                    //         }
                    //     }
                    // }

                    return true;
                }

                function canChangeDocumentVisibility(sedutaDoc) {
                    if ($state.current.name !== 'seduta-detail.edit') {
                        return false;
                    }
                    if (vm.isAdmin) { 
                        return true;
                    }

                    var authorities = [];
                    authorities = getDocumentAuthorities(sedutaDoc, vm.seduta.legislatura);

                    if(sedutaDoc.owner.id === 'SYSTEM' && vm.isProtocollo) {
                        return true;
                    }

                    if (!vm.editable || sedutaDoc.owner.id === 'SYSTEM' || !Principal.hasAnyAuthority(authorities, vm.seduta.legislatura)) {
                        return false;
                    }

                    if (sedutaDoc.owner.id === vm.user.id) {
                        return true;
                    }

                    var documentCommissioni = getDocumentCommissioni(sedutaDoc, vm.seduta.legislatura);
                    var documentExternalSubjects = getDocumentExternalSubjects(sedutaDoc, vm.seduta.legislatura);
                    
                    if (vm.isCommissione) {
                        return User.hasAnyCommission(vm.user, documentCommissioni, vm.seduta.legislatura) && User.isCommissionRole(vm.user, 'Dipendente', vm.seduta.legislatura);
                    } else if (vm.isSettore) {
                        return User.hasAnySector(vm.user, sedutaDoc.owner.settori);
                    } else if (vm.isExternal) {
                        return User.hasAnyExternalSubject(vm.user, documentExternalSubjects, vm.seduta.legislatura);
                    } else {
                        return true;
                    }
                }

                function getDocumentAuthorities(sedutaDoc, legislatura) {
                    var authorities = [];
                    // Authorities globali
                    if (sedutaDoc.owner.authorities) {
                        angular.forEach(sedutaDoc.owner.authorities, function (auth) {
                            if (auth.name !== 'ROLE_USER') {
                                authorities.push(auth.name);
                            }
                        });
                    }
                    // Authorities per legislatura: solo quella dell'atto corrente
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.authorities
                            ) {
                                angular.forEach(legiAuth.authorities, function (auth) {
                                    if (auth.name !== 'ROLE_USER') {
                                        authorities.push(auth.name);
                                    }
                                });
                            }
                        });
                    }
                    return authorities;
                }

                function getDocumentCommissioni(sedutaDoc, legislatura) {
                    var docCommissioni = [];
                    // Commissioni globali (gestione pregresso)
                    if (sedutaDoc.owner.commissioni) {
                        angular.forEach(sedutaDoc.owner.commissioni, function (comm) {
                            docCommissioni.push(comm);
                        });
                    }
                    // Commissioni per legislatura: solo quella della legislatura della seduta
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.commissioneRuoloAssociato &&
                                legiAuth.commissioneRuoloAssociato.commissione

                            ) {
                                docCommissioni.push(legiAuth.commissioneRuoloAssociato.commissione);
                            }
                        });
                    }
                    return docCommissioni;
                }

                function getDocumentExternalSubjects(sedutaDoc, legislatura) {
                    var docSoggetti = [];
                    // Soggetti globali (gestione pregresso)
                    if (sedutaDoc.owner.soggettiEsterni) {
                        angular.forEach(sedutaDoc.owner.soggettiEsterni, function (sogg) {
                            docSoggetti.push(sogg);
                        });
                    }
                    // Soggetti per legislatura: solo quella della legislatura della seduta
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.soggettiEsterni

                            ) {
                                angular.forEach(legiAuth.soggettiEsterni, function (sogg) {
                                    docSoggetti.push(sogg);
                                });
                            }
                        });
                    }
                    return docSoggetti;
                }

                function displayTooBigFilesWarning(docs) {
                    if (!docs || docs.length === 0) {
                        return;
                    }
                    var msg = 'I seguenti file sono troppo grandi per essere caricati:';
                    angular.forEach(docs, function (doc) {
                        msg += '<br>&bullet;&nbsp;' + doc;
                    });
                    toastr.error('Attenzione', msg);
                }

                function initUserRoles() {
                    vm.isAuthenticated = Principal.isAuthenticated();
                    if (vm.isAuthenticated) {
                        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'], vm.seduta.legislatura);
                        vm.isProtocollo = Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'], vm.seduta.legislatura);
                        vm.isCommissione = Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], vm.seduta.legislatura);
                        vm.isSettore = Principal.hasAnyAuthority(['ROLE_SETTORE'], vm.seduta.legislatura);
                        vm.isExternal = Principal.hasAnyAuthority(['ROLE_EXTERNAL'], vm.seduta.legislatura);
                    }
                }

                function initDocTypesById() {
                    vm.docTypesById = {};
                    angular.forEach(vm.docTypes, function (docType) {
                        vm.docTypesById[docType.id] = docType;
                    });
                }

                function initDocVisibilities() {
                    vm.visibilityStates = [];

                    angular.forEach(GESTIONE_ATTI_DOC_VISIBILITIES, function (docVisibility) {
                        if (!docVisibility.onlyForCommission) {
                            if (docVisibility.value !== 'SECTION_VISIBILITY') {
                                vm.visibilityStates.push(docVisibility);
                            }
                        }
                    });

                }

                function initToolbarSectionVisibilities() {
                    vm.showCloseAll = false;
                    vm.showDocuments = false;
                    vm.showUpload = false;
                }

                function setProtocolStateForSingle(file) {
                    if (file.protocolState === 'NO_ARCHIVE') {
                        file.notArchive = true;
                        file.protocolGroup = 0;
                    } else {
                        file.notArchive = false;
                        //file.frontpiece = !isFrontpieceDisabled(file);
                    }
                }

                function setProtocolStateForGroup(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState ? group.protocolState : file.protocolState;
                        if (file.protocolState === 'NO_ARCHIVE') {
                            file.notArchive = true;
                            file.protocolGroup = 0;
                        } else {
                            file.protocolGroup = group.name;
                            file.notArchive = false;
                            //file.frontpiece = !isFrontpieceDisabled(file);
                        }
                    });
                }

                function isSingleFileGroup(group) {
                    return !vm.isRealGroup(group);
                }

                function isRealGroup(group) {
                    return group && group.documents && group.documents.length > 1;
                }

                function isDeletable(doc) {
                    if (vm.isAdmin) {
                        return doc.protocolState !== "ARCHIVE_NOW" && vm.editable;
                    }
                    return doc.protocolState !== "ARCHIVED" && doc.protocolState !== "ARCHIVE_NOW"
                            && vm.editable;
                }

                function isFrontpieceDisabled(file) {
                    var getExtension = /(?:\.([^.]+))?$/;
                    var extension = getExtension.exec(file.name)[1];
                    if (typeof (extension) === 'undefined' || extension === null) {
                        extension = '';
                    } else {
                        extension = extension.trim().toLowerCase();
                    }
                    return vm.frontespieceAllowedExtensions.indexOf(extension) === -1;
                }


                // FOR ANCHORING TO THE DOCUMENTS 
                /*if(vm.section.anchorToDocuments) {
                    vm.section.showDocuments();
                    $timeout(function () {
                        $anchorScroll(vm.section.id);
                    }, 1500);
                }*/
            }]
    };

});

angular.module('gestioneAttiApp').directive('sectionNotes', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/sectionNotes/sectionNotes.directive.html',
        scope: {
            note: '=',
            disabled: '=',
            showNotes: '=?',
            showToggler: '=?'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: [
            function () {
                var vm = this;
                vm.showNotes = vm.showNotes || false;
            }]
    };
});

angular.module('gestioneAttiApp').directive('sectionLinks', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/sectionLinks/sectionLinks.directive.html',
        scope: {
            defaultLinks: '=?',
            editable: '=',
            links: "=",
            section: '=',
            showLinks: '=?',
            showToggler: '=?'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: [ '$translate',
            function ($translate) {
                var vm = this;

                var DEFAULT_LINKS_MAP = {
                    "burt": $translate.instant('sectionLinks.default.burt'),
                    "regulatoryCollection": $translate.instant('sectionLinks.default.regulatoryCollection'),
                    "bancaDatiDelConsiglio": $translate.instant('sectionLinks.default.bancaDatiDelConsiglio'),
                    "deliberaDefinitiva": $translate.instant('sectionLinks.default.deliberaDefinitiva')
                };
                vm.urlPattern = "(\b(https?|ftp|file)://)?[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]";
                vm.showLinks = vm.showLinks || false;
                vm.includeDefault = (vm.defaultLinks.length) ? true : false;

                var default_links = addDefaultLinksByParameter(vm.defaultLinks);

                vm.canAdd = canAdd;
                vm.addLink = addLink;
                vm.removeItem = removeItem;
                vm.testLink = testLink;

                function addDefaultLinksByParameter(defaultLinks){
                    var links = [];
                    for (var i=0; i < defaultLinks.length; i++) {
                        if (DEFAULT_LINKS_MAP[defaultLinks[i]]){
                            links.push(new Link(DEFAULT_LINKS_MAP[defaultLinks[i]], "", "0", true))
                        }
                    }
                    return links;
                }

                function Link (descr, url, priority, isDefault){
                    this.description = descr;
                    this.url = url;
                    this.ordine = priority;
                    this.isDefault = isDefault || false;
                }

                function addLink(obj){
                    if (!(obj instanceof Link))
                        obj = new Link("", "", "", false);

                    for (var i=0; i < vm.links.length; i++) {
                        var link = vm.links[i];
                        if (obj.description === link.description) return; // Duplicate not accepted
                    }

                    vm.links.push(obj);
                }

                function canAdd() {
                    for (var i=0; i < vm.links.length; i++){
                        var link = vm.links[i];

                        if (link.isDefault) continue;

                        if (!link.url || link.url.length <= 0
                                || !link.description || link.description.length <= 0)
                            return false;
                    }
                    return true;
                }

                function addDefaultLinks(defLink, index, array){
                    if (!(defLink instanceof Link))
                        throw "Default link must be of type Link";

                    for (var i=0; i < vm.links.length; i++) {
                        var link = vm.links[i];
                        if (defLink.description === link.description) return; // Duplicate not accepted
                    }

                    vm.links.unshift(defLink);
                }

                function removeItem(index) {
                    var l = vm.links.length;

                    if (!vm.links[index].isDefault) {
                        if (l === 1) {
                            vm.links[index].description = "";
                            vm.links[index].url = "";
                        } else if (l > 1) {
                            vm.links.splice(index, 1);
                        }
                    } else {
                        vm.links[index].url = "";
                    }
                }

                function testLink(url) {
                    if(url.length)
                        window.open(httpizerURL(url), '_blank');
                }

                function clearLinks () {
                    for (var i=0; i < vm.links.length; i++) {
                        var link = vm.links[i];
                        if (!link.isDefault && !link.description && !link.url)
                            vm.removeItem(i); // Remove empty items
                        else
                            link.url = httpizerURL(link.url); // Add http protocol if absent
                    }
                }

                function httpizerURL(url) {
                    if (url && url.length > 0 && url.indexOf("http") < 0) {
                        return "http://".concat(url);
                    } else {
                        return url;
                    }
                }

                (function init(){
                    clearLinks(); // Dovrebbe essere fatto in validazione
                    if (vm.includeDefault && vm.editable) {
                        default_links.forEach(addDefaultLinks);
                    }
                    if (!vm.includeDefault && !vm.links.length) {
                        vm.links.push(new Link("", "", "", false));
                    }
                })();
            }]
    };
});

angular.module('gestioneAttiApp').directive('rispostaScrittaBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/rispostaScrittaBlock/rispostaScrittaBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            statoPresentatoCollapsed: '=',
            courtOutcome: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.clearRadio = PdlService.clearRadio;
            vm.attoRitiratoDocs = [];
            vm.sezioni = {
                COURT_OUTCOME: {
                    form: (vm.atto.tipoAtto === 'IO' || vm.atto.tipoAtto === 'IS')
                            ? 'app/components/courtroomBlock/io.courtroomOutcome.html'
                            : 'app/components/courtroomBlock/courtroomOutcome.html'
                }
            };

            vm.stato = {
                rispostaScritta: {
                    isCollapsed: vm.statoAttoCorrente === 'RISPOSTA_SCRITTA' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];

        }]
    };
});

angular.module('gestioneAttiApp').directive('retiredBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/retiredBlock/retiredBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            presentationSection: '=',
            statoPresentatoCollapsed: '=',
            viewMode: '=',
            docTypes: "=",
            workDocumentsMap: '=',
            retiredSection: '=',
            utente: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "="
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.actType = vm.atto.tipoAtto;
            vm.attoRitiratoDocs = [];
            vm.retired = {visible: true};
            vm.docPresentationSession = false;
            vm.canEdit = vm.retiredSection.editable;

            Documento.getDocumentiDiRitiroAtto({idAtto: vm.atto.id, mnemonic: 'X0380'}, onSuccess, onError);

            function onSuccess(data) {

                vm.attoRitiratoDocs = data;
                if(vm.attoRitiratoDocs.lenght === 0) {
                    return;
                }
                vm.attoRitiratoDocs.forEach(function(doc){
                    // Provo a settarlo solo se è false
                    // Se il doc di ritiro atto è presente in altre sezioni (oltre che in presentazione) si considera "true"
                    if(!vm.docPresentationSession) {
                        vm.docPresentationSession = (doc.idSezione === vm.presentationSection.id);
                    }
                    if(doc.datiProtocollo && doc.datiProtocollo.numeroProtocolloConsiglio && doc.datiProtocollo.dataProtocolloConsiglio){
                        vm.numeroProtocolloConsiglio = doc.datiProtocollo.numeroProtocolloConsiglio;
                        vm.dataProtocolloConsiglio = doc.datiProtocollo.dataProtocolloConsiglio;
                        return;
                    }
                });
            }

            function onError(error) {
                console.log("An error has occurred retreiving documents for tipo atto Lettera di ritiro atto: ", error);
            }
            vm.sezioni = {
                RETIRED: {
                    form: 'app/components/retiredBlock/retired.html'
                }

            };

            vm.stato = {
                retired: {
                    isCollapsed: vm.statoAttoCorrente === 'RITIRATO' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];

            vm.scrollToPresentationDocs = function() {
                vm.presentationSection.visible = true;
                vm.statoPresentatoCollapsed = true;
                vm.presentationSection.showDocuments();
                //timeout is 0 because otherwise it is fired the anchor scroll before the dom changes
                $timeout(function () {
                    $anchorScroll(vm.presentationSection.id);
                }, 0);
            };
        }]
    };
});

angular.module('gestioneAttiApp').directive('respintoBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/respintoBlock/respintoBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            respinto: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.respinto = {visible: true};

            vm.sezioni = {
                RESPINTO: {
                    form: 'app/components/respintoBlock/respinto.html'
                }
            };

            vm.stato = {
                respinto: {
                    isCollapsed: vm.statoAttoCorrente === 'RESPINTO' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});

/**
 * Created by Michele Romani on 23/06/2017.
 */
(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('NotificationsService', NotificationsService);

    NotificationsService.$inject = ['$resource'];

    function NotificationsService ($resource) {
        var resourceUrl =  'api/notifications/:idAtto';

        return $resource(resourceUrl, { idAtto: '@idAtto', id: '@id'}, {
            'getAllNotifications': {
                method: 'GET',
                isArray: true
            },
            'markAsRead': {
                method: 'PUT',
                url: resourceUrl + '/:id'
            },
            'sendNotification': {
                method: 'POST',
            }
        });
    }
})();

/**
 * Created by Michele Romani on 23/06/2017.
 */
angular.module('gestioneAttiApp').directive('notificationsList', function () {
    return {
        restrict: "E",
        scope: {
            idAtto: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ["$scope", 'NotificationsService', 'Principal', 'Commissione', 'Atto',
            function ($scope, NotificationsService, Principal, Commissione, Atto) {
                var vm = this;
                vm.notifications = [];
                vm.commissioni = [];

                vm.defaultLegislature = [];

                // Ricerca legislatura di default e Commissioni relative
                // NOTA: Le commissioni relative alle notifiche sono SEMPRE quelle della legislatura in corso!!!
                Atto.defaultLegislatura({}, onSuccessLeg, onErrorLeg);
                function onSuccessLeg(data) {
                    vm.defaultLegislature.push(data.legislatura);
                    Commissione.query({legislature: vm.defaultLegislature}, function (commissioni) {
                        vm.commissioni = commissioni;
                        loadNotifications();
                    });
                    vm.showCommissioniReferentiSearch = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_COMMISSIONE'], vm.defaultLegislature[0]);
                }
                function onErrorLeg(error) {
                    console.log('Error loading legislatura default', error);
                }


                vm.loadNotifications = loadNotifications;
                vm.markAsRead = markAsRead;
                vm.search = search;

                vm.showOnlyUnreadNotifications = false;
                vm.idCommissioniReferenti = [];
                vm.openNotification = null;

                

                /* Load all notifications from db*/
                function loadNotifications() {
                    vm.notifications = [];
                    NotificationsService.getAllNotifications({
                        idAtto: null,
                        onlyUnread: vm.showOnlyUnreadNotifications,
                        idCommissioniReferenti: vm.idCommissioniReferenti.length ? JSON.stringify(vm.idCommissioniReferenti) : null
                    }, function (data) {
                        vm.notifications = data || [];
                        calculateUnreadClass();
                    }, function (error) {
                        console.error("Error: ", error);
                    });

                }

                function search(idCommissione) {
                    var idx = vm.idCommissioniReferenti.indexOf(idCommissione);
                    if (idx > -1) {
                        vm.idCommissioniReferenti.splice(idx, 1);
                    } else {
                        vm.idCommissioniReferenti.push(idCommissione);
                    }
                    loadNotifications();
                }

                /* Mark target notification as read*/
                function markAsRead(notification) {
                    Principal.identity().then(function (user) {
                        var isUnread = notification.utentiLetto.indexOf(user.login) < 0;
                        if (isUnread) {
                            NotificationsService.markAsRead({id: notification.id}).$promise.then(function (payload) {
                                notification.utentiLetto.push(user.login);
                                notification.isUnread = false;
                                if (vm.showOnlyUnreadNotifications) {
                                    vm.notifications.splice(vm.notifications.indexOf(notification));
                                }
                            });
                        }
                    });
                }

                /* Init classes to show unread notifications and to initialize css openin animation*/
                function calculateUnreadClass() {
                    Principal.identity().then(function (user) {
                        angular.forEach(vm.notifications, function (notification) {
                            var isUnread = notification.utentiLetto.indexOf(user.login) < 0;
                            notification.isUnread = isUnread;
                            notification.notificationOpen = false;
                        });
                    });
                }

            }],
        templateUrl: 'app/components/notifications/notifications.html'
    };

});

(function () {
    'use strict';

    var macroMateriaMateriaListComponent = {

        templateUrl: 'app/components/macro-materia-materia-list/macro-materia-materia-list.html',
        bindings: {
            // model will be populated with a list of pairs of <macroMateriaId, materiaId>
            'model' : '=',
            'disabled' : '=',
            'macroMateriaList': '=',
            'materiaList': '='
        },
        controller: ['toastr', 'Materia', 'MacroMateria', '$q', function (toastr, Materia, MacroMateria, $q) {
            var vm = this;
            vm.selectedMacroMateria = null;
            vm.selectedMateria = null;
            vm.macroMateriaIdToMateriaListMap = {};
            vm.availableMateriaList = [];
            // list of the row with macro materia and materia with the full object
            vm.translatedRowList = [];
            vm.translating = vm.model && vm.model.length > 0;
            
            translateFromIds();
            initMacroMateriaToMateriaListMap();

            function initMacroMateriaToMateriaListMap() {
                vm.materiaList.forEach(function(materia) {
                    if (vm.macroMateriaIdToMateriaListMap[materia.macroMateria.id]) {
                        vm.macroMateriaIdToMateriaListMap[materia.macroMateria.id].push(materia);
                    } else {
                        vm.macroMateriaIdToMateriaListMap[materia.macroMateria.id] = [materia];
                    }
                });
            }

            function translateFromIds() {
                if (!vm.model || vm.model.length === 0) {
                    vm.translating = false;
                    return;
                }

                var promises = [];
                var fetchedMacroMateria = [];
                var fetchedMateria = [];
                vm.model.forEach(function(pair) {
                    if (pair.materiaId) {
                        promises.push(Materia.get({id: pair.materiaId}, onSuccessMateria, onError).$promise);
                    } else {
                        promises.push(MacroMateria.get({id: pair.macroMateriaId}, onSuccessMacroMateria, onError).$promise);
                    }
                });

                if(promises.length > 0) {
                    $q.all(promises).then(function(result) {
                        vm.model.forEach(function(untraslatedRow){
                            if (untraslatedRow.materiaId) {
                                var materiaTranslated = fetchedMateria.find(function(m){
                                    return m.id === untraslatedRow.materiaId;
                                });
                                if (materiaTranslated) {
                                   vm.translatedRowList.push({macroMateria: materiaTranslated.macroMateria, materia: materiaTranslated}); 
                                }
                            } else {
                                var macroMateriaTranslated = fetchedMacroMateria.find(function(mm){
                                    return mm.id === untraslatedRow.macroMateriaId;
                                });
                                if (macroMateriaTranslated) {
                                   vm.translatedRowList.push({macroMateria: macroMateriaTranslated, materia: null}); 
                                }
                            }
                        });
                        vm.translating = false;
                    });
                }
                function onSuccessMateria(result) { 
                    fetchedMateria.push(result);
                }
                function onSuccessMacroMateria(result) { 
                    fetchedMacroMateria.push(result);
                }
                function onError(error) {
                    console.log('Error while retrieving materia or macromateria ', error);
                }
            }

            vm.macroMateriaChanged = function() {
                vm.selectedMateria = null;
                if (!vm.selectedMacroMateria) {
                    vm.availableMateriaList = [];
                    return;
                }
                vm.availableMateriaList = vm.macroMateriaIdToMateriaListMap[vm.selectedMacroMateria.id];
            }

            vm.addNewMacromateriaMateriaRow = function() {
                if (!vm.model) {
                    vm.model = [];
                }

                // Validate the new row
                var alreadyPresent = vm.translatedRowList.find(function(tr){
                    var sameMacroMateria = vm.selectedMacroMateria.id === tr.macroMateria.id;
                    var sameMateria = (vm.selectedMateria && tr.materia && vm.selectedMateria.id === tr.materia.id) || (!vm.selectedMateria && !tr.materia);
                    return sameMacroMateria && sameMateria; 
                });

                if (alreadyPresent) {
                    toastr.error('Coppia macro materia e materia già presente!');
                    return;
                }
                
                var newRow = {
                    macroMateria: vm.selectedMacroMateria,
                    materia: vm.selectedMateria
                };
                //Valid lets insert it
                vm.translatedRowList.push(newRow);
                vm.selectedMateria = null;
                updateModel();
            }

            vm.changeOrder = function($event, direction, idx) {
                var elem = vm.translatedRowList[idx];
                if(direction < 0 && idx > 0) {
                    vm.translatedRowList.splice(idx, 1);
                    vm.translatedRowList.splice(idx - 1, 0, elem);
                } else if(direction >= 0 && idx >= 0 && idx < vm.translatedRowList.length - 1) {
                    vm.translatedRowList.splice(idx, 1);
                    vm.translatedRowList.splice(idx + 1, 0, elem);
                }
                updateModel();
            }

            vm.onDeleteRow = function(idx) {
                vm.translatedRowList.splice(idx, 1);
                updateModel();
            }

            /**
             * Recreate the model from the list of translated rows
             */
            function updateModel() {
                var newModel = [];
                vm.translatedRowList.forEach(function(row, idx){
                    newModel.push({macroMateriaId: row.macroMateria.id, materiaId: row.materia ? row.materia.id : null, progressivo: idx + 1});
                });
                vm.model = newModel;
            }
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('macroMateriaMateriaListComponent', macroMateriaMateriaListComponent);
})();

(function () {
    'use strict';

    var macroMateriaChipSearchComponent = {

        templateUrl: 'app/components/macro-materia-chip-search/macro-materia-chip-search.html',
        bindings: {
            'model' : '=',
            'macroMateriaList' : '=',
            'maxChips' : '=',
            'disabled' : '=',
            'onModelChange': '<',
            'label': '@',
            'showEndDate' : '@'
        },
        controller: ['toastr', '$scope', function (toastr, $scope) {
            var vm = this;
            vm.selectedMacroMateria = vm.model ? [vm.model] : [];

            vm.searchMacroMateria = function (tokenMacroMateria) {
                var results = vm.macroMateriaList ? vm.macroMateriaList : [];
                return tokenMacroMateria ? results.filter(createFilterForMacroMateria(tokenMacroMateria)) : [];
            }
    
            function createFilterForMacroMateria(tokenMacroMateria) {
                return function filterFn(macroMateria) {
                    var description = macroMateria.description;
                    var code = macroMateria.code;
                    return description.toLowerCase().includes(tokenMacroMateria.toLowerCase()) || code.toString().includes(tokenMacroMateria.toString());
                };
            }
            vm.changedMacroMateria = function() {
                var output;
                if (vm.maxChips && vm.maxChips === 1) {
                    output = vm.selectedMacroMateria ? vm.selectedMacroMateria[0] : null;
                } else {
                    output = vm.selectedMacroMateria;
                }
                vm.model = output;
                
                setTimeout(function(){ 
                    if (vm.onModelChange != null) {
                        vm.onModelChange(output);
                    } 
                },0);
            }
            /**
             * Clean both the outer and inned models
             */
            $scope.$on('cleanMacroMateriaChip', function() {
                vm.selectedMacroMateria = [];
                vm.model = null;
            });
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('macroMateriaChipSearchComponent', macroMateriaChipSearchComponent);
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'Principal'];

    function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                                
                Principal.identity().then(function (result) {
                    $rootScope.userDescription = result.firstName + " " + result.lastName;
                });
                
                $uibModalInstance.close();
                if ($state.current.name === 'home' || $state.current.name === 'register' || $state.current.name === 'activate' ||
                        $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $timeout(function () {
                        $state.go('home', {}, {reload: 'home'})
                    }, 0);
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });

        }

        function register() {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .filter('findLanguageFromKey', findLanguageFromKey);

    angular
            .module('gestioneAttiApp')
            .filter('yesNo', function () {
                return function (input) {
                    return input ? 'Sì' : 'No';
                };
            });

    angular
            .module('gestioneAttiApp')
            .filter('protocolState', function () {
                return function (input) {
                    if (input === 'ARCHIVED') {
                        return 'Protocollato';
                    } else if (input === 'TO_BE_ARCHIVED') {
                        return 'Da Protocollare';
                    } else if (input === 'ARCHIVE_NOW') {
                        return 'Protocollazione in corso';
                    } else if (input === 'ALREADY_ARCHIVED') {
                        return 'Già protocollato';
                    } else if (input === 'ERROR') {
                        return 'Errore';
                    } else {
                        return 'Non Protocollato';
                    }
                };
            });

    angular
            .module('gestioneAttiApp')
            .filter('visibility', function () {
                return function (input) {
                    if (input === 'PUBLIC') {
                        return 'Pubblico';
                    } else if (input === 'INTRANET') {
                        return 'Intranet';
                    } else if (input === 'COMMISSION_MEMBER') {
                        return 'Membro commissione';
                    } else if (input === 'COMMISSION_PRESIDENT') {
                        return 'Presidente commissione';
                    } else if (input === 'SECTION_VISIBILITY') {
                        return 'Sezione';
                    } else {
                        return '';
                    }
                };
            });

    angular
            .module('gestioneAttiApp')
            .filter('protocolDirection', function () {
                return function (input) {
                    if (input === 'P') {
                        return 'Partenza';
                    } else if (input === 'A') {
                        return 'Arrivo';
                    } else {
                        return '';
                    }
                };
            });

    angular
            .module('gestioneAttiApp')
            .filter('romanize', function () {
                return function (num) {
                    if (!+num)
                        return false;
                    var digits = String(+num).split(""),
                        key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
                            "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
                            "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
                        roman = "",
                        i = 3;
                    while (i--)
                        roman = (key[+digits.pop() + (i * 10)] || "") + roman;
                    return Array(+digits.join("") + 1).join("M") + roman;
                };
            });

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

angular.module('gestioneAttiApp').directive('inammissibileBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/inammissibileBlock/inammissibileBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            inammissibile: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.inammissibile = {visible: true};

            vm.sezioni = {
                INAMMISSIBILE: {
                    form: 'app/components/inammissibileBlock/inammissibile.html'
                }
            };

            vm.stato = {
                inammissibile: {
                    isCollapsed: vm.statoAttoCorrente === 'INAMMISSIBILE' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});

angular.module('gestioneAttiApp').directive('improcedibileBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/improcedibileBlock/improcedibileBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            improcedibile: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.improcedibile = {visible: true};

            vm.sezioni = {
                IMPROCEDIBILE: {
                    form: 'app/components/improcedibileBlock/improcedibile.html'
                }
            };

            vm.stato = {
                improcedibile: {
                    isCollapsed: vm.statoAttoCorrente === 'IMPROCEDIBILE' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});

angular.module('gestioneAttiApp').directive('giuntaTrasmissionBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/giuntaTrasmissionBlock/giuntaTrasmissionBlock.html',
        scope: {
            atto: '=',
            docTypes: "=",
            statoAttoCorrente: '=',
            workDocumentsMap: '=',
            giuntaTrasmissionSection: '=',
            utente: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            viewMode: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            vm.attoRitiratoDocs = [];
            vm.clearRadio = PdlService.clearRadio;
            vm.giuntaTrasmission = {visible: true};
            vm.sezioni = {
                GIUNTA_TRASMISSION: {
                    form: 'app/components/giuntaTrasmissionBlock/giuntaTrasmissionSection.html'
                }
            };

            vm.stato = {
                giuntaTrasmission: {
                    isCollapsed: vm.statoAttoCorrente === 'TRASMISSIONE GIUNTA' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];

        }]
    };
});

/**
 * Created by Michele Romani on 27/06/2017.
 */
angular.module('gestioneAttiApp').directive('formToolbar',  function () {
    return {
        restrict: "E",
        scope: {
        },
        controller: ["$scope",
            function ($scope) {
                var vm = this;
            }],
        templateUrl: 'app/components/formToolbar/formToolbar.html'
    }
});

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';

    var eventMailNotificationButtonComponent = {

        templateUrl: 'app/components/eventMailNotificationButton/eventMailNotificationButton.html',
        bindings: {
            'eventType' : '=',
            'atto' : '=',
        },
        controller: ['Atto','toastr', 'EVENTI_NOTIFICA_ATTO', '$mdDialog', '$translate', function (Atto, toastr, EVENTI_NOTIFICA_ATTO, $mdDialog, $translate) {
            var vm = this;
            var notifica = EVENTI_NOTIFICA_ATTO[EVENTI_NOTIFICA_ATTO.findIndex(function(evento) {return evento.value === vm.eventType})];
            var notificaDescr = $translate.instant(notifica.name);
            var confirmDlg = $mdDialog.confirm()
            .title('ATTENZIONE!')
            .textContent("Si ricorda che le email sono mandate automaticamente dall'applicazione! Se confermi la seguente operazione saranno notificate via email tutte le liste di distribuzione interessate a questo evento! L'evento interessato e': " + notificaDescr)
            .ariaLabel('conferma Aria Label')
            .ok('Conferma Invio Email')
            .cancel('Annulla');
            
            vm.isSendingMails = false;
            vm.onButtonClick = function() {
                $mdDialog.show(confirmDlg).then(function () {
                    sendEventNotification();        
                }, function(){});
            }

            function sendEventNotification() {
                vm.isSendingMails = true; 
                Atto.sendAttoNotificationByEmail({idAtto: vm.atto.id, eventoNotificaAtto: vm.eventType}, {}, 
                    function(result) {
                        vm.isSendingMails = false;
                        toastr.success('Notifiche mandate con successo!');
                    },
                    function(error) {
                        vm.isSendingMails = false;
                        toastr.error('Errore durante invio delle notifiche!');
                    }
                );
            }
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('eventMailNotificationButtonComponent', eventMailNotificationButtonComponent);
})();

angular.module('gestioneAttiApp').directive('emendments', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/emendments/emendments.directive.html',
        scope: {
            editable: '=',
            emendments: '=',
            includeState: '=',
            invalidFields: '=?',
            peopleList: '=?',
            postponementNumber: '=?',
            validating: '=?',
            sezioneId: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['AnagraficaProtocollo', 'toastr', 'Documento', function (AnagraficaProtocollo, toastr, Documento) {
                var vm = this;
                vm.documentiEmendamento = Documento.getDocumentiEmendamento({sezioneId: vm.sezioneId}, onDocumentSuccess, onDocumentFail);
                function onDocumentSuccess(data){                 
                    var ementamentiFromDocumento = [];
                    data.forEach(function(document){
                        if(document.datiProtocollo && document.datiProtocollo.numeroProtocolloConsiglio && !protocolloAlreadyPresent(document.datiProtocollo.numeroProtocolloConsiglio)) {
                            ementamentiFromDocumento.push(
                                {
                                    firmatari: document.mittentiProtocollo,
                                    dataProtocollo: document.datiProtocollo.dataProtocolloConsiglio,
                                    protocollo: document.datiProtocollo.numeroProtocolloConsiglio
                                })
                        }
                    });

                    angular.forEach(ementamentiFromDocumento, function (emendment) {
                        vm.emendments.push(emendment);
                        vm.extendedEmendments.push({
                            emendment: emendment,
                            searchFunction: searchFunction()
                        });
                    });
                }

                function protocolloAlreadyPresent(numero) {
                    if(!vm.emendments || vm.emendments.length === 0) {
                        return false;
                    }
                    for(var i=0; i < vm.emendments.length; i++){
                        if( vm.emendments[i].protocollo &&  vm.emendments[i].protocollo == numero){
                            return true;
                        }   
                    }
                    return false;
                }

                function onDocumentFail(error) {
                    console.log("Error retriving emendamenti documents: " + error);
                }

                vm.invalidFields = vm.invalidFields || [];
                vm.postponementSuffix = '';
                if (vm.postponementNumber && vm.postponementNumber > 0) {
                    vm.postponementSuffix = '_' + vm.postponementNumber;
                }

                vm.firmatari = [];
                vm.emendments = vm.emendments || [];
                vm.states = ['APPROVED', 'REJECTED', 'WITHDRAWN', 'UNACCEPTABLE', 'DECAYED'];

                vm.extendedEmendments = [];
                angular.forEach(vm.emendments, function (emendment) {
                    vm.extendedEmendments.push({
                        emendment: emendment,
                        searchFunction: searchFunction()
                    });
                });

                vm.isInvalidField = function (fieldName, idx) {
                    return vm.invalidFields.indexOf(fieldName + vm.postponementSuffix + '_' + idx) > -1;
                };

                vm.newEmendment = function () {
                    var emendment = {firmatari: []};
                    vm.emendments.push(emendment);
                    vm.extendedEmendments.push({
                        emendment: emendment,
                        searchFunction: searchFunction()
                    });
                };

                vm.removeEmendment = function (idx) {
                    if (vm.extendedEmendments.length === 1) {
                        var emendment = {firmatari: []};
                        vm.emendments[0] = emendment;
                        vm.extendedEmendments[0].emendment = emendment;
                        return;
                    }

                    vm.extendedEmendments.splice(idx, 1);
                    vm.emendments.splice(idx, 1);
                };

                vm.addPersonToList = function (chip) {
                    // If it is an object, it's already a known chip
                    if (angular.isObject(chip)) {
                        return chip;
                    }
                    // Otherwise, create a new one
                    return {descrizione: chip};
                };

                if (vm.peopleList) {
                    vm.firmatari = vm.peopleList;
                } else {
                    //load firmatari (persone generiche atm)
                    AnagraficaProtocollo.query({}, function (anagrafiche) {
                        vm.firmatari = anagrafiche;
                    }, function (error) {
                        toastr.error('Impossibile reperire la lista dei firmatari: ' + error.message, 'Errore!');
                    });
                }

                function searchFunction() {
                    return function (query) {
                        var results = query ? vm.firmatari.filter(createFilterFor(query)) : [];
                        return results;
                    };
                }

                function createFilterFor(query) {
                    var lowercaseQuery = angular.lowercase(query);

                    return function filterFn(firmatario) {
                        var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                        var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                        return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                    };

                }

                //Not needed anymore because now emendments come only from protocollo
/*                 if (vm.emendments.length === 0) {
                    vm.newEmendment();
                } */


                vm.isAddButtonEnabled = function (index) {
                    if (vm.disabled || !vm.emendments || vm.emendments[index] && index !== vm.emendments.length - 1) {
                        return false;
                    }
                    var emendment = vm.emendments[index];
                    if (!emendment) {
                        return false;
                    }
                    
                    if (vm.includeState && !emendment.state) {
                        return false;
                    }
                    return emendment.numeroEmendamento && emendment.dataProtocollo && emendment.protocollo && emendment.firmatari && emendment.firmatari.length > 0;
                };
            }]
    };

});

(function () {
    'use strict';

    angular.module('gestioneAttiApp').controller('SenderReceiverDialogController', SenderReceiverDialogController);

    SenderReceiverDialogController.$inject = ['$mdDialog', 'anagrafiche', 'document', 'group', 'uffici', 'AnagraficaProtocollo'];

    function SenderReceiverDialogController($mdDialog, anagrafiche, document, group, uffici, AnagraficaProtocollo) {
        var descAnagraficaMaxLength = 20;

        var vm = this;
        vm.userOperatingOffices = [];
        vm.selectedSenderSearchText = '';
        vm.selectedReceiverSearchText = '';
        vm.anagrafiche = anagrafiche;
        vm.uffici = uffici;
                
        vm.document = document;
        vm.group = group;
        
        vm.group.mittenti = vm.group.mittenti || [];
        vm.group.destinatari = vm.group.destinatari || [];
        
        AnagraficaProtocollo.userOperatingOffices({}, function (data) {
            vm.userOperatingOffices = data.operatingOffice;
            if (data.operatingOffice.length === 1) {
                vm.group.operatingOfficeSelected = data.operatingOffice[0].code;
            }
        }, function (error) {
            console.log(error);
        });

        vm.getPlaceholder = function () {
            if (vm.group.operatingOfficeSelected) {
                return vm.group.operatingOfficeSelected.description;
            } else {
                return "Seleziona l'ufficio operante!"
            }
        }
        
        
        vm.clear = function () {
            $mdDialog.cancel();
        };
        
        vm.addPersonToList = function (chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {descrizione: chip};
        };

        
        vm.searchUffici = function (searchText) {
            return searchText ? vm.uffici.filter(createFilterFor(searchText)) : [];
        };
        
        vm.searchAnagrafiche = function (searchText) {
            
            //return searchText ? vm.anagrafiche.filter(createFilterFor(searchText)) : [];

            if(searchText.length < 3) {
                return [];
            }

            return AnagraficaProtocollo.search(
                { 
                    term: searchText,
                    protocolSystem: vm.document.protocolSystem,
                    page: 0,
                    size: 20
                }).$promise.then(onSuccessAnag, onErrorAnag);

        };

        function onSuccessAnag(data, headers) {
            vm.anagrafiche = data;
            return vm.anagrafiche;
        }

        function onErrorAnag(error) {
            console.log("Errore nel recupero anagrafiche!", error);
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(anag) {
                var codice = anag.codice ? anag.codice.toLowerCase() : '';
                var descrizione = anag.descrizione ? anag.descrizione.toLowerCase() : '';
                return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
            };
        }
        
        vm.getDescAnagrafica = function(item, limitText) {
            var email = item.anagraficaProtocollo.emailPec || item.anagraficaProtocollo.email;
            var desc = item.descrizione + ' ' + (email ? '(' + email + ')' : '(EMAIL NON PRESENTE)');
            if (limitText && desc.length > descAnagraficaMaxLength) {
                desc = item.descrizione.substring(0, descAnagraficaMaxLength) + ' ' + (email ? '(' + email + ')' : '(EMAIL NON PRESENTE)');
            }
            return desc;
        };
    }
})();

angular.module('gestioneAttiApp').directive('documentToolbar', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/documentToolbar/documentToolbar.directive.html',
        scope: {
            changeDocumentTypeCallback: '&?',
            changeDocumentVisibilityCallback: '&?',
            changeDocumentFrontpieceCallback: '&?',
            removeDocumentCallback: '&?',
            defaultLinks: '=?',
            documentTypes: '=?',
            editable: '=',
            includeLinks: '=?',
            includeNotes: '=?',
            publicView: '=?',
            section: '=',
            uploadedFileCallback: '&',
            user: '=',
            tipoAtto: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'Documento', 'AnagraficaProtocollo', 'toastr', 'FileSaver', '$timeout', '$uibModal', 'Principal', 'GESTIONE_ATTI_DOC_VISIBILITIES', 'MAX_UPLOAD_SIZE', '$mdDialog', 'User', '$anchorScroll','$state', 'PROTOCOLLAZIONE_DISABILITATA',
            function (Atto, Documento, AnagraficaProtocollo, toastr, FileSaver, $timeout, $uibModal, Principal, GESTIONE_ATTI_DOC_VISIBILITIES, MAX_UPLOAD_SIZE, $mdDialog, User, $anchorScroll, $state, PROTOCOLLAZIONE_DISABILITATA) {
                var vm = this;

                vm.includeNotes = vm.includeNotes || false;
                vm.includeLinks = vm.includeLinks || true;
                vm.defaultLinks = vm.defaultLinks || [];
                
                vm.instantProtocolEnabled = vm.user && vm.user.instantProtocolEnabled;

                initUserRoles();
                initToolbarSectionVisibilities();

                vm.commissionPresidentOrMember = false;

                vm.uploadPanel = 'app/components/documentToolbar/documentToolbar.uploadPanel.html';
                vm.documentsPanel = 'app/components/documentToolbar/documentToolbar.documentsPanel.html';
                vm.documentTableBody = 'app/components/documentToolbar/documentToolbar.documentTableBody.html';

                vm.docTypes = vm.documentTypes || [];

                vm.files = [];
                vm.uploading = false;
                vm.uploadingGroup = false;
                vm.protocolGroups = [];
                vm.singleFilesCount = 0;
                vm.singleDocumentsCount = 0;

                vm.defaultVisibility = "INTRANET";

                vm.frontespieceAllowedExtensions = ['pdf'];

                vm.canChangeDocumentType = canChangeDocumentType;
                vm.canChangeDocumentVisibility = canChangeDocumentVisibility;
                vm.changeDocumentType = changeDocumentType;
                vm.changeDocumentVisibility = changeDocumentVisibility;
                vm.changeDocumentFrontpiece = changeDocumentFrontpiece;
                vm.closeDocumentToolbarPanels = closeDocumentToolbarPanels;
                vm.deleteDocument = deleteDocument;
                vm.downloadDocument = downloadDocument;
                vm.downloadGroupDocuments = downloadGroupDocuments;
                vm.dragOverClass = dragOverClass;
                vm.enableSectionNotes = enableSectionNotes;
                vm.isDeletable = isDeletable;
                vm.isLinkPresent = isLinkPresent;
                vm.isRealGroup = isRealGroup;
                vm.isSingleFileGroup = isSingleFileGroup;
                vm.loadDocuments = loadDocuments;
                vm.onFileSelect = onFileSelect;
                vm.openProtocolDataDialog = openProtocolDataDialog;
                vm.openSenderReceiverDialog = openSenderReceiverDialog;
                vm.removeGroupUpload = removeGroupUpload;
                vm.removeSingleUpload = removeSingleUpload;
                vm.resetUploads = resetUploads;
                vm.retryProcolAction = retryProcolAction;
                vm.setDefaultVisibility = setDefaultVisibility;
                vm.setPrimaryDoc = setPrimaryDoc;
                vm.setProtocolStateForGroup = setProtocolStateForGroup;
                vm.setProtocolStateForSingle = setProtocolStateForSingle;
                vm.showLinksToggler = showLinksToggler;
                vm.uploadFiles = uploadFiles;
                vm.isFrontpieceDisabled = isFrontpieceDisabled;

                vm.loadDocuments(false);

                vm.setProtocolStateForAllFilesOfGroup = function(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState;
                    });
                };

                vm.setProtocolSystemForAllFilesOfGroup = function(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolSystem = group.protocolSystem;
                    });
                };

                vm.protocolOptions = [
                    {
                        'value': 'NO_ARCHIVE',
                        'textKey': 'documentToolbar.noArchive'
                    },
                    {
                        'value': 'ALREADY_ARCHIVED',
                        'textKey': 'documentToolbar.alreadyArchived'
                    }
                ];

                if (!PROTOCOLLAZIONE_DISABILITATA && vm.editable && vm.section.nomeSezione !== "POST_COURT"
                        && vm.section.nomeSezione !== "CONSTITUTIONAL_APPEAL") {
                    vm.protocolOptions.push({
                        'value': 'TO_BE_ARCHIVED',
                        'textKey': 'documentToolbar.toBeArchived'
                    });
                }

                if (!PROTOCOLLAZIONE_DISABILITATA && vm.instantProtocolEnabled) {
                    vm.protocolOptions.push({
                        'value': 'ARCHIVE_NOW',
                        'textKey': 'documentToolbar.toBeImmediatelyArchived'
                    });
                }

                // by Anno too
                vm.orderByNumeroProtocolloConsiglio = function(v1, v2){
                    if(!v2) {
                        return 1;
                    }
                    var doc1 = v1.value.documents[0];
                    var doc2 = v2.value.documents[0];
                    if(!doc1 || !doc1.datiProtocollo || !doc1.datiProtocollo.numeroProtocolloConsiglio) {
                        return -1;
                    } else if(!doc2 || !doc2.datiProtocollo || !doc2.datiProtocollo.numeroProtocolloConsiglio) {
                        return 1;
                    } else {
                        var dataProtCons1 = new Date(doc1.datiProtocollo.dataProtocolloConsiglio);
                        var dataProtCons2 = new Date(doc2.datiProtocollo.dataProtocolloConsiglio);
                        // Protocolli di anno differente possono avere un numero uguale o inferiori, quindi prima si ordina per anno
                        if (dataProtCons1 && dataProtCons2 && dataProtCons1.getFullYear() !== dataProtCons2.getFullYear()) {
                            if (dataProtCons1.getFullYear() < dataProtCons2.getFullYear()) {
                                return 1;    
                            } else {
                                return -1;
                            }
                        }
                        if(doc1.datiProtocollo.numeroProtocolloConsiglio <= doc2.datiProtocollo.numeroProtocolloConsiglio){
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                };

                vm.toggleUpload = function () {
                    if (vm.showUpload) {
                        vm.showUpload = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showUpload = true;
                        vm.showCloseAll = true;
                        vm.showDocuments = false;
                        vm.showNotes = false;
                        vm.showLinks = false;
                    }
                };

                vm.toggleDocuments = function () {
                    if (vm.showDocuments) {
                        vm.showDocuments = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showDocuments = true;
                        vm.showCloseAll = true;
                        vm.showUpload = false;
                        vm.showNotes = false;
                        vm.showLinks = false;
                    }
                };

                vm.section.showDocuments = function(){
                    vm.showDocuments = true;
                    vm.showCloseAll = true;
                    vm.showUpload = false;
                    vm.showNotes = false;
                    vm.showLinks = false;
                };

                vm.toggleNotes = function () {
                    if (vm.showNotes) {
                        vm.showNotes = false;
                    } else {
                        vm.showNotes = true;
                        vm.showDocuments = false;
                        vm.showCloseAll = false;
                        vm.showUpload = false;
                        vm.showLinks = false;
                    }
                };

                vm.toggleLinks = function () {
                    if (vm.showLinks) {
                        vm.showLinks = false;
                    } else {
                        vm.showLinks = true;
                        vm.showNotes = false;
                        vm.showDocuments = false;
                        vm.showCloseAll = false;
                        vm.showUpload = false;
                    }
                };

                vm.cancelUpload = function () {
                    vm.resetUploads();
                    vm.uploading = false;
                    vm.showUpload = false;
                    vm.protocolGroups = [];
                    vm.singleFilesCount = 0;
                    //vm.singleDocumentsCount = 0;
                };

                function openProtocolDataDialog(group) {
                    var doc = group.documents[0];
                    doc.protocoldDataOpen = true;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-dialog-editable.html',
                        controller: ['$scope', '$mdDialog', 'Atto', 'entity', 'protocolState', 'editable', 'idSezione', 'idAtto', 'documents', 'documento', 'group', 'tipoAtto', 'anagrafiche',
                            function ($scope, $mdDialog, Atto, entity, protocolState, editable, idSezione, idAtto, documents, documento, group, tipoAtto, anagrafiche) {
                                var vm = this;
                                vm.protocolData = entity || {};
                                vm.protocolState = protocolState;
                                vm.editable = editable;
                                vm.documents = documents;
                                vm.documento = documento;
                                vm.anagrafiche = [];//anagrafiche;
                                vm.selectedSenderSearchText = '';
                                vm.selectedReceiverSearchText = '';
                                vm.group = group;
                                Atto.getFilingCode({'tipoAtto': tipoAtto, 'protocolSystem': doc.protocolSystem}, {}, function (value) {
                                    vm.protocolData.classificazioneArchivistica = value.data;
                                }, function (reason) {
                                    toastr.error('Impossibile Recuperare il Codice Classificazione ', 'Errore!');
                                });

                                vm.dataProtocolloMittenteAusiliare;

                                vm.dataProtocolloMittenteAusiliareChanged = function() {
                                    vm.protocolData.dataProtocolloMittente = vm.dataProtocolloMittenteAusiliare;
                                };
                                
                                vm.isDataProtocolloMittentiWrong = function(){
                                    if(!vm.protocolData || !vm.protocolData.dataProtocolloMittente){
                                        return true;
                                    }
                                    var data = new Date(vm.protocolData.dataProtocolloMittente);
                                    if(data.getFullYear() == 1000) {
                                        return true;
                                    }
                                    return false;
                                };

                                vm.clear = function () {
                                    $mdDialog.cancel();
                                };

                                vm.checkProtocolState = function (protocolState) {
                                    return protocolState === 'ALREADY_ARCHIVED';
                                };

                                vm.saveProtocolData = function () {
                                    // Non è possibile salvare i dettagli se è presente solo uno tra "dataProtocolloConsiglio" e "numeroProtocolloConsiglio"
                                    if(vm.protocolData.dataProtocolloConsiglio && !vm.protocolData.numeroProtocolloConsiglio 
                                        || !vm.protocolData.dataProtocolloConsiglio && vm.protocolData.numeroProtocolloConsiglio) {
                                        toastr.error('Inserire sia il numero di protocollo che la data di protocollo', 'Errore!');
                                        return;
                                    }
                                    if(vm.protocolData && vm.protocolData.dataProtocolloConsiglio && vm.protocolData.dataProtocolloConsiglio instanceof Date) {
                                        // Quando la data è impostata dal datepicker è di tipo Date
                                        //Converte la data in UTC altrimenti da BE viene fatto un parsing errato
                                        var newDataProtCons = new Date(Date.UTC(vm.protocolData.dataProtocolloConsiglio.getFullYear(), 
                                        vm.protocolData.dataProtocolloConsiglio.getMonth(),
                                        vm.protocolData.dataProtocolloConsiglio.getDate()));
                                        vm.protocolData.dataProtocolloConsiglio = newDataProtCons;
                                    } // Altrimenti La data è in formato stringa "dd-MM-yyyy" quindi non è stata modificata
                                    angular.forEach(vm.documents, function (doc) {
                                        doc.datiProtocollo = vm.protocolData;
                                    });
                                    Atto.updateFileProtocolData(idAtto, idSezione, documents).then(
                                            function (response) {
                                                toastr.success('Dati di protocollazione salvati', 'Successo!');
                                            },
                                            function (response) {
                                                toastr.error('Impossibile salvare i dati di protocollazione', 'Errore!');
                                            });
                                    vm.clear();
                                };

                                vm.addPersonToList = function (chip) {
                                    // If it is an object, it's already a known chip
                                    if (angular.isObject(chip)) {
                                        return chip;
                                    }
                                    // Otherwise, create a new one
                                    return {descrizione: chip};
                                };


                                // vm.searchFirmatari = function (searchText) {
                                //     var lista = vm.anagrafiche;
                                //     return searchText ? lista.filter(createFilterFor(searchText)) : [];
                                // };

                                vm.searchFirmatari = function (searchText) {

                                    if(searchText.length < 3) {
                                        return [];
                                    }
                        
                                    return AnagraficaProtocollo.search(
                                        { 
                                            term: searchText,
                                            protocolSystem: vm.documento.protocolSystem,
                                            page: 0,
                                            size: 20
                                        }).$promise.then(onSuccessAnag, onErrorAnag);
                        
                                };
                        
                                function onSuccessAnag(data, headers) {
                                    vm.anagrafiche = data;
                                    return data;
                                }
                        
                                function onErrorAnag(error) {
                                    console.log("Errore nel recupero anagrafiche!", error);
                                }
                        

                                function createFilterFor(query) {
                                    var lowercaseQuery = angular.lowercase(query);

                                    return function filterFn(firmatario) {
                                        var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                                        var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                                        return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                                    };
                                }
                            }],
                        controllerAs: 'vm',
                        size: 'lg',
                        locals: {
                            entity: doc.datiProtocollo || doc.protocolData,
                            protocolState: doc.statoProtocollo || doc.protocolState,
                            editable: vm.isAdmin || vm.isProtocollo || vm.editable,
                            idSezione: vm.section.id,
                            idAtto: vm.section.idAtto,
                            documents: group.documents,
                            documento: doc,
                            group: group,
                            tipoAtto: vm.tipoAtto,
                            anagrafiche: AnagraficaProtocollo.query({protocolSystem: doc.protocolSystem}).$promise,
                        }
                    });
                }

                function openSenderReceiverDialog(group, docIdx) {
                    var currDoc = group.documents[docIdx];
                    var currGroup = group;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-sender-receiver-dialog.html',
                        controller: 'SenderReceiverDialogController',
                        //size: 'lg',
                        fullscreen: true,
                        controllerAs: 'vm',
                        locals: {
                            $mdDialog: $mdDialog,
                            anagrafiche: AnagraficaProtocollo.query({}).$promise,
                            uffici: AnagraficaProtocollo.query({}).$promise,//AnagraficaProtocollo.listOffices({}).$promise,
                            document: currDoc,
                            group: currGroup
                        }
                    });
                }

                function calculateSingleDocGroups(groupedDocs) {
                    var single = 0;
                    angular.forEach(groupedDocs, function (group) {
                        if (group.documents.length === 1) {
                            single++;
                        }
                    });
                    vm.singleDocumentsCount = single;
                }

                function updateArchiveNowProtocolState(groupedDocs) {
                    var archiveNowCounts = 0;
                    angular.forEach(groupedDocs, function (group) {
                        angular.forEach(group.documents, function (doc) {
                            if (doc.protocolState === 'ARCHIVE_NOW') {
                                archiveNowCounts++;
                                Documento.get({id: doc.id}, function (result) {
                                    if (result.statoProtocollo === 'ARCHIVED' || result.statoProtocollo === 'ERROR') {
                                        doc.protocolData = result.datiProtocollo;
                                        doc.protocolState = result.statoProtocollo;

                                        doc.datiProtocollo = result.datiProtocollo;

                                        group.protocolState = result.statoProtocollo;
                                        archiveNowCounts--;
                                    }
                                });
                            }
                        });
                    });

                    if (archiveNowCounts > 0) {
                        $timeout(function () {
                            updateArchiveNowProtocolState(groupedDocs);
                        }, 5000);
                    }
                }

                function validate() {
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var primaryFound = false;
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            primaryFound = primaryFound || file.primary;
                            if (!file.docType || !file.protocolState || !file.visibility) {
                                return false;
                            } else if ((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED')
                                    && (!vm.protocolGroups[j].mittenti || vm.protocolGroups[j].mittenti.length <= 0
                                            || !vm.protocolGroups[j].destinatari || vm.protocolGroups[j].destinatari.length <= 0)) {
                                return false;
                            } else if((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED') && !vm.protocolGroups[j].operatingOfficeSelected) {
                                return false;
                            }
                        }
                        if (!primaryFound) {
                            return false;
                        }
                    }
                    return true;
                }

                function loadDocuments(pollForProtocolUpdates) {
                    vm.existingDocs = [];
                    vm.groupedDocs = {};
                    if (vm.section) {
                        Atto.sezioniFilesGrouped({id: vm.section.idAtto, idSezione: vm.section.id, publicView: vm.publicView}, function (result) {
                            vm.groupedDocs = result.data;
                            calculateSingleDocGroups(vm.groupedDocs);
                            if (pollForProtocolUpdates) {
                                updateArchiveNowProtocolState(vm.groupedDocs);
                            }
                        }, function () {
                            toastr.error('Impossibile ottenere la lista dei documenti caricati', 'Errore!');
                        });
                    }
                }

                function closeDocumentToolbarPanels() {
                    vm.showUpload = false;
                    vm.showDocuments = false;
                    vm.showCloseAll = false;
                }

                function onFileSelect($files) {
                    if($files.length === 0) {
                        return;
                    }
                    var tooBigFiles = [];

                    if (vm.uploadingGroup === true) {
                        var lastIterator = getAlreadyUploadedGreaterGroupNumber(vm.groupedDocs) + vm.protocolGroups.length;
                        // var lastIterator = vm.groupedDocs.length + vm.protocolGroups.length;
                        var newGroupUpload = {
                            documents: [],
                            name: lastIterator + 1,
                            protocolState: null,
                            isGroup: true
                        };

                        angular.forEach($files, function (file) {
                            if (file.size > MAX_UPLOAD_SIZE) {
                                tooBigFiles.push(file.name);
                            } else {
                                file.frontpieceDisabled = isFrontpieceDisabled(file);

                                newGroupUpload.documents.push({
                                    name: file.name,
                                    type: file.type,
                                    size: file.size,
                                    visibilityStates: vm.visibilityStates,
                                    protocolState: null,
                                    protocolGroup: newGroupUpload.name,
                                    protocolOptions: vm.protocolOptions,
                                    docType: null,
                                    frontpiece: false,
                                    notArchive: true,
                                    frontpieceDisabled: file.frontpieceDisabled,
                                    progress: 0,
                                    file: file,
                                    primary: file.primary
                                });
                            }
                        });
                        vm.protocolGroups.push(newGroupUpload);
                    } else {
                        angular.forEach($files, function (file) {
                            var lastIterator = getAlreadyUploadedGreaterGroupNumber(vm.groupedDocs) + vm.protocolGroups.length;
                        // var lastIterator = vm.groupedDocs.length + vm.protocolGroups.length;
                            if (file.size > MAX_UPLOAD_SIZE) {
                                tooBigFiles.push(file.name);
                            } else {
                                var newSingleUpload = {
                                    documents: [],
                                    name: lastIterator + 1,
                                    protocolState: null,
                                    isGroup: false,
                                };

                                file.frontpieceDisabled = isFrontpieceDisabled(file);

                                newSingleUpload.documents.push({
                                    name: file.name,
                                    type: file.type,
                                    size: file.size,
                                    protocolGroup: newSingleUpload.name,
                                    protocolState: null,
                                    protocolOptions: vm.protocolOptions,
                                    visibilityStates: vm.visibilityStates,
                                    docType: null,
                                    frontpiece: false,
                                    notArchive: true,
                                    frontpieceDisabled: file.frontpieceDisabled,
                                    progress: 0,
                                    file: file,
                                    primary: true
                                });
                                vm.protocolGroups.push(newSingleUpload);
                                vm.singleFilesCount++;
                            }
                        });
                    }

                    displayTooBigFilesWarning(tooBigFiles);
                    vm.uploadingGroup = false;
                    $files = [];
                }

                function getAlreadyUploadedGreaterGroupNumber(groupList) {
                    var maxValue = 0;
                    angular.forEach(groupList, function(group) {
                        if(group.name > maxValue) {
                            maxValue = group.name;
                        }        
                    });
                    return maxValue;
                }

                function changeDocumentType(doc) {
                    if (!vm.docTypesById) {
                        initDocTypesById();
                    }
                    var newDocumentType = vm.docTypesById[doc.tipoDocumento.id];
                    vm.changeDocumentTypeCallback({document: doc, newDocumentType: newDocumentType});
                }

                function changeDocumentVisibility(doc) {
                    vm.changeDocumentVisibilityCallback({document: doc, newDocumentVisibility: doc.visibilita});
                }

                function changeDocumentFrontpiece(doc) {
                    vm.changeDocumentFrontpieceCallback({document: doc, frontpiece: doc.frontespizio});
                }

                function uploadFiles() {
                    var valid = validate();
                    if (!valid) {
                        toastr.error('Per ogni file o gruppo che carichi devi specificare:<ul><li>Tipo Documento</li><li>Tipo Protocollazione</li><li>Visibilità</li><li>Mittenti di protocollo</li><li>Destinatari di protocollo</li><li>Ufficio operante</li></ul>Se stai caricando un gruppo di protocollazione, allora devi specificare anche il documento primario.', {
                            timeOut: 60000,
                            extendedTimeOut: 0
                        });
                        return;
                    }

                    vm.uploading = true;

                    //files: an array of files selected, each file has name, size, and type.
                    vm.resetUploads();
                    var totalFiles = 0;
                    var uploadCounter = 0;
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var mittentiId = [];
                        var destinatariId = [];
                        if (vm.protocolGroups[j].documents.length > 0) {
                            angular.forEach(vm.protocolGroups[j].mittenti, function (mittente) {
                                mittentiId.push(mittente.id);
                            });

                            angular.forEach(vm.protocolGroups[j].destinatari, function (destinatario) {
                                destinatariId.push(destinatario.id);
                            });
                        }
                        setProtocolStateForGroup(vm.protocolGroups[j]);
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            totalFiles++;
                            var params = {
                                protocolSystem: file.protocolSystem,
                                idTipoDocumento: file.docType.id,
                                visibilita: file.visibility,
                                frontespizio: file.frontpiece || file.frontespizio,
                                gruppoProtocollo: file.protocolGroup,
                                statoProtocollo: file.protocolState,
                                primario: file.primary,
                                operatingOffice: vm.protocolGroups[j].operatingOfficeSelected                                
                            };

                            function updateProgress(fileRef) {
                                return function (evt) {
                                    fileRef.progress = parseInt(100.0 * evt.loaded / evt.total);
                                    fileRef.progress = 'info';
                                };
                            }

                            function uploadOutcomeHandler(fileRef, success, iterator) {
                                return function (status) {
                                    fileRef.progress = success ? 100 : fileRef.progress;
                                    fileRef.progressClass = success ? 'success' : 'danger';
                                    uploadCounter++;

                                    if (success) {
                                        if (vm.uploadedFileCallback) {
                                            vm.uploadedFileCallback({documento: fileRef});
                                        }
                                    } else {
                                        var message = 'Impossibile caricare il file: ' + fileRef.name + ' Attenzione a non caricare file con lo stesso nome!';
                                        if (status && status.message) {
                                            message += ' ERRORE: ' + status.message;
                                        }
                                        console.error(message);
                                        toastr.error(message, 'Errore!');
                                    }

                                    if (uploadCounter === totalFiles) {
                                        Atto.protocolNow({id: vm.section.idAtto, idSezione: vm.section.id}, function (result) {
                                        }, function () {
                                            toastr.error('Impossibile completare la protocollazione', 'Errore!');
                                        });
                                        vm.loadDocuments(true);
                                        vm.uploads = [];

                                        if (success) {
                                            var p1 = $timeout(vm.cancelUpload, 2000);
                                            p1.then(function(){
                                                return $timeout(vm.toggleDocuments);
                                            });
                                        }
                                    }
                                };

                            }
                            //params.mittenti = params.mittenti || [];
                            //params.destinatari = params.mittenti || [];
                            //if(file.primary) {
                            params.mittenti = JSON.stringify(mittentiId);
                            params.destinatari = JSON.stringify(destinatariId);
                            //}
                            var currUpload = Atto.uploadFileSezione(vm.section.idAtto, vm.section.id, file.file, params)
                                    .progress(updateProgress(file))
                                    .success(uploadOutcomeHandler(file, true, j))
                                    .error(uploadOutcomeHandler(file, false));

                            vm.uploads.push(currUpload);
                        }
                    }
                }

                function dragOverClass($event) {
                    var items = $event.dataTransfer.items;
                    var hasFile = false;
                    if (items !== null) {
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].kind === 'file') {
                                hasFile = true;
                                break;
                            }
                        }
                    } else {
                        hasFile = true;
                    }
                    return hasFile ? "dragover" : "dragover-err";
                }

                function resetUploads() {
                    if (vm.uploads) {
                        angular.forEach(vm.uploads, function (upload) {
                            upload.abort();
                        });
                    }
                    vm.uploads = [];
                }

                function downloadDocument(docId, docName) {
                    Documento.getContent(docId).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), docName);
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare il documento', 'Errore!');
                    });
                }

                function downloadGroupDocuments(group) {
                    Documento.getGroupArchive(vm.section.id, group, vm.publicView).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), 'Sezione-' + vm.section.id + '_' + group + '.zip');
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare i documenti', 'Errore!');
                    });
                }

                function removeSingleUpload(group, docIdx) {
                    angular.forEach(group.documents, function (document, iterator) {
                        var currDoc = document;
                        if (currDoc.id === docIdx) {
                            if (vm.removeDocumentCallback) {
                                vm.removeDocumentCallback({documento: currDoc});
                            }
                        }
                    });
                    group.documents.splice(docIdx, 1);
                    if (!group.isGroup) {
                        vm.singleFilesCount--;
                    } else if (group.documents && group.documents.length === 1) {
                        vm.singleFilesCount++;
                    }
                }

                function removeGroupUpload(group) {
                    for (var idx = 0; idx < vm.protocolGroups.length; idx++) {
                        if (vm.protocolGroups[idx].name === group.name) {
                            break;
                        }
                    }
                    vm.protocolGroups.splice(idx, 1);
                }

                function deleteDocument(docId) {
                    $uibModal.open({
                        template: '<div class="modal-header">\
                            <h4 class="modal-title" ng-bind="title"></h4>\
                        </div>\
                        <div class="modal-body" ng-bind="::modalVm.deleteConfirmMsg"></div>\
                        <div class="modal-footer">\
                            <button class="btn btn-default" ng-click="modalVm.deleteDoc()" ng-bind="::modalVm.confirmBtnText"></button>\
                            <button class="btn btn-primary" ng-click="modalVm.cancel()" ng-bind="::modalVm.cancelBtnText"></button>\
                        </div>',
                        controller: ['$uibModalInstance', '$translate', function ($uibModalInstance, $translate) {
                            var modalVm = this;
                            modalVm.deleteConfirmMsg = $translate.instant('documentToolbar.deleteConfirmMsg');
                            modalVm.confirmBtnText = $translate.instant('entity.action.delete');
                            modalVm.cancelBtnText = $translate.instant('entity.action.cancel');

                            modalVm.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                            modalVm.deleteDoc = function () {
                                Documento.delete({id: docId}, {}, function () {
                                    for (var i = 0; i < vm.groupedDocs.length; i++) {
                                        var currentGroup = vm.groupedDocs[i];
                                        var isSingleDoc = currentGroup.documents.length === 1;
                                        angular.forEach(vm.groupedDocs[i].documents, function (document, iterator) {
                                            var currDoc = document;
                                            if (currDoc.id === docId) {
                                                if (vm.removeDocumentCallback) {
                                                    vm.removeDocumentCallback({documento: currDoc});
                                                }
                                                currentGroup.documents.splice(iterator, 1);
                                                if (currentGroup.documents.length === 0) {
                                                    if (isSingleDoc) {
                                                        vm.singleDocumentsCount--;
                                                    }
                                                    vm.groupedDocs.splice(i, 1);
                                                } else if (currentGroup.documents.length === 1) {
                                                    vm.singleDocumentsCount++;
                                                }
                                            }
                                        });
                                    }
                                    toastr.success('Eliminazione documento completata');
                                    $uibModalInstance.close();
                                }, function (error) {
                                    console.error(error);
                                    toastr.error('Impossibile eliminare il documento', 'Errore!');
                                });
                            };
                        }],
                        controllerAs: 'modalVm',
                        backdrop: 'static',
                        size: 'lg',
                    });
                }

                function enableSectionNotes() {
                    return vm.includeNotes
                            && vm.isAuthenticated
                            && (vm.editable || (vm.section.metadati.sectionNotes && vm.section.metadati.sectionNotes.toString().trim().length));
                }

                function setDefaultVisibility(document) {
                    if (document.docType && document.docType.defaultVisibility) {
                        document.visibility = document.docType.defaultVisibility;
                    } else {
                        document.visibility = vm.defaultVisibility;
                    }
                }

                function setPrimaryDoc(documents, primaryDocIdx) {
                    var i = 0;
                    angular.forEach(documents, function (document) {
                        if (i === primaryDocIdx) {
                            document.primary = true;
                        } else {
                            document.primary = false;
                        }
                        i++;
                    });
                }

                function retryProcolAction(group) {
                    group.protocolState = 'ARCHIVE_NOW';
                    angular.forEach(group.documents, function (document) {
                        document.protocolState = 'ARCHIVE_NOW';
                    });
                    Documento.retryProtocol({idSezione: vm.section.id, group: group.name}, {}, function (result) {
                        if (angular.isArray(group)) {
                            updateArchiveNowProtocolState(group);
                        } else {
                            updateArchiveNowProtocolState([group]);
                        }
                    });
                }

                function canChangeDocumentType(document) {
                    if ($state.current.name !== 'atto-edit') {
                        return false;
                    }

                    if (vm.isAdmin) { // 2025-06-18 L'admin deve poter modificare
                        return true;
                    }

                    if (!vm.isProtocollo) {
                        return false;
                    }

                    if (document.owner.id === 'SYSTEM') {
                        return true;
                    }

                    if (document.owner.authorities) {
                        for (var i = 0; i < document.owner.authorities.length; i++) {
                            var auth = document.owner.authorities[i];
                            if (auth.name === 'ROLE_PROTOCOLLO') {
                                return true;
                            }
                        }
                    }

                    return false;
                }

                function canChangeDocumentVisibility(doc) {

                    if ($state.current.name !== 'atto-edit') {
                        return false;
                    }
                    if (vm.isAdmin) { // 2025-06-18 L'admin deve poter modificare
                        return true;
                    }

                    var authorities = [];
                    authorities = getDocumentAuthorities(doc, vm.legislatura);

                    if(doc.owner.id === 'SYSTEM' && vm.isProtocollo) {
                        return true;
                    }

                    if (!vm.editable || doc.owner.id === 'SYSTEM' || !Principal.hasAnyAuthority(authorities, vm.legislatura)) {
                        return false;
                    }

                    if (doc.owner.id === vm.user.id) {
                        return true;
                    }

                    var documentCommissioni = getDocumentCommissioni(doc, vm.legislatura);
                    var documentExternalSubjects = getDocumentExternalSubjects(doc, vm.legislatura);

                    if (vm.isCommissione) {
                        return User.hasAnyCommission(vm.user, documentCommissioni, vm.legislatura) && User.isCommissionRole(vm.user, 'Dipendente', vm.legislatura);
                    } else if (vm.isSettore) {
                        return User.hasAnySector(vm.user, doc.owner.settori);
                    } else if (vm.isExternal) {
                        return User.hasAnyExternalSubject(vm.user, documentExternalSubjects, vm.legislatura);
                    } else {
                        return true;
                    }
                }

                function getDocumentAuthorities(doc, legislatura) {
                    var authorities = [];
                    // Authorities globali
                    if (doc.owner.authorities) {
                        angular.forEach(doc.owner.authorities, function (auth) {
                            if (auth.name !== 'ROLE_USER') {
                                authorities.push(auth.name);
                            }
                        });
                    }
                    // Authorities per legislatura: solo quella dell'atto corrente
                    if (doc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(doc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.authorities
                            ) {
                                angular.forEach(legiAuth.authorities, function (auth) {
                                    if (auth.name !== 'ROLE_USER') {
                                        authorities.push(auth.name);
                                    }
                                });
                            }
                        });
                    }
                    return authorities;
                }

                function getDocumentCommissioni(doc, legislatura) {
                    var docCommissioni = [];
                    // Commissioni globali (gestione pregresso)
                    if (doc.owner.commissioni) {
                        angular.forEach(doc.owner.commissioni, function (comm) {
                            docCommissioni.push(comm);
                        });
                    }
                    // Commissioni per legislatura: solo quella della legislatura dell'atto
                    if (doc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(doc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.commissioneRuoloAssociato &&
                                legiAuth.commissioneRuoloAssociato.commissione

                            ) {
                                docCommissioni.push(legiAuth.commissioneRuoloAssociato.commissione);
                            }
                        });
                    }
                    return docCommissioni;
                }

                function getDocumentExternalSubjects(doc, legislatura) {
                    var docSoggetti = [];
                    // Soggetti globali (gestione pregresso)
                    if (doc.owner.soggettiEsterni) {
                        angular.forEach(doc.owner.soggettiEsterni, function (sogg) {
                            docSoggetti.push(sogg);
                        });
                    }
                    // Soggetti per legislatura: solo quella della legislatura dell'atto
                    if (doc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(doc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.soggettiEsterni

                            ) {
                                angular.forEach(legiAuth.soggettiEsterni, function (sogg) {
                                    docSoggetti.push(sogg);
                                });
                            }
                        });
                    }
                    return docSoggetti;
                }

                function showLinksToggler() {
                    if (!vm.includeLinks) {
                        return false;
                    } else if (vm.editable) {
                        return true;
                    }

                    if (!vm.section.metadati || !vm.section.metadati.links) {
                        return false;
                    }

                    for (var i = 0; i < vm.section.metadati.links.length; i++) {
                        var link = vm.section.metadati.links[i];
                        if (link.url && link.description) {
                            return true;
                        }
                    }

                    return false;
                }

                function displayTooBigFilesWarning(docs) {
                    if (!docs || docs.length === 0) {
                        return;
                    }
                    var msg = 'I seguenti file sono troppo grandi per essere caricati:';
                    angular.forEach(docs, function (doc) {
                        msg += '<br>&bullet;&nbsp;' + doc;
                    });
                    toastr.error('Attenzione', msg);
                }

                function initUserRoles() {

                    Atto.get({
                        id: vm.section.idAtto
                    }, function (atto) {
                        vm.isAuthenticated = Principal.isAuthenticated();
                        vm.legislatura = atto.legislatura;
                        if (vm.isAuthenticated) {
                            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'], vm.legislatura);
                            vm.isProtocollo = Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'], vm.legislatura);
                            vm.isCommissione = Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], vm.legislatura);
                            vm.isSettore = Principal.hasAnyAuthority(['ROLE_SETTORE'], vm.legislatura);
                            vm.isExternal = Principal.hasAnyAuthority(['ROLE_EXTERNAL'], vm.legislatura);
                        }
                        initDocVisibilities();
                    }, function (error) {
                        console.log("Error retrieving Atto");
                    });
                
                }

                function initDocTypesById() {
                    vm.docTypesById = {};
                    angular.forEach(vm.docTypes, function (docType) {
                        vm.docTypesById[docType.id] = docType;
                    });
                }

                function initDocVisibilities() {
                    vm.visibilityStates = [];
                    if (!vm.isCommissione && !vm.isAdmin) {
                        angular.forEach(GESTIONE_ATTI_DOC_VISIBILITIES, function (docVisibility) {
                            if (!docVisibility.onlyForCommission) {
                                vm.visibilityStates.push(docVisibility);
                            }
                        });
                    } else {
                        vm.visibilityStates = GESTIONE_ATTI_DOC_VISIBILITIES;
                    }
                }

                function initToolbarSectionVisibilities() {
                    vm.showCloseAll = false;
                    vm.showDocuments = false;
                    vm.showUpload = false;
                    vm.showNotes = false;
                    vm.showLinks = isLinkPresent(vm.section.metadati.links);
                }

                function isLinkPresent(linksObj) {
                    for (var i = 0; i < linksObj.length; i++) {
                        var url = linksObj[i].url;
                        if (url && url.length)
                            return true;
                    }
                    return false;
                }

                function setProtocolStateForSingle(file) {
                    if (file.protocolState === 'NO_ARCHIVE') {
                        file.notArchive = true;
                        file.protocolGroup = 0;
                    } else {
                        file.notArchive = false;
                        //file.frontpiece = !isFrontpieceDisabled(file);
                    }
                }

                function setProtocolStateForGroup(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState ? group.protocolState : file.protocolState;
                        if (file.protocolState === 'NO_ARCHIVE') {
                            file.notArchive = true;
                            file.protocolGroup = 0;
                        } else {
                            file.protocolGroup = group.name;
                            file.notArchive = false;
                            //file.frontpiece = !isFrontpieceDisabled(file);
                        }
                    });
                }

                function isSingleFileGroup(group) {
                    return !vm.isRealGroup(group);
                }

                function isRealGroup(group) {
                    return group && group.documents && group.documents.length > 1;
                }

                function isDeletable(doc) {
                    if (vm.isAdmin) {
                        return doc.protocolState !== "ARCHIVE_NOW" && vm.editable;
                    }
                    return doc.protocolState !== "ARCHIVED" && doc.protocolState !== "ARCHIVE_NOW"
                            && (vm.isProtocollo || vm.editable);
                }

                function isFrontpieceDisabled(file) {
                    var getExtension = /(?:\.([^.]+))?$/;
                    var extension = getExtension.exec(file.name)[1];
                    if (typeof (extension) === 'undefined' || extension === null) {
                        extension = '';
                    } else {
                        extension = extension.trim().toLowerCase();
                    }
                    return vm.frontespieceAllowedExtensions.indexOf(extension) === -1;
                }


                // FOR ANCHORING TO THE DOCUMENTS 
                if(vm.section.anchorToDocuments) {
                    vm.section.showDocuments();
                    $timeout(function () {
                        $anchorScroll(vm.section.id);
                    }, 1500);
                }
            }]
    };

});

angular.module('gestioneAttiApp').directive('decadutoBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/decadutoBlock/decadutoBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            decaduto: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: "=",
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.decaduto = {visible: true};

            vm.sezioni = {
                DECADUTO: {
                    form: 'app/components/decadutoBlock/decaduto.html'
                }
            };

            vm.stato = {
                decaduto: {
                    isCollapsed: vm.statoAttoCorrente === 'DECADUTO' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});

(function () {
    'use strict';

    var loadingSpinnerComponent = {

        templateUrl: 'app/components/custom-loading-spinner/loading-spinner.html',
        controller: [ function () {
            var vm = this;

        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('loadingSpinnerComponent', loadingSpinnerComponent);
})();

angular.module('gestioneAttiApp').directive('courtroomBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/courtroomBlock/courtroomBlock.directive.html',
        scope: {
            actType: '=',
            changeDocumentTypeCallback: '&?',
            changeDocumentVisibilityCallback: '&?',
            changeDocumentFrontpieceCallback: '&?',
            constitutionalAppeal: '=',
            courtEmendments: '=',
            courtMeeting: '=',
            courtOutcome: '=',
            currentUser: '=',
            docTypes: '=',
            invalidFields: '=',
            isAdmin: '=',
            index: '=',
            isProtocollo: '=',
            iterationIndex: '=',
            noticeOfRectification: '=',
            peopleList: '=',
            postCourt: '=',
            sendBackDate: '=?',
            showSectionCallback: '&',
            validating: '=',
            statoAttoCorrente: '=',
            numeroRinvii: '=',
            isAttoMinore: '=',
            actuationNotes: '=',
            assignmentLetter: '=',
            commissioni: '=',
            isSectorUserEnabled:'=',
            attachedActs: '=',
            atto: '=',
            isCourtroom: '=',
            workDocumentsMap: '=?',
            emanazione: "=?",
            viewMode: '=',
            procedimento: '=',
            showCourtroomBlock: '=',
            adempimenti: '=',
            materieSection: '=',
            courtAssignmentLetter: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$rootScope', 'PdlService','toastr', 'ACT_TYPES', 'Atto', 'Principal','FileSaver', 'Materia', 'MacroMateria' , function ($rootScope, PdlService,toastr, ACT_TYPES, Atto, Principal, FileSaver, Materia, MacroMateria) {
            var vm = this;
            vm.materiaList = [];
            vm.macroMateriaList = [];

            // Se avevo il numero BURT precedentemente popolato e non esiste l'array burtDetails
            // Crea l'array burtDetails con 1 elemento con valori già esistenti
            if (vm.noticeOfRectification
                && vm.noticeOfRectification.metadati
                && vm.noticeOfRectification.metadati.numeroBurt
                && !vm.noticeOfRectification.metadati.burtDetails)
            {
                vm.noticeOfRectification.metadati.burtDetails = [
                    {
                        numeroBurt: vm.noticeOfRectification.metadati.numeroBurt,
                        parteBurt: vm.noticeOfRectification.metadati.parteBurt,
                        dataBurt: vm.noticeOfRectification.metadati.dataBurt
                    }
                ];

                delete vm.noticeOfRectification.metadati.numeroBurt;
                delete vm.noticeOfRectification.metadati.parteBurt;
                delete vm.noticeOfRectification.metadati.dataBurt;
            }

            // Se nella sezione noticeOfRectification non ha popolato l'array burtDetails -> Crea un array con elemento vuoto
            if(vm.noticeOfRectification && vm.noticeOfRectification.metadati && 
                (vm.noticeOfRectification.metadati.burtDetails === undefined || vm.noticeOfRectification.metadati.burtDetails === null)) {
                vm.noticeOfRectification.metadati.burtDetails = [
                    {
                        numeroBurt: "",
                        parteBurt: "",
                        dataBurt: ""
                    }
                ];
            }

            vm.checkShowSection = function (section) {
                return vm.showSectionCallback({section: section});
            };

            if (vm.materieSection && vm.checkShowSection(vm.materieSection) && vm.materieSection.editable) {
                vm.loadedMacroMaterie = false;
                vm.loadedMaterie = false;
                loadMacroMaterie();
                loadMaterie();
            }
            if(vm.procedimento && (!vm.procedimento.metadati || !vm.procedimento.metadati.procedimentoExArticolo)) {
                vm.procedimento.metadati.procedimentoExArticolo = false;
            }
            vm.isParereReferenteValorised =  !!vm.assignmentLetter && !!vm.assignmentLetter.metadati && !!vm.assignmentLetter.metadati.parereReferente && vm.assignmentLetter.metadati.parereReferente.length > 0;
            vm.isStatoAula = vm.atto.statoCorrente.statoAtto.name === 'AULA';
            vm.isAula = Principal.hasAnyAuthority(['ROLE_AULA'], vm.atto.legislatura);
            if(vm.assignmentLetter){
                vm.isCommissionAlreadySelected = vm.assignmentLetter.metadati.parereReferente ? true : false;
                if(vm.isAula && vm.actType === 'MOZIONE' && vm.statoAttoCorrente === 'AULA'){
                    vm.assignmentLetter.editable = true;
                    vm.assignmentLetter.visible = true;
                }
            }

            vm.clearRadio = PdlService.clearRadio;
            vm.numeroRinvii = vm.numeroRinvii || 0;

            vm.sezioni = {
                COURT_EMENDMENTS: {
                    form: 'app/components/courtroomBlock/courtroomEmendments.html'
                },
                COURT_MEETING: {
                    form: 'app/components/courtroomBlock/courtroomMeeting.html'
                },
                COURT_OUTCOME: {
                    form: (vm.actType === 'IO' || vm.actType === 'IS')
                            ? 'app/components/courtroomBlock/io.courtroomOutcome.html'
                            : 'app/components/courtroomBlock/courtroomOutcome.html'
                },
                POST_COURT: {
                    form: getPostCourt()
                },
                EMANAZIONE:{
                    form: 'app/components/courtroomBlock/pea.emanazione.html'
                },
                NOTICE_OF_RECTIFICATION: {
                    form: 'app/components/courtroomBlock/noticeOfRectification.html'
                },
                CONSTITUTIONAL_APPEAL: {
                    form: 'app/components/courtroomBlock/constitutionalAppeal.html'
                },
                ACTUATION_NOTES: {
                    form: 'app/components/courtroomBlock/actuationNotes.html'
                },
                ASSIGNMENT_LETTER: {
                    form: 'app/entities/atto/sezioni/onlyReferente.assignmentLetter.html'
                },
                ATTACHED_ACTS: {
                    form: 'app/entities/atto/sezioni/attachedActs.html'
                },
                PROCEDIMENTO: {
                    form: 'app/components/courtroomBlock/procedimento.html'
                },
                ADEMPIMENTI: {
                    form: 'app/components/courtroomBlock/adempimenti.html'
                },
                MATERIE: {
                    form: 'app/components/courtroomBlock/materie-section.html'
                },
                COURT_ASSIGNMENT_LETTER: {
                    form: 'app/components/courtroomBlock/pdls.courtAssignmentLetter.html',
                },
            };
            vm.getSezioniFromMap = PdlService.getSezioniFromMap;

            vm.stato = {
                aula: {
                    isCollapsed: (vm.statoAttoCorrente === 'AULA' && vm.numeroRinvii === vm.index) || vm.viewMode
                },
                approvato: {
                    isCollapsed: (vm.statoAttoCorrente === 'APPROVATO' && vm.numeroRinvii === vm.index) || vm.viewMode
                }
            };

            vm.defaultLinks = getDefaultLinks();

            function getPostCourt(){
                if (vm.actType === 'PDD' || vm.actType === 'RINT'){
                    return 'app/components/courtroomBlock/pdd.postCourtroom.html';
                }
                else if (vm.actType === 'PEA'){
                    return 'app/components/courtroomBlock/pea.postCourtroom.html';
                }
                else if (vm.actType === 'PDLP'){
                    return 'app/components/courtroomBlock/pdlp.postCourtroom.html';
                }
                else return 'app/components/courtroomBlock/postCourtroom.html';
            }

            function getDefaultLinks() {
                if (vm.actType === 'ODG' || vm.actType === 'PDR' || vm.actType === 'MOZIONE') {
                    return ['burt', 'bancaDatiDelConsiglio'];
                } else {
                    return (vm.actType !== 'PDLP') ? ['burt', 'regulatoryCollection'] : ['deliberaDefinitiva'];
                }

            }
            vm.invalidFields = vm.invalidFields || [];
            vm.utente = vm.currentUser;

            function loadMacroMaterie() {
                MacroMateria.query({onlyValid: true},
                    function(result) {
                        vm.macroMateriaList = result;
                        vm.loadedMacroMaterie = true;
                    },
                    function(error) {console.log('Error while loading materie');});
            }
            function loadMaterie() {
                Materia.query({onlyValid: true},
                    function(result){
                        vm.materiaList = result;
                        vm.loadedMaterie = true;
                    },
                    function(error) {console.log('Error while loading materie');});
            }
            if (vm.postCourt) {
                vm.postCourt.metadati = vm.postCourt.metadati || {collegioGaranzia: false};

                if (!vm.postCourt.metadati.collegioGaranzia) {
                    vm.postCourt.metadati.collegioGaranzia = false;
                }
            }

            if (vm.courtOutcome) {
                vm.courtOutcome.metadati.clausolaValutativa = vm.courtOutcome.metadati.clausolaValutativa || false;
            }

            vm.fieldSuffix = '';
            if (vm.iterationIndex && vm.iterationIndex > 0) {
                vm.fieldSuffix = '_' + vm.iterationIndex;
            }


            vm.changeDocumentType = function (document, newDocumentType) {
                vm.changeDocumentTypeCallback({document: document, newDocumentType: newDocumentType});
            };

            vm.changeDocumentVisibility = function (document, newDocumentVisibility) {
                vm.changeDocumentVisibilityCallback({document: document, newDocumentVisibility: newDocumentVisibility});
            };

            vm.changeDocumentFrontpiece = function (document, frontpiece) {
                vm.changeDocumentFrontpieceCallback({document: document, frontpiece: frontpiece});
            };

            vm.isInvalidField = function (fieldName) {
                return vm.invalidFields.indexOf(fieldName + vm.fieldSuffix) > -1;
            };

            vm.exists = function (item, list) {
                if (!list || !angular.isArray(list)) {
                    list = [];
                }
                return list.indexOf(item) > -1;
            };

            vm.toggle = function (item, metadata, fieldName) {
                var list = metadata[fieldName];
                if (!list || !angular.isArray(list)) {
                    metadata[fieldName] = [];
                    list = metadata[fieldName];
                }

                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            vm.showManifestaInfondatezza = function () {
                return vm.postCourt.metadati.collegioGaranzia === true;
            };
            vm.showConformita = function () {
                return vm.showManifestaInfondatezza() &&
                vm.postCourt.metadati.manifestaInfondatezza === false;
            };
            vm.showEntrataVigoreAnticipata = function() {
                return vm.actType !== 'PDLS' &&
                vm.actType !== 'PLIP' &&
                vm.nonContestata();
            };

            vm.nonContestata = function () {
                return vm.postCourt.metadati.collegioGaranzia === false
                        || (vm.showConformita() && vm.postCourt.metadati.conformita === true);
            };

            vm.checkConformita = function() {
                if (!vm.showConformita()) {
                    vm.postCourt.metadati.conformita = null;
                }
                vm.broadcastConformitaEvent();
            };

            vm.broadcastConformitaEvent = function () {
                $rootScope.$broadcast('conformitaChange');
            };

            vm.downloadReportEmendamenti = function() {
                Atto.getEmendamentiPDFReport(vm.courtEmendments.id)
                .then(
                    function(result) {
                        FileSaver.saveAs(new Blob([result.data], {}), "ReportEmendamentiAula.pdf");
                    },
                    function(error) {
                        var errorCode = error.headers('X-gestioneAttiApp-error');
                        var errorText = '';
                        if(errorCode === 'error.noContent') {
                            errorText = 'Questa sezione non ha nessun emendamento presentato, quindi non e\' stato possibile generare nessun report!';
                        } else if(errorCode === 'error.forbiddenOp') {
                            errorText = 'La tua utenza non e\' abilitata alla generazione di report. Si prega di contattare l\'amministratore!';
                        } else {
                            errorText = 'Errore inaspettato. Si prega di riprovare o contattare l\'amministratore!';
                        }
                        toastr.error(errorText, "Errore!", {
                            timeOut: 60000,
                            extendedTimeOut: 0
                        });
                    });
            };
        }]
    };
});

angular.module('gestioneAttiApp').directive('commissionOpinion', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/commissionOpinion/commissionOpinion.directive.html',
        scope: {
            title: '@',
            metadata: '=',
            subjects: '=',
            actType: '=',
            favorableOptionEnabled: '=',
            notExpressedOptionEnabled: '=',
            editable: '=',
            invalidFields: '=?',
            validating: '=?',
            postponementNumber: '=?',
            includeMeetingDates: '=?',
            includeInvestigationBoard: '=?'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: [
            function () {
                var vm = this;

                vm.invalidFields = vm.invalidFields || [];
                vm.subjects = vm.subjects || [];
                vm.postponementSuffix = '';
                if (vm.postponementNumber && vm.postponementNumber > 0) {
                    vm.postponementSuffix = '_' + vm.postponementNumber;
                }

                vm.isInvalidField = function (fieldName, subjectId) {
                    return vm.invalidFields.indexOf(fieldName + vm.postponementSuffix + '_' + subjectId) > -1;
                };

                vm.clearRadio = function (metadataName) {
                    if (vm.editable) {
                        vm.metadata[metadataName][vm.subjectId] = null;
                    }
                };

                vm.subjectId = "";
                if (vm.subjects.length === 1) {
                    vm.subjectId = vm.subjects[0].id;
                } else {
                    vm.subjects.sort();
                    angular.forEach(vm.subjects, function (subject) {
                        vm.subjectId = vm.subjectId + "_" + subject.id;
                    });
                }
                if(vm.title === 'Parere di merito') {
                    // console.log(vm.subjectId, vm.title, vm.metadata.dateSeduteIscrizione[vm.subjectId]);
                }
            }]
    };

});

angular.module('gestioneAttiApp').directive('commissionObservation', function () {
    return {
        restrict: 'E',
        templateUrl: 'app/components/commissionObservation/commissionObservation.directive.html',
        scope: {
            title: '@',
            metadata: '=',
            subjects: '=',
            actType: '=',
            editable: '=',
            invalidFields: '=?',
            validating: '=?',
            postponementNumber: '=?',

        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: [
            function () {
                var vm = this;

                vm.invalidFields = vm.invalidFields || [];
                vm.subjects = vm.subjects || [];
                vm.postponementSuffix = '';
                if (vm.postponementNumber && vm.postponementNumber > 0) {
                    vm.postponementSuffix = '_' + vm.postponementNumber;
                }

                vm.isInvalidField = function (fieldName, subjectId) {
                    return vm.invalidFields.indexOf(fieldName + vm.postponementSuffix + '_' + subjectId) > -1;
                };

                vm.clearRadio = function (metadataName) {
                    if (vm.editable) {
                        vm.metadata[metadataName][vm.subjectId] = null;
                    }
                };

                vm.subjectId = "";
                if (vm.subjects.length === 1) {
                    vm.subjectId = vm.subjects[0].id;
                } else {
                    vm.subjects.sort();
                    angular.forEach(vm.subjects, function (subject) {
                        vm.subjectId = vm.subjectId + "_" + subject.id;
                    });
                }
                
            }
        ]
    }
})
angular.module('gestioneAttiApp').directive('commissionBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/commissionBlock/commissionBlock.directive.html',
        scope: {
            actType: '=',
            changeDocumentTypeCallback: '&?',
            changeDocumentVisibilityCallback: '&?',
            changeDocumentFrontpieceCallback: '&?',
            commissionEmendments: '=',
            commissionMessage: '=',
            commissionOpinions: '=',
            consultations: '=',
            currentUser: '=',
            docTypes: '=',
            feasibility: '=',
            financialCoverage: '=',
            postCourt: '=?',
            index: '=',
            invalidFields: '=',
            isAdmin: '=',
            isAuthenticated: '=',
            isFeasibility: '=',
            isLegitimacy: '=',
            isPrimaryCommission: '=',
            isProtocollo: '=',
            iterationIndex: '=',
            legitimacy: '=',
            opinionSubjects: '=',
            peopleList: '=',
            referendumReport: '=',
            sendBackDate: '=?',
            showSectionCallback: '&',
            unifiedText: '=',
            unionProposal: '=',
            validating: '=',
            workDocuments: '=',
            documentsCheckCallback: '&',
            removeDocumentsCheckCallback: '&',
            workDocumentsMap: '=',
            statoAttoCorrente: '=',
            numeroRinvii: '=',
            isAttoMinore: '=',
            seatManagement: '=?',
            decadence: '=',
            parereCal: '=?',
            userSoggettiEsterniMap: '=?',
            resolution: '=?',
            atto: '=',
            viewMode: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Principal', function (Atto, User, PdlService) {
            var vm = this;
            vm.numeroRinvii = vm.numeroRinvii || 0;
            vm.clearRadio = PdlService.clearRadio;
            vm.atti = [];
            vm.allPdris = [];
            vm.numeroPdrisSearchText = '';
            vm.searchPdris = searchPdris;
            vm.pdrisSelectedChip = [];
                

            function resolveAttachedPdris() {
                if (!vm.commissionMessage.metadati.attachedPdrisId) {
                    return;
                }
                Atto.get({
                    id: vm.commissionMessage.metadati.attachedPdrisId
                }, onRetrieveSuccess, onError);
                
                function onRetrieveSuccess(data, headers) {
                    vm.pdrisSelectedChip.push(data);
                }
                function onError(error) {
                    console.log(error);
                }
            }

            vm.onChipAdd = function ($index, $chip) {
                vm.commissionMessage.metadati.attachedPdrisId = $chip.id;
            };

            vm.onRemoveChip = function ($index, $chip, $event) {
                vm.commissionMessage.metadati.attachedPdrisId = null;
            };

            if(vm.actType === 'REL' || vm.atto.tipoAtto === 'REL') {
                resolveAttachedPdris();
                getAllPdris();
            }

            vm.sezioni = {
                LEGITIMACY: {
                    form: 'app/components/commissionBlock/legitimacy.html'
                },
                FEASIBILITY: {
                    form: 'app/components/commissionBlock/feasibility.html'
                },
                CONSULTATIONS: {
                    form: 'app/components/commissionBlock/consultations.html'
                },
                COMMISSION_MESSAGE: {
                    form: 'app/components/commissionBlock/commissionMessage.html'
                },
                COMMISSION_ASSIGNED_EMENDMENTS: {
                    form: 'app/components/commissionBlock/commissionAssignedEmendments.html'
                },
                COMMISSION_EMENDMENTS: {
                    form: 'app/components/commissionBlock/commissionEmendments.html'
                },
                WORK_DOCUMENTS: {
                    form: 'app/components/commissionBlock/workDocuments.html'
                },
                PARERE_CAL:{
                    form: 'app/components/commissionBlock/parereCal.html'
                },
                RESOLUTION:{
                    form: 'app/components/commissionBlock/resolution.html'
                },
                FINANCIAL_COVERAGE: {
                    form: 'app/components/commissionBlock/financialCoverage.html'
                },
                COMMISSION_OPINIONS: {
                    form: 'app/components/commissionBlock/commissionOpinions.html'
                },
                UNION_PROPOSAL: {
                    form: 'app/components/commissionBlock/unionProposal.html'
                },
                REFERENDUM_REPORT: {
                    form: 'app/components/commissionBlock/referendumReport.html'
                },
                UNIFIED_TEXT: {
                    form: 'app/components/commissionBlock/unifiedText.html'
                },
                SEAT_MANAGEMENT: {
                    form: 'app/components/commissionBlock/seatManagement.html'
                },
                DECADENCE: {
                    form: 'app/components/commissionBlock/decadence.html'
                }
            };

            vm.stato = {
                commissione: {
                    isCollapsed: (vm.statoAttoCorrente === 'COMMISSIONE' && vm.numeroRinvii === vm.index) || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            vm.utente = vm.currentUser;
            vm.soggettiOpinioni = vm.opinionSubjects;

            if (vm.unifiedText) {
                vm.unifiedText.metadati.unifiedTexts = vm.unifiedText.metadati.unifiedTexts || [];
                vm.unifiedText.metadati.hasUnifiedTexts = vm.unifiedText.metadati.hasUnifiedTexts || false;
                if (vm.unifiedText.metadati.hasUnifiedTexts) {
                    loadAtti();
                }
                vm.numeroAttoSearchText = '';
                vm.searchAtti = searchUnifiedTexts;
                vm.unifiedTextsModel = [];
                resolveUnifiedTexts();
                vm.onAddUnifiedText = onAddUnifiedText;
                vm.onRemoveUnifiedText = onRemoveUnifiedText;
                vm.transformChip = transformChip;
                vm.toogleAddUnifiedText = toogleAddUnifiedText;
            }

            vm.fieldSuffix = '';
            if (vm.iterationIndex && vm.iterationIndex > 0) {
                vm.fieldSuffix = '_' + vm.iterationIndex;
            }

            vm.checkShowSection = function (section) {
                return vm.showSectionCallback({section: section});
            };

            vm.initDocumentsCheck = function (documento) {
                vm.documentsCheckCallback({documento: documento, numeroRinvio: vm.iterationIndex});
            };

            vm.removeDocumentsCheck = function (documento) {
                vm.removeDocumentsCheckCallback({documento: documento, numeroRinvio: vm.iterationIndex});
            };

            vm.changeDocumentType = function (document, newDocumentType) {
                vm.changeDocumentTypeCallback({document: document, newDocumentType: newDocumentType});
            };

            vm.changeDocumentVisibility = function (document, newDocumentVisibility) {
                vm.changeDocumentVisibilityCallback({document: document, newDocumentVisibility: newDocumentVisibility});
            };

            vm.changeDocumentFrontpiece = function (document, frontpiece) {
                vm.changeDocumentFrontpieceCallback({document: document, frontpiece: frontpiece});
            };

            vm.hasAnyCommission = function (commissions) {
                return User.hasAnyCommission(vm.utente, commissions, vm.atto.legislatura);
            };

            vm.hasAnyExternalSubject = function (subjects) {
                return User.hasAnyExternalSubject(vm.utente, subjects, vm.atto.legislatura);
            };

            vm.isCommissionOpinionEditable = function (subjects) {
                return PdlService.isCommissionOpinionEditable(vm.utente, subjects, vm.iterationIndex, vm.isAdmin);
            };

            vm.isExternalSubjectOpionionEditable = function (subjects) {
                return PdlService.isExternalSubjectOpionionEditable(vm.utente, subjects, vm.iterationIndex, vm.isAdmin);
            };

            vm.isInvalidField = function (fieldName) {
                return vm.invalidFields.indexOf(fieldName + vm.fieldSuffix) > -1;
            };

            vm.exists = function (item, list) {
                if (!list || !angular.isArray(list)) {
                    list = [];
                }
                return list.indexOf(item) > -1;
            };

            vm.toggle = function (item, metadata, fieldName) {
                var list = metadata[fieldName];
                if (!list || !angular.isArray(list)) {
                    metadata[fieldName] = [];
                    list = metadata[fieldName];
                }

                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            vm.showNonPrimaryOpinion = function () {
                if (!vm.postCourt) {
                    return true;
                } else if (vm.postCourt.metadati.collegioGaranzia === true
                        && vm.postCourt.metadati.manifestaInfondatezza === true
                        && vm.postCourt.metadati.conformita === false) {
                    return false;
                }
                return true;
            };

            // Autocomplete for section UnifiedText
            function searchUnifiedTexts(tokenNumeroAtto) {
                var results = vm.atti;

                return tokenNumeroAtto ? results.filter(createFilterFor(tokenNumeroAtto)) : [];
            }

            function createFilterFor(tokenNumeroAtto) {
                return function filterFn(atto) {
                    var numeroAtto = atto.numeroAtto;
                    return (numeroAtto.includes(tokenNumeroAtto) && !alreadySelected(atto.id));
                };
            }

            function alreadySelected(idAtto) {
                for (var i in vm.unifiedText.metadati.unifiedTexts) {
                    if (idAtto === vm.unifiedText.metadati.unifiedTexts[i].id) {
                        return true;
                    }
                }
                return false;
            }

            function getAllPdris () {
                vm.allPdris = [];
                Atto.queryNonPaged({
                    type: 'PDRIS'
                }, onSuccess, onError);
                function onSuccess(data) {
                    vm.allPdris = data;
                };
                function onError(error) {
                    console.log(error);
                }
            }

            // Autocomplete for section Commission Message for REL
            function searchPdris(tokenNumeroAtto) {
                var results = vm.allPdris;
                return tokenNumeroAtto ? results.filter(createFilterForPdris(tokenNumeroAtto)) : [];
            }

            function createFilterForPdris(tokenNumeroAtto) {
                return function filterFn(atto) {
                    var numeroAtto = atto.numeroAtto;
                    return numeroAtto.includes(tokenNumeroAtto);
                };
            }

            function loadAtti() {
                Atto.queryLite({
                    page: 0,
                    sort: 'numeroAtto,desc',
                    state: 'COMMISSIONE',
                    type: vm.actType
                }, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                for (var i in data) {
                    if (data[i].id === vm.unifiedText.idAtto) {
                        data.splice(i, 1); // remove myself
                        break;
                    }
                }
                vm.atti = data;
            }

            function onError(error) {
                console.log("Failure!", error);
                toastr.error(error.data.message);
            }

            function transformChip($chip) {
                return {"id": $chip.id, "numeroAtto": $chip.numeroAtto, "titolo": $chip.titolo};
            }

            function resolveUnifiedTexts() {
                if (!vm.unifiedText.metadati.unifiedTexts)
                    return [];

                for (var i in vm.unifiedText.metadati.unifiedTexts) {
                    Atto.get({
                        id: vm.unifiedText.metadati.unifiedTexts[i].id
                    }, onRetrieveSuccess, onError);
                }
            }

            function onRetrieveSuccess(data, headers) {
                vm.unifiedTextsModel.push({id: data.id, numeroAtto: data.numeroAtto, titolo: data.titolo});
            }

            function onAddUnifiedText($index, $chip) {
                vm.unifiedText.metadati.unifiedTexts.push({id: $chip.id});
            }

            function onRemoveUnifiedText($index, $chip) {
                for (var i in vm.unifiedText.metadati.unifiedTexts) {
                    if ($chip.id === vm.unifiedText.metadati.unifiedTexts[i].id) {
                        vm.unifiedText.metadati.unifiedTexts.splice(i, 1);
                        break;
                    }
                }
            }

            function toogleAddUnifiedText(status) {
                if (status) {
                    if (vm.unifiedText.editable && !vm.atti.length) {
                        loadAtti();
                    }
                } else {
                    vm.unifiedTextsModel = [];
                    vm.unifiedText.metadati.unifiedTexts = [];
                }
                vm.unifiedText.metadati.hasUnifiedTexts = status;
            }
        }]
    };
});

var app = angular.module('app', ['ui.bootstrap', 'ui.bootstrap.datetimepicker']);

app.controller('MyController', ['$scope', function($scope) {

    var that = this;

    // date picker
    this.picker1 = {
        date: new Date('2015-03-01T00:00:00Z'),
        datepickerOptions: {
            showWeeks: false,
            startingDay: 1,
            dateDisabled: function(data) {
                return (data.mode === 'day' && (new Date().toDateString() == data.date.toDateString()));
            }
        }
    };

    // time picker
    this.picker2 = {
        date: new Date('2015-03-01T12:30:00Z'),
        timepickerOptions: {
            readonlyInput: false,
            showMeridian: false
        }
    };

    // date and time picker
    this.picker3 = {
        date: new Date()
    };

    // min date picker
    this.picker4 = {
        date: new Date(),
        datepickerOptions: {
            maxDate: null
        }
    };

    // max date picker
    this.picker5 = {
        date: new Date(),
        datepickerOptions: {
            minDate: null
        }
    };

    // set date for max picker, 10 days in future
    this.picker5.date.setDate(this.picker5.date.getDate() + 10);

    // global config picker
    this.picker6 = {
        date: new Date()
    };

    // dropdown up picker
    this.picker7 = {
        date: new Date()
    };

    // view mode picker
    this.picker8 = {
        date: new Date(),
        datepickerOptions: {
            mode: 'year',
            minMode: 'year',
            maxMode: 'year'
        }
    };

    // dropdown up picker
    this.picker9 = {
        date: null
    };

    // min time picker
    this.picker10 = {
        date: new Date('2016-03-01T09:00:00Z'),
        timepickerOptions: {
            max: null
        }
    };

    // max time picker
    this.picker11 = {
        date: new Date('2016-03-01T10:00:00Z'),
        timepickerOptions: {
            min: null
        }
    };

    // button bar
    this.picker12 = {
        date: new Date(),
        buttonBar: {
            show: true,
            now: {
                show: true,
                text: 'Now!'
            },
            today: {
                show: true,
                text: 'Today!'
            },
            clear: {
                show: false,
                text: 'Wipe'
            },
            date: {
                show: true,
                text: 'Date'
            },
            time: {
                show: true,
                text: 'Time'
            },
            close: {
                show: true,
                text: 'Shut'
            }
        }
    };

    // when closed picker
    this.picker13 = {
        date: new Date(),
        closed: function(args) {
            that.closedArgs = args;
        }
    };

    // saveAs - ISO
    this.picker14 = {
        date: new Date().toISOString()
    }

    this.openCalendar = function(e, picker) {
        that[picker].open = true;
    };

    // watch min and max dates to calculate difference
    var unwatchMinMaxValues = $scope.$watch(function() {
        return [that.picker4, that.picker5, that.picker10, that.picker11];
    }, function() {
        // min max dates
        that.picker4.datepickerOptions.maxDate = that.picker5.date;
        that.picker5.datepickerOptions.minDate = that.picker4.date;

        if (that.picker4.date && that.picker5.date) {
            var diff = that.picker4.date.getTime() - that.picker5.date.getTime();
            that.dayRange = Math.round(Math.abs(diff/(1000*60*60*24)))
        } else {
            that.dayRange = 'n/a';
        }

        // min max times
        that.picker10.timepickerOptions.max = that.picker11.date;
        that.picker11.timepickerOptions.min = that.picker10.date;
    }, true);


    // destroy watcher
    $scope.$on('$destroy', function() {
        unwatchMinMaxValues();
    });

}]);
// https://github.com/Gillardo/bootstrap-ui-datetime-picker
// Version: 2.4.3
// Released: 2016-07-14 
angular.module('ui.bootstrap.datetimepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
    .constant('uiDatetimePickerConfig', {
        dateFormat: 'yyyy-MM-dd HH:mm',
        defaultTime: '00:00:00',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        initialPicker: 'date',
        reOpenDefault: false,
        enableDate: true,
        enableTime: true,
        buttonBar: {
            show: true,
            now: {
                show: true,
                text: 'Now'
            },
            today: {
                show: true,
                text: 'Today'
            },
            clear: {
                show: true,
                text: 'Clear'
            },
            date: {
                show: true,
                text: 'Date'
            },
            time: {
                show: true,
                text: 'Time'
            },
            close: {
                show: true,
                text: 'Close'
            }
        },
        closeOnDateSelection: true,
        closeOnTimeNow: true,
        appendToBody: false,
        altInputFormats: [],
        ngModelOptions: {},
        saveAs: false,
        readAs: false
    })
    .controller('DateTimePickerController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$document', '$timeout', '$uibPosition', 'dateFilter', 'uibDateParser', 'uiDatetimePickerConfig', '$rootScope',
        function ($scope, $element, $attrs, $compile, $parse, $document, $timeout, $uibPosition, dateFilter, uibDateParser, uiDatetimePickerConfig, $rootScope) {
            var dateFormat = uiDatetimePickerConfig.dateFormat,
                ngModel, ngModelOptions, $popup, cache = {}, watchListeners = [],
                closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : uiDatetimePickerConfig.closeOnDateSelection,
                closeOnTimeNow = angular.isDefined($attrs.closeOnTimeNow) ? $scope.$parent.$eval($attrs.closeOnTimeNow) : uiDatetimePickerConfig.closeOnTimeNow,
                appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : uiDatetimePickerConfig.appendToBody,
                altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : uiDatetimePickerConfig.altInputFormats,
                saveAs = angular.isDefined($attrs.saveAs) ? $scope.$parent.$eval($attrs.saveAs) || $attrs.saveAs : uiDatetimePickerConfig.saveAs,
                readAs = angular.isDefined($attrs.readAs) ? $scope.$parent.$eval($attrs.readAs) : uiDatetimePickerConfig.readAs;

            this.init = function (_ngModel) {
                ngModel = _ngModel;
                ngModelOptions = ngModel.$options || uiDatetimePickerConfig.ngModelOptions;

                $scope.buttonBar = angular.isDefined($attrs.buttonBar) ? $scope.$parent.$eval($attrs.buttonBar) : uiDatetimePickerConfig.buttonBar;

                // determine which pickers should be available. Defaults to date and time
                $scope.enableDate = angular.isDefined($scope.enableDate) ? $scope.enableDate : uiDatetimePickerConfig.enableDate;
                $scope.enableTime = angular.isDefined($scope.enableTime) ? $scope.enableTime : uiDatetimePickerConfig.enableTime;

                // determine default picker
                $scope.initialPicker = angular.isDefined($attrs.initialPicker) ? $attrs.initialPicker : ($scope.enableDate ? uiDatetimePickerConfig.initialPicker : 'time');

                // determine the picker to open when control is re-opened
                $scope.reOpenDefault = angular.isDefined($attrs.reOpenDefault) ? $attrs.reOpenDefault : uiDatetimePickerConfig.reOpenDefault;

                // check if an illegal combination of options exists
                if ($scope.initialPicker == 'date' && !$scope.enableDate) {
                    throw new Error("datetimePicker can't have initialPicker set to date and have enableDate set to false.");
                }

                // default picker view
                $scope.showPicker = !$scope.enableDate ? 'time' : $scope.initialPicker;

                var isHtml5DateInput = false;

                if (uiDatetimePickerConfig.html5Types[$attrs.type]) {
                    dateFormat = uiDatetimePickerConfig.html5Types[$attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = $attrs.datetimePicker || uiDatetimePickerConfig.dateFormat;
                    $attrs.$observe('datetimePicker', function (value) {
                        var newDateFormat = value || uiDatetimePickerConfig.dateFormat;

                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = null;

                            if (!dateFormat) {
                                throw new Error('datetimePicker must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('datetimePicker must have a date format specified.');
                }

                // popup element used to display calendar
                var popupEl = angular.element('' +
                    '<div date-picker-wrap>' +
                    '<div uib-datepicker></div>' +
                    '</div>' +
                    '<div time-picker-wrap>' +
                    '<div uib-timepicker style="margin:0 auto"></div>' +
                    '</div>');

                if (ngModelOptions) {
                    timezone = ngModelOptions.timezone;
                    $scope.ngModelOptions = angular.copy(ngModelOptions);
                    $scope.ngModelOptions.timezone = null;
                    if ($scope.ngModelOptions.updateOnDefault === true) {
                        $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ?
                        $scope.ngModelOptions.updateOn + ' default' : 'default';
                    }

                    popupEl.attr('ng-model-options', 'ngModelOptions');
                } else {
                    timezone = null;
                }

                // get attributes from directive
                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)'
                });

                // datepicker element
                var datepickerEl = angular.element(popupEl.children()[0]);

                if (!$scope.datepickerOptions) {
                    $scope.datepickerOptions = {};
                }

                if (isHtml5DateInput) {
                    if ($attrs.type === 'month') {
                        $scope.datepickerOptions.datepickerMode = 'month';
                        $scope.datepickerOptions.minMode = 'month';
                    }
                }

                datepickerEl.attr('datepicker-options', 'datepickerOptions');

                // set datepickerMode to day by default as need to create watch
                // else disabled cannot pass in mode
                if (!angular.isDefined($scope.datepickerOptions.datepickerMode)) {
                    $scope.datepickerOptions.datepickerMode = 'day';
                }

                // timepicker element
                var timepickerEl = angular.element(popupEl.children()[1]);

                if (!$scope.timepickerOptions)
                    $scope.timepickerOptions = {};

                for (var key in $scope.timepickerOptions) {
                    timepickerEl.attr(cameltoDash(key), 'timepickerOptions.' + key);
                }

                // watch attrs - NOTE: minDate and maxDate are used with datePicker and timePicker.  By using the minDate and maxDate
                // with the timePicker, you can dynamically set the min and max time values.  This cannot be done using the min and max values
                // with the timePickerOptions
                angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
                    if ($scope.datepickerOptions[key]) {
                        if (key == 'minDate') {
                            timepickerEl.attr('min', 'datepickerOptions.minDate');
                        } else if (key == 'maxDate')
                            timepickerEl.attr('max', 'datepickerOptions.maxDate');
                    }
                });

                // do not check showWeeks attr, as should be used via datePickerOptions

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'datetime';
                    ngModel.$validators.datetime = validator;
                    ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        if (ngModel.$isEmpty(value)) {
                            $scope.date = value;
                            return value;
                        }

                        $scope.date = uibDateParser.fromTimezone(value, ngModelOptions.timezone);

                        dateFormat = dateFormat.replace(/M!/, 'MM')
                            .replace(/d!/, 'dd');

                        return uibDateParser.filter($scope.date, dateFormat);
                    });
                } else {
                    ngModel.$formatters.push(function (value) {
                        $scope.date = uibDateParser.fromTimezone(value, ngModelOptions.timezone);
                        return value;
                    });
                }

                if (saveAs) {
                    // If it is determined closure var's need to be exposed to the parser, don't add the formatter here.
                    // Instead just call the method from within the stock parser with this context and/or any needed closure variables.
                    if (angular.isFunction(saveAs))
                        ngModel.$parsers.push(saveAs);
                    else
                        ngModel.$parsers.push(saveAsParser);

                    // Assuming if saveAs is !false, we'll want to convert, either pass the function, or the stock str/num -> Date obj formatter.
                    if (angular.isFunction(readAs))
                        ngModel.$formatters.push(readAs);
                    else
                        ngModel.$formatters.push(readAsFormatter);
                }
                // Detect changes in the view from the text box
                ngModel.$viewChangeListeners.push(function () {
                    $scope.date = parseDateString(ngModel.$viewValue);
                });

                $element.bind('keydown', inputKeydownBind);

                $popup = $compile(popupEl)($scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    $element.after($popup);
                }

                function readAsFormatter(value) {
                    if (ngModel.$isEmpty(value))
                        return value;

                    var d = new Date(value);
                    if (angular.isDate(d) && !isNaN(d))
                        return d;

                    return value;
                }

                function saveAsParser(value) {
                    if (!value || angular.isString(value) || !angular.isDate(value) || isNaN(value))
                        return value;

                    if (saveAs === 'ISO')
                        return value.toISOString();

                    if (saveAs === 'json')
                        return value.toJSON();

                    if (saveAs === 'number')
                        return value.valueOf();

                    if (!isHtml5DateInput) {
                        dateFormat = dateFormat.replace(/M!/, 'MM')
                            .replace(/d!/, 'dd');
                        return uibDateParser.filter(uibDateParser.fromTimezone(value, ngModelOptions.timezone), dateFormat);
                    } else {
                        return uibDateParser.fromTimezone(value, ngModelOptions.timezone).toLocaleString();
                    }
                }
            };

            // get text
            $scope.getText = function (key) {
                return $scope.buttonBar[key].text || uiDatetimePickerConfig.buttonBar[key].text;
            };

            $scope.keydown = function (evt) {
                if (evt.which === 27) {
                    $scope.close(false);
                    $element[0].focus();
                }
            };

            // determine if button is to be shown or not
            $scope.doShow = function (key) {
                if (angular.isDefined($scope.buttonBar[key].show))
                    return $scope.buttonBar[key].show;
                else
                    return uiDatetimePickerConfig.buttonBar[key].show;
            };

            // Inner change
            $scope.dateSelection = function (dt, opt) {

                if(dt === null) return;
 
                // check if timePicker is being shown and merge dates, so that the date
                // part is never changed, only the time
                if ($scope.enableTime && $scope.showPicker === 'time') {

                    // only proceed if dt is a date
                    if (dt || dt != null) {
                        // check if our $scope.date is null, and if so, set to todays date
                        if (!angular.isDefined($scope.date) || $scope.date == null) {
                            $scope.date = new Date();
                        }

                        // dt will not be undefined if the now or today button is pressed
                        if (dt && dt != null) {
                            // get the existing date and update the time
                            var date = new Date($scope.date);
                            date.setHours(dt.getHours());
                            date.setMinutes(dt.getMinutes());
                            date.setSeconds(dt.getSeconds());
                            date.setMilliseconds(dt.getMilliseconds());
                            dt = date;
                        }
                    }
                }

                if (angular.isDefined(dt)) {
                    if (!$scope.date) {
                        var defaultTime = angular.isDefined($attrs.defaultTime) ? $attrs.defaultTime : uiDatetimePickerConfig.defaultTime;
                        var t = new Date('2001-01-01 ' + defaultTime);

                        if (!isNaN(t) && dt != null) {
                            dt.setHours(t.getHours());
                            dt.setMinutes(t.getMinutes());
                            dt.setSeconds(t.getSeconds());
                            dt.setMilliseconds(t.getMilliseconds());
                        }
                    }
                    $scope.date = dt;
                }

                var date = $scope.date ? dateFilter($scope.date, dateFormat) : null;

                $element.val(date);
                ngModel.$setViewValue(date);

                if (closeOnDateSelection) {
                    // do not close when using timePicker as make impossible to choose a time
                    if ($scope.showPicker != 'time' && date != null) {
                        // if time is enabled, swap to timePicker
                        if ($scope.enableTime) {
                            $scope.open('time');
                        } else {
                            $scope.close(false);
                        }
                    } else if (closeOnTimeNow && $scope.showPicker === 'time' && date != null && opt === 'now') {
                        $scope.close(false);
                    }
                }

            };

            $scope.$watch('isOpen', function (value) {
                $scope.dropdownStyle = {
                    display: value ? 'block' : 'none'
                };

                if (value) {
                    cache['openDate'] = $scope.date;

                    var position = appendToBody ? $uibPosition.offset($element) : $uibPosition.position($element);

                    if (appendToBody) {
                        $scope.dropdownStyle.top = (position.top + $element.prop('offsetHeight')) + 'px';
                    } else {
                        $scope.dropdownStyle.top = undefined;
                    }

                    $scope.dropdownStyle.left = position.left + 'px';

                    $timeout(function () {
                        $scope.$broadcast('uib:datepicker.focus');
                        $document.bind('click', documentClickBind);
                    }, 0, false);

                    $scope.open($scope.showPicker);
                } else {
                    $document.unbind('click', documentClickBind);
                }
            });

            $scope.isDisabled = function (date) {
                if (date === 'today' || date === 'now')
                    date = uibDateParser.fromTimezone(new Date(), timezone);

                var dates = {};
                angular.forEach(['minDate', 'maxDate'], function (key) {
                    if (!$scope.datepickerOptions[key]) {
                        dates[key] = null;
                    } else if (angular.isDate($scope.datepickerOptions[key])) {
                        dates[key] = uibDateParser.fromTimezone(new Date($scope.datepickerOptions[key]), timezone);
                    } else {
                        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
                    }
                });

                return $scope.datepickerOptions &&
                    dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
                    dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
            };

            $scope.compare = function (date1, date2) {
                return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            };

            $scope.select = function (opt, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
				
                var date = null;
                var isNow = opt === 'now';

                if (opt === 'today' || opt == 'now') {
                    var now = new Date();
                    if (angular.isDate($scope.date)) {
                        date = new Date($scope.date);
                        date.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                        date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
                    } else {
                        date = now;
                    }
                }

                $scope.dateSelection(date, opt);
            };

            $scope.open = function (picker, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                // need to delay this, else timePicker never shown
                $timeout(function () {
                    $scope.showPicker = picker;
                }, 0);

                // in order to update the timePicker, we need to update the model reference!
                // as found here https://angular-ui.github.io/bootstrap/#/timepicker
                if (picker == 'time') {
                    $timeout(function () {
                        $scope.date = parseDateString(ngModel.$viewValue);
                    }, 50);
                }
            };

            $scope.close = function (closePressed, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
				
                $scope.isOpen = false;

                // if enableDate and enableTime are true, reopen the picker in date mode first
                if ($scope.enableDate && $scope.enableTime)
                    $scope.showPicker = $scope.reOpenDefault === false ? 'date' : $scope.reOpenDefault;

                // if a on-close-fn has been defined, lets call it
                // we only call this if closePressed is defined!
                if (angular.isDefined(closePressed)) {
                    $scope.whenClosed({args: {closePressed: closePressed, openDate: cache['openDate'] || null, closeDate: $scope.date}});
                } else {
                    $element[0].focus();
                }
            };

            $scope.$on('$destroy', function () {
                if ($scope.isOpen === true) {
                    if (!$rootScope.$$phase) {
                        $scope.$apply(function () {
                            $scope.close();
                        });
                    }
                }

                watchListeners.forEach(function (a) {
                    a();
                });
                $popup.remove();
                $element.unbind('keydown', inputKeydownBind);
                $document.unbind('click', documentClickBind);
            });

            function documentClickBind(evt) {
                var popup = $popup[0];
                var dpContainsTarget = $element[0].contains(evt.target);

                // The popup node may not be an element node
                // In some browsers (IE only) element nodes have the 'contains' function
                var popupContainsTarget = popup.contains !== undefined && popup.contains(evt.target);

                if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
                    $scope.$apply(function () {
                        $scope.close(false);
                    });
                }
            }

            function inputKeydownBind(evt) {
                if (evt.which === 27 && $scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.close(false);
                    });
                    $element[0].focus();
                } else if (evt.which === 40 && !$scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = true;
                    });
                }
            }

            function cameltoDash(string) {
                return string.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }

            function parseDateString(viewValue) {
                var date = uibDateParser.parse(viewValue, dateFormat, $scope.date);
                if (isNaN(date)) {
                    for (var i = 0; i < altInputFormats.length; i++) {
                        date = uibDateParser.parse(viewValue, altInputFormats[i], $scope.date);
                        if (!isNaN(date)) {
                            return date;
                        }
                    }
                }
                return date;
            }

            function parseDate(viewValue) {
                if (angular.isNumber(viewValue) && !isNaN(viewValue)) {
                    // presumably timestamp to date object
                    viewValue = new Date(viewValue);
                }

                if (!viewValue) {
                    return null;
                }

                if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                    return viewValue;
                }

                if (angular.isString(viewValue)) {
                    var date = parseDateString(viewValue);
                    if (!isNaN(date)) {
                        return uibDateParser.toTimezone(date, ngModelOptions.timezone);
                    }

                    return undefined;
                } else {
                    return undefined;
                }
            }

            function validateMinMax(value) {
                if ($scope.datepickerOptions.minDate && value < $scope.datepickerOptions.minDate) {
                    return false;
                } else if ($scope.datepickerOptions.maxDate && value > $scope.datepickerOptions.maxDate) {
                    return false;
                } else {
                    return true;
                }
            }

            function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;

                if (!($attrs.ngRequired || $attrs.required) && !value) {
                    return true;
                }

                if (angular.isNumber(value)) {
                    value = new Date(value);
                }

                if (!value) {
                    return true;
                } else if (angular.isDate(value) && !isNaN(value)) {
                    return validateMinMax(value);
                } else if (angular.isDate(new Date(value)) && !isNaN(new Date(value).valueOf())) {
                    return validateMinMax(new Date(value));
                } else if (angular.isString(value)) {
                    return !isNaN(parseDateString(viewValue)) && validateMinMax(parseDateString(viewValue));
                } else {
                    return false;
                }
            }

        }])
    .directive('datetimePicker', function () {
        return {
            restrict: 'A',
            require: ['ngModel', 'datetimePicker'],
            controller: 'DateTimePickerController',
            scope: {
                isOpen: '=?',
                datepickerOptions: '=?',
                timepickerOptions: '=?',
                enableDate: '=?',
                enableTime: '=?',
                initialPicker: '=?',
                reOpenDefault: '=?',
                whenClosed: '&'
            },
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0],
                    ctrl = ctrls[1];

                ctrl.init(ngModel);
            }
        };
    })
    .directive('datePickerWrap', function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: 'template/date-picker.html'
        };
    })

    .directive('timePickerWrap', function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: 'template/time-picker.html'
        };
    });

angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('template/date-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'date'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=date-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('today') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('today')\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('today') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('time') && enableTime) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('time') && enableTime\" ng-click=\"open('time', $event)\">{{ getText('time')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );


  $templateCache.put('template/time-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'time'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=time-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('now') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('now')\" ng-click=\"select('now', $event)\" ng-disabled=\"isDisabled('now')\">{{ getText('now') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('date') && enableDate) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('date') && enableDate\" ng-click=\"open('date', $event)\">{{ getText('date')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );

}]);

angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('template/date-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'date'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=date-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('today') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('today')\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('today') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('time') && enableTime) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('time') && enableTime\" ng-click=\"open('time', $event)\">{{ getText('time')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );


  $templateCache.put('template/time-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'time'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=time-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('now') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('now')\" ng-click=\"select('now', $event)\" ng-disabled=\"isDisabled('now')\">{{ getText('now') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('date') && enableDate) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('date') && enableDate\" ng-click=\"open('date', $event)\">{{ getText('date')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );

}]);

/**
 * Created by miche on 27/06/2017.
 */
angular.module('gestioneAttiApp').controller('backToTopController', ['$scope', '$window', function($scope, $window){

}]).directive('backToTop', function () {
    return {
        restrict: 'E',
        scope : {
        },
        link: function ($scope, element, attrs) {
            $(window).ready(function() {
                $(element).fadeOut();
            });

            $(window).scroll(function () {

                if ($(window).scrollTop() <= 0) {
                    $(element).fadeOut();
                }
                else {
                    $(element).fadeIn();
                }

            });

            $(element).on('click', function () {
                $('html, body').animate({scrollTop: 0}, 'medium');
            });

        },
        template: '<md-button class="md-fab md-primary back-to-top" aria-label="BackToTop"><i class="glyphicon glyphicon-chevron-up" style="color: white" aria-hidden="true"></i> </md-button>'
    };
});

/**
 * Created by Michele Romani on 23/06/2017.
 */


angular.module('gestioneAttiApp').directive('attoTableList', function () {
    return {
        restrict: "EA",
        scope: {
            format: '=',
            paging: '=',
            showControls: '=',
            title: '=',
            tableType: '@',
            archiveTree: '&',
        },
        controller: ['$rootScope', '$scope', '$mdSidenav', '$state', 'Atto', 'ParseLinks', 'toastr', 'paginationConstants', 'Principal', 'FileSaver', '$mdDialog', 'SEARCH_STATES', 'ACT_TYPES', 'AdvanceSearchService', 'ATTI_TABLE_TYPE',
            function ($rootScope, $scope, $mdSidenav, $state, Atto, ParseLinks, toastr, paginationConstants, Principal, FileSaver, $mdDialog, SEARCH_STATES, ACT_TYPES, AdvanceSearchService, ATTI_TABLE_TYPE) {
                var vm = this;
                vm.queryStates = SEARCH_STATES;
                vm.actTypes = ACT_TYPES;
                vm.basicSearchFormPath = 'app/components/attoTableList/basicSearchForm.html';
                // defaults
                vm.paging = vm.paging || {};
                vm.format = vm.format || 'expanded';
                vm.tableType = vm.tableType || 0;

                // Usato per le pagine delle commissioni (giacenti - licenziati)
                vm.isCommissioneAtti = false;
                vm.isCommissioneAttiEsame = false;
                vm.isCommissioneAttiEsaminati = false;

                switch (Number(vm.tableType)) {
                case ATTI_TABLE_TYPE.COMMISSIONE_ESAME:{
                    vm.isCommissioneAtti = true;
                    vm.isCommissioneAttiEsame = true;
                    break;
                }
                case ATTI_TABLE_TYPE.COMMISSIONE_ESAMINATI: {
                    vm.isCommissioneAtti = true;
                    vm.isCommissioneAttiEsaminati = true;
                    break;
                }
                default:
                    vm.isCommissioneAtti = false;
                }

                vm.getProponentiAttoString = getProponentiAttoString;

                vm.basicSearchType = vm.paging.type;
                vm.basicSearchState = vm.paging.state;
                vm.basicSearchTerm = vm.paging.term;
                vm.basicNumeroAtto = vm.paging.numeroAttoSearch;
                vm.basicSearchLegislatura = vm.paging.legislatura;
                vm.basicSearchNumeroLegge = vm.paging.numeroLegge;
                vm.basicSearchDataPromulgazione = getDataPromulgazioneDate(vm.paging.dataPromulgazione);

                vm.isAdvancedSearchOpen = isAdvancedSearchOpen;
                vm.isAdvancedSearchOpenState = isAdvancedSearchOpenState;
                vm.advancedSearch = advancedSearch;

                vm.attachmentsModal = "attachmentsModal";
                vm.uploadModal = "uploadModal";
                vm.isAuthenticated = Principal.isAuthenticated();
                vm.authorizationLegislatura = vm.basicSearchLegislatura === 'ALL' ? 11 : vm.basicSearchLegislatura;
                vm.isAdmin = vm.isAuthenticated && Principal.hasAnyAuthority(['ROLE_ADMIN'],  vm.authorizationLegislatura);
                vm.isProtocollo = vm.isAuthenticated && Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'], vm.authorizationLegislatura);
                vm.isAula = vm.isAuthenticated && Principal.hasAnyAuthority(['ROLE_AULA'], vm.authorizationLegislatura);
                vm.isCommissione = vm.isAuthenticated && Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], vm.authorizationLegislatura);
                vm.isSettoreAtti = vm.isAuthenticated && Principal.hasAnyAuthority(['ROLE_SETTORE'], vm.authorizationLegislatura);
                vm.canEdit = vm.isAuthenticated;

                if (vm.canEdit && !vm.isAdmin) {
                    if(Principal.isCommissionWithRole(null, 'Dipendente', vm.authorizationLegislatura)) {
                        vm.canEdit = true;
                    } else {
                        vm.canEdit = vm.isProtocollo || Principal.hasAnyAuthority(['ROLE_SETTORE', 'ROLE_AULA', 'ROLE_EXTERNAL'], vm.authorizationLegislatura);
                    }
                    
                }

                vm.editDisabled = function (atto) {
                    if (vm.isAdmin || vm.isProtocollo) {
                        return false;
                    } else if (vm.isCommissione && atto.statoCorrente.statoAtto.name === 'APPROVATO' && ['PDRIS', 'MOZIONE', 'ODG'].includes(atto.tipoAtto)) {
                        return false;
                    } else if (vm.isAula && atto.statoCorrente.statoAtto.name === 'APPROVATO') {
                        return false;
                    } else if(vm.isSettoreAtti && atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA') {
                        return false;
                    } else if (vm.isStatoFinale(atto.statoCorrente.statoAtto)) {
                        if((atto.tipoAtto === "PEA" || atto.tipoAtto === "DEA") && (atto.statoCorrente.statoAtto.name === 'TRASMISSIONE GIUNTA' || atto.statoCorrente.statoAtto.name === 'APPROVATO')){
                            return !(vm.isCommissione || vm.isSettoreAtti);
                        }
                        return !(vm.isSettoreAtti || vm.isAula);
                    } else {
                        return false;
                    }
                };

                vm.transition = transition;
                vm.downloadArchive = downloadArchive;
                vm.panelStickyEvent = panelStickyEvent;

                // query stuff
                vm.predicate = vm.paging.predicate;
                vm.reverse = vm.paging.ascending;
                vm.itemsPerPage = paginationConstants.itemsPerPage;

                vm.loading = false;

                vm.legislature = [];
                Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);

                function onSuccessLeg(data){
                    vm.legislature=data;
                    if(vm.legislature && vm.legislature.indexOf(11) === -1) {
                        vm.legislature.push(11);
                    }
                }
                function onErrorLeg(error){
                    toastr.error(error.data.message);
                }

                loadAll();

                function loadAll() {
                    vm.loading = true;

                    if (vm.isCommissioneAtti) {
                        Atto.queryCommissioniAtti({
                            page: vm.paging.page - 1,
                            sort: sort(),
                            size: vm.itemsPerPage,
                            type: vm.basicSearchType,
                            term: vm.basicSearchTerm,
                            legislaturaSearch: vm.basicSearchLegislatura === 'ALL' ? null : vm.paging.legislatura, //11
                            numeroAttoSearch: vm.basicNumeroAtto,
                            idCommissione: vm.paging.idCommissione,
                            tipoPaginaCommissione: vm.paging.tipoPaginaCommissione
                        }, onSuccess, onError);
                    }
                    else {
                        // Se e' aperta la ricerca avanzata si fa la query con quella
                        if (vm.isAdvancedSearchOpenState()) {
                            vm.advancedSearch(AdvanceSearchService.getLatestSearchParams());
                        } else {
                            // Altrimenti si usa la basic search
                            Atto.query({
                                page: vm.paging.page - 1,
                                sort: sort(),
                                size: vm.itemsPerPage,
                                state: vm.basicSearchState,
                                type: vm.basicSearchType,
                                term: vm.basicSearchTerm,
                                legislaturaSearch: vm.basicSearchLegislatura === 'ALL' ? null : vm.basicSearchLegislatura,
                                numeroAttoSearch: vm.basicNumeroAtto,
                                numeroLegge: vm.basicSearchNumeroLegge,
                                dataPromulgazione: getFormattedDate(vm.basicSearchDataPromulgazione)
                            }, onSuccess, onError);
                        }
                    }
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.attos = data;
                    vm.page = vm.paging.page;
                    vm.loading = false;

                }


                function onError(error) {
                    toastr.error(error.data.message);
                    vm.loading = false;
                }

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        result.push('id');
                    }
                    return result;
                }

                /**
                 *
                 * @param {*} dataPromulgazioneStr date string format yyyy-MM-dd
                 */
                function getDataPromulgazioneDate(dataPromulgazioneStr) {
                    if (dataPromulgazioneStr && dataPromulgazioneStr.length > 0) {
                        return new Date(dataPromulgazioneStr);
                    }
                    return null;
                }

                function getFormattedDate(date) {
                    if (!date) {
                        return null;
                    }
                    var year = date.getFullYear();
                    var month = date.getMonth() + 1;
                    if (month < 10) {
                        month = '0' + month;
                    }
                    var day = date.getDate();
                    if (day < 10) {
                        day = '0' + day;
                    }
                    return year + '-' + month + '-' + day;
                }

                vm.clearDataPromulgazione = function() {
                    vm.basicSearchDataPromulgazione = null;
                    vm.transition(true);
                };

                function panelStickyEvent(event) {
                    $scope.$apply(function () {
                        vm.sticky = event && event.event && event.event === 'stick';
                    });
                }

                function transition(resetPage) {
                    if (resetPage) {
                        vm.page = 1;
                    }

                    if(vm.isCommissioneAtti) {
                        $state.transitionTo($state.$current, {
                            page: vm.page,
                            sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                            type: vm.basicSearchType,
                            term: vm.basicSearchTerm,
                            legislatura: vm.basicSearchLegislatura,
                            numeroAttoSearch: vm.basicNumeroAtto,
                            idCommissione: vm.paging.idCommissione,
                            tipoPaginaCommissione: vm.paging.tipoPaginaCommissione
                        });
                    }
                    else {
                        if(!vm.basicSearchLegislatura || vm.basicSearchLegislatura > 0 || vm.basicSearchLegislatura === 'ALL'){
                            $state.transitionTo($state.$current, {
                                page: vm.page,
                                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                                state: vm.basicSearchState,
                                type: vm.basicSearchType,
                                term: vm.basicSearchTerm,
                                legislatura: vm.basicSearchLegislatura,
                                numeroAttoSearch: vm.basicNumeroAtto,
                                numeroLegge: vm.basicSearchNumeroLegge,
                                dataPromulgazione: getFormattedDate(vm.basicSearchDataPromulgazione)
                            });

                        } else {
                            vm.basicSearchLegislatura = null;
                            toastr.error('Legislatura deve essere un intero!', {
                                timeOut: 60000,
                                extendedTimeOut: 0
                            });
                        }
                    }
                }

                function downloadArchive(attoId) {
                    if (!attoId)
                        return;
                    vm.loading = true;
                    Atto.getArchive(attoId).then(function (response) {
                        if (response && response.data) {
                            FileSaver.saveAs(new Blob([response.data], {}), 'Fascicolo-' + attoId + '.zip');
                        }
                        vm.loading = false;
                    }, function (error) {
                        toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                        vm.loading = false;
                    });

                }

                vm.setAttoIdForArchiveTree = function (attoId) {
                    $rootScope.attoIdForArchiveTree = attoId;
                    vm.attoIdForArchiveTree = attoId;
                    if (!$mdSidenav('right').isOpen()) {
                        $mdSidenav('right').open();
                    }
                    if ($mdSidenav('advanced-search-sidebar').isOpen()) {
                        $mdSidenav('advanced-search-sidebar').close();
                    }
                };

                vm.advancedSearchVisible = function () {
                    return $mdSidenav('advanced-search-sidebar').isOpen();
                };

                vm.deleteAtto = function (attoId) {
                    var confirm = $mdDialog.confirm()
                            .title('Eliminazione atto')
                            .textContent('Sicuro di voler eliminare questo atto?')
                            .ariaLabel('eliminazione atto')
                            .ok('Elimina')
                            .cancel('Annulla');

                    $mdDialog.show(confirm).then(function () {
                        Atto.delete({id: attoId}, function (result) {
                            toastr.success('OK', 'Atto eliminato correttamente');
                            $state.go($state.current, {}, {reload: true});
                        }, function (error) {
                            toastr.error(error);
                        });
                    });
                };

                vm.isStatoFinale = function (stato) {
                    return stato.finalState;
                };

                vm.toggleAdvancedSearch = function () {
                    vm.attoIdForArchiveTree = null;
                    if (!$mdSidenav('advanced-search-sidebar').isOpen()) {
                        $mdSidenav('advanced-search-sidebar').open();
                        // Passa il valore della legislatura al form di ricerca avanzata
                        var searchParams = AdvanceSearchService.getLatestSearchParams() || {};
                        searchParams.legislatura = vm.basicSearchLegislatura === 'ALL' ? null : vm.basicSearchLegislatura;
                        AdvanceSearchService.saveLatestSearchParams(searchParams);
                        AdvanceSearchService.setOpen();
                    } else {
                        $mdSidenav('advanced-search-sidebar').close();
                        AdvanceSearchService.setClosed();
                    }
                };


                function isAdvancedSearchOpen() {
                    return $mdSidenav('advanced-search-sidebar').isOpen();
                }

                function isAdvancedSearchOpenState() {
                    return AdvanceSearchService.isOpen();
                }

                function advancedSearch(searchParams) {
                    vm.loading = false;
                    Atto.advancedSearch({
                        searchParams: searchParams,
                        page: vm.paging.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }

                function getProponentiAttoString(data){

                    if(data.proponente) {
                        var proponenti = data.proponente.proponenti;
                        var descrizioniAnagrafiche = [];

                        if(proponenti) {
                            for (var i = 0; i < proponenti.length; i++) {
                                var descrizione = proponenti[i].descrizione;
                                descrizioniAnagrafiche.push(descrizione);
                            }

                            var resultString = descrizioniAnagrafiche.join(', ');
                            return resultString;
                        } else {
                            return "";
                        }
                    } else if (data.proponentiText) {
                        var proponenti = data.proponentiText;
                        var descrizioniAnagrafiche = [];

                        if(proponenti) {
                            for (var i = 0; i < proponenti.length; i++) {
                                var descrizione = proponenti[i];
                                descrizioniAnagrafiche.push(descrizione);
                            }

                            var resultString = descrizioniAnagrafiche.join(', ');
                            return resultString;
                        } else {
                            return "";
                        }
                    }
                }


            }],
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'app/components/attoTableList/attoTableList.html'
    };


});

/**
 * Created by Michele Romani on 26/06/2017.
 */

angular.module('gestioneAttiApp').directive('attachmentsDialog',  function () {
    return {
        restrict: "E",
        scope: {
            dialogId: "=dialogId"
        },
        controller: ["$scope",
            function ($scope) {
                var vm = this;
            }],
        templateUrl: 'app/components/attachmentsDialog/attachmentsDialog.html'
    }
});

/**
 * Created by miche on 26/06/2017.
 */

(function () {

    'use strict';

    var ArchiveTreeService = ['toastr', '$mdDialog', '$translate',
        function (toastr, $mdDialog, $translate) {
            var service = this;
            var copyLinkMsg = $translate.instant('archiveTree.copiedMsg');
            
            service.getLink = function(treeLink) {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    templateUrl: 'app/components/archiveTree/get-link-modal.html',
                    controller: ['$scope', '$mdDialog',
                        function ($scope, $mdDialog) {
                            $scope.treeLink = treeLink;

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            $scope.copyLink = function () {
                                var inputElement = document.getElementById('tree-link');
                                inputElement.select();
                                document.execCommand("Copy");
                                toastr.success("Ok", copyLinkMsg);
                                $mdDialog.cancel();
                            };
                        }],
                    locals: {
                    }
                });
            }

        }];

    angular.module('gestioneAttiApp').service('ArchiveTreeService', ArchiveTreeService);

})();

angular.module('gestioneAttiApp').directive('archiveTree', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/archiveTree/archiveTree.directive.html',
        scope: {
            attoId: '=',
            publicView: '=?'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'Documento', 'toastr', '$rootScope', '$mdSidenav', 'FileSaver', '$window', 'ArchiveTreeService',
            function (Atto, Documento, toastr, $rootScope, $mdSidenav, FileSaver, $window, ArchiveTreeService) {
                var vm = this;
                
                vm.loading = false;
                vm.loadingZip = false;

                vm.getArchiveTree = getArchiveTree;
                vm.downloadArchive = downloadArchive;
                vm.downloadFile = downloadFile;
                vm.getLink = ArchiveTreeService.getLink;

                vm.getArchiveTree();

                $rootScope.$watch('attoIdForArchiveTree', function (newVal, oldVal) {
                    vm.attoId = newVal;
                    getArchiveTree();
                }, true);

                function getArchiveTree() {
                    if (!vm.attoId) {
                        return;
                    }
                    vm.loading = true;
                    Atto.getArchiveTree(vm.attoId, vm.publicView).then(function (response) {
                        if (response && response.data) {
                            vm.archiveTree = [response.data];
                        }
                        vm.loading = false;
                    }, function (error) {
                        console.log('Impossibile scaricare il fascicolo');
                        toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                        vm.loading = false;
                    });

                }
                
                function downloadArchive() {
                    toastr.warning("Attenzione: La generazione dell'archivio può impiegare del tempo per essere completata. Si prega di rimanere nella pagina e attendere l'esito.", '', {
                        timeOut: 10000
                    });
                    if (!vm.attoId)
                        return;
                    vm.loadingZip = true;
                    Atto.getArchive(vm.attoId, vm.publicView).then(function (response) {
                        if (response && response.data) {
                            FileSaver.saveAs(new Blob([response.data], {}), 'Fascicolo-' + vm.attoId + '.zip');
                        }
                        vm.loadingZip = false;
                    }, function (error) {
                        console.log('Impossibile scaricare il fascicolo');
                        toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                        vm.loadingZip = false;
                    });

                }
                
                function downloadFile(id, name) {
                    if (!vm.attoId)
                        return;
                                        
                    vm.loading = true;
                    Documento.get({id:id}, {}, function(doc) {
                        Documento.getContent(id).then(function (response) {
                        if (response && response.data) {
                                var fileType = 'application/octet-stream';
                                if(doc.nome.toLowerCase().endsWith(".pdf") ){
                                    fileType = 	'application/pdf';
                                } else if((doc.nome.toLowerCase()).endsWith(".doc")) {
                                    fileType = 	'application/msword';
                                } else if((doc.nome.toLowerCase()).endsWith(".docx")){
                                    fileType = 	'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                                } else if((doc.nome.toLowerCase()).endsWith(".xls")){
                                    fileType = 	'application/vnd.ms-excel';
                                } else if((doc.nome.toLowerCase()).endsWith(".xlsx")){
                                    fileType = 	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                                } else if((doc.nome.toLowerCase()).endsWith(".ppt")){
                                    fileType = 	'application/vnd.ms-powerpoint';
                                } else if((doc.nome.toLowerCase()).endsWith(".pptx")){
                                    fileType = 	'application/vnd.openxmlformats-officedocument.presentationml.presentation';
                                }  else if((doc.nome.toLowerCase()).endsWith(".png")){
                                    fileType = 	'image/png';
                                }  else if((doc.nome.toLowerCase()).endsWith(".jpeg")){
                                    fileType = 	'image/jpeg';
                                }  else if((doc.nome.toLowerCase()).endsWith(".gif")){
                                    fileType = 	'image/gif';
                                }
                                FileSaver.saveAs(new Blob([response.data], {type: fileType}), doc.nome);
                        }
                        
                        vm.loading = false;
                    }, function (error) {
                        console.log('Impossibile scaricare il fascicolo');
                        toastr.error('Impossibile scaricare il fascicolo', error.data.message);
                        vm.loading = false;
                    });
                    });
                    
                    
                }

                vm.routeOrDownloadFile = function(node) {
                    // Mobile download it
                    if(navigator.userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)) {
                        downloadFile(node.id, node.title);
                    } else {
                        //Desktop route to preview
                        $window.open('/#/document/' + node.id + '/content', '_blank');
                    }
                }
                
                vm.closeArchiveTree = function() {
                    $rootScope.attoIdForArchiveTree = null;
                    vm.attoIdForArchiveTree = null;
                    
                    if ($mdSidenav('right').isOpen()) {
                        $mdSidenav('right').close();
                    }
                };
            }]
    };

});

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('gestioneAttiApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('gestioneAttiApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('gestioneAttiApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 403:
                addErrorAlert('Access Denied', $translate.instant('error.access.forbidden'));
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('gestioneAttiApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function () {

    'use strict';

    var AdvanceSearchService = ['Atto', 'Principal', 'User', 'toastr', '$rootScope',
        function (Atto, Principal, User, toastr, $rootScope) {
            var service = this;
            var searchParams;

            service.isAdvanceSearchOpen = false;
            
            service.setOpen = function() {
                service.isAdvanceSearchOpen = true;
                $rootScope.$broadcast('advancedSearchOpened');
            };

            service.setClosed = function() {
                service.isAdvanceSearchOpen = false;
                $rootScope.$broadcast('advancedSearchClosed');
            };

            service.isOpen = function() {
                return service.isAdvanceSearchOpen;
            };

            service.saveLatestSearchParams  = function(searchParams) {
                service.searchParams = searchParams;
            };

            service.getLatestSearchParams = function() {
                return service.searchParams;
            };
        }];

    angular.module('gestioneAttiApp').service('AdvanceSearchService', AdvanceSearchService);

})();

angular.module('gestioneAttiApp').directive('advancedSearch', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/advancedSearch/advancedSearch.directive.html',
        scope: {
            loading: '=',
            searchCallback: '&'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$mdSidenav', 'SEARCH_STATES', 'Commissione', 'SoggettoEsterno', 'ACT_TYPES', 'AnagraficaProtocollo', 'Direzione', 'Atto', 'AdvanceSearchService', '$scope',
            function ($mdSidenav, SEARCH_STATES, Commissione, SoggettoEsterno, ACT_TYPES, AnagraficaProtocollo, Direzione, Atto, AdvanceSearchService, $scope) {
                var vm = this;
                vm.listaAssessoriOrConsiglieri = [];
                vm.showConsiglieri = false;
                vm.legislature = [];
                initController();

                // Aggiungo un listener per reinizializzare quando il pannello viene aperto
                $scope.$on('advancedSearchOpened', function() {
                    initController();
                });

                vm.closeSearchPanel = function () {
                    if ($mdSidenav('advanced-search-sidebar').isOpen()) {
                        $mdSidenav('advanced-search-sidebar').close();
                        AdvanceSearchService.setClosed();
                    }
                };

                vm.toggleCheck = function (fieldName, value, dependentField) {
                    console.log(vm.searchParams);
                    var idx = vm.searchParams[fieldName].indexOf(value);
                    if (idx > -1) {
                        vm.searchParams[fieldName].splice(vm.searchParams[fieldName].indexOf(value), 1);
                    } else {
                        if (dependentField && vm.searchParams[dependentField] && vm.searchParams[dependentField].indexOf(value) > -1) {
                            vm.searchParams[dependentField].splice(vm.searchParams[dependentField].indexOf(value), 1);
                        }
                        vm.searchParams[fieldName].push(value);
                    }
                };

                vm.searchParamExists = function(fieldName, value) {
                    return vm.searchParams && vm.searchParams[fieldName] && vm.searchParams[fieldName].indexOf(value) > -1;
                };

                vm.search = function() {
                    if (!vm.loading) {
                        AdvanceSearchService.saveLatestSearchParams(vm.searchParams);
                        vm.searchCallback({searchParams: vm.searchParams});
                    }
                };

                function initController() {
                    vm.clearSearch = clearSearch;
                    var latestSearchParams = AdvanceSearchService.getLatestSearchParams();

                    if (latestSearchParams) {
                        vm.searchParams = latestSearchParams;
                        if (vm.searchParams.tipoProponente === 'GR') {
                            vm.showConsiglieri = false;  
                        } else {
                            vm.showConsiglieri = true;
                        }
                    } else {
                        vm.clearSearch();
                    }
                    
                    vm.queryStates = SEARCH_STATES;
                    vm.actTypes = ACT_TYPES;

                    var organismiLegislaturaFilter = null;
                    if(vm.searchParams.legislatura && vm.searchParams.legislatura !== 'ALL') {
                        organismiLegislaturaFilter = vm.searchParams.legislatura;
                    }

                    Commissione.query({legislature: organismiLegislaturaFilter}, function (result) {
                        vm.commissioni = result;
                    });

                    SoggettoEsterno.query({legislature: organismiLegislaturaFilter}, function (result) {
                        vm.soggettiEsterni = result;
                    });

                    AnagraficaProtocollo.query({}, function(result){
                        vm.assessori = [];
                        vm.consiglieri = [];
                        angular.forEach(result, function (anagrafica) {
                            if (anagrafica.tipoProponente === "GR") {
                                vm.assessori.push(anagrafica);
                            } else {
                                vm.consiglieri.push(anagrafica);
                            }
                        });
                    });
                
                    Direzione.query({}, function(result){
                        vm.direzione = result;
                    });

                     // Carica gruppi politici
                    Atto.getGruppiPolitici({}, function (data) {
                        vm.gruppiPolitici = data || [];
                        shuffle(vm.gruppiPolitici);
                    }, function (error) {
                        console.log('Errore nel recupero gruppi politici', error);
                    });


                    Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);
                    function onSuccessLeg(data){
                        vm.legislature = data;
                    }
                    function onErrorLeg(error){
                        console.log("Failure!", error);
                    }

                    AdvanceSearchService.saveLatestSearchParams(vm.searchParams);
                    
                }

                function shuffle(array) {
                    var currentIndex = array.length;
                  
                    while (currentIndex !== 0) {
                  
                        var randomIndex = Math.floor(Math.random() * currentIndex);
                        currentIndex--;

                        var temp = array[currentIndex];
                        array[currentIndex] = array[randomIndex];
                        array[randomIndex] = temp;

                    }
                }

                vm.searchFirmatari = function (searchText) {
                    //console.log("SEARCH FIRMATARI");
                    return searchText ? vm.listaAssessoriOrConsiglieri.filter(createFilterFor(searchText)) : [];
                };

                vm.searchAssessori = function (searchText) {
                    //console.log("SEARCH ASSESSORI - tipoAnagrafica =GR");
                    //return searchText ? vm.assessori.filter(createFilterFor(searchText)) : [];

                    if(searchText.length < 3) {
                        return [];
                    }
        
                    return AnagraficaProtocollo.search(
                        { 
                            term: searchText,
                            protocolSystem: 'ALL',
                            tipoAnagrafica: 'GR',
                            page: 0,
                            size: 20
                        }).$promise.then(onSuccessAnagAss, onErrorAnag);
        
                };

                function onSuccessAnagAss(data, headers) {
                    vm.assessori = data;
                    return data;
                }
        
                function onErrorAnag(error) {
                    console.log("Errore nel recupero anagrafiche!", error);
                }

                vm.searchConsiglieri = function (searchText) {
                    //console.log("SEARCH CONSIGLIERI - tipoAnagrafica = CR");
                    //return searchText ? vm.consiglieri.filter(createFilterFor(searchText)) : [];
                    if(searchText.length < 3) {
                        return [];
                    }
        
                    return AnagraficaProtocollo.search(
                        { 
                            term: searchText,
                            protocolSystem: 'ALL',
                            tipoAnagrafica: 'CR',
                            page: 0,
                            size: 20
                        }).$promise.then(onSuccessAnagCons, onErrorAnag);
                };

                function onSuccessAnagCons(data, headers) {
                    vm.consiglieri = data;
                    return vm.consiglieri;
                }

                vm.addPersonToList = function (chip) {
                    // Otherwise, create a new one
                    if (angular.isObject(chip)) {
                        return chip;
                    }
                    return {descrizione: chip};
        
                };
        
                function createFilterFor(query) {
                    var lowercaseQuery = angular.lowercase(query);
        
                    return function filterFn(firmatario) {
                        var codice = firmatario.codice.toLowerCase();
                        var descrizione = firmatario.descrizione.toLowerCase();
                        return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                    };
                }

                vm.tipoProponenteChange = function () {
                    vm.searchParams.proponenti = [];
                    vm.searchParams.gruppiPolitici = [];
                    vm.searchParams.direzioneGRId = null;
                    if (vm.searchParams.tipoProponente === 'GR') {
                        vm.showConsiglieri = false;  
                    } else {
                        vm.showConsiglieri = true;
                    }
                };

                vm.legislaturaChange = function () {
                    initController();
                    resetPareriOnSearchParams();
                };

                function resetPareriOnSearchParams(){
                    vm.searchParams.parereReferente = [];
                    vm.searchParams.parereSecondario = [];
                    vm.searchParams.parereObbligatorio = [];
                    vm.searchParams.osservazioni = [];
                    AdvanceSearchService.saveLatestSearchParams(vm.searchParams);

                }

                function clearSearch() {
                    vm.searchParams = {
                        parereReferente: [],
                        parereSecondario: [],
                        parereObbligatorio: [],
                        osservazioni: [],
                        legislatura : 11,
                        tipoProponente: null,
                        proponenti: [],
                        gruppiPolitici: [],
                        direzioneGRId: null
                    };
                }
            }]
    };

});

(function () {
    'use strict';

    var adempimentoComponent = {

        templateUrl: 'app/components/adempimento/adempimento.html',
        bindings: {
            'model' : '=',
            'disabled' : '=',
            'commissioni': '=',
            'label': '@',
            'onDelete': '&',
        },
        controller: ['toastr', 'DateUtils', '$mdDialog', function (toastr, DateUtils, $mdDialog) {
            var vm = this;
            vm.incaricatoList = ['GIUNTA', 'CONSIGLIO', 'ALTRO'];
            vm.destinatarioAdempimento = ['COMMISSIONE', 'CONSIGLIO', 'ALTRO'];
            vm.model.commissioniDestinatarie = !vm.model.commissioniDestinatarie ? [] : vm.model.commissioniDestinatarie;
            vm.model.incaricatiAdempimento = !vm.model.incaricatiAdempimento ? [] : vm.model.incaricatiAdempimento;
            vm.model.destinatariAdempimento = !vm.model.destinatariAdempimento ? [] : vm.model.destinatariAdempimento;

            vm.destinatarioAdempimentoChanged = function() {
                if (vm.model.destinatariAdempimento && !vm.model.destinatariAdempimento.includes('COMMISSIONE')) {
                    vm.model.commissioniDestinatarie = [];
                }
            }
            
            vm.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                list.splice(idx, 1);
                }
                else {
                list.push(item);
                }
            };

            vm.exists = function (item, list) {
                if (!list) {
                    return false;
                }
                return list.indexOf(item) > -1;
            };

            vm.onClearClick = function() {

                var confirm = $mdDialog.confirm()
                    .title('Sei sicuro di voler eliminare l\'adempimento?')
                    .textContent('Eliminando l\'adempimento le informazioni già inserite verranno perse. Procedere comunque?')
                    .ariaLabel('Eliminazione adempimento')
                    .ok('Conferma')
                    .cancel('Annulla');

                $mdDialog.show(confirm).then(function () {
                    vm.model = {
                        commissioniDestinatarie: []
                    };
                    vm.onDelete();
                }, function () {
                    
                });
                
            }
            
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('adempimentoComponent', adempimentoComponent);
})();

(function () {
    'use strict';

    var adempimentiListComponent = {

        templateUrl: 'app/components/adempimentiList/adempimenti-list.html',
        bindings: {
            'model' : '=',
            'disabled' : '=',
            'commissioni': '='
        },
        controller: ['toastr', 'AdempimentoUtil', function (toastr, AdempimentoUtil) {
            var vm = this;
            vm.model.adempimenti = !vm.model.adempimenti ? [] : vm.model.adempimenti;

            vm.onAdempimentoDelete = function(index) {
                vm.model.adempimenti.splice(index, 1);
            }

            vm.addNewAdempimento = function() {
                for(var i = 0; i < vm.model.adempimenti.length; i++) {
                    if (!AdempimentoUtil.isAdempimentoValid(vm.model.adempimenti[i])) {
                        toastr.error('Impossibile aggiungere un nuovo adempimento: controllare che i precedenti siano compilati correttamente.');
                        return;
                    }
                }
                vm.model.adempimenti.push({});
            }
        }],
        controllerAs: 'vm'
    };

    angular.module('gestioneAttiApp').component('adempimentiListComponent', adempimentiListComponent);
})();

angular.module('gestioneAttiApp').directive('addableInput', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/addableInput/addableInput.directive.html',
        scope: {
            dateLabel: '=?',
            disabled: '=',
            editOnlyLastValue: '=?',
            inputModel: '=',
            inputType: '=',
            invalidFields: '=?',
            textLabel: '=?',
            validating: '=?',
            fieldName: '@?',
            anagraficheProtocollo: '=?',
            protocolSystem: '=?',
            organismiSeduta: '=?'
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$translate','AnagraficaProtocollo', function ($translate, AnagraficaProtocollo) {
            var vm = this;

            var dateObjTemplate = "";
            var textObjTemplate = "";
            var textAndDateObjTemplate = {text:"", date:""};
            var attachedActObjTemplate = {type:"", number:"", state:""};
            var richiestaDiGiuntaObjTemplate = {proponente:[], dataRichiesta:"", numeroProtocollo:""};
            var resolutionObjTemplate = {date:"", esito:"", voto:"",resolutionNumber:""};
            var deaPresentationInputObjTemplate = {ente: "", carica: "", personaNominata: ""};
            var avvisoRettificaObjTemplate = { numeroBurt: "", parteBurt: "", dataBurt: ""};

            vm.addInput = addInput;
            vm.clearOrRemoveInput = clearOrRemoveInput;
            vm.membroSelected = membroSelected;

            init();

            vm.isInputDisabled = function (index) {
                if (vm.disabled) {
                    return true;
                }

                if (vm.blockedEntries.length > 0) {
                    return index < vm.blockedEntries.length;
                }

                return false;
            };

            vm.isButtonEnabled = function (index, type) {
                if (vm.disabled || !vm.inputModel) {
                    return false;
                }

                if (vm.blockedEntries.length > 0) {
                    return index >= vm.blockedEntries.length;
                }

                if (type === 'add') {
                    if (vm.inputType === 'textAndDate') {
                        return vm.inputModel[index] && index === vm.inputModel.length - 1 && vm.inputModel[index].text && vm.inputModel[index].date;
                    } else if (vm.inputType === 'attachedActs') {
                        return vm.inputModel[index] && index === vm.inputModel.length - 1 && vm.inputModel[index].type && vm.inputModel[index].number;
                    } else {
                        return vm.inputModel[index] && index === vm.inputModel.length - 1;
                    }
                } else if (type === 'remove') {
                    return index === 0 ? vm.inputModel[index] : true;
                } else {
                    return false;
                }
            };

            function clearOrRemoveInput(index){
                if(vm.inputModel.length > 1 ) {
                    vm.inputModel.splice(index, 1);
                } else {
                    vm.inputModel[index] = angular.copy(vm.objTemplate);
                }
            }

            //var tmp = angular.copy(params);
            function isFieldsetFilled(fieldset){
                if (typeof fieldset === 'string' || fieldset instanceof String) {
                    return fieldset.length
                } else {
                    for (var i in fieldset) {
                        if(fieldset[i] instanceof Array && fieldset[i].length === 0){
                            return false;
                        } else if (fieldset[i] === "") {
                            return false;
                        }
                    }
                    return true;
                }
            }

            function areAllFieldsetFilled() {
                for (var i in vm.inputModel) {
                    if(!isFieldsetFilled(vm.inputModel[i])){
                        return false;
                    }
                }
                return true;
            }

            function addInput(template){
                if (areAllFieldsetFilled()) {
                    vm.inputModel.push(template);
                }
            }

            function init() {
                vm.invalidFields = vm.invalidFields || [];
                vm.blockedEntries = [];
                vm.attachedActsTypes = ['resolution', 'motion', 'odg'];
                vm.attachedActsStates = ['approved', 'rejected', 'expired', 'withdrawn', 'delayed'];

                switch (vm.inputType) {
                    case "text": vm.objTemplate=textObjTemplate; break;
                    case "date": vm.objTemplate=dateObjTemplate;break;
                    case "textAndDate": vm.objTemplate=textAndDateObjTemplate ;break;
                    case "attachedActs": vm.objTemplate=attachedActObjTemplate ;break;
                    case "richiestaDiGiunta": vm.objTemplate= richiestaDiGiuntaObjTemplate;break;
                    case "resolution": vm.objTemplate = resolutionObjTemplate; break;
                    case "dea-presentation-input": vm.objTemplate = deaPresentationInputObjTemplate; break;
                    case "avvisoRettifica": vm.objTemplate = avvisoRettificaObjTemplate; break;
                }

                if (!vm.inputType) throw Exception;

                if (vm.editOnlyLastValue && vm.inputModel && vm.inputModel.length > 0) {
                    for (var i = 0; i < vm.inputModel.length - 1; i++) {
                        vm.blockedEntries.push(vm.inputModel[i]);
                    }
                }

                if (!vm.inputModel) {
                    vm.inputModel = [];
                }

                if (vm.inputModel.length === 0) {
                    vm.addInput(angular.copy(vm.objTemplate));
                } else if (!vm.inputModel[0]) {
                    vm.inputModel[0] = angular.copy(vm.objTemplate);
                }

                vm.label = $translate.instant(vm.inputLabel);
            }

            vm.isFieldInvalid = function (idx) {
                if (!vm.fieldName) {
                    return false;
                }

                var invalidFieldPresent = false;
                if (vm.invalidFields) {
                    if (idx) {
                        invalidFieldPresent = vm.invalidFields.indexOf(vm.fieldName + '_' + idx) > -1;
                    } else {
                        invalidFieldPresent = vm.invalidFields.indexOf(vm.fieldName) > -1
                    }
                }
                return vm.validating && invalidFieldPresent;
            };


            vm.searchFirmatari = function (searchText) {

                if(searchText.length < 3) {
                    return [];
                }
        
                return AnagraficaProtocollo.search(
                    { 
                        term: searchText,
                        protocolSystem: vm.protocolSystem,
                        //tipoAnagrafica: 'CR',
                        page: 0,
                        size: 20
                    }).$promise.then(onSuccessAnag, onErrorAnag);

                //var lista = vm.anagraficheProtocollo;
    /*             if (vm.atto.tipoProponente === 'GR') {
                    lista = vm.assessori;
                } else if (vm.atto.tipoProponente === 'COMMISSIONE') {
                    lista = vm.commissioni;
                } else {
                    lista = vm.consiglieri;
                } */
                //return searchText ? lista.filter(createFilterFor(searchText)) : [];
            };
            
            function onSuccessAnag(data, headers) {
                vm.anagraficheProtocollo = data;
                return data;
            }
        
            function onErrorAnag(error) {
                console.log("Errore nel recupero anagrafiche!", error);
            }

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
    
                return function filterFn(firmatario) {
                    var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                    var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                    return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                };
            }

            function membroSelected(event){
                console.log(event);
            }


        }]
    };
});

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                if(response.status === 403 && response.config.url.indexOf('/api/internal/check') === 0) {
                    //Remove error emit for directive is-intranet
                } else {
                    $rootScope.$emit('gestioneAttiApp.httpError', response);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                //Se sono diversi, non sto facendo il refresh nella solita pagina
                if(toState.name != fromState.name) {
                	sessionStorage.setItem('fromState', fromState.name);
                }

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;
                //Se sono diversi, non sto facendo il refresh nella solita pagina
                if(toState.name != fromState.name) {
	                sessionStorage.setItem('type', fromParams.type);
	                sessionStorage.setItem('state', fromParams.state);
	                sessionStorage.setItem('term', fromParams.term);
	                sessionStorage.setItem('page', fromParams.page);
                    sessionStorage.setItem('legislatura', fromParams.legislatura);
                    sessionStorage.setItem('numeroAttoSearch', fromParams.numeroAttoSearch);
                    sessionStorage.setItem('idCommissione', fromParams.idCommissione);
                }
                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(bootstrapMaterialDesignConfig);

    compileServiceConfig.$inject = [];

    function bootstrapMaterialDesignConfig() {
        $.material.init();

    }

    function compileServiceConfig() {

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];


    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translatePartialLoader', function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('archive-tree');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gestioneAttiApp')
        .constant('VERSION', "6.2.12")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$mdDialog', 'User', 'JhiLanguageService', 'toastr', 'Commissione',
        'CommissioneRuolo', 'SoggettoEsterno', 'Settore', 'AUTHORITIES', '$state', '$translate', 'Atto', '$scope', 'TipoDocumento', 'Sezione'];

    function UserManagementDialogController($mdDialog, User, JhiLanguageService, toastr, Commissione, CommissioneRuolo,
            SoggettoEsterno, Settore, AUTHORITIES, $state, $translate, Atto, $scope, TipoDocumento, Sezione) {
        var vm = this;
        vm.windowsAuthEnabled = vm.env.windowsAuthEnabled;
        vm.user = vm.entity;
        vm.isExternalDomainUser = false;
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.settori = [];
        vm.commissioni = [];
        vm.commissioniRuoli = [];
        vm.soggettiEsterni = [];
        vm.tipiDocumento = [];
        vm.user.langKey = 'it';
        vm.legislature = [];
        vm.selectedLegislaturaIndex = 0;
        vm.filterSoggettoStoricizzato = filterSoggettoStoricizzato;
        vm.nomiSezione = [];

        initController();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        vm.isCommissionUser = function (legislatura) {
            if(!legislatura) {
                return hasAuthority('ROLE_COMMISSIONE');
            } else {
                var legiAuth = vm.getLegislaturaAuthorities(legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_COMMISSIONE') > -1;
                } else {
                    return false;
                }
            }
        };

        vm.isExternalUser = function (legislatura) {
            if(!legislatura) {
                return hasAuthority('ROLE_EXTERNAL');
            } else {
                var legiAuth = vm.getLegislaturaAuthorities(legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_EXTERNAL') > -1;
                } else {
                    return false;
                }    
            }
        };

        vm.isSectorUser = function () {
            return hasAuthority('ROLE_SETTORE');
        };

        vm.isSectionUser = function () {
            return hasAuthority('ROLE_SECTION');
        };

        vm.setUserData = function (ldapUser) {
            if (ldapUser) {
                vm.user.login = ldapUser.principal;
                vm.user.firstName = ldapUser.firstName;
                vm.user.lastName = ldapUser.lastName;
                vm.user.email = ldapUser.email;
            }
        };

        vm.searchLdapUsers = function (text) {
            if (!text || text.length < 3) {
                return [];
            }
            return vm.ldapUsers.filter(createFilterFor(text));
        };


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(user) {
                return ((user.lastName && user.lastName.toString().toLowerCase().indexOf(lowercaseQuery) === 0)
                        || (user.firstName && user.firstName.toString().toLowerCase().indexOf(lowercaseQuery) === 0)
                        || (user.principal && user.principal.toString().toLowerCase().indexOf(lowercaseQuery) === 0));
            };
        }

        function hasAuthority(authority) {
            return vm.user.authorities !== null
                    && angular.isDefined(vm.user.authorities)
                    && vm.user.authorities.indexOf(authority) > -1;
        }

        function clear() {
            $mdDialog.cancel();
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('user-management', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;

            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                if(vm.isExternalDomainUser){
                    vm.user.fiscalCode = vm.user.login;
                }
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function initController() {

            // Array di authorities permanenti
            vm.authorities = [];
            vm.authorities.push("ROLE_USER");
            angular.forEach(AUTHORITIES, function(auth) {
                vm.authorities.push(auth.name);
            });

            // Authorities specifiche per legislatura
            vm.legiAuthorities = ["ROLE_COMMISSIONE","ROLE_AULA","ROLE_EXTERNAL"];
            // Rimuove authority di legislatura 
            angular.forEach(vm.legiAuthorities, function(legiAuth) {
                var index = vm.authorities.indexOf(legiAuth);
                if (index !== -1) {
                    vm.authorities.splice(index, 1);
                }
            });
            
            // load settori
            Settore.query({}, function (settori) {
                vm.settori = settori;
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei settori: ' + error.message, 'Errore!');
            });

            // load commissioni
            Commissione.query({includeHidden : true}, function (commissioni) {
                vm.commissioni = commissioni;
            }, function (error) {
                toastr.error('Impossibile reperire la lista delle commissioni: ' + error.message, 'Errore!');
            });

            // load commissioni ruoli
            CommissioneRuolo.query({}, function (commissioniRuoli) {
                vm.commissioniRuoli = commissioniRuoli;
                normalizzaCommissioniRuoloAssociato();
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei ruoli delle commissioni: ' + error.message, 'Errore!');
            });

            // load soggetti
            SoggettoEsterno.query({}, function (soggetto) {
                vm.soggettiEsterni = soggetto;
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei soggetti esterni: ' + error.message, 'Errore!');
            });

            if (vm.windowsAuthEnabled) {
                vm.filteredLdapUsers = [];
                vm.loadingLdapUsers = true;
                User.fromLdap({}, function (results) {
                    vm.ldapUsers = results;
                    vm.loadingLdapUsers = false;
                }, function (error) {
                    if(error.status === 403) {
                        toastr.error($translate.instant('userManagement.error.forbidden'));
                    } else {
                        toastr.error("Errore nell'interrogazione dell'Active Directory: " + error);
                    }
                    vm.loadingLdapUsers = false;
                });
            }

            // Carica le legislature
            Atto.queryLegislature({}, function (legislature) {
                vm.legislature = legislature;
                if (vm.legislature && vm.legislature.length > 0) {
                    vm.selectedLegislaturaIndex = vm.legislature.length - 1;
                }
            }, function (error) {
                toastr.error('Impossibile reperire la lista delle legislature: ' + error.message, 'Errore!');
            });

            // Inizializza la lista di sezione authorities se non esiste
            if (!vm.user.sectionAuthorities) {
                vm.user.sectionAuthorities = [];
            }

            TipoDocumento.query({}, function(docTypes){
                vm.tipiDocumento = docTypes;
                normalizzaTipiDocumento();
            }, function (error){
                toastr.error('Impossibile reperire la lista dei tipi documento: ' + error.message, 'Errore!');
            });

            // Carica le sezioni
            Sezione.query({}, function(sezioni) {
                if(angular.isArray(sezioni)) {
                    for (var i = 0; i < sezioni.length; i++) {
                        var nomeSezione = sezioni[i];
                        var traduzione = $translate.instant('sezioni.' + nomeSezione) || nomeSezione;
                        vm.nomiSezione.push({
                            nome : nomeSezione,
                            view : traduzione
                        });
                    }
                }
            }, function(error) {
                toastr.error('Impossibile reperire la lista delle sezioni: ' + error.message, 'Errore!');
            });

        }

        function findById(array, id) {
            return findByField(array, "id", id);
        }

        function findByLegislatura(legiAuth, legislatura) {
            for (var i = 0; i < legiAuth.length; i++) {
                if (legiAuth[i]['legislatura'].legislatura === legislatura) {
                    return legiAuth[i];
                }
            }
            return null;
        }

        function findByField(array, fieldName, value) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][fieldName] === value) {
                    return array[i];
                }
            }
            return null;
        }

        // Recupera le authorities di legsilatura per la legislatura in input
        vm.getLegislaturaAuthorities = function(legislatura) {
            if(angular.isArray(vm.user.legislaturaAuthorities)) {
                return findByLegislatura(vm.user.legislaturaAuthorities, legislatura);
            } else  {
                return null;
            }
        };

        // Recupera l'oggetto CommissioneRuoloAssociato 
        // relativo alla commissione in input
        // Per la legislatura in input
        vm.getCommissioneRuoloAssociato = function(legislatura, commissione){
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth['commissioneRuoloAssociato'])) {
                for (var i = 0; i < legAuth['commissioneRuoloAssociato'].length; i++) {
                    var item = legAuth['commissioneRuoloAssociato'][i];
                    if (item.commissione && item.commissione.id === commissione.id) {
                        return legAuth.commissioneRuoloAssociato[i];
                    }
                }
            }
        };

        //------------ Funzioni di normalizzazione per riallineare gli oggetti del BE con quelli angular

        // Ruoli commissione
        function normalizzaCommissioniRuoloAssociato() {
            if (!vm.user.legislaturaAuthorities) return;
            
            // Sostituisci forEach() con cicli for per essere più sicuri
            for (var i = 0; i < vm.user.legislaturaAuthorities.length; i++) {
                var legAuth = vm.user.legislaturaAuthorities[i];
                if (legAuth.commissioneRuoloAssociato) {
                    for (var j = 0; j < legAuth.commissioneRuoloAssociato.length; j++) {
                        var item = legAuth.commissioneRuoloAssociato[j];
                        if (item.commissioneRuolo) {
                            var found = findById(vm.commissioniRuoli, item.commissioneRuolo.id);
                            if (found) {
                                item.commissioneRuolo = found;
                            }
                        }
                    }
                }
            }
        }

        // Tipi documento in SectionAuthorities
        function normalizzaTipiDocumento() {
            if (!vm.user.sectionAuthorities) return;
            
            for (var i = 0; i < vm.user.sectionAuthorities.length; i++) {
                var sectionAuth = vm.user.sectionAuthorities[i];
                var tipiNormalizzati = [];
                if (sectionAuth.tipiDocumento) {
                    for (var j = 0; j < sectionAuth.tipiDocumento.length; j++) {
                        var item = sectionAuth.tipiDocumento[j];
                        if (item.id) {
                            var found = findById(vm.tipiDocumento, item.id);
                            if (found) {
                                tipiNormalizzati.push(found);
                            }
                        }
                    }
                    sectionAuth.tipiDocumento = tipiNormalizzati;
                }
            }
        }

        // ----------- Fine Normalizzazioni

        // Ritorna 
        function filterSoggettoStoricizzato(soggettiStoricizzati, legislatura) {
            if (!soggettiStoricizzati || !legislatura) return [];
            
            // Sostituisci filter() con un ciclo for
            var filtered = [];
            for (var i = 0; i < soggettiStoricizzati.length; i++) {
                var item = soggettiStoricizzati[i];
                if (item.legislature && item.legislature.indexOf(legislatura) > -1) {
                    filtered.push(item);
                }
            }
            return filtered;
        }

        vm.isCheckedItem = function(legislatura, arrayName, value) {
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth[arrayName])) {
                if (arrayName === 'commissioneRuoloAssociato') {
                    // Cerca se esiste un oggetto con commissione.id === value.id
                    return legAuth[arrayName].some(function(item) {
                        return item.commissione && item.commissione.id === value.id;
                    });
                } else if(angular.isString(value)){
                    return legAuth[arrayName].indexOf(value) > -1;
                } else {
                    for (var j = 0; j < legAuth[arrayName].length; j++) {
                        if (legAuth[arrayName][j].id === value.id) {
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };

        vm.toggleItem = function(legislatura, arrayName, value) {
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            // Inserisce informazioni legislatura se non presenti
            if (!legAuth) {
                legAuth = { legislatura: { legislatura: legislatura } };
                legAuth[arrayName] = [];
                if (!vm.user.legislaturaAuthorities) {
                    vm.user.legislaturaAuthorities = [];
                }
                vm.user.legislaturaAuthorities.push(legAuth);
            }
            // Inserisce l'array dei permessi "arrayName" se non presente
            if (!angular.isArray(legAuth[arrayName])) {
                legAuth[arrayName] = [];
            }
            // Comportamento specifico per gli oggetti commissione (con ruolo) e soggetti esterni
            if (arrayName === 'commissioneRuoloAssociato') {

                var idxC = -1;
                for (var i = 0; i < legAuth[arrayName].length; i++) {
                    var item = legAuth[arrayName][i];
                    if (item.commissione && item.commissione.id === value.id) {
                        idxC = i;
                        break;
                    }
                }
                
                if (idxC > -1) {
                    // Se già presente, rimuovi
                    legAuth[arrayName].splice(idxC, 1);
                } else { 
                    // Se non presente inserisce l'oggetto commissioneRuoloAssociato con ruolo di default
                    legAuth[arrayName].push({ commissione: value, commissioneRuolo: null });
                }
            } else if (arrayName === 'soggettiEsterni' || arrayName === 'settori') {

                var idxE = -1;
                for (var j = 0; j < legAuth[arrayName].length; j++) {
                    if (legAuth[arrayName][j].id === value.id) {
                        idxE = j;
                        break;
                    }
                }
                
                if (idxE > -1) {
                    // Se già presente, rimuovi
                    legAuth[arrayName].splice(idxE, 1);
                } else {
                    // Se non presente inserisce il soggetto esterno
                    legAuth[arrayName].push(value);
                }
            } else {
                // Comportamento di default per elementi stringa
                var idx = legAuth[arrayName].indexOf(value);
                if (idx > -1) {
                    legAuth[arrayName].splice(idx, 1);
                } else {
                    legAuth[arrayName].push(value);
                }
            }
        };

        // Toggle authorities permanenti
        vm.togglePermanentProfile = function(value) {
            var permAuth = vm.user.authorities;
            if(permAuth) {
                var idx = permAuth.indexOf(value);
                if (idx > -1) {
                    permAuth.splice(idx, 1);
                } else {
                    permAuth.push(value);
                }
            }
        };

        // Toggle settore
        vm.toggleSettore = function(value) {
            if (!vm.user.settori) {
                vm.user.settori = [];
            }
            var settori = vm.user.settori;
            var idx = settori.indexOf(value);
            if (idx > -1) {
                settori.splice(idx, 1);
            } else {
                settori.push(value);
            }
        };

        /*  
        *      AUTHORITIES SEZIONE
        */
        // Funzione per aggiungere una Sezione Authority
        vm.addSezioneAuthority = function() {
            if(!vm.user.sectionAuthorities) {
                vm.user.sectionAuthorities = [];
            }
        
            if(!hasOneEmptyElement(vm.user.sectionAuthorities)){
                // Controlla se ci sono ancora sezioni disponibili PRIMA di aggiungere
                var availableSections = vm.getAvailableSections(vm.user.sectionAuthorities.length);
                if (availableSections.length === 0) {
                    // Tutte le sezioni assegnate
                    toastr.error('Tutte le sezioni sono già state assegnate');
                    return;
                }
                
                vm.user.sectionAuthorities.push({
                    nomeSezione: '',
                    tipiDocumento: [] 
                });
            }
        };

        function hasOneEmptyElement(sectionAuthorities) {
            if(angular.isArray(sectionAuthorities)) {
                for (var i = 0; i < sectionAuthorities.length; i++) {
                    var sezioneAuth = sectionAuthorities[i];
                    if (!sezioneAuth.nomeSezione || sezioneAuth.nomeSezione === '') {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        // Funzione per rimuovere una Sezione Authority
        vm.removeSezioneAuthority = function(index) {
            if (vm.user.sectionAuthorities && index >= 0 && index < vm.user.sectionAuthorities.length) {
                vm.user.sectionAuthorities.splice(index, 1);
            }
        };

        vm.getAvailableSections = function(currentIndex) {
            if (!vm.nomiSezione || !vm.user.sectionAuthorities) {
                return vm.nomiSezione || [];
            }

            // Sezioni già selezionate escludendo quella corrente
            var selectedSections = [];
            for (var i = 0; i < vm.user.sectionAuthorities.length; i++) {
                if (i !== currentIndex) {
                    var section = vm.user.sectionAuthorities[i].nomeSezione;
                    if (section !== null && angular.isDefined(section) && section !== '') {
                        selectedSections.push(section);
                    }
                }
            }

            // Filtra le sezioni disponibili escludendo quelle già selezionate
            var availableSections = [];
            for (var j = 0; j < vm.nomiSezione.length; j++) {
                var nomeSezione = vm.nomiSezione[j];
                var isAlreadySelected = false;
                
                for (var k = 0; k < selectedSections.length; k++) {
                    if (selectedSections[k] === nomeSezione.nome) {
                        isAlreadySelected = true;
                        break;
                    }
                }
                
                if (!isAlreadySelected) {
                    availableSections.push(nomeSezione);
                }
            }
            return availableSections;
        };

        vm.onSectionChange = function(sezioneAuth, index) {

            // TODO
            
        };
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Commissione', 'CommissioneRuolo', 'SoggettoEsterno', 'Settore'];

    function UserManagementDetailController($stateParams, User, Commissione, CommissioneRuolo, SoggettoEsterno, Settore) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.settori = [];
        vm.commissioni = [];
        vm.commissioniRuoli = [];
        vm.soggettiEsterni = [];

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                
                angular.forEach(vm.user.settori, function(sectorId) {
                    Settore.get({id: sectorId}, {}, function(result) {
                        vm.settori.push(result.nome);
                    });
                });
                
                angular.forEach(vm.user.commissioni, function(commissionId) {
                    Commissione.get({id: commissionId}, {}, function(result) {
                        vm.commissioni.push(result.nome);
                    });
                });
                
                angular.forEach(vm.user.commissioniRuoli, function(commissioniRuoliId) {
                	CommissioneRuolo.get({id: commissioniRuoliId}, {}, function(result) {
                		vm.commissioniRuoli.push(result.nome);
                	});
                });
                
                angular.forEach(vm.user.soggettiEsterni, function(soggettoId) {
                    SoggettoEsterno.get({id: soggettoId}, {}, function(result) {
                        vm.soggettiEsterni.push(result.nome);
                    });
                });
                
                
            });
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('user-management', {
                    parent: 'admin',
                    url: '/user-management?page&sort&nome&cognome&email&ruolo',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'userManagement.home.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/admin/user-management/user-management.html',
                            controller: 'UserManagementController',
                            controllerAs: 'vm'
                        }
                    }, 
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        nome: {
                            value: null,
                            squash: true
                        },
                        cognome: {
                            value: null,
                            squash: true
                        },
                        email: {
                            value: null,
                            squash: true
                        },
                        ruolo: {
                            value: null,
                            squash: true
                        },
                    },
                    resolve: {
                        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                nome: $stateParams.nome,
                                cognome: $stateParams.cognome,
                                email: $stateParams.email,
                                ruolo: $stateParams.ruolo,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort)
                            };
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('sezioni');
                            return $translate.refresh();
                        }]

                    }})
                .state('user-management.new', {
                    url: '/new',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$mdDialog', 'ProfileService', '$state', function ($mdDialog, ProfileService, $state) {
                        $mdDialog.show({
                            clickOutsideToClose: false,
                            fullscreen: true,
                            templateUrl: 'app/admin/user-management/user-management-dialog.html',
                            controller: 'UserManagementDialogController',
                            controllerAs: 'vm',
                            bindToController: true,
                            locals: {
                                entity: {
                                    id: null, login: null, fiscalCode: null, firstName: null, lastName: null, email: null,
                                    activated: true, langKey: null, createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                    resetKey: null, authorities: ["ROLE_USER"], legislaturaAuthorities: []
                                },
                                env: ProfileService.getProfileInfo()
                            }
                        }).then(function (result) {
                            $state.go('user-management', null, {reload: true});
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
                .state('user-management.edit', {
                    url: '/{login}/edit',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$mdDialog', 'User', 'ProfileService', '$state', function ($stateParams, $mdDialog, User, ProfileService, $state) {
                        $mdDialog.show({
                            clickOutsideToClose: false,
                            fullscreen: true,
                            templateUrl: 'app/admin/user-management/user-management-dialog.html',
                            controller: 'UserManagementDialogController',
                            controllerAs: 'vm',
                            bindToController: true,
                            locals: {
                                entity: User.get({login: $stateParams.login}),                                      
                                env: ProfileService.getProfileInfo()
                            }
                        }).then(function (result) {
                            $state.go('user-management', null, {reload: true});
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
                .state('user-management-detail', {
                    parent: 'user-management',
                    url: '/{login}',
                    data: {
                        authorities: ['ROLE_ADMIN'],
                        pageTitle: 'user-management.detail.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/admin/user-management/user-management-detail.html',
                            controller: 'UserManagementDetailController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('sezioni');
                            return $translate.refresh();
                        }]
                    }
                })
                .state('user-management.delete', {
                    url: '/{login}/delete',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                            controller: 'UserManagementDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            resolve: {
                                entity: ['User', function (User) {
                                    return User.get({login: $stateParams.login});
                                }]
                            }
                        }).result.then(function () {
                            $state.go('user-management', null, {reload: true});
                        }, function () {
                            $state.go('^');
                        });
                    }]
                });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'RESOURCE_PERMISSIONS','$translate', 'Atto'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, RESOURCE_PERMISSIONS, $translate, Atto) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.nome = pagingParams.nome;
        vm.cognome = pagingParams.cognome;
        vm.email = pagingParams.email;
        vm.ruolo = pagingParams.ruolo;
        vm.RESOURCE_PERMISSIONS = RESOURCE_PERMISSIONS;
        vm.getAllAuthorities = getAllAuthorities;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            Atto.defaultLegislatura({}, onSuccessDefLeg, onErrorDefLeg);
        }

        function onSuccessDefLeg(data) {
            vm.defaultLegislatura = data.legislatura;
            loadUsers();
        }
        function onErrorDefLeg(error) {
            vm.legislatura = 11;
            loadUsers();
        }

        function loadUsers() {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                nome: vm.nome,
                cognome: vm.cognome,
                email: vm.email,
                ruolo: vm.ruolo
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            if(error.status === 403){
                AlertService.error($translate.instant('error.access.external.forbidden'));
            } else {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                nome: vm.nome,
                cognome: vm.cognome,
                email: vm.email,
                ruolo: vm.ruolo
            });
        }

        function getAllAuthorities(user) {
            var authorities = [];
            if(user && user.authorities) {
                angular.forEach(user.authorities, function(val, key){
                    authorities.push(val);
                });
            }
            if(user && user.legislaturaAuthorities) {
                angular.forEach(user.legislaturaAuthorities, function(legiAuth, key){
                    if(legiAuth.legislatura && legiAuth.legislatura.legislatura === vm.defaultLegislatura) {
                        angular.forEach(legiAuth.authorities, function(auth, key) {
                            authorities.push(auth.name);
                        });
                    }
                });
            }
            return authorities;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('PermissionsDialogController', PermissionsDialogController);

            PermissionsDialogController.$inject = ['$mdDialog', '$state', 'Atto'];

    function PermissionsDialogController($mdDialog, $state, Atto) {
        var vm = this;
       
        vm.permission = vm.entity;       
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
       

        function clear() {
            $mdDialog.cancel();
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('permissions', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;

            if (vm.permission.id !== null) {
                Atto.updateTipoAtto(vm.permission, onSaveSuccess, onSaveError);
            } else {
                Atto.saveTipoAtto(vm.permission, onSaveSuccess, onSaveError);
            }
        }

        
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PermissionsDeleteController', PermissionsDeleteController);

        PermissionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atto'];

    function PermissionsDeleteController ($uibModalInstance, entity, Atto) {
        var vm = this;

        vm.tipoAtto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            Atto.deleteTipoAtto({id: vm.tipoAtto.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PermissionsController', PermissionsController);

        PermissionsController.$inject = ['Principal', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'Atto', '$translate'];

    function PermissionsController (Principal, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, Atto, $translate) {
        var vm = this;

        
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.tipiAtto = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            Atto.getAllTipoAtto(onSuccess, onError);
        }

        function onSuccess(data) {
            vm.tipiAtto = data;
        }

        function onError(error) {
            if(error.status === 403){
                AlertService.error($translate.instant('error.access.external.forbidden'));
            } else {
                AlertService.error(error.data);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('permissions', {
            parent: 'admin',
            url: '/permissions?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'permissions.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/permissions/permissions.html',
                    controller: 'PermissionsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('permissions');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('atto');
                        $translatePartialLoader.addPart('tipoAtto');
                        $translatePartialLoader.addPart('tipoProponente');
                        $translatePartialLoader.addPart('form');
                        return $translate.refresh();
                      
                    }]

            }
        })
        .state('permissions.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve :{
                tipiAtto: ['ACT_TYPES',function(ACT_TYPES){
                    var array = [];
                    for(var i=0; i< ACT_TYPES.length; i++){
                        array[i] = ACT_TYPES[i].value
                    }
                        return array;
                    
                }]
            },
            onEnter: ['$mdDialog', 'ProfileService','tipiAtto', function ($mdDialog, ProfileService, tipiAtto) {
                    $mdDialog.show({
                        clickOutsideToClose: false,
                        fullscreen: true,
                        templateUrl: 'app/admin/permissions/permissions-dialog.html',
                        controller: 'PermissionsDialogController',
                        controllerAs: 'vm',
                        bindToController: true,
                        tipiAtto: tipiAtto,
                        locals: {
                            entity: {
                                id: null, tipoAtto: null, pubblicato: null
                            },
                            env: ProfileService.getProfileInfo()
                        }
                    });
                }]
        })
        .state('permissions.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve :{
                tipiAtto: ['ACT_TYPES',function(ACT_TYPES){
                    var array = [];
                    for(var i=0; i< ACT_TYPES.length; i++){
                        array[i] = ACT_TYPES[i].value
                    }
                    return array;
                    
                }]
            },
            onEnter: ['$stateParams', '$mdDialog', 'Atto', 'ProfileService','tipiAtto', function ($stateParams, $mdDialog, Atto, ProfileService, tipiAtto) {
                    $mdDialog.show({
                        clickOutsideToClose: false,
                        fullscreen: true,
                        templateUrl: 'app/admin/permissions/permissions-dialog.html',
                        controller: 'PermissionsDialogController',
                        controllerAs: 'vm',
                        tipiAtto: tipiAtto,
                        bindToController: true,
                        locals: {
                            
                            entity: Atto.getTipoAtto({id: $stateParams.id}),                                      
                            env: ProfileService.getProfileInfo()
                        }
                    });
                }]
        })
        .state('permissions.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/permissions/permissions-delete-dialog.html',
                        controller: 'PermissionsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Atto', function (Atto) {
                                    return Atto.getTipoAtto({id: $stateParams.id});
                                }]
                        }
                    }).result.then(function () {
                        $state.go('permissions', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http', 'toastr', '$translate'];

    function JhiMetricsService ($rootScope, $http, toastr, $translate) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            }, onError);
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            }, onError);
        }

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService', 'toastr', '$translate'];

    function LogsController (LogsService, toastr, $translate) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll({}, {}, angular.noop, onError);

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http', 'toastr', '$translate'];

    function JhiHealthService ($rootScope, $http, toastr, $translate) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }


        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            }, onError);
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('gestioneAttiApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http', 'toastr', '$translate'];

    function JhiConfigurationService ($filter, $http, toastr, $translate) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete, onError);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete, onError);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks', 'toastr', '$translate'];

    function AuditsController ($filter, AuditsService, ParseLinks, toastr, $translate) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            }, onError);
        }

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            url: '/admin-mgmt',
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'toastr', 'Account', '$http'];

    function SettingsController(Principal, Auth, JhiLanguageService, $translate, toastr, Account, $http) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        
        vm.protocolPassword = null;

        vm.isExternal = true;

        $http.get("/api/internal/check").then(onSuccess, onError)

        function onSuccess(){
            vm.isExternal = false;
        }

        function onError(error){
            if(error.status === 403){
                vm.isExternal = true;
            } else {
                vm.isExternal = false;
            }
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                protocolLogin: account.protocolLogin,
                protocolPassword: account.protocolPassword
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);
        });

        vm.testProtocol = function () {
            if (!vm.settingsAccount.protocolLogin || !vm.settingsAccount.protocolPassword) {
                toastr.error($translate.instant('settings.messages.error.protocolInfoNotComplete'), 'Errore!');
                return;
            }
            Account.testProtocolCredentials({
                protocolLogin: vm.settingsAccount.protocolLogin,
                protocolPassword: vm.settingsAccount.protocolPassword
            }, function (result) {
                if (result === true) {
                    toastr.success($translate.instant('settings.messages.protocolTestSuccess'), 'Ok!');
                } else {
                    toastr.error($translate.instant('settings.messages.error.protocolTestWentWrong'), 'Errore!');
                }
            }, function (error) {
                toastr.error(error, 'Errore!');
            });
        };

        function save() {
            //vm.settingsAccount.protocolPassword = vm.protocolPassword;
            if (!vm.settingsAccount.languageKey) {
                vm.settingsAccount.languageKey = 'it';
            }
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('gestioneAttiApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div class="container"><h1 data-translate="gestioneAttiApp.atto.home.title">Atti</h1><jhi-alert></jhi-alert><atto-table-list format="\'compressed\'" paging="vm.pagingParams" show-controls="true"></atto-table-list></div>');
$templateCache.put('app/home_logged/homeLogged.html','<div class="container-fluid"><div class="col-md-8"><h1 data-translate="gestioneAttiApp.atto.homeLogged.title">Atti</h1><atto-table-list format="\'compressed\'" paging="vm.pagingParams" show-controls="true"></atto-table-list></div><div class="col-md-4"><h2 data-translate="gestioneAttiApp.atto.homeLogged.notifications">Notifiche</h2><notifications-list></notifications-list></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\'| translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="100" required maxlength="100" ng-readonly="form.firstName.$pristine && vm.settingsAccount.firstName"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\'| translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="100" required maxlength="100" ng-readonly="form.lastName.$pristine && vm.settingsAccount.lastName"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\'| translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100" ng-readonly="form.email.$pristine && vm.settingsAccount.email"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="settings.form.protocolLogin">Protocol Login</label><input type="text" class="form-control" name="protocolLogin" autocomplete="false" autocomplete="nope" ng-model="vm.settingsAccount.protocolLogin" required ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.protocolLogin.$invalid"><p class="help-block" ng-show="editForm.protocolLogin.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="settings.form.protocolPassword">Protocol Password</label><input type="password" class="form-control" name="protocolPassword" autocomplete="new-password" ng-model="vm.settingsAccount.protocolPassword" ng-maxlength="60"><div ng-show="editForm.protocolPassword.$invalid"><p class="help-block" ng-show="editForm.protocolPassword.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 60 characters.</p></div></div><!-- div class="form-group">\r\n                    <label for="langKey" data-translate="settings.form.language">Language</label>\r\n                    <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>\r\n                </div --> <button type="submit" ng-disabled="form.$invalid || vm.isExternal" class="btn btn-primary" data-translate="settings.form.button">Save</button> <button type="button" ng-disabled="form.protocolLogin.$invalid" class="btn btn-danger" ng-click="vm.testProtocol()" data-translate="settings.form.testProtocol">Test Protocollo</button></form></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/permissions/permissions-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this TipoAtto permission?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/permissions/permissions-dialog.html','<md-dialog-content><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" ng-if="vm.permission.id">Modifica un permesso</h4><h4 class="modal-title" id="myUserLabel" ng-if="!(vm.permission.id)">Crea un permesso</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-show="false" class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.permission.id" ng-disabled="true"></div><div class="form-group"><md-input-container><label>Tipo Atto</label><md-select ng-model="vm.permission.tipoAtto" ng-disabled="vm.permission.id"><md-option ng-repeat="tipoAtto in vm.tipiAtto" value="{{tipoAtto}}">{{tipoAtto}}</md-option></md-select></md-input-container></div><div class="form-group"><div layout="row" layout-align="start center"><md-radio-group ng-model="vm.permission.pubblicato"><label>Pubblicato</label><md-radio-button ng-value="true" class="md-primary">SI</md-radio-button><md-radio-button ng-value="false" class="md-primary">NO</md-radio-button></md-radio-group></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></md-dialog-content>');
$templateCache.put('app/admin/permissions/permissions.html','<div><h2 data-translate="permissions.title"></h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="permissions.new" ui-sref-opts="{reload: true}"><span class="glyphicon glyphicon-flash"></span> <span>Crea un permesso</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span data-translate="global.field.id"></span><span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="login"><span data-translate="permissions.tipoAtto"></span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="permissions.permessoUtente"></span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="atto in vm.tipiAtto"><!-- <td>{{atto.id}}</a></td> --><td data-translate="{{\'gestioneAttiApp.atto.type.\' + atto.tipoAtto.toLowerCase()}}"></td><td>{{atto.pubblicato}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="permissions.edit({id: atto.id})" ui-sref-opts="{reload: true}" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="permissions.delete({id: atto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.fiscalCode">Fiscal Code</span></dt><dd><span>{{vm.user.fiscalCode}}</span></dd><!-- dt><span data-translate="userManagement.protocolLogin">Protocol Login</span></dt>\r\n        <dd>{{vm.user.protocolLogin}}</dd --><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.instantProtocolEnabled">Instant protocol enabled</span></dt><dd>{{vm.user.instantProtocolEnabled | yesNo}}</dd><dt><span data-translate="userManagement.reportEnabled">Report enabled</span></dt><dd>{{vm.user.reportEnabled | yesNo}}</dd></dl><div><label data-translate="userManagement.summaryPermanentPermissions">Riepilogo Permessi Permanenti</label><div layout="row" layout-wrap><div layout-margin flex="45"><div class="panel panel-default"><div class="panel-heading"><strong>Permessi Permanenti</strong></div><div class="panel-body"><!-- Profili permanenti --><div><strong>Profili:</strong> <span ng-if="vm.user.authorities && vm.user.authorities.length > 0"><span ng-repeat="auth in vm.user.authorities"><span class="label label-info" style="margin-right: 3px">{{ auth }}</span> </span></span><span ng-if="!vm.user.authorities || vm.user.authorities.length === 0">Nessuno</span></div><!-- Settori --><div><strong>Settori:</strong> <span ng-if="vm.settori && vm.settori.length > 0"><span ng-repeat="settore in vm.settori"><span class="label label-default" style="margin-right: 3px">{{ settore }} </span></span></span><span ng-if="!vm.settori || vm.settori.length === 0">Nessuno</span></div><!-- Sezioni --><div><strong>Sezioni:</strong> <span ng-if="vm.user.sectionAuthorities && vm.user.sectionAuthorities.length > 0"><span ng-repeat="sezioneAuth in vm.user.sectionAuthorities"><span ng-if="sezioneAuth.nomeSezione" class="label label-default" style="margin-right: 3px">{{ "sezioni." + sezioneAuth.nomeSezione | translate }} <span ng-if="sezioneAuth.tipiDocumento.length > 0">(Filtro Doc.) </span></span></span></span><span ng-if="!vm.user.sectionAuthorities || vm.user.sectionAuthorities.length === 0 || vm.user.sectionAuthorities[0].nomeSezione === \'\'">Nessuno</span></div></div></div></div></div><label data-translate="userManagement.summaryPermissions">Riepilogo Permessi per Legislatura</label><div layout="row" layout-wrap><div layout-margin flex="45" ng-repeat="legAuth in vm.user.legislaturaAuthorities | orderBy:\'-legislatura.legislatura\'"><div class="panel panel-default"><div class="panel-heading"><strong>Legislatura:</strong> <span ng-if="legAuth.legislatura && legAuth.legislatura.nome">{{ legAuth.legislatura.nome }}</span> <span ng-if="!legAuth.legislatura || !legAuth.legislatura.nome">{{ legAuth.legislatura.legislatura }}</span></div><div class="panel-body"><div><strong>Profili:</strong> <span ng-if="legAuth.authorities && legAuth.authorities.length > 0"><span ng-repeat="auth in legAuth.authorities"><span class="label label-info" style="margin-right: 3px">{{ auth }}</span> </span></span><span ng-if="!legAuth.authorities || legAuth.authorities.length === 0">Nessuno</span></div><div><strong>Commissioni:</strong><div style="display:flex; flex-wrap: wrap" ng-if="legAuth.commissioneRuoloAssociato && legAuth.commissioneRuoloAssociato.length > 0"><span ng-repeat="commissioneRuolo in legAuth.commissioneRuoloAssociato track by $index"><span class="label label-primary" style="margin-right: 3px">{{ commissioneRuolo.commissione.nome }} <span ng-if="commissioneRuolo.commissioneRuolo">({{ commissioneRuolo.commissioneRuolo.nome }})</span></span></span></div><span ng-if="!legAuth.commissioneRuoloAssociato || legAuth.commissioneRuoloAssociato.length === 0">Nessuna</span></div><div><strong>Soggetti Esterni:</strong> <span ng-if="legAuth.soggettiEsterni && legAuth.soggettiEsterni.length > 0"><span ng-repeat="soggettoEst in legAuth.soggettiEsterni"><span class="label label-warning" style="margin-right: 3px">{{ soggettoEst.nome }} </span></span></span><span ng-if="!legAuth.soggettiEsterni || legAuth.soggettiEsterni.length === 0">Nessuno</span></div></div></div></div></div></div><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<md-dialog-content><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div layout="row" ng-if="vm.user.id"><div flex="45"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" ng-disabled="true"></div><div flex="5"></div><div flex="45"><label data-translate="userManagement.fiscalCode">Fiscal Code</label><input type="text" class="form-control" name="fiscalCode" ng-model="vm.user.fiscalCode"></div></div><md-checkbox ng-model="vm.isExternalDomainUser" ng-if="vm.windowsAuthEnabled && !vm.user.id">Utente Esterno al Dominio</md-checkbox><div layout="row"><div flex="45"><label data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-show="!vm.windowsAuthEnabled || vm.user.id || vm.isExternalDomainUser" ng-disabled="vm.user.id"><md-autocomplete ng-disabled="vm.loadingLdapUsers" ng-show="vm.windowsAuthEnabled && !vm.user.id && !vm.isExternalDomainUser" aria-label="login" md-no-cache="true" md-selected-item="vm.selectedItem" md-search-text="vm.searchText" md-selected-item-change="vm.setUserData(item)" md-items="item in vm.searchLdapUsers(vm.searchText)" md-item-text="item.principal" md-min-length="3" placeholder="Utenti LDAP"><md-item-template><span class="item-title"><span>{{item.lastName}} {{item.firstName}} ({{item.principal}})</span></span></md-item-template></md-autocomplete><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div flex="5"></div><div flex="45"><div layout="row" layout-align="space-between center"><label data-translate="userManagement.email">Email</label></div><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div></div><div layout="row"><div flex="45"><label data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div flex="5"></div><div flex="45"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div layout="row"><div flex="20"><label data-translate="userManagement.activeKey">Status</label><div layout-margin flex="100"><md-checkbox ng-model="vm.user.activated" ng-disabled="vm.user.id === null"><span data-translate="userManagement.activated">Activated</span></md-checkbox></div></div><div flex="25"><label data-translate="userManagement.langKey">Lang Key</label><md-select ng-model="vm.user.langKey"><md-option ng-repeat="language in vm.languages" ng-value="language">{{ language }}</md-option></md-select></div><div flex="5"></div><div flex="25"><label data-translate="userManagement.protocolKey">Protocol Enabled</label><div layout-margin flex="100"><md-checkbox ng-model="vm.user.instantProtocolEnabled" id="instantProtocolEnabled" name="instantProtocolEnabled"><span data-translate="userManagement.instantProtocolEnabled">Instant protocol enabled</span></md-checkbox></div></div><div flex="25"><label data-translate="userManagement.reportKey">Report Enabled</label><div layout-margin flex="100"><md-checkbox ng-model="vm.user.reportGeneratorEnabled" id="reportGeneratorEnabled" name="reportGeneratorEnabled"><span data-translate="userManagement.reportEnabled">Report Enabled</span></md-checkbox></div></div></div><!-- PERMESSI PERMANENTI --><div><label data-translate="userManagement.permanentProfiles">Permanent Profiles</label><div layout="row"><div layout-margin ng-repeat="authority in vm.authorities"><md-checkbox ng-checked="vm.user.authorities.indexOf(authority) > -1" ng-disabled="authority === \'ROLE_USER\'" ng-click="vm.togglePermanentProfile(authority)">{{ authority }}</md-checkbox></div></div></div><!-- Settori --><div layout="row"><div flex="5"></div><div ng-if="vm.isSectorUser()"><label data-translate="userManagement.sectors">Settori</label><div layout="row"><div layout-margin ng-repeat="settore in vm.settori"><md-checkbox ng-checked="vm.user.settori.indexOf(settore.id) > -1" ng-click="vm.toggleSettore(settore.id)">{{ settore.nome }}</md-checkbox></div></div></div></div><!-- Sezioni Authority --><div layout="row"><div flex="5"></div><div flex ng-if="vm.isSectionUser()"><label>Abilitazione Sezioni</label><md-button class="md-icon-button md-primary" ng-click="vm.addSezioneAuthority()"><span class="glyphicon glyphicon-plus"></span></md-button><!-- Pulsante aggiungi --><div ng-repeat="sezioneAuth in vm.user.sectionAuthorities track by $index"><div layout="row" layout-align="start center"><!-- Nome sezione --><md-input-container flex="20"><label>Sezione</label><md-select ng-model="sezioneAuth.nomeSezione" ng-change="vm.onSectionChange(sezioneAuth, $index)" required><md-option ng-value=""></md-option><md-option ng-value="nomeSezione.nome" ng-repeat="nomeSezione in vm.getAvailableSections($index) | orderBy:\'view\'">{{ nomeSezione.view | uppercase}}</md-option></md-select></md-input-container><!-- Tipi documento associati --><md-input-container flex="60"><label>Tipi documento</label><md-select ng-model="sezioneAuth.tipiDocumento" multiple="multiple"><md-option ng-value="tipo" ng-repeat="tipo in vm.tipiDocumento">{{ tipo.tipo }}</md-option></md-select></md-input-container><!-- Pulsante rimuovi --><md-button class="md-icon-button md-warn" ng-click="vm.removeSezioneAuthority($index)"><span class="glyphicon glyphicon-minus"></span></md-button></div></div></div></div><!-- PERMESSI DIVISI PER LEGISLATURA --><div><label data-translate="userManagement.legislaturaAuthorities">Permessi per Legislatura</label><md-tabs md-dynamic-height md-selected="vm.selectedLegislaturaIndex"><md-tab ng-repeat="legislatura in vm.legislature" label="Legislatura {{ legislatura | romanize }}"><div layout-margin><!-- Profili --><div><label data-translate="userManagement.profiles">Profili</label><div layout="row"><div layout-margin ng-repeat="authority in vm.legiAuthorities"><md-checkbox ng-checked="vm.isCheckedItem(legislatura, \'authorities\', authority)" ng-click="vm.toggleItem(legislatura, \'authorities\', authority)">{{ authority }}</md-checkbox></div></div></div><!-- Commissioni e Ruoli --><div ng-if="vm.isCommissionUser(legislatura)"><label data-translate="userManagement.commissions">Commissioni</label><div layout="row" flex layout-wrap><div flex="50" ng-repeat="commissione in vm.filterSoggettoStoricizzato(vm.commissioni, legislatura)"><md-checkbox ng-checked="vm.isCheckedItem(legislatura, \'commissioneRuoloAssociato\', commissione)" ng-click="vm.toggleItem(legislatura, \'commissioneRuoloAssociato\', commissione)">{{ commissione.nome }}</md-checkbox><md-input-container><md-select aria-label="commissione" ng-model="vm.getCommissioneRuoloAssociato(legislatura, commissione).commissioneRuolo" ng-disabled="!vm.isCheckedItem(legislatura, \'commissioneRuoloAssociato\', commissione)"><md-option ng-value="null" disabled="disabled">Seleziona ruolo</md-option><md-option ng-value="ruolo" ng-repeat="ruolo in vm.commissioniRuoli">{{ ruolo.nome }}</md-option></md-select></md-input-container></div></div></div><!-- Soggetti Esterni --><div ng-if="vm.isExternalUser(legislatura)"><label data-translate="userManagement.externalSubjects">Soggetti Esterni</label><div layout="row"><div layout-margin ng-repeat="soggettoEsterno in vm.filterSoggettoStoricizzato(vm.soggettiEsterni, legislatura)"><md-checkbox ng-checked="vm.isCheckedItem(legislatura, \'soggettiEsterni\', soggettoEsterno)" ng-click="vm.toggleItem(legislatura, \'soggettiEsterni\', soggettoEsterno)">{{ soggettoEsterno.nome }}</md-checkbox></div></div></div></div></md-tab></md-tabs></div><!-- RIEPILOGO PERMESSI --><div style="border: dotted 2px"><div><label data-translate="userManagement.summaryPermanentPermissions">Riepilogo Permessi Permanenti</label><div layout="row" layout-wrap><div layout-margin flex="45"><div class="panel panel-default"><div class="panel-heading"><strong>Permessi Permanenti</strong></div><div class="panel-body"><div><strong>Profili:</strong> <span ng-if="vm.user.authorities && vm.user.authorities.length > 0"><span ng-repeat="auth in vm.user.authorities"><span class="label label-info" style="margin-right: 3px">{{ auth }}</span> </span></span><span ng-if="!vm.user.authorities || vm.user.authorities.length === 0">Nessuno</span></div><!-- Settori --><div><strong>Settori:</strong> <span ng-if="vm.user.settori && vm.user.settori.length > 0"><span ng-repeat="settore in vm.user.settori"><span class="label label-default" style="margin-right: 3px">{{ (vm.settori | filter:{id:settore})[0].nome }} </span></span></span><span ng-if="!vm.user.settori || vm.user.settori.length === 0">Nessuno</span></div><!-- Sezioni --><div><strong>Sezioni:</strong> <span ng-if="vm.user.sectionAuthorities && vm.user.sectionAuthorities.length > 0"><span ng-repeat="sezioneAuth in vm.user.sectionAuthorities"><span ng-if="sezioneAuth.nomeSezione" class="label label-default" style="margin-right: 3px">{{ "sezioni." + sezioneAuth.nomeSezione | translate }} <span ng-if="sezioneAuth.tipiDocumento.length > 0">(Filtro Doc.) </span></span></span></span><span ng-if="!vm.user.sectionAuthorities || vm.user.sectionAuthorities.length === 0 || vm.user.sectionAuthorities[0].nomeSezione === \'\'">Nessuno</span></div></div></div></div></div></div><div><label data-translate="userManagement.summaryPermissions">Riepilogo Permessi per Legislatura</label><div layout="row" layout-wrap><div layout-margin flex="45" ng-repeat="legAuth in vm.user.legislaturaAuthorities | orderBy:\'-legislatura.legislatura\'"><div class="panel panel-default" style="margin-bottom: 10px"><div class="panel-heading"><strong>Legislatura:</strong> <span ng-if="legAuth.legislatura && legAuth.legislatura.nome">{{ legAuth.legislatura.nome }}</span> <span ng-if="!legAuth.legislatura || !legAuth.legislatura.nome">{{ legAuth.legislatura.legislatura }}</span></div><div class="panel-body"><div><strong>Profili:</strong> <span ng-if="legAuth.authorities && legAuth.authorities.length > 0"><span ng-repeat="auth in legAuth.authorities"><span class="label label-info" style="margin-right: 3px">{{ auth }}</span> </span></span><span ng-if="!legAuth.authorities || legAuth.authorities.length === 0">Nessuno</span></div><div><!-- Riepilogo commissioni --> <strong>Commissioni:</strong><div style="display:flex; flex-wrap: wrap" ng-if="legAuth.commissioneRuoloAssociato && legAuth.commissioneRuoloAssociato.length > 0"><span ng-repeat="commissioneRuolo in legAuth.commissioneRuoloAssociato track by $index"><span class="label label-primary" style="margin-right: 3px">{{ commissioneRuolo.commissione.nome }} <span ng-if="commissioneRuolo.commissioneRuolo">({{ commissioneRuolo.commissioneRuolo.nome }})</span></span></span></div><span ng-if="!legAuth.commissioneRuoloAssociato || legAuth.commissioneRuoloAssociato.length === 0">Nessuna</span></div><div><strong>Soggetti Esterni:</strong> <span ng-if="legAuth.soggettiEsterni && legAuth.soggettiEsterni.length > 0"><span ng-repeat="soggettoEst in legAuth.soggettiEsterni"><span class="label label-warning" style="margin-right: 3px">{{ soggettoEst.nome }} </span></span></span><span ng-if="!legAuth.soggettiEsterni || legAuth.soggettiEsterni.length === 0">Nessuno</span></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></md-dialog-content>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new" ui-sref-opts="{reload: true}"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container><input type="text" ng-model="vm.nome" placeholder="Nome"></md-input-container><md-input-container><input type="text" ng-model="vm.cognome" placeholder="Cognome"></md-input-container><md-input-container><input type="text" ng-model="vm.email" placeholder="Email"></md-input-container><!--  <md-input-container>\r\n                <input type="text" >\r\n            </md-input-container> --><md-input-container><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.ruolo" placeholder="Ruolo"><md-option></md-option><md-option value="ROLE_ADMIN">Admin</md-option><md-option ng-repeat="item in ::vm.RESOURCE_PERMISSIONS" value="{{::item.name}}">{{item.textKey| translate}}</md-option></md-select></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fiscalCode"><span data-translate="userManagement.fiscalCode">Fiscal Code</span><span class="glyphicon glyphicon-sort"></span></th><th>Stato Attivazione</th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span><span> (Leg. {{vm.defaultLegislatura | romanize}})</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reportGeneratorEnabled"><span>Generazione Report</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.login}}</a></td><td>{{user.email}}</td><td>{{user.fiscalCode}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in vm.getAllAuthorities(user)"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td><span ng-if="user.reportGeneratorEnabled" style="font-size:larger; color:green">Abilitato</span> <span ng-if="!user.reportGeneratorEnabled" style="font-size:larger; color:red">Non abilitato</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" ui-sref-opts="{reload: true}" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/anagrafica-iterlegis/anagrafica-iterlegis-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.anagraficaIterlegis.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.anagraficaIterlegis.delete.question" translate-values="{id: \'{{vm.anagraficaIterlegis.id}}\'}">Are you sure you want to delete this anagrafica?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/anagrafica-iterlegis/anagrafica-iterlegis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAnagraficaIterlegisLabel" data-translate="gestioneAttiApp.anagraficaIterlegis.home.createOrEditLabel">Create or edit a AnagraficaIterlegis</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.anagraficaIterlegis.descrizione" for="field_descrizione">descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.anagraficaIterlegis.descrizioneAnagrafica"></div><md-input-container><label data-translate="gestioneAttiApp.anagraficaIterlegis.tipoProponente"></label><md-select ng-model="vm.anagraficaIterlegis.tipoAnagrafica" placeholder="Tipo Anagrafica"><md-option ng-repeat="item in ::vm.tipoAnagraficaList track by item.name" value="{{::item.name}}">{{::item.name| translate}}</md-option></md-select></md-input-container></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/anagrafica-iterlegis/anagrafica-iterlegis.html','<h1 style="margin-bottom: 60px" class="not-sticky">Anagrafiche Iterlegis</h1><div id="atto-list-container"><div class="col-xs-4 col-md-2 no-padding-left"><button class="btn btn-primary" ui-sref="anagrafica-iterlegis.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="anagrafica-iterlegis.addLabel">Create new AnagraficaIterlegis</span></button></div><table class="table table-bordered"><thead><tr><th>Descrizione Anagrafica</th><th>Tipo Anagrafica</th><th></th></tr></thead><tbody><tr ng-repeat="anagrafica in vm.anagraficaIterlegisList track by $index" ng-class="{\'striped-row\': $index % 2 === 0}"><td>{{::anagrafica.descrizioneAnagrafica}}</td><td>{{::anagrafica.tipoAnagrafica}}</td><td><button type="submit" ui-sref="anagrafica-iterlegis.delete({id:anagrafica.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/atto/atto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.atto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.atto.delete.question" translate-values="{id: \'{{vm.atto.id}}\'}">Are you sure you want to delete this Atto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/atto/atto-detail.html','<div><div class="row"><div class="col-md-2"><h2><span>{{::vm.atto.tipoAtto}}</span>{{::vm.atto.numeroAtto}}</h2></div></div><div><label class="label label-{{vm.atto.tipoAtto}}">{{::vm.atto.statoCorrente.statoAtto.name| translate}}</label>&nbsp; da {{::vm.atto.statoCorrente.utenteStato}} il {{::vm.atto.statoCorrente.dataStato| date: \'dd/MM/yyyy\'}}<md-button ng-if="::vm.atto.storico.length > 0" ng-click="vm.showStateHistory = !vm.showStateHistory" class="md-raised md-accent"><span class="glyphicon glyphicon-tasks"></span> <span data-translate="entity.action.history" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.history\'| translate}}</md-tooltip></md-button><md-button class="md-raised md-primary" ng-click="vm.setAttoIdForArchiveTree()" aria-label="attachments"><span class="glyphicon glyphicon-folder-open"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.archive"></span></md-button><a ui-sref="atto-edit({id: vm.atto.id})"><md-button ng-if="::vm.canSeeEditButton()" class="md-raised md-warn" aria-label="edit"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.edit\'| translate}}</md-tooltip></md-button></a><md-button aria-label="mail" ui-sref="registrazione-utente.new({id: vm.atto.id, atto: vm.atto})" class="btn btn-secondary btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm hidden-xs">Notifiche</span></md-button></div><!-- HISTORY PANEL --><div ng-if="::vm.atto.storico.length > 0 && vm.showStateHistory" class="animate-show-hide" ng-show="vm.showStateHistory"><div ng-repeat="state in ::vm.atto.storico track by $index"><label class="label" ng-class="::{\r\n                   \'label-primary\' : state.statoAtto.name !== vm.atto.statoCorrente.statoAtto.name,\r\n                   \'label-danger\' : state.statoAtto.name === vm.atto.statoCorrente.statoAtto.name\r\n                   }">{{::state.statoAtto.name| translate}}</label>&nbsp; <span ng-if="::state.utenteStato.length > 0">da {{::state.utenteStato}} </span>il {{::state.dataStato| date: \'dd/MM/yyyy\'}} <span ng-if="::state.statoAtto.dataRinvio">&dash; <strong>{{\'gestioneAttiApp.form.dataRinvio\'| translate}}: {{::state.statoAtto.dataRinvio| date: \'dd/MM/yyyy\'}}</strong></span><md-button ng-if="vm.isAdmin && $index == (vm.atto.storico.length - 1) && !(vm.atto.statoCorrente.statoAtto.name == \'PRESENTATO\')" style="transform: scale(0.7)" class="md-raised md-primary" ng-click="vm.cancelCurrentState(vm.atto)"><span class="glyphicon glyphicon-fast-backward"></span> <span data-translate="entity.action.cancelState"></span><md-tooltip>{{\'entity.action.cancelStateTooltip\'| translate}}</md-tooltip></md-button></div></div><hr><!-- PANES --><div id="presentation-state" class="atto-detail-pane"><a ng-click="vm.stato.presentato.isCollapsed = !vm.stato.presentato.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.presentato.isCollapsed, \'glyphicon-eye-close\': vm.stato.presentato.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">PRESENTAZIONE</span> <span ng-if="vm.isAdmin" style="vertical-align: 5px"><event-mail-notification-button-component atto="vm.atto" event-type="\'PRESENTAZIONE\'"></event-mail-notification-button-component></span><div ng-show="vm.stato.presentato.isCollapsed" layout="column" layout-margin><!-- PRESENTATION --><section ng-if="::vm.checkShowSection(vm.sezioniMap.PRESENTATION)" ng-include="::vm.sezioni.PRESENTATION.form" ng-cloak class="panel atto-sezione"></section><!-- ATTACHED ACTS --><section ng-if="::vm.checkShowSection(vm.sezioniMap.ATTACHED_ACTS)" ng-cloak class="panel atto-sezione"><attached-acts-component attached-acts="vm.getSezioniFromMap(\'ATTACHED_ACTS\', 0)" atto="vm.atto" change-document-type="vm.changeDocumentType" change-document-visibility="vm.changeDocumentVisibility" change-document-frontpiece="vm.changeDocumentFrontpiece" doc-types="vm.docTypes" public-view="vm.publicView" utente="vm.utente"></attached-acts-component></section><!-- ASSIGNMENT LETTER --><section ng-if="::vm.showAssignmentLetter()" ng-include="::vm.sezioni.ASSIGNMENT_LETTER.form" ng-cloak class="panel atto-sezione"></section><!-- CANDIDATURE E DESIGNAZIONI --><section ng-if="vm.atto.tipoAtto === \'PDD\' && vm.isPddNomina() && vm.checkShowSection(vm.sezioniMap.CANDIDATURE_E_DESIGNAZIONI)" ng-cloak class="panel atto-sezione"><candidature-designazioni-component candidature-designazioni="vm.getSezioniFromMap(\'CANDIDATURE_E_DESIGNAZIONI\', 0)" atto="vm.atto" change-document-type="vm.changeDocumentType" change-document-visibility="vm.changeDocumentVisibility" change-document-frontpiece="vm.changeDocumentFrontpiece" doc-types="vm.docTypes" public-view="vm.publicView" utente="vm.utente"></candidature-designazioni-component></section><!-- ISCRIZIONE --><section ng-if="::vm.sezioniMap.ISCRIZIONE" ng-include="::vm.sezioni.ISCRIZIONE.form" ng-cloak class="panel atto-sezione"></section><!-- COMMISSION ASSIGNED EMENDMENTS --><section ng-if="!vm.isAulaDiretta() && vm.checkShowSection(vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS)" ng-include="::vm.sezioni.COMMISSION_ASSIGNED_EMENDMENTS.form" ng-cloak class="panel atto-sezione"></section><!-- DECADENCE --><section ng-if="::vm.sezioniMap.DECADENCE" ng-include="::vm.sezioni.DECADENCE.form" ng-cloak class="panel atto-sezione"></section><!-- ESITO ATTO: SOLO PER IS --><section ng-if="vm.sezioniMap.COURT_OUTCOME && vm.atto.tipoAtto === \'IS\' && vm.atto.statoCorrente.statoAtto.finalState === \'false\'" ng-include="::vm.sezioni.COURT_OUTCOME.form" ng-cloak class="panel atto-sezione"></section></div></div><div><div ng-repeat="idx in vm.getIteratoreSezioniRipetibili() track by $index"><commission-block id="commission-state" ng-if="vm.showCommissionBlock($index)" act-type="::vm.atto.tipoAtto" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" commission-emendments="::vm.getSezioniFromMap(\'COMMISSION_EMENDMENTS\', $index)" commission-message="::vm.getSezioniFromMap(\'COMMISSION_MESSAGE\', $index)" commission-opinions="::vm.getSezioniFromMap(\'COMMISSION_OPINIONS\', $index)" consultations="::vm.getSezioniFromMap(\'CONSULTATIONS\', $index)" current-user="::vm.utente" decadence="::vm.getSezioniFromMap(\'DECADENCE\', $index)" doc-types="::vm.docTypes" feasibility="::vm.getSezioniFromMap(\'FEASIBILITY\', $index)" financial-coverage="::vm.getSezioniFromMap(\'FINANCIAL_COVERAGE\', $index)" post-court="::vm.getSezioniFromMap(\'POST_COURT\', $index - 1)" index="$index" invalid-fields="vm.invalidFields" is-admin="::vm.userRolesMap.isAdmin" is-authenticated="::vm.isAuthenticated" is-feasibility="::vm.userRolesMap.isFeasibility" is-legitimacy="::vm.userRolesMap.isLegitimacy" is-primary-commission="::vm.primaryCommission" is-protocollo="::vm.userRolesMap.isProtocollo" iteration-index="$index" legitimacy="::vm.getSezioniFromMap(\'LEGITIMACY\', $index)" opinion-subjects="::vm.soggettiOpinioni" people-list="::vm.anagraficheProtocollo" referendum-report="::vm.getSezioniFromMap(\'REFERENDUM_REPORT\', $index)" send-back-date="vm.dateRinvio[$index]" show-section-callback="vm.checkShowSection(section)" unified-text="::vm.getSezioniFromMap(\'UNIFIED_TEXT\', $index)" union-proposal="::vm.getSezioniFromMap(\'UNION_PROPOSAL\', $index)" validating="vm.validating" documents-check-callback="vm.initDocumentsCheck(documento, numeroRinvio, workDocumentsMap)" remove-documents-check-callback="vm.removeDocumentsCheck(documento, numeroRinvio, workDocumentsMap)" work-documents-map="vm.workDocumentsMap" work-documents="::vm.getSezioniFromMap(\'WORK_DOCUMENTS\', $index)" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" numero-rinvii="vm.numeroRinvii" is-atto-minore="vm.isAttoMinore" seat-management="::vm.getSezioniFromMap(\'SEAT_MANAGEMENT\', $index)" parere-cal="::vm.getSezioniFromMap(\'PARERE_CAL\', $index)" user-soggetti-esterni-map="vm.userSoggettiEsterniMap" resolution="::vm.getSezioniFromMap(\'RESOLUTION\', $index)" atto="::vm.atto" view-mode="vm.viewMode"></commission-block><!-- TRASMISSIONE GIUNTA BLOCK--><div ng-if="::(vm.showTrasmissioneGiuntaBlock() && vm.showTrasmissioneGiuntaBeforeCourtroom())"><giunta-trasmission-block atto="vm.atto" doc-types="::vm.docTypes" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" giunta-trasmission-section="vm.sezioniMap.GIUNTA_TRASMISSION" work-documents-map="vm.workDocumentsMap" utente="::vm.utente" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" view-mode="::vm.viewMode" public-view="vm.publicView"></giunta-trasmission-block></div><courtroom-block act-type="::vm.atto.tipoAtto" show-courtroom-block="::vm.showCourtroomBlock($index)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" constitutional-appeal="::vm.getSezioniFromMap(\'CONSTITUTIONAL_APPEAL\', $index)" procedimento="::vm.getSezioniFromMap(\'PROCEDIMENTO\')" court-emendments="::vm.getSezioniFromMap(\'COURT_EMENDMENTS\', $index)" court-meeting="::vm.getSezioniFromMap(\'COURT_MEETING\', $index)" court-outcome="::vm.getSezioniFromMap(\'COURT_OUTCOME\', $index)" current-user="::vm.utente" doc-types="::vm.docTypes" invalid-fields="vm.invalidFields" index="$index" is-admin="::vm.userRolesMap.isAdmin" is-protocollo="::vm.userRolesMap.isProtocollo" iteration-index="$index" notice-of-rectification="::vm.getSezioniFromMap(\'NOTICE_OF_RECTIFICATION\', $index)" people-list="::vm.anagraficheProtocollo" post-court="::vm.getSezioniFromMap(\'POST_COURT\', $index)" send-back-date="vm.dateRinvio[$index]" show-section-callback="vm.checkShowSection(section)" validating="vm.validating" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" numero-rinvii="vm.numeroRinvii" is-atto-minore="vm.isAttoMinore" actuation-notes="::vm.getSezioniFromMap(\'ACTUATION_NOTES\', $index)" assignment-letter="::vm.getAssignmentLetter()" commissioni="vm.commissioni" is-sector-user-enabled="::vm.isSectorUserEnabled" attached-acts="::vm.getSezioniFromMap(\'ATTACHED_ACTS_COURTROOM\', 0)" atto="::vm.atto" is-courtroom="true" work-documents-map="vm.workDocumentsMap" emanazione="vm.sezioniMap.EMANAZIONE" view-mode="::vm.viewMode" adempimenti="::vm.getSezioniFromMap(\'ADEMPIMENTI\', $index)" materie-section="::vm.getSezioniFromMap(\'MATERIE\', $index)" court-assignment-letter="::vm.getSezioniFromMap(\'COURT_ASSIGNMENT_LETTER\', $index)"></courtroom-block></div></div><!-- TRASMISSIONE GIUNTA BLOCK--><div ng-if="::(vm.showTrasmissioneGiuntaBlock() && !vm.showTrasmissioneGiuntaBeforeCourtroom())"><giunta-trasmission-block atto="vm.atto" doc-types="::vm.docTypes" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" giunta-trasmission-section="vm.sezioniMap.GIUNTA_TRASMISSION" work-documents-map="vm.workDocumentsMap" utente="::vm.utente" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></giunta-trasmission-block></div><!-- WITHDRAWN BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'RITIRATO\'"><retired-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" presentation-section="vm.sezioniMap.PRESENTATION" stato-presentato-collapsed="vm.stato.presentato.isCollapsed" view-mode="::vm.viewMode" retired-section="vm.sezioniMap.RETIRED" doc-types="::vm.docTypes" work-documents-map="vm.workDocumentsMap" utente="::vm.utente" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView"></retired-block></div><!-- Improcedibile BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'IMPROCEDIBILE\'"><improcedibile-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" improcedibile="::vm.sezioniMap.IMPOSSIBLE_TO_PASS" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></improcedibile-block></div><!-- Decaduto BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'DECADUTO\'"><decaduto-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" decaduto="::vm.sezioniMap.DECAYED" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></decaduto-block></div><!-- Respinto BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'RESPINTO\'"><respinto-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" respinto="::vm.sezioniMap.REJECTED" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></respinto-block></div><!-- Inammissibile BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'INAMMISSIBILE\'"><inammissibile-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" inammissibile="::vm.sezioniMap.INADMISSIBLE" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></inammissibile-block></div><!-- SVOLTA BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'SVOLTA\'"><svolta-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" court-outcome="::vm.getSezioniFromMap(\'COURT_OUTCOME\', $index)" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" hide-esito-atto-medatati="!vm.atto.tipoAtto === \'IS\'" view-mode="::vm.viewMode"></svolta-block></div><!-- RISPOSTA SCRITTA BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'RISPOSTA SCRITTA\'"><risposta-scritta-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" court-outcome="::vm.getSezioniFromMap(\'COURT_OUTCOME\', $index)" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" hide-esito-atto-medatati="!vm.atto.tipoAtto === \'IS\'" view-mode="::vm.viewMode"></risposta-scritta-block></div><!-- TRANSFER COMPETENCE BLOCK--><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'TRASFERITA COMPETENZA\'"><transfer-competence-block atto="vm.atto" stato-atto-corrente="::vm.atto.statoCorrente.statoAtto.name" decree="::vm.sezioniMap.DECREE" notice-of-rectification="vm.sezioniMap.NOTICE_OF_RECTIFICATION_TRANSFER_COMPETENCE" is-protocollo="::vm.userRolesMap.isProtocollo" is-settore-atti="::vm.userRolesMap.isSettoreAtti" utente="::vm.utente" doc-types="::vm.docTypes" change-document-type-callback="vm.changeDocumentType" change-document-visibility-callback="vm.changeDocumentVisibility" change-document-frontpiece-callback="vm.changeDocumentFrontpiece" public-view="vm.publicView" view-mode="::vm.viewMode"></transfer-competence-block></div><div class="padded-bottom-70"></div><div class="bottom-sheet-demo inset action-button-fixed-bottom hide-sm hide-xs show-gt-sm" layout="row" layout-xs="column" layout-align="center"><!-- ACTION BUTTONS --><div class="md-button-group"><md-button ng-repeat="button in vm.visibleButtons" ng-click="vm.performButtonAction(button)" ng-disabled="vm.isSaving" ng-class="::{\'md-primary\' : $index % 2 === 0, \'md-accent\' : $index % 2 !== 0}" class="md-raised"><md-tooltip md-direction="top">{{::button.title| translate}}</md-tooltip><span class="glyphicon {{::button.iconClass|| \'glyphicon-floppy-disk\'}}"></span> <span data-translate="{{::button.title}}" layout-wrap></span></md-button><md-button ng-if="::vm.displayProtocolloSaveButton" class="md-raised md-primary" ng-disabled="vm.isSaving" ng-click="vm.performProtocolloSave()"><md-tooltip>{{\'entity.action.save\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.saveprotocol"></span></md-button></div></div><div class="bottom-sheet-demo inset action-button-fixed-bottom show-sm show-xs hide-gt-sm" layout="row" layout-xs="column" layout-align="start"><md-content layout-padding><div layout="column" layout-align="start"><md-button ng-click="vm.openMobileButtons()" aria-label="attachments" class="md-fab md-info md-button md-ink-ripple atto-detail-button-sidenav"><span class="glyphicon glyphicon-list"></span></md-button></div></md-content></div><md-sidenav class="md-sidenav-left" fullscreen md-component-id="buttons-mobile" md-whiteframe="4" md-disable-backdrop="true"><md-content layout-padding layout="column" layout-align="space-between start"><md-button class="md-info atto-detail-button-sidenav" ng-click="vm.closeMobileButtons()" aria-label="close buttons"><span class="glyphicon glyphicon-remove-circle ng-scope"></span></md-button><md-button ng-repeat="button in ::vm.visibleButtons" ng-disabled="vm.isSaving" ng-class="::{\'md-primary\' : $index % 2 === 0, \'md-accent\' : $index % 2 !== 0}" ng-click="vm.performButtonAction(button)" class="md-raised"><md-tooltip>{{::button.title| translate}}</md-tooltip><span class="glyphicon {{::button.iconClass|| \'glyphicon-floppy-disk\'}}"></span> <span data-translate="{{::button.title}}" layout-wrap></span></md-button><md-button ng-if="::vm.displayProtocolloSaveButton" ng-click="vm.performProtocolloSave()" ng-disabled="vm.isSaving" class="md-raised md-primary"><md-tooltip>{{\'entity.action.save\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.saveprotocol"></span></md-button></md-content></md-sidenav><div ng-if="::vm.previousState" class="pull-left pull-left-space-bottom"><md-button ng-click="vm.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span data-translate="entity.action.back">Back</span></md-button></div></div><md-sidenav class="md-sidenav-right gestione-atti-fixed-sidenav" md-component-id="right" md-whiteframe="4" md-disable-backdrop="true"><md-content layout-padded><archive-tree ng-if="vm.attoIdForArchiveTree" atto-id="vm.attoIdForArchiveTree" public-view="vm.publicView"></archive-tree></md-content></md-sidenav>');
$templateCache.put('app/entities/atto/atto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAttoLabel" data-translate="gestioneAttiApp.atto.home.createOrEditLabel">Create or edit a Atto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.atto.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.atto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.legislatura" for="field_legislatura">Legislatura</label><input type="number" class="form-control" name="legislatura" id="field_legislatura" ng-model="vm.atto.legislatura"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.tipoAtto" for="field_tipoAtto">Tipo Atto</label><select class="form-control" name="tipoAtto" ng-model="vm.atto.tipoAtto" id="field_tipoAtto"><option value="PDL" data-translate="gestioneAttiApp.TipoAtto.PDL">PDL</option></select></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.classifica" for="field_classifica">Classifica</label><input type="text" class="form-control" name="classifica" id="field_classifica" ng-model="vm.atto.classifica"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.numeroAtto" for="field_numeroAtto">Numero Atto</label><input type="text" class="form-control" name="numeroAtto" id="field_numeroAtto" ng-model="vm.atto.numeroAtto"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="text" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.atto.numeroProtocollo"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.dataProtocollo" for="field_dataProtocollo">Data Protocollo</label><div class="input-group"><input id="field_dataProtocollo" type="text" class="form-control" name="dataProtocollo" uib-datepicker-popup="{{dateformat}}" ng-model="vm.atto.dataProtocollo" is-open="vm.datePickerOpenStatus.dataProtocollo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataProtocollo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.titolo" for="field_titolo">Titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="vm.atto.titolo"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.atto.tipoProponente" for="field_tipoProponente">Tipo Proponente</label><select class="form-control" name="tipoProponente" ng-model="vm.atto.tipoProponente" id="field_tipoProponente"><option value="GR" data-translate="gestioneAttiApp.TipoProponente.GR">GR</option><option value="CRT" data-translate="gestioneAttiApp.TipoProponente.CRT">CRT</option><option value="UP" data-translate="gestioneAttiApp.TipoProponente.UP">UP</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/atto/atto-insert.html','<div><div class="row"><div class="col-md-2"><h2>Nuovo atto</h2></div></div><section id="presentation-section"><div class="panel atto-sezione" ng-include="\'app/entities/atto/sezioni/presentation.html\'" ng-cloak></div></section><div class="bottom-sheet-demo inset" layout="row" layout-xs="column" layout-align="center"><!-- ACTION BUTTONS --><div class="md-button-group"><md-button class="md-raised md-primary" ng-disabled="vm.isSaving" ng-click="vm.createAtto()"><md-tooltip>{{\'entity.action.insert\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.insert"></span></md-button></div></div><div class="pull-left" ng-if="::vm.previousState"><button type="submit" ui-sref="{{::vm.previousState}}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span data-translate="entity.action.back">Back</span></button></div></div><md-sidenav class="md-sidenav-right gestione-atti-fixed-sidenav" md-component-id="right" md-whiteframe="4" md-disable-backdrop="true"><md-content layout-padded><archive-tree ng-if="vm.attoIdForArchiveTree" atto-id="vm.attoIdForArchiveTree"></archive-tree></md-content></md-sidenav>');
$templateCache.put('app/entities/atto/attos.html','<div><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atto.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.atto.home.createLabel">Create new Atto</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="legislatura"><span data-translate="gestioneAttiApp.atto.legislatura">Legislatura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoAtto"><span data-translate="gestioneAttiApp.atto.tipoAtto">Tipo Atto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="classifica"><span data-translate="gestioneAttiApp.atto.classifica">Classifica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numeroAtto"><span data-translate="gestioneAttiApp.atto.numeroAtto">Numero Atto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numeroProtocollo"><span data-translate="gestioneAttiApp.atto.numeroProtocollo">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataProtocollo"><span data-translate="gestioneAttiApp.atto.dataProtocollo">Data Protocollo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="titolo"><span data-translate="gestioneAttiApp.atto.titolo">Titolo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoProponente"><span data-translate="gestioneAttiApp.atto.tipoProponente">Tipo Proponente</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="atto in vm.attos track by atto.id"><td><a ui-sref="atto-detail({id:atto.id})">{{atto.id}}</a></td><td>{{atto.legislatura}}</td><td data-translate="{{\'gestioneAttiApp.TipoAtto.\' + atto.tipoAtto}}">{{atto.tipoAtto}}</td><td>{{atto.classifica}}</td><td>{{atto.numeroAtto}}</td><td>{{atto.numeroProtocollo}}</td><td>{{atto.dataProtocollo | date:\'mediumDate\'}}</td><td>{{atto.titolo}}</td><td data-translate="{{\'gestioneAttiApp.TipoProponente.\' + atto.tipoProponente}}">{{atto.tipoProponente}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atto-detail({id:atto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atto.edit({id:atto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atto.delete({id:atto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/atto-report-generator/adempimenti-atti-indirizzo-report-generator.html','<div class="row tree-header"><div class="col-xs-6"><h3 flex-offset="5" data-translate="report-generator.title"></h3></div></div><form name="formAdvancedSearch" class="advanced-search"><div layout="row" layout-wrap ng-if="vm.fulfillmentReportVisible"><div flex="100" flex-offset="5"><div style="border-style: solid; border-width: 1px; height: 100%; padding: 15px; border-color: #c7030a"><legend ng-if="vm.searchParams.tipoReportAttiIndirizzo === \'adempimenti\'">{{\'report-generator.fulfillment-report.title\' | translate}}</legend><legend ng-if="vm.searchParams.tipoReportAttiIndirizzo === \'noteAttuazione\'">{{\'report-generator.actuation-notes-report.title\' | translate}}</legend><div style="display: flex; justify-content: center"><div><md-button class="md-raised" ng-class="{\'md-primary\': vm.searchParams.tipoReportAttiIndirizzo === \'adempimenti\'}" ng-click="vm.changedReportType(\'adempimenti\')">Report adempimenti degli atti di indirizzo</md-button><md-button class="md-raised" ng-class="{\'md-primary\': vm.searchParams.tipoReportAttiIndirizzo === \'noteAttuazione\'}" ng-click="vm.changedReportType(\'noteAttuazione\')">Report atti di indirizzo con note di attuazione</md-button></div></div><!-- Legislatura --><div layout-gt-xs="row" flex-offset="5" flex><md-input-container flex-gt-xs="33"><label>{{\'gestioneAttiApp.atto.legislatura\'| translate}}</label><md-select required name="legislatura" ng-model="vm.searchParams.legislatura" ng-change="vm.loadCommissioni()"><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select><div ng-messages="formAdvancedSearch.legislatura.$error" role="alert"><div ng-message="required">{{\'entity.validation.required\' | translate }}</div></div></md-input-container></div><!-- Periodo approvazione --><div flex layout-gt-xs="row" flex-offset="5" flex-layout="start"><div flex-gt-xs="20" flex-layout="start center"><label>{{\'report-generator.fulfillment-report.approval-period\' | translate}}</label></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data approvazione dal</label><md-datepicker md-open-on-focus onkeydown="return false" name="dataApprovazioneInizio" ng-model="vm.searchParams.dataApprovazioneInizio" ng-required="vm.searchParams.dataApprovazioneFine != null"></md-datepicker><div ng-messages="formAdvancedSearch.dataApprovazioneInizio.$error" role="alert"><div ng-message="required">{{\'entity.validation.required\' | translate }}</div></div></md-input-container><span ng-if="vm.searchParams.dataApprovazioneInizio"><md-button ng-click="vm.searchParams.dataApprovazioneInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data approvazione al</label><md-datepicker md-open-on-focus onkeydown="return false" name="dataApprovazioneFine" ng-model="vm.searchParams.dataApprovazioneFine" ng-required="vm.searchParams.dataApprovazioneInizio != null"></md-datepicker><div ng-messages="formAdvancedSearch.dataApprovazioneFine.$error" role="alert"><div ng-message="required">{{\'entity.validation.required\' | translate }}</div></div></md-input-container><span ng-if="vm.searchParams.dataApprovazioneFine"><md-button ng-click="vm.searchParams.dataApprovazioneFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div><!-- Sede di approvazione --><div flex layout-gt-xs="row" flex-offset="5"><div layout="column" flex-gt-xs="25"><label data-translate="report-generator.fulfillment-report.approval-site"></label><div layout-margin ng-repeat="site in vm.approvalSites"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'sedeApprovazione\', site)" ng-checked="vm.searchParamExists(\'sedeApprovazione\', site)" ng-disabled="vm.loading">{{site}}</md-checkbox></div></div><div layout="column" flex-gt-xs="25" ng-if="vm.searchParamExists(\'sedeApprovazione\', \'COMMISSIONE\')"><label data-translate="report-generator.fulfillment-report.approval-commission"></label><div layout-margin><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'commissioneApprovazione\', commissione.id)" ng-checked="vm.searchParamExists(\'commissioneApprovazione\', commissione.id)" ng-disabled="vm.loading || !vm.searchParamExists(\'sedeApprovazione\', \'COMMISSIONE\')">{{commissione.nome}}</md-checkbox></div></div></div></div><!-- Selezione delle macro materie--><div flex layout-gt-xs="row" flex-offset="5" layout-align="start center"><div layout="column" flex-gt-xs="50"><macro-materia-chip-search-component model="vm.searchParams.macroMateria" macro-materia-list="vm.macroMaterie" show-end-date="true"></macro-materia-chip-search-component></div></div><div class="spacer">&nbsp;</div><!-- Incaricato, Destinatario, Commissione Destinataria adempimento --><div ng-if="vm.searchParams.tipoReportAttiIndirizzo === \'adempimenti\'"><legend>Filtri Adempimenti</legend><div flex layout-gt-xs="row" flex-offset="5" layout-align="start"><div layout="column" flex-gt-xs="33" layout-margin><label data-translate="report-generator.fulfillment-report.fulfillment-delegate"></label><div ng-repeat="incaricato in vm.fulfillmentDelegates"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'incaricatoAdempimento\', incaricato)" ng-checked="vm.searchParamExists(\'incaricatoAdempimento\', incaricato)" ng-disabled="vm.loading">{{incaricato}}</md-checkbox></div></div><div layout="column" flex-gt-xs="33" layout-margin><label data-translate="report-generator.fulfillment-report.fulfillment-recipient"></label><div ng-repeat="destinatario in vm.fulfillmentRecipients"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'destinatarioAdempimento\', destinatario)" ng-checked="vm.searchParamExists(\'destinatarioAdempimento\', destinatario)" ng-disabled="vm.loading">{{destinatario}}</md-checkbox></div></div><div layout="column" flex-gt-xs="25" ng-if="vm.searchParamExists(\'destinatarioAdempimento\', \'COMMISSIONE\')"><label layout-margin data-translate="report-generator.fulfillment-report.recipient-commission"></label><div ng-repeat="commissioneDest in vm.commissioni"><md-checkbox class="md-primary" ng-value="value" ng-click="vm.toggleCheck(\'commissioneDestinataria\', commissioneDest.id)" ng-checked="vm.searchParamExists(\'commissioneDestinataria\', commissioneDest.id)" ng-disabled="vm.loading">{{commissioneDest.nome}}</md-checkbox></div></div></div><!-- Flag Adempimento Effettuato --><div flex layout-gt-xs="column" flex-offset="5" layout-align="start"><label layout-margin data-translate="report-generator.fulfillment-report.fulfilled" ng-click="vm.searchParams.flagAdempimentoEffettuato = null"></label><md-radio-group ng-model="vm.searchParams.flagAdempimentoEffettuato"><md-radio-button class="md-primary" ng-value="true">Si</md-radio-button><md-radio-button class="md-primary" ng-value="false">No</md-radio-button></md-radio-group></div></div><div class="spacer">&nbsp;</div></div></div><div class="md-button-group" style="position: fixed; bottom: 1em; left: 6%; width: 93%"><md-button type="submit" ng-click="vm.searchValidation()" ng-disabled="vm.loading" class="md-raised md-primary"><md-tooltip>Genera report PDF</md-tooltip><span class="glyphicon glyphicon-file"></span> <span>Genera report</span></md-button><md-button type="reset" ng-click="vm.clearSearch()" ng-disabled="vm.loading" class="md-raised md-accent"><md-tooltip>{{\'entity.action.clear\'| translate}}</md-tooltip><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.clear"></span></md-button></div></div><div ng-if="!vm.fulfillmentReportVisible"><h2>Non si dispongono i privilegi sufficienti per accedere a questa pagina.</h2></div></form>');
$templateCache.put('app/entities/atto-report-generator/atto-report-generator.html','<div class="row tree-header"><div class="col-xs-6"><h3 flex-offset="5" data-translate="report-generator.title"></h3></div></div><form name="formAdvancedSearch" class="advanced-search"><div layout="row" layout-wrap ng-if="vm.commissionsReportVisible"><div flex="100" flex-offset="5"><div style="border-style: solid; border-width: 1px; height: 100%; padding: 15px; border-color: #c7030a"><legend>{{\'report-generator.commissions-report.title\' | translate}}</legend><div layout-gt-xs="row" flex-offset="5" layout="column" layout-align="space-around center" flex><md-input-container flex-gt-xs="33"><label>{{\'gestioneAttiApp.atto.legislatura\'| translate}}</label><md-select ng-required="vm.searchParams.attiGiacentiOrLicenziatiInCommissione != null" name="legislatura" ng-model="vm.searchParams.legislatura" ng-change="vm.legislaturaChanged()"><md-option ng-value></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select><div ng-messages="formAdvancedSearch.legislatura.$error" role="alert"><div ng-message="required">{{\'report-generator.commissions-report.required\' | translate}}</div></div></md-input-container><md-input-container flex-gt-xs="33"><label>{{\'gestioneAttiApp.commissione.detail.title\'| translate}}</label><md-select ng-required="vm.searchParams.attiGiacentiOrLicenziatiInCommissione != null" name="commissioneReport" ng-model="vm.searchParams.commissioneReport"><md-option ng-value></md-option><md-option ng-repeat="item in vm.commissioni track by item.id" value="{{item.id}}">{{item.nome}}</md-option></md-select><div ng-messages="formAdvancedSearch.commissioneReport.$error" role="alert"><div ng-message="required">{{\'report-generator.commissions-report.required\' | translate}}</div></div></md-input-container><div flex-gt-xs="20" margin><md-radio-group ng-model="vm.searchParams.attiGiacentiOrLicenziatiInCommissione"><label ng-click="vm.searchParams.attiGiacentiOrLicenziatiInCommissione = null">{{\'report-generator.commissions-report.acts-laying-commission\' | translate}}</label><md-radio-button class="md-primary" value="GIACENTE"></md-radio-button><label ng-click="vm.searchParams.attiGiacentiOrLicenziatiInCommissione = null">{{\'report-generator.commissions-report.acts-out-of-commission\' | translate}}</label><md-radio-button class="md-primary" value="LICENZIATO"></md-radio-button></md-radio-group></div></div></div></div></div><div class="spacer">&nbsp;</div><div flex="100" flex-offset="5"><div style="border-style: solid; border-width: 1px; height: 100%; padding: 15px; border-color: #c7030a"><legend>{{\'report-generator.generic-report.title\' | translate}}</legend><div flex layout-gt-xs="row"><div layout="column" flex-gt-xs="15"><md-input-container><label>{{\'gestioneAttiApp.atto.ricercaStato\' | translate}}</label><md-select ng-model="vm.searchParams.statoAttoList" multiple="multiple"><md-option ng-repeat="item in ::vm.queryStates track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container></div><div layout="column" flex-gt-xs="15" class="rep-gen-ml"><md-input-container><label>{{\'gestioneAttiApp.atto.ricercaTipo\' | translate}}</label><md-select ng-model="vm.searchParams.tipoAttoList" multiple="multiple"><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container></div><div layout="column" flex-gt-xs="10" class="rep-gen-ml"><md-input-container><label>{{\'gestioneAttiApp.atto.legislatura\'| translate}}</label><md-select ng-model="vm.searchParams.legislatura" ng-change="vm.legislaturaChanged()"><md-option></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container></div><div layout="column" flex-gt-xs flex-offset="5" class="rep-gen-ml"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.oggetto"></label><input type="text" ng-model="vm.searchParams.titoloAtto" autocomplete="off"></md-input-container></div></div><div flex layout-gt-xs="row"><md-input-container flex-gt-xs="25"><label data-translate="gestioneAttiApp.form.presentation.numeroAtto"></label><input ng-model="vm.searchParams.numeroAtto"></md-input-container><div layout="row" flex-gt-xs="25"><md-input-container><label style="overflow: visible">Presentata dal</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataPresentazioneInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataPresentazioneInizio"><md-button ng-click="vm.searchParams.dataPresentazioneInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="25"><md-input-container><label style="overflow: visible">Presentata al</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataPresentazioneFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataPresentazioneFine"><md-button ng-click="vm.searchParams.dataPresentazioneFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div><div flex layout-gt-xs="row"><div layout="column" flex="10"><md-input-container style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><md-select ng-model="vm.searchParams.tipoProponenteList" ng-change="vm.tipoProponenteChange()" multiple="multiple"><md-option value="CR">CR</md-option><md-option value="GR">GR</md-option><md-option value="UP">UP</md-option></md-select></md-input-container></div><!-- 2023-06 rimosso in fase di integrazione con josh protocol - Le direzioni sono considerate anagrafiche, si gestiscono come proponenti\r\n                     <div ng-show="vm.isTipoGRselected" layout="column" flex="20">\r\n                        <md-input-container>\r\n                            <label data-translate="gestioneAttiApp.form.presentation.direzioneGR"></label>\r\n                            <md-select ng-model="vm.searchParams.direzioneGRId" placeholder="Direzione">\r\n                                <md-option value="none" data-translate="gestioneAttiApp.form.presentation.tipoAtto.empty"></md-option>\r\n                                <md-option ng-repeat="direzione in vm.direzione" ng-value="direzione.id">\r\n                                    {{direzione.nome}}\r\n                                </md-option>\r\n                            </md-select>\r\n                        </md-input-container>\r\n                </div> --><md-input-container ng-show="vm.isTipoGRselected" style="width: 200px"><label>Data GR</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataGR"></md-datepicker></md-input-container><div layout="column" flex="30" flex-offset="5"><label>Proponenti</label><md-chips md-autocomplete-snap ng-model="vm.searchParams.proponenti"><md-autocomplete md-selected-item="vm.searchParams.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchProponenti(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><div ng-if="vm.searchParams.proponenti && vm.searchParams.proponenti.length > 0"><md-radio-group ng-model="vm.searchParams.proponentiExclusionType"><md-radio-button class="md-primary" ng-value="\'ALL_INCLUDED\'">Tutti inclusi</md-radio-button><md-radio-button class="md-primary" ng-value="\'AT_LEAST_ONE_INCLUDED\'">Almeno uno incluso</md-radio-button></md-radio-group></div><div layout="column" flex="30" flex-offset="5"><label>Primo firmatario</label><md-chips md-autocomplete-snap ng-model="vm.searchParams.primiFirmatari"><md-autocomplete md-selected-item="vm.searchParams.selectedPrimiFirmatari" md-search-text="vm.selectedPrimiFirmatariSearchText" md-items="item in vm.searchProponenti(vm.selectedPrimiFirmatariSearchText)" md-item-text="item.descrizione"><span md-highlight-text="vm.selectedPrimiFirmatariSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><div ng-if="vm.searchParams.primiFirmatari && vm.searchParams.primiFirmatari.length > 0"><md-radio-group ng-model="vm.searchParams.primiFirmatariExclusionType"><md-radio-button class="md-primary" ng-value="\'ALL_INCLUDED\'">Tutti inclusi</md-radio-button><md-radio-button class="md-primary" ng-value="\'AT_LEAST_ONE_INCLUDED\'">Almeno uno incluso</md-radio-button></md-radio-group></div></div><div layout="column" flex><div flex="100" layout-gt-xs="row"><div layout="column" flex-gt-xs="15"><label data-translate="gestioneAttiApp.form.assignment.parereReferenteObbligatorioCommissioni"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereReferente\', commissione.id, null)" ng-checked="vm.searchParamExists(\'parereReferente\', commissione.id)" ng-disabled="vm.loading">{{commissione.descrizione}}</md-checkbox></div></div><div layout="column" flex-gt-xs="15" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereSecondario"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereSecondario\', commissione.id, null)" ng-checked="vm.searchParamExists(\'parereSecondario\', commissione.id)" ng-disabled="vm.loading">{{commissione.descrizione}}</md-checkbox></div></div><div layout="column" flex-gt-xs="15" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereDiMerito"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-checked="vm.searchParamExists(\'parereDiMerito\', commissione.id)" ng-click="vm.toggleCheck(\'parereDiMerito\', commissione.id, null)" ng-disabled="vm.loading">{{commissione.descrizione}}</md-checkbox></div></div><div layout="column" flex><md-radio-group ng-model="vm.searchParams.parereIstituzionale"><label data-translate="gestioneAttiApp.form.assignment.parereIstituzionale" ng-click="vm.searchParams.parereIstituzionale = null"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div layout="column" flex><label data-translate="gestioneAttiApp.form.assignment.parereObbligatorio"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereObbligatorio\', soggetto.id, null)" ng-checked="vm.searchParamExists(\'parereObbligatorio\', soggetto.id)" ng-disabled="vm.loading">{{soggetto.nome}}</md-checkbox></div></div><div layout="column" flex><label data-translate="gestioneAttiApp.form.assignment.osservazioni"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'osservazioni\', soggetto.id, null)" ng-checked="vm.searchParamExists(\'osservazioni\', soggetto.id)" ng-disabled="vm.loading">{{soggetto.nome}}</md-checkbox></div></div></div><div class="spacer">&nbsp;</div><div flex layout-gt-xs="row"><div layout="column" flex="25"><md-input-container><label>Passato in stato</label><md-select ng-model="vm.searchParams.statiCambioStato" multiple="multiple"><md-option ng-repeat="item in ::vm.cambioStatoAttoList track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container></div><div layout="row" flex-gt-xs="25"><md-input-container><label style="overflow: visible">Passato in stato dal</label><md-datepicker ng-disabled="!vm.searchParams.statiCambioStato || vm.searchParams.statiCambioStato.length === 0" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataCambioStatoInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataCambioStatoInizio"><md-button ng-click="vm.searchParams.dataCambioStatoInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="25"><md-input-container><label style="overflow: visible">Passato in stato al</label><md-datepicker ng-disabled="!vm.searchParams.statiCambioStato || vm.searchParams.statiCambioStato.length === 0" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataCambioStatoFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataCambioStatoFine"><md-button ng-click="vm.searchParams.dataCambioStatoFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div><div flex layout-gt-xs="row"><div flex-gt-xs="20"><label>Data esito commissione</label></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data esito Commissione dal</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataEsitoCommissioneInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataEsitoCommissioneInizio"><md-button ng-click="vm.searchParams.dataEsitoCommissioneInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data esito Commissione al</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataEsitoCommissioneFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataEsitoCommissioneFine"><md-button ng-click="vm.searchParams.dataEsitoCommissioneFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div><div flex layout-gt-xs="row"><div layout="row"><md-input-container><label>Tipo Atto collegato</label><md-select ng-model="vm.basicSearchType" ng-change="vm.getAllActs()" placeholder="{{\'gestioneAttiApp.atto.ricercaTipo\'| translate}}"><md-option></md-option><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><md-chips flex ng-model="vm.attachedActsModel" md-on-add="vm.onAddAttachedAct($index, $chip)" md-on-remove="vm.onRemoveAttachedAct($index, $chip, $event)" md-on-select="false" md-transform-chip="vm.transformChip($chip)" ng-class="{\'md-focused\': false}" ng-show="vm.basicSearchType || vm.attachedActsModel.length > 0"><md-autocomplete md-selected-item="vm.selectedUnifiedTextActRef" md-search-text="vm.numeroAttoSearchText" md-items="item in vm.searchActs(vm.numeroAttoSearchText)" md-item-text="item.numeroAtto" md-no-cache="true" placeholder="Numero atto"><span md-highlight-text="vm.selectedAttoSearchText">[{{item.tipoAtto}}] {{item.numeroAtto}}: {{item.titolo}}</span></md-autocomplete><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span><b>[{{$chip.tipoAtto}}]</b> {{$chip.numeroAtto}}: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div><div layout="column" layout-align-gt-xs="start start" class="rep-gen-ml"><label data-translate="gestioneAttiApp.atto.collegatoCon"></label><md-chips md-autocomplete-snap ng-model="vm.attachedActsReadOnlyListModel" md-on-remove="vm.onRemoveAttachedAct($index, $chip, $event)" md-on-select="false" md-transform-chip="vm.transformChip($chip)" ng-class="{\'md-focused\': false}" md-removable="true" readonly="true"><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span><b>[{{$chip.tipoAtto}}]</b> {{$chip.numeroAtto}}: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div><div ng-if="vm.searchParams.attiCollegati && vm.searchParams.attiCollegati.length > 0"><md-radio-group ng-model="vm.searchParams.attiCollegatiExclusionType"><md-radio-button class="md-primary" ng-value="\'ALL_INCLUDED\'">Tutti inclusi</md-radio-button><md-radio-button class="md-primary" ng-value="\'AT_LEAST_ONE_INCLUDED\'">Almeno uno incluso</md-radio-button></md-radio-group></div></div><div flex layout-gt-xs="row" style="margin-top: 35px"><div><md-radio-group ng-model="vm.searchParams.testoSostitutivoPresentato"><label ng-click="vm.searchParams.testoSostitutivoPresentato = null">Testo sostitutivo</label><md-radio-button class="md-primary" ng-value="true">Presentato</md-radio-button></md-radio-group></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Testo presentato dal</label><md-datepicker ng-disabled="!vm.searchParams.testoSostitutivoPresentato" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.testoSostitutivoInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.testoSostitutivoInizio"><md-button ng-click="vm.searchParams.testoSostitutivoInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Testo presentato al</label><md-datepicker ng-disabled="!vm.searchParams.testoSostitutivoPresentato" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.testoSostitutivoFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.testoSostitutivoFine"><md-button ng-click="vm.searchParams.testoSostitutivoFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data BURT dal</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataBurtInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataBurtInizio"><md-button ng-click="vm.searchParams.dataBurtInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data BURT al</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataBurtFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataBurtFine"><md-button ng-click="vm.searchParams.dataBurtFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data Trattazione dal</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataTrattazioneInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataTrattazioneInizio"><md-button ng-click="vm.searchParams.dataTrattazioneInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data Trattazione al</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataTrattazioneFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataTrattazioneFine"><md-button ng-click="vm.searchParams.dataTrattazioneFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div><md-radio-group ng-model="vm.searchParams.ricorsoCostituzionale"><label ng-click="vm.searchParams.ricorsoCostituzionale = null">Ricorso Costituzionale</label><md-radio-button class="md-primary" ng-value="true">Si</md-radio-button></md-radio-group></div></div><div flex layout-gt-md="row" style="margin-top: 35px"><div><md-radio-group ng-model="vm.searchParams.impegnoCaricoGiunta"><label ng-click="vm.searchParams.impegnoCaricoGiunta = null">Impegno a carico giunta</label><md-radio-button class="md-primary" ng-value="true">Si</md-radio-button></md-radio-group></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data invio richiesta dal</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataInvioRichiestaInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataInvioRichiestaInizio"><md-button ng-click="vm.searchParams.dataInvioRichiestaInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data invio richiesta al</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataInvioRichiestaFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataInvioRichiestaFine"><md-button ng-click="vm.searchParams.dataInvioRichiestaFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data ricezione dal</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataRicezioneInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataRicezioneInizio"><md-button ng-click="vm.searchParams.dataRicezioneInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data ricezione al</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataRicezioneFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataRicezioneFine"><md-button ng-click="vm.searchParams.dataRicezioneFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data sollecito dal</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataSollecitoInizio"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataSollecitoInizio"><md-button ng-click="vm.searchParams.dataSollecitoInizio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex-gt-xs="20"><md-input-container><label style="overflow: visible">Data sollecito al</label><md-datepicker ng-disabled="!vm.searchParams.impegnoCaricoGiunta" md-open-on-focus onkeydown="return false" ng-model="vm.searchParams.dataSollecitoFine"></md-datepicker></md-input-container><span ng-if="vm.searchParams.dataSollecitoFine"><md-button ng-click="vm.searchParams.dataSollecitoFine = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div><div class="spacer">&nbsp;</div></div><div class="md-button-group" style="position: fixed; bottom: 1em; left: 6%; width: 93%"><md-button type="submit" ng-click="vm.searchWithCommissionCheck()" ng-disabled="vm.loading" class="md-raised md-primary"><md-tooltip>Genera report PDF</md-tooltip><span class="glyphicon glyphicon-file"></span> <span>Genera report</span></md-button><md-button type="reset" ng-click="vm.clearSearch()" ng-disabled="vm.loading" class="md-raised md-accent"><md-tooltip>{{\'entity.action.clear\'| translate}}</md-tooltip><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.clear"></span></md-button></div></div></div></form>');
$templateCache.put('app/entities/anagrafica-protocollo/anagrafica-protocollo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.anagraficaProtocollo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.anagraficaProtocollo.delete.question" translate-values="{id: \'{{vm.anagraficaProtocollo.id}}\'}">Are you sure you want to delete this AnagraficaProtocollo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/anagrafica-protocollo/anagrafica-protocollo-detail.html','<div><h2><span data-translate="gestioneAttiApp.anagraficaProtocollo.detail.title">AnagraficaProtocollo</span> {{vm.anagraficaProtocollo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.anagraficaProtocollo.codice">Codice</span></dt><dd><span>{{vm.anagraficaProtocollo.codice}}</span></dd><dt><span data-translate="gestioneAttiApp.anagraficaProtocollo.descrizione">Descrizione</span></dt><dd><span>{{vm.anagraficaProtocollo.descrizione}}</span></dd><dt><span data-translate="gestioneAttiApp.anagraficaProtocollo.pubblica">Pubblica</span></dt><dd><span>{{vm.anagraficaProtocollo.pubblica | yesNo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="anagraficaProtocollo-detail.edit({id:vm.anagraficaProtocollo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/anagrafica-protocollo/anagrafica-protocollo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAnagraficaProtocolloLabel" data-translate="gestioneAttiApp.anagraficaProtocollo.home.createOrEditLabel">Create or edit a AnagraficaProtocollo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.anagraficaProtocollo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.anagraficaProtocollo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.anagraficaProtocollo.anagrafica">Anagrafica</label><md-autocomplete aria-label="anagraficaProtocollo" md-no-cache="true" md-selected-item="vm.selectedItem" md-search-text="vm.searchText" md-selected-item-change="vm.setAnagrafic(item)" md-items="item in vm.searchAnagrafics(vm.searchText)" md-min-length="2" md-delay="400" md-dropdown-position="bottom" md-clear-button="false" md-search-text-change="vm.anagraficaProtocollo.anagraficaProtocollo = null" md-item-text="vm.getDisplayName(item)" placeholder="{{\'gestioneAttiApp.anagraficaProtocollo.codAnagrafica\'| translate}}"><md-item-template><span class="item-title"><span>{{vm.getDisplayName(item)}}</span></span></md-item-template></md-autocomplete></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.anagraficaProtocollo.codice" for="field_codice">codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.anagraficaProtocollo.codice" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.anagraficaProtocollo.descrizione" for="field_descrizione">descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.anagraficaProtocollo.descrizione" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.anagraficaProtocollo.pubblica" for="field_pubblica">pubblica</label><md-checkbox class="form-control" name="pubblica" aria-label="pubblica" id="field_pubblica" ng-checked="vm.anagraficaProtocollo.pubblica" ng-click="vm.anagraficaProtocollo.pubblica = !vm.anagraficaProtocollo.pubblica"></md-checkbox></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/anagrafica-protocollo/anagrafica-protocollos.html','<div class="md-whiteframe-5dp"><div class="container-fluid"><div class="row"><div class="col-xs-8 col-md-4"><h2 data-translate="gestioneAttiApp.anagraficaProtocollo.home.title">AnagraficaProtocollos</h2></div><div class="col-xs-8 col-md-4"><md-input-container><md-select ng-model="vm.protocolSystem" ng-change="vm.onChangeProtocolSystem()" placeholder="Seleziona un sistema di protocollo"><md-option></md-option><md-option value="INSIEL">Insiel</md-option><md-option value="JOSH_PROTOCOL">Josh protocol</md-option></md-select></md-input-container></div></div><jhi-alert></jhi-alert><div class="row"><div class="col-xs-4 col-md-2 no-padding-left"><button class="btn btn-primary" ui-sref="anagrafica-protocollo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.anagraficaProtocollo.home.createLabel">Create new AnagraficaProtocollo</span></button></div><div class="col-md-8"><md-input-container style="width: 70%"><input type="text" ng-model="vm.searchTerm" placeholder="{{\'gestioneAttiApp.anagraficaProtocollo.search\' | translate}}"></md-input-container><md-button type="button" class="md-fab md-primary" ng-click="vm.search()"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.anagraficaProtocollo.codice">Codice</span></th><th><span data-translate="gestioneAttiApp.anagraficaProtocollo.descrizione">Descrizione</span></th><th><span data-translate="gestioneAttiApp.anagraficaProtocollo.pubblica">Pubblica</span></th><th></th></tr></thead><tbody><tr ng-repeat="anagraficaProtocollo in vm.anagraficaProtocollos track by anagraficaProtocollo.id"><td><a ui-sref="anagraficaProtocollo-detail({id:anagraficaProtocollo.id})">{{anagraficaProtocollo.id}}</a></td><td>{{anagraficaProtocollo.codice}}</td><td>{{anagraficaProtocollo.descrizione}}</td><td>{{anagraficaProtocollo.pubblica| yesNo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="anagrafica-protocollo-detail({id:anagraficaProtocollo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="anagrafica-protocollo.edit({id:anagraficaProtocollo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="anagrafica-protocollo.delete({id:anagraficaProtocollo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/commissione/commissione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.commissione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.commissione.delete.question" translate-values="{id: \'{{vm.commissione.id}}\'}">Are you sure you want to delete this Commissione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/commissione/commissione-detail.html','<div><h2><span data-translate="gestioneAttiApp.commissione.detail.title">Commissione</span> {{vm.commissione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.nome">Nome</span></dt><dd class="col-md-8"><span>{{vm.commissione.nome}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.descrizione">Descrizione</span></dt><dd class="col-md-8"><span>{{vm.commissione.descrizione}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.legislature">Legislature</span></dt><dd class="col-md-8"><span>{{vm.commissione.legislature}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.filingCodeOdg">Codice Classificazione Protocollo ODG</span></dt><dd class="col-md-8"><span>{{vm.commissione.filingCodeOdg}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</span></dt><dd class="col-md-8"><span>{{vm.commissione.filingCodeOdgFormattedForWS}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.primaCommissione">Prima Commissione</span></dt><dd class="col-md-8"><input type="checkbox" ng-checked="vm.commissione.primaCommissione" disabled="disabled"></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.commissione.commissioneControllo">Commissione di Controllo</span></dt><dd class="col-md-8"><input type="checkbox" ng-checked="vm.commissione.commissioneDiControllo" disabled="disabled"></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="commissione-detail.edit({id:vm.commissione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/commissione/commissione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCommissioneLabel" data-translate="gestioneAttiApp.commissione.home.createOrEditLabel">Create or edit a Commissione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.commissione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.commissione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.commissione.nome"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="nome" id="field_descrizione" ng-model="vm.commissione.descrizione"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.legislature">Legislature</label><div><md-checkbox ng-repeat="legislatura in vm.legislature" ng-model="vm.selectedLegislature[legislatura]" aria-label="Legislatura {{legislatura}}">{{legislatura | romanize}}</md-checkbox></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.filingCodeOdg" for="field_filingCodeOdg">Codice Classificazione Protocollo ODG</label><input type="text" class="form-control" name="filingCodeOdg" id="field_filingCodeOdg" ng-model="vm.commissione.filingCodeOdg"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.filingCodeOdgFormattedForWS" for="field_filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</label><input type="text" class="form-control" name="nome" id="field_filingCodeOdgFormattedForWS" ng-model="vm.commissione.filingCodeOdgFormattedForWS"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.primaCommissione">Prima Commissione</label><div><md-checkbox ng-model="vm.commissione.primaCommissione" aria-label="Prima Commissione">Prima Commissione</md-checkbox></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissione.commissioneControllo">Commissione di Controllo</label><div><md-checkbox ng-model="vm.commissione.commissioneDiControllo" aria-label="Commissione di Controllo">Commissione di Controllo</md-checkbox></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/commissione/commissione-search-form.html','<form ng-submit="vm.transition()" name="stickyCommissioneSearchForm"><div layout="row"><md-input-container style="min-width: 82px"><label data-translate="gestioneAttiApp.commissione.legislatura"></label><md-select ng-model="vm.basicSearchLegislatura" ng-change="vm.transition()" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.commissione.legislatura\'| translate}}"><md-option value="ALL"></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form>');
$templateCache.put('app/entities/commissione/commissiones.html','<div><h2 data-translate="gestioneAttiApp.commissione.home.title">Commissioni</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="commissione.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.commissione.home.createLabel">Create new Commissione</span></button></div></div></div><br><div ng-include="\'app/entities/commissione/commissione-search-form.html\'"></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.commissione.legislature">Legislature</span></th><th><span data-translate="gestioneAttiApp.commissione.nome">Nome</span></th><th><span data-translate="gestioneAttiApp.commissione.descrizione">Descrizione</span></th><th><span data-translate="gestioneAttiApp.commissione.filingCodeOdg">Codice Classificazione Protocollo ODG</span></th><th><span data-translate="gestioneAttiApp.commissione.filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</span></th><th></th></tr></thead><tbody><tr ng-repeat="commissione in vm.commissiones track by commissione.id"><td><a ui-sref="commissione-detail({id:commissione.id})">{{commissione.id}}</a></td><td>{{commissione.legislature}}</td><td><span ng-if="commissione.primaCommissione" title="Prima Commissione" style="margin-left:5px"><span class="badge badge-success" style="background-color: #c7030a; color: white; font-size: 15px; vertical-align: middle"><span class="glyphicon glyphicon-star" aria-hidden="true"></span>1 </span></span><span ng-if="commissione.commissioneDiControllo" title="Commissione di controllo" style="margin-left:5px"><span class="badge badge-success" style="background-color: #c7030a; color: white; font-size: 15px; vertical-align: middle"><span class="glyphicon glyphicon-check" aria-hidden="true"></span> </span></span>{{commissione.nome}}</td><td>{{commissione.descrizione}}</td><td>{{commissione.filingCodeOdg}}</td><td>{{commissione.filingCodeOdgFormattedForWS}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="commissione-detail({id:commissione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="commissione.edit({id:commissione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="commissione.delete({id:commissione.id})" class="btn btn-danger btn-sm" ng-disabled="commissione.system"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/commissione-atti/commissione-atti.html','<div class="container"><h1><span ng-if="vm.tipoPaginaCommissione == 1" data-translate="gestioneAttiApp.commissioneAtti.home.title-giacenti">Atti attualmente all\u2019esame della Commissione</span> <span ng-if="vm.tipoPaginaCommissione == 2" data-translate="gestioneAttiApp.commissioneAtti.home.title-licenziati">Atti gi\xE0 esaminati dalla Commissione</span><br><span>Leg. {{vm.legislatura | romanize}} - {{vm.commissione.nome}}</span></h1><jhi-alert></jhi-alert><atto-table-list format="\'compressed\'" table-type="{{vm.tipoPaginaCommissione}}" paging="vm.pagingParams" show-controls="true"></atto-table-list></div>');
$templateCache.put('app/entities/commissione-ruolo/commissione-ruolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.commissioneRuolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.commissioneRuolo.delete.question" translate-values="{id: \'{{vm.commissioneRuolo.id}}\'}">Are you sure you want to delete this Commissione Ruolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/commissione-ruolo/commissione-ruolo-detail.html','<div><h2><span data-translate="gestioneAttiApp.commissioneRuolo.detail.title">Commissione Ruolo</span> {{vm.commissioneRuolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.commissioneRuolo.nome">Nome</span></dt><dd><span>{{vm.commissioneRuolo.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="commissione-ruolo-detail.edit({id:vm.commissioneRuolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/commissione-ruolo/commissione-ruolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCommissioneRuoloLabel" data-translate="gestioneAttiApp.commissioneRuolo.home.createOrEditLabel">Create or edit a Commissione Ruolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.commissioneRuolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.commissioneRuolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.commissioneRuolo.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.commissioneRuolo.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/commissione-ruolo/commissione-ruolos.html','<div><h2 data-translate="gestioneAttiApp.commissioneRuolo.home.title">Commissione Ruolos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="commissione-ruolo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.commissioneRuolo.home.createLabel">Create new Commissione Ruolo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.commissioneRuolo.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="commissioneRuolo in vm.commissioneRuolos track by commissioneRuolo.id"><td><a ui-sref="commissione-ruolo-detail({id:commissioneRuolo.id})">{{commissioneRuolo.id}}</a></td><td>{{commissioneRuolo.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="commissione-ruolo-detail({id:commissioneRuolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="commissione-ruolo.edit({id:commissioneRuolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="commissione-ruolo.delete({id:commissioneRuolo.id})" class="btn btn-danger btn-sm" ng-disabled="commissioneRuolo.system"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/direzione/direzione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.direzione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.direzione.delete.question" translate-values="{id: \'{{vm.direzione.id}}\'}">Are you sure you want to delete this Direzione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/direzione/direzione-detail.html','<div><h2><span data-translate="gestioneAttiApp.direzione.detail.title">Direzione</span> {{vm.direzione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.direzione.nome">Nome</span></dt><dd><span>{{vm.direzione.nome}}</span></dd><dt><span data-translate="gestioneAttiApp.direzione.anagrafica">Anagrafica Protocollo</span></dt><dd><span>{{vm.direzione.anagraficaProtocollo.anagraficCode + \' - \' + vm.direzione.anagraficaProtocollo.anagraficDescription}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="direzione-detail.edit({id:vm.direzione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/direzione/direzione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDirezioneLabel" data-translate="gestioneAttiApp.direzione.home.createOrEditLabel">Create or edit a Direzione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.direzione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.direzione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.direzione.anagrafica">Anagrafica</label><md-autocomplete aria-label="anagraficaProtocollo" md-no-cache="true" md-selected-item="vm.selectedItem" md-search-text="vm.searchText" md-selected-item-change="vm.setAnagrafic(item)" md-items="item in vm.searchAnagrafics(vm.searchText)" md-min-length="2" md-delay="400" md-dropdown-position="bottom" md-item-text="vm.getDisplayName(item)" md-search-text-change="vm.direzione.anagraficaProtocollo = null" md-clear-button="false" placeholder="{{\'gestioneAttiApp.direzione.codAnagrafica\' | translate}}"><md-item-template><span class="item-title"><span>{{vm.getDisplayName(item)}}</span></span></md-item-template></md-autocomplete></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.direzione.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.direzione.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/direzione/direziones.html','<div class="md-whiteframe-5dp"><div class="container-fluid"><h2 data-translate="gestioneAttiApp.direzione.home.title">Direziones</h2><jhi-alert></jhi-alert><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="direzione.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.direzione.home.createLabel">Create new Direzione</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.direzione.nome">Nome</span></th><th><span data-translate="gestioneAttiApp.direzione.anagrafica">Anagrafica Protocollo</span></th><th></th></tr></thead><tbody><tr ng-repeat="direzione in vm.direziones track by direzione.id"><td><a ui-sref="direzione-detail({id:direzione.id})">{{direzione.id}}</a></td><td>{{direzione.nome}}</td><td>{{direzione.anagraficaProtocollo.anagraficCode + \' - \' + direzione.anagraficaProtocollo.anagraficDescription}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="direzione-detail({id:direzione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="direzione.edit({id:direzione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="direzione.delete({id:direzione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/documento/documento-content.html','<div class="container-fluid"><h2><label class="label label-warning">{{vm.doc.nome}}</label></h2><span ng-if="!vm.loading && !vm.error"><md-button style="left: 12px" class="md-raised md-primary" ng-click="vm.download()">Scarica <i class="glyphicon glyphicon-download-alt"></i></md-button></span><div style="padding-top: 10px" ng-if="!vm.error"><iframe width="100%" height="800" ng-src="{{vm.path}}" allowfullscreen frameborder="0"></iframe></div><div style="padding-top: 10px" ng-if="vm.error"><label class="label label-danger">Impossibile visualizzare il file <span ng-if="vm.errorStatus === 400">: utenza non autorizzata</span></label></div></div>');
$templateCache.put('app/entities/documento/documento-tree.html','<div class="container-fluid"><h1 data-translate="gestioneAttiApp.documento-tree.title">Fascicolo</h1><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\r\n\t\t<div class="archive-tree-row" ng-if="node.nodes && node.nodes.length > 0" data-nodrag>\r\n\t\t\t<a class="btn archive-tree-folder btn-xs" title="{{\'archiveTree.actions.getLink\' | translate}}" ng-click="vm.getLink(node.link)">\r\n\t\t\t\t<span class="glyphicon glyphicon-link"></span>\r\n\t\t\t</a>\r\n\t\t\t<a class="btn archive-tree-folder btn-xs" style="padding: 4px 5px;" ng-click="toggle(this)">\r\n\t\t\t\t<span class="glyphicon" ng-class="{\'glyphicon glyphicon-folder-close\': collapsed, \'glyphicon glyphicon-folder-open\': !collapsed}"></span>\r\n\t\t\t</a>\r\n\t\t\t<span>{{node.title | translate}}</span>\r\n\t\t</div>\r\n\t\t\r\n\t\t<!--ng-click="vm.downloadFile(node.id, node.title)" -->\r\n\t\t<div class="archive-tree-row archive-tree-leaf"  ng-if="node.nodes == null || node.nodes.length == 0" data-nodrag>\r\n\t\t\t<a class="btn archive-tree-folder btn-xs" style="padding: 4px 5px;" title="{{\'archiveTree.actions.getLink\' | translate}}" ng-click="vm.getLink(node.link)">\r\n\t\t\t\t<span class="glyphicon glyphicon-link"></span>\r\n\t\t\t</a>\r\n\t\t\t<a href="/#/document/{{node.id}}/content" target="_blank">\t\t\r\n\t\t\t\t<button class="btn archive-tree-folder btn-sm">\r\n\t\t\t\t\t<span class="glyphicon glyphicon-file archive-tree-file"  data-nodrag></span>\r\n\t\t\t\t</button>\r\n\t\t\t\t<span>{{node.title | translate}}</span>\r\n\t\t\t</a>\r\n\t\t</div>\r\n\t  </div>\r\n\t  \r\n\t  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\r\n\t\t<li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\r\n\t  </ol></script><div ui-tree id="tree-root" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.archiveTree"><li ng-repeat="node in vm.archiveTree" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></div>');
$templateCache.put('app/entities/importer-board-monitor/importer-board-monitor.html','<h1 style="margin-bottom: 60px" class="not-sticky">Importer Dashboard</h1><div hl-sticky="" name="stickySearchFormImporterDetail"><div layout="row"><md-input-container flex="10" style="background-color: #fafafa; margin-top: 0px"><label>Sistema Protocollo</label><md-select ng-model="vm.protocolSystem" ng-change="vm.transition()" placeholder="Sistema Protocollo"><md-option></md-option><md-option value="INSIEL">Insiel</md-option><md-option value="JOSH_PROTOCOL">Josh Protocol</md-option></md-select></md-input-container><md-input-container flex="10" style="background-color: #fafafa; margin-top: 0px"><input type="number" ng-model="vm.protocolNumber" placeholder="Numero Protocollo"></md-input-container><md-input-container flex="10" style="background-color: #fafafa; margin-top: 0px"><input type="number" ng-model="vm.year" placeholder="Anno Protocollazione"></md-input-container><md-input-container flex="10" style="background-color: #fafafa; margin-top: 0px"><input type="number" ng-model="vm.attoNumber" placeholder="Numero Atto"></md-input-container><md-input-container style="min-width: 82px; margin-top: 0px"><label data-translate="gestioneAttiApp.atto.legislatura"></label><md-select ng-model="vm.legislatura" ng-change="vm.transition()" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}"><md-option value=""></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container style="background-color: #fafafa; margin-top: 0px"><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.importType" ng-change="vm.transition()" placeholder="{{\'gestioneAttiApp.atto.ricercaTipo\'| translate}}"><md-option></md-option><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><md-input-container style="background-color: #fafafa; margin-top: 0px"><label>Direzione</label><md-select ng-model="vm.direction" ng-change="vm.transition()" placeholder="Direzione"><md-option></md-option><md-option value="P">Partenza</md-option><md-option value="A">Arrivo</md-option></md-select></md-input-container><md-input-container style="background-color: #fafafa; margin-top: 0px"><label>Tipologia Errore</label><md-select ng-model="vm.errorType" ng-change="vm.transition()" placeholder="Tipologia errore"><md-option></md-option><md-option value="PRATICA_ASSENTE">Pratica Assente</md-option><md-option value="DETTAGLI_DOSSIER_NON_RICEVUTI">Dettagli prartica non ricevuti da protocollo</md-option><md-option value="DATI_NON_COMPLETI">Dati incompleti</md-option><md-option value="TIPO_PROPONENTE_SCONOSCIUTO">Tipo proponente sconosciuto</md-option><md-option value="IMPOSSIBILE_RECUPERARE_PROPONENTE">Recupero anagrafica proponente fallito</md-option><md-option value="CODICE_SEZIONE_SCONOSCIUTO">Codice mnemonico sezione sconosciuto o assente</md-option><md-option value="CODICE_DOCUMENTO_SCONOSCIUTO">Codice mnemonico documento sconosciuto o assente</md-option><md-option value="ALTRO">Errore generico</md-option><md-option value="SUCCESS">Importato con successo</md-option><md-option value="IMPORT_STARTED">Import iniziato</md-option><md-option value="IMPORT_NOT_ENABLED">Flag import non abilitato</md-option><md-option value="LISTA_DOSSIER_VUOTA">Lista dossier vuota</md-option><md-option value="XML_PARSE_ERROR">Errore parsing XML</md-option><md-option value="CONTROLLO_IMPORT_DOCUMENTI_FALLITO">Errore Documento non importato</md-option><md-option value="DOCUMENTO_NON_SALVATO_DB">Errore Documento non salvato DB</md-option><md-option value="DOCUMENTO_NON_SALVATO_FS">Errore Documento non salvato Filesystem</md-option><md-option value="DOCUMENTO_NON_AGGIORNATO_FS">Errore Documento non aggiornato alla versione pi\xF9 recente</md-option><md-option value="DOCUMENTI_MANCANTI">Importato ma documenti mancanti</md-option><md-option value="DETTAGLI_DOCUMENTO_NON_RICEVUTI">Dettagli documento non ricevuti</md-option><md-option value="PROPRIETA_AGGIUNTIVE_DOCUMENTO_NON_RICEVUTE">Propriet&agrave; aggiuntive Documento mancanti</md-option><md-option value="DETTAGLI_FASCICOLO_NON_RICEVUTI">Dettagli Fascicolo non ricevuti da protocollo</md-option><md-option value="PROPRIETA_AGGIUNTIVE_FASCICOLO_NON_RICEVUTE">Propriet&agrave; aggiuntive Fascicolo mancanti</md-option><md-option value="FILES_NON_RICEVUTI">Files allegati non ricevuti</md-option></md-select></md-input-container><md-button ng-click="vm.transition()" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></div><div id="atto-list-container"><table class="table table-bordered"><thead><tr><th>Sistema Protocollo</th><th>Numero Protocollo</th><th>Tipo Import</th><th>Document Prog.</th><th>Direzione</th><th>Data protocollo</th><th>Data Ultima modifica</th><th>Data ultima modifica importato</th><th>Data Prima importazione</th><th>Data ultima importazione</th><th>Tipo - Numero Atto - Legislatura - Anno</th><!--                 <th>Numero Atto</th>\r\n                <th>Legislatura</th>\r\n                <th>Anno</th> --><th>Documenti Importati/Totali</th><th>File tecnici</th><th>Ripeti import</th><th>Data Ultima Importazione Manuale</th><th>Esito Import Manuale</th><th>Tentativi Importazione Auto</th><th>Risultato Importazione Auto</th></tr></thead><tbody><tr ng-repeat="importDetail in vm.protocolImportDetails track by $index" ng-class="{\'striped-row\': $index % 2 === 0}"><td>{{::importDetail.protocolSystem}}</td><td>{{::importDetail.protocolNumber}}</td><td>{{::importDetail.importType}}</td><td>{{::importDetail.documentProg}}</td><td>{{::importDetail.direction}}</td><td>{{::importDetail.registrationDate | date: \'dd/MM/yyyy\'}}</td><td>{{::importDetail.lastProtocolUpdateDate | date: \'dd/MM/yyyy, HH:mm:ss\'}}</td><td>{{::importDetail.lastSuccessImportProtocolUpdateDate | date: \'dd/MM/yyyy, HH:mm:ss\'}}</td><td>{{::importDetail.firstImportDate | date: \'dd/MM/yyyy, HH:mm:ss\'}}</td><td>{{::importDetail.latestImportDate | date: \'dd/MM/yyyy, HH:mm:ss\'}}</td><td><table class="table table-bordered" style="margin-bottom: 0px"><tbody><tr ng-repeat="atto in importDetail.listaAtti track by $index"><td>{{::atto.tipoAtto}}</td><td>{{::atto.numeroAtto}}</td><td ng-if="atto.legislatura">{{::atto.legislatura | romanize}}</td><td ng-if="!atto.legislatura"></td><td>{{::atto.anno}}</td></tr></tbody></table></td><td><table class="table table-bordered" style="margin-bottom: 0px"><tbody><tr ng-repeat="atto in importDetail.listaAtti track by $index"><td ng-if="atto.listaDocumenti" ng-class="vm.alertImportDocument(atto.listaDocumenti) ? \'error\' : \'\'">{{vm.filterImportedDocuments(atto.listaDocumenti).length}} / {{vm.filterTotalDocuments(atto.listaDocumenti).length}}</td><td ng-if="!atto.listaDocumenti">NON DISP</td></tr></tbody></table></td><td><table class="table table-bordered" style="margin-bottom: 0px"><tbody><tr ng-repeat="atto in importDetail.listaAtti track by $index"><td ng-if="atto.listaDocumenti" ng-class="vm.alertImportDocument(atto.listaDocumenti) ? \'error\' : \'\'">{{vm.filterTechnicalDocuments(atto.listaDocumenti).length}}</td><td ng-if="!atto.listaDocumenti">NON DISP</td></tr></tbody></table></td><td><div layout-align="center"><button ng-if="!vm.manualImportLoadingMap[importDetail.id]" ng-disabled="importDetail.protocolSystem===\'JOSH_PROTOCOL\'" class="btn btn-primary btn-sm" ng-click="vm.startProtocolImport($index, importDetail)">Import manuale</button><md-progress-circular ng-if="vm.manualImportLoadingMap[importDetail.id]" md-mode="indeterminate"></md-progress-circular></div></td><td><span ng-if="importDetail.latestManualImportDate">{{::importDetail.latestManualImportDate | date: \'dd/MM/yyyy, HH:mm:ss\'}} </span><span ng-if="!importDetail.latestManualImportDate">NON ESEGUITO</span></td><td ng-class="{\'import-detail-error\': importDetail.manualImportErrorType !== \'SUCCESS\', \'import-detail-success\': importDetail.manualImportErrorType === \'SUCCESS\'}"><span ng-if="importDetail.manualImportErrorType">{{vm.ImporterBoardMonitor.getErrorTypeString(importDetail.manualImportErrorType)}} {{vm.ImporterBoardMonitor.errorCodeToString(importDetail.manualImportErrorType, importDetail.metadati)}}</span></td><td>{{::importDetail.numeroTentativi}}</td><td ng-class="{\'import-detail-error\': importDetail.errorType !== \'SUCCESS\', \'import-detail-success\': importDetail.errorType === \'SUCCESS\'}">{{vm.ImporterBoardMonitor.getErrorTypeString(importDetail.errorType)}} {{vm.ImporterBoardMonitor.errorCodeToString(importDetail.errorType, importDetail.metadati)}}</td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/lista-di-distribuzione/gestione-notifiche.html','<div class="text-center"><h1 style="margin-bottom: 60px" class="not-sticky">Gestione Notifiche</h1></div><div class="text-center"><md-input-container><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.selectedAtto" ng-change="vm.loadConfigurazioneNotifiche()" placeholder="Seleziona un tipo atto" ng-disabled="vm.loadingListe"><md-option></md-option><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container></div><div ng-if="vm.selectedAtto" class="text-center" style="margin-bottom: 35px"><div ng-if="!vm.loading"><div ng-repeat="eventoAtto in vm.listaEventi"><h3>{{eventoAtto.name | translate}}</h3><div style="max-width: 60%; margin-left: auto; margin-right: auto; margin-top: 35px"><label>Liste associate</label><md-chips ng-model="vm.selectedAttoConfig.mappaNotifiche[eventoAtto.value]"><md-autocomplete md-selected-item="vm.autocompleteModelMap[eventoAtto.value]" md-search-text="vm.autocompleteSearchtextMap[eventoAtto.value]" md-items="item in vm.searchLista(vm.autocompleteSearchtextMap[eventoAtto.value])" md-item-text="item.nomeLista" placeholder="Seleziona una lista"><span md-highlight-text="vm.autocompleteSearchtextMap[eventoAtto.value]">{{item.nomeLista}} - {{item.mail}}</span></md-autocomplete><md-chip-template><span>[{{$chip.nomeLista}}] - {{$chip.mail}}</span></md-chip-template></md-chips><div class="spacer"></div></div></div><div layout-align="end center" ng-if="vm.selectedAttoConfig"><md-button ng-click="vm.saveConfig()" class="md-raised md-primary" ng-disabled="vm.isSavingConfig"><span class="glyphicon glyphicon-floppy-disk"></span> <span layout-wrap>Salva Configurazione</span></md-button></div></div><div ng-if="vm.loading"><loading-spinner-component></loading-spinner-component></div></div><div ng-if="!vm.selectedAtto" class="text-center" style="margin-top: 40px">Seleziona un tipo di atto per configurare ad ogni evento le liste di distribuzione da notificare.</div>');
$templateCache.put('app/entities/lista-di-distribuzione/lista-di-distribuzione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.listaDiDistribuzione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.listaDiDistribuzione.delete.question" translate-values="{id: \'{{vm.listaDiDistribuzione.id}}\'}">Are you sure you want to delete this lista di distribuzione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/lista-di-distribuzione/lista-di-distribuzione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mylistaDiDistribuzioneLabel" data-translate="gestioneAttiApp.listaDiDistribuzione.home.createOrEditLabel">Create or edit a listaDiDistribuzione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.listaDiDistribuzione.nomeLista" for="field_nomeLista">descrizione</label><input type="text" class="form-control" name="nomeLista" id="field_nomeLista" ng-model="vm.listaDiDistribuzione.nomeLista" required ng-maxlength="50"><div ng-show="editForm.nomeLista.$invalid"><p class="help-block" ng-show="editForm.nomeLista.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomeLista.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.listaDiDistribuzione.mail">Email</label><input type="email" class="form-control" name="email" ng-model="vm.listaDiDistribuzione.mail" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.listaDiDistribuzione.descrizione" for="field_descrizione">descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.listaDiDistribuzione.descrizione"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/lista-di-distribuzione/lista-di-distribuzione.html','<h1 style="margin-bottom: 60px" class="not-sticky">Liste di distribuzione</h1><div id="atto-list-container"><div class="col-xs-4 col-md-2 no-padding-left"><button class="btn btn-primary" ui-sref="lista-di-distribuzione.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="lista-di-distribuzione.addLabel">Create new Lista di distribuzione</span></button></div><table class="table table-bordered"><thead><tr><th>Nome lista di distribuzione</th><th>E-mail</th><th>Descrizione</th><th></th></tr></thead><tbody><tr ng-repeat="lista in vm.listaDiDistribuzioneList track by $index" ng-class="{\'striped-row\': $index % 2 === 0}"><td>{{::lista.nomeLista}}</td><td>{{::lista.mail}}</td><td>{{::lista.descrizione}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="lista-di-distribuzione.edit({id:lista.id})" ui-sref-opts="{reload: true}" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="lista-di-distribuzione.delete({id:lista.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/macro-materia/macro-materia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.macroMateria.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="macroMateria.delete.question" translate-values="{code: \'{{vm.macroMateria.code}}\'}">Are you sure you want to delete this macro materia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/macro-materia/macro-materia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" style="min-width: 500px"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMacroMateriaLabel" data-translate="macroMateria.home.createOrEditLabel">Create or edit a MacroMateria</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="macroMateria.description" for="field_descrizione">descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.macroMateria.description"></div><div class="form-group"><label class="control-label" data-translate="macroMateria.code" for="field_codice">codice</label><input type="number" class="form-control" name="codice" id="field_codice" ng-model="vm.macroMateria.code"></div><div class="form-group" flex layout="row" layout-align="space-around"><div flex="50"><md-input-container><label data-translate="macroMateria.validityStart">Inizio validit\xE0</label><md-datepicker name="validityStartDate" id="field_validityStartDate" md-open-on-focus onkeydown="return false" ng-model="vm.macroMateria.validityStartDate" ng-change="vm.startDateChanged()"></md-datepicker></md-input-container></div><div flex="50" layout="row"><md-input-container><label data-translate="macroMateria.validityEnd">Fine validit\xE0</label><md-datepicker ng-disabled="!vm.endMinDate" md-min-date="vm.endMinDate" name="validityEndDate" id="field_validityEndDate" md-open-on-focus onkeydown="return false" ng-model="vm.macroMateria.validityEndDate"></md-datepicker></md-input-container><span ng-if="vm.macroMateria.validityEndDate != null"><md-button ng-click="vm.macroMateria.validityEndDate = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data fine validit\xE0</md-tooltip></md-button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.isFormValid()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/macro-materia/macro-materia.html','<h1 style="margin-bottom: 60px" class="not-sticky">Macro Materie</h1><div id="atto-list-container"><div class="col-xs-4 col-md-2 no-padding-left"><button class="btn btn-primary" ui-sref="macro-materia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="macroMateria.home.addLabel">Create new MacroMateria</span></button></div><div><form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container><input type="text" ng-model="vm.code" placeholder="Codice"></md-input-container><md-input-container><input type="text" ng-model="vm.description" placeholder="Descrizione"></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form></div><table class="table table-bordered"><thead><tr><th>Codice</th><th>Descrizione</th><th>Inizio validit\xE0</th><th>Fine validit\xE0</th><th></th></tr></thead><tbody><tr ng-repeat="macroMateria in vm.macroMateriaList track by $index" ng-class="{\'striped-row\': $index % 2 === 0}"><td>{{::macroMateria.code}}</td><td>{{::macroMateria.description}}</td><td>{{::macroMateria.validityStartDate | date:\'dd/MM/yy\'}}</td><td>{{::macroMateria.validityEndDate | date:\'dd/MM/yy\'}}</td><td><button type="submit" ui-sref="macro-materia.edit({id:macroMateria.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="macro-materia.delete({id:macroMateria.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/materia/materia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.materia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="materia.delete.question" translate-values="{code: \'{{vm.materia.code}}\'}">Are you sure you want to delete this materia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/materia/materia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" style="min-width: 500px"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMateriaLabel" data-translate="materia.home.createOrEditLabel">Create or edit a Materia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="materia.description" for="field_descrizione">descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.materia.description"></div><div class="form-group"><macro-materia-chip-search-component model="vm.materia.macroMateria" macro-materia-list="vm.macroMateriaList" max-chips="1" on-model-change="vm.macroMateriaChanged" show-end-date="true"></macro-materia-chip-search-component></div><div class="form-group"><label class="control-label" data-translate="materia.code" for="field_codice">codice</label><div style="display: flex; flex-direction: row"><span style="position: relative; top: 7px; font-size: 17px">{{vm.materia.macroMateria ? vm.materia.macroMateria.code + \'.\' : \'\'}}</span> <input type="number" class="form-control" name="codice" id="field_codice" ng-model="vm.materia.code" ng-disabled="!vm.materia.macroMateria"></div></div><div class="form-group" flex layout="row" layout-align="space-around"><div flex="50"><md-input-container><label data-translate="materia.validityStart">Inizio validit\xE0</label><md-datepicker ng-disabled="!vm.materia.macroMateria" md-min-date="vm.startMinDate" md-max-date="vm.startMaxDate" name="validityStartDate" id="field_validityStartDate" md-open-on-focus onkeydown="return false" ng-model="vm.materia.validityStartDate" ng-change="vm.startDateChanged()"></md-datepicker></md-input-container></div><div flex="50" layout="row"><md-input-container><label data-translate="materia.validityEnd">Fine validit\xE0</label><md-datepicker ng-disabled="!vm.materia.macroMateria" md-max-date="vm.endMaxDate" md-min-date="vm.endMinDate" name="validityEndDate" id="field_validityEndDate" md-open-on-focus onkeydown="return false" ng-model="vm.materia.validityEndDate"></md-datepicker></md-input-container><span ng-if="vm.materia.validityEndDate != null"><md-button ng-click="vm.materia.validityEndDate = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data fine validit\xE0</md-tooltip></md-button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.isFormValid()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/materia/materia.html','<h1 style="margin-bottom: 60px" class="not-sticky">Materie</h1><div id="atto-list-container"><div class="col-xs-4 col-md-2 no-padding-left"><button class="btn btn-primary" ui-sref="materia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="materia.home.addLabel">Create new Materia</span></button></div><div><form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container><input type="text" ng-model="vm.code" placeholder="Codice"></md-input-container><md-input-container><input type="text" ng-model="vm.description" placeholder="Descrizione"></md-input-container><md-input-container style="position: relative; top: -19px"><macro-materia-chip-search-component model="vm.macroMateriaSelected" macro-materia-list="vm.macroMateriaList" max-chips="1"></macro-materia-chip-search-component></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form></div><table class="table table-bordered"><thead><tr><th>Codice</th><th>Descrizione</th><th>Inizio validit\xE0</th><th>Fine validit\xE0</th><th>Macro Materia (Codice - Descrizione)</th><th></th></tr></thead><tbody><tr ng-repeat="materia in vm.materiaList track by $index" ng-class="{\'striped-row\': $index % 2 === 0}"><td>{{::materia.macroMateria.code}}.{{::materia.code}}</td><td>{{::materia.description}}</td><td>{{::materia.validityStartDate | date:\'dd/MM/yy\'}}</td><td>{{::materia.validityEndDate | date:\'dd/MM/yy\'}}</td><td>{{::materia.macroMateria.code}} - {{::materia.macroMateria.description}}<md-tooltip class="tooltip-multiline">Codice: {{::materia.macroMateria.code}}<br>Description: {{::materia.macroMateria.description}}<br>Inizio validit\xE0: {{::materia.macroMateria.validityStartDate | date:\'dd/MM/yy\'}}<br>Fine validit\xE0: {{::materia.macroMateria.validityEndDate | date:\'dd/MM/yy\'}}</md-tooltip></td><td><button type="submit" ui-sref="materia.edit({id:materia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="materia.delete({id:materia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div>');
$templateCache.put('app/entities/ordine-del-giorno/ordine-del-giorno-create.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="form-group" layout-padding><button type="submit" ui-sref="seduta({idOrg: vm.workingBody.id, typeOrg: vm.workingBody.tipoOrganismo, nome: vm.workingBody.nameOrg})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><h3 id="myOrdineDelGiornoLabel" data-translate="gestioneAttiApp.ordineDelGiorno.home.createLabel">Crea un Ordine del Giorno</h3><!-- TESTATA ODG --><div class="card" layout-padding layout-margin><h4 class="card-header">Testata ODG</h4><div class="card-body"><div layout="row"><!-- LEGISLATURA --><md-input-container flex="10"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input value="{{vm.seduta.legislatura | romanize}}" disabled="disabled"></md-input-container><!-- ANNO SEDUTA--><md-input-container flex="10"><label data-translate="gestioneAttiApp.seduta.annoSeduta"></label><input value="{{vm.seduta.annoSeduta}}" disabled="disabled"></md-input-container><!-- ORGANIZZATORE --><md-input-container flex="20"><label data-translate="gestioneAttiApp.seduta.organizzatore"></label><input value="{{vm.organizzatoreSeduta.nome}}" disabled="disabled"></md-input-container><!-- NUMERO SEDUTA --><md-input-container flex="10"><label data-translate="gestioneAttiApp.seduta.numeroSeduta"></label><input value="{{vm.organizzatoreSeduta.numeroSeduta}}" disabled="disabled"></md-input-container><!-- TIPO SEDUTA --><md-input-container flex="15"><label data-translate="gestioneAttiApp.seduta.tipoSeduta"></label><input value="{{vm.tipoSeduta}}" disabled="disabled"></md-input-container><!-- DATA CONVOCAZIONE --><md-input-container flex="20"><label data-translate="gestioneAttiApp.seduta.dataDiConvocazione"></label><md-datepicker md-open-on-focus ng-model="vm.seduta.dataDiConvocazione" disabled="disabled"></md-datepicker></md-input-container><!-- PROGRESSIVO ODG --><md-input-container flex="10"><label data-translate="gestioneAttiApp.ordineDelGiorno.progressivoODG"></label><input value="{{vm.odg.progressivoODG}}" disabled="disabled"></md-input-container></div><div layout="row"><!-- TIPO ODG --><md-input-container flex="20"><label data-translate="gestioneAttiApp.ordineDelGiorno.tipoODG">Tipo ODG</label><md-select name="tipoODG" class="form-select" placeholder="Tipo ODG" ng-model="vm.odg.tipoODG"><md-option value="P" data-translate="gestioneAttiApp.TipoODG.P"></md-option><md-option value="I" data-translate="gestioneAttiApp.TipoODG.I"></md-option></md-select></md-input-container><!-- OGGETTO ODG --><md-input-container flex="75"><label data-translate="gestioneAttiApp.ordineDelGiorno.oggettoODG">Oggetto ODG</label><input type="text" class="form-control" name="oggettoODG" id="field_oggettoODG" ng-model="vm.odg.oggettoODG"></md-input-container></div><md-button type="submit" class="btn btn-primary" ng-disabled="!vm.isFirstFormValid()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span><md-tooltip>Salva</md-tooltip></md-button></div></div><br><!-- DETTAGLIO ODG\r\n        <div class="card" layout-padding layout-margin ng-if="vm.dettaglioVisibile">\r\n            <h4 class="card-header">Dettaglio ODG</h4>\r\n            <div class="card-body">\r\n                    <md-button class="btn btn-primary" ui-sref="punto-odg-dialog({idSeduta: vm.seduta.id, idODG: vm.odg.id})" >\r\n                        <span class="glyphicon glyphicon-plus"></span>&nbsp;<span>Crea un nuovo Punto ODG</span>\r\n                    </md-button>  \r\n                </div>  \r\n            </div>\r\n        </div> --></div></form>');
$templateCache.put('app/entities/ordine-del-giorno/ordine-del-giorno-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ordineDelGiorno.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.ordineDelGiorno.delete.question" translate-values="{id: \'{{vm.ordineDelGiorno.id}}\'}">Are you sure you want to delete this Ordine Del Giorno?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ordine-del-giorno/ordine-del-giorno-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><md-sidenav style="width: 600px" class="md-sidenav-right" fullscreen md-component-id="esitoPublish" md-disable-backdrop="true" md-whiteframe="4"><md-toolbar class="md-theme-indigo"><h1 class="md-toolbar-tools">AGGIORNAMENTO ATTI</h1></md-toolbar><md-content layout-margin=""><ul style="list-style-type:disc"><li ng-style="{ color: esito.startsWith(\'NON AGGIORNATO\') ? \'red\' : \'auto\' }" ng-repeat="esito in vm.odg.esitoPubblicazione | orderBy track by $index">{{esito}}</li></ul><md-button ng-click="vm.toggleEsitoPublish()" class="md-accent">Chiudi</md-button></md-content></md-sidenav><div layout-padding><div><!-- HISTORY PANEL --><div><label class="label label-odg-{{vm.odg.statoCorrenteODG.statoODG}}">{{\'gestioneAttiApp.StatoODGType.\' + vm.odg.statoCorrenteODG.statoODG | translate}}</label>&nbsp; da {{::vm.odg.statoCorrenteODG.utenteStato}} il {{::vm.odg.statoCorrenteODG.dataStato| date: \'dd/MM/yyyy\'}}<md-button ng-if="::vm.odg.storicoStatoODG.length > 0" ng-click="vm.showStateHistory = !vm.showStateHistory" class="md-raised md-accent"><span class="glyphicon glyphicon-tasks"></span> <span data-translate="entity.action.history" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.history\'| translate}}</md-tooltip></md-button><md-button ng-if="vm.canSeeEditOdgButton()" ng-disabled="vm.editingMode || !vm.isOrganizzatore" ui-sref="ordine-del-giorno.edit({\r\n                            idSeduta:vm.seduta.id, \r\n                            idODG: vm.odg.id, \r\n                            idOrg: vm.workingBody.id, \r\n                            typeOrg : vm.workingBody.tipoOrganismo, \r\n                            nameOrg: vm.workingBody.nome})" class="md-raised md-warn" aria-label="edit"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.edit\'| translate}}</md-tooltip></md-button><md-button ng-if="::vm.odg.esitoPubblicazione.length > 0" ng-click="vm.toggleEsitoPublish()" class="md-raised md-accent"><span class="glyphicon glyphicon-tasks"></span> <span data-translate="entity.action.esitoPubblicazione" class="hidden-sm hidden-xs"></span><md-tooltip>Esito Pubblicazione</md-tooltip></md-button></div><div ng-if="::vm.odg.storicoStatoODG.length > 0 && vm.showStateHistory" class="animate-show-hide" ng-show="vm.showStateHistory"><div ng-repeat="state in ::vm.odg.storicoStatoODG track by $index"><label class="label" ng-class="::{\r\n                            \'label-primary\' : state.statoODG !== vm.odg.statoCorrenteODG.statoODG,\r\n                            \'label-danger\' : state.statoODG === vm.odg.statoCorrenteODG.statoODG\r\n                            }">{{\'gestioneAttiApp.StatoODGType.\' + state.statoODG | translate}}</label>&nbsp; <span ng-if="::state.utenteStato.length > 0">da {{::state.utenteStato}} </span>il {{::state.dataStato| date: \'dd/MM/yyyy\'}}</div></div></div><h3 id="myOrdineDelGiornoLabel">Ordine del giorno</h3><!-- TESTATA ODG --><div class="card" layout-padding layout-margin><h4 class="card-header">Testata ODG</h4><div class="card-body"><div layout="row"><!-- LEGISLATURA --><md-input-container style="width: 100px"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input value="{{vm.seduta.legislatura | romanize}}" disabled="disabled"></md-input-container><!-- ANNO SEDUTA--><md-input-container style="width: 100px"><label data-translate="gestioneAttiApp.seduta.annoSeduta"></label><input value="{{vm.seduta.annoSeduta}}" disabled="disabled"></md-input-container><!-- ORGANIZZATORE --><md-input-container style="width: 170px"><label data-translate="gestioneAttiApp.seduta.organizzatore"></label><input value="{{vm.organizzatoreSeduta.nome}}" disabled="disabled"></md-input-container><!-- NUMERO SEDUTA --><md-input-container><label data-translate="gestioneAttiApp.seduta.numeroSeduta"></label><input value="{{vm.organizzatoreSeduta.numeroSeduta}}" disabled="disabled"></md-input-container><!-- TIPO SEDUTA --><md-input-container><label data-translate="gestioneAttiApp.seduta.tipoSeduta"></label><input value="{{vm.tipoSeduta}}" disabled="disabled"></md-input-container><!-- PROGRESSIVO ODG --><md-input-container><label data-translate="gestioneAttiApp.ordineDelGiorno.progressivoODG"></label><input value="{{vm.odg.progressivoODG}}" disabled="disabled"></md-input-container><!-- DATA CONVOCAZIONE --><md-input-container style="width: 250px"><label data-translate="gestioneAttiApp.seduta.dataDiConvocazione"></label><input md-open-on-focus datetime-picker="{{vm.dateformat}}" ng-model="vm.seduta.dataDiConvocazione" disabled="disabled"></md-input-container><!-- STATO CORRENTE ODG --><md-input-container style="width: 200px"><label data-translate="gestioneAttiApp.ordineDelGiorno.statoCorrenteODG">Stato Corrente ODG</label><md-select name="statoCorrenteODG" ng-model="vm.odg.statoCorrenteODG.statoODG" disabled="disabled"><md-option value="A" data-translate="gestioneAttiApp.StatoODGType.A"></md-option><md-option value="P" data-translate="gestioneAttiApp.StatoODGType.P"></md-option><md-option value="X" data-translate="gestioneAttiApp.StatoODGType.X"></md-option></md-select></md-input-container></div><div layout="row"><!-- TIPO ODG --><md-input-container style="width: 200px"><label data-translate="gestioneAttiApp.ordineDelGiorno.tipoODG">Tipo ODG</label><md-select name="tipoODG" class="form-select" placeholder="Tipo ODG" ng-model="vm.odg.tipoODG" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\' || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.seduta.statoCorrente.statoSeduta === \'PAT\'"><md-option value="P" data-translate="gestioneAttiApp.TipoODG.P"></md-option><md-option value="I" data-translate="gestioneAttiApp.TipoODG.I"></md-option></md-select></md-input-container><!-- OGGETTO ODG --><md-input-container flex><label data-translate="gestioneAttiApp.ordineDelGiorno.oggettoODG">Oggetto ODG</label><input type="text" class="form-control" name="oggettoODG" id="field_oggettoODG" ng-model="vm.odg.oggettoODG" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\' || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.seduta.statoCorrente.statoSeduta === \'PAT\'"></md-input-container></div></div><div class="panel-footer" ng-if="true"><seduta-document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" document-types="::vm.docTypes" editable="vm.isAdmin || (vm.editingMode && vm.isOrganizzatore && vm.odg.statoCorrenteODG.statoODG === \'A\')" public-view="true" seduta="::vm.seduta" ordine-del-giorno="vm.odg" user="::vm.utente"></seduta-document-toolbar></div></div><br><!-- DETTAGLIO ODG --><div class="card" layout-padding layout-margin><h4 class="card-header">Dettaglio ODG</h4><div class="card-body"><div class="table-responsive"><!-- PUNTI ODG --><table mat-table class="jh-table table table-striped"><thead><tr><th><span>Prog</span></th><th><span>Tipo Punto ODG</span></th><th><span>Atto Collegato</span></th><th><span>Testo Punto ODG</span></th><th><span>Tipo Espressione Richiesta</span></th><th><span>Esito Punto ODG</span></th><th><span>Descrizione Esito Punto ODG</span></th><th></th></tr></thead><tbody><tr ng-repeat="puntoODG in vm.puntiODG | orderBy: \'progressivoPuntoODG\' track by $index" ng-class="vm.isDuplicateProgressive($index) ? \'danger\' : \'\'"><td><a ui-sref="punto-odg-detail({idPODG:puntoODG.id})"></a>{{puntoODG.progressivoPuntoODG}}</td><td data-translate="{{\'gestioneAttiApp.TipoPuntoODG.\' + puntoODG.tipoPuntoODG}}">{{puntoODG.tipoPuntoODG}}</td><td><a ui-sref="atto-detail({id:puntoODG.atto.id})">{{puntoODG.atto.tipoAtto}} {{puntoODG.atto.numeroAtto}}</a></td><td>{{puntoODG.testoPuntoODG}}</td><!-- Modifica per PEL e DEA - Il parere referente diventa Parere Obbligatorio Commissione --><td ng-if="puntoODG.tipoEspressioneRichiesta !== \'PARERE_REF\' || (puntoODG.atto.tipoAtto !== \'PEL\' && puntoODG.atto.tipoAtto !== \'DEA\')" data-translate="{{\'gestioneAttiApp.EspressioneRichiesta.\' + puntoODG.tipoEspressioneRichiesta}}">{{puntoODG.tipoEspressioneRichiesta}}</td><td ng-if="puntoODG.tipoEspressioneRichiesta === \'PARERE_REF\' && (puntoODG.atto.tipoAtto === \'PEL\' || puntoODG.atto.tipoAtto === \'DEA\')" data-translate="{{\'gestioneAttiApp.EspressioneRichiesta.PARERE_OBB_COM\'}}">{{puntoODG.tipoEspressioneRichiesta}}</td><td data-translate="{{\'gestioneAttiApp.EsitoPuntoODG.\' + puntoODG.esitoPuntoODG}}">{{puntoODG.esitoPuntoODG}}</td><td>{{puntoODG.descrizioneEsitoPuntoODG}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder(-1, $index)" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\' || vm.seduta.statoCorrente.statoSeduta === \'P\'"><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span><md-tooltip>Sposta sopra</md-tooltip></md-button><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder(1, $index)" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\' || vm.seduta.statoCorrente.statoSeduta === \'P\'"><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span><md-tooltip>Sposta sotto</md-tooltip></md-button><md-button aria-label="detailPuntoODG" class="btn btn-info btn-sm" ui-sref="punto-odg-detail({\r\n                                                idPODG: puntoODG.id,\r\n                                                idAttoCollegato: puntoODG.idAtto,\r\n                                                idODG: vm.odg.id, \r\n                                                idSeduta: vm.seduta.id,\r\n                                                idOrg: vm.workingBody.id,\r\n                                                typeOrg : vm.workingBody.tipoOrganismo, \r\n                                                nameOrg: vm.workingBody.nome,\r\n                                                editODG: vm.editingMode})"><span class="glyphicon glyphicon-eye-open"></span></md-button><md-button aria-label="editPuntoODG" class="btn btn-primary btn-sm" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG === \'X\' || vm.seduta.statoCorrente.statoSeduta === \'P\' || \r\n                                                (vm.odg.statoCorrenteODG.statoODG === \'P\' && puntoODG.tipoPuntoODG === \'SE\')" ui-sref="punto-odg-detail.edit({\r\n                                                idPODG: puntoODG.id, \r\n                                                idAttoCollegato: puntoODG.idAtto,\r\n                                                idODG: vm.odg.id, \r\n                                                idSeduta: vm.seduta.id,\r\n                                                idOrg: vm.workingBody.id,\r\n                                                typeOrg : vm.workingBody.tipoOrganismo, \r\n                                                nameOrg: vm.workingBody.nome})"><span class="glyphicon glyphicon-pencil"></span></md-button><md-button ui-sref="punto-odg-dialog.delete({idPODG: puntoODG.id, idODG: vm.odg.id})" aria-label="deletePuntoODG" class="btn btn-danger btn-sm" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\' || vm.seduta.statoCorrente.statoSeduta === \'PAT\' || vm.seduta.statoCorrente.statoSeduta === \'P\'"><span class="glyphicon glyphicon-remove-circle"></span></md-button></div></td></tr></tbody></table></div><div layout="row"><!-- COPIA PUNTI ODG --><md-button type="button" aria-label="copy" class="btn btn-warning" ng-if="vm.puntiODG && vm.puntiODG.length > 0" ui-sref="punto-odg-dialog.copy({idSeduta: vm.seduta.id, idODG: vm.odg.id, numeroSeduta: vm.organizzatoreSeduta.numeroSeduta})"><span class="glyphicon glyphicon-book"></span> <span class="hidden-sm-down">Copia i Punti ODG</span></md-button><!-- CREA NUOVO PUNTO ODG --><md-button class="btn btn-primary" ui-sref="punto-odg-dialog({\r\n                        idSeduta: vm.seduta.id, \r\n                        idODG: vm.odg.id, \r\n                        idOrg: vm.workingBody.id,\r\n                        typeOrg : vm.workingBody.tipoOrganismo, \r\n                        nameOrg: vm.workingBody.nome})" ng-disabled="!vm.editingMode || !vm.isOrganizzatore || vm.odg.statoCorrenteODG.statoODG !== \'A\'  || vm.seduta.statoCorrente.statoSeduta === \'PAT\' || vm.seduta.statoCorrente.statoSeduta === \'P\'"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span>Crea un nuovo Punto ODG</span></md-button></div></div></div><button type="submit" aria-label="previousState" ui-sref="seduta({idOrg: vm.workingBody.id, typeOrg : vm.workingBody.tipoOrganismo, nameOrg: vm.workingBody.nome})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><div class="padded-bottom-70"></div><!-- ACTION BUTTONS --><div class="bottom-sheet-demo inset action-button-fixed-bottom hide-sm hide-xs show-gt-sm" layout="row" layout-xs="column" layout-align="center"><div class="md-button-group"><md-button ng-repeat="button in vm.visibleButtons" ng-click="vm.performButtonAction(button)" ng-if="vm.editingMode && vm.isOrganizzatore && vm.seduta.statoCorrente.statoSeduta === \'A\'" ng-disabled="vm.isSaving" ng-class="::{\'md-primary\' : $index % 2 === 0, \'md-accent\' : $index % 2 !== 0}" class="md-raised"><md-tooltip md-direction="top">{{::button.title| translate}}</md-tooltip><span class="glyphicon {{::button.iconClass|| \'glyphicon-floppy-disk\'}}"></span> <span data-translate="{{::button.title}}" layout-wrap></span></md-button><md-button ng-if="vm.editingMode && vm.isOrganizzatore && vm.seduta.statoCorrente.statoSeduta === \'A\'" class="md-raised md-primary" ng-disabled="vm.isSaving" ng-click="vm.save()"><md-tooltip>{{\'entity.action.save\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.save"></span></md-button></div></div></div></form>');
$templateCache.put('app/entities/persona/persona-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.persona.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.persona.delete.question" translate-values="{id: \'{{vm.persona.id}}\'}">Are you sure you want to delete this Persona?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/persona/persona-detail.html','<div><h2><span data-translate="gestioneAttiApp.persona.detail.title">Persona</span> {{vm.persona.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.persona.nome">Nome</span></dt><dd><span>{{vm.persona.nome}}</span></dd><dt><span data-translate="gestioneAttiApp.persona.cognome">Cognome</span></dt><dd><span>{{vm.persona.cognome}}</span></dd><dt><span data-translate="gestioneAttiApp.persona.ruolo">Ruolo</span></dt><dd><span data-translate="{{\'gestioneAttiApp.RuoloPersona.\' + vm.persona.ruolo}}">{{vm.persona.ruolo}}</span></dd><dt><span data-translate="gestioneAttiApp.persona.anagrafica">Anagrafica Protocollo</span></dt><dd><span>{{vm.persona.anagraficaProtocollo.anagraficCode + \' - \' + vm.persona.anagraficaProtocollo.anagraficDescription}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="persona-detail.edit({id:vm.persona.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/persona/persona-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPersonaLabel" data-translate="gestioneAttiApp.persona.home.createOrEditLabel">Create or edit a Persona</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.persona.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.persona.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.persona.anagrafica">Anagrafica</label><md-autocomplete aria-label="anagraficaProtocollo" md-no-cache="true" md-selected-item="vm.selectedItem" md-search-text="vm.searchText" md-selected-item-change="vm.setAnagrafic(item)" md-items="item in vm.searchAnagrafics(vm.searchText)" md-min-length="2" md-delay="400" md-dropdown-position="bottom" md-clear-button="false" md-search-text-change="vm.persona.anagraficaProtocollo = null" md-item-text="vm.getDisplayName(item)" placeholder="{{\'gestioneAttiApp.persona.codAnagrafica\' | translate}}"><md-item-template><span class="item-title"><span>{{vm.getDisplayName(item)}}</span></span></md-item-template></md-autocomplete></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.persona.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.persona.nome"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.persona.cognome" for="field_cognome">Cognome</label><input type="text" class="form-control" name="cognome" id="field_cognome" ng-model="vm.persona.cognome"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.persona.ruolo" for="field_ruolo">Ruolo</label><select class="form-control" name="ruolo" ng-model="vm.persona.ruolo" id="field_ruolo"><option value="ASSESSORE" data-translate="gestioneAttiApp.RuoloPersona.ASSESSORE">ASSESSORE</option><option value="CONSIGLIERE" data-translate="gestioneAttiApp.RuoloPersona.CONSIGLIERE">CONSIGLIERE</option><option value="PRESIDENTE" data-translate="gestioneAttiApp.RuoloPersona.PRESIDENTE">PRESIDENTE</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/persona/personas.html','<div class="md-whiteframe-5dp"><div class="container-fluid"><h2 data-translate="gestioneAttiApp.persona.home.title">Personas</h2><jhi-alert></jhi-alert><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="persona.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.persona.home.createLabel">Create new Persona</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.persona.nome">Nome</span></th><th><span data-translate="gestioneAttiApp.persona.cognome">Cognome</span></th><th><span data-translate="gestioneAttiApp.persona.ruolo">Ruolo</span></th><th><span data-translate="gestioneAttiApp.persona.anagrafica">Anagrafica Protocollo</span></th><th></th></tr></thead><tbody><tr ng-repeat="persona in vm.personas track by persona.id"><td><a ui-sref="persona-detail({id:persona.id})">{{persona.id}}</a></td><td>{{persona.nome}}</td><td>{{persona.cognome}}</td><td data-translate="{{\'gestioneAttiApp.RuoloPersona.\' + persona.ruolo}}">{{persona.ruolo}}</td><td>{{persona.anagraficaProtocollo.anagraficCode + \' - \' + persona.anagraficaProtocollo.anagraficDescription}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="persona-detail({id:persona.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="persona.edit({id:persona.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="persona.delete({id:persona.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/punto-odg/punto-odg-copy-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><p style="text-align: center; font-size: 125%"><strong>{{vm.title}}</strong></p><div style="text-align: center; font-size: 125%" layout-align="center start"><md-button layout-sm="column" aria-label="copy" class="md-raised" ng-click="vm.copyRichTextToClipboard(vm.richTextToCopy)" ng-if="vm.puntiODG && vm.puntiODG.length > 0">Copia il Dettaglio dell\'Ordine del Giorno <span class="glyphicon glyphicon-book"></span></md-button></div><!-- <div flex="grow" layout="column">\r\n            <div>\r\n                <div ng-repeat="line in vm.textToCopy">\r\n                    <p ng-if="line.attachedActUrl"><a href="{{line.attachedActUrl}}">{{line.text}}</a></p>\r\n                    <p ng-if="!line.attachedActUrl">{{line.text}}</p>\r\n                </div>\r\n            </div>\r\n        </div>    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back">Indietro</span></button></div></form>');
$templateCache.put('app/entities/punto-odg/punto-odg-delete-dialog.html','<form name="copyForm" ng-submit="vm.confirmDelete(vm.idPuntoODG)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.puntoODG.delete.question" translate-values="{id: \'{{vm.idPuntoODG}}\'}">Are you sure you want to delete this Punto ODG?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/punto-odg/punto-odg-dialog.html','<md-dialog-content style="padding: 50px"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">{{vm.title}}</h3></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><h4 ng-if="!vm.puntoODG.id">Seleziona un Atto collegato oppure compila i campi necessari</h4><br><!-- ATTO COLLEGATO --><div class="form-row" ng-if="vm.canEdit() && vm.seduta.statoCorrente.statoSeduta !== \'P\' && vm.odg.statoCorrenteODG.statoODG === \'A\'"><!-- Ricerca Atto --><form name="attachedActForm" layout="column"><div layout="row"><!--Tipo Atto --><md-input-container><label>Tipo Atto</label><md-select ng-model="vm.basicSearchType" ng-change="vm.getAllActs()" placeholder="Seleziona Tipo Atto"><md-option></md-option><md-option ng-repeat="item in ::vm.actsTypeSelection track by item.value" value="{{::item.value}}">{{::item.name|translate}}</md-option></md-select></md-input-container><!--Numero Atto --><md-chips flex ng-model="vm.attachedActsModel" md-on-add="vm.completeFormByAct($chip)" md-on-remove="vm.clearForm()" md-transform-chip="vm.transformChip($chip)" ng-class="{\'md-focused\': false}" ng-show="vm.basicSearchType" md-max-chips="1"><md-autocomplete md-selected-item="vm.selectedAtto" md-search-text="vm.numeroAttoSearchText" md-items="item in vm.searchActs(vm.numeroAttoSearchText)" md-item-text="item.numeroAtto" md-no-cache="true" placeholder="Numero atto"><span md-highlight-text="vm.selectedAttoSearchText">[{{item.legislatura | romanize}}][{{item.tipoAtto}}] {{item.numeroAtto}}:{{item.titolo}}</span></md-autocomplete><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span>[{{$chip.legislatura | romanize}}]<b>[{{$chip.tipoAtto}}]</b> {{$chip.numeroAtto}}: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div></form></div><!-- Atto Collegato --><div ng-if="vm.puntoODG.idAtto && !vm.canEdit()" class="form-row" layout="row"><div layout="column"><md-input-container style="width: 200px"><label>Tipo Atto Collegato</label><input value="{{vm.attoCollegato.tipoAtto}}" disabled="disabled"></md-input-container></div><div layout="column"><md-input-container style="width: 200px"><label>Numero Atto Collegato</label><input value="{{vm.attoCollegato.numeroAtto}}" disabled="disabled"></md-input-container></div></div><div><!-- TESTO PUNTO ODG --><div class="form-row" flex="grow" layout="column"><md-input-container><label class="control-label">Testo Punto ODG</label><textarea class="form-control" type="text" ng-model="vm.puntoODG.testoPuntoODG" ng-disabled="!vm.canEdit() || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.odg.statoCorrenteODG.statoODG !== \'A\'"></textarea></md-input-container></div></div><div class="form-row" layout="column"><div flex=""><!-- TIPO ESPRESSIONE RICHIESTA --><md-input-container><label class="control-label">Tipo Espressione Richiesta</label><md-select class="form-control" ng-model="vm.puntoODG.tipoEspressioneRichiesta" ng-disabled="!vm.canEdit() || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.odg.statoCorrenteODG.statoODG !== \'A\'"><md-option></md-option><!-- PEL e DEA - Parere referente diventa Parere Obbligatorio commissioni solo nella label, la chiave rimane PARERE_REF --><md-option ng-if="vm.basicSearchType !== \'PEL\' && vm.basicSearchType !== \'DEA\'" value="PARERE_REF" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_REF"></md-option><md-option ng-if="vm.basicSearchType === \'PEL\' || vm.basicSearchType === \'DEA\'" value="PARERE_REF" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_OBB_COM"></md-option><md-option value="PARERE_REF_CONG" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_REF_CONG"></md-option><md-option value="PARERE_SEC" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_SEC"></md-option><md-option value="PARERE_MER" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_MER"></md-option><md-option value="PARERE_IST" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_IST"></md-option><md-option value="PARERE_OBB" data-translate="gestioneAttiApp.EspressioneRichiesta.PARERE_OBB"></md-option><md-option value="OSSERVAZIONI" data-translate="gestioneAttiApp.EspressioneRichiesta.OSSERVAZIONI"></md-option></md-select></md-input-container></div><div flex=""><!-- TIPO PUNTO ODG --><md-input-container><label class="control-label">Tipo Punto ODG</label><md-select class="form-control" ng-model="vm.puntoODG.tipoPuntoODG" ng-disabled="!vm.canEdit() || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.odg.statoCorrenteODG.statoODG !== \'A\'"><md-option></md-option><md-option value="E" data-translate="gestioneAttiApp.TipoPuntoODG.E"></md-option><md-option value="SE" data-translate="gestioneAttiApp.TipoPuntoODG.SE"></md-option></md-select></md-input-container></div></div><!-- NON VALORIZZABILI IN FASE DI INSERIMENTO, MA SOLO DOPO LA PUBBLICAZIONE DELL\'ODG--><div ng-if="vm.canEdit() && vm.odg.statoCorrenteODG.statoODG === \'P\' && vm.hasEsito()" layout="column"><!-- ESITO --><div class="form-row" layout="row"><md-input-container><label class="control-label">Esito Punto ODG</label><md-select class="form-control" name="esitoPuntoODG" ng-model="vm.puntoODG.esitoPuntoODG" id="field_esitoPuntoODG"><md-option></md-option><md-option value="RINV" data-translate="gestioneAttiApp.EsitoPuntoODG.RINV"></md-option><md-option value="SVOLTA_ILL_E_RINV" data-translate="gestioneAttiApp.EsitoPuntoODG.SVOLTA_ILL_E_RINV"></md-option><md-option value="PARERE_FAV_MAGG" data-translate="gestioneAttiApp.EsitoPuntoODG.PARERE_FAV_MAGG"></md-option><md-option value="PARERE_FAV_UNAN" data-translate="gestioneAttiApp.EsitoPuntoODG.PARERE_FAV_UNAN"></md-option><md-option value="PARERE_CONTR_MAGG" data-translate="gestioneAttiApp.EsitoPuntoODG.PARERE_CONTR_MAGG"></md-option><md-option value="PARERE_CONTR_UNAN" data-translate="gestioneAttiApp.EsitoPuntoODG.PARERE_CONTR_UNAN"></md-option><md-option value="SVOLTA_AUDIZ" data-translate="gestioneAttiApp.EsitoPuntoODG.SVOLTA_AUDIZ"></md-option><md-option value="SVOLTO" data-translate="gestioneAttiApp.EsitoPuntoODG.SVOLTO"></md-option><md-option value="ELIMINATO" data-translate="gestioneAttiApp.EsitoPuntoODG.ELIMINATO"></md-option></md-select></md-input-container></div><!-- DESCRIZIONE ESITO --><div class="form-row" layout="row"><md-input-container flex="grow"><label class="control-label">Descrizione Esito Punto ODG</label><input type="text" class="form-control" name="descrizioneEsitoPuntoODG" id="field_descrizioneEsitoPuntoODG" ng-model="vm.puntoODG.descrizioneEsitoPuntoODG"></md-input-container></div></div></div><div class="modal-footer"><md-button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back">Back</span></md-button><md-button type="submit" ng-if="vm.seduta.statoCorrente.statoSeduta === \'A\'" class="btn btn-primary" ng-click="vm.save()" ng-disabled="!vm.isFormValid() || vm.isSaving || !vm.canEdit() || vm.seduta.statoCorrente.statoSeduta === \'P\' || vm.odg.statoCorrenteODG.statoODG === \'X\'"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></md-button></div></form></md-dialog-content>');
$templateCache.put('app/entities/registrazione-utente/cancellazione-registrazione-utente.html','<div ng-if="vm.registrationId && vm.attoType && vm.attoId" class="text-center"><div ng-if="!vm.loadingDettaglioRegistrazione"><div ng-if="vm.dettaglioRegistrazione"><div style="margin-top: 40px" ng-if="vm.dettaglioRegistrazione.attoId"><div><h3>Confermi di non voler ricevere le notifiche per email in merito alla {{vm.attoTypeName | translate}} numero {{vm.attoNumber}}?</h3><span>Confermando non riceverai pi\xF9 notifiche solamente in merito a questo preciso atto!</span></div><div style="margin-top: 25px"><md-button ng-click="vm.onConfirmClickIdAtto()" ng-disabled="vm.idAttoButtonClicked" class="md-raised md-primary">Conferma</md-button></div></div><div style="margin-top: 80px" ng-if="vm.dettaglioRegistrazione.tipoAttoList"><div><h3>Confermi di non voler ricevere le notifiche via email di tutti gli atti di tipologia {{vm.attoTypeName | translate}}?</h3><span>Confermando non riceverai pi\xF9 notifiche in merito a tutte le {{vm.attoTypeName | translate}}! Attenzione: continuerai a ricevere le notifiche in merito alle singole registrazioni effettuate sulle altre {{vm.attoTypeName | translate}}!</span></div><div style="margin-top: 25px"><md-button ng-click="vm.onConfirmClickTipoAtto()" ng-disabled="vm.tipoAttoButtonClicked" class="md-raised md-primary">Conferma</md-button></div></div></div><div ng-if="!vm.dettaglioRegistrazione"><span><b>Impossibile eliminare la registrazione: Nessuna registrazione trovata.</b></span></div></div><div ng-if="vm.loadingDettaglioRegistrazione"><loading-spinner-component></loading-spinner-component></div></div><div ng-if="!vm.registrationId || !vm.attoType" class="text-center"><span style="font-weight: bold">Impossibile cancellare la registrazione alle notifiche: identificativo registrazione o tipo di atto mancante. La preghiamo di riprovare.</span></div>');
$templateCache.put('app/entities/registrazione-utente/registrazione-utente-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title" id="registrazioneUtenteLabel">{{\'gestioneAttiApp.registrazioneUtente.home.createLabel\' | translate}} per <span style="color: #c7030a">{{ vm.attoTypeName | translate}} N\xB0 {{vm.atto.numeroAtto}}</span></h3><div><br><span><b>ATTENZIONE: </b></span><span data-translate="gestioneAttiApp.registrazioneUtente.warning"></span></div></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.registrazioneUtente.mail">Email</label><input type="email" class="form-control" name="email" ng-model="vm.mail" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/registrazione-utente/registrazione-utente.html','<div class="text-center" style="margin-top: 40px"><h1 style="margin-bottom: 60px" class="not-sticky">Registrati alle Notifiche</h1><div class="form-group"><md-input-container><label>Inserisci la tua mail</label><input type="text" name="mail" ng-model="vm.mail" required></md-input-container></div><!-- Inserimento nuovo tipo atto da aggiungere alle notifiche --><div class="form-group" ng-if="vm.mail"><h4>Seleziona un tipo di atto per rimanere aggiornato via email</h4><div style="margin-top: 30px"><div><b>ATTENZIONE:</b></div><span>una volta confermato inizierai a ricevere tutte le notifiche inerenti alla tipologia di atto selezionata! Sar\xE0 sempre possibile disiscriversi tramite un apposito link presente in tutte le email che ti saranno inviate!</span></div><!-- Selezionare tipo atto da aggiungere alle notifiche --><md-input-container><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.selectedTipoAtto" placeholder="Seleziona un tipo atto" multiple="multiple"><md-option ng-repeat="item in ::vm.actTypesPublished track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container><div layout-align="end center" ng-if="vm.selectedTipoAtto" ng-click="vm.save()"><md-button ng-click="vm.saveConfig()" class="md-raised md-primary" ng-disabled="vm.isSavingConfig"><span class="glyphicon glyphicon-floppy-disk"></span> <span layout-wrap>CONFERMA</span></md-button></div></div></div>');
$templateCache.put('app/entities/seduta/basicSedutaSearchForm.html','<form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container ng-class="{\'rotella-burger-open\': vm.navbarState.burgerOpen}"><!-- <i  class="glyphicon glyphicon-cog advanced-search-toggler"></i> --> <span style="top: 5px; position: relative" class="hidden-xs">Ricerca Sedute</span></md-input-container><md-input-container style="min-width: 82px"><label data-translate="gestioneAttiApp.atto.legislatura"></label><md-select ng-model="vm.legislatura" ng-change="vm.transition(true)" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}"><md-option ng-repeat="legislatura in vm.legislatureOrganismo" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container><label data-translate="gestioneAttiApp.seduta.anno"></label><md-select ng-model="vm.anno" ng-change="vm.transition(true)" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.seduta.anno\'| translate}}"><md-option ng-value=""></md-option><md-option ng-repeat="anno in vm.years" value="{{anno}}">{{anno}}</md-option></md-select></md-input-container><md-input-container flex="5"><label style="overflow: visible">Num. Da</label><input type="text" ng-change="vm.transition(true)" ng-model="vm.minNum"></md-input-container><md-input-container flex="5"><label style="overflow: visible">Num. A</label><input type="text" ng-change="vm.transition(true)" ng-model="vm.maxNum"></md-input-container><!-- <md-input-container>\r\n            <label data-translate="gestioneAttiApp.atto.ricercaStato"></label>\r\n            <md-select ng-model="vm.basicSearchState" ng-change="vm.transition(true)" placeholder="{{\'gestioneAttiApp.atto.ricercaStato\'| translate}}">\r\n                <md-option></md-option>\r\n                <md-option ng-repeat="item in ::vm.queryStates track by item.value" value="{{::item.value}}">{{item.name|\r\n                    translate}}</md-option>\r\n            </md-select>\r\n        </md-input-container> --><div layout="row" flex="10"><md-input-container class="md-block" flex-gt-sm><label style="overflow: visible">Data Conv. Da</label><md-datepicker ng-change="vm.transition(true)" md-hide-icons="calendar" md-open-on-focus onkeydown="return false" ng-model="vm.minDataConv"></md-datepicker></md-input-container><span ng-if="vm.minDataConv"><md-button ng-click="vm.clearMinDataConvocazione()" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><div layout="row" flex="10"><md-input-container class="md-block" flex-gt-sm><label style="overflow: visible">Data Conv. A</label><md-datepicker ng-change="vm.transition(true)" md-hide-icons="calendar" md-open-on-focus onkeydown="return false" ng-model="vm.maxDataConv"></md-datepicker></md-input-container><span ng-if="vm.maxDataConv"><md-button ng-click="vm.clearMaxDataConvocazione()" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div><md-input-container flex><input type="text" ng-model="vm.testoOdg" placeholder="{{\'gestioneAttiApp.seduta.ricercaSegnaposto\'| translate}}"></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form>');
$templateCache.put('app/entities/seduta/seduta-copy-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><p style="text-align: center; font-size: 125%"><strong>{{vm.title}}</strong></p><div style="text-align: center; font-size: 125%" layout-align="center start"><md-button layout-sm="column" aria-label="copy" class="md-raised" ng-click="vm.copyRichTextToClipboard(vm.richTextToCopy)" ng-if="vm.puntiODG && vm.puntiODG.length > 0">Copia il Dettaglio degli affari trattati <span class="glyphicon glyphicon-book"></span></md-button></div><!-- <div flex="grow" layout="column">\r\n            <div>\r\n                <table style="border: thin solid black">\r\n                    <tr ng-repeat="line in vm.textToCopy" ng-if="line.esito.trim().length > 0">\r\n                        <td style="border: thin solid black; padding-left: 1em;" ng-if="line.attachedActUrl"><a href="{{line.attachedActUrl}}">{{line.text}}</a></td>\r\n                        <td style="border: thin solid black; padding-left: 1em;" ng-if="!line.attachedActUrl">{{line.text}}</td>\r\n                        <td style="border: thin solid black; padding-left: 1em;">{{line.esito}}</td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n        </div>    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back">Indietro</span></button></div></form>');
$templateCache.put('app/entities/seduta/seduta-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.seduta.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.seduta.delete.question" translate-values="{id: \'{{vm.seduta.id}}\'}">Are you sure you want to delete this Seduta?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/seduta/seduta-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.saveSeduta()"><div><h2><span data-translate="gestioneAttiApp.seduta.detail.title">Seduta</span> {{vm.seduta.numeroSeduta}} <span>- Leg. {{vm.seduta.legislatura | romanize}} - </span><span>{{vm.workingBody.nome}}</span></h2><hr><jhi-alert-error></jhi-alert-error><md-sidenav style="width: 600px" class="md-sidenav-right" fullscreen md-component-id="sedutaEsitoPublish" md-disable-backdrop="true" md-whiteframe="4"><md-toolbar class="md-theme-indigo"><h1 class="md-toolbar-tools">AGGIORNAMENTO ATTI</h1></md-toolbar><md-content layout-margin=""><ul style="list-style-type:disc"><li ng-style="{ color: esito.startsWith(\'NON AGGIORNATO\') ? \'red\' : \'auto\' }" ng-repeat="esito in vm.seduta.esitoPubblicazione | orderBy track by $index">{{esito}}</li></ul><md-button ng-click="vm.toggleEsitoPublish()" class="md-accent">Chiudi</md-button></md-content></md-sidenav><div><div><label class="label label-seduta-{{vm.seduta.statoCorrente.statoSeduta}}">{{\'gestioneAttiApp.StatoSeduta.\' + vm.seduta.statoCorrente.statoSeduta | translate}}</label>&nbsp; da {{::vm.seduta.statoCorrente.utenteStato}} il {{::vm.seduta.statoCorrente.dataStato| date: \'dd/MM/yyyy\'}}<md-button ng-if="::vm.seduta.storicoStato.length > 0" ng-click="vm.showStateHistory = !vm.showStateHistory" class="md-raised md-accent"><span class="glyphicon glyphicon-tasks"></span> <span data-translate="entity.action.history" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.history\'| translate}}</md-tooltip></md-button><md-button ui-sref="seduta-detail.edit({id: vm.seduta.id})" ng-click="vm.prepareEditing()" ng-if="vm.canSeeEditButton(vm.seduta)" class="md-raised md-warn" aria-label="edit"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.edit\'| translate}}</md-tooltip></md-button><md-button ng-click="vm.prepareNumberEditing()" ng-if="vm.canSeeEditNumberButton(vm.seduta)" class="md-raised md-warn"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.editSedutaNumber" class="hidden-sm hidden-xs"></span><md-tooltip>{{\'entity.action.editSedutaNumber\'| translate}}</md-tooltip></md-button><!-- COPIA PUNTI AFFARI TRATTATI --><md-button type="button" aria-label="copy" class="btn btn-warning" ng-if="vm.ordiniDelGiorno && vm.ordiniDelGiorno.length > 0" ui-sref="seduta-detail.copy({idSeduta: vm.seduta.id, numeroSeduta: vm.seduta.numeroSeduta, seduta : vm.seduta})"><span class="glyphicon glyphicon-book"></span> <span class="hidden-sm-down">Elenco Affari Trattati</span></md-button><!-- GENERAZIONE REPORT AFFARI TRATTATI --><md-button type="button" aria-label="report" class="btn btn-info" ng-if="vm.ordiniDelGiorno && vm.ordiniDelGiorno.length > 0" ng-click="vm.generateAffariTrattatiPDFReport()"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm-down">Genera Report Affari Trattati</span></md-button><md-button ng-if="vm.seduta.esitoPubblicazione.length > 0" ng-click="vm.toggleEsitoPublish()" class="md-raised md-accent"><span class="glyphicon glyphicon-tasks"></span> <span data-translate="entity.action.esitoPubblicazione" class="hidden-sm hidden-xs"></span><md-tooltip>Esito Pubblicazione</md-tooltip></md-button></div><!-- HISTORY PANEL --><div ng-if="::vm.seduta.storicoStato.length > 0 && vm.showStateHistory" class="animate-show-hide" ng-show="vm.showStateHistory"><div ng-repeat="state in ::vm.seduta.storicoStato track by $index"><label class="label" ng-class="::{\r\n                        \'label-primary\' : state.statoSeduta !== vm.seduta.statoCorrente.statoSeduta,\r\n                        \'label-danger\' : state.statoSeduta === vm.seduta.statoCorrente.statoSeduta\r\n                        }">{{\'gestioneAttiApp.StatoSeduta.\' + state.statoSeduta | translate}}</label>&nbsp; <span ng-if="::state.utenteStato.length > 0">da {{::state.utenteStato}} </span>il {{::state.dataStato| date: \'dd/MM/yyyy\'}}</div></div></div><div class="card" layout-padding layout-margin layout-align="start center"><h4 class="card-header">Seduta n\xB0: {{vm.seduta.numeroSeduta}}</h4><div class="card-body"><div layout-gt-xs="row" layout-padding><md-input-container flex="10"><label data-translate="gestioneAttiApp.seduta.legislatura" for="field_legislatura">Legislatura</label><md-select ng-required="true" name="legislatura" ng-model="vm.seduta.legislatura" ng-change="vm.legislaturaChanged()" ng-disabled="!vm.isEditing"><md-option ng-repeat="legislatura in vm.legislatureOrganismo" ng-value="legislatura">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container flex="10"><label data-translate="gestioneAttiApp.seduta.numeroSeduta" for="field_numeroSeduta">Numero Seduta</label><input ng-required="true" type="number" name="numeroSeduta" id="field_numeroSeduta" ng-model="vm.seduta.numeroSeduta" ng-disabled="!vm.isEditing && !vm.isNumberEditing"></md-input-container><md-input-container flex="20" ng-show="false"><label data-translate="gestioneAttiApp.seduta.tipoOrganizzatore" for="field_tipoOrganizzatore">Tipo Organizzatore</label><input type="text" name="tipoOrganizzatore" id="field_tipoOrganizzatore" ng-model="vm.seduta.tipoOrganizzatore" disabled="disabled"></md-input-container><md-input-container flex="20"><label data-translate="gestioneAttiApp.seduta.tipoOrganizzatore" for="field_tipoOrganizzatoreStr">Tipo Organizzatore</label><input type="text" name="tipoOrganizzatoreStr" id="field_tipoOrganizzatoreStr" value="{{\'gestioneAttiApp.TipoOrganizzatore.\' + vm.seduta.tipoOrganizzatore | translate}}" disabled="disabled"></md-input-container><md-input-container flex="60"><label data-translate="gestioneAttiApp.seduta.organizzatore" for="field_organizzatore">Organizzatore</label><input type="text" name="organizzatore" id="field_organizzatore" ng-model="vm.seduta.organizzatore" disabled="disabled"></md-input-container><md-input-container flex="5" hidden><label data-translate="gestioneAttiApp.seduta.idOrganizzatore" for="field_idOrganizzatore">IdOrganizzatore</label><input type="text" name="idOrganizzatore" id="field_idOrganizzatore" ng-model="vm.seduta.idOrganizzatore" ng-value="vm.seduta.idOrganizzatore | translate" ng-disabled="true"></md-input-container></div><div layout-gt-xs="row" layout-align="start" layout-padding><!-- STATO SEDUTA--><div layout="column" flex="20"><md-input-container><label data-translate="gestioneAttiApp.seduta.statoSeduta" for="field_statoSeduta">Stato Seduta</label><md-select ng-required="true" name="statoSeduta" ng-model="vm.seduta.statoCorrente.statoSeduta" id="field_statoSeduta" disabled="disabled"><md-option value="A" data-translate="gestioneAttiApp.StatoSeduta.A">A</md-option><md-option value="PAT" data-translate="gestioneAttiApp.StatoSeduta.PAT">PAT</md-option><md-option value="P" data-translate="gestioneAttiApp.StatoSeduta.P">P</md-option><md-option value="X" data-translate="gestioneAttiApp.StatoSeduta.X">X</md-option></md-select></md-input-container></div><!-- TIPO SEDUTA--><div layout="column" flex="10"><md-input-container><label data-translate="gestioneAttiApp.seduta.tipoSeduta" for="field_tipoSeduta">Tipo Seduta</label><md-select ng-required="true" name="tipoSeduta" ng-model="vm.seduta.tipoSeduta" id="field_tipoSeduta" ng-disabled="!vm.isEditing"><md-option value="N" data-translate="gestioneAttiApp.TipoSeduta.N">N</md-option><md-option value="C" data-translate="gestioneAttiApp.TipoSeduta.C">C</md-option></md-select></md-input-container></div><!-- PARTECIPANTI (SE CONGIUNTA) --><div layout="column" flex="40" ng-if="!vm.isEditing"><div ng-repeat="partecipante in vm.seduta.partecipantiSeduta track by $index"><md-input-container style="width: 100%"><label ng-if="$index == 0" data-translate="gestioneAttiApp.seduta.congiuntaCon"></label><input value="{{partecipante.descrizione}}" disabled="disabled"></md-input-container></div></div><div layout="column" flex="40" ng-if="vm.seduta.tipoSeduta===\'C\'" ng-if="vm.isEditing"><label data-translate="gestioneAttiApp.seduta.partecipanti" for="field_membriSeduta" ng-if="vm.isEditing">Partecipanti</label><addable-input id="field_membriSeduta" ng-if="vm.isEditing" input-type="\'membriSeduta\'" input-model="vm.seduta.membriSeduta" inner-label="false" text-label="\'documentToolbar.mittentiEsterni\'" disabled="false" organismi-seduta="vm.organismiSeduta" class="" style="width: 100%"></addable-input></div></div><!-- DATA DI CONVOCAZIONE --><div ng-if="!vm.isEditing" layout="row" layout-padding><div class="input-group date" layout-gt-xs="row" layout-align="start center"><div class="md-form form-group" style="margin : 0!important"><label for="field_dataDiConvocazione" class="sedutaDataConvocazione" data-translate="gestioneAttiApp.seduta.dataDiConvocazione">Data Di Convocazione</label><input disabled="disabled" class="form-control" type="text" id="field_dataDiConvocazione" name="dataDiConvocazione" datetime-picker="{{vm.dateformat}}" ng-model="vm.seduta.dataDiConvocazione" onkeydown="return false"></div></div></div><div ng-if="vm.isEditing" class="input-group date" layout-gt-xs="row" layout-align="start center" layout-padding><div class="md-form form-group" style="margin : 0!important"><label for="field_dataDiConvocazioneEdit" class="sedutaDataConvocazione required" data-translate="gestioneAttiApp.seduta.dataDiConvocazione">Data Di Convocazione</label><input class="form-control" type="text" id="field_dataDiConvocazioneEdit" name="dataDiConvocazioneEdit" datetime-picker="{{vm.dateformat}}" timepicker-options="{\'show-meridian\': false}" datepicker-options="{\'showWeeks\' : false}" ng-model="vm.seduta.dataDiConvocazione" is-open="vm.datePickerOpenStatus.dataDiConvocazioneEdit" onkeydown="return false" required></div><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataDiConvocazioneEdit\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><button class="btn btn-primary" ng-if="vm.isEditing" ui-sref="ordine-del-giorno.new({\r\n                idSeduta:vm.seduta.id,\r\n                idOrg: vm.workingBody.id,\r\n                typeOrg : vm.workingBody.tipoOrganismo, \r\n                nameOrg: vm.workingBody.nome})"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.ordineDelGiorno.home.createLabel">Crea un nuovo Ordine Del Giorno</span></button></div><div class="panel-footer" ng-if="true"><seduta-document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" document-types="::vm.docTypes" editable="vm.isEditing" public-view="true" seduta="::vm.seduta" user="::vm.utente"></seduta-document-toolbar></div></div><!-- LISTA DEGLI ORDINI DEL GIORNO DELLA SEDUTA --><h4 class="card-header" ng-if="vm.ordiniDelGiorno.length > 0">Ordini del giorno</h4><div class="card" layout-margin ng-repeat="odg in vm.ordiniDelGiorno track by $index"><div class="card-body"><div layout="row"><!-- PROGRESSIVO ODG --><md-input-container flex="10"><label data-translate="gestioneAttiApp.ordineDelGiorno.progressivoODG"></label><input value="{{odg.progressivoODG}}" disabled="disabled"></md-input-container><!-- STATO CORRENTE ODG --><md-input-container flex="10"><label data-translate="gestioneAttiApp.ordineDelGiorno.statoCorrenteODG">Stato Corrente ODG</label><md-select name="statoCorrenteODG" ng-model="odg.statoCorrenteODG.statoODG" disabled="disabled"><md-option value="A" data-translate="gestioneAttiApp.StatoODGType.A"></md-option><md-option value="P" data-translate="gestioneAttiApp.StatoODGType.P"></md-option><md-option value="X" data-translate="gestioneAttiApp.StatoODGType.X"></md-option></md-select></md-input-container><!-- TIPO ODG --><md-input-container flex="10"><label data-translate="gestioneAttiApp.ordineDelGiorno.tipoODG">Tipo ODG</label><md-select name="tipoODG" placeholder="Tipo ODG" ng-model="odg.tipoODG" disabled="disabled"><md-option value="P">Primario</md-option><md-option value="I">Integrativo</md-option></md-select></md-input-container><!-- OGGETTO ODG --><md-input-container flex="70"><label data-translate="gestioneAttiApp.ordineDelGiorno.oggettoODG">Oggetto ODG</label><input type="text" name="oggettoODG" id="field_oggettoODG" ng-model="odg.oggettoODG" disabled="disabled"></md-input-container></div><a ui-sref="ordine-del-giorno({idSeduta: vm.seduta.id, idODG: odg.id})" aria-label="saveDetail" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span data-translate="entity.action.goToOdg">Vai al dettaglio</span><md-tooltip>Vai all\'ordine del giorno</md-tooltip></a></div></div><button type="submit" ui-sref="seduta" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="padded-bottom-70"></div><div class="bottom-sheet-demo inset action-button-fixed-bottom hide-sm hide-xs show-gt-sm" layout="row" layout-xs="column" layout-align="center"><!-- ACTION BUTTONS --><div class="md-button-group"><md-button ng-repeat="button in vm.visibleButtons" ng-click="vm.performButtonAction(button)" ng-disabled="vm.isSaving" ng-class="::{\'md-primary\' : $index % 2 === 0, \'md-accent\' : $index % 2 !== 0}" class="md-raised"><md-tooltip md-direction="top">{{::button.title| translate}}</md-tooltip><span class="glyphicon {{::button.iconClass|| \'glyphicon-floppy-disk\'}}"></span> <span data-translate="{{::button.title}}" layout-wrap></span></md-button><md-button ng-if="vm.isEditing" class="md-raised md-primary" ng-disabled="vm.isSaving" ng-click="vm.saveSeduta()"><md-tooltip>{{\'entity.action.save\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.save"></span></md-button><md-button ng-if="vm.isNumberEditing" class="md-raised md-primary" ng-disabled="vm.isSaving" ng-click="vm.saveSeduta()"><md-tooltip>{{\'entity.action.save\'| translate}}</md-tooltip><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.saveSedutaNumber"></span></md-button></div></div></form>');
$templateCache.put('app/entities/seduta/seduta-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" ng-cloak><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySedutaLabel" data-translate="gestioneAttiApp.seduta.home.createOrEditLabel">Create or edit a Seduta</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div layout-gt-xs="row" layout-align="start center" layout-margin layout-padding><md-input-container flex="20" ng-show="vm.seduta.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" id="id" name="id" ng-model="vm.seduta.id" readonly="readonly"></md-input-container></div><div layout-gt-xs="row" layout-align="start center" layout-margin layout-padding><md-input-container flex="20"><label data-translate="gestioneAttiApp.seduta.legislatura" for="field_legislatura">Legislatura</label><md-select ng-required="true" name="legislatura" ng-model="vm.seduta.legislatura" ng-change="vm.legislaturaChanged()"><md-option ng-repeat="legislatura in vm.legislatureOrganismo" ng-value="legislatura">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container flex="20" ng-show="false"><label data-translate="gestioneAttiApp.seduta.tipoOrganizzatore" for="field_tipoOrganizzatore">Tipo Organizzatore</label><input type="text" name="tipoOrganizzatore" id="field_tipoOrganizzatore" ng-model="vm.seduta.tipoOrganizzatore" disabled="disabled"></md-input-container><md-input-container flex="20"><label data-translate="gestioneAttiApp.seduta.tipoOrganizzatore" for="field_tipoOrganizzatoreStr">Tipo Organizzatore</label><input type="text" name="tipoOrganizzatoreStr" id="field_tipoOrganizzatoreStr" value="{{\'gestioneAttiApp.TipoOrganizzatore.\' + vm.seduta.tipoOrganizzatore | translate}}" disabled="disabled"></md-input-container><md-input-container flex="60"><label data-translate="gestioneAttiApp.seduta.organizzatore" for="field_organizzatore">Organizzatore</label><input type="text" name="organizzatore" id="field_organizzatore" ng-model="vm.seduta.organizzatore" disabled="disabled"></md-input-container><md-input-container flex="5" hidden><label data-translate="gestioneAttiApp.seduta.idOrganizzatore" for="field_idOrganizzatore">IdOrganizzatore</label><input type="text" name="idOrganizzatore" id="field_idOrganizzatore" ng-model="vm.seduta.idOrganizzatore" ng-value="vm.seduta.idOrganizzatore | translate" ng-disabled="true"></md-input-container></div><div layout-gt-xs="row" layout-align="start center" layout-margin layout-padding><md-input-container flex="20" layout-align="start end"><label data-translate="gestioneAttiApp.seduta.numeroSeduta" for="field_numeroSeduta">Numero Seduta</label><input ng-required="true" type="number" name="numeroSeduta" id="field_numeroSeduta" ng-model="vm.seduta.numeroSeduta"></md-input-container><md-input-container flex="40"><label data-translate="gestioneAttiApp.seduta.statoSeduta" for="field_statoSeduta">Stato Seduta</label><md-select ng-required="true" name="statoSeduta" ng-model="vm.seduta.statoCorrente.statoSeduta" id="field_statoSeduta"><md-option value="A" data-translate="gestioneAttiApp.StatoSeduta.A">A</md-option><!-- <md-option value="P" data-translate="gestioneAttiApp.StatoSeduta.P">P</md-option>\r\n                        <md-option value="X" data-translate="gestioneAttiApp.StatoSeduta.X">X</md-option> --></md-select></md-input-container><md-input-container flex="40"><label data-translate="gestioneAttiApp.seduta.tipoSeduta" for="field_tipoSeduta">Tipo Seduta</label><md-select ng-required="true" name="tipoSeduta" ng-model="vm.seduta.tipoSeduta" id="field_tipoSeduta"><md-option value="N" data-translate="gestioneAttiApp.TipoSeduta.N">N</md-option><md-option value="C" data-translate="gestioneAttiApp.TipoSeduta.C">C</md-option></md-select></md-input-container></div><!-- <div layout="row" layout-margin layout-padding>\r\n                <md-input-container flex="20">\r\n                    <label style="overflow: visible;" data-translate="gestioneAttiApp.seduta.dataDiConvocazione">Data Di Convocazione</label>\r\n                    <md-datepicker required name="field_dataDiConvocazione" id="field_dataDiConvocazione" \r\n                        onkeydown="return false" ng-model="vm.seduta.dataDiConvocazione" md-open-on-focus>\r\n                    </md-datepicker>\r\n                </md-input-container>\r\n                <md-input-container flex="20">\r\n                    <label style="overflow: visible;" data-translate="gestioneAttiApp.seduta.oraDiConvocazione">Ora Di Convocazione</label>\r\n                    <input ng-required="true" type="time" id="field_oraDiConvocazione" name="field_oraDiConvocazione" ng-model="vm.seduta.oraDiConvocazione"\r\n                        ng-model-options="{ timeSecondsFormat: \'\', timeStripZeroSeconds: true }"/>\r\n                </md-input-container>\r\n            </div> --><div class="input-group date" layout-gt-xs="row" layout-align="start center" layout-margin layout-padding><div class="md-form form-group"><label for="field_dataDiConvocazione" class="sedutaDataConvocazione required" data-translate="gestioneAttiApp.seduta.dataDiConvocazione">Data Di Convocazione</label><input class="form-control" type="text" id="field_dataDiConvocazione" name="dataDiConvocazione" datetime-picker="{{vm.dateformat}}" timepicker-options="{\'show-meridian\': false }" datepicker-options="{\'showWeeks\' : false}" ng-model="vm.seduta.dataDiConvocazione" is-open="vm.datePickerOpenStatus.dataDiConvocazione" onkeydown="return false" required></div><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataDiConvocazione\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div layout="column" flex-gt-xs="50" ng-if="vm.seduta.tipoSeduta===\'C\'"><h3 class="md-title">Partecipanti*</h3><addable-input input-type="\'membriSeduta\'" input-model="vm.seduta.membriSeduta" inner-label="false" text-label="\'documentToolbar.mittentiEsterni\'" disabled="false" organismi-seduta="vm.organismiSeduta" class="" style="width: 100%"></addable-input></div></div><div class="modal-footer" layout-align="start center"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button><!-- <label>{{editForm.$error}}</label> --></div></form>');
$templateCache.put('app/entities/seduta/seduta-select-working-dialog.html','<md-dialog-content><form name="selectWorkingForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Seleziona Commissione / Organismo Esterno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div layout="column"><md-input-container><label data-translate="gestioneAttiApp.atto.legislatura" style="overflow: visible"></label><md-select ng-model="vm.legislatura" ng-change="vm.legislaturaChanged()" ng-required="!vm.workingBody.tipoNumerazioneSeduta || vm.workingBody.tipoNumerazioneSeduta === vm.TIPO_NUMERAZIONE_SEDUTA.LEGISLATURA" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}"><md-option ng-value=""></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container><label ng-if="vm.legislatura && vm.organismi.length > 0" data-translate="gestioneAttiApp.seduta.selectWorkingDialog.title" style="overflow: visible"></label><md-select ng-if="vm.legislatura && vm.organismi.length > 0" required name="workingBody" ng-model="vm.workingBody"><md-option ng-repeat="item in vm.organismi" ng-value="item">{{item.nome}}</md-option></md-select><div ng-if="vm.organismi.length === 0"><p>Nessun organismo trovato per la legislatura selezionata</p></div></md-input-container><md-input-container ng-if="vm.workingBody.tipoNumerazioneSeduta === vm.TIPO_NUMERAZIONE_SEDUTA.ANNO"><label data-translate="gestioneAttiApp.seduta.selectWorkingDialog.year" style="overflow: visible"></label><md-select required name="selectedYear" ng-model="vm.selectedYear" placeholder="{{\'gestioneAttiApp.seduta.selectWorkingDialog.year\'| translate}}"><md-option ng-value=""></md-option><md-option ng-repeat="year in vm.years" ng-value="year">{{ year }}</md-option></md-select></md-input-container></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></md-dialog-content>');
$templateCache.put('app/entities/seduta/sedutas.html','<div><div layout="row"><h2 data-translate="gestioneAttiApp.seduta.home.title">Sedutas</h2><h2 ng-if="vm.workingBody.tipoNumerazioneSeduta !== \'ANNO\'">Leg. {{vm.legislatura | romanize}} - {{vm.workingBody.nome}}</h2><h2 ng-if="vm.workingBody.tipoNumerazioneSeduta === \'ANNO\'">Leg. {{vm.legislatura | romanize}} - {{vm.anno ? "Anno " + vm.anno + " - " : ""}}{{vm.workingBody.nome}}</h2><div class="container-fluid" style="margin-left: 1em"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="seduta.new(vm.workingBody)" ng-disabled="!vm.canEdit(null)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.seduta.home.createLabel">Create new Seduta</span></button></div></div></div><a ui-sref="sedute-pubbliche({legislatura : vm.legislatura, anno : vm.anno, tipoOrganismo: vm.workingBody.tipoOrganismo, idOrganismo : vm.workingBody.id })">Vai alle sedute pubbliche</a></div><jhi-alert></jhi-alert><div ng-include="\'app/entities/seduta/basicSedutaSearchForm.html\'"></div><br><div class="table-responsive" ng-if="vm.sedutas && vm.sedutas.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numeroSeduta"><span data-translate="gestioneAttiApp.seduta.numeroSeduta">Numero Seduta</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataDiConvocazione"><span data-translate="gestioneAttiApp.seduta.dataDiConvocazione">Data Di Convocazione</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoSeduta"><span data-translate="gestioneAttiApp.seduta.tipoSeduta">Tipo Seduta</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="statoSeduta"><span data-translate="gestioneAttiApp.seduta.statoSeduta">Stato Seduta</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organizzatore"><span data-translate="gestioneAttiApp.seduta.organizzatore">Organizzatore</span></th><th><span data-translate="gestioneAttiApp.seduta.congiuntaCon">Congiunta con</span></th><th><span data-translate="gestioneAttiApp.ordineDelGiorno.home.title">Ordini del Giorno</span></th><th></th></tr></thead><tbody><tr ng-repeat="seduta in vm.sedutas track by seduta.id" ng-style="seduta.statoCorrente.statoSeduta === \'X\' ? {opacity: \'50%\' } : {opacity: \'100%\'}"><td><a ui-sref="seduta-detail({id:seduta.id})">{{seduta.id}}</a></td><td>{{seduta.numeroSeduta}}<span ng-if="seduta.tipoSeduta === \'C\'">c</span></td><td>{{seduta.dataDiConvocazione | date:\'dd/MM/yyyy HH:mm\'}}</td><td data-translate="{{\'gestioneAttiApp.TipoSeduta.\' + seduta.tipoSeduta}}">{{seduta.tipoSeduta}}</td><td><div data-translate="{{\'gestioneAttiApp.StatoSeduta.\' + seduta.statoCorrente.statoSeduta}}" ng-class="{\'label label-danger\' : seduta.statoCorrente.statoSeduta === \'X\', \'label label-pat\' : seduta.statoCorrente.statoSeduta === \'PAT\', \'label label-success\' : seduta.statoCorrente.statoSeduta === \'P\', \'label label-info\' : seduta.statoCorrente.statoSeduta === \'A\'}">{{seduta.statoCorrente.statoSeduta}}</div></td><td><div ng-repeat="organizzatore in seduta.organizzatoreSeduta"><span>{{organizzatore.numeroSeduta}}<span ng-if="seduta.tipoSeduta === \'C\'">c</span> - {{organizzatore.descrizione}}</span></div></td><td><div ng-repeat="partecipante in seduta.partecipantiSeduta"><span>{{partecipante.numeroSeduta}}<span ng-if="seduta.tipoSeduta === \'C\'">c</span> - {{partecipante.descrizione}}</span></div></td><td><div ng-repeat="odg in vm.odgSedute[seduta.id] | orderBy:\'progressivoODG\'"><a ng-class="{\'label label-danger\' : odg.statoCorrenteODG.statoODG === \'X\', \'label label-success\' : odg.statoCorrenteODG.statoODG === \'P\', \'label label-info\' : odg.statoCorrenteODG.statoODG === \'A\'}" ui-sref="ordine-del-giorno({\r\n                                idODG:odg.id,\r\n                                idSeduta:seduta.id,\r\n                                idOrg: vm.workingBody.id,\r\n                                typeOrg : vm.workingBody.tipoOrganismo, \r\n                                nameOrg: vm.workingBody.nome})">{{ odg.progressivoODG }}. {{ odg.oggettoODG }}</a></div><button class="btn btn-primary btn-sm" ng-if="seduta.statoCorrente.statoSeduta === \'A\' && seduta.isOrganizzatore" ui-sref="ordine-del-giorno.new({\r\n                            idSeduta:seduta.id,\r\n                            idOrg: vm.workingBody.id,\r\n                            typeOrg : vm.workingBody.tipoOrganismo, \r\n                            nameOrg: vm.workingBody.nome})"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.ordineDelGiorno.home.createLabel">Crea un nuovo Ordine Del Giorno</span></button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="seduta-detail({id:seduta.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="button" ui-sref="seduta-detail.edit({id:seduta.id})" class="btn btn-primary btn-sm" ng-disabled="!vm.canEdit(seduta)"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="button" ui-sref="seduta.delete({id:seduta.id})" class="btn btn-danger btn-sm" ng-disabled="vm.deleteSedutaDisabled(seduta)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center" ng-if="vm.sedutas && vm.sedutas.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div ng-if="!vm.sedutas || vm.sedutas.length == 0"><p>Nessuna seduta trovata.</p></div></div>');
$templateCache.put('app/entities/sedute-pubbliche/basicSedutaSearchForm.html','<form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container ng-class="{\'rotella-burger-open\': vm.navbarState.burgerOpen}"><!-- <i  class="glyphicon glyphicon-cog advanced-search-toggler"></i> --> <span style="top: 5px; position: relative" class="hidden-xs">Filtra Sedute</span></md-input-container><md-input-container><label data-translate="gestioneAttiApp.seduta.anno"></label><md-select ng-model="vm.anno" ng-change="vm.transition(true)" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.seduta.anno\'| translate}}"><md-option ng-value=""></md-option><md-option ng-repeat="anno in vm.anniDisponibili" value="{{anno}}">{{anno}}</md-option></md-select></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form>');
$templateCache.put('app/entities/sedute-pubbliche/sedute-pubbliche.html','<div class="container"><div><h1>Legislatura {{vm.legislatura | romanize}} - {{vm.organismo.nome}}</h1></div><div layout="row"><h1 data-translate="gestioneAttiApp.seduta.home.title">Sedutas</h1><h2></h2><md-input-container style="font-size:x-large"><!--<label data-translate="gestioneAttiApp.seduta.anno"></label>--><md-select ng-model="vm.anno" ng-change="vm.transition(true)" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.seduta.anno\'| translate}}"><md-option ng-value=""></md-option><md-option ng-repeat="anno in vm.anniDisponibili" value="{{anno}}">{{anno}}</md-option></md-select></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th>Numero e Data Seduta</th><th>Congiunta con</th><th>Ordine del Giorno</th><th>Affari Trattati</th><th>Verbale</th></tr></thead><tbody><tr ng-repeat="seduta in vm.sedute"><td><strong>{{seduta.numeroSeduta}}</strong> del {{seduta.dataSeduta | date:\'dd/MM/yyyy\'}}</td><td><span ng-if="seduta.congiunta"><span ng-repeat="organismo in seduta.congiuntaCon"><a ui-sref="sedute-pubbliche({legislatura : vm.legislatura, anno : vm.anno, tipoOrganismo: organismo.tipoOrganismo, idOrganismo : organismo.id })">{{organismo.nome}}<br></a></span></span><span ng-if="!seduta.congiunta" class="text-muted">-</span></td><td><div class="sedute-document-list" ng-if="seduta.docOdgs"><a ng-repeat="odg in seduta.docOdgs" class="sedute-download sedute-document-link" ng-click="vm.downloadDocument(odg.id, odg.name)" title="{{vm.getOdgTitle($index)}}" aria-label="Scarica ODG"><i class="glyphicon glyphicon-file"></i></a></div></td><td><div ng-if="seduta.docAffariTrattati"><a class="sedute-download sedute-document-link" ng-click="vm.downloadDocument(seduta.docAffariTrattati.id, seduta.docAffariTrattati.name)" title="Affari Trattati" aria-label="Scarica {{seduta.docAffariTrattati.name}}"><i class="glyphicon glyphicon-file"></i></a></div></td><td><div ng-if="seduta.docVerbaleSeduta"><a class="sedute-download sedute-document-link" ng-click="vm.downloadDocument(seduta.docVerbaleSeduta.id, seduta.docVerbaleSeduta.name)" title="Verbale" aria-label="Scarica {{seduta.docVerbaleSeduta.name}}"><i class="glyphicon glyphicon-file"></i></a></div></td></tr><tr ng-if="vm.sedute.length === 0"><td colspan="5" class="text-center">Nessuna seduta trovata per l\'anno {{vm.anno}}.</td></tr></tbody></table></div><div class="text-center" ng-if="vm.sedute && vm.sedute.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/settore/settore-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.settore.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.settore.delete.question" translate-values="{id: \'{{vm.settore.id}}\'}">Are you sure you want to delete this Settore?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/settore/settore-detail.html','<div><h2><span data-translate="gestioneAttiApp.settore.detail.title">Settore</span> {{vm.settore.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.settore.nome">Nome</span></dt><dd><span>{{vm.settore.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="settore-detail.edit({id:vm.settore.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/settore/settore-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySettoreLabel" data-translate="gestioneAttiApp.settore.home.createOrEditLabel">Create or edit a Settore</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.settore.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.settore.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.settore.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.settore.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/settore/settores.html','<div><h2 data-translate="gestioneAttiApp.settore.home.title">Settores</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="settore.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.settore.home.createLabel">Create new Settore</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.settore.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="settore in vm.settores track by settore.id"><td><a ui-sref="settore-detail({id:settore.id})">{{settore.id}}</a></td><td>{{settore.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="settore-detail({id:settore.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="settore.edit({id:settore.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="settore.delete({id:settore.id})" class="btn btn-danger btn-sm" ng-disabled="settore.system"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/SincronizzatoreAnagrafiche/sincronizzatore-anagrafiche.html','<h1 data-translate="sincronizzatore.title"></h1><div ng-if="!vm.runningSyncro || !vm.runningSyncro.length"><h3 data-translate="sincronizzatore.no-sincronizzazione-trovata"></h3><div class="col-md-2"><md-select ng-model="vm.selectedCode" placeholder="Tipo anagrafica" class="addable-input-attachedacts-type"><md-option ng-repeat="anaTypeCode in vm.anagraficTypeCodes" ng-value="anaTypeCode">{{\'sincronizzatore.\' + anaTypeCode | translate}}</md-option></md-select></div></div><div ng-if="vm.runningSyncro && vm.runningSyncro.length"><h3 data-translate="sincronizzatore.sincronizzazione-esistente" translate-values="{id: vm.runningSyncro[0].id}"></h3></div><button class="btn btn-primary btn-sm" ng-click="vm.clickStart()" ng-disabled="vm.runningSyncro && vm.runningSyncro.length">Inizia Sincronizzazione</button><div ng-if="vm.runningSyncro && vm.runningSyncro.length" class="col-md-12 nopadding"><h3 data-translate="sincronizzatore.sync-in-esecuzione"></h3><div class="col-md-12"><div class="col-md-2 bold-text" data-translate="sincronizzatore.result-id"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.by"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.startAt"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.endAt"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.tipoAnagrafica"></div><div class="col-md-2 text-center bold-text"></div></div><div class="col-md-12 nopadding"><div class="col-md-2">{{vm.runningSyncro[0].id}}</div><div class="col-md-2 text-center">{{vm.runningSyncro[0].lastModifiedBy}}</div><div class="col-md-2 text-center">{{vm.runningSyncro[0].startDate | date:\'dd/MM/yy HH:mm\' }}</div><div class="col-md-2 text-center">{{vm.runningSyncro[0].endDate | date:\'dd/MM/yy HH:mm\' }}</div><div class="col-md-2 text-center" ng-if="!vm.runningSyncro[0].tipoAnagrafica">{{\'sincronizzatore.\' + vm.selectedCode | translate}}</div><div class="col-md-2 text-center" ng-if="vm.runningSyncro[0].tipoAnagrafica">{{\'sincronizzatore.\' + vm.runningSyncro[0].tipoAnagrafica | translate}}</div><div class="col-md-2 text-center"></div></div></div><div ng-if="vm.latestSyncro" class="col-md-12 nopadding"><h3 data-translate="sincronizzatore.last-sync"></h3><div class="col-md-12"><div class="col-md-1 bold-text">#</div><div class="col-md-2 bold-text" data-translate="sincronizzatore.result-id"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.by"></div><div class="col-md-1 text-center bold-text" data-translate="sincronizzatore.startAt"></div><div class="col-md-1 text-center bold-text" data-translate="sincronizzatore.endAt"></div><div class="col-md-1 text-center bold-text" data-translate="sincronizzatore.tipoAnagrafica"></div><div class="col-md-2 text-center bold-text" data-translate="sincronizzatore.aggiunte"></div><div class="col-md-2 text-center bold-text">Aggiornate</div></div><div ng-repeat="item in vm.latestSyncro track by $index"><div class="col-md-12"><div class="col-md-1" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{$index +1}} - {{item.systemExecution ? "System" : "MANUAL"}}</div><div class="col-md-2" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.id}}</div><div class="col-md-2 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.lastModifiedBy}}</div><div class="col-md-1 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.startDate | date:\'dd/MM/yy HH:mm\' }}</div><div class="col-md-1 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.endDate | date:\'dd/MM/yy HH:mm\' }}</div><div class="col-md-1 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{\'sincronizzatore.\' + item.tipoAnagrafica | translate}}</div><div class="col-md-2 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.anagraficheAggiunte}}</div><div class="col-md-2 text-center" style="border-style: solid; border-width: 1px; padding-top: 5px; padding-bottom: 5px">{{item.anagraficheAggiornate}}</div></div></div></div>');
$templateCache.put('app/entities/soggetto-esterno/soggetto-esterno-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.soggettoEsterno.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.soggettoEsterno.delete.question" translate-values="{id: \'{{vm.soggettoEsterno.id}}\'}">Are you sure you want to delete this Soggetto Esterno?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/soggetto-esterno/soggetto-esterno-detail.html','<div><h2><span data-translate="gestioneAttiApp.soggettoEsterno.detail.title">Soggetto Esterno</span> {{vm.soggettoEsterno.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.nome">Nome</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.nome}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.descrizione">Descrizione</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.descrizione}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.legislature">Legislature</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.legislature}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.tipoNumerazioneSeduta">Tipo Numerazione Seduta</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.tipoNumerazioneSeduta}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdg">Codice Classificazione Protocollo ODG</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.filingCodeOdg}}</span></dd></dl><dl class="row jh-entity-details"><dt class="col-md-4"><span data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</span></dt><dd class="col-md-8"><span>{{vm.soggettoEsterno.filingCodeOdgFormattedForWS}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="soggetto-esterno-detail.edit({id:vm.soggettoEsterno.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/soggetto-esterno/soggetto-esterno-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySoggettoEsternoLabel" data-translate="gestioneAttiApp.soggettoEsterno.home.createOrEditLabel">Create or edit a Soggetto Esterno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.soggettoEsterno.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.soggettoEsterno.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.soggettoEsterno.nome"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="nome" id="field_descrizione" ng-model="vm.soggettoEsterno.descrizione"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.legislature">Legislature</label><div><md-checkbox ng-repeat="legislatura in vm.legislature" ng-model="vm.selectedLegislature[legislatura]" aria-label="Legislatura {{legislatura}}">{{legislatura | romanize}}</md-checkbox></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.tipoNumerazioneSeduta" for="field_tipoNumerazioneSeduta">Tipo Numerazione Seduta</label><select class="form-control" name="tipoNumerazioneSeduta" id="field_tipoNumerazioneSeduta" ng-model="vm.soggettoEsterno.tipoNumerazioneSeduta"><option value="ANNO">ANNO</option><option value="LEGISLATURA">LEGISLATURA</option></select></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdg" for="field_filingCodeOdg">Codice Classificazione Protocollo ODG</label><input type="text" class="form-control" name="filingCodeOdg" id="field_filingCodeOdg" ng-model="vm.soggettoEsterno.filingCodeOdg"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdgFormattedForWS" for="field_filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</label><input type="text" class="form-control" name="nome" id="field_filingCodeOdgFormattedForWS" ng-model="vm.soggettoEsterno.filingCodeOdgFormattedForWS"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/soggetto-esterno/soggetto-esterno-search-form.html','<form ng-submit="vm.transition()" name="stickySoggettoEsternoSearchForm"><div layout="row"><md-input-container style="min-width: 82px"><label data-translate="gestioneAttiApp.soggettoEsterno.legislatura"></label><md-select ng-model="vm.basicSearchLegislatura" ng-change="vm.transition()" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.soggettoEsterno.legislatura\'| translate}}"><md-option value="ALL"></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form>');
$templateCache.put('app/entities/soggetto-esterno/soggetto-esternos.html','<div><h2 data-translate="gestioneAttiApp.soggettoEsterno.home.title">Soggetti Esterni</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="soggetto-esterno.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.soggettoEsterno.home.createLabel">Create new Soggetto Esterno</span></button></div></div></div><br><div ng-include="\'app/entities/soggetto-esterno/soggetto-esterno-search-form.html\'"></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.legislature">Legislature</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.nome">Nome</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.descrizione">Descrizione</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.tipoNumerazioneSeduta">Numerazione Sedute</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdg">Codice Classificazione Protocollo ODG</span></th><th><span data-translate="gestioneAttiApp.soggettoEsterno.filingCodeOdgFormattedForWS">Codice Classificazione Protocollo ODG (Formattato)</span></th><th></th></tr></thead><tbody><tr ng-repeat="soggettoEsterno in vm.soggettoEsternos track by soggettoEsterno.id"><td><a ui-sref="soggetto-esterno-detail({id:soggettoEsterno.id})">{{soggettoEsterno.id}}</a></td><td>{{soggettoEsterno.legislature}}</td><td>{{soggettoEsterno.nome}}</td><td>{{soggettoEsterno.descrizione}}</td><td>{{soggettoEsterno.tipoNumerazioneSeduta}}</td><td>{{soggettoEsterno.filingCodeOdg}}</td><td>{{soggettoEsterno.filingCodeOdgFormattedForWS}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="soggetto-esterno-detail({id:soggettoEsterno.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="soggetto-esterno.edit({id:soggettoEsterno.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="soggetto-esterno.delete({id:soggettoEsterno.id})" class="btn btn-danger btn-sm" ng-disabled="soggettoEsterno.system"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/stato-odg/stato-odg-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.statoODG.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.statoODG.delete.question" translate-values="{id: \'{{vm.statoODG.id}}\'}">Are you sure you want to delete this Stato ODG?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/stato-odg/stato-odg-detail.html','<div><h2><span data-translate="gestioneAttiApp.statoODG.detail.title">Stato ODG</span> {{vm.statoODG.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.statoODG.stato">Stato</span></dt><dd><span data-translate="{{\'gestioneAttiApp.StatoODGType.\' + vm.statoODG.stato}}">{{vm.statoODG.stato}}</span></dd><dt><span data-translate="gestioneAttiApp.statoODG.dataOraCambioStato">Data Ora Cambio Stato</span></dt><dd><span>{{vm.statoODG.dataOraCambioStato | date:\'medium\'}}</span></dd><dt><span data-translate="gestioneAttiApp.statoODG.utenteCambioStato">Utente Cambio Stato</span></dt><dd><span>{{vm.statoODG.utenteCambioStato}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="stato-odg-detail.edit({id:vm.statoODG.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/stato-odg/stato-odg-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStatoODGLabel" data-translate="gestioneAttiApp.statoODG.home.createOrEditLabel">Create or edit a Stato ODG</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.statoODG.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.statoODG.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.statoODG.stato" for="field_stato">Stato</label><select class="form-control" name="stato" ng-model="vm.statoODG.stato" id="field_stato"><option value="A" data-translate="gestioneAttiApp.StatoODGType.A">A</option><option value="P" data-translate="gestioneAttiApp.StatoODGType.P">P</option><option value="X" data-translate="gestioneAttiApp.StatoODGType.X">X</option></select></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.statoODG.dataOraCambioStato" for="field_dataOraCambioStato">Data Ora Cambio Stato</label><div class="input-group"><input id="field_dataOraCambioStato" type="text" class="form-control" name="dataOraCambioStato" datetime-picker="{{vm.dateformat}}" ng-model="vm.statoODG.dataOraCambioStato" is-open="vm.datePickerOpenStatus.dataOraCambioStato"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataOraCambioStato\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.statoODG.utenteCambioStato" for="field_utenteCambioStato">Utente Cambio Stato</label><input type="text" class="form-control" name="utenteCambioStato" id="field_utenteCambioStato" ng-model="vm.statoODG.utenteCambioStato"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/stato-odg/stato-odgs.html','<div><h2 data-translate="gestioneAttiApp.statoODG.home.title">Stato ODGS</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="stato-odg.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.statoODG.home.createLabel">Create new Stato ODG</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.statoODG.stato">Stato</span></th><th><span data-translate="gestioneAttiApp.statoODG.dataOraCambioStato">Data Ora Cambio Stato</span></th><th><span data-translate="gestioneAttiApp.statoODG.utenteCambioStato">Utente Cambio Stato</span></th><th></th></tr></thead><tbody><tr ng-repeat="statoODG in vm.statoODGS track by statoODG.id"><td><a ui-sref="stato-odg-detail({id:statoODG.id})">{{statoODG.id}}</a></td><td data-translate="{{\'gestioneAttiApp.StatoODGType.\' + statoODG.stato}}">{{statoODG.stato}}</td><td>{{statoODG.dataOraCambioStato | date:\'medium\'}}</td><td>{{statoODG.utenteCambioStato}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="stato-odg-detail({id:statoODG.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="stato-odg.edit({id:statoODG.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="stato-odg.delete({id:statoODG.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tipo-documento/tipo-documento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tipoDocumento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="gestioneAttiApp.tipoDocumento.delete.question" translate-values="{id: \'{{vm.tipoDocumento.id}}\'}">Are you sure you want to delete this Tipo Documento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tipo-documento/tipo-documento-detail.html','<div><h2><span data-translate="gestioneAttiApp.tipoDocumento.detail.title">Tipo Documento</span> {{vm.tipoDocumento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.tipo">Tipo</span></dt><dd><span>{{vm.tipoDocumento.tipo}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.defaultVisibility">Visibilit\xE0 di default</span></dt><dd><span>{{vm.tipoDocumento.defaultVisibility | visibility}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.protocolDirection">Direzione Protocollo</span></dt><dd><span>{{vm.tipoDocumento.direzioneProtocollazione | protocolDirection}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.protocolMnemonic">Mnemonico Protocollo</span></dt><dd><span>{{vm.tipoDocumento.codiceMnemonicoProtocollo}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.uploadPermissions">Visibilit\xE0 per ruolo</span></dt><dd><span><md-chips ng-model="vm.tipoDocumento.authorities" readonly="true" md-removable="false"><md-chip-template><span>{{$chip.name}}</span></md-chip-template><md-chip ng-show="(vm.tipoDocumento.authorities.length === 0)">ALL</md-chip></md-chips></span></dd></dl><dl class="dl-horizontal jh-entity-details" ng-show="vm.hasAuthority(\'ROLE_SETTORE\')"><dt><span data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecSettori">Visibilit\xE0 specializzazione</span></dt><dd><md-chips ng-model="vm.tipoDocumento.settori" readonly="true" md-removable="false"><md-chip-template><span>{{$chip.nome}}</span></md-chip-template><md-chip ng-show="(vm.tipoDocumento.settori.length === 0)">ALL</md-chip></md-chips></dd></dl><dl class="dl-horizontal jh-entity-details" ng-show="vm.hasAuthority(\'ROLE_COMMISSIONE\')"><dt><span data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecCommissioni">Visibilit\xE0 specializzazione</span></dt><dd><md-chips ng-model="vm.tipoDocumento.commissioni" readonly="true" md-removable="false"><md-chip-template><span>{{$chip.nome}}</span></md-chip-template><md-chip ng-show="(vm.tipoDocumento.commissioni.length === 0)">ALL</md-chip></md-chips></dd></dl><dl class="dl-horizontal jh-entity-details" ng-show="vm.hasAuthority(\'ROLE_EXTERNAL\')"><dt><span data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecSoggettiEsterni">Visibilit\xE0 specializzazione</span></dt><dd><md-chips ng-model="vm.tipoDocumento.soggettiEsterni" readonly="true" md-removable="false"><md-chip-template><span>{{$chip.nome}}</span></md-chip-template><md-chip ng-show="(vm.tipoDocumento.soggettiEsterni.length === 0)">ALL</md-chip></md-chips></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="gestioneAttiApp.tipoDocumento.uploadPermissionsOnActType">Visibilit\xE0 per tipo atto</span></dt><dd><span><md-chips ng-model="vm.tipoDocumento.tipiAtto" readonly="true" md-removable="false"><span>{{$chip.name}}</span><md-chip ng-show="(vm.tipoDocumento.tipiAtto.length === 0)">ALL</md-chip></md-chips></span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tipo-documento-detail.edit({id:vm.tipoDocumento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tipo-documento/tipo-documento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h2 class="modal-title" id="myTipoDocumentoLabel" data-translate="gestioneAttiApp.tipoDocumento.home.createOrEditLabel">Create or edit a Tipo Documento</h2></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tipoDocumento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tipoDocumento.id" readonly="readonly" ng-disabled="true"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.tipoDocumento.tipo" for="field_tipo">Tipo</label><input type="text" class="form-control" name="tipo" id="field_tipo" ng-model="vm.tipoDocumento.tipo"></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.tipoDocumento.defaultVisibility" for="field_defaultVisibility">Visibilit\xE0 di default</label><select aria-label="{{\'gestioneAttiApp.tipoDocumento.defaultVisibility\'| translate}}" class="form-control" name="defaultVisibility" id="field_defaultVisibility" ng-model="vm.tipoDocumento.defaultVisibility" ng-options="visibility.value as visibility.text for visibility in vm.visibilities"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.tipoDocumento.protocolDirection" for="field_protocolDirection">Direzione protocollo</label><select aria-label="{{\'gestioneAttiApp.tipoDocumento.protocolDirection\'| translate}}" class="form-control" name="defaultVisibility" id="field_protocolDirection" ng-model="vm.tipoDocumento.direzioneProtocollazione"><option></option><option value="A">Arrivo</option><option value="P">Partenza</option></select></div><div class="form-group"><label class="control-label" data-translate="gestioneAttiApp.tipoDocumento.protocolMnemonic" for="field_protocolmnemonic">Codice mnemonico protocollo</label><input type="text" class="form-control" id="field_protocolmnemonic" name="protocolmnemonic" ng-model="vm.tipoDocumento.codiceMnemonicoProtocollo"></div><div><h3 data-translate="gestioneAttiApp.tipoDocumento.uploadPermissions">Visibile a:</h3><div flex id="res-permission" layout="row" layout-wrap class="form-group"><div flex><md-checkbox flex ng-repeat="authority in vm.authorities" ng-checked="vm.hasPermissionOnAuthority(authority.name)" ng-click="vm.toggleAuthorityPermission(authority)">{{authority.textKey| translate}}</md-checkbox></div></div><div id="res-permission-spec" layout="column" flex-offset="5"><fieldset ng-show="vm.hasPermissionOnAuthority(\'ROLE_SETTORE\')" class="form-group"><legend data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecSettori">Specifica un settore:</legend><md-checkbox ng-repeat="settore in vm.availableSectors" ng-checked="vm.hasPermissionOnAuthoritySpec(\'settori\', settore)" ng-click="vm.toggleAuthoritySpecPermission(\'settori\', settore)">{{ settore.nome}}</md-checkbox></fieldset><fieldset ng-show="vm.hasPermissionOnAuthority(\'ROLE_COMMISSIONE\')" layout="column" class="form-group"><legend data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecCommissioni">Specifica una commissione:</legend><md-checkbox ng-repeat="commissione in vm.availableCommissions" ng-checked="vm.hasPermissionOnAuthoritySpec(\'commissioni\', commissione)" ng-click="vm.toggleAuthoritySpecPermission(\'commissioni\', commissione)">{{ commissione.nome}}</md-checkbox></fieldset><fieldset ng-show="vm.hasPermissionOnAuthority(\'ROLE_EXTERNAL\')" class="form-group"><legend data-translate="gestioneAttiApp.tipoDocumento.uploadPermSpecSoggettiEsterni">Specifica un soggetto esterno:</legend><md-checkbox ng-repeat="soggettoEsterno in vm.availableExternalSubjects" ng-checked="vm.hasPermissionOnAuthoritySpec(\'soggettiEsterni\', soggettoEsterno)" ng-click="vm.toggleAuthoritySpecPermission(\'soggettiEsterni\', soggettoEsterno)">{{ soggettoEsterno.nome}}</md-checkbox></fieldset></div></div><fieldset><legend data-translate="gestioneAttiApp.tipoDocumento.uploadPermissionsOnActType">Filtra visibilit\xE0 per tipo atto:</legend><div flex id="res-act-type" layout="row" layout-wrap class="form-group"><div flex><md-checkbox flex ng-repeat="actType in vm.availableActTypes" ng-checked="vm.hasPermissionOnActType(actType.value)" ng-click="vm.toggleActTypePermission(actType.value)">{{actType.value}}</md-checkbox></div></div></fieldset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tipo-documento/tipo-documentos.html','<div class="md-whiteframe-5dp"><div class="container-fluid"><h2 data-translate="gestioneAttiApp.tipoDocumento.home.title">Tipo Documentos</h2><jhi-alert></jhi-alert><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tipo-documento.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="gestioneAttiApp.tipoDocumento.home.createLabel">Create new Tipo Documento</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="gestioneAttiApp.tipoDocumento.tipo">Tipo</span></th><th><span data-translate="gestioneAttiApp.tipoDocumento.defaultVisibility">Visibilit\xE0 di default</span></th><th><span data-translate="gestioneAttiApp.tipoDocumento.protocolDirection">Direzione protocollo</span></th><th><span data-translate="gestioneAttiApp.tipoDocumento.protocolMnemonic">Mnemonico protocollo</span></th><th></th></tr></thead><tbody><tr ng-repeat="tipoDocumento in vm.tipoDocumentos track by tipoDocumento.id"><td><a ui-sref="tipo-documento-detail({id:tipoDocumento.id})">{{tipoDocumento.id}}</a></td><td>{{tipoDocumento.tipo}}</td><td>{{tipoDocumento.defaultVisibility | visibility}}</td><td>{{tipoDocumento.direzioneProtocollazione | protocolDirection}}</td><td>{{tipoDocumento.codiceMnemonicoProtocollo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tipo-documento-detail({id:tipoDocumento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tipo-documento.edit({id:tipoDocumento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tipo-documento.delete({id:tipoDocumento.id})" class="btn btn-danger btn-sm" ng-disabled="tipoDocumento.system"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/addableInput/addableInput.directive.html','<!--<div ng-if="!vm.innerLabel"><label ng-class="{\'field-invalid\': vm.isFieldInvalid()}">{{vm.label}}</label></div>--><div ng-if="::(vm.inputType === \'date\')"><fieldset class="standard"><legend data-translate="{{::vm.dateLabel}}" ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}"></legend><div layout="row" layout-no-wrap ng-repeat="item in vm.inputModel track by $index"><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.inputModel[$index]" ng-disabled="vm.isInputDisabled($index)" md-placeholder="Data"></md-datepicker><div layout="row" layout-align="end center" ng-if="!vm.isInputDisabled"><a ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a> <a ng-if="$last" ng-click="vm.addInput(\'\')" class="glyphicon glyphicon-plus-sign addable-action"></a></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput(\'\')" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div layout="row" ng-if="::(vm.inputType === \'text\')"><fieldset class="standard" style="width: 100%"><div layout="row" layout-no-wrap ng-repeat="item in vm.inputModel track by $index"><md-input-container class="clean-allignment" style="margin-top: 0px !important; width: 100%"><input type="text" placeholder="{{ vm.textLabel | translate}}" ng-model="vm.inputModel[$index]" ng-disabled="vm.isInputDisabled($index)"></md-input-container><div layout="row" layout-align="end center" ng-if="!vm.isInputDisabled"><a ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a> <a ng-if="$last" ng-click="vm.addInput(\'\')" class="glyphicon glyphicon-plus-sign addable-action"></a></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput(\'\')" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div ng-if="::vm.inputType === \'textAndDate\'"><fieldset name="text&date" class="standard" ng-repeat="item in vm.inputModel track by $index"><div layout="row" layout-no-wrap><md-input-container class="clean-allignment addable-action"><label ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}" data-translate="{{vm.textLabel}}"></label><input ng-model="vm.inputModel[$index].text" ng-disabled="vm.isInputDisabled($index)"></md-input-container><md-input-container flex-offset-gt-xs="5" class="clean-allignment"><label ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}" data-translate="{{vm.dateLabel}}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.inputModel[$index].date" ng-disabled="vm.isInputDisabled($index)"></md-datepicker></md-input-container><div layout="row" layout-align="end center" ng-if="!vm.isInputDisabled"><a ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a> <a ng-if="$last" ng-click="vm.addInput({text: \'\', date: \'\'})" class="glyphicon glyphicon-plus-sign addable-action"></a></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({text: \'\', date: \'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div ng-if="::vm.inputType === \'attachedActs\'" ng-repeat="item in vm.inputModel track by $index"><fieldset name="attachedActs" class="standard"><div layout="row" flex-offset-gt-xs="5"><div layout="row" layout-no-wrap><md-input-container><label data-translate="addableInput.attachedActs.type"></label><md-select ng-model="vm.inputModel[$index].type" placeholder="Tipo" class="addable-input-attachedacts-type" ng-disabled="vm.isInputDisabled($index)"><md-option ng-repeat="langKey in vm.attachedActsTypes" ng-value="langKey">{{\'addableInput.attachedActs.\' + langKey| translate}}</md-option></md-select></md-input-container><md-input-container flex-offset-gt-xs="5" style="max-width:  100px"><label data-translate="addableInput.attachedActs.number"></label><input ng-model="vm.inputModel[$index].number" ng-disabled="vm.isInputDisabled($index)"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="addableInput.attachedActs.state"></label><md-select ng-model="vm.inputModel[$index].state" placeholder="Stato" class="addable-input-attachedacts-type" ng-disabled="vm.isInputDisabled($index)"><md-option ng-repeat="langKey in vm.attachedActsStates" ng-value="langKey">{{\'addableInput.attachedActs.states.\' + langKey| translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({type: \'\', number: \'\', state: \'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div ng-if="::vm.inputType === \'richiestaDiGiunta\'" ng-repeat="item in vm.inputModel track by $index"><fieldset name="richiestaDiGiunta" class="standard"><legend style="margin-bottom: 0px">Richiesta {{$index + 1}}</legend><div layout="row" layout-xs="column"><div layout="column" layout-align-gt-xs="start start"><md-chips md-autocomplete-snap ng-model="vm.inputModel[$index].proponente" readonly="vm.isInputDisabled($index) || vm.inputModel[$index].proponente.length > 0" md-max-chips="1"><md-autocomplete md-selected-item="vm.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchFirmatari(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione" placeholder="Consigliere"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><div layout="row"><md-input-container flex-offset-gt-xs="5" style="max-width:  100px"><label style="overflow: visible">N\xB0 protocollo</label><input type="number" ng-model="vm.inputModel[$index].numeroProtocollo" ng-disabled="vm.isInputDisabled($index)"></md-input-container><md-input-container flex-offset-gt-xs="5" class="clean-allignment"><label style="overflow: visible" ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}">Data richiesta</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.inputModel[$index].dataRichiesta" ng-disabled="vm.isInputDisabled($index)"></md-datepicker></md-input-container><div layout="row" layout-align-gt-xs="start center" style="margin-top: -15px; margin-left: 50px"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({proponente:[], dataRichiesta:\'\', numeroProtocollo:\'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></div></fieldset></div><div ng-if="::vm.inputType === \'resolution\'"><fieldset name="risoluzione" class="standard" ng-repeat="item in vm.inputModel track by $index"><div layout="row" layout-xs="column" layout-align="start start" layout-no-wrap><div><md-input-container><label ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}" data-translate="{{vm.dateLabel}}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.inputModel[$index].date" ng-disabled="vm.isInputDisabled($index)"></md-datepicker></md-input-container></div><div layout="row"><div flex-offset="5"><md-radio-group ng-model="vm.inputModel[$index].esito" ng-disabled="vm.isInputDisabled($index)"><label data-translate="gestioneAttiApp.form.postCourtroom.collegioDiGaranzia" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviFattibilita\')}"></label><md-radio-button ng-value="\'FAVORABLE\'" class="md-primary">Favorevole</md-radio-button><md-radio-button ng-value="\'UNFAVORABLE\'" class="md-primary">Contrario</md-radio-button></md-radio-group></div><div flex-offset="5"><md-radio-group ng-model="vm.inputModel[$index].voto" ng-disabled="vm.isInputDisabled($index)"><label data-translate="gestioneAttiApp.form.postCourtroom.collegioDiGaranzia" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviFattibilita\')}"></label><md-radio-button ng-value="\'MAJORITY\'" class="md-primary">Maggioranza</md-radio-button><md-radio-button ng-value="\'ALL\'" class="md-primary">Unanimit\xE0</md-radio-button></md-radio-group></div></div><div flex-offset="5"><md-input-container><label ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}" data-translate="{{vm.textLabel}}"></label><input type="number" ng-model="vm.inputModel[$index].resolutionNumber" ng-disabled="vm.isInputDisabled($index)"></md-input-container></div><div layout="row" layout-align-gt-xs="start center" style="margin-top: 15px; margin-left: 50px"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({date:\'\', esito:\'\', voto:\'\',resolutionNumber:\'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div layout="row" ng-if="::(vm.inputType === \'dea-presentation-input\')"><fieldset class="standard" style="width: 100%"><legend data-translate="{{::vm.textLabel}}" ng-class="{\'field-invalid\': vm.isFieldInvalid($index)}"></legend><div layout="row" layout-xs="column" flex ng-repeat="item in vm.inputModel track by $index"><md-input-container class="clean-allignment" style="margin-top: 0px !important" flex-gt-xs="33"><input type="text" placeholder="Ente e organo" ng-model="vm.inputModel[$index].ente" ng-disabled="vm.isInputDisabled($index)"></md-input-container><md-input-container class="clean-allignment" style="margin-top: 0px !important" flex-gt-xs="25"><input type="text" placeholder="Carica" ng-model="vm.inputModel[$index].carica" ng-disabled="vm.isInputDisabled($index)"></md-input-container><md-input-container class="clean-allignment" style="margin-top: 0px !important" flex-gt-xs="25"><input type="text" placeholder="Persona nominata" ng-model="vm.inputModel[$index].personaNominata" ng-disabled="vm.isInputDisabled($index)"></md-input-container><div layout="row" layout-align="end center" ng-if="!vm.isInputDisabled"><a ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a> <a ng-if="$last" ng-click="vm.addInput(\'\')" class="glyphicon glyphicon-plus-sign addable-action"></a></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({ente: \'\', carica: \'\', personaNominata: \'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div ng-if="::vm.inputType === \'membriSeduta\'" ng-repeat="item in vm.inputModel track by $index"><fieldset name="membriSeduta" class="standard"><div layout="row" flex-offset-gt-xs="5"><div layout="row" style="width: 100%" layout-no-wrap layout-margin layout-padding><md-input-container flex-offset-gt-xs="5" flex-gt-xs="95"><!-- <label style="overflow: visible;" data-translate="addableInput.membriSeduta.organismo"></label> --><md-select ng-model="vm.inputModel[$index]" placeholder="Membro" class="addable-input-membriSeduta-organismo" ng-disabled="vm.isInputDisabled($index)"><md-option ng-repeat="organismo in vm.organismiSeduta" ng-value="organismo">{{organismo.nome}}</md-option></md-select></md-input-container><!-- <md-input-container ng-if="vm.inputModel[$index]" flex-gt-xs="30">\r\n                    <label data-translate="addableInput.membriSeduta.type"></label>\r\n                    <input type="text" ng-model="vm.inputModel[$index].tipoOrganismo|translate" disabled class="addable-input-membriSeduta-type" >\r\n                </md-input-container> --></div><div layout="row" layout-xs="column" layout-align-gt-xs="start center"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div><div ng-if="::vm.inputType === \'avvisoRettifica\'" ng-repeat="item in vm.inputModel track by $index"><fieldset name="avvisoRettifica" class="standard"><div layout="row"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.noticeOfRectification.numeroBurt"></label><input type="number" ng-disabled="vm.disabled" ng-model="item.numeroBurt"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.noticeOfRectification.parteBurt"></label><input ng-model="item.parteBurt" ng-disabled="vm.disabled"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="item.dataBurt" ng-disabled="vm.disabled"></md-datepicker></md-input-container><span ng-if="item.dataBurt && !vm.disabled"><md-button ng-click="item.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span><div layout="row" layout-align-gt-xs="start center" style="margin-top: -15px; margin-left: 50px"><a ng-if="vm.isButtonEnabled($index, \'add\')" ng-click="vm.addInput({numeroBurt:\'\', parteBurt:\'\', dataBurt:\'\'})" class="glyphicon glyphicon-plus-sign addable-action addable-input-add-{{::vm.inputType}}"></a> <a ng-if="vm.isButtonEnabled($index, \'remove\')" ng-click="vm.clearOrRemoveInput($index)" class="glyphicon addable-action glyphicon-minus-sign"></a></div></div></fieldset></div>');
$templateCache.put('app/components/adempimentiList/adempimenti-list.html','<label>{{\'adempimenti.adempimento.listaAdempimenti\' | translate}}</label><ng-container ng-repeat="adempimento in vm.model.adempimenti track by $index"><div><adempimento-component disabled="vm.disabled" on-delete="vm.onAdempimentoDelete($index)" model="adempimento" commissioni="vm.commissioni" label="{{(\'adempimenti.adempimento.label\' | translate) + \' N. \' + ($index + 1)}}"></adempimento-component></div></ng-container><ng-container ng-if="!vm.disabled"><button class="md-raised md-primary md-button" ng-click="vm.addNewAdempimento()"><span style="margin-right: 5px" class="glyphicon glyphicon-plus-sign"></span>{{\'adempimenti.adempimento.aggiungiButtonLabel\' | translate}}</button></ng-container>');
$templateCache.put('app/components/advancedSearch/advancedSearch.directive.html','<div class="row tree-header"><div class="col-xs-6"><h3 flex-offset="5" data-translate="gestioneAttiApp.atto.ricercaAvanzata"></h3></div><div class="col-xs-6" style="text-align: right"><a class="btn btn-danger" ng-click="vm.closeSearchPanel()" style="padding: 5px 0px"><span class="glyphicon glyphicon-remove-circle archive-tree-close"></span></a></div></div><form class="advanced-search"><div flex layout-gt-xs="row"><div layout="column" flex="30" flex-offset="5"><md-input-container><label>{{\'gestioneAttiApp.atto.ricercaStato\' | translate}}</label><md-select ng-model="vm.searchParams.stato" ng-disabled="vm.loading"><md-option></md-option><md-option ng-repeat="item in ::vm.queryStates track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container></div><div layout="column" flex="30" flex-offset="5"><md-input-container><label>{{\'gestioneAttiApp.atto.ricercaTipo\' | translate}}</label><md-select ng-model="vm.searchParams.tipo" ng-disabled="vm.loading"><md-option></md-option><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container></div><div layout="column" flex="30" flex-offset="5"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.oggetto"></label><input type="text" ng-model="vm.searchParams.oggetto" ng-disabled="vm.loading" autocomplete="off"></md-input-container></div></div><div flex layout-gt-xs="row"><div layout="column" flex="30" flex-offset="5"><!--             <md-input-container flex>\r\n                <input type="text" ng-model="vm.searchParams.legislatura" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}">\r\n            </md-input-container> --><md-select ng-model="vm.searchParams.legislatura" ng-change="vm.legislaturaChange()" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}"><md-option></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></div><div layout="column" flex="30" flex-offset="5"><md-input-container style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><md-select ng-model="vm.searchParams.tipoProponente" ng-change="vm.tipoProponenteChange()"><md-option></md-option><md-option value="CR">CR</md-option><md-option value="GR">GR</md-option><md-option value="UP">UP</md-option></md-select></md-input-container></div><!-- GRUPPI POLITICI --><div ng-if="vm.searchParams.tipoProponente && vm.showConsiglieri" layout="column" flex="30" flex-offset="5"><md-input-container style="min-width: 90px"><label>{{\'gestioneAttiApp.atto.ricercaGruppiPolitici\' | translate}}</label><md-select ng-model="vm.searchParams.gruppiPolitici" ng-disabled="vm.loading" multiple="multiple"><md-option ng-repeat="item in ::vm.gruppiPolitici track by item.id" value="{{::item.id}}">{{item.description| translate}}</md-option></md-select></md-input-container></div><!--<div ng-show="vm.searchParams.tipoProponente === \'GR\'" layout="column" flex="30" flex-offset="5">\r\n    \r\n                <md-input-container>\r\n                    <label data-translate="gestioneAttiApp.form.presentation.direzioneGR"></label>\r\n                    <md-select ng-model="vm.searchParams.direzioneGRId" placeholder="Direzione">\r\n                        <md-option data-translate="gestioneAttiApp.form.presentation.tipoAtto.empty"></md-option>\r\n                        <md-option ng-repeat="direzione in vm.direzione" ng-value="direzione.id">\r\n                            {{direzione.nome}}\r\n                        </md-option>\r\n                    </md-select>\r\n                </md-input-container>\r\n        \r\n        </div>--></div><div flex layout-gt-xs="row"><div ng-if="vm.searchParams.tipoProponente && vm.showConsiglieri" layout="column" flex="30" flex-offset="5"><label ng-if="vm.searchParams.tipoProponente === \'CR\' || vm.searchParams.tipoProponente === \'UP\'" data-translate="gestioneAttiApp.form.presentation.consiglieri"></label><md-chips md-autocomplete-snap ng-model="vm.searchParams.proponenti"><md-autocomplete md-selected-item="vm.searchParams.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchConsiglieri(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><!-- PRIMO FIRMATARIO PER I CONSIGLIERI --><div ng-if="vm.showConsiglieri && vm.searchParams.proponenti.length" layout="column" flex="30" flex-offset="5"><label data-translate="gestioneAttiApp.form.presentation.primoFirmatario"></label><md-checkbox ng-model="vm.searchParams.primoFirmatario"></md-checkbox></div><div ng-if="vm.searchParams.tipoProponente && !vm.showConsiglieri" layout="column" flex="30" flex-offset="5"><label ng-if="vm.searchParams.tipoProponente === \'GR\'" data-translate="gestioneAttiApp.form.presentation.proponenti"></label><md-chips md-autocomplete-snap ng-model="vm.searchParams.proponenti"><md-autocomplete md-selected-item="vm.searchParams.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchAssessori(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div></div><div flex layout-gt-xs="row"><div layout="column" flex="45" flex-offset="5"><label data-translate="gestioneAttiApp.form.assignment.parereReferenteObbligatorioCommissioni"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereReferente\', commissione.id, \'parereSecondario\')" ng-checked="vm.searchParamExists(\'parereReferente\', commissione.id)" ng-disabled="vm.loading">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex="45" flex-offset="5"><label data-translate="gestioneAttiApp.form.assignment.parereSecondario"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereSecondario\', commissione.id, \'parereReferente\')" ng-checked="vm.searchParamExists(\'parereSecondario\', commissione.id)" ng-disabled="vm.loading">{{commissione.nome}}</md-checkbox></div></div></div><div class="spacer">&nbsp;</div><div flex layout-gt-xs="row"><div layout="column" flex="45" flex-offset="5"><label data-translate="gestioneAttiApp.form.assignment.parereObbligatorio"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'parereObbligatorio\', soggetto.id, \'osservazioni\')" ng-checked="vm.searchParamExists(\'parereObbligatorio\', soggetto.id)" ng-disabled="vm.loading">{{soggetto.nome}}</md-checkbox></div></div><div layout="column" flex="45" flex-offset="5"><label data-translate="gestioneAttiApp.form.assignment.osservazioni"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-click="vm.toggleCheck(\'osservazioni\', soggetto.id, \'parereObbligatorio\')" ng-checked="vm.searchParamExists(\'osservazioni\', soggetto.id)" ng-disabled="vm.loading">{{soggetto.nome}}</md-checkbox></div></div></div><div class="spacer">&nbsp;</div><div flex layout-gt-xs="row"><div layout="column" flex="45" flex-offset="5"><md-radio-group ng-model="vm.searchParams.ricorso" ng-disabled="vm.loading"><label data-translate="gestioneAttiApp.form.constitutionalAppeal.ricorso" ng-click="vm.searchParams.ricorso = null"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><!-- <div layout="column" flex="45" flex-offset="5">\r\n            <md-radio-group ng-model="vm.searchParams.clausolaValutativa" ng-disabled="vm.loading">\r\n                <label data-translate="gestioneAttiApp.form.courtroomOutcome.clausolaValutativa" ng-click="vm.searchParams.clausolaValutativa = null"></label>\r\n                <md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button>\r\n                <md-radio-button ng-value="false" class="md-primary">No</md-radio-button>\r\n            </md-radio-group>\r\n        </div> --></div><div class="spacer">&nbsp;</div><div class="md-button-group"><md-button type="submit" ng-click="vm.search()" ng-disabled="vm.loading" class="md-raised md-primary"><!-- <md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip> --> <span class="glyphicon glyphicon-search"></span> <span data-translate="entity.action.search"></span></md-button><md-button type="reset" ng-click="vm.clearSearch()" ng-disabled="vm.loading" class="md-raised md-accent"><md-tooltip>{{\'entity.action.clear\'| translate}}</md-tooltip><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.clear"></span></md-button></div></form>');
$templateCache.put('app/components/archiveTree/archiveTree.directive.html','<div class="row tree-header"><div class="col-xs-6"><md-button ng-click="vm.downloadArchive()" ng-disabled="vm.loadingZip" aria-label="{{\'archiveTree.actions.downloadZip\' | translate}}" class="md-raised md-primary archive-tree-download-zip"><span class="glyphicon glyphicon-paperclip"></span> <span class="hidden-sm hidden-xs" data-translate="archiveTree.actions.downloadZip"></span></md-button></div><div class="col-xs-6" style="text-align: right"><a class="btn btn-danger" ng-click="vm.closeArchiveTree()" style="padding: 5px 0px"><span class="glyphicon glyphicon-remove-circle archive-tree-close"></span></a></div></div><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\r\n    <div class="archive-tree-row" ng-if="node.nodes && node.nodes.length > 0" data-nodrag>\r\n\t<a class="btn archive-tree-folder btn-xs" style="padding: 4px 5px;" title="{{\'archiveTree.actions.getLink\' | translate}}" ng-click="vm.getLink(node.link)">\r\n\t\t\t\t<span class="glyphicon glyphicon-link"></span>\r\n\t\t\t</a>\r\n        <a class="btn archive-tree-folder btn-xs" ng-click="toggle(this)">\r\n            <span class="glyphicon" ng-class="{\'glyphicon glyphicon-folder-close\': collapsed, \'glyphicon glyphicon-folder-open\': !collapsed}"></span>\r\n        </a>\r\n        <span>{{node.title | translate}}</span>\r\n    </div>\r\n    \r\n    <!--ng-click="vm.downloadFile(node.id, node.title)" -->\r\n    <div class="archive-tree-row archive-tree-leaf"  ng-if="node.nodes == null || node.nodes.length == 0" data-nodrag>\r\n        <a class="btn archive-tree-folder btn-xs" style="padding: 4px 5px;" title="{{\'archiveTree.actions.getLink\' | translate}}" ng-click="vm.getLink(node.link)">\r\n\t\t\t\t<span class="glyphicon glyphicon-link"></span>\r\n\t\t\t</a>\r\n        <!-- <a href="/#/document/{{node.id}}/content" target="_blank"> -->\r\n        <a href="" ng-click="vm.routeOrDownloadFile(node)">\r\n            <button class="btn archive-tree-folder btn-sm">\r\n                <span class="glyphicon glyphicon-file archive-tree-file" data-nodrag></span>\r\n            </button>\r\n            <span>{{node.title | translate}}</span>\r\n        </a>\r\n    </div>\r\n  </div>\r\n  \r\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\r\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\r\n  </ol></script><div ui-tree id="tree-root" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.archiveTree"><li ng-repeat="node in vm.archiveTree" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div>');
$templateCache.put('app/components/archiveTree/get-link-modal.html','<md-dialog aria-label="ottieni link" flex="30" layout-padding layout-align="center center"><md-dialog-content layout="row" flex="100" style="width: 100%"><md-input-container style="width: 100%"><input aria-label="link" ng-readonly="true" ng-model="treeLink" id="tree-link" style="width: 100%; text-align: center"></md-input-container></md-dialog-content><md-dialog-actions layout="row" flex="100"><md-button aria-label="copia link" class="md-raised md-primary" ng-click="copyLink()"><span data-translate="archiveTree.actions.copyLink"></span></md-button><span flex></span><md-button aria-label="annulla" class="md-raised md-accent" ng-click="cancel()"><span data-translate="entity.action.cancel"></span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/attachmentsDialog/attachmentsDialog.html','<div id="{{dialogId}}" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Attachments</h4></div><div class="modal-body"><ul><li><span>File 1</span></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/components/adempimento/adempimento.html','<div style="border: 1px solid #c7030a; padding: 15px"><fieldset><legend>{{vm.label ? vm.label : \'Adempimento\'}}<ng-container ng-if="!vm.disabled"><md-button ng-click="vm.onClearClick()" class="md-icon-button md-primary"><span class="glyphicon glyphicon-trash"></span><md-tooltip>{{ \'adempimenti.adempimento.tooltip.delete\' | translate}}</md-tooltip></md-button></ng-container></legend><div layout="column" style="padding: 20px"><div layout="row" layout-xs="column"><div layout="column"><label>{{ \'adempimenti.adempimento.incaricatoLabel\' | translate}}<span class="glyphicon glyphicon-asterisk"><md-tooltip>Campo Obbligatorio</md-tooltip></span></label><ng-container ng-repeat="incaricato in vm.incaricatoList"><md-checkbox class="md-primary" ng-disabled="vm.disabled" ng-checked="vm.exists(incaricato, vm.model.incaricatiAdempimento)" ng-click="vm.toggle(incaricato, vm.model.incaricatiAdempimento)">{{ \'adempimenti.adempimento.incaricatiDestinatari.\' + incaricato | translate}}</md-checkbox></ng-container></div><div layout="row" layout-xs="column" flex-offset="5"><div layout="column"><label>{{ \'adempimenti.adempimento.destinatarioLabel\' | translate}}<span class="glyphicon glyphicon-asterisk"><md-tooltip>Campo Obbligatorio</md-tooltip></span></label><ng-container ng-repeat="destinatario in vm.destinatarioAdempimento"><md-checkbox class="md-primary" ng-disabled="vm.disabled" ng-checked="vm.exists(destinatario, vm.model.destinatariAdempimento)" ng-click="vm.toggle(destinatario, vm.model.destinatariAdempimento); vm.destinatarioAdempimentoChanged();">{{\'adempimenti.adempimento.incaricatiDestinatari.\' + destinatario | translate}}</md-checkbox></ng-container></div><div layout="column" flex-offset="5" ng-if="vm.model.destinatariAdempimento && vm.model.destinatariAdempimento.includes(\'COMMISSIONE\')"><label>{{ \'adempimenti.adempimento.commissioniLabel\' | translate}} <span class="glyphicon glyphicon-asterisk"><md-tooltip>Campo Obbligatorio</md-tooltip></span></label><ng-container ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="vm.disabled" ng-checked="vm.exists(commissione.id, vm.model.commissioniDestinatarie)" ng-click="vm.toggle(commissione.id, vm.model.commissioniDestinatarie)">{{commissione.nome}}</md-checkbox></ng-container></div></div></div><div><md-input-container class="md-block" flex="100" flex-gt-sm="50"><label>{{ \'adempimenti.adempimento.descrizioneLabel\' | translate}}<span class="glyphicon glyphicon-asterisk"><md-tooltip>Campo Obbligatorio</md-tooltip></span></label><textarea ng-disabled="vm.disabled" ng-model="vm.model.descrizioneAdempimento" ng-focus="vm.showNotes" md-select-on-focus></textarea></md-input-container></div><div layout="row" layout-xs="column"><md-input-container><label style="overflow: inherit">{{ \'adempimenti.adempimento.dataScadenzaLabel\' | translate}}</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.model.scadenzaAdempimento" ng-disabled="vm.disabled"></md-datepicker></md-input-container><div style="margin-left: 50px"><span ng-if="vm.model.scadenzaAdempimento && !vm.disabled"><md-button ng-click="vm.model.scadenzaAdempimento = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data scadenza adempimento</md-tooltip></md-button></span></div><md-radio-group flex-offset="10" ng-model="vm.model.adempimentoEffettuato" ng-disabled="vm.disabled"><label ng-click="vm.prova = null;">{{ \'adempimenti.adempimento.effettuatoLabel\' | translate}}</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group><addable-input input-type="\'date\'" input-model="vm.model.dateEsecuzioneAdempimento" date-label="\'adempimenti.adempimento.dateEsecuzioneAdempimentoLabel\'" disabled="vm.disabled" style="width: 100%"></addable-input></div><div><md-input-container class="md-block" flex="100" flex-gt-sm="50"><label>{{ \'adempimenti.adempimento.svolgimentoLabel\' | translate}}</label><textarea ng-disabled="vm.disabled" ng-model="vm.model.svolgimentoAdempimento" ng-focus="vm.showNotes" md-select-on-focus></textarea></md-input-container></div></div></fieldset></div>');
$templateCache.put('app/components/attoTableList/attoTableList.html','<div id="atto-list-container"><h1 ng-if="vm.title" class="not-sticky">{{vm.title}}</h1><div ng-if="vm.showControls"><h3 ng-if="vm.title" class="sticks">{{vm.title}}</h3><div><div hl-sticky="" event="vm.panelStickyEvent(event)" container="atto-list-container" ng-class="{\'well well-sm\': vm.sticky}" ng-include="::vm.basicSearchFormPath" ng-if="!vm.advancedSearchVisible()"></div><div ng-include="::vm.basicSearchFormPath" ng-if="vm.advancedSearchVisible()"></div><br><div><table class="jh-table table table-striped table-condensed table-responsive" jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><thead><tr><th jh-sort-by="numeroAtto" ng-class="{\'col-xs-6\': vm.format !== \'expanded\', \'col-xs-7\': vm.format === \'expanded\'}"><span data-translate="gestioneAttiApp.atto.numero">Numero</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-if="!vm.isCommissioneAtti" jh-sort-by="dataProtocollo" ng-class="{\'col-xs-6\': vm.format !== \'expanded\', \'col-xs-4\': vm.format === \'expanded\'}"><span data-translate="gestioneAttiApp.atto.dataProtocollo">DataProtocollo</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead></table></div></div></div><table class="jh-table table table-striped"><tbody><tr ng-repeat="atto in vm.attos track by atto.id"><td><div class="row"><div style="display: inline-block"><span style="font-size: 15px" class="atto-class-row-item atto-class-row-item-tipo-atto label label-{{atto.tipoAtto}}">{{atto.tipoAtto}} {{::atto.numeroAtto}}</span></div><div style="display: inline-block" ng-if="!vm.isCommissioneAttiEsame"><span class="atto-class-row-item atto-class-row-item-tipo-atto label label-danger" data-translate="{{::atto.statoCorrente.statoAtto.name}}">{{::atto.statoCorrente.statoAtto.name}}</span></div><div style="display: inline-block" ng-if="vm.isCommissioneAttiEsame"><span class="atto-class-row-item atto-class-row-item-tipo-atto label label-warning" style="font-size: 100%">In commissione dal: {{::atto.dataUltimoPassaggioCommissione | date:\'dd/MM/yyyy\'}}</span></div><div style="display: inline-block" ng-if="atto.numeroLegge && atto.dataPromulgazione"><span class="atto-class-row-item atto-class-row-item-tipo-atto label label-legge">Legge n. {{::atto.numeroLegge}} del {{::atto.dataPromulgazione | date:\'dd/MM/yyyy\'}}</span></div></div><div ng-if="vm.isCommissioneAtti" class="row"><div style="height: 5px"></div><span><b>PROPONENTI:</b> {{::vm.getProponentiAttoString(atto)}}</span></div><div class="row"><span ui-sref="atto-detail({id:atto.id})" style="cursor: pointer" class="atto-class-row-item atto-class-row-item-titolo"><span ng-if="atto.titoloModificato && atto.titoloModificato !== \'\' || atto.hasTitoloModificatoInCommissione || atto.hasTitoloModificatoInAula" style="color: #c7030a; font-weight: bold">[Titolo modificato]</span> {{::atto.titolo}}</span></div></td><td ng-if="!vm.isCommissioneAtti" class="hidden-xs">{{::atto.dataProtocollo| date:\'dd/MM/yyyy\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button aria-label="public view" ui-sref="atto-public-detail({id:atto.id})" ng-if="::(vm.canEdit || vm.isProtocollo) && !vm.isCommissioneAtti" class="btn btn-default btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.publicView">CITTADINO</span></button> <button aria-label="view" ui-sref="atto-detail({id:atto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.view"></span></button> <button ng-click="vm.setAttoIdForArchiveTree(atto.id)" aria-label="tree" class="btn btn-sm btn-warning"><span class="glyphicon glyphicon-folder-open"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.archive"></span></button> <button ng-if="!vm.isCommissioneAtti" aria-label="mail" ui-sref="registrazione-utente.new({id:atto.id, atto: atto})" class="btn btn-secondary btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm hidden-xs">Notifiche</span></button> <button aria-label="edit" ng-if="::vm.canEdit && !vm.isCommissioneAtti" ng-disabled="::vm.editDisabled(atto)" ui-sref="atto-edit({id:atto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.edit"></span></button> <button aria-label="delete" ng-if="vm.isAdmin && !vm.isCommissioneAtti" ng-click="vm.deleteAtto(atto.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-trash"></span> <span class="hidden-sm hidden-xs" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-model="vm.page" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-change="vm.transition()" class="pagination-sm"></uib-pagination></div></div><md-sidenav class="md-sidenav-right gestione-atti-fixed-sidenav" md-component-id="right" md-whiteframe="4" md-disable-backdrop="true"><md-content layout-padded><archive-tree atto-id="vm.attoIdForArchiveTree" ng-if="vm.attoIdForArchiveTree"></archive-tree></md-content></md-sidenav><md-sidenav class="md-sidenav-right gestione-atti-fixed-sidenav" md-component-id="advanced-search-sidebar" md-whiteframe="4" md-disable-backdrop="true" md-is-open="vm.isAdvancedSearchOpenState()"><md-content layout-padded><advanced-search search-callback="vm.advancedSearch(searchParams)" loading="vm.loading"></advanced-search></md-content></md-sidenav>');
$templateCache.put('app/components/attoTableList/basicSearchForm.html','<form ng-submit="vm.transition(true)" name="stickySearchForm"><div layout="row"><md-input-container ng-if="!vm.isCommissioneAtti" ng-class="{\'rotella-burger-open\': vm.navbarState.burgerOpen}"><a style="margin-right: 5px" ng-click="vm.toggleAdvancedSearch()"><i class="glyphicon glyphicon-cog advanced-search-toggler"></i> <span style="top: 5px; position: relative" class="hidden-xs">Ricerca avanzata</span></a></md-input-container><md-input-container ng-if="!vm.isCommissioneAtti" style="min-width: 82px" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><label data-translate="gestioneAttiApp.atto.legislatura"></label><md-select ng-model="vm.basicSearchLegislatura" ng-change="vm.transition(true)" ng-disabled="vm.loading" placeholder="{{\'gestioneAttiApp.atto.legislatura\'| translate}}"><md-option value="ALL"></md-option><md-option ng-repeat="legislatura in vm.legislature" value="{{legislatura}}">{{legislatura | romanize}}</md-option></md-select></md-input-container><md-input-container ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.basicSearchType" ng-change="vm.transition(true)" placeholder="{{\'gestioneAttiApp.atto.ricercaTipo\'| translate}}"><md-option></md-option><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container><md-input-container ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><input type="text" ng-model="vm.basicNumeroAtto" placeholder="Numero Atto"></md-input-container><md-input-container ng-if="!vm.isCommissioneAtti" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><label data-translate="gestioneAttiApp.atto.ricercaStato"></label><md-select ng-model="vm.basicSearchState" ng-change="vm.transition(true)" placeholder="{{\'gestioneAttiApp.atto.ricercaStato\'| translate}}"><md-option></md-option><md-option ng-repeat="item in ::vm.queryStates track by item.value" value="{{::item.value}}">{{item.name| translate}}</md-option></md-select></md-input-container><md-input-container ng-if="!vm.isCommissioneAtti" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><input type="text" ng-model="vm.basicSearchNumeroLegge" placeholder="Numero Legge"></md-input-container><div ng-if="!vm.isCommissioneAtti" style="display: flex; flex-direction: row" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><md-input-container><label>Data Promulgazione</label><md-datepicker ng-change="vm.transition(true)" md-hide-icons="calendar" md-open-on-focus onkeydown="return false" ng-model="vm.basicSearchDataPromulgazione"></md-datepicker></md-input-container><span ng-if="vm.basicSearchDataPromulgazione"><md-button ng-click="vm.clearDataPromulgazione()" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data promulgazione</md-tooltip></md-button></span></div><md-input-container flex ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><input type="text" ng-model="vm.basicSearchTerm" placeholder="{{\'gestioneAttiApp.atto.ricercaSegnaposto\'| translate}}"></md-input-container><md-button type="submit" ng-disabled="vm.loading" class="md-fab md-primary" ng-class="{\'hidden\': vm.isAdvancedSearchOpen()}"><i class="glyphicon glyphicon-search"></i><md-tooltip>{{\'entity.action.search\'| translate}}</md-tooltip></md-button></div></form>');
$templateCache.put('app/components/commissionBlock/commissionBlock.directive.html','<div id="commission-state-{{::vm.index}}" ng-if="::(vm.checkShowSection(vm.legitimacy) || vm.checkShowSection(vm.feasibility) || vm.checkShowSection(vm.consultations) || vm.checkShowSection(vm.commissionEmendments) || vm.checkShowSection(vm.commissionOpinions) || vm.checkShowSection(vm.workDocuments) || vm.checkShowSection(vm.financialCoverage) || vm.checkShowSection(vm.commissionMessage) || vm.checkShowSection(vm.unionProposal)) || vm.seatManagement || vm.parereCal || vm.checkShowSection(vm.resolution)" class="atto-detail-pane"><a ng-click="vm.stato.commissione.isCollapsed = !vm.stato.commissione.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.commissione.isCollapsed, \'glyphicon-eye-close\': vm.stato.commissione.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">COMMISSIONE</span> <span ng-if="vm.isAdmin" style="vertical-align: 5px"><event-mail-notification-button-component atto="vm.atto" event-type="\'ASSEGNAZIONE\'"></event-mail-notification-button-component></span><span ng-if="::vm.actType === \'PDLS\'" data-translate="gestioneAttiApp.form.lettura{{vm.index}}"></span><!-- <span ng-if="::vm.actType === \'PDLS\' && vm.index === 0" data-translate="gestioneAttiApp.form.primaLettura"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index === 1" data-translate="gestioneAttiApp.form.secondaLettura"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index > 0 && (vm.index % 2) === 0" data-translate="gestioneAttiApp.form.ritornoPrimaLettura"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index > 1 && (vm.index % 2) !== 0" data-translate="gestioneAttiApp.form.ritornoSecondaLettura"></span> --> <span ng-if="::vm.actType !== \'PDLS\' && vm.index > 0" class="rinvio-notice">{{\'gestioneAttiApp.form.rinvioCommissione\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span><div ng-show="vm.stato.commissione.isCollapsed" layout="column" layout-margin><!-- LEGITIMACY --><section class="panel atto-sezione" ng-include="::vm.sezioni.LEGITIMACY.form" ng-if="::vm.checkShowSection(vm.legitimacy) && vm.isAuthenticated" ng-cloak></section><!-- FEASIBILITY --><section class="panel atto-sezione" ng-include="::vm.sezioni.FEASIBILITY.form" ng-if="::vm.checkShowSection(vm.feasibility) && vm.isAuthenticated" ng-cloak></section><!-- CONSULTATIONS --><section class="panel atto-sezione" ng-include="::vm.sezioni.CONSULTATIONS.form" ng-if="::vm.checkShowSection(vm.consultations)" ng-cloak></section><!-- COMMISSION EMENDMENTS --><section class="panel atto-sezione" ng-include="::vm.sezioni.COMMISSION_EMENDMENTS.form" ng-if="::vm.checkShowSection(vm.commissionEmendments)" ng-cloak></section><!-- COMMISSION OPINIONS --><section class="panel atto-sezione" ng-include="::vm.sezioni.COMMISSION_OPINIONS.form" ng-if="::vm.checkShowSection(vm.commissionOpinions)" ng-cloak></section><!-- WORK DOCUMENTS --><section class="panel atto-sezione" ng-include="::vm.sezioni.WORK_DOCUMENTS.form" ng-if="::vm.checkShowSection(vm.workDocuments)" ng-cloak></section><!--PARERE CAL--><section class="panel atto-sezione" ng-include="::vm.sezioni.PARERE_CAL.form" ng-if="vm.parereCal" ng-cloak></section><!--RESOLUTION--><section class="panel atto-sezione" ng-include="::vm.sezioni.RESOLUTION.form" ng-if="vm.resolution" ng-cloak></section><!-- FINANCIAL COVERAGE --><section class="panel atto-sezione" ng-include="::vm.sezioni.FINANCIAL_COVERAGE.form" ng-if="::vm.checkShowSection(vm.financialCoverage)" ng-cloak></section><!-- COMMISSION MESSAGE --><section class="panel atto-sezione" ng-include="::vm.sezioni.COMMISSION_MESSAGE.form" ng-if="::vm.checkShowSection(vm.commissionMessage)" ng-cloak></section><!-- UNION PROPOSAL --><section class="panel atto-sezione" ng-include="::vm.sezioni.UNION_PROPOSAL.form" ng-if="::vm.checkShowSection(vm.unionProposal)" ng-cloak></section><!-- REFERENDUM REPORT --><section class="panel atto-sezione" ng-include="::vm.sezioni.REFERENDUM_REPORT.form" ng-if="::(vm.unionProposal && vm.unionProposal.metadati && vm.unionProposal.metadati.proposal === true && vm.checkShowSection(vm.referendumReport))" ng-cloak></section><!-- UNIFIED TEXT --><section class="panel atto-sezione" ng-include="::vm.sezioni.UNIFIED_TEXT.form" ng-if="vm.checkShowSection(vm.unifiedText)" ng-cloak></section><!-- SEAT MANAGEMENT --><section class="panel atto-sezione" ng-include="::vm.sezioni.SEAT_MANAGEMENT.form" ng-if="vm.seatManagement" ng-cloak></section><!-- DECADENCE --><section class="panel atto-sezione" ng-include="::vm.sezioni.DECADENCE.form" ng-if="vm.checkShowSection(vm.decadence)" ng-cloak></section></div></div>');
$templateCache.put('app/components/commissionBlock/commissionEmendments.html','<div class="panel-heading"><a class="hand glyphicon" name="commissionEmendments{{vm.fieldSuffix}}" ng-click="vm.commissionEmendments.visible = !vm.commissionEmendments.visible" ng-class="{\'glyphicon-chevron-down\': !vm.commissionEmendments.visible, \'glyphicon-chevron-up\': vm.commissionEmendments.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.commissionEmendments" ng-class="{\'readonly-section\': !vm.commissionEmendments.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.commissionEmendments.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="commission-emendments-body" ng-if="vm.commissionEmendments.visible" class="panel-body" layout-padding><form name="commissionEmendmentsForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.commissionEmendments.emendamentiPresentatiCommissione"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\'md-primary\': vm.commissionEmendments.metadati.emendamentiPresentatiCommissione}" ng-click="vm.commissionEmendments.metadati.emendamentiPresentatiCommissione = true" ng-disabled="!vm.commissionEmendments.editable && !vm.isProtocollo">Si</md-button><md-button class="md-raised" ng-class="{\'md-primary\': !vm.commissionEmendments.metadati.emendamentiPresentatiCommissione}" ng-click="vm.commissionEmendments.metadati.emendamentiPresentatiCommissione = false" ng-disabled="!vm.commissionEmendments.editable && !vm.isProtocollo">No</md-button></div></div><div flex-offset-gt-xs="5"><emendments ng-if="vm.commissionEmendments.metadati.emendamentiPresentatiCommissione" editable="::(vm.commissionEmendments.editable || vm.isProtocollo)" emendments="vm.commissionEmendments.metadati.emendamentiPresentati" sezione-id="vm.commissionEmendments.id" include-state="true" invalid-fields="vm.invalidFields" ng-cloak people-list="vm.peopleList" postponement-number="vm.iterationIndex" validating="vm.validating"></emendments></div></form></div><div class="panel-footer" ng-if="vm.commissionEmendments.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.commissionEmendments.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.commissionEmendments" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/commissionMessage.html','<div class="panel-heading"><a class="hand glyphicon" name="commissionMessage{{vm.fieldSuffix}}" ng-click="vm.commissionMessage.visible = !vm.commissionMessage.visible" ng-class="{\'glyphicon-chevron-down\': !vm.commissionMessage.visible, \'glyphicon-chevron-up\': vm.commissionMessage.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.commissionMessage" ng-class="{\'readonly-section\': !vm.commissionMessage.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.commissionMessage.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.commissionMessage.visible" id="commission-message-body" class="panel-body" layout-padding><form name="commissionMessageForm" layout="column"><div ng-if="vm.actType !== \'REL\'"><fieldset><div layout="row" layout-xs="column" layout-align-gt-xs="start end"><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.commissionMessage.metadati.modificaOggettoTitolo" ng-disabled="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)"><label data-translate="gestioneAttiApp.form.commissionMessage.modificaOggettoTitolo" ng-click="vm.clearRadio(!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission), vm.commissionMessage, \'modificaOggettoTitolo\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'modificaOggettoTitolo\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div style="width: 50%"><md-input-container style="width: 50%" ng-if="vm.commissionMessage.metadati.modificaOggettoTitolo" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.commissionMessage.nuovoOggettoTitolo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'nuovoOggettoTitolo\')}"></label><input ng-if="!(!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission))" ng-model="vm.commissionMessage.metadati.nuovoOggettoTitolo"> <input ng-if="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)" readonly="readonly" ng-model="vm.commissionMessage.metadati.nuovoOggettoTitolo"><md-tooltip md-z-index="9999" ng-if="vm.commissionMessage.metadati.nuovoOggettoTitolo" md-direction="bottom">{{vm.commissionMessage.metadati.nuovoOggettoTitolo}}</md-tooltip></md-input-container></div></div></fieldset><fieldset><div layout="row" layout-xs="column" layout-align="start start"><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.commissionMessage.metadati.modificaTesto" ng-disabled="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)"><label data-translate="gestioneAttiApp.form.commissionMessage.modificaTesto" ng-click="vm.clearRadio(!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission), vm.commissionMessage, \'modificaTesto\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'modificaTesto\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div layout="column" ng-if="vm.commissionMessage.metadati.modificaTesto" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.commissionMessage.tipoModifica" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoModifica\')}"></label><md-checkbox class="md-primary" value="drafting" ng-disabled="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)" ng-checked="vm.exists(\'drafting\', vm.commissionMessage.metadati.tipoModifica)" ng-click="vm.toggle(\'drafting\', vm.commissionMessage.metadati, \'tipoModifica\');">{{\'gestioneAttiApp.form.commissionMessage.drafting\' | translate}}</md-checkbox><md-checkbox class="md-primary" value="sostanziali" ng-disabled="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)" ng-checked="vm.exists(\'sostanziali\', vm.commissionMessage.metadati.tipoModifica)" ng-click="vm.toggle(\'sostanziali\', vm.commissionMessage.metadati, \'tipoModifica\');">{{\'gestioneAttiApp.form.commissionMessage.sostanziali\' | translate}}</md-checkbox></div></div></fieldset></div><div ng-if="!vm.isAttoMinore" flex-offset-gt-xs="5"><md-radio-group ng-model="vm.commissionMessage.metadati.propostaRisoluzione" ng-disabled="!vm.commissionMessage.editable"><label data-translate="gestioneAttiApp.form.commissionMessage.propostaRisoluzione" ng-click="vm.clearRadio(!vm.commissionMessage.editable, vm.commissionMessage, \'propostaRisoluzione\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'propostaRisoluzione\')}"></label><md-radio-button value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button value="false" class="md-primary">No</md-radio-button></md-radio-group></div><ng-container flex-offset-gt-xs="5" style="margin-top: 10px" ng-if="vm.actType === \'REL\' && vm.commissionMessage.metadati.propostaRisoluzione === \'true\'"><label data-translate="gestioneAttiApp.form.commissionMessage.numeroPdris" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroPdris\')}"></label><md-chips flex ng-model="vm.pdrisSelectedChip" md-on-select="false" md-on-add="vm.onChipAdd($index, $chip)" md-on-remove="vm.onRemoveChip($index, $chip, $event)" md-max-chips="1" ng-class="{\'md-focused\': false}" readonly="!vm.commissionMessage.editable || (!vm.isAdmin && !vm.isPrimaryCommission)"><md-autocomplete md-selected-item="vm.numeroPropostaRisoluzione" md-search-text="vm.numeroPdrisSearchText" md-items="item in vm.searchPdris(vm.numeroPdrisSearchText)" md-item-text="item.numeroAtto" md-no-cache="true" placeholder="Numero Proposta di risoluzione"><span md-highlight-text="vm.selectedAttoSearchText">[{{item.legislatura | romanize}}][{{item.tipoAtto}}] {{item.numeroAtto}}: {{item.titolo}}</span></md-autocomplete><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span>[{{$chip.legislatura | romanize}}]<b>[{{$chip.tipoAtto}}]</b> {{$chip.numeroAtto}}: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></ng-container></form></div><div class="panel-footer" ng-if="vm.commissionMessage.visible"><document-toolbar section="::vm.commissionMessage" document-types="::vm.docTypes" include-notes="true" editable="::(vm.commissionMessage.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/commissionOpinions.html','<div class="panel-heading"><a class="hand glyphicon" name="commissionOpinions{{vm.fieldSuffix}}" ng-click="vm.commissionOpinions.visible = !vm.commissionOpinions.visible" ng-class="{\'glyphicon-chevron-down\': !vm.commissionOpinions.visible, \'glyphicon-chevron-up\': vm.commissionOpinions.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.commissionOpinions" ng-class="{\'readonly-section\': !vm.commissionOpinions.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.commissionOpinions.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="commission-opinions-body" class="panel-body" ng-if="vm.commissionOpinions.visible"><md-content layout-padding><form name="commissionOpinionsForm"><div ng-repeat="soggetto in vm.soggettiOpinioni[\'SECONDARIO\']" class="commission-opinion-block" ng-if="vm.showNonPrimaryOpinion()"><commission-opinion editable="::vm.isCommissionOpinionEditable([soggetto])" act-type="vm.actType" favorable-option-enabled="false" not-expressed-option-enabled="false" include-investigation-board="true" include-meeting-dates="true" invalid-fields="vm.invalidFields" validating="vm.validating" metadata="vm.commissionOpinions.metadati.parereSecondario" ng-cloak postponement-number="vm.iterationIndex" subjects="::[soggetto]" title="{{\'gestioneAttiApp.form.commissionOpinions.parereSecondario\'| translate}}"></commission-opinion></div><div ng-repeat="soggetto in vm.soggettiOpinioni[\'DI_MERITO\']" class="commission-opinion-block" ng-if="vm.showNonPrimaryOpinion()"><commission-opinion editable="::vm.isCommissionOpinionEditable([soggetto])" act-type="vm.actType" favorable-option-enabled="false" not-expressed-option-enabled="false" include-investigation-board="true" include-meeting-dates="true" invalid-fields="vm.invalidFields" validating="vm.validating" metadata="vm.commissionOpinions.metadati.parereDiMerito" ng-cloak postponement-number="vm.iterationIndex" subjects="::[soggetto]" title="{{\'gestioneAttiApp.form.commissionOpinions.parereDiMerito\'| translate}}"></commission-opinion></div><div ng-repeat="soggetto in vm.soggettiOpinioni[\'ISTITUZIONALE\']" class="commission-opinion-block" ng-if="vm.showNonPrimaryOpinion()"><commission-opinion editable="::vm.isCommissionOpinionEditable([soggetto])" act-type="vm.actType" favorable-option-enabled="true" not-expressed-option-enabled="false" include-investigation-board="true" include-meeting-dates="true" invalid-fields="vm.invalidFields" validating="vm.validating" metadata="vm.commissionOpinions.metadati.parereIstituzionale" ng-cloak postponement-number="vm.iterationIndex" subjects="::[soggetto]" title="{{\'gestioneAttiApp.form.commissionOpinions.parereIstituzionale\'| translate}}"></commission-opinion></div><div ng-repeat="soggetto in vm.soggettiOpinioni[\'OBBLIGATORIO\']" class="commission-opinion-block" ng-if="vm.showNonPrimaryOpinion()"><commission-opinion editable="::vm.isExternalSubjectOpionionEditable([soggetto])" act-type="vm.actType" favorable-option-enabled="true" not-expressed-option-enabled="true" invalid-fields="vm.invalidFields" validating="vm.validating" metadata="vm.commissionOpinions.metadati.parereObbligatorio" ng-cloak postponement-number="vm.iterationIndex" subjects="::[soggetto]" title="{{\'gestioneAttiApp.form.commissionOpinions.parereObbligatorio\'| translate}}"></commission-opinion></div><div ng-repeat="soggetto in vm.soggettiOpinioni[\'OSSERVAZIONI\']" class="commission-opinion-block" ng-if="vm.showNonPrimaryOpinion()"><commission-observation title="{{\'gestioneAttiApp.form.commissionOpinions.osservazioni\'| translate}}" metadata="vm.commissionOpinions.metadati.osservazioni" subjects="::[soggetto]" act-type="vm.actType" editable="::vm.isExternalSubjectOpionionEditable([soggetto])" invalid-fields="vm.invalidFields" validating="vm.validating" postponement-number="vm.iterationIndex" ng-cloak></commission-observation></div><div class="commission-opinion-block"><commission-opinion authority="[\'ROLE_COMMISSIONE\']" editable="::vm.isCommissionOpinionEditable(vm.soggettiOpinioni[\'REFERENTE\'])" act-type="vm.actType" favorable-option-enabled="false" not-expressed-option-enabled="false" include-meeting-dates="true" invalid-fields="vm.invalidFields" validating="vm.validating" metadata="vm.commissionOpinions.metadati.parereReferente" ng-cloak postponement-number="vm.iterationIndex" subjects="::vm.soggettiOpinioni[\'REFERENTE\']" title="{{\'gestioneAttiApp.form.commissionOpinions.parereReferente\'| translate}}"></commission-opinion></div></form></md-content></div><div class="panel-footer" ng-if="vm.commissionOpinions.visible"><document-toolbar document-types="::vm.docTypes" section="::vm.commissionOpinions" include-notes="true" editable="::(vm.commissionOpinions.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/consultations.html','<div class="panel-heading"><a class="hand glyphicon" name="consultations{{vm.fieldSuffix}}" ng-click="vm.consultations.visible = !vm.consultations.visible" ng-class="{\'glyphicon-chevron-down\': !vm.consultations.visible, \'glyphicon-chevron-up\': vm.consultations.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.consultations" ng-class="{\'readonly-section\': !vm.consultations.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.consultations.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="consultations-body" class="panel-body" ng-if="vm.consultations.visible" layout-padding><form name="consultationsForm" layout="row" layout-xs="column"><div flex-gt-xs="45" flex-offset-gt-xs="5"><addable-input input-type="\'date\'" input-model="vm.consultations.metadati.dateConsultazioni" date-label="\'gestioneAttiApp.form.consultations.dateConsultazioni\'" disabled="!vm.consultations.editable" style="width: 100%"></addable-input></div><div flex-gt-xs="50"><addable-input input-type="\'date\'" input-model="vm.consultations.metadati.dateAudizioni" date-label="\'gestioneAttiApp.form.consultations.dateAudizioni\'" disabled="!vm.consultations.editable" style="width: 100%"></addable-input></div></form></div><div class="panel-footer" ng-if="vm.consultations.visible"><document-toolbar section="::vm.consultations" document-types="::vm.docTypes" include-notes="true" editable="::(vm.consultations.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/decadence.html','<div class="panel-heading"><a class="hand glyphicon" name="decadence" ng-click="vm.decadence.visible = !vm.decadence.visible" ng-class="{\'glyphicon-chevron-down\': !vm.decadence.visible, \'glyphicon-chevron-up\': vm.decadence.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.decadence" ng-class="{\'readonly-section\': !vm.decadence.editable && !vm.isCommission}"></span></div><div ng-if="vm.decadence.visible" id="decadence-letter-body" class="panel-body" layout-padding><form name="decadenzaForm" layout="column"><!-- <div layout="row" flex-offset-gt-xs="5" layout-align-xs="start start" style="margin-top: 30px;">\r\n            <addable-input input-type="\'date\'"\r\n                input-model="vm.decadence.metadati.dataDecadenza"\r\n                inner-label="true"\r\n                date-label="\'gestioneAttiApp.form.decadenza.dataDecadenza\'"\r\n                disabled="!vm.decadence.editable"\r\n                class="testo-sostitutivo-datepicker"\r\n                style="width: 100%">\r\n            </addable-input>\r\n        </div> --><div layout="row" flex-offset-gt-xs="5" layout-align-xs="start start" style="margin-top: 30px"><md-input-container><label data-translate="gestioneAttiApp.form.decadenza.dataDecadenza"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.decadence.metadati.dataDecadenza" ng-disabled="!vm.decadence.editable"></md-datepicker></md-input-container><span ng-if="vm.decadence.metadati.dataDecadenza && vm.decadence.editable"><md-button ng-click="vm.decadence.metadati.dataDecadenza = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data decadenza</md-tooltip></md-button></span></div><md-input-container flex="grow" flex-offset-gt-xs="5" layout-align-xs="start start"><label data-translate="gestioneAttiApp.form.decadenza.noteDecadenza"></label><textarea ng-model="vm.decadence.metadati.noteDecadenza" ng-disabled="!vm.decadence.editable"></textarea></md-input-container></form></div><div class="panel-footer" ng-if="vm.decadence.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.decadence.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.decadence" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/feasibility.html','<div class="panel-heading"><a class="hand glyphicon" name="feasibility{{vm.fieldSuffix}}" ng-click="vm.feasibility.visible = !vm.feasibility.visible" ng-class="{\'glyphicon-chevron-down\': !vm.feasibility.visible, \'glyphicon-chevron-up\': vm.feasibility.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.feasibility" ng-class="{\'readonly-section\': !vm.feasibility.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.feasibility.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="feasibility-body" ng-if="vm.feasibility.visible" class="panel-body" layout-padding=""><form name="feasibilityForm" layout="row"><fieldset class="standart"><div layout="column" layout-xs="column" layout-align="start start"><div flex-offset-gt-xs="5"><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'SCHEDA_FATTIBILITA\' + vm.fieldSuffix]" ng-model="vm.feasibility.metadati.fattibilita">{{\'gestioneAttiApp.form.feasibility.feasibility\' | translate}}</md-checkbox></div><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.feasibility.metadati.rilieviFattibilita" ng-show="vm.workDocumentsMap[\'SCHEDA_FATTIBILITA\' + vm.fieldSuffix]" ng-disabled="!vm.feasibility.editable || !(vm.isAdmin || vm.isFeasibility)" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.feasibility.rilieviTitle" ng-click="vm.clearRadio(!vm.feasibility.editable || !(vm.isAdmin || vm.isFeasibility), vm.feasibility, \'rilieviFattibilita\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviFattibilita\')}"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.feasibility.rilievi\'| translate}}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.feasibility.noRilievi\'| translate}}</md-radio-button></md-radio-group></div></div></fieldset></form></div><div class="panel-footer" ng-if="vm.feasibility.visible"><document-toolbar section="::vm.feasibility" document-types="::vm.docTypes" include-notes="true" editable="::(vm.feasibility.editable || vm.isProtocollo)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/financialCoverage.html','<div class="panel-heading"><a class="hand glyphicon" name="financialCoverage{{vm.fieldSuffix}}" ng-click="vm.financialCoverage.visible = !vm.financialCoverage.visible" ng-class="{\'glyphicon-chevron-down\': !vm.financialCoverage.visible, \'glyphicon-chevron-up\': vm.financialCoverage.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.financialCoverage" ng-class="{\'readonly-section\': !vm.financialCoverage.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.financialCoverage.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.financialCoverage.visible" id="financial-coverage-body" class="panel-body" layout-padding><form name="financialCoverageForm" layout="column"><fieldset class="standard"><legend data-translate="gestioneAttiApp.form.financialCoverage.coperturaFinanziaria"></legend><div layout-gt-xs="row" layout-align="start start"><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.financialCoverage.metadati.coperturaRichiesta" ng-disabled="!vm.financialCoverage.editable"><label data-translate="gestioneAttiApp.form.financialCoverage.richiesta" ng-click="vm.clearRadio(!vm.financialCoverage.editable, vm.financialCoverage, \'coperturaRichiesta\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'coperturaRichiesta\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary" ng-click="vm.clearRadio(!vm.financialCoverage.editable, vm.financialCoverage, \'coperturaAcquisita\')">No</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.financialCoverage.metadati.coperturaAcquisita" ng-if="vm.financialCoverage.metadati.coperturaRichiesta" ng-disabled="!vm.financialCoverage.editable"><label data-translate="gestioneAttiApp.form.financialCoverage.coperturaAcquisita" ng-click="vm.clearRadio(!vm.financialCoverage.editable, vm.financialCoverage, \'coperturaAcquisita\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'coperturaAcquisita\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div></fieldset></form></div><div class="panel-footer" ng-if="vm.financialCoverage.visible"><document-toolbar section="::vm.financialCoverage" document-types="::vm.docTypes" include-notes="true" editable="::(vm.financialCoverage.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/legitimacy.html','<div class="panel-heading"><a class="hand glyphicon" name="legitimacy{{vm.fieldSuffix}}" ng-click="vm.legitimacy.visible = !vm.legitimacy.visible" ng-class="{\'glyphicon-chevron-down\': !vm.legitimacy.visible, \'glyphicon-chevron-up\': vm.legitimacy.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.legitimacy" ng-class="{\'readonly-section\': !vm.legitimacy.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.legitimacy.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div ng-show="vm.legitimacy.visible" id="legitimacy-body" class="panel-body" layout-padding><form name="legitimacyForm" layout="row"><!--<md-content layout-padding layout="row"> --><fieldset class="standard"><div layout="column" layout-align="start start"><div flex-offset-gt-xs="5"><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_REF\' + vm.fieldSuffix]" ng-model="vm.legitimacy.metadati.legittimita">{{\'gestioneAttiApp.form.legitimacy.primaryLegitimacy\' | translate}}</md-checkbox></div><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.legitimacy.metadati.rilieviLegittimita" ng-show="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_REF\' + vm.fieldSuffix]" ng-disabled="!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy)" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.legitimacy.rilieviTitle" ng-click="vm.clearRadio(!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy), vm.legitimacy, \'rilieviLegittimita\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviLegittimita\')}"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.rilievi\'| translate}}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.noRilievi\'| translate}}</md-radio-button></md-radio-group></div></div></fieldset><fieldset class="standard"><div layout="column" layout-align="start start"><div flex-offset-gt-xs="5"><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_SEC\' + vm.fieldSuffix]">{{\'gestioneAttiApp.form.legitimacy.secondaryLegitimacy\' | translate}}</md-checkbox></div><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.legitimacy.metadati.rilieviLegittimitaSecondaria" ng-show="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_SEC\' + vm.fieldSuffix]" ng-disabled="!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy)" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.legitimacy.rilieviTitle" ng-click="vm.clearRadio(!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy), vm.legitimacy, \'rilieviLegittimitaSecondaria\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviLegittimitaSecondaria\')}"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.rilievi\'| translate}}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.noRilievi\'| translate}}</md-radio-button></md-radio-group></div></div></fieldset><fieldset class="standard"><div layout="column" layout-align="start start"><div flex-offset-gt-xs="5"><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_IST\' + vm.fieldSuffix]">{{\'gestioneAttiApp.form.legitimacy.institutionalLegitimacy\' | translate}}</md-checkbox></div><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.legitimacy.metadati.rilieviLegittimitaIstituzionale" ng-show="vm.workDocumentsMap[\'SCHEDA_LEGITTIMITA_IST\' + vm.fieldSuffix]" ng-disabled="!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy)" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.legitimacy.rilieviTitle" ng-click="vm.clearRadio(!vm.legitimacy.editable || !(vm.isAdmin || vm.isLegitimacy), vm.legitimacy, \'rilieviLegittimitaIstituzionale\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviLegittimitaIstituzionale\')}"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.rilievi\'| translate}}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.legitimacy.noRilievi\'| translate}}</md-radio-button></md-radio-group></div></div></fieldset><!-- </md-content>  --></form></div><div class="panel-footer" ng-if="vm.legitimacy.visible"><document-toolbar section="::vm.legitimacy" document-types="::vm.docTypes" include-notes="true" editable="::(vm.legitimacy.editable || vm.isProtocollo)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/parereCal.html','<div class="panel-heading"><!-- <a class="hand glyphicon " name="parereCal{{vm.fieldSuffix}}"\r\n       ng-click="vm.parereCal.visible = !vm.parereCal.visible"\r\n       ng-class="{\'glyphicon-chevron-down\': !vm.parereCal.visible, \'glyphicon-chevron-up\': vm.parereCal.visible}">\r\n    </a> --> <span data-translate="gestioneAttiApp.form.sezioni.parereCal" ng-class="{\'readonly-section\': !((vm.parereCal.editable && vm.userSoggettiEsterniMap.isCAL ) || vm.isProtocollo || vm.isAdmin)}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.parereCal.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div class="panel-footer" ng-if="vm.parereCal.visible"><document-toolbar section="::vm.parereCal" document-types="::vm.docTypes" include-notes="true" editable="::((vm.parereCal.editable && vm.userSoggettiEsterniMap.isCAL ) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/referendumReport.html','<div class="panel-heading"><a class="hand glyphicon" name="referendumReport{{vm.fieldSuffix}}" ng-click="vm.referendumReport.visible = !vm.referendumReport.visible" ng-class="{\'glyphicon-chevron-down\': !vm.referendumReport.visible, \'glyphicon-chevron-up\': vm.referendumReport.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.referendumReport" ng-class="{\'readonly-section\': !vm.referendumReport.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.referendumReport.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="referendum-report-message-body" class="panel-body" ng-if="vm.referendumReport.visible"><md-content layout-padding><form name="referendumReportForm"><div layout-gt-xs="row"><div flex="100" flex-gt-xs="25" layout="column" flex-offset-gt-xs="5"><md-radio-group ng-model="vm.referendumReport.metadati.reportAcquisito" ng-disabled="!vm.referendumReport.editable"><label data-translate="gestioneAttiApp.form.referendumReport.reportAcquisito" ng-click="vm.clearRadio(!vm.referendumReport.editable, vm.referendumReport, \'reportAcquisito\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div></form></md-content></div><div class="panel-footer" ng-if="vm.referendumReport.visible"><document-toolbar section="::vm.referendumReport" document-types="::vm.docTypes" include-notes="true" editable="::(vm.referendumReport.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/resolution.html','<div class="panel-heading"><a class="hand glyphicon" name="resolution{{vm.fieldSuffix}}" ng-click="vm.resolution.visible = !vm.resolution.visible" ng-class="{\'glyphicon-chevron-down\': !vm.resolution.visible, \'glyphicon-chevron-up\': vm.resolution.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.resolution" ng-class="{\'readonly-section\': !((vm.resolution.editable) || vm.isProtocollo || vm.isAdmin)}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.resolution.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.risoluzioni"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n            \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.resolution.resolutionsPresent = true" ng-disabled="::(!vm.resolution.editable\r\n                                    || !vm.isAdmin )">Si</md-button><md-button class="md-raised" ng-class="{\r\n            \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.resolution.resolutionsPresent = false" ng-disabled="::(!vm.resolution.editable\r\n                || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))">No</md-button></div><div flex-offset-gt-xs="5" ng-if="vm.resolution.resolutionsPresent === true"><addable-input input-type="\'resolution\'" input-model="vm.resolution.metadati.resolution" date-label="\'gestioneAttiApp.form.consultations.dateConsultazioni\'" disabled="!vm.resolution.editable" text-label="\'N\xB0 Risoluzione\'" style="width: 100%"></addable-input></div><div class="panel-footer" ng-if="vm.resolution.visible"><document-toolbar section="::vm.resolution" document-types="::vm.docTypes" include-notes="true" editable="::((vm.resolution.editable) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/seatManagement.html','<div class="panel-heading"><a class="hand glyphicon" name="seatManagement" ng-click="vm.seatManagement.visible = !vm.seatManagement.visible" ng-class="{\'glyphicon-chevron-down\': !vm.seatManagement.visible, \'glyphicon-chevron-up\': vm.seatManagement.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.seatManagement" ng-class="{\'readonly-section\': !vm.seatManagement.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.seatManagement.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-meeting-body" ng-if="vm.seatManagement.visible" class="panel-body"><form name="seatManagementForm"><addable-input input-type="\'date\'" disabled="!vm.seatManagement.editable" date-label="\'gestioneAttiApp.form.courtMeeting.sessionsDate\'" input-model="vm.seatManagement.metadati.sedute" invalid-fields="vm.invalidFields" validating="vm.validating" field-name="sessionsDate" style="width: 100%"></addable-input><addable-input input-type="\'date\'" disabled="!vm.seatManagement.editable" date-label="\'gestioneAttiApp.form.courtMeeting.trattazioneDate\'" input-model="vm.seatManagement.metadati.seduteTrattazione" invalid-fields="vm.invalidFields" validating="vm.validating" field-name="trattazioneDate" style="width: 100%"></addable-input><div layout-gt-sm="row" layout-xs="column"><div style="margin-top: 15px"><md-input-container style="margin-top: 60px; margin-left: -5px"><label>Data Esito</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.seatManagement.metadati.dataEsito" ng-disabled="!vm.seatManagement.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'esitoDate\')}"></md-datepicker></md-input-container><span ng-if="vm.seatManagement.metadati.dataEsito && vm.seatManagement.editable"><md-button ng-click="vm.seatManagement.metadati.dataEsito = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data esito</md-tooltip></md-button></span></div><div ng-if="vm.actType === \'PEA\' || vm.actType === \'DEA\' || vm.actType === \'PEL\'" flex-offset-gt-xs="5" style="margin-top: 20px"><md-radio-group ng-model="vm.seatManagement.metadati.parere"><label data-translate="commissionOpinion.parere" ng-click="vm.seatManagement.metadati.parere = null;" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parere\', vm.subjectId)}"></label><md-radio-button value="FAVORABLE" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.favorevole\'| translate}}</md-radio-button><md-radio-button ng-if="vm.actType === \'PEA\'" value="CONDITIONED_FAVORABLE" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.favorevoleCondizionato\'| translate}}</md-radio-button><md-radio-button value="UNFAVORABLE" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.contrario\'| translate}}</md-radio-button><md-radio-button value="NOT_EXPRESSED" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.nonEspresso\'| translate}}</md-radio-button></md-radio-group></div><div ng-if="(vm.actType === \'PEA\' || vm.actType === \'DEA\' || vm.actType === \'PEL\') && vm.seatManagement.metadati.parere" flex-offset-gt-xs="5" style="margin-top: 20px"><md-radio-group ng-model="vm.seatManagement.metadati.tipoFavorevolezza"><label data-translate="commissionOpinion.tipoFavorevolezza" ng-click="vm.clearRadio(\'tipoFavorevolezza\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoFavorevolezza\', vm.subjectId)}"></label><md-radio-button value="MAJORITY" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.maggioranza\'| translate}}</md-radio-button><md-radio-button value="ALL" class="md-primary" ng-disabled="!vm.seatManagement.editable">{{\'commissionOpinion.unanimita\'| translate}}</md-radio-button></md-radio-group></div></div></form></div><div class="panel-footer" ng-if="vm.seatManagement.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.seatManagement.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.seatManagement" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/unifiedText.html','<div class="panel-heading"><a class="hand glyphicon" name="unifiedText{{vm.fieldSuffix}}" ng-click="vm.unifiedText.visible = !vm.unifiedText.visible" ng-class="{\'glyphicon-chevron-down\': !vm.unifiedText.visible, \'glyphicon-chevron-up\': vm.unifiedText.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.unifiedText" ng-class="{\'readonly-section\': !vm.unifiedText.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.unifiedText.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div id="unified-text-body" class="panel-body" ng-if="vm.unifiedText.visible"><form name="unifiedTextForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.sezioni.unifiedText" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'hasUnifiedTexts\')}"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\'md-primary\': vm.unifiedText.metadati.hasUnifiedTexts}" ng-click="vm.toogleAddUnifiedText(true)" ng-disabled="!vm.unifiedText.editable">Si</md-button><md-button class="md-raised" ng-class="{\'md-primary\': !vm.unifiedText.metadati.hasUnifiedTexts}" ng-click="vm.toogleAddUnifiedText(false)" ng-disabled="!vm.unifiedText.editable">No</md-button></div></div><div ng-if="vm.unifiedText.metadati.hasUnifiedText" class="spacer"></div><div ng-if="vm.unifiedText.metadati.hasUnifiedTexts" layout="row" layout-xs="column" layout-align="space-between start" flex-offset-gt-xs="5"><md-chips ng-model="vm.unifiedTextsModel" md-on-add="vm.onAddUnifiedText($index, $chip)" md-on-remove="vm.onRemoveUnifiedText($index, $chip, $event)" md-on-select="false" md-transform-chip="vm.transformChip($chip)" readonly="::!vm.unifiedText.editable" ng-class="{\'md-focused\': false}"><md-autocomplete md-selected-item="vm.selectedUnifiedTextActRef" md-search-text="vm.numeroAttoSearchText" md-items="item in vm.searchAtti(vm.numeroAttoSearchText)" md-item-text="item.numeroAtto" md-no-cache="true" placeholder="Numero atto"><span md-highlight-text="vm.selectedAttoSearchText">{{item.numeroAtto}}: {{item.titolo}}</span></md-autocomplete><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span>{{$chip.numeroAtto}}: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div></form></div><div class="panel-footer" ng-if="vm.unifiedText.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.unifiedText.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.unifiedText" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/unionProposal.html','<div class="panel-heading"><a class="hand glyphicon" name="unionProposal{{vm.fieldSuffix}}" ng-click="vm.unionProposal.visible = !vm.unionProposal.visible" ng-class="{\'glyphicon-chevron-down\': !vm.unionProposal.visible, \'glyphicon-chevron-up\': vm.unionProposal.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.unionProposal" ng-class="{\'readonly-section\': !vm.unionProposal.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.unionProposal.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div id="union-proposal-message-body" class="panel-body" ng-if="vm.unionProposal.visible" layout-padding=""><form name="unionProposalForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.sezioni.unionProposal"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': vm.unionProposal.metadati.proposal}" ng-click="vm.unionProposal.metadati.proposal = true" ng-disabled="!vm.unionProposal.editable">Si</md-button><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': !vm.unionProposal.metadati.proposal}" ng-click="vm.unionProposal.metadati.proposal = false" ng-disabled="!vm.unionProposal.editable">No</md-button></div></div><div ng-if="vm.unionProposal.metadati.proposal === true" class="spacer"></div><div ng-if="vm.unionProposal.metadati.proposal === true" layout="row" layout-xs="column" layout-align="space-around" layout-align-xs="start start"><div layout="row" layout-xs="column"><md-input-container><label data-translate="gestioneAttiApp.form.unionProposal.proposalDate"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.unionProposal.metadati.proposalDate" ng-disabled="!vm.unionProposal.editable"></md-datepicker></md-input-container><span ng-if="vm.unionProposal.metadati.proposalDate && vm.unionProposal.editable"><md-button ng-click="vm.unionProposal.metadati.proposalDate = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data proposta</md-tooltip></md-button></span></div><md-radio-group ng-model="vm.unionProposal.metadati.referendumProposal" ng-disabled="!vm.unionProposal.editable"><label data-translate="gestioneAttiApp.form.unionProposal.referendumProposal" ng-click="vm.clearRadio(!vm.unionProposal.editable, vm.unionProposal, \'referendumProposal\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.unionProposal.proposalNumber"></label><input type="number" ng-model="vm.unionProposal.metadati.proposalNumber" ng-disabled="!vm.unionProposal.editable"></md-input-container></div></form></div><div class="panel-footer" ng-if="vm.unionProposal.visible"><document-toolbar section="::vm.unionProposal" document-types="::vm.docTypes" include-notes="true" editable="::(vm.unionProposal.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionBlock/workDocuments.html','<div class="panel-heading"><a class="hand glyphicon" name="workDocuments{{vm.fieldSuffix}}" ng-click="vm.workDocuments.visible = !vm.workDocuments.visible" ng-class="{\'glyphicon-chevron-down\': !vm.workDocuments.visible, \'glyphicon-chevron-up\': vm.workDocuments.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.workDocuments" ng-class="{\'readonly-section\': !vm.workDocuments.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.workDocuments.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="work-documents-body" class="panel-body" ng-if="vm.workDocuments.visible" flex-offset-gt-xs="5"><md-content layout-padding><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'SCHEDA_ISTRUTTORIA\' + vm.fieldSuffix]">{{\'gestioneAttiApp.form.workDocuments.schedaIstruttoria\' | translate}}</md-checkbox><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'TESTI_FRONTE\' + vm.fieldSuffix]" flex-offset-gt-xs="5">{{\'gestioneAttiApp.form.workDocuments.testiFronte\' | translate}}</md-checkbox><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'IPOTESI_TESTO\' + vm.fieldSuffix]" flex-offset-gt-xs="5">{{\'gestioneAttiApp.form.workDocuments.ipotestiTesto\' | translate}}</md-checkbox><!--         <md-checkbox ng-if="vm.actType !== \'PLIP\'" class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'RASSEGNA_STAMPA\' + vm.fieldSuffix]" flex-offset-gt-xs="5">\r\n            {{\'gestioneAttiApp.form.workDocuments.rassegnaStampa\' | translate}}\r\n        </md-checkbox> --><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'CORRISPONDENZA_VARIA\' + vm.fieldSuffix]" flex-offset-gt-xs="5">{{\'gestioneAttiApp.form.workDocuments.corrispondenzaVaria\' | translate}}</md-checkbox></md-content></div><div class="panel-footer" ng-if="vm.workDocuments.visible"><document-toolbar section="::vm.workDocuments" document-types="::vm.docTypes" include-notes="true" editable="::(vm.workDocuments.editable || vm.isProtocollo)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionObservation/commissionObservation.directive.html','<div class="commission-opinion" ng-class="{\'commission-opinion-editable\': vm.editable}"><h3 class="commission-opinion-title" ng-bind="::vm.title"></h3><div layout="row" layout-xs="column" layout-align-gt-xs="start start" class="commission-opinion-body" layout-wrap="true" style="margin-top: 15px"><md-input-container flex-gt-xs="15"><label data-translate="commissionObservation.dataOsservazioni" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'data\', vm.subjectId)}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.metadata.data[vm.subjectId]" ng-disabled="!vm.editable" ng-required="true"></md-datepicker></md-input-container><span ng-if="vm.metadata.data[vm.subjectId] && vm.editable" style="margin-left: -15px"><md-button ng-click="vm.metadata.data[vm.subjectId] = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data osservazioni</md-tooltip></md-button></span><md-chips ng-model="vm.subjects" readonly="true" flex-offset-gt-xs="5"><md-chip-template><span>{{$chip.nome}}</span></md-chip-template></md-chips><div flex-offset-gt-xs="10" ng-if="::vm.actType !== \'REL\'"><md-radio-group ng-model="vm.metadata.parere[vm.subjectId]"><label data-translate="commissionObservation.osservazioni" ng-click="vm.clearRadio(\'parere\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parere\', vm.subjectId)}"></label><md-radio-button value="EXPRESSED" class="md-primary" ng-disabled="!vm.editable">{{\'commissionObservation.espresse\'| translate}}</md-radio-button><md-radio-button value="NOT_EXPRESSED" class="md-primary" ng-disabled="!vm.editable" ng-click="vm.clearRadio(\'tipoFavorevolezza\')">{{\'commissionObservation.nonEspresse\'| translate}}</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="10" ng-if="::vm.actType !== \'REL\'"><md-radio-group ng-model="vm.metadata.tipoFavorevolezza[vm.subjectId]" ng-if="vm.metadata.parere[vm.subjectId] === \'EXPRESSED\'"><label data-translate="commissionObservation.tipoFavorevolezza" ng-click="vm.clearRadio(\'tipoFavorevolezza\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoFavorevolezza\', vm.subjectId)}"></label><md-radio-button value="MAJORITY" class="md-primary" ng-disabled="!vm.editable">{{\'commissionObservation.maggioranza\'| translate}}</md-radio-button><md-radio-button value="ALL" class="md-primary" ng-disabled="!vm.editable">{{\'commissionObservation.unanimita\'| translate}}</md-radio-button></md-radio-group></div></div></div>');
$templateCache.put('app/components/courtroomBlock/actuationNotes.html','<div class="panel-heading"><a class="hand glyphicon" name="actuationNotes{{vm.fieldSuffix}}" ng-click="vm.actuationNotes.visible = !vm.actuationNotes.visible" ng-class="{\'glyphicon-chevron-down\': !vm.actuationNotes.visible, \'glyphicon-chevron-up\': vm.actuationNotes.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.actuationNotes" ng-class="{\'readonly-section\': !vm.actuationNotes.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.actuationNotes.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="actuationNotes-appeal-body" ng-if="vm.actuationNotes.visible" class="panel-body" layout-padding><form name="actuationNotesForm" layout="column"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><div><md-radio-group ng-model="vm.actuationNotes.metadati.isACaricoGiunta" ng-disabled="!vm.actuationNotes.editable"><label data-translate="gestioneAttiApp.form.actuationNotes.isACaricoGiunta" ng-click="vm.clearRadio(!vm.actuationNotes.editable, vm.actuationNotes, \'isACaricoGiunta\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5" ng-if="vm.actuationNotes.metadati.isACaricoGiunta"><md-input-container><label data-translate="gestioneAttiApp.form.actuationNotes.dataInvioRichiesta" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataInvioRichiesta\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.actuationNotes.metadati.dataInvioRichiesta" ng-disabled="!vm.actuationNotes.editable"></md-datepicker></md-input-container><span ng-if="vm.actuationNotes.metadati.dataInvioRichiesta && vm.actuationNotes.editable"><md-button ng-click="vm.actuationNotes.metadati.dataInvioRichiesta = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data invio richiesta</md-tooltip></md-button></span><md-input-container><label data-translate="gestioneAttiApp.form.actuationNotes.dataRicezioneNotaGiunta" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataRicezioneNotaGiunta\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.actuationNotes.metadati.dataRicezioneNotaGiunta" ng-disabled="!vm.actuationNotes.editable"></md-datepicker></md-input-container><span ng-if="vm.actuationNotes.metadati.dataRicezioneNotaGiunta && vm.actuationNotes.editable"><md-button ng-click="vm.actuationNotes.metadati.dataRicezioneNotaGiunta = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data ricezione nota giunta</md-tooltip></md-button></span><md-input-container><label data-translate="gestioneAttiApp.form.actuationNotes.dataSollecito" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSollecito\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.actuationNotes.metadati.dataSollecito" ng-disabled="!vm.actuationNotes.editable"></md-datepicker></md-input-container><span ng-if="vm.actuationNotes.metadati.dataSollecito && vm.actuationNotes.editable"><md-button ng-click="vm.actuationNotes.metadati.dataSollecito = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data sollecito</md-tooltip></md-button></span></div></form></div><div class="panel-footer" ng-if="vm.actuationNotes.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="vm.defaultLinks" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.actuationNotes" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/adempimenti.html','<div class="panel-heading"><a class="hand glyphicon" name="adempimenti{{vm.fieldSuffix}}" ng-click="vm.adempimenti.visible = !vm.adempimenti.visible" ng-class="{\'glyphicon-chevron-down\': !vm.adempimenti.visible, \'glyphicon-chevron-up\': vm.adempimenti.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.adempimenti" ng-class="{\'readonly-section\': !vm.adempimenti.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.adempimenti.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="constitutional-appeal-body" ng-if="vm.adempimenti.visible" class="panel-body" layout-padding><form name="adempimentiForm" layout="column"><adempimenti-list-component disabled="!vm.adempimenti.editable" model="vm.adempimenti.metadati" commissioni="vm.commissioni"></adempimenti-list-component></form></div><div class="panel-footer" ng-if="vm.adempimenti.visible"><document-toolbar section="::vm.adempimenti" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="[\'burt\', \'regulatoryCollection\']" editable="::(vm.adempimenti.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/constitutionalAppeal.html','<div class="panel-heading"><a class="hand glyphicon" name="constitutionalAppeal{{vm.fieldSuffix}}" ng-click="vm.constitutionalAppeal.visible = !vm.constitutionalAppeal.visible" ng-class="{\'glyphicon-chevron-down\': !vm.constitutionalAppeal.visible, \'glyphicon-chevron-up\': vm.constitutionalAppeal.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.constitutionalAppeal" ng-class="{\'readonly-section\': !vm.constitutionalAppeal.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.constitutionalAppeal.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="constitutional-appeal-body" ng-if="vm.constitutionalAppeal.visible" class="panel-body" layout-padding><form name="constitutionalAppealForm" layout="column"><div layout="row" layout-xs="column" flex-offset-gt-xs="5"><div><md-radio-group ng-model="vm.constitutionalAppeal.metadati.ricorso" ng-disabled="!vm.constitutionalAppeal.editable"><label data-translate="gestioneAttiApp.form.constitutionalAppeal.ricorso" ng-click="vm.clearRadio(!vm.constitutionalAppeal.editable, vm.constitutionalAppeal, \'ricorso\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'ricorso\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><md-input-container ng-if="vm.constitutionalAppeal.metadati.ricorso" flex flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.constitutionalAppeal.esitoRicorso" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'esitoRicorso\')}"></label><input ng-model="vm.constitutionalAppeal.metadati.esitoRicorso" ng-disabled="!vm.constitutionalAppeal.editable"></md-input-container></div></form></div><div class="panel-footer" ng-if="vm.constitutionalAppeal.visible"><document-toolbar section="::vm.constitutionalAppeal" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="[\'burt\', \'regulatoryCollection\']" editable="::(vm.constitutionalAppeal.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/courtroomBlock.directive.html','<div id="courtroom-state-{{::vm.index}}" ng-if="::(vm.showCourtroomBlock && ((vm.checkShowSection(vm.courtEmendments) || vm.checkShowSection(vm.courtMeeting) || vm.checkShowSection(vm.courtOutcome))))" class="atto-detail-pane"><a ng-click="vm.stato.aula.isCollapsed = !vm.stato.aula.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.aula.isCollapsed, \'glyphicon-eye-close\': vm.stato.aula.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">AULA</span> <span ng-if="vm.isAdmin" style="vertical-align: 5px"><event-mail-notification-button-component atto="vm.atto" event-type="\'PASSAGGIO_IN_AULA\'"></event-mail-notification-button-component></span><span ng-if="::vm.actType === \'PDLS\'" data-translate="gestioneAttiApp.form.lettura{{vm.index}}"></span><!-- <span ng-if="::vm.actType === \'PDLS\' && vm.index === 0" data-translate="gestioneAttiApp.form.aulaPrimaFase"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index === 1" data-translate="gestioneAttiApp.form.aulaSecondaFase"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index > 1 && ($index % 2) === 0" data-translate="gestioneAttiApp.form.ritornoAulaPrimaFase"></span>\r\n    <span ng-if="::vm.actType === \'PDLS\' && vm.index > 1 && ($index % 2) !== 0" data-translate="gestioneAttiApp.form.ritornoAulaSecondaFase"></span> --> <span ng-if="::vm.actType !== \'PDLS\' && vm.index > 0" class="rinvio-notice">{{\'gestioneAttiApp.form.rinvioCommissione\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span><div ng-show="vm.stato.aula.isCollapsed" layout="column" layout-margin><!-- COURTROOM EMENDMENTS --><div ng-if="::vm.checkShowSection(vm.courtEmendments)" ng-include="::vm.sezioni.COURT_EMENDMENTS.form" class="panel atto-sezione" ng-cloak></div><!-- COURTROOM MEETING --><div ng-if="::vm.checkShowSection(vm.courtMeeting)" ng-include="::vm.sezioni.COURT_MEETING.form" class="panel atto-sezione" ng-cloak></div><!-- COURTROOM OUTCOME --><div ng-if="::vm.checkShowSection(vm.courtOutcome) && (!vm.atto.tipoAtto === \'IS\' || (vm.atto.tipoAtto === \'IS\' && vm.atto.statoCorrente.statoAtto.finalState === \'false\'))" ng-include="::vm.sezioni.COURT_OUTCOME.form" class="panel atto-sezione" ng-cloak></div><!-- ATTACHED ACTS --><section ng-if="::vm.attachedActs" ng-cloak class="panel atto-sezione"><attached-acts-component attached-acts="vm.attachedActs" atto="vm.atto" change-document-type="vm.changeDocumentType" change-document-visibility="vm.changeDocumentVisibility" change-document-frontpiece="vm.changeDocumentFrontpiece" doc-types="vm.docTypes" public-view="vm.publicView" utente="vm.utente"></attached-acts-component></section><!-- ASSIGNMENT LETTER --><section ng-if="::vm.assignmentLetter && (vm.isParereReferenteValorised || vm.isStatoAula) && vm.actType !== \'PDLS\'" ng-include="::vm.sezioni.ASSIGNMENT_LETTER.form" ng-cloak class="panel atto-sezione"></section><!-- COURT ASSIGNMENT LETTER FOR PDLS--><div ng-if="::vm.checkShowSection(vm.courtAssignmentLetter) && vm.actType === \'PDLS\'" ng-include="::vm.sezioni.COURT_ASSIGNMENT_LETTER.form" ng-cloak class="panel atto-sezione"></div></div></div><!-- APPROVATO  (o APPROVAZIONE DEFINITIVA) --><div id="approved-state" class="atto-detail-pane" ng-if="::vm.statoAttoCorrente != \'RITIRATO\' && vm.statoAttoCorrente != \'RESPINTO\' && vm.statoAttoCorrente != \'TRASMISSIONE GIUNTA\' && vm.statoAttoCorrente != \'IMPROCEDIBILE\' && vm.statoAttoCorrente != \'DECADUTO\' && vm.statoAttoCorrente != \'TRASFERITA COMPETENZA\' && ((vm.checkShowSection(vm.postCourt) || vm.checkShowSection(vm.noticeOfRectification) || vm.checkShowSection(vm.constitutionalAppeal)))"><a ng-click="vm.stato.approvato.isCollapsed = !vm.stato.approvato.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.commissione.isCollapsed, \'glyphicon-eye-close\': vm.stato.commissione.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">{{vm.atto.tipoAtto === \'PEA\' ? \'APPROVAZIONE DEFINITIVA\' : \'APPROVATO\'}}</span><div ng-show="vm.stato.approvato.isCollapsed" layout="column" layout-margin><!-- POST COURTROOM --><div ng-if="::vm.checkShowSection(vm.postCourt)" ng-include="::vm.sezioni.POST_COURT.form" class="panel atto-sezione" ng-cloak></div><!-- EMANAZIONE --><div ng-if="::vm.checkShowSection(vm.emanazione)" ng-include="::vm.sezioni.EMANAZIONE.form" class="panel atto-sezione" ng-cloak></div><!--MATERIE --><div ng-if="::vm.checkShowSection(vm.materieSection)" ng-include="::vm.sezioni.MATERIE.form" class="panel atto-sezione" ng-cloak></div><!--ADEMPIMENTO --><div ng-if="::vm.checkShowSection(vm.adempimenti)" ng-include="::vm.sezioni.ADEMPIMENTI.form" class="panel atto-sezione" ng-cloak></div><!-- ACTUATION NOTES --><div ng-if="::vm.checkShowSection(vm.actuationNotes)" ng-include="::vm.sezioni.ACTUATION_NOTES.form" class="panel atto-sezione" ng-cloak></div><!-- NOTICE_OF_RECTIFICATION --><div ng-if="::vm.checkShowSection(vm.noticeOfRectification)" ng-include="::vm.sezioni.NOTICE_OF_RECTIFICATION.form" class="panel atto-sezione" ng-cloak></div><!-- CONSTITUTIONAL APPEAL --><div ng-if="::vm.checkShowSection(vm.constitutionalAppeal)" ng-include="::vm.sezioni.CONSTITUTIONAL_APPEAL.form" class="panel atto-sezione" ng-cloak></div><!--PROCEDIMENTO --><div ng-if="::vm.atto.tipoAtto === \'PDD\'" ng-include="::vm.sezioni.PROCEDIMENTO.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/courtroomBlock/courtroomEmendments.html','<div class="panel-heading"><a class="hand glyphicon" name="courtroomEmendments{{vm.fieldSuffix}}" ng-click="vm.courtEmendments.visible = !vm.courtEmendments.visible" ng-class="{\'glyphicon-chevron-down\': !vm.courtEmendments.visible, \'glyphicon-chevron-up\': vm.courtEmendments.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.courtroomEmendments" ng-class="{\'readonly-section\': !vm.courtEmendments.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.courtEmendments.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-emendments-body" ng-if="vm.courtEmendments.visible" class="panel-body"><form name="courtroomEmendmentsForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.courtroomEmendments.emendamentiPresentatiAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\'md-primary\': vm.courtEmendments.metadati.emendamentiPresentatiAula}" ng-click="vm.courtEmendments.metadati.emendamentiPresentatiAula = true" ng-disabled="!vm.courtEmendments.editable && !vm.isProtocollo">Si</md-button><md-button class="md-raised" ng-class="{\'md-primary\': !vm.courtEmendments.metadati.emendamentiPresentatiAula}" ng-click="vm.courtEmendments.metadati.emendamentiPresentatiAula = false" ng-disabled="!vm.courtEmendments.editable && !vm.isProtocollo">No</md-button></div></div><div flex-offset-gt-xs="5"><emendments editable="vm.isAdmin || vm.isProtocollo" emendments="vm.courtEmendments.metadati.emendamenti" sezione-id="vm.courtEmendments.id" include-state="true" invalid-fields="vm.invalidFields" ng-cloak ng-show="vm.courtEmendments.metadati.emendamentiPresentatiAula" people-list="vm.peopleList" postponement-number="vm.iterationIndex" validating="vm.validating"></emendments></div></form><div ng-show="vm.courtEmendments.metadati.emendamentiPresentatiAula" style="text-align: center"><md-button class="md-raised md-primary" ng-click="vm.downloadReportEmendamenti()">Download riassunto emendamenti</md-button></div></div><div class="panel-footer" ng-if="vm.courtEmendments.visible"><!-- MODIFICA TEMPORANEA: editable= vm.courtEmendments.editable --><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.isAdmin || vm.isProtocollo || vm.courtEmendments.editable)" include-notes="true" public-view="::vm.publicView" section="::vm.courtEmendments" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/courtroomMeeting.html','<div class="panel-heading"><a class="hand glyphicon" name="courtroomMeeting{{vm.fieldSuffix}}" ng-click="vm.courtMeeting.visible = !vm.courtMeeting.visible" ng-class="{\'glyphicon-chevron-down\': !vm.courtMeeting.visible, \'glyphicon-chevron-up\': vm.courtMeeting.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.courtroomMeeting" ng-class="{\'readonly-section\': !vm.courtMeeting.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.courtMeeting.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-meeting-body" ng-if="vm.courtMeeting.visible" class="panel-body"><form name="courtMeetingForm"><addable-input input-type="\'date\'" disabled="!vm.courtMeeting.editable" date-label="\'gestioneAttiApp.form.courtMeeting.sessionsDate\'" input-model="vm.courtMeeting.metadati.sedute" invalid-fields="vm.invalidFields" validating="vm.validating" field-name="sessionsDate" style="width: 100%"></addable-input><addable-input input-type="\'date\'" disabled="!vm.courtMeeting.editable" date-label="\'gestioneAttiApp.form.courtMeeting.trattazioneDate\'" input-model="vm.courtMeeting.metadati.seduteTrattazione" invalid-fields="vm.invalidFields" validating="vm.validating" field-name="trattazioneDate" style="width: 100%"></addable-input></form></div><div class="panel-footer" ng-if="vm.courtMeeting.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.courtMeeting.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.courtMeeting" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/courtroomOutcome.html','<div class="panel-heading"><a class="hand glyphicon" name="courtroomOutcome{{vm.fieldSuffix}}" ng-click="vm.courtOutcome.visible = !vm.courtOutcome.visible" ng-class="{\'glyphicon-chevron-down\': !vm.courtOutcome.visible, \'glyphicon-chevron-up\': vm.courtOutcome.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.courtroomOutcome" ng-class="{\'readonly-section\': !vm.courtOutcome.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.courtOutcome.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-outcome-body" class="panel-body" ng-if="vm.courtOutcome.visible"><form name="courtOutcomeForm" layout="column"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><div ng-if="!vm.isAttoMinore && vm.actType !== \'PDD\'"><md-radio-group ng-model="vm.courtOutcome.metadati.clausolaValutativa" ng-disabled="!vm.courtOutcome.editable"><label data-translate="gestioneAttiApp.form.courtroomOutcome.clausolaValutativa" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'clausolaValutativa\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="{{!vm.isAttoMinore ? 5 : 0}}"><md-radio-group ng-model="vm.courtOutcome.metadati.coordinamentoTesto" ng-disabled="!vm.courtOutcome.editable"><label data-translate="gestioneAttiApp.form.courtroomOutcome.coordinamentoTesto" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'coordinamentoTesto\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'coordinamentoTesto\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div><fieldset class="standard" name="modificaOggettoTitolo"><legend></legend><div layout="row" layout-xs="column" layout-align-xs="start start"><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.courtOutcome.metadati.modificaOggettoTitolo" ng-disabled="!vm.courtOutcome.editable"><label data-translate="gestioneAttiApp.form.courtroomOutcome.modificaOggettoTitolo" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'modificaOggettoTitolo\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'modificaOggettoTitoloAula\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div><md-input-container ng-if="vm.courtOutcome.metadati.modificaOggettoTitolo" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.courtroomOutcome.nuovoOggettoTitolo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'nuovoOggettoTitoloAula\')}"></label><input ng-disabled="!vm.courtOutcome.editable" ng-model="vm.courtOutcome.metadati.nuovoOggettoTitolo"></md-input-container></div></div></fieldset><div ng-if="!vm.isAttoMinore"><div class="spacer"></div><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.courtroomOutcome.attiCollegati"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': vm.courtOutcome.metadati.showRealatedActs}" ng-click="vm.courtOutcome.metadati.showRealatedActs = true" ng-disabled="!vm.courtOutcome.editable">Si</md-button><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': !vm.courtOutcome.metadati.showRealatedActs}" ng-click="vm.courtOutcome.metadati.showRealatedActs = false" ng-disabled="!vm.courtOutcome.editable">No</md-button></div></div><div ng-if="vm.courtOutcome.metadati.showRealatedActs === true" layout="column" layout-gt-sm="row" layout-align="space-between start" flex-offset-gt-xs="5"><div class="spacer"></div><addable-input input-type="\'attachedActs\'" disabled="!vm.courtOutcome.editable" input-label="\'gestioneAttiApp.form.courtroomOutcome.attiCollegati\'" input-model="vm.courtOutcome.metadati.attiCollegati" style="width: 100%"></addable-input></div></div></form></div><div class="panel-footer" ng-if="vm.courtOutcome.visible"><document-toolbar section="::vm.courtOutcome" document-types="::vm.docTypes" include-notes="true" editable="::(vm.courtOutcome.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/io.courtroomOutcome.html','<div class="panel-heading"><a class="hand glyphicon" name="courtroomOutcome" ng-click="vm.courtOutcome.visible = !vm.courtOutcome.visible" ng-class="{\'glyphicon-chevron-down\': !vm.courtOutcome.visible, \'glyphicon-chevron-up\': vm.courtOutcome.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.courtroomOutcome" ng-class="{\'readonly-section\': !vm.courtOutcome.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.courtOutcome.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-outcome-body" class="panel-body" ng-if="vm.courtOutcome.visible"><form ng-if="!vm.hideEsitoAttoMedatati" name="courtOutcomeForm" layout="column"><div><md-radio-group ng-model="vm.courtOutcome.metadati.rispostaScrittaIn3Giorni" ng-disabled="!vm.courtOutcome.editable" ng-change="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn15Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaConsegnata\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScritta\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'svolta\')"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rispostaScritta\')}" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn3Giorni\')">Risposta scritta in 3 gg</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button></md-radio-group></div><div><md-radio-group ng-model="vm.courtOutcome.metadati.rispostaScrittaIn15Giorni" ng-disabled="!vm.courtOutcome.editable" ng-change="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn3Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaConsegnata\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScritta\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'svolta\')"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rispostaScritta\')}" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn15Giorni\')">Risposta scritta in 15 gg</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button></md-radio-group></div><div><md-radio-group ng-model="vm.courtOutcome.metadati.rispostaScrittaConsegnata" ng-disabled="!vm.courtOutcome.editable" ng-change="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn15Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn3Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScritta\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'svolta\')"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rispostaScritta\')}" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaConsegnata\')">Consegnata risposta scritta</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button></md-radio-group></div><div ng-if="vm.atto.tipoAtto === \'IO\' || vm.atto.tipoAtto === \'IS\'"></div><div><md-radio-group ng-model="vm.courtOutcome.metadati.rispostaScritta" ng-disabled="!vm.courtOutcome.editable" ng-change="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn15Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn3Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaConsegnata\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'svolta\')"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rispostaScritta\')}" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScritta\')">Risposta scritta</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button></md-radio-group></div><div><md-radio-group ng-model="vm.courtOutcome.metadati.svolta" ng-disabled="!vm.courtOutcome.editable" ng-change="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn15Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaIn3Giorni\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScrittaConsegnata\'); vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'rispostaScritta\')"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'svolta\')}" ng-click="vm.clearRadio(!vm.courtOutcome.editable, vm.courtOutcome, \'svolta\')">Svolta</label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button></md-radio-group></div></form></div><div ng-if="!vm.isCourtOutcomeInPresentationSection && vm.courtOutcome.visible" class="panel-footer"><document-toolbar section="::vm.courtOutcome" document-types="::vm.docTypes" include-notes="true" editable="::(vm.courtOutcome.editable || vm.isProtocollo || (vm.isSettoreAtti && vm.atto.statoCorrente.statoAtto.finalState))" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div><!--Per la gestione dei pannello documento in caso la sezione si trovi in presentazione--><div ng-if="vm.isCourtOutcomeInPresentationSection && vm.courtOutcome.visible" class="panel-footer"><document-toolbar section="vm.sezioniMap.COURT_OUTCOME" document-types="vm.docTypes" include-notes="true" editable="(vm.sezioniMap.COURT_OUTCOME.editable || vm.isProtocollo || (vm.userRolesMap.isSettoreAtti && vm.atto.statoCorrente.statoAtto.name === \'PRESENTATO\'))" user="vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/materie-section.html','<div class="panel-heading"><a class="hand glyphicon" name="materieSection{{vm.fieldSuffix}}" ng-click="vm.materieSection.visible = !vm.materieSection.visible" ng-class="{\'glyphicon-chevron-down\': !vm.materieSection.visible, \'glyphicon-chevron-up\': vm.materieSection.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.materieSection" ng-class="{\'readonly-section\': !vm.materieSection.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.materieSection.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="constitutional-appeal-body" ng-if="vm.materieSection.visible" class="panel-body" layout-padding><form name="materieSectionForm" layout="column"><ng-container ng-if="!vm.materieSection.editable || (vm.loadedMacroMaterie && vm.loadedMaterie)"><macro-materia-materia-list-component model="vm.materieSection.metadati.macroMateriaMateriaPairs" macro-materia-list="vm.macroMateriaList" materia-list="vm.materiaList" disabled="!vm.materieSection.editable"></macro-materia-materia-list-component></ng-container></form></div><div class="panel-footer" ng-if="vm.materieSection.visible"><document-toolbar section="::vm.materieSection" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="[\'burt\', \'regulatoryCollection\']" editable="::(vm.materieSection.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/noticeOfRectification.html','<div class="panel-heading"><a class="hand glyphicon" name="noticeOfRectification{{vm.fieldSuffix}}" ng-click="vm.noticeOfRectification.visible = !vm.noticeOfRectification.visible" ng-class="{\'glyphicon-chevron-down\': !vm.noticeOfRectification.visible, \'glyphicon-chevron-up\': vm.noticeOfRectification.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.noticeOfRectification" ng-class="{\'readonly-section\': !vm.noticeOfRectification.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.noticeOfRectification.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div id="noticeOfRectification-body" class="panel-body" ng-if="vm.noticeOfRectification.visible" layout-padding><form name="noticeOfRectificationForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.sezioni.noticeOfRectification"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': vm.noticeOfRectification.metadati.showRealatedActs}" ng-click="vm.noticeOfRectification.metadati.showRealatedActs = true" ng-disabled="!vm.noticeOfRectification.editable">Si</md-button><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': !vm.noticeOfRectification.metadati.showRealatedActs}" ng-click="vm.noticeOfRectification.metadati.showRealatedActs = false" ng-disabled="!vm.noticeOfRectification.editable">No</md-button></div></div><div ng-if="vm.noticeOfRectification.metadati.showRealatedActs === true" class="spacer"></div><fieldset ng-if="vm.noticeOfRectification.metadati.showRealatedActs === true" name="burt" class="standard"><div flex-offset-gt-xs="5"><div ng-if="!vm.isInsert" layout="row" layout-xs="column"><addable-input input-type="\'avvisoRettifica\'" input-model="vm.noticeOfRectification.metadati.burtDetails" inner-label="true" disabled="!vm.noticeOfRectification.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div></div><!-- <div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5">\r\n\r\n                <md-input-container style="max-width: 100px;">\r\n                    <label data-translate="gestioneAttiApp.form.noticeOfRectification.numeroBurt"></label>\r\n                    <input  type="number" ng-disabled="!vm.noticeOfRectification.editable" ng-model="vm.noticeOfRectification.metadati.numeroBurt">\r\n                </md-input-container>\r\n\r\n                <md-input-container flex-offset-gt-xs="5">\r\n                    <label data-translate="gestioneAttiApp.form.noticeOfRectification.parteBurt"></label>\r\n                    <input ng-model="vm.noticeOfRectification.metadati.parteBurt" ng-disabled="!vm.noticeOfRectification.editable">\r\n                </md-input-container>\r\n\r\n\r\n                <md-input-container flex-offset-gt-xs="5">\r\n                    <label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label>\r\n                    <md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.noticeOfRectification.metadati.dataBurt" ng-disabled="!vm.noticeOfRectification.editable"></md-datepicker>\r\n                </md-input-container>\r\n                <span ng-if="vm.noticeOfRectification.metadati.dataBurt && vm.noticeOfRectification.editable">\r\n                    <md-button ng-click="vm.noticeOfRectification.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button">\r\n                        <span class="glyphicon glyphicon-remove-circle"></span>\r\n                        <md-tooltip>Rimuovi data BURT</md-tooltip>\r\n                    </md-button>\r\n                </span>\r\n\r\n            </div>--></fieldset></form></div><div class="panel-footer" ng-if="vm.noticeOfRectification.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="[]" document-types="::vm.docTypes" editable="::(vm.noticeOfRectification.editable || vm.isProtocollo)" include-links="true" include-notes="false" public-view="::vm.publicView" section="::vm.noticeOfRectification" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/pdd.postCourtroom.html','<div class="panel-heading"><a class="hand glyphicon" name="postCourtroom{{vm.fieldSuffix}}" ng-click="vm.postCourt.visible = !vm.postCourt.visible" ng-class="{\'glyphicon-chevron-down\': !vm.postCourt.visible, \'glyphicon-chevron-up\': vm.postCourt.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.postCourtroom" ng-class="{\'readonly-section\': !vm.postCourt.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="postcourt-body" class="panel-body" ng-if="vm.postCourt.visible"><md-content layout-padding><form name="postCourtForm"><div layout-gt-xs="row" flex-offset-gt-xs="5"><md-input-container><label style="overflow: visible">{{ (vm.actType === \'PDD\' ? \'gestioneAttiApp.form.postCourtroom.numeroDefinitivoDelibera\' : \'gestioneAttiApp.form.postCourtroom.numeroDefinitivoRegolamento\') | translate }}</label><input ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroDefinitivoDelibera"></md-input-container><md-input-container flex-offset-gt-xs="5"><label style="overflow: visible">{{ (vm.actType === \'PDD\' ? \'gestioneAttiApp.form.postCourtroom.dataDelibera\' : \'gestioneAttiApp.form.postCourtroom.dataRegolamento\') | translate }}</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataDelibera" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataDelibera && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataDelibera = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data delibera</md-tooltip></md-button></span></div><fieldset ng-if="vm.nonContestata()" name="burt"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroBurt"></label><input type="number" ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroBurt"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.parteBurt"></label><input ng-model="vm.postCourt.metadati.parteBurt" ng-disabled="!vm.postCourt.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataBurt" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataBurt && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span></div></fieldset></form></md-content></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="[\'burt\']" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.postCourt" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/pdlp.postCourtroom.html','<div class="panel-heading"><a class="hand glyphicon" name="postCourtroom{{vm.fieldSuffix}}" ng-click="vm.postCourt.visible = !vm.postCourt.visible" ng-class="{\'glyphicon-chevron-down\': !vm.postCourt.visible, \'glyphicon-chevron-up\': vm.postCourt.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.postCourtroom" ng-class="{\'readonly-section\': !vm.postCourt.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.postCourt.visible" id="postcourt-body" class="panel-body" layout-padding><form name="postCourtForm" layout="column"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><!-- Data Deliberazione CR --><div layout="row"><md-input-container style="width: 200px"><label style="overflow: visible" data-translate="gestioneAttiApp.form.postCourtroom.dataDeliberazioneCR" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataDeliberazioneCR\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataDeliberazioneCR" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataDeliberazioneCR && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataDeliberazioneCR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data deliberazione CR</md-tooltip></md-button></span></div><!-- Numero Deliberazione --><div flex-offset-gt-xs="5"><md-input-container class="md-block" style="width: 190px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroDeliberazione"></label><input type="number" ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroDeliberazione"></md-input-container></div></div><div><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><div><md-radio-group ng-if="vm.showManifestaInfondatezza()" ng-model="vm.postCourt.metadati.manifestaInfondatezza" ng-disabled="!vm.postCourt.editable" flex-offset-gt-xs="5" ng-change="vm.checkConformita()"><label data-translate="gestioneAttiApp.form.postCourtroom.manifestaInfondatezza" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'manifestaInfondatezza\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div><md-radio-group ng-if="vm.showConformita()" ng-model="vm.postCourt.metadati.conformita" ng-disabled="!vm.postCourt.editable" ng-change="vm.broadcastConformitaEvent()" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.conformitaTitle" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'conformita\'); vm.broadcastConformitaEvent();"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.postCourtroom.conformita\'| translate }}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.postCourtroom.nonConformita\'| translate }}</md-radio-button></md-radio-group></div></div></div><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><!-- Camera di Destinazione --><div><md-radio-group ng-model="vm.postCourt.metadati.cameraDestinazione" ng-disabled="!vm.postCourt.editable"><label data-translate="gestioneAttiApp.form.postCourtroom.cameraDestinazione" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'cameraDestinazione\')"></label><md-radio-button ng-value="\'CAMERA_DEI_DEPUTATI\'" class="md-primary">Camera dei Deputati</md-radio-button><md-radio-button ng-value="\'SENATO_DELLA_REPUBBLICA\'" class="md-primary">Senato della Repubblica</md-radio-button></md-radio-group></div><!-- Data di invio in Parlamento --><div layout="row" flex-offset-gt-xs="5"><md-input-container style="width: 200px"><label data-translate="gestioneAttiApp.form.postCourtroom.dataInvioParlamento" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataInvioParlamento\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataInvioParlamento" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataInvioParlamento && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataInvioParlamento = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data di invio in Parlamento</md-tooltip></md-button></span></div></div><fieldset ng-if="vm.nonContestata()" name="burt"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroBurt"></label><input type="number" ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroBurt"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.parteBurt"></label><input ng-model="vm.postCourt.metadati.parteBurt" ng-disabled="!vm.postCourt.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataBurt" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataBurt && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span></div></fieldset></form></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="vm.defaultLinks" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.postCourt" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/pdls.courtAssignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="courtAssignmentLetter{{vm.fieldSuffix}}" ng-click="vm.courtAssignmentLetter.visible = !vm.courtAssignmentLetter.visible" ng-class="{\'glyphicon-chevron-down\': !vm.courtAssignmentLetter.visible, \'glyphicon-chevron-up\': vm.courtAssignmentLetter.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.courtAssignmentLetter" ng-class="{\'readonly-section\': !vm.courtAssignmentLetter.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.courtAssignmentLetter.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="courtroom-meeting-body" ng-if="vm.courtAssignmentLetter.visible" class="panel-body"><form name="courtAssignmentLetterForm"><legend ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataRiassegnazione\')}">{{\'gestioneAttiApp.form.assignment.dataRiassegnazione\' | translate}}</legend><div layout="row"><md-input-container><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.courtOutcome.metadati.dataRinvio" ng-disabled="::(!vm.courtAssignmentLetter.editable)"></md-datepicker></md-input-container><span ng-if="vm.courtOutcome.metadati.dataRinvio && vm.courtAssignmentLetter.editable"><md-button ng-click="vm.courtOutcome.metadati.dataRinvio = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data riassegnazione</md-tooltip></md-button></span></div></form></div><div class="panel-footer" ng-if="vm.courtAssignmentLetter.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.courtAssignmentLetter.editable || vm.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.courtAssignmentLetter" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/pea.emanazione.html','<div class="panel-heading"><a class="hand glyphicon" name="emanazione{{vm.fieldSuffix}}" ng-click="vm.emanazione.visible = !vm.emanazione.visible" ng-class="{\'glyphicon-chevron-down\': !vm.emanazione.visible, \'glyphicon-chevron-up\': vm.emanazione.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.emanazione"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.emanazione.visible" id="emanazione-body" class="panel-body" layout-padding><form name="emanazioneForm" layout="column"><div class="panel-body"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroBurt"></label><input type="number" ng-model="vm.emanazione.metadati.numeroBurt" ng-disabled="!vm.emanazione.editable"></md-input-container><md-input-container flex-offset-gt-xs="5" ng-disabled="!vm.emanazione.editable"><label data-translate="gestioneAttiApp.form.postCourtroom.parteBurt"></label><input ng-model="vm.emanazione.metadati.parteBurt" ng-disabled="!vm.emanazione.editable"></md-input-container></div></form></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="vm.defaultLinks" document-types="::vm.docTypes" editable="::(vm.emanazione.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.emanazione" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/pea.postCourtroom.html','<div class="panel-heading"><a class="hand glyphicon" name="postCourtroom{{vm.fieldSuffix}}" ng-click="vm.postCourt.visible = !vm.postCourt.visible" ng-class="{\'glyphicon-chevron-down\': !vm.postCourt.visible, \'glyphicon-chevron-up\': vm.postCourt.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.chiusuraIter" ng-class="{\'readonly-section\': !vm.postCourt.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.postCourt.visible" id="postcourt-body" class="panel-body" layout-padding><form name="postCourtForm" layout="column"><div id="post-court-documents-body" class="panel-body" layout="row"><md-content layout-padding><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'ADEMPIMENTI\']">{{\'gestioneAttiApp.form.postCourtroom.adempimenti\' | translate}}</md-checkbox></md-content><md-content layout-padding><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_TRASMISSIONE\']">{{\'gestioneAttiApp.form.postCourtroom.letteraTrasmissione\' | translate}}</md-checkbox></md-content></div><div layout="row" layout-align="start center"><md-radio-group ng-model="vm.postCourt.metadati.collegioGaranzia" ng-disabled="!vm.postCourt.editable"><label data-translate="gestioneAttiApp.form.postCourtroom.collegioDiGaranzia" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'rilieviFattibilita\')}"></label><md-radio-button ng-value="true" class="md-primary">SI</md-radio-button><md-radio-button ng-value="false" class="md-primary">NO</md-radio-button></md-radio-group></div><div layout="row" layout-align="center center" ng-if="vm.postCourt.metadati.collegioGaranzia"><addable-input input-type="\'date\'" input-model="vm.postCourt.metadati.dateInvioGiunta" date-label="\'gestioneAttiApp.form.postCourtroom.invioGiunta\'" style="width: 100%" ng-disabled="!vm.postCourt.editable"></addable-input></div></form></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="vm.defaultLinks" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.postCourt" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/postCourtroom.html','<div class="panel-heading"><a class="hand glyphicon" name="postCourtroom{{vm.fieldSuffix}}" ng-click="vm.postCourt.visible = !vm.postCourt.visible" ng-class="{\'glyphicon-chevron-down\': !vm.postCourt.visible, \'glyphicon-chevron-up\': vm.postCourt.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.postCourtroom" ng-class="{\'readonly-section\': !vm.postCourt.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\'| translate}} {{vm.sendBackDate| date: \'dd/MM/yyyy\'}}</span></div><div ng-if="vm.postCourt.visible" id="postcourt-body" class="panel-body" layout-padding><form name="postCourtForm" layout="column"><div ng-if="vm.actType !== \'MOZIONE\' && vm.actType !== \'ODG\' && vm.actType !== \'PDRIS\'" layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container><label data-translate="gestioneAttiApp.form.postCourtroom.dataLeggeAC" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataLeggeAC\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataLeggeAC" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataLeggeAC && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataLeggeAC = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data legge AC</md-tooltip></md-button></span><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroLeggeAC" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroLeggeAC\')}"></label><input ng-model="vm.postCourt.metadati.numeroLeggeAC" ng-disabled="!vm.postCourt.editable"></md-input-container></div><div ng-if="vm.actType !== \'MOZIONE\' && vm.actType !== \'ODG\' && vm.actType !== \'PDRIS\'"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><div><md-radio-group ng-model="vm.postCourt.metadati.collegioGaranzia" ng-disabled="!vm.postCourt.editable" ng-change="vm.checkConformita()"><label data-translate="gestioneAttiApp.form.postCourtroom.collegioGaranzia" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'collegioGaranzia\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="5"><md-radio-group ng-if="vm.showManifestaInfondatezza()" ng-model="vm.postCourt.metadati.manifestaInfondatezza" ng-disabled="!vm.postCourt.editable" flex-offset-gt-xs="5" ng-change="vm.checkConformita()"><label data-translate="gestioneAttiApp.form.postCourtroom.manifestaInfondatezza" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'manifestaInfondatezza\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="5"><md-radio-group ng-if="vm.showConformita()" ng-model="vm.postCourt.metadati.conformita" ng-disabled="!vm.postCourt.editable" ng-change="vm.broadcastConformitaEvent()" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.conformitaTitle" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'conformita\'); vm.broadcastConformitaEvent();"></label><md-radio-button ng-value="true" class="md-primary">{{\'gestioneAttiApp.form.postCourtroom.conformita\'| translate }}</md-radio-button><md-radio-button ng-value="false" class="md-primary">{{\'gestioneAttiApp.form.postCourtroom.nonConformita\'| translate }}</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="5" ng-if="vm.showEntrataVigoreAnticipata()"><md-radio-group ng-model="vm.postCourt.metadati.entrataVigoreAnticipata" ng-disabled="!vm.postCourt.editable"><label data-translate="gestioneAttiApp.form.postCourtroom.entrataVigoreAnticipata" ng-click="vm.clearRadio(!vm.postCourt.editable, vm.postCourt, \'entrataVigoreAnticipata\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div><div ng-if="vm.nonContestata()" layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container class="md-block"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroLegge"></label><input ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroLegge"></md-input-container><md-input-container class="md-block" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataPromulgazione"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataPromulgazione" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataPromulgazione && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataPromulgazione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data promulgazione</md-tooltip></md-button></span></div></div><fieldset ng-if="vm.nonContestata()" name="burt"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroBurt"></label><input type="number" ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroBurt"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.parteBurt"></label><input ng-model="vm.postCourt.metadati.parteBurt" ng-disabled="!vm.postCourt.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataBurt" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataBurt && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span></div></fieldset></form></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="vm.defaultLinks" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.postCourt" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/procedimento.html','<div class="panel-heading"><a class="hand glyphicon" name="procedimento{{vm.fieldSuffix}}" ng-click="vm.procedimento.visible = !vm.procedimento.visible" ng-class="{\'glyphicon-chevron-down\': !vm.procedimento.visible, \'glyphicon-chevron-up\': vm.procedimento.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.procedimento" ng-class="{\'readonly-section\': !vm.procedimento.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.procedimento.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="constitutional-appeal-body" ng-if="vm.procedimento.visible" class="panel-body" layout-padding><form name="procedimentoForm" layout="column"><div flex-offset-gt-xs="5"><md-radio-group ng-model="vm.procedimento.metadati.procedimentoExArticolo" ng-disabled="!vm.procedimento.editable"><label data-translate="gestioneAttiApp.form.procedimento.procedimentoExArticolo" ng-click="vm.clearRadio(!vm.procedimento.editable, vm.procedimento, \'procedimentoExArticolo\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><!-- Atti Collegati --><attached-acts-component ng-if="vm.procedimento.metadati.procedimentoExArticolo" attached-acts="vm.getSezioniFromMap(\'PROCEDIMENTO\', 0)" atto="vm.atto" change-document-type="vm.changeDocumentType" change-document-visibility="vm.changeDocumentVisibility" change-document-frontpiece="vm.changeDocumentFrontpiece" doc-types="vm.docTypes" public-view="vm.publicView" utente="vm.utente" heading-panel-disabled="true" footer-panel-disabled="true"></attached-acts-component></form></div><div class="panel-footer" ng-if="vm.procedimento.visible"><document-toolbar section="::vm.procedimento" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="[\'burt\', \'regulatoryCollection\']" editable="::(vm.procedimento.editable || vm.isProtocollo)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/courtroomBlock/rint.postCourtroom.html','<div class="panel-heading"><a class="hand glyphicon" name="postCourtroom{{vm.fieldSuffix}}" ng-click="vm.postCourt.visible = !vm.postCourt.visible" ng-class="{\'glyphicon-chevron-down\': !vm.postCourt.visible, \'glyphicon-chevron-up\': vm.postCourt.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.postCourtroom" ng-class="{\'readonly-section\': !vm.postCourt.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.postCourt.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div id="postcourt-body" class="panel-body" ng-if="vm.postCourt.visible"><md-content layout-padding><form name="postCourtForm"><div layout-gt-xs="row" flex-offset-gt-xs="5"><md-input-container><label style="overflow: visible">{{ (vm.actType === \'PDD\' ? \'gestioneAttiApp.form.postCourtroom.numeroDefinitivoDelibera\' : \'gestioneAttiApp.form.postCourtroom.numeroDefinitivoRegolamento\') | translate }}</label><input ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroDefinitivoDelibera"></md-input-container><md-input-container flex-offset-gt-xs="5"><label style="overflow: visible">{{ (vm.actType === \'PDD\' ? \'gestioneAttiApp.form.postCourtroom.dataDelibera\' : \'gestioneAttiApp.form.postCourtroom.dataRegolamento\') | translate }}</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataDelibera" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataDelibera && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataDelibera = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data delibera</md-tooltip></md-button></span></div><fieldset ng-if="vm.nonContestata()" name="burt"><div layout="row" layout-xs="column" layout-align="start start" flex-offset-gt-xs="5"><md-input-container style="max-width: 100px"><label data-translate="gestioneAttiApp.form.postCourtroom.numeroBurt"></label><input type="number" ng-disabled="!vm.postCourt.editable" ng-model="vm.postCourt.metadati.numeroBurt"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.parteBurt"></label><input ng-model="vm.postCourt.metadati.parteBurt" ng-disabled="!vm.postCourt.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.postCourtroom.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.postCourt.metadati.dataBurt" ng-disabled="!vm.postCourt.editable"></md-datepicker></md-input-container><span ng-if="vm.postCourt.metadati.dataBurt && vm.postCourt.editable"><md-button ng-click="vm.postCourt.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span></div></fieldset></form></md-content></div><div class="panel-footer" ng-if="vm.postCourt.visible"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" default-links="[\'burt\']" document-types="::vm.docTypes" editable="::(vm.postCourt.editable || vm.isProtocollo)" include-links="true" include-notes="true" public-view="::vm.publicView" section="::vm.postCourt" user="::vm.utente" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/commissionOpinion/commissionOpinion.directive.html','<div class="commission-opinion" ng-class="{\'commission-opinion-editable\': vm.editable}"><h3 class="commission-opinion-title" ng-bind="::vm.title"></h3><div layout-gt-xs="row" ng-if="vm.includeMeetingDates"><addable-input input-type="\'date\'" flex input-model="vm.metadata.dateSeduteIscrizione[vm.subjectId]" date-label="\'gestioneAttiApp.form.commissionOpinions.dateSeduteIscrizione\'" disabled="!vm.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div layout-gt-xs="row" ng-if="vm.includeMeetingDates"><addable-input input-type="\'date\'" flex input-model="vm.metadata.dateSeduteTrattazione[vm.subjectId]" date-label="\'gestioneAttiApp.form.commissionOpinions.dateSeduteTrattazione\'" disabled="!vm.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div layout="row" layout-xs="column" layout-align-gt-xs="start start" class="commission-opinion-body" layout-wrap="true" style="margin-top: 15px"><md-input-container><label data-translate="commissionOpinion.dataParere" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'data\', vm.subjectId)}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.metadata.data[vm.subjectId]" ng-disabled="!vm.editable" ng-required="true"></md-datepicker></md-input-container><span ng-if="vm.metadata.data[vm.subjectId] && vm.editable"><md-button ng-click="vm.metadata.data[vm.subjectId] = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data parere</md-tooltip></md-button></span><!--<label data-translate="commissionOpinion.esprimenteParere"></label>--><md-chips ng-model="vm.subjects" readonly="true" flex-offset-gt-xs="5"><md-chip-template><span>{{$chip.nome}}</span></md-chip-template></md-chips><div flex-offset-gt-xs="5" ng-if="::vm.actType !== \'REL\'"><md-radio-group ng-model="vm.metadata.parere[vm.subjectId]"><label data-translate="commissionOpinion.parere" ng-click="vm.clearRadio(\'parere\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parere\', vm.subjectId)}"></label><md-radio-button value="FAVORABLE" class="md-primary" ng-disabled="!vm.editable">{{\'commissionOpinion.favorevole\'| translate}}</md-radio-button><md-radio-button value="CONDITIONED_FAVORABLE" class="md-primary" ng-disabled="!vm.editable" ng-if="vm.favorableOptionEnabled">{{\'commissionOpinion.favorevoleCondizionato\'| translate}}</md-radio-button><md-radio-button value="UNFAVORABLE" class="md-primary" ng-disabled="!vm.editable" ng-click="!!vm.editable ? vm.metadata.tipoFavorevolezza[vm.subjectId] = null : return">{{\'commissionOpinion.contrario\'| translate}}</md-radio-button><md-radio-button value="NOT_EXPRESSED" class="md-primary" ng-disabled="!vm.editable" ng-if="vm.notExpressedOptionEnabled">{{\'commissionOpinion.nonEspresso\'| translate}}</md-radio-button></md-radio-group></div><div flex-offset-gt-xs="5" ng-if="::vm.actType !== \'REL\'"><md-radio-group ng-model="vm.metadata.tipoFavorevolezza[vm.subjectId]" ng-if="vm.metadata.parere[vm.subjectId]"><label data-translate="commissionOpinion.tipoFavorevolezza" ng-click="vm.clearRadio(\'tipoFavorevolezza\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoFavorevolezza\', vm.subjectId)}"></label><md-radio-button value="MAJORITY" class="md-primary" ng-disabled="!vm.editable">{{\'commissionOpinion.maggioranza\'| translate}}</md-radio-button><md-radio-button value="ALL" class="md-primary" ng-disabled="!vm.editable">{{\'commissionOpinion.unanimita\'| translate}}</md-radio-button></md-radio-group></div></div><div ng-if="vm.includeInvestigationBoard"><md-radio-group ng-model="vm.metadata.schedaIstruttoria[vm.subjectId]" ng-disabled="!vm.editable"><label data-translate="gestioneAttiApp.form.commissionOpinions.schedaIstruttoria" ng-click="vm.clearRadio(\'schedaIstruttoria\')"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div></div>');
$templateCache.put('app/components/custom-loading-spinner/loading-spinner.html','<div class="custom-loader"></div>');
$templateCache.put('app/components/decadutoBlock/decaduto.html','<div class="panel-heading"><!-- <a class="hand glyphicon " name="decaduto{{vm.fieldSuffix}}"\r\n       ng-click="vm.decaduto.visible = !vm.decaduto.visible"\r\n       ng-class="{\'glyphicon-chevron-down\': !vm.decaduto.visible, \'glyphicon-chevron-up\': vm.decaduto.visible}">\r\n    </a> --> <span data-translate="gestioneAttiApp.form.sezioni.decaduto" ng-class="{\'readonly-section\': !vm.decaduto.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.decaduto.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div class="panel-footer"><document-toolbar section="::vm.decaduto" document-types="::vm.docTypes" include-notes="true" editable="::((vm.decaduto.editable) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/decadutoBlock/decadutoBlock.html','<div id="decaduto-state" class="atto-detail-pane"><a ng-click="vm.stato.decaduto.isCollapsed = !vm.stato.decaduto.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.decaduto.isCollapsed, \'glyphicon-eye-close\': vm.stato.decaduto.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">DECADUTO</span><div ng-show="vm.stato.decaduto.isCollapsed" layout="column" layout-margin><!-- decaduto SECTION --><div ng-include="::vm.sezioni.DECADUTO.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/documentToolbar/documentToolbar.directive.html','<div class="document-toolbar"><a name="{{vm.section.id}}"></a><div layout="row" class="document-toolbar-buttons"><a class="highlighted" style="margin-right: 5px" ng-if="vm.groupedDocs.length" ng-click="vm.toggleDocuments()" title="{{\'documentToolbar.showDocuments\'| translate}}"><i class="hand glyphicon glyphicon-file"></i> <span class="hidden-xs">Visualizza documenti</span> </a><a style="margin-right: 5px" ng-if="::vm.editable" ng-click="vm.toggleUpload()" title="{{\'documentToolbar.uploadDocuments\'| translate}}"><i class="hand glyphicon glyphicon-upload"></i> <span class="hidden-xs">Carica documenti</span> </a><a style="margin-right: 5px" ng-if="::vm.editable && vm.includeNotes" ng-click="vm.toggleNotes()" ng-class="{\'action-inactive\': !vm.section.metadati.sectionNotes}" title="{{\'sectionNotes.notes\'| translate}}"><i class="hand glyphicon glyphicon-tag"></i> <span class="hidden-xs">Note</span> </a><a ng-if="::vm.showLinksToggler()" ng-click="vm.toggleLinks()" ng-class="{\'action-inactive\': (vm.links.length<=1)}" title="{{\'sectionLinks.title\'| translate}}"><i class="hand glyphicon glyphicon-link"></i> <span class="hidden-xs">Link</span></a></div><div class="animate-show-hide" ng-show="vm.showDocuments && vm.groupedDocs.length" ng-include="::vm.documentsPanel"></div><div class="animate-show-hide" ng-show="vm.showUpload" ng-include="::vm.uploadPanel" ng-if="::vm.editable"></div><section-notes ng-if="::vm.enableSectionNotes()" note="vm.section.metadati.sectionNotes" show-notes="vm.showNotes" disabled="::(!vm.editable)"></section-notes><section-links ng-if="vm.includeLinks" show-links="vm.showLinks" default-links="::vm.defaultLinks" links="vm.section.metadati.links" editable="::vm.editable"></section-links></div>');
$templateCache.put('app/components/documentToolbar/documentToolbar.documentsPanel.html','<div class="row well document-toolbar-central-block"><div class="table-responsive"><span ng-if="!vm.groupedDocs || !vm.groupedDocs.length" data-translate="documentToolbar.noDocs"></span><table class="jh-table table table-striped" ng-if="vm.groupedDocs && vm.groupedDocs.length"><thead><tr class="header-row"><th width="30%" data-translate="documentToolbar.file">File</th><th width="20%" data-translate="documentToolbar.type">Tipo Documento</th><th width="5%" data-translate="documentToolbar.status">Stato</th><th width="5%" data-translate="documentToolbar.visibility">Visibilita</th><th width="5%" data-translate="documentToolbar.primary">Primario</th><th width="10%" data-translate="documentToolbar.numProtClass">Num. Prot./Classificazione</th><th width="5%" data-translate="documentToolbar.annoProt"></th><th width="5%" data-translate="documentToolbar.frontpiece">Copertina</th><th width="4%"></th><th width="2%"></th></tr></thead><!-- documenti non raggruppati --><tbody ng-repeat="group in vm.groupedDocs | filter: vm.isSingleFileGroup | orderBy: \'\':true:vm.orderByNumeroProtocolloConsiglio track by group.name"><tr ng-repeat="doc in group.documents track by doc.id"><td><span class="iter-hyper-link" ng-click="vm.downloadDocument(doc.id, doc.name)">{{::doc.name}}</span></td><td ng-if="::vm.canChangeDocumentType(doc)"><md-select aria-label="tipo documento" ng-model="doc.tipoDocumento.id" ng-change="vm.changeDocumentType(doc)"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType.id">{{docType.tipo}}</md-option></md-select></td><td ng-if="::(!vm.canChangeDocumentType(doc))">{{::doc.docType}}</td><td ng-if="!doc.datiProtocollo.error">{{doc.protocolState| protocolState}}<md-progress-circular md-mode="indeterminate" ng-if="doc.protocolState === \'ARCHIVE_NOW\'" class="md-hue-2 protocol-now-progress" md-diameter="16px"></md-progress-circular><a class="glyphicon glyphicon-repeat" title="{{\'documentToolbar.protocolRetry\'| translate}}" ng-if="group.protocolState === \'ERROR\'" ng-click="vm.retryProcolAction(group)"></a></td><td ng-if="doc.datiProtocollo.error">ERRORE: {{doc.datiProtocollo.errorMessage}}</td><td ng-if="::!vm.canChangeDocumentVisibility(doc)">{{::doc.visibilita| visibility}}</td><td ng-if="::vm.canChangeDocumentVisibility(doc)"><md-select ng-model="doc.visibilita" aria-label="visibilit\xE0 documento" ng-change="vm.changeDocumentVisibility(doc)"><md-option ng-repeat="visibilityState in vm.visibilityStates" value="{{visibilityState.value}}" ng-selected="doc.visibilita === visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><td>&dash;</td><td ng-if="(doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.numeroProtocolloConsiglio}}/{{doc.datiProtocollo.classificazioneArchivistica}}</td><td ng-if="(doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td ng-if="(doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.dataProtocolloConsiglio | date: \'yyyy\'}}</td><td ng-if="(doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td ng-if="!vm.canChangeDocumentVisibility(doc) || vm.isFrontpieceDisabled(doc)">{{doc.frontespizio | yesNo}}</td><td ng-if="vm.canChangeDocumentVisibility(doc) && !vm.isFrontpieceDisabled(doc)"><md-checkbox ng-model="doc.frontespizio" aria-label="frontespizio documento" ng-change="vm.changeDocumentFrontpiece(doc)"></md-checkbox></td><td><a class="hand glyphicon glyphicon-download-alt" ng-click="vm.downloadDocument(doc.id, doc.name)" title="{{\'documentToolbar.downloadFile\'| translate}}"></a> <a class="hand glyphicon glyphicon-trash" ng-click="vm.deleteDocument(doc.id)" title="{{\'documentToolbar.delete\'| translate}}" ng-if="vm.isDeletable(doc)" flex-offset-gt-xs="10"></a></td><td><a class="glyphicon" ng-if="group.protocolState === \'ARCHIVED\' || group.protocolState === \'ALREADY_ARCHIVED\'" ng-click="vm.openProtocolDataDialog(group)" ng-class="{\'glyphicon-eye-open\': !group.protocoldDataOpen, \'glyphicon-eye-close\': group.protocoldDataOpen}" flex-offset-gt-xs="10"></a></td></tr></tbody><tbody ng-if="vm.singleDocumentsCount > 0"><tr class="end-group-row"><td colspan="10"><span data-translate="documentToolbar.ungroupedFiles"></span>: {{vm.singleDocumentsCount}}</td></tr></tbody><!-- gruppi di documenti --><tbody ng-repeat="group in vm.groupedDocs | filter: vm.isRealGroup track by group.name"><tr ng-repeat="doc in group.documents track by doc.id"><td><span class="iter-hyper-link" ng-click="vm.downloadDocument(doc.id, doc.name)">{{::doc.name}}</span></td><td ng-if="::vm.canChangeDocumentType(doc)"><md-select aria-label="tipo documento" ng-model="doc.tipoDocumento.id" ng-change="vm.changeDocumentType(doc)"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType.id">{{docType.tipo}}</md-option></md-select></td><td ng-if="::(!vm.canChangeDocumentType(doc))">{{::doc.docType}}</td><td ng-if="!doc.datiProtocollo.error">{{doc.protocolState| protocolState}}<md-progress-circular md-mode="indeterminate" ng-if="doc.protocolState === \'ARCHIVE_NOW\'" class="md-hue-2 protocol-now-progress" md-diameter="16px"></md-progress-circular></td><td ng-if="doc.datiProtocollo.error">ERRORE: {{doc.datiProtocollo.errorMessage}}</td><td ng-if="::!vm.canChangeDocumentVisibility(doc)">{{::doc.visibilita| visibility}}</td><td ng-if="::vm.canChangeDocumentVisibility(doc)"><md-select ng-model="doc.visibilita" aria-label="visibilit\xE0 documento" ng-change="vm.changeDocumentVisibility(doc)"><md-option ng-repeat="visibilityState in vm.visibilityStates" value="{{visibilityState.value}}" ng-selected="doc.visibilita === visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><td>{{::doc.primario| yesNo}}</td><td ng-if="doc.primario && (doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.numeroProtocolloConsiglio}}/{{doc.datiProtocollo.classificazioneArchivistica}}</td><td ng-if="!doc.primario || (doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td ng-if="doc.primario && (doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.dataProtocolloConsiglio | date: \'yyyy\'}}</td><td ng-if="!doc.primario || (doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td ng-if="!vm.canChangeDocumentVisibility(doc) || vm.isFrontpieceDisabled(doc)">{{doc.frontespizio | yesNo}}</td><td ng-if="vm.canChangeDocumentVisibility(doc) && !vm.isFrontpieceDisabled(doc)"><md-checkbox ng-model="doc.frontespizio" aria-label="frontespizio documento" ng-change="vm.changeDocumentVisibility(doc)"></md-checkbox></td><td><a class="hand glyphicon glyphicon-download-alt" ng-click="vm.downloadDocument(doc.id, doc.name)" title="{{\'documentToolbar.downloadFile\'| translate}}"></a> <a class="hand glyphicon glyphicon-trash" ng-click="vm.deleteDocument(doc.id)" title="{{\'documentToolbar.delete\'| translate}}" ng-if="vm.isDeletable(doc)" flex-offset-gt-xs="10"></a></td><td></td></tr><tr class="end-group-row" ng-if="group.documents && group.documents.length > 0"><td colspan="2"><span data-translate="documentToolbar.groupedFiles"></span>: {{group.documents.length}}</td><td><a class="end-group-btn glyphicon glyphicon-repeat" title="{{\'documentToolbar.protocolRetry\'| translate}}" ng-if="group.protocolState === \'ERROR\'" ng-click="vm.retryProcolAction(group)" flex-offset-gt-xs="10"></a></td><td colspan="5"></td><td><a class="end-group-btn hand glyphicon glyphicon-download-alt" ng-click="vm.downloadGroupDocuments(group.name)" title="{{\'documentToolbar.downloadGroup\'| translate}}"></a></td><td><a class="end-group-btn glyphicon" ng-if="group.protocolState === \'ARCHIVED\' || group.protocolState === \'ALREADY_ARCHIVED\'" ng-click="vm.openProtocolDataDialog(group)" ng-class="{\'glyphicon-eye-open\': !group.protocoldDataOpen, \'glyphicon-eye-close\': group.protocoldDataOpen}" flex-offset-gt-xs="10"></a></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/documentToolbar/documentToolbar.uploadPanel.html','<div class="row well document-toolbar-central-block"><div class="row"><div ng-show="vm.showUpload && !vm.uploading"><div class="col-md-2 col-sm-12 col-xs-12"><label class="btn btn-default btn-file">{{\'documentToolbar.chooseFiles\' | translate}} <input type="file" ngf-select="vm.onFileSelect($files)" placeholder="Scegli file" ngf-multiple="true" style="display: none"></label><md-checkbox aria-label="upload-group" ng-model="vm.uploadingGroup">Sto caricando un gruppo</md-checkbox></div><div class="col-md-1 col-sm-12 col-xs-12">{{\'documentToolbar.or\' | translate}}</div><div class="col-md-9 col-sm-12 col-xs-12 pull-right"><div class="drop-box" ngf-drop="vm.onFileSelect($files)" ngf-multiple="true" ngf-drag-over-class="vm.dragOverClass($event)" ng-show="dropSupported">{{\'documentToolbar.dragHere\' | translate}}</div><div ngf-drop-available="dropSupported=true" ng-show="!dropSupported">{{\'documentToolbar.dragNotSupported\' | translate}}</div></div></div></div><div class="table-responsive" ng-show="vm.protocolGroups.length > 0"><table class="jh-table table table-striped"><thead><tr><th data-translate="documentToolbar.file">File</th><th data-translate="documentToolbar.type">Tipo Documento</th><!--<th data-translate="documentToolbar.group">Gruppo</th>--><th data-translate="documentToolbar.protocolAction">Tipo Protocollazione</th><th data-translate="documentToolbar.protocolSystem">Sistema Protocollo</th><th data-translate="documentToolbar.primary">Primario</th><th data-translate="documentToolbar.frontpiece">Frontespizio</th><th data-translate="documentToolbar.visibility">Visibilita</th><th></th><th></th></tr></thead><!-- documenti non raggruppati --><tbody ng-repeat="group in vm.protocolGroups | filter: vm.isSingleFileGroup track by $index"><tr ng-repeat="file in group.documents track by $index"><td><div>{{file.name}}</div><uib-progressbar min="0" max="100" value="file.progress" class="progress-striped active" type="{{file.progressClass}}" ng-show="vm.uploading"><span>{{file.progress| number:0}}%</span></uib-progressbar></td><td><md-select aria-label="tipo documento" ng-model="file.docType" ng-change="vm.setDefaultVisibility(file)"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType">{{docType.tipo}}</md-option></md-select></td><td><md-select ng-model="file.protocolState" ng-if="group.documents.length <= 1"><md-option ng-repeat="protocolOption in file.protocolOptions" ng-value="protocolOption.value" ng-disabled="protocolOption.disabled">{{protocolOption.textKey | translate}}</md-option></md-select><label ng-if="group.documents.length > 1 && group.protocolState ">{{\'documentToolbar.\' + group.protocolState | translate}}</label></td><td><md-select ng-model="file.protocolSystem"><md-option value="INSIEL">Sistema Insiel</md-option><md-option value="JOSH_PROTOCOL">Sistema Josh Protocol</md-option></md-select></td><td>&nbsp;</td><td><md-checkbox aria-label="frontpiece" ng-model="file.frontespizio" class="no-margin-bottom"></md-checkbox></td><td><md-select ng-model="file.visibility"><md-option value=""></md-option><md-option ng-repeat="visibilityState in file.visibilityStates" value="{{visibilityState.value}}" ng-selected="file.visibility === visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><td><a ng-if="file.protocolState === \'TO_BE_ARCHIVED\' || file.protocolState === \'ARCHIVE_NOW\'" class="hand glyphicon glyphicon-user" ng-click="vm.openSenderReceiverDialog(group, $index)" title="{{\'documentToolbar.senderReceiver\' | translate}}" flex-offset-gt-xs="10"></a></td><td><a class="hand glyphicon glyphicon-trash" ng-click="vm.removeSingleUpload(group, $index)" title="{{\'documentToolbar.delete\' | translate}}" flex-offset-gt-xs="10"></a></td></tr></tbody><tbody ng-if="vm.singleFilesCount > 0"><tr class="end-group-row"><td colspan="9"><span data-translate="documentToolbar.ungroupedFiles"></span>: {{vm.singleFilesCount}}</td></tr></tbody><!-- gruppi di documenti --><tbody ng-repeat="group in vm.protocolGroups | filter: vm.isRealGroup track by $index"><tr ng-repeat="file in group.documents track by $index"><td><div>{{file.name}}</div><uib-progressbar min="0" max="100" value="file.progress" class="progress-striped active" type="{{file.progressClass}}" ng-show="vm.uploading"><span>{{file.progress| number:0}}%</span></uib-progressbar></td><td><md-select aria-label="tipo documento" ng-model="file.docType"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType">{{docType.tipo}}</md-option></md-select></td><td><md-select ng-model="file.protocolState" ng-if="group.documents.length <= 1"><md-option ng-repeat="protocolOption in file.protocolOptions" ng-value="protocolOption.value" ng-disabled="protocolOption.disabled">{{protocolOption.textKey | translate}}</md-option></md-select><label ng-if="group.documents.length > 1 && group.protocolState ">{{\'documentToolbar.\' + group.protocolState | translate}}</label></td><td><md-select ng-model="file.protocolSystem" ng-if="group.documents.length <= 1"><md-option value="INSIEL">Sistema Insiel</md-option><md-option value="JOSH_PROTOCOL">Sistema Josh Protocol</md-option></md-select><label ng-if="group.documents.length > 1 && group.protocolSystem ">{{\'documentToolbar.\' + group.protocolSystem | translate}}</label></td><td><md-checkbox aria-label="primary" ng-checked="file.primary" ng-click="vm.setPrimaryDoc(group.documents, $index)" ng-if="group.protocolState !== \'NO_ARCHIVE\'" class="no-margin-bottom"></md-checkbox></td><td><md-checkbox aria-label="frontpiece" ng-model="file.frontespizio" class="no-margin-bottom"></md-checkbox></td><td><md-select ng-model="file.visibility"><md-option ng-repeat="visibilityState in file.visibilityStates" ng-value="visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><td></td><td><a class="hand glyphicon glyphicon-trash" ng-click="vm.removeSingleUpload(group, $index)" title="{{\'documentToolbar.delete\' | translate}}" flex-offset-gt-xs="10"></a></td></tr><tr class="end-group-row"><td colspan="2"><span data-translate="documentToolbar.groupedFiles"></span>: {{group.documents.length}}</td><td><md-select style="color:black" ng-model="group.protocolState" ng-change="vm.setProtocolStateForAllFilesOfGroup(group)" ng-if="group.documents.length > 1"><md-option ng-repeat="protocolOption in vm.protocolOptions" ng-value="protocolOption.value" ng-disabled="protocolOption.disabled" ng-if="protocolOption.value !== \'NO_ARCHIVE\'">{{protocolOption.textKey | translate}}</md-option></md-select></td><td><md-select style="color:black" ng-model="group.protocolSystem" ng-change="vm.setProtocolSystemForAllFilesOfGroup(group)" ng-if="group.documents.length > 1"><md-option value="INSIEL">Sistema Insiel</md-option><md-option value="JOSH_PROTOCOL">Sistema Josh Protocol</md-option></md-select></td><td colspan="3"></td><td><a ng-if="group.protocolState === \'TO_BE_ARCHIVED\' || group.protocolState === \'ARCHIVE_NOW\'" class="hand glyphicon glyphicon-user" ng-click="vm.openSenderReceiverDialog(group, $index)" title="{{\'documentToolbar.senderReceiver\' | translate}}" flex-offset-gt-xs="10"></a></td><td><a class="hand glyphicon glyphicon-trash" ng-click="vm.removeGroupUpload(group)" title="{{\'documentToolbar.delete\' | translate}}" flex-offset-gt-xs="10"></a></td></tr></tbody></table></div><div ng-show="vm.protocolGroups.length > 0" class="spacer"></div><div class="row"><div ng-show="vm.protocolGroups.length > 0"><div class="col-md-2"><md-button class="md-raised md-primary" ng-click="vm.uploadFiles()" ng-disabled="vm.uploading || vm.protocolGroups.length === 0" aria-label="upload" data-translate="documentToolbar.confirm"></md-button></div><div class="col-md-2"><md-button class="md-raised md-secondary" ng-click="vm.cancelUpload()" aria-label="undo" data-translate="documentToolbar.cancel"></md-button></div></div></div></div>');
$templateCache.put('app/components/documentToolbar/protocol-data-dialog-editable.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Dati Protocollo</h4></div><div class="modal-body"><div class="col-md-12"><div class="col-xs-6 col-sm-6 col-md-1"><md-input-container flex="grow"><label style="overflow: visible">Classificazione</label><input ng-model="vm.protocolData.classificazioneArchivistica" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-input-container></div><div class="col-xs-6 col-sm-6 col-md-2" ng-if="vm.protocolData.numeroProtocolloMittente"><md-input-container><label style="overflow: visible">Numero Prot. Mittente</label><input ng-model="vm.protocolData.numeroProtocolloMittente" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-input-container></div><div class="col-xs-6 col-sm-6 col-md-2" ng-if="vm.protocolData.direzione === \'A\' && vm.protocolData.dataProtocolloMittente"><md-input-container ng-show="!vm.isDataProtocolloMittentiWrong()"><label style="overflow: visible">Data Prot. Mittente</label><md-datepicker md-open-on-focus onkeydown="return false" md-hide-icons="calendar" class="" ng-model="vm.protocolData.dataProtocolloMittente" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-datepicker></md-input-container><md-input-container ng-show="vm.isDataProtocolloMittentiWrong()"><label>Data Prot. Mittente</label><md-datepicker md-open-on-focus onkeydown="return false" md-hide-icons="calendar" class="" ng-model="vm.dataProtocolloMittenteAusiliare" ng-change="vm.dataProtocolloMittenteAusiliareChanged()" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-datepicker></md-input-container></div><div class="col-xs-6 col-sm-6 col-md-2"><md-input-container><label style="overflow: visible">Numero Prot. Consiglio</label><input ng-model="vm.protocolData.numeroProtocolloConsiglio" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-input-container></div><div class="col-xs-6 col-sm-6 col-md-2"><md-input-container><label style="overflow: visible">Data Prot. Consiglio</label><md-datepicker md-open-on-focus onkeydown="return false" md-hide-icons="calendar" ng-model="vm.protocolData.dataProtocolloConsiglio" ng-value="vm.protocolData.dataProtocolloConsiglio | date: \'dd/MM/yyyy\'" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable"></md-datepicker></md-input-container></div><div class="col-xs-12 col-sm-12 col-md-12"><md-input-container style="width: 100%"><label>Oggetto</label><textarea ng-model="vm.protocolData.oggetto" ng-disabled="!vm.checkProtocolState(vm.protocolState) || !vm.editable">\r\n                </textarea></md-input-container></div><div class="col-xs-12"><label data-translate="documentToolbar.mitDestDialog.mittenti"></label><md-chips md-autocomplete-snap ng-model="vm.group.mittenti" md-transform-chip="vm.addPersonToList($chip)" readonly="!vm.checkProtocolState(vm.protocolState) || !vm.editable"><md-autocomplete md-selected-item="vm.selectedSender" md-search-text="vm.selectedSenderSearchText" md-items="item in vm.searchFirmatari(vm.selectedSenderSearchText)" md-item-text="item.descrizione" placeholder="{{\'documentToolbar.mitDestDialog.mittentiPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedSenderSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips></div><div class="col-xs-12" ng-if="vm.documento.mittentiEsterni && vm.documento.mittentiEsterni.length > 0" style="margin-top: 40px"><addable-input input-type="\'text\'" input-model="vm.documento.mittentiEsterni" inner-label="false" text-label="\'documentToolbar.mittentiEsterni\'" disabled="true" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div class="col-xs-12"><label data-translate="documentToolbar.mitDestDialog.destinatari"></label><md-chips md-autocomplete-snap ng-model="vm.group.destinatari" md-transform-chip="vm.addPersonToList($chip)" readonly="!vm.checkProtocolState(vm.protocolState) || !vm.editable"><md-autocomplete md-selected-item="vm.selectedReceiver" md-search-text="vm.selectedReceiverSearchText" md-items="item in vm.searchFirmatari(vm.selectedReceiverSearchText)" md-item-text="item.descrizione" placeholder="{{\'documentToolbar.mitDestDialog.destinatariPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedReceiverSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips></div><div class="col-xs-12" ng-if="vm.documento.destinatariEsterni && vm.documento.destinatariEsterni.length > 0" style="margin-top: 40px"><addable-input input-type="\'text\'" input-model="vm.documento.destinatariEsterni" inner-label="false" text-label="\'documentToolbar.destinatariEsterni\'" disabled="true" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div class="col-xs-12 bg-danger text-center" ng-if="vm.protocolData.error"><div class="col-xs-12"><span class="text-danger">Errore di Protocollazione</span></div><div class="col-xs-12">{{::vm.protocolData.errorMessage}}</div></div></div></div><div class="col-md-12" style="margin-bottom:10px"><div class="col-md-1 col-md-offset-8 col-xs-3 col-xs-offset-3"><md-button type="button" class="md-raised md-primary" ng-click="vm.saveProtocolData()" ng-if="vm.checkProtocolState(vm.protocolState) && vm.editable"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span>Salva</span></md-button></div><div class="col-md-1 col-md-offset-1 col-xs-3"><md-button type="button" class="md-raised" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Chiudi</span></md-button></div></div>');
$templateCache.put('app/components/documentToolbar/protocol-data-sender-receiver-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Lista Mittenti/Destinatari</h4></div><div class="modal-body" class="col-md-12"><div style="margin-left: 10px"><div><label>Ufficio operante</label></div><md-input-container><md-select ng-model="vm.group.operatingOfficeSelected" placeholder="{{vm.getPlaceholder()}}" ng-disabled="vm.userOperatingOffices.length === 1"><md-option ng-repeat="office in vm.userOperatingOffices track by office.code" value="{{::office.code}}">{{::office.description}}</md-option></md-select></md-input-container></div><!-- Mittenti --><div class="col-md-12" style="margin-top: 10px"><label data-translate="documentToolbar.mitDestDialog.mittenti"></label><md-chips md-autocomplete-snap ng-model="vm.group.mittenti" md-transform-chip="vm.addPersonToList($chip)"><md-autocomplete md-selected-item="vm.selectedSender" md-search-text="vm.selectedSenderSearchText" md-items="item in vm.searchUffici(vm.selectedSenderSearchText)" md-item-text="vm.getDescAnagrafica(item, false)" placeholder="{{\'documentToolbar.mitDestDialog.mittentiPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedSenderSearchText">{{vm.getDescAnagrafica(item, false)}}</span></md-autocomplete><md-chip-template><span class="small-chip">{{vm.getDescAnagrafica($chip, false)}}</span></md-chip-template></md-chips></div><!-- Destinatari --><div class="col-md-12" style="margin-top: 40px"><label data-translate="documentToolbar.mitDestDialog.destinatari"></label><md-chips md-autocomplete-snap ng-model="vm.group.destinatari" md-transform-chip="vm.addPersonToList($chip)"><md-autocomplete md-selected-item="vm.selectedReceiver" md-search-text="vm.selectedReceiverSearchText" md-items="item in vm.searchAnagrafiche(vm.selectedReceiverSearchText)" md-item-text="vm.getDescAnagrafica(item, false)" placeholder="{{\'documentToolbar.mitDestDialog.destinatariPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedReceiverSearchText">{{vm.getDescAnagrafica(item, false)}}</span></md-autocomplete><md-chip-template><span class="small-chip">{{vm.getDescAnagrafica($chip, false)}}</span></md-chip-template></md-chips></div></div><div class="col-md-12" style="padding-bottom: 10px"><div class="col-md-1 col-md-offset-10 col-xs-3 col-xs-offset-3"><md-button type="button" class="md-raised" data-dismiss="modal" ng-click="vm.clear()" layout-align="end center"><span>Chiudi</span></md-button></div></div>');
$templateCache.put('app/components/emendments/emendments.directive.html','<div><h4 data-translate="emendments.emendamentiPresentati"></h4></div><div ng-repeat="extendedEmendment in vm.extendedEmendments | orderBy : [\'emendment.dataProtocollo\',\'emendment.protocollo\'] track by $index"><div ng-if="extendedEmendment.emendment.dataProtocollo || extendedEmendment.emendment.protocollo"><div class="col-md-1" style="padding-top: 115px" ng-if="vm.editable"><div><a class="glyphicon glyphicon-minus-sign addable-input-action" ng-click="vm.removeEmendment($index)" ng-if="vm.editable"></a> <a class="glyphicon glyphicon-plus-sign addable-input-action" ng-click="vm.newEmendment()" ng-if="vm.isAddButtonEnabled($index)"></a></div></div><div class="emendment-block" ng-class="{\'emendment-block-first\': $first, \'col-md-11\': vm.editable, \'col-md-12\': !vm.editable}"><fieldset><div layout="row"><div layout="column"><div layout="row" layout-xs="column"><!-- Richiesta Caldini 05/19--><!--                         <md-input-container style="max-width: 150px;">\r\n                                <label data-translate="emendments.numeroEmendamento" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroEmendamento\', $index)}"></label>\r\n                                <input ng-disabled="!vm.editable" ng-model="extendedEmendment.emendment.numeroEmendamento" autocomplete="off">\r\n                            </md-input-container>\r\n    --><md-input-container flex-offset-gt-xs="5" style="min-width: 245px"><label data-translate="emendments.dataProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\', $index)}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="extendedEmendment.emendment.dataProtocollo" disabled="disabled" autocomplete="off"></md-datepicker></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="emendments.protocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'protocollo\', $index)}"></label><input disabled="disabled" ng-model="extendedEmendment.emendment.protocollo" autocomplete="off"></md-input-container><!--                             <md-input-container ng-if="vm.includeState" flex-offset-gt-xs="5" class="clean-allignment">\r\n                                <label data-translate="emendments.state"  ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'state\', $index)}"></label>\r\n                                <md-select ng-model="extendedEmendment.emendment.state" ng-disabled="!vm.editable">\r\n                                    <md-option ng-repeat="state in vm.states" ng-value="state">{{\'emendments.states.\' + state| translate}}</md-option>\r\n                                </md-select>\r\n                            </md-input-container> --></div><div layout="row" layout-xs="column" layout-align-gt-xs="start end"><div layout="column"><label data-translate="emendments.firmatari" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'firmatari\', $index)}"></label><md-chips md-autocomplete-snap ng-model="extendedEmendment.emendment.firmatari" md-transform-chip="vm.addPersonToList($chip)" readonly="true"><md-autocomplete md-selected-item="extendedEmendment.selectedItem" md-search-text="extendedEmendment.searchText" md-items="item in extendedEmendment.searchFunction(extendedEmendment.searchText)" md-item-text="item.descrizione" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="extendedEmendment.searchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips></div></div></div></div></fieldset></div></div></div>');
$templateCache.put('app/components/eventMailNotificationButton/eventMailNotificationButton.html','<md-button ng-click="vm.onButtonClick()" class="md-fab md-mini md-primary"><span class="glyphicon glyphicon-envelope"></span><md-tooltip>Invia notifica email</md-tooltip></md-button>');
$templateCache.put('app/components/formToolbar/formToolbar.html','<md-toolbar hl-sticky="" flex layout="row" anchor="top" offset-top="0" layout-align="end center" class="toolbar-sticky md-whiteframe-2dp" ng-cloak><div flex-gt-xs="30" flex-offset-gt-xs="70" flex="50" layout="row" layout-align="end center"><md-button aria-label="save" data-toggle="modal" class="md-icon-button"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span></md-button><md-button aria-label="download" data-toggle="modal" class="md-icon-button"><span class="glyphicon glyphicon-cloud-download" aria-hidden="true"></span></md-button><md-button aria-label="next" data-toggle="modal" class="md-icon-button"><span class="glyphicon glyphicon-circle-arrow-right" aria-hidden="true"></span></md-button></div></md-toolbar>');
$templateCache.put('app/components/giuntaTrasmissionBlock/giuntaTrasmissionBlock.html','<div id="giuntaTrasmission-state" ng-if="::true" class="atto-detail-pane"><a ng-click="vm.stato.giuntaTrasmission.isCollapsed = !vm.stato.giuntaTrasmission.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.giuntaTrasmission.isCollapsed, \'glyphicon-eye-close\': vm.stato.giuntaTrasmission.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">TRASMISSIONE GIUNTA</span><div ng-show="vm.stato.giuntaTrasmission.isCollapsed" layout="column" layout-margin><!-- GIUNTA TRASMISSION --><div ng-include="::vm.sezioni.GIUNTA_TRASMISSION.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/giuntaTrasmissionBlock/giuntaTrasmissionSection.html','<div class="panel-heading" style="background-color: #eeeeee"><a class="hand glyphicon" name="giuntaTrasmissionSection" ng-click="vm.giuntaTrasmission.visible = !vm.giuntaTrasmission.visible" ng-class="{\'glyphicon-chevron-down\': !vm.giuntaTrasmission.visible, \'glyphicon-chevron-up\': vm.giuntaTrasmission.visible}"></a> <span ng-class="{\'readonly-section\': !vm.giuntaTrasmission.editable}">Trasmissione Giunta</span></div><div ng-if="vm.giuntaTrasmission.visible" id="unified-text-body" class="panel-body"><div class="panel-body" flex-offset-gt-xs="5"><md-content layout="row" layout-xs="column" flex layout-padding><md-checkbox ng-if="vm.atto.tipoAtto === \'CDG\' || vm.atto.tipoAtto === \'IEA\'" class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_TRASMISSIONE_ATTI_COLLEGATI\']">Lettera Trasmissione Atti Collegati</md-checkbox><md-checkbox ng-if="vm.atto.tipoAtto !== \'CDG\' && vm.atto.tipoAtto !== \'IEA\'" class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_TRASMISSIONE\']">Lettera Trasmissione Giunta</md-checkbox></md-content><div layout="row" layout-xs="column" layout-align-xs="start start"><addable-input input-type="\'date\'" input-model="vm.giuntaTrasmissionSection.metadati.dateTrasmissioneGiunta" inner-label="true" date-label="\'gestioneAttiApp.form.giuntaTrasmission.dataTrasmissioneGiunta\'" disabled="::(!vm.giuntaTrasmissionSection.editable)" class="testo-sostitutivo-datepicker" style="width: 200px; margin-top: 20px"></addable-input></div></div></div><div class="panel-footer" ng-if="vm.giuntaTrasmission.visible"><document-toolbar section="::vm.giuntaTrasmissionSection" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="[\'burt\', \'regulatoryCollection\']" editable="::(vm.giuntaTrasmissionSection.editable)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/inammissibileBlock/inammissibile.html','<div class="panel-heading"><!-- <a class="hand glyphicon " name="inammissibile{{vm.fieldSuffix}}"\r\n       ng-click="vm.inammissibile.visible = !vm.inammissibile.visible"\r\n       ng-class="{\'glyphicon-chevron-down\': !vm.inammissibile.visible, \'glyphicon-chevron-up\': vm.inammissibile.visible}">\r\n    </a> --> <span data-translate="gestioneAttiApp.form.sezioni.inammissibile" ng-class="{\'readonly-section\': !vm.inammissibile.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.inammissibile.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div class="panel-footer"><document-toolbar section="::vm.inammissibile" document-types="::vm.docTypes" include-notes="true" editable="::((vm.inammissibile.editable) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/inammissibileBlock/inammissibileBlock.html','<div id="inammissibile-state" class="atto-detail-pane"><a ng-click="vm.stato.inammissibile.isCollapsed = !vm.stato.inammissibile.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.inammissibile.isCollapsed, \'glyphicon-eye-close\': vm.stato.inammissibile.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">INAMMISSIBILE</span><div ng-show="vm.stato.inammissibile.isCollapsed" layout="column" layout-margin><!-- inammissibile SECTION --><div ng-include="::vm.sezioni.INAMMISSIBILE.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/improcedibileBlock/improcedibile.html','<div class="panel-heading"><!-- <a class="hand glyphicon " name="improcedibile{{vm.fieldSuffix}}"\r\n       ng-click="vm.improcedibile.visible = !vm.improcedibile.visible"\r\n       ng-class="{\'glyphicon-chevron-down\': !vm.improcedibile.visible, \'glyphicon-chevron-up\': vm.improcedibile.visible}">\r\n    </a> --> <span data-translate="gestioneAttiApp.form.sezioni.improcedibile" ng-class="{\'readonly-section\': !vm.improcedibile.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.improcedibile.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div class="panel-footer"><document-toolbar section="::vm.improcedibile" document-types="::vm.docTypes" include-notes="true" editable="::((vm.improcedibile.editable) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/improcedibileBlock/improcedibileBlock.html','<div id="improcedibile-state" class="atto-detail-pane"><a ng-click="vm.stato.improcedibile.isCollapsed = !vm.stato.improcedibile.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.improcedibile.isCollapsed, \'glyphicon-eye-close\': vm.stato.improcedibile.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">IMPROCEDIBILE</span><div ng-show="vm.stato.improcedibile.isCollapsed" layout="column" layout-margin><!-- improcedibile SECTION --><div ng-include="::vm.sezioni.IMPROCEDIBILE.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><md-button type="submit" class="md-raised md-accent pull-right" data-translate="login.form.button">Sign in</md-button></form></div></div></div>');
$templateCache.put('app/components/macro-materia-materia-list/macro-materia-materia-list.html','<label>{{\'macro-materia-materia-list.title\' | translate}}</label><div layout="row" ng-if="!vm.disabled"><macro-materia-chip-search-component model="vm.selectedMacroMateria" macro-materia-list="vm.macroMateriaList" max-chips="1" label="macro-materia-materia-list.macro-materia-chip-label" on-model-change="vm.macroMateriaChanged"></macro-materia-chip-search-component><md-input-container style="position: relative; top: 22px"><label>Materia</label><md-select ng-model="vm.selectedMateria" ng-disabled="!vm.selectedMacroMateria"><md-option ng-repeat="materia in vm.availableMateriaList" ng-value="{{materia}}">{{materia.macroMateria.code + \'.\' + materia.code + \' \' + materia.description}}</md-option></md-select></md-input-container><div><button ng-disabled="!vm.selectedMacroMateria" class="md-raised md-primary md-button" ng-click="vm.addNewMacromateriaMateriaRow()" style="position: relative; top: 20px"><span style="margin-right: 5px" class="glyphicon glyphicon-plus-sign"></span>{{\'macro-materia-materia-list.add-macro-materia-materia-row\' | translate}}</button></div></div><div style="margin-top: 10px" ng-if="vm.model && vm.model.length > 0 && !translating"><table class="table table-striped"><thead><tr><th class="col-md-1 text-left">Progressivo</th><th class="col-md-1 text-left">Codice</th><th class="col-md-5 text-left">Macro Materia</th><th class="col-md-4 text-left">Materia</th><th ng-if="!vm.disabled" class="col-md-1 text-center"></th></tr></thead><tbody><tr ng-repeat="macroMateriaMateriaRow in vm.translatedRowList track by $index"><td class="col-md-1 text-left">{{$index + 1}}</td><td class="col-md-1 text-left">{{ !macroMateriaMateriaRow.materia ? macroMateriaMateriaRow.macroMateria.code : macroMateriaMateriaRow.macroMateria.code + \'.\' + macroMateriaMateriaRow.materia.code}}</td><td class="col-md-5 text-left">{{macroMateriaMateriaRow.macroMateria.description}}</td><td class="col-md-4 text-left">{{macroMateriaMateriaRow.materia.description}}</td><td class="col-md-1 text-center" ng-if="!vm.disabled"><div><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder($event, -1, $index)"><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span><md-tooltip>Sposta sopra</md-tooltip></md-button><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder($event, 1, $index)"><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span><md-tooltip>Sposta sotto</md-tooltip></md-button><md-button class="md-icon-button md-primary" ng-click="vm.onDeleteRow($index)"><span class="glyphicon glyphicon glyphicon-remove" aria-hidden="true"></span><md-tooltip>Elimina riga</md-tooltip></md-button></div></td></tr></tbody></table></div>');
$templateCache.put('app/components/macro-materia-chip-search/macro-materia-chip-search.html','<label data-translate="{{ !vm.label ? \'materia.addMacroMateriaLabel\' : vm.label}}" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroPdris\')}"></label><md-chips flex ng-model="vm.selectedMacroMateria" ng-change="vm.changedMacroMateria()" md-on-select="false" md-max-chips="{{vm.maxChips}}" ng-class="{\'md-focused\': false}" readonly="vm.disabled"><md-autocomplete md-selected-item="vm.macroMateria" md-search-text="vm.macroMateriaSearchText" md-items="item in vm.searchMacroMateria(vm.macroMateriaSearchText)" md-item-text="item.description" md-no-cache="true" placeholder="Macro materia"><div><span md-highlight-text="vm.macroMateriaSearchText">{{item.code}} - {{item.description | limitTo:50}}</span> <span ng-if="vm.showEndDate && item.validityEndDate != null">[ scad. {{item.validityEndDate}}]</span></div></md-autocomplete><md-chip-template><div><span>{{$chip.code}} - {{$chip.description | limitTo:50}}</span> <span ng-if="vm.showEndDate && $chip.validityEndDate != null">[ scad. {{$chip.validityEndDate}}]</span></div></md-chip-template></md-chips>');
$templateCache.put('app/components/respintoBlock/respinto.html','<div class="panel-heading"><!-- <a class="hand glyphicon " name="respinto{{vm.fieldSuffix}}"\r\n       ng-click="vm.respinto.visible = !vm.respinto.visible"\r\n       ng-class="{\'glyphicon-chevron-down\': !vm.respinto.visible, \'glyphicon-chevron-up\': vm.respinto.visible}">\r\n    </a> --> <span data-translate="gestioneAttiApp.form.sezioni.respinto" ng-class="{\'readonly-section\': !vm.respinto.editable}"></span> <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.respinto.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span></div><div class="panel-footer"><document-toolbar section="::vm.respinto" document-types="::vm.docTypes" include-notes="true" editable="::((vm.respinto.editable) || vm.isProtocollo || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/respintoBlock/respintoBlock.html','<div id="respinto-state" class="atto-detail-pane"><a ng-click="vm.stato.respinto.isCollapsed = !vm.stato.respinto.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.respinto.isCollapsed, \'glyphicon-eye-close\': vm.stato.respinto.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">RESPINTO</span><div ng-show="vm.stato.respinto.isCollapsed" layout="column" layout-margin><!-- respinto SECTION --><div ng-include="::vm.sezioni.RESPINTO.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/notifications/notifications.html','<div class="list-group"><a name="notifiche-anchor-name"></a> <a href="#" class="flex-column align-items-start" flex-offset-gt-xs="5"><md-checkbox aria-label="showUnread" class="md-primary notification-body" ng-model="vm.showOnlyUnreadNotifications" ng-change="vm.loadNotifications()"><span data-translate="gestioneAttiApp.notifications.checkbox"></span></md-checkbox></a><div ng-if="vm.showCommissioniReferentiSearch" class="notifications-search" flex-offset-gt-xs="5"><div><md-checkbox ng-repeat="commissione in vm.commissioni" aria-label="{{::commissione.nome}}" class="md-primary notification-body" ng-click="vm.search(commissione.id)"><span>{{::commissione.nome}}</span></md-checkbox></div></div><a href="#" ng-if="!vm.notifications.length" ng-cloak="" class="flex-column align-items-start"><p class="mb-1"><span class="glyphicon glyphicon-eye-close"></span>&nbsp;<i data-translate="gestioneAttiApp.notifications.nocontent"></i></p></a><div class="list-group-item list-group-item-action flex-column align-items-start notification-list-item hand" ng-class="{}" ng-cloak="" ng-if="vm.notifications.length" ng-repeat="notification in vm.notifications" ng-click="vm.openNotification = notification"><div class="notification-body" ng-class="::{\'bg-info\': vm.openNotification === notification,\'open\': vm.openNotification === notification,\'unread\': notification.isUnread, \'read\': !notification.isUnread,}" ng-click="vm.markAsRead(notification)"><div class="d-flex w-100 justify-content-between"><h5 class="mb-1"><span ng-click="vm.markAsRead(notification)" class="glyphicon" ng-class="::{\'unread\': notification.isUnread, \'read\': !notification.isUnread, \'glyphicon-record\': notification.isUnread, \'glyphicon-ok-circle\': !notification.isUnread}"></span> <a class="notifica-atto-link" ui-sref="atto-edit({id: notification.idAtto})">Atto {{::notification.legislatura ? \'[\' + (notification.legislatura | romanize) + \']\' : \'\'}} {{::notification.tipoAtto}}{{::notification.numeroAtto}}</a> <small>{{::notification.dataNotifica| date: \'dd/MM/yyyy HH:mm\'}}</small></h5></div><p class="mb-1" ng-if="vm.notifications.length">{{notification.messaggio| limitTo: (vm.openNotification === notification ? null : 55)}} {{vm.openNotification !== notification ? \' ...\' : \'\'}}</p><a ui-sref="atto-edit({id: notification.idAtto})"><small class="text-uppercase text-primary notifica-atto-link" ng-show="vm.openNotification === notification">Atto in stato <b>{{::notification.statoAtto.name}}</b></small></a></div><md-divider></md-divider></div></div>');
$templateCache.put('app/components/rispostaScrittaBlock/rispostaScrittaBlock.html','<div id="risposta-scritta-state" ng-if="::true" class="atto-detail-pane"><a ng-click="vm.stato.rispostaScritta.isCollapsed = !vm.stato.rispostaScritta.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.rispostaScritta.isCollapsed, \'glyphicon-eye-close\': vm.stato.rispostaScritta.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">RISPOSTA SCRITTA</span><div ng-show="vm.stato.rispostaScritta.isCollapsed" layout="column" layout-margin><!-- COURTROOM OUTCOME --><div ng-include="::vm.sezioni.COURT_OUTCOME.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/retiredBlock/retired.html','<div class="panel-heading" style="background-color: #eeeeee"><a class="hand glyphicon" name="retiredSection" ng-click="vm.retired.visible = !vm.retired.visible" ng-class="{\'glyphicon-chevron-down\': !vm.retired.visible, \'glyphicon-chevron-up\': vm.retired.visible}"></a> <span ng-class="{\'readonly-section\': !vm.retired.editable}">Ritiro atto</span></div><div ng-if="vm.retired.visible" id="unified-text-body" class="panel-body"><!-- Data Ritiro --><div layout="row" layout-xs="column"><md-input-container flex><label data-translate="gestioneAttiApp.form.withdrawn.dataRitiro"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.presentationSection.metadati.dataRitiro" ng-disabled="vm.viewMode || !vm.canEdit" autocomplete="off"></md-datepicker></md-input-container></div><!-- Note di ritiro --><div flex layout="row" layout-xs="column" layout-margin="10"><md-input-container flex><label data-translate="gestioneAttiApp.form.withdrawn.notaRitiro"></label><textarea ng-model="vm.presentationSection.metadati.notaRitiro" ng-disabled="vm.viewMode || !vm.canEdit" autocomplete="off"></textarea></md-input-container></div><!-- Dati protocollo --><div flex layout-xs="column" layout-align="start start"><div layout="row" layout-margin="10"><label>Dati Protocollo</label></div><div flex layout="row"><md-input-container flex><label data-translate="emendments.dataProtocollo" style="overflow: visible"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.dataProtocolloConsiglio" disabled="disabled" autocomplete="off"></md-datepicker></md-input-container><md-input-container flex><label data-translate="emendments.protocollo"></label><input disabled="disabled" ng-model="vm.numeroProtocolloConsiglio" disabled="disabled" autocomplete="off"></md-input-container></div></div><div ng-if="vm.attoRitiratoDocs.length > 0 && vm.docPresentationSession" layout="row" layout-xs="column" layout-align="start start"><a ng-click="vm.scrollToPresentationDocs()"><i class="glyphicon glyphicon-link">&nbsp;</i>Tutti i documenti relativi alla lettera di ritiro atto sono presenti nella sezione Presentazione</a></div><!-- Rimossa indicazione di documenti non trovati\r\n        <div ng-if="vm.attoRitiratoDocs.length === 0 || !vm.docPresentationSession" layout="row" layout-xs="column" layout-align="start start">\r\n            <a ng-click="vm.scrollToPresentationDocs()"><i class="glyphicon glyphicon-link">&nbsp;</i>Non \xE8 stato trovato nessun documento relativo alla lettera di ritiro atto</a>\r\n    </div> --></div><div class="panel-footer" ng-if="vm.retired.visible"><document-toolbar section="::vm.retiredSection" document-types="::vm.docTypes" include-notes="true" include-links="true" default-links="" editable="!vm.viewMode &&  vm.canEdit" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.actType"></document-toolbar></div>');
$templateCache.put('app/components/retiredBlock/retiredBlock.html','<div id="retired-state" ng-if="::true" class="atto-detail-pane"><a ng-click="vm.stato.retired.isCollapsed = !vm.stato.retired.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.retired.isCollapsed, \'glyphicon-eye-close\': vm.stato.retired.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">RITIRATO</span><div ng-show="vm.stato.retired.isCollapsed" layout="column" layout-margin><!-- RETIRED SECTION --><div ng-include="::vm.sezioni.RETIRED.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/retiredBlock/ritirato-date-dialog.html','<md-dialog aria-label="ritiro atto" class="send-back-date-container" flex="150" layout-padding layout-align="center center"><!-- <md-input-container>\r\n        <label data-translate="gestioneAttiApp.form.withdrawn.dataRitiro"></label>\r\n        <md-datepicker md-open-on-focus onkeydown="return false" ng-model="dataRitiro"></md-datepicker>\r\n    </md-input-container>\r\n    <span ng-if="dataRitiro">\r\n        <md-button ng-click="dataRitiro = null" class="md-icon-button home-prom-date-clear-button">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>\r\n            <md-tooltip>Rimuovi data ritiro</md-tooltip>\r\n        </md-button>\r\n    </span> --><md-dialog-actions layout="row" flex="100"><md-button class="md-raised md-primary" ng-click="confirm();"><span data-translate="entity.action.confirm"></span></md-button><span flex></span><md-button class="md-raised md-accent" ng-click="cancel();"><span data-translate="entity.action.cancel"></span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/sectionNotes/sectionNotes.directive.html','<div class="animate-show-hide section-notes-input" ng-show="vm.showNotes" layout="row" flex-offset="5" layout-align="start start"><md-input-container class="md-block" flex="100" flex-gt-sm="50"><label>{{\'sectionNotes.notes\'| translate}}</label><textarea ng-model="vm.note" ng-focus="vm.showNotes" rows="5" md-no-autogrow md-select-on-focus></textarea></md-input-container></div>');
$templateCache.put('app/components/sectionLinks/sectionLinks.directive.html','<div ng-show="vm.showLinks" class="animate-show-hide" flex-offset="5" layout-padding><form name="linksForm" ng-if="vm.editable"><div ng-repeat="link in vm.links" data-order="{{$index}}" layout="row" layout-align="start start"><md-input-container flex="15"><label>{{\'sectionLinks.link.description\' | translate}}</label><input name="description{{$index}}" ng-model="link.description" ng-disabled="link.isDefault"></md-input-container><md-input-container flex="20" flex-offset="5"><label>{{\'sectionLinks.link.url\' | translate}}</label><input name="url{{$index}}" ng-model="link.url" ng-pattern="vm.urlPattern" required> <span ng-if="!linksForm[\'url\' + $index].$valid" class="invalid-input">Inserire un URL valido</span></md-input-container><md-button ng-click="vm.testLink(link.url)" class="btn-test">Test</md-button><md-button ng-click="vm.removeItem($index)" class="btn-cancel">Cancella</md-button><md-button ng-if="$last && vm.canAdd()" ng-click="vm.addLink({})" class="btn-add">Aggiungi</md-button></div></form><div ng-if="!vm.editable" layout="column" layout-align="start start"><h3 class="md-headline" data-translate="sectionLinks.title"></h3><md-content ng-if="link.description && link.url" ng-repeat="link in vm.links"><a href="{{link.url}}" rel="external" target="_blank"><i class="glyphicon glyphicon-link"></i>&nbsp;&nbsp;{{link.description}}</a></md-content></div></div>');
$templateCache.put('app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.directive.html','<div class="document-toolbar"><a name="{{vm.seduta.id}}"></a><div layout="row" class="document-toolbar-buttons"><a style="margin-right: 5px" ng-if="vm.groupedDocs.length" ng-click="vm.toggleDocuments()" title="{{\'documentToolbar.showDocuments\'| translate}}"><i class="hand glyphicon glyphicon-file"></i> <span class="hidden-xs">Visualizza documenti</span> </a><a style="margin-right: 5px" ng-if="vm.editable" ng-click="vm.toggleUpload()" title="{{\'documentToolbar.uploadDocuments\'| translate}}"><i class="hand glyphicon glyphicon-upload"></i> <span class="hidden-xs">Carica documenti</span></a></div><div class="animate-show-hide" ng-show="vm.showDocuments && vm.groupedDocs.length" ng-include="::vm.documentsPanel"></div><div class="animate-show-hide" ng-show="vm.showUpload" ng-include="::vm.uploadPanel" ng-if="vm.editable"></div></div>');
$templateCache.put('app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.documentsPanel.html','<div class="row well document-toolbar-central-block"><div class="table-responsive"><span ng-if="!vm.groupedDocs || !vm.groupedDocs.length" data-translate="documentToolbar.noDocs"></span><table class="jh-table table table-striped" ng-if="vm.groupedDocs && vm.groupedDocs.length"><thead><tr class="header-row"><th data-translate="documentToolbar.file">File</th><th data-translate="documentToolbar.type">Tipo Documento</th><th data-translate="documentToolbar.status">Stato</th><th data-translate="documentToolbar.visibility">Visibilita</th><!-- <th data-translate="documentToolbar.primary">Primario</th> --><th data-translate="documentToolbar.numProtClass">Num. Prot./Classificazione</th><th data-translate="documentToolbar.annoProt"></th><th></th><th></th></tr></thead><!-- documenti non raggruppati --><tbody ng-repeat="group in vm.groupedDocs | filter: vm.isSingleFileGroup | orderBy: \'\':true:vm.orderByNumeroProtocolloConsiglio track by group.name"><tr ng-repeat="doc in group.documents track by doc.id"><td><span class="iter-hyper-link" ng-click="vm.downloadDocument(doc.id, doc.name)">{{::doc.name}}</span></td><td ng-if="::vm.canChangeDocumentType(doc)"><md-select aria-label="tipo documento" ng-model="doc.tipoDocumento.id" ng-change="vm.changeDocumentType(doc)"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType.id">{{docType.tipo}}</md-option></md-select></td><td ng-if="::(!vm.canChangeDocumentType(doc))">{{::doc.docType}}</td><td ng-if="!doc.datiProtocollo.error">{{doc.protocolState| protocolState}}<md-progress-circular md-mode="indeterminate" ng-if="doc.protocolState === \'ARCHIVE_NOW\'" class="md-hue-2 protocol-now-progress" md-diameter="16px"></md-progress-circular><a class="glyphicon glyphicon-repeat" title="{{\'documentToolbar.protocolRetry\'| translate}}" ng-if="group.protocolState === \'ERROR\'" ng-click="vm.retryProcolAction(group)"></a></td><td ng-if="doc.datiProtocollo.error">ERRORE: {{doc.datiProtocollo.errorMessage}}</td><td ng-if="::!vm.canChangeDocumentVisibility(doc)">{{::doc.visibilita| visibility}}</td><td ng-if="::vm.canChangeDocumentVisibility(doc)"><md-select ng-model="doc.visibilita" aria-label="visibilit\xE0 documento" ng-change="vm.changeDocumentVisibility(doc)"><md-option ng-repeat="visibilityState in vm.visibilityStates" value="{{visibilityState.value}}" ng-selected="doc.visibilita === visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><!-- <td>&dash;</td> --><td ng-if="(doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.numeroProtocolloConsiglio}}/{{doc.datiProtocollo.classificazioneArchivistica}}</td><td ng-if="(doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td ng-if="(doc.protocolState === \'ARCHIVED\' || doc.protocolState === \'ALREADY_ARCHIVED\') && (doc.datiProtocollo !== null && doc.datiProtocollo.numeroProtocolloConsiglio !== null)">{{doc.datiProtocollo.dataProtocolloConsiglio | date: \'yyyy\'}}</td><td ng-if="(doc.protocolState !== \'ARCHIVED\' && doc.protocolState !== \'ALREADY_ARCHIVED\') || (doc.datiProtocollo === null || doc.datiProtocollo.numeroProtocolloConsiglio === null)">&dash;</td><td><a class="hand glyphicon glyphicon-download-alt" ng-click="vm.downloadDocument(doc.id, doc.name)" title="{{\'documentToolbar.downloadFile\'| translate}}"></a> <a class="hand glyphicon glyphicon-trash" ng-click="vm.deleteDocument(doc.id)" title="{{\'documentToolbar.delete\'| translate}}" ng-if="vm.isDeletable(doc)" flex-offset-gt-xs="10"></a></td><td><a class="glyphicon" ng-if="group.protocolState === \'ARCHIVED\' || group.protocolState === \'ALREADY_ARCHIVED\'" ng-click="vm.openProtocolDataDialog(group)" ng-class="{\'glyphicon-eye-open\': !group.protocoldDataOpen, \'glyphicon-eye-close\': group.protocoldDataOpen}" flex-offset-gt-xs="10"></a></td></tr></tbody><tbody ng-if="vm.singleDocumentsCount > 0"><tr class="end-group-row"><td colspan="9"><span data-translate="documentToolbar.uploadedFiles"></span>: {{vm.singleDocumentsCount}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.uploadPanel.html','<div class="row well document-toolbar-central-block"><div class="row"><div ng-show="vm.showUpload && !vm.uploading"><div class="col-md-2 col-sm-12 col-xs-12"><label class="btn btn-default btn-file">{{\'documentToolbar.chooseFiles\' | translate}} <input type="file" ngf-select="vm.onFileSelect($files)" placeholder="Scegli file" ngf-multiple="false" style="display: none"></label></div><div class="col-md-1 col-sm-12 col-xs-12">{{\'documentToolbar.or\' | translate}}</div><div class="col-md-9 col-sm-12 col-xs-12 pull-right"><div class="drop-box" ngf-drop="vm.onFileSelect($files)" ngf-multiple="false" ngf-drag-over-class="vm.dragOverClass($event)" ng-show="dropSupported">{{\'documentToolbar.dragHere\' | translate}}</div><div ngf-drop-available="dropSupported=true" ng-show="!dropSupported">{{\'documentToolbar.dragNotSupported\' | translate}}</div></div></div></div><div class="table-responsive" ng-show="vm.protocolGroups.length > 0"><table class="jh-table table table-striped"><thead><tr><th data-translate="documentToolbar.file">File</th><th data-translate="documentToolbar.type">Tipo Documento</th><!--<th data-translate="documentToolbar.group">Gruppo</th>--><th data-translate="documentToolbar.protocolAction">Tipo Protocollazione</th><th data-translate="documentToolbar.protocolSystem">Sistema Protocollo</th><!-- <th data-translate="documentToolbar.primary">Primario</th>\r\n                <th data-translate="documentToolbar.frontpiece">Frontespizio</th> --><th data-translate="documentToolbar.visibility">Visibilita</th><th></th><th></th></tr></thead><!-- documenti non raggruppati --><tbody ng-repeat="group in vm.protocolGroups | filter: vm.isSingleFileGroup track by $index"><tr ng-repeat="file in group.documents track by $index"><td><div>{{file.name}}</div><uib-progressbar min="0" max="100" value="file.progress" class="progress-striped active" type="{{file.progressClass}}" ng-show="vm.uploading"><span>{{file.progress| number:0}}%</span></uib-progressbar></td><td><md-select aria-label="tipo documento" ng-model="file.docType" ng-change="vm.setDefaultVisibility(file)"><md-option ng-repeat="docType in vm.docTypes" ng-value="docType">{{docType.tipo}}</md-option></md-select></td><td><md-select ng-model="file.protocolState" ng-if="group.documents.length <= 1"><md-option ng-repeat="protocolOption in file.protocolOptions" ng-value="protocolOption.value" ng-disabled="protocolOption.disabled">{{protocolOption.textKey | translate}}</md-option></md-select><label ng-if="group.documents.length > 1 && group.protocolState ">{{\'documentToolbar.\' + group.protocolState | translate}}</label></td><td><md-select ng-model="file.protocolSystem"><!--<md-option value="INSIEL">Sistema Insiel</md-option>--><md-option value="JOSH_PROTOCOL">Sistema Josh Protocol</md-option></md-select></td><td hidden>&nbsp;</td><td hidden><md-checkbox aria-label="frontpiece" ng-model="file.frontpiece" class="no-margin-bottom" ng-if="!(file.frontpieceDisabled || file.notArchive)"></md-checkbox></td><td><md-select ng-model="file.visibility"><md-option value=""></md-option><md-option ng-repeat="visibilityState in file.visibilityStates" value="{{visibilityState.value}}" ng-selected="file.visibility === visibilityState.value">{{visibilityState.textKey | translate}}</md-option></md-select></td><td><a ng-if="file.protocolState === \'TO_BE_ARCHIVED\' || file.protocolState === \'ARCHIVE_NOW\'" class="hand glyphicon glyphicon-user" ng-click="vm.openSenderReceiverDialog(group, $index)" title="{{\'documentToolbar.senderReceiver\' | translate}}" flex-offset-gt-xs="10"></a></td><td><a class="hand glyphicon glyphicon-trash" ng-click="vm.removeSingleUpload(group, $index)" title="{{\'documentToolbar.delete\' | translate}}" flex-offset-gt-xs="10"></a></td></tr></tbody><tbody ng-if="vm.singleFilesCount > 0"><tr class="end-group-row"><td colspan="8"><span data-translate="documentToolbar.uploadedFiles"></span>: {{vm.singleFilesCount}}</td></tr></tbody></table></div><div ng-show="vm.protocolGroups.length > 0" class="spacer"></div><div class="row"><div ng-show="vm.protocolGroups.length > 0"><div class="col-md-2"><md-button class="md-raised md-primary" ng-click="vm.uploadFiles()" ng-disabled="vm.uploading || vm.protocolGroups.length === 0" aria-label="upload" data-translate="documentToolbar.confirm"></md-button></div><div class="col-md-2"><md-button class="md-raised md-secondary" ng-click="vm.cancelUpload()" aria-label="undo" data-translate="documentToolbar.cancel"></md-button></div></div></div></div>');
$templateCache.put('app/components/uploadDialog/uploadDialog.html','<div id="{{dialogId}}" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Upload File</h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/components/transferCompetenceBlock/decree.html','<div class="panel-heading"><a class="hand glyphicon" name="decree" ng-click="vm.decree.visible = !vm.decree.visible" ng-class="{\'glyphicon-chevron-down\': !vm.decree.visible, \'glyphicon-chevron-up\': vm.decree.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.decree" ng-class="{\'readonly-section\': !vm.decree.editable}"></span><!-- <span ng-if="vm.sendBackDate" ng-class="{\'readonly-section\': !vm.decree.editable}">&dash; {{\'gestioneAttiApp.form.rinvioDel\' | translate}} {{vm.sendBackDate | date: \'dd/MM/yyyy\'}}</span> --></div><div id="decree-body" class="panel-body" ng-if="vm.decree.visible" layout-padding><div layout="column" layout-align="start start"><label ng-click="vm.decree.metadati.competenceOf = null">Passata competenza a:</label><md-radio-group ng-model="vm.decree.metadati.competenceOf" ng-disabled="!vm.decree.editable" layout="row" layout-padding="5"><md-radio-button value="presConsiglio" class="md-primary">Presidente del Consiglio</md-radio-button><md-radio-button value="presGiunta" class="md-primary">Presidente della Giunta</md-radio-button></md-radio-group></div><div flex layout="row"><md-input-container><label data-translate="gestioneAttiApp.form.decree.numeroDecreto"></label><input ng-model="vm.decree.metadati.numeroDecreto" ng-disabled="!vm.decree.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.decree.dataDecreto"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.decree.metadati.dataDecreto" ng-disabled="!vm.decree.editable"></md-datepicker></md-input-container><span ng-if="vm.decree.metadati.dataDecreto && vm.decree.editable"><md-button ng-click="vm.decree.metadati.dataDecreto = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data Decreto</md-tooltip></md-button></span></div><div flex layout="row"><md-input-container><label data-translate="gestioneAttiApp.form.decree.numeroBurt"></label><input type="number" ng-model="vm.decree.metadati.numeroBurt" ng-disabled="!vm.decree.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.decree.parteBurt"></label><input ng-model="vm.decree.metadati.parteBurt" ng-disabled="!vm.decree.editable"></md-input-container><md-input-container flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.decree.dataBurt"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.decree.metadati.dataBurt" ng-disabled="!vm.decree.editable"></md-datepicker></md-input-container><span ng-if="vm.decree.metadati.dataBurt && vm.decree.editable"><md-button ng-click="vm.decree.metadati.dataBurt = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data BURT</md-tooltip></md-button></span></div><div class="panel-footer"><document-toolbar section="::vm.decree" document-types="::vm.docTypes" include-notes="true" editable="::((vm.decree.editable) || vm.isAdmin)" user="::vm.utente" uploaded-file-callback="vm.initDocumentsCheck(documento)" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" remove-document-callback="vm.removeDocumentsCheck(documento)" tipo-atto="::vm.actType"></document-toolbar></div></div>');
$templateCache.put('app/components/transferCompetenceBlock/transferCompetenceBlock.html','<div id="transfer-competence-state" class="atto-detail-pane"><a ng-click="vm.stato.transferCompetence.isCollapsed = !vm.stato.transferCompetence.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.transferCompetence.isCollapsed, \'glyphicon-eye-close\': vm.stato.transferCompetence.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">TRASFERITA COMPETENZA</span><div ng-show="vm.stato.transferCompetence.isCollapsed" layout="column" layout-margin><!-- Decree SECTION --><div ng-include="::vm.sezioni.DECREE.form" class="panel atto-sezione" ng-cloak></div><!-- Notice of rectification (Trasfer competence) SECTION --><div ng-include="::vm.sezioni.NOTICE_OF_RECTIFICATION_TRANSFER_COMPETENCE.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/components/svoltaBlock/svoltaBlock.html','<div id="svolta-state" ng-if="::true" class="atto-detail-pane"><a ng-click="vm.stato.svolta.isCollapsed = !vm.stato.svolta.isCollapsed" ng-class="{\'glyphicon-eye-open\': !vm.stato.svolta.isCollapsed, \'glyphicon-eye-close\': vm.stato.svolta.isCollapsed}" class="hand glyphicon section-collapser"></a> <span class="pane-title">SVOLTA</span><!-- <span ng-if="vm.atto.tipoAtto === \'IS\' || vm.atto.tipoAtto === \'IO\'" class="pane-title">ESITO ATTO</span> --><div ng-show="vm.stato.svolta.isCollapsed" layout="column" layout-margin><!-- COURTROOM OUTCOME --><div ng-if="vm.atto.tipoAtto !== \'IEA\'" ng-include="::vm.sezioni.COURT_OUTCOME.form" class="panel atto-sezione" ng-cloak></div></div></div>');
$templateCache.put('app/layouts/form/form.html','<div class="container"><div class="col-md-10 col-md-offset-1" id="sticky-container"><form-toolbar></form-toolbar><md-content class="md-whiteframe-5dp" layout-padding><h1>Pdl Form</h1><section-prefilled></section-prefilled><section-atti></section-atti></md-content></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-xs-12"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-xs-12"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar-commission-pages.html','<nav class="navbar navbar-default" ng-class="{\'production\': vm.inProduction, \'staging\': vm.inStaging, \'dev\': vm.inDev, \'navbar-small\': vm.screenIsSmall}" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" ng-class="{\'logo-big\': !vm.screenIsSmall, \'navbar-brand-small\': vm.screenIsSmall}" href="https://www.consiglio.regione.toscana.it" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-crt.png" alt="logo" ng-if="!vm.screenIsSmall"> <img class="logo-img-small" src="content/images/logo-crt-small.png" alt="logo" ng-if="vm.screenIsSmall"> </a><a class="navbar-brand logo title" ng-class="{\'logo-big\': !vm.screenIsSmall, \'navbar-brand-small\': vm.screenIsSmall}" href="#/home" ng-click="vm.collapseNavbar()"><span data-translate="global.title">Iterlegis</span> <span class="navbar-version">v{{VERSION}}</span> </a><!-- SHOWED ONLY ON MOBILE, ANCHOR TO NOTIFICATION COMPONENT--><md-button style="top: 9px" ng-if="vm.screenIsSmall && vm.isAuthenticated" class="primary" ng-click="vm.onClickNotificheAnchor()"><span class="glyphicon glyphicon-cog glyphicon-bell" aria-hidden="true"></span></md-button></div><div class="navbar-collapse" ng-class="{\'production\': vm.inProduction, \'staging\': vm.inStaging, \'dev\': vm.inDev, \'navbar-small\': vm.screenIsSmall}" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"></div></div></nav>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" ng-class="{\'production\': vm.inProduction, \'staging\': vm.inStaging, \'dev\': vm.inDev, \'navbar-small\': vm.screenIsSmall}" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" ng-class="{\'logo-big\': !vm.screenIsSmall, \'navbar-brand-small\': vm.screenIsSmall}" href="https://www.consiglio.regione.toscana.it" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-crt.png" alt="logo" ng-if="!vm.screenIsSmall"> <img class="logo-img-small" src="content/images/logo-crt-small.png" alt="logo" ng-if="vm.screenIsSmall"> </a><a class="navbar-brand logo title" ng-class="{\'logo-big\': !vm.screenIsSmall, \'navbar-brand-small\': vm.screenIsSmall}" href="#/home" ng-click="vm.collapseNavbar()"><span data-translate="global.title">Iterlegis</span> <span class="navbar-version">v{{VERSION}}</span> </a><!-- SHOWED ONLY ON MOBILE, ANCHOR TO NOTIFICATION COMPONENT--><md-button style="top: 9px" ng-if="vm.screenIsSmall && vm.isAuthenticated" class="primary" ng-click="vm.onClickNotificheAnchor()"><span class="glyphicon glyphicon-cog glyphicon-bell" aria-hidden="true"></span></md-button></div><div class="navbar-collapse" ng-class="{\'production\': vm.inProduction, \'staging\': vm.inStaging, \'dev\': vm.inDev, \'navbar-small\': vm.screenIsSmall}" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><!--                 <li ng-if="vm.canInsert()">\r\n                    <a ui-sref="atto-insert">\r\n                        <span class="glyphicon glyphicon-plus-sign"></span>\r\n                        <span>Inserisci Atto</span>\r\n                    </a>\r\n                </li> --><li ng-if="!vm.isCommissioneAtti"><a ui-sref="registrazione-utente"><span class="glyphicon glyphicon-envelope"></span> <span>Registrati alle notifiche</span></a></li><li><a ui-sref="seduta.select-working()" ng-if="vm.showGestioneSedute"><span class="glyphicon glyphicon-tasks"></span> <span>Gestione Sedute</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown dropdown><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="tipo-documento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tipoDocumento">Tipo Documento</span></a></li><li ui-sref-active="active"><a ui-sref="anagrafica-protocollo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.anagraficaProtocollo">Anagrafica Protocollo</span></a></li><li ui-sref-active="active"><a ui-sref="macro-materia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp;<!-- <span data-translate="global.menu.entities.anagraficaProtocollo">Anagrafica Protocollo</span> --> <span>Macro Materie</span></a></li><li ui-sref-active="active"><a ui-sref="materia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp;<!-- <span data-translate="global.menu.entities.anagraficaProtocollo">Anagrafica Protocollo</span> --> <span>Materie</span></a></li><li ui-sref-active="active"><a ui-sref="direzione" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.direzione">Direzione</span></a></li><li ui-sref-active="active"><a ui-sref="settore" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.settore">Settore</span></a></li><li ui-sref-active="active"><a ui-sref="commissione" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.commissione">Commissione</span></a></li><li ui-sref-active="active"><a ui-sref="soggetto-esterno" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.soggettoEsterno">Soggetto Esterno</span></a></li><li ui-sref-active="active"><a ui-sref="commissione-ruolo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.commissioneRuolo">Commissione Ruolo</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" is-intranet="true" uib-dropdown dropdown><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="anagrafica-iterlegis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.anagrafica-iterlegis"></span></a></li><li ui-sref-active="active"><a ui-sref="lista-di-distribuzione" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-envelope"></span>&nbsp; <span data-translate="global.menu.admin.lista-di-distribuzione"></span></a></li><li ui-sref-active="active"><a ui-sref="gestione-notifiche" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-envelope"></span>&nbsp; <span data-translate="global.menu.admin.gestione-notifiche"></span></a></li><li ui-sref-active="active"><a ui-sref="permissions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>Visibilit\xE0 atti per utenti non autenticati</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" ng-switch-when="false" ng-if="!vm.windowsAuthEnabled"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false" ng-if="vm.windowsAuthEnabled"><a href="/autoLogin" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown dropdown><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu" ng-switch-when="true"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" ng-bind="::userDescription"></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" ng-if="!(vm.isTemporaryUser() || vm.isCitizenUser())"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="!vm.windowsAuthEnabled && !vm.isTemporaryUser()"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="!vm.isCitizenUser()"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.canViewProtoSync"><a ui-sref="sincronizzatore-anagrafiche" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-refresh"></span>&nbsp; <span data-translate="sincronizzatore.title">Sincronizzatore Anagrafiche</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.canViewImporterMonitorBoard"><a ui-sref="importer-board-monitor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart-empty"></span>&nbsp; <span data-translate="importer-board-monitor.title">Importer Board Monitor</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.showReportGenerator || vm.isAdmin"><a ui-sref="atto-report-generator" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-file"></span>&nbsp; <span data-translate="report-generator.title">Atto Report Generator</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.showAdempimentiReportGenerator || vm.isAdmin"><a ui-sref="adempimenti-atti-indirizzo-report-generator" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-file"></span>&nbsp; <span data-translate="report-generator.title-act-address">Adempimenti Atti Indirizzo Report Generator</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown dropdown ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language| findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/entities/atto/atto-landing-page/atto-landing-page.html','<div ng-if="vm.notFound" class="text-center"><div style="font-size: xx-large">Nessun atto \xE8 stato trovato su Iterlegis</div></div>');
$templateCache.put('app/entities/atto-report-generator/confirm-report-modal/confirm-report-modal.html','<md-dialog flex="50" layout-padding layout-align="center center"><h3>Generazione Report<md-dialog-content style="width: 100%; padding: 15px"><div layout-gt-xs="row"><md-input-container style="margin-top: 15px; width: 100%"><label>Titolo report</label><input type="text" ng-model="searchParams.titoloReport" autocomplete="off"></md-input-container></div><div layout-gt-xs="row"><md-input-container><md-checkbox ng-model="searchParams.showReportCriteria"><span data-translate="report-generator.generate-dialog.show-criteria-first-page"></span></md-checkbox></md-input-container></div><div layout-gt-xs="row" ng-if="showOrdinamento"><md-input-container><label>Ordina per</label><md-select ng-model="searchParams.tipologiaOrdinamento"><md-option ng-value="null">{{\'report-generator.ordering.NESSUNO\' | translate}}</md-option><md-option ng-repeat="item in ::TIPOLOGIA_ORDINAMENTO_REPORT" value="{{::item}}">{{\'report-generator.ordering.\' + item | translate}}</md-option></md-select></md-input-container></div><div layout-gt-xs="row" ng-if="searchParams.tipologiaReport != null"><md-input-container style="margin-left: auto; margin-right: auto; width: 200px"><label>Tipologia Report</label><md-select ng-model="searchParams.tipologiaReport"><md-option ng-repeat="item in ::TIPOLOGIA_REPORT" value="{{::item}}">{{item}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" flex="100"><md-button class="md-raised md-primary" ng-click="confirm();"><span data-translate="entity.action.confirm"></span></md-button><span flex></span><md-button class="md-raised md-accent" ng-click="cancel();"><span data-translate="entity.action.cancel"></span></md-button></md-dialog-actions></h3></md-dialog>');
$templateCache.put('app/entities/atto/sezioni/assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div ng-if="vm.atto.tipoAtto === \'PDD\'" style="margin-bottom: 30px"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.assignment.pddDiNomina"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd = true" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                                || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                                || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd = false" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">No</md-button></div></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.isNominaPdd"><div ng-hide="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.enti && !vm.sezioniMap.ASSIGNMENT_LETTER.editable" layout="column" layout-align-gt-xs="start start" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.enti">Enti</label><md-chips md-autocomplete-snap ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.enti" readonly="::!vm.sezioniMap.ASSIGNMENT_LETTER.editable && !vm.displayProtocolloSaveButton" md-max-chips="1"><md-autocomplete md-selected-item="vm.selectedEnte" md-search-text="vm.selectedEnteSearchText" md-items="item in vm.searchEnti(vm.selectedEnteSearchText)" md-item-text="item.descrizioneAnagrafica" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedEnteSearchText">{{item.descrizioneAnagrafica}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizioneAnagrafica}}</span></md-chip-template></md-chips><div class="spacer"></div></div><div ng-hide="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.organi && !vm.sezioniMap.ASSIGNMENT_LETTER.editable" layout="column" layout-align-gt-xs="start start" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.organi">Organi</label><md-chips md-autocomplete-snap ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.organi" readonly="::!vm.sezioniMap.ASSIGNMENT_LETTER.editable && !vm.displayProtocolloSaveButton"><md-autocomplete md-selected-item="vm.selectedOrgano" md-search-text="vm.selectedOrganoSearchText" md-items="item in vm.searchOrgani(vm.selectedOrganoSearchText)" md-item-text="item.descrizioneAnagrafica" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedOrganoSearchText">{{item.descrizioneAnagrafica}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizioneAnagrafica}}</span></md-chip-template></md-chips><div class="spacer"></div></div></div></div><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.sceltaAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = true" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = false" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">No</md-button></div></div><div ng-show="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="column" layout-align-gt-xs="center"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><md-input-container style="width: 210px"><label data-translate="gestioneAttiApp.form.assignment.dataSedutaUp" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSedutaUp\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta UP</md-tooltip></md-button></span></div></div><div ng-show="!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="column" layout-align-gt-xs="center"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataAssegnazione" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataAssegnazione\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data assegnazione</md-tooltip></md-button></span><md-radio-group flex-offset-gt-xs="5" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.riduzioneTermineParere" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))"><label data-translate="gestioneAttiApp.form.assignment.riduzioneTermineParere" ng-click="vm.clearRadio(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')), vm.sezioniMap.ASSIGNMENT_LETTER, \'riduzioneTermineParere\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'riduzioneTermineParere\')}"></label><md-radio-button value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div class="spacer"></div><div layout="row" layout-xs="column" layout-align="space-between start" layout-align-xs="start start" layout-wrap><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 3); vm.toggleParereSecondario(); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereReferente\');">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereSecondario"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="vm.parereSecondarioDisableMap[commissione.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereSecondario\'); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereSecondario\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5" ng-if="vm.atto.tipoAtto === \'PDD\'"><label data-translate="gestioneAttiApp.form.assignment.parereDiMerito"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="vm.parereDiMeritoDisableMap[commissione.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereDiMerito)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereDiMerito\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5"><md-radio-group ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereIstituzionale" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || vm.parereIstituzionaleDisabled || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))"><label data-translate="gestioneAttiApp.form.assignment.parereIstituzionale" ng-click="vm.clearRadio(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || vm.parereIstituzionaleDisabled || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')), vm.sezioniMap.ASSIGNMENT_LETTER, \'parereIstituzionale\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereIstituzionale\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereObbligatorio" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereObbligatorio\')}"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereObbligatorio)" ng-click="vm.toggle(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereObbligatorio\'); vm.toggleOsservazioni()">{{soggetto.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5" style="padding-right: 70px"><label data-translate="gestioneAttiApp.form.assignment.osservazioni"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-disabled="vm.osservazioniDisableMap[soggetto.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.osservazioni)" ng-click="vm.toggle(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'osservazioni\')">{{soggetto.nome}}</md-checkbox></div></div></div><div class="spacer"></div><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'COMMISSIONE\'\r\n                      || (vm.atto.statoCorrente.statoAtto.name !== \'PRESENTATO\'\r\n                      && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione)" layout="row" layout-xs="column"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione" date-label="\'gestioneAttiApp.form.assignment.dataRettificaAssegnazione\'" disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !vm.userRolesMap.isSettoreAtti)" edit-only-last-value="true" style="width: 100%"></addable-input></div></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/attachedActs.html','<div ng-if="!vm.headingPanelDisabled" class="panel-heading" style="background-color: #eeeeee"><a class="hand glyphicon" name="attachedActs" ng-click="vm.attachedActs.visible = !vm.attachedActs.visible" ng-class="{\'glyphicon-chevron-down\': !vm.attachedActs.visible, \'glyphicon-chevron-up\': vm.attachedActs.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.attachedActs" ng-class="{\'readonly-section\': !vm.attachedActs.editable}"></span></div><div ng-if="vm.attachedActs.visible" id="unified-text-body" class="panel-body"><form name="attachedActsForm" layout="column"><div ng-if="vm.attachedActs.editable" layout="row"><md-input-container><label data-translate="gestioneAttiApp.atto.ricercaTipo"></label><md-select ng-model="vm.basicSearchType" ng-change="vm.getAllActs()" placeholder="{{\'gestioneAttiApp.atto.ricercaTipo\'| translate}}"><md-option></md-option><md-option ng-repeat="item in ::vm.actsTypeSelection track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><md-chips flex ng-model="vm.attachedActsModel" md-on-add="vm.onAddAttachedAct($index, $chip)" md-on-remove="vm.onRemoveAttachedAct($index, $chip, $event)" md-on-select="false" md-transform-chip="vm.transformChip($chip)" ng-class="{\'md-focused\': false}" ng-show="vm.basicSearchType || vm.attachedActsModel.length > 0"><md-autocomplete md-selected-item="vm.selectedUnifiedTextActRef" md-search-text="vm.numeroAttoSearchText" md-items="item in vm.searchActs(vm.numeroAttoSearchText)" md-item-text="item.numeroAtto" md-no-cache="true" placeholder="Numero atto"><span md-highlight-text="vm.selectedAttoSearchText">[{{item.legislatura | romanize}}][{{item.tipoAtto}} {{item.numeroAtto}}] [{{item.statoCorrente.statoAtto.name}}]: {{item.titolo}}</span></md-autocomplete><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span>[{{$chip.legislatura | romanize}}]<b>[{{$chip.tipoAtto}} {{$chip.numeroAtto}}]</b><b>[{{$chip.statoAtto}}]</b>: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div><div layout="column" layout-align-gt-xs="start start"><label data-translate="gestioneAttiApp.atto.collegatoCon"></label><md-chips md-autocomplete-snap ng-model="vm.attachedActsReadOnlyListModel" md-on-remove="vm.onRemoveAttachedAct($index, $chip, $event)" md-on-select="false" md-transform-chip="vm.transformChip($chip)" ng-class="{\'md-focused\': false}" md-removable="vm.attachedActs.editable" readonly="true"><md-chip-template><a ui-sref="atto-detail({id:$chip.id})" target="_blank"><span>[{{$chip.legislatura | romanize}}]<b>[{{$chip.tipoAtto}} {{$chip.numeroAtto}}]</b><b>[{{$chip.statoAtto}}]</b>: {{$chip.titolo | limitTo:50 }}</span></a></md-chip-template></md-chips></div></form></div><div ng-if="vm.attachedActs.visible && !vm.footerPanelDisabled" class="panel-footer"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" include-notes="true" editable="::((vm.attachedActs.editable && vm.isSettoreAtti) || vm.isProtocollo || vm.isAdmin)" public-view="::vm.publicView" section="::vm.attachedActs" user="::vm.utente" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/candidatureDesignazioni.html','<div class="panel-heading" style="background-color: #eeeeee"><a class="hand glyphicon" name="candidatureDesignazioni" ng-click="vm.candidatureDesignazioni.visible = !vm.candidatureDesignazioni.visible" ng-class="{\'glyphicon-chevron-down\': !vm.candidatureDesignazioni.visible, \'glyphicon-chevron-up\': vm.candidatureDesignazioni.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.candidatureDesignazioni" ng-class="{\'readonly-section\': !vm.candidatureDesignazioni.editable}"></span></div><div ng-if="vm.candidatureDesignazioni.visible" id="unified-text-body" class="panel-body"><form name="candidatureDesignazioniForm" layout="column"><div ng-if="false" layout="row" ng-repeat="candidatura in vm.candidatureDesignazioniList" flex-offset-gt-xs="5" style="margin-top: 30px"><div><md-input-container class="clean-allignment" style="margin-top: 0px !important; min-width: 500px"><input type="text" placeholder="{{ \'candidatureDesignazioni.candidaturaDesignazioneLabel\' | translate}}" ng-model="candidatura.nuovaDescrizioneCandidato" ng-disabled="vm.isInputDisabled($index)"></md-input-container></div><div layout-align="end center" ng-if="!vm.isInputDisabled"><md-button ng-click="vm.updateCandidatoDesignazioneDescription(candidatura)" class="md-raised md-primary"><span class="glyphicon glyphicon-floppy-disk"></span> <span data-translate="entity.action.save" layout-wrap></span></md-button></div></div></form></div><div ng-if="vm.candidatureDesignazioni.visible" class="panel-footer"><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" include-notes="true" editable="::(vm.candidatureDesignazioni.editable || vm.isSettoreAtti || vm.isProtocollo || vm.isAdmin)" public-view="::vm.publicView" section="::vm.candidatureDesignazioni" user="::vm.utente" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/cdg.presentation.html','<div class="panel-heading"><a class="hand glyphicon" name="presentation" ng-click="vm.sezioniMap.PRESENTATION.visible = !vm.sezioniMap.PRESENTATION.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.PRESENTATION.visible, \'glyphicon-chevron-up\': vm.sezioniMap.PRESENTATION.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.presentation" ng-class="{\'readonly-section\': !vm.sezioniMap.PRESENTATION.editable}"></span></div><div ng-if="vm.sezioniMap.PRESENTATION.visible" id="presentation-body" class="panel-body" layout-padding><form name="prefilledForm" layout="column"><div layout="row" layout-xs="column" layout-align="start start"><!-- Legislatura --><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input value="{{vm.atto.legislatura| romanize}}" ng-disabled="true"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'legislatura\')}"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input type="number" ng-model="vm.atto.legislatura"></md-input-container><!-- Tipo atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.tipoAtto.title" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoAtto\')}"></label><md-select ng-model="vm.atto.tipoAtto" vm.sezionimapplaceholder="Tipo atto" ng-disabled="!vm.sezioniMap.PRESENTATION.insert" ng-change="vm.tipoAttoChange()"><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><!-- Numero atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroAtto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroAtto\')}"></label><input ng-model="vm.atto.numeroAtto" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container></div><div layout="row" layout-xs="column"><!-- Titolo atto --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.oggetto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'titolo\')}"></label><textarea ng-model="vm.atto.titolo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></textarea></md-input-container></div><div layout="row"><!-- Titolo atto modificato --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.titoloModificato"></label><textarea ng-model="vm.atto.titoloModificato" ng-disabled="!vm.userRolesMap.isProtocollo && !vm.userRolesMap.isSettoreAtti"></textarea></md-input-container></div><!--N\xB0 protocollo, Data protocollo --><div layout="row" layout-xs="column"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroProtocollo\')}"></label><input type="number" ng-model="vm.atto.numeroProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.dataProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.dataProtocollo && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.dataProtocollo = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data protocollo</md-tooltip></md-button></span><md-input-container ng-if="!vm.isInsert && vm.sezioniMap.PRESENTATION.metadati.plipTermine"><label data-translate="gestioneAttiApp.form.presentation.plipTermine"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.plipTermine" ng-disabled="true"></md-datepicker></md-input-container></div><div layout-gt-md="row" layout="column" flex flex-offset-gt-xs="5"><md-input-container style="width: 280px" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroComunicazioneGiuntaRegionale\')}"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.numeroComunicazioneGiuntaRegionale"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.numeroComunicazioneGiuntaRegionale" ng-disabled="!vm.sezioniMap.PRESENTATION.editable && !vm.userRolesMap.isProtocollo"></md-input-container></div><div><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.presentation.richiestaDiComunicazione"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                                \'md-primary\': vm.sezioniMap.PRESENTATION.metadati.richiestaDiComunicazione}" ng-click="vm.sezioniMap.PRESENTATION.metadati.richiestaDiComunicazione = true" ng-disabled="!vm.sezioniMap.PRESENTATION.editable && !vm.userRolesMap.isProtocollo">Si</md-button><md-button class="md-raised" ng-class="{\r\n                                \'md-primary\': !vm.sezioniMap.PRESENTATION.metadati.richiestaDiComunicazione}" ng-click="vm.sezioniMap.PRESENTATION.metadati.richiestaDiComunicazione = false" ng-disabled="!vm.sezioniMap.PRESENTATION.editable && !vm.userRolesMap.isProtocollo">No</md-button></div></div><div flex-offset-gt-xs="5" ng-if="vm.sezioniMap.PRESENTATION.metadati.richiestaDiComunicazione"><div ng-if="!vm.isInsert" layout="row" layout-xs="column"><addable-input input-type="\'richiestaDiGiunta\'" input-model="vm.sezioniMap.PRESENTATION.metadati.richiestaDiGiuntaList" inner-label="true" date-label="\'gestioneAttiApp.form.presentation.dateTestoSotitutivo\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%" anagrafiche-protocollo="vm.anagraficheProtocollo" protocol-system="vm.atto.protocolSystem"></addable-input></div></div></div><div class="panel-body"><md-content layout="row" layout-xs="column" flex layout-padding><md-checkbox class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'COMUNICAZIONE_GIUNTA_REGIONALE\']">Comunicazione Giunta Regionale</md-checkbox></md-content></div><div layout="row"><md-input-container><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.dataDocumentoComunicazioneGiuntaRegionale" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoComunicazioneGiuntaRegionale" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoComunicazioneGiuntaRegionale && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoComunicazioneGiuntaRegionale = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data documento comunicazione GR</md-tooltip></md-button></span></div><div><div layout="row" ng-if="vm.tipiProponente"><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><input ng-model="vm.atto.tipoProponente" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoProponente\')}" style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><md-select ng-model="vm.atto.tipoProponente" ng-change="vm.tipoProponenteChange()"><md-option ng-value="proponente" ng-repeat="proponente in vm.tipiProponente">{{proponente}}</md-option></md-select></md-input-container></div></div><div ng-if="vm.atto.tipoProponente" layout="column" layout-align-gt-xs="start start"><label ng-if="vm.atto.tipoProponente === \'GR\'" data-translate="gestioneAttiApp.form.presentation.assessori" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><label ng-if="vm.atto.tipoProponente === \'CR\' || vm.atto.tipoProponente === \'UP\'" data-translate="gestioneAttiApp.form.presentation.consiglieri" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><md-chips md-autocomplete-snap ng-model="vm.atto.proponente.proponenti" readonly="::!vm.sezioniMap.PRESENTATION.editable && !vm.displayProtocolloSaveButton"><md-autocomplete md-selected-item="vm.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchFirmatari(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><div ng-show="vm.atto.tipoProponente === \'GR\'" layout="column" layout-align="start start"><div layout="row" layout-xs="column" layout-align="start start"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroGR"></label><input ng-model="vm.atto.proponente.numeroGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data GR</md-tooltip></md-button></span></div><div layout="row" layout-xs="column" layout-align="start start"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.protocolloTrasmissioneGR"></label><input ng-model="vm.atto.proponente.protocolloTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataTrasmissioneGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataTrasmissioneGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataTrasmissioneGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data trasmissione GR</md-tooltip></md-button></span></div></div><!-- <div ng-show="vm.atto.tipoProponente === \'GR\'" layout="row" layout-xs="column">\r\n        \r\n                        <md-input-container>\r\n                            <label data-translate="gestioneAttiApp.form.presentation.direzioneGR"></label>\r\n                            <md-select ng-model="vm.atto.proponente.direzioneGR.id" placeholder="Direzione" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                                <md-option value="none" data-translate="gestioneAttiApp.form.presentation.tipoAtto.empty"></md-option>\r\n                                <md-option ng-repeat="direzione in vm.direzioni" ng-value="direzione.id">\r\n                                    {{direzione.nome}}\r\n                                </md-option>\r\n                            </md-select>\r\n                        </md-input-container>\r\n        \r\n                        <md-input-container flex-offset-gt-xs="5">\r\n                            <label data-translate="gestioneAttiApp.form.presentation.estensoreGR"></label>\r\n                            <input ng-model="vm.atto.proponente.estensoreGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                        </md-input-container>\r\n        \r\n                    </div> --></form></div><div class="panel-footer" ng-if="vm.sezioniMap.PRESENTATION.visible && !vm.sezioniMap.PRESENTATION.insert"><a name="presentation-documents"></a><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.sezioniMap.PRESENTATION.editable || vm.userRolesMap.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.sezioniMap.PRESENTATION" user="::vm.utente" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/commissionAssignedEmendments.html','<div class="panel-heading"><a class="hand glyphicon" name="commissionAssignedEmendments" ng-click="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible = !vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible, \'glyphicon-chevron-up\': vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.commissionAssignedEmendments" ng-class="{\'readonly-section\': !vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.editable}"></span></div><div id="commission-emendments-body" ng-if="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible" class="panel-body" layout-padding><form name="commissionEmendmentsForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label data-translate="gestioneAttiApp.form.commissionEmendments.emendamentiAssegnati"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti}" ng-click="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti = true" ng-disabled="!vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.editable && !vm.userRolesMap.isProtocollo">Si</md-button><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': !vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti}" ng-click="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti = false" ng-disabled="!vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.editable && !vm.userRolesMap.isProtocollo">No</md-button></div></div><div flex-offset-gt-xs="5" ng-if="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti"><emendments editable="vm.isAdmin || vm.userRolesMap.isProtocollo" emendments="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiAssegnati" sezione-id="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.id" include-state="true" invalid-fields="vm.invalidFields" ng-cloak ng-show="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.metadati.emendamentiPresenti" people-list="::vm.anagraficheProtocollo" validating="vm.validating"></emendments></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.visible"><!-- MODIFICA TEMPORANEA: editable= vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.editable --><document-toolbar section="::vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS" document-types="::vm.docTypes" include-notes="true" editable="::(vm.userRolesMap.isSettoreAtti || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin || vm.sezioniMap.COMMISSION_ASSIGNED_EMENDMENTS.editable)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/dea.presentation.html','<div class="panel-heading"><a class="hand glyphicon" name="presentation" ng-click="vm.sezioniMap.PRESENTATION.visible = !vm.sezioniMap.PRESENTATION.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.PRESENTATION.visible, \'glyphicon-chevron-up\': vm.sezioniMap.PRESENTATION.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.presentation" ng-class="{\'readonly-section\': !vm.sezioniMap.PRESENTATION.editable}"></span></div><div ng-if="vm.sezioniMap.PRESENTATION.visible" id="presentation-body" class="panel-body" layout-padding><form name="prefilledForm" layout="column"><!-- Legislatura --><div layout="row" layout-xs="column" layout-align="start start"><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input value="{{vm.atto.legislatura| romanize}}" ng-disabled="true"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'legislatura\')}"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input type="number" ng-model="vm.atto.legislatura"></md-input-container><!-- Tipo atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.tipoAtto.title" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoAtto\')}"></label><md-select ng-model="vm.atto.tipoAtto" vm.sezionimapplaceholder="Tipo atto" ng-disabled="!vm.sezioniMap.PRESENTATION.insert" ng-change="vm.tipoAttoChange()"><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><!-- Numero atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroAtto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroAtto\')}"></label><input ng-model="vm.atto.numeroAtto" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container></div><div layout="row" layout-xs="column"><!-- Titolo atto --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.oggetto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'titolo\')}"></label><textarea ng-model="vm.atto.titolo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></textarea></md-input-container></div><div layout="row"><!-- Titolo atto modificato --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.titoloModificato"></label><textarea ng-model="vm.atto.titoloModificato" ng-disabled="!vm.userRolesMap.isProtocollo && !vm.userRolesMap.isSettoreAtti"></textarea></md-input-container></div><!--N\xB0 protocollo, Data protocollo --><div layout="row" layout-xs="column"><md-input-container style="width: 280px"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.numeroProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroProtocollo\')}"></label><input type="number" ng-model="vm.atto.numeroProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container style="min-width: 90px"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.dataProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.dataProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.dataProtocollo && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.dataProtocollo = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data protocollo</md-tooltip></md-button></span></div><!-- protocollo Trasmissione, Data trasmissione --><div layout-xs="column" layout="row"><md-input-container style="width: 280px" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'protocolloTrasmissione\')}"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.protocolloTrasmissione"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.protocolloTrasmissione" ng-disabled="!vm.sezioniMap.PRESENTATION.editable && !vm.userRolesMap.isProtocollo"></md-input-container><md-input-container><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.dataTrasmissione" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.dataTrasmissione" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.PRESENTATION.metadati.dataTrasmissione && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.PRESENTATION.metadati.dataTrasmissione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data trasmissione</md-tooltip></md-button></span></div><!--             <div flex-offset-gt-xs="5">\r\n            </div> --><div layout="row" ng-if="vm.tipiProponente"><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><input ng-model="vm.atto.tipoProponente" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoProponente\')}" style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><md-select ng-model="vm.atto.tipoProponente" ng-change="vm.tipoProponenteChange()"><md-option ng-value="proponente" ng-repeat="proponente in vm.tipiProponente">{{proponente}}</md-option></md-select></md-input-container></div><!-- ASSESSORI o CONSIGLIERI --><div ng-if="vm.atto.tipoProponente" layout="column" layout-align-gt-xs="start start"><label ng-if="vm.atto.tipoProponente === \'GR\'" data-translate="gestioneAttiApp.form.presentation.assessori" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><label ng-if="vm.atto.tipoProponente === \'CR\' || vm.atto.tipoProponente === \'UP\'" data-translate="gestioneAttiApp.form.presentation.consiglieri" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><md-chips md-autocomplete-snap ng-model="vm.atto.proponente.proponenti" readonly="::!vm.sezioniMap.PRESENTATION.editable && !vm.displayProtocolloSaveButton"><md-autocomplete md-selected-item="vm.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchFirmatari(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span></md-chip-template></md-chips><div class="spacer"></div></div><!-- SE PROPONENTE GR: NUMERO GR, DATA GR, PROTOCOLLO TRASMISSIONE GR, DATA TRASMISSIONE GR --><div ng-show="vm.atto.tipoProponente === \'GR\'"><div layout="column" layout-align="start start"><div layout="row" layout-xs="column" layout-align="start start" style="width: 100%"><md-input-container style="width: 280px"><label data-translate="gestioneAttiApp.form.presentation.numeroGR"></label><input ng-model="vm.atto.proponente.numeroGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.dataGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data GR</md-tooltip></md-button></span></div><div layout="row" layout-xs="column" layout-align="start start"><md-input-container style="width: 280px"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.protocolloTrasmissioneGR"></label><input ng-model="vm.atto.proponente.protocolloTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container style="min-width: 90px"><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.dataTrasmissioneGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataTrasmissioneGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataTrasmissioneGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data trasmissione GR</md-tooltip></md-button></span></div></div><!-- <div layout="row" layout-xs="column">\r\n    \r\n                    <md-input-container>\r\n                        <label data-translate="gestioneAttiApp.form.presentation.direzioneGR"></label>\r\n                        <md-select ng-model="vm.atto.proponente.direzioneGR.id" placeholder="Direzione" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                            <md-option value="none" data-translate="gestioneAttiApp.form.presentation.tipoAtto.empty"></md-option>\r\n                            <md-option ng-repeat="direzione in vm.direzioni" ng-value="direzione.id">\r\n                                {{direzione.nome}}\r\n                            </md-option>\r\n                        </md-select>\r\n                    </md-input-container>\r\n    \r\n                    <md-input-container flex-offset-gt-xs="5">\r\n                        <label data-translate="gestioneAttiApp.form.presentation.estensoreGR"></label>\r\n                        <input ng-model="vm.atto.proponente.estensoreGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                    </md-input-container>\r\n                </div> --></div><!-- NOMINE --><div layout="row" layout-xs="column"><addable-input input-type="\'dea-presentation-input\'" input-model="vm.sezioniMap.PRESENTATION.metadati.personeNominate" inner-label="true" text-label="\'gestioneAttiApp.form.presentation.nomine\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.PRESENTATION.visible && !vm.sezioniMap.PRESENTATION.insert"><a name="presentation-documents"></a><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.sezioniMap.PRESENTATION.editable || vm.userRolesMap.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.sezioniMap.PRESENTATION" user="::vm.utente" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/iea.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><md-content layout-padding><md-checkbox class="md-primary" ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_TRASMISSIONE_CONSIGLIERI\']">{{\'gestioneAttiApp.form.postCourtroom.letteraTrasmissione\' | translate}}</md-checkbox></md-content><div layout="row" layout-align="center center"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateTrasmissioneConsiglieri" date-label="\'gestioneAttiApp.form.assignment.dataTrasmissioneConsiglieri\'" style="width: 100%" ng-disabled="!vm.postCourt.editable"></addable-input></div><div><label>Data seduta CPL</label><div layout="row"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.sedutaCPL"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataCPL" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataCPL && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataCPL = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta CPL</md-tooltip></md-button></span></div></div><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.sceltaAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = true" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = false" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">No</md-button></div><div layout="column" layout-align="space-between start" layout-align-xs="start start"><div layout="column" ng-if="!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-hide="(commissione.nome === \'Commissione di controllo\')" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 4)">{{commissione.nome}}</md-checkbox></div></div></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/io.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div layout="row" layout-align="center" layout-align-xs="start start"><md-input-container style="width: 210px"><label data-translate="gestioneAttiApp.form.assignment.dataSedutaCPL" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSedutaCPL\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaCPL" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaCPL && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaCPL = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta CPL</md-tooltip></md-button></span></div><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.sceltaAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = true" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = false" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">No</md-button></div></div><div ng-show="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="row" layout-align="center center" layout-align-gt-xs="center" style="margin-top: 50px"><md-checkbox ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.questionTime" class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))">Question time</md-checkbox></div><div ng-show="!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="column" layout-align-gt-xs="center" style="margin-top: 50px"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateAssegnazione" inner-label="true" date-label="\'gestioneAttiApp.form.assignment.dataAssegnazione\'" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)" class="testo-sostitutivo-datepicker" style="width: 200px; margin-top: 20px"></addable-input></div><div class="spacer"></div><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start" layout-wrap><div layout="column"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 4); vm.toggleParereSecondario(); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereReferente\');" ng-hide="(commissione.nome === \'Commissione di controllo\')">{{commissione.nome}}</md-checkbox></div></div></div><div class="spacer"></div><!--             <div ng-if="vm.atto.statoCorrente.statoAtto.name === \'COMMISSIONE\'\r\n                      || (vm.atto.statoCorrente.statoAtto.name !== \'PRESENTATO\'\r\n                      && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione)"\r\n                 layout="row" layout-xs="column">\r\n                <addable-input input-type="\'date\'"\r\n                               input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione"\r\n                               date-label="\'gestioneAttiApp.form.assignment.dataRettificaAssegnazione\'"\r\n                               disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !vm.userRolesMap.isSettoreAtti)"\r\n                               edit-only-last-value="true"\r\n                               style="width: 100%">\r\n                </addable-input>\r\n            </div> --></div><div class="panel-body" flex-offset-gt-xs="5"><md-content layout="row" layout-xs="column" flex layout-padding><md-checkbox class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'RISPOSTA_INTERROGAZIONE\']">Richiesta di risposta interrogazione</md-checkbox><md-checkbox class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_ASSEGNAZIONE\']">Lettera di assegnazione</md-checkbox></md-content></div><!-- ASSESSORE CHE RISPONDE --><label data-translate="gestioneAttiApp.form.assignment.assessoreRisponde"></label><div layout="row" layout-xs="column"><div ng-if="vm.atto.tipoProponente" layout="column" layout-align-gt-xs="start start"><md-chips md-autocomplete-snap ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRisponde.assessori" md-on-add="vm.onAddAssessoreRisponde($index, $chip)" md-on-remove="vm.onRemoveAssessoreRisponde($index, $chip, $event)" readonly="::!vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-autocomplete md-selected-item="vm.selectedAssessoreRisponde" md-search-text="vm.selectedAssessoreRispondeSearchText" md-items="item in vm.searchFirmatari(vm.selectedAssessoreRispondeSearchText)" md-item-text="item.descrizione" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedAssessoreRispondeSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder1(vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRisponde.assessori, $event, -1, $chip)" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.editable"><span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span><md-tooltip>Sposta a sinistra</md-tooltip></md-button><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder1(vm.sezioniMap.ASSIGNMENT_LETTER.metadati.assessoreRisponde.assessori, $event, 1, $chip)" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.editable"><span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span><md-tooltip>Sposta a destra</md-tooltip></md-button></md-chip-template></md-chips></div></div><div class="spacer"></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/iscrizione.html','<div class="panel-heading"><a class="hand glyphicon" name="iscrizione" ng-click="vm.sezioniMap.ISCRIZIONE.visible = !vm.sezioniMap.ISCRIZIONE.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ISCRIZIONE.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ISCRIZIONE.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.iscrizione" ng-class="{\'readonly-section\': !vm.sezioniMap.ISCRIZIONE.editable}"></span></div><div ng-if="vm.sezioniMap.ISCRIZIONE.visible" id="iscrizione-letter-body" class="panel-body" layout-padding><form name="iscrizioneForm" layout="column"><div class="panel-body" flex-offset-gt-xs="5"><md-content layout="row" layout-xs="column" flex layout-padding><md-checkbox class="md-primary" flex ng-disabled="true" ng-checked="vm.workDocumentsMap[\'LETTERA_TRASMISSIONE_CONSIGLIERI\']">Lettera trasmissione consiglieri</md-checkbox></md-content></div><div layout="row" flex-offset-gt-xs="5" layout-align-xs="start start"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ISCRIZIONE.metadati.dateTrasmissioneConsiglieri" inner-label="true" date-label="\'gestioneAttiApp.form.iscrizione.dataTrasmissioneConsiglieri\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div layout="row" flex-offset-gt-xs="5" layout-align-xs="start start" style="margin-top: 30px"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ISCRIZIONE.metadati.dateSedutaCPL" inner-label="true" date-label="\'gestioneAttiApp.form.assignment.dataSedutaCPL\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ISCRIZIONE.visible"><document-toolbar section="::vm.sezioniMap.ISCRIZIONE" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ISCRIZIONE.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/onlyReferente.assignmentLetter.html','<div><div class="panel-heading" style="background-color: #eeeeee"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.assignmentLetter.visible = !vm.assignmentLetter.visible" ng-class="{\'glyphicon-chevron-down\': !vm.assignmentLetter.visible, \'glyphicon-chevron-up\': vm.assignmentLetter.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.assignmentLetter.editable}"></span></div><div ng-if="vm.assignmentLetter.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div ng-if="vm.actType === \'MOZIONE\' && !vm.isCourtroom" layout="column" layout-align="center center"><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.sceltaAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': vm.assignmentLetter.metadati.aulaDiretta}" ng-click="vm.assignmentLetter.metadati.aulaDiretta = true" ng-disabled="::(!vm.assignmentLetter.editable\r\n                                                || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                                || vm.assignmentLetter.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                        \'md-primary\': !vm.assignmentLetter.metadati.aulaDiretta}" ng-click="vm.assignmentLetter.metadati.aulaDiretta = false" ng-disabled="::(!vm.assignmentLetter.editable\r\n                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                            || vm.assignmentLetter.skipCurrentStateCheck)">No</md-button></div></div><div ng-if="vm.actType === \'MOZIONE\'" layout="row" layout-align-gt-xs="center"><md-input-container><label style="overflow: visible" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSedutaCPR\')}">{{(vm.atto.tipoAtto === \'MOZIONE\' ? \'gestioneAttiApp.form.assignment.dataSedutaCPL\' : \'gestioneAttiApp.form.assignment.dataSedutaCPR\') | translate}}</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.assignmentLetter.metadati.dataSedutaCPR" ng-disabled="::(!vm.assignmentLetter.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.assignmentLetter.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.assignmentLetter.metadati.dataSedutaCPR && vm.assignmentLetter.editable"><md-button ng-click="vm.assignmentLetter.metadati.dataSedutaCPR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta CPL</md-tooltip></md-button></span></div><div ng-if="vm.actType !== \'MOZIONE\' || !vm.assignmentLetter.metadati.aulaDiretta || vm.isCourtroom" layout="column" layout-align-gt-xs="center"><div class="spacer"></div><div layout="row" layout-xs="column" layout-align="space-between start" layout-align-xs="start start" layout-wrap><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.assignmentLetter.editable || !(vm.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\') || (vm.userRolesMap.isAula && vm.statoAttoCorrente === \'AULA\')))" ng-checked="vm.exists(commissione.id, vm.assignmentLetter.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.assignmentLetter.metadati, \'parereReferente\', 5);">{{commissione.nome}}</md-checkbox></div></div></div></div></form></div><div class="panel-footer" ng-if="vm.assignmentLetter.visible"><document-toolbar section="::vm.assignmentLetter" document-types="::vm.docTypes" include-notes="true" editable="::((vm.assignmentLetter.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin || vm.isAdmin || (vm.userRolesMap.isAula && vm.statoAttoCorrente === \'AULA\'))" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div></div>');
$templateCache.put('app/entities/atto/sezioni/pdls.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataSedutaUp" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSedutaUp\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta UP</md-tooltip></md-button></span><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataAssegnazione" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataAssegnazione\')}" style="overflow: visible"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data assegnazione</md-tooltip></md-button></span><md-radio-group flex-offset-gt-xs="5" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.riduzioneTermineParere" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"><label data-translate="gestioneAttiApp.form.assignment.riduzioneTermineParere" ng-click="vm.clearRadio(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')) || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck, vm.sezioniMap.ASSIGNMENT_LETTER, \'riduzioneTermineParere\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'riduzioneTermineParere\')}"></label><md-radio-button value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div class="spacer"></div><div layout="row" layout-xs="column" layout-align="space-between start" layout-align-xs="start start" layout-wrap><div layout="column"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 3); vm.toggleParereSecondario(); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereReferente\');">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereSecondario"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="vm.parereSecondarioDisableMap[commissione.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereSecondario\'); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereSecondario\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div><!-- div layout="column" flex-offset-gt-xs="5">\r\n                <label data-translate="gestioneAttiApp.form.assignment.parereDiMerito"></label>\r\n                <div ng-repeat=\'commissione in vm.commissioni\'>\r\n                    <md-checkbox class="md-primary" ng-disabled="vm.parereDiMeritoDisableMap[commissione.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))"\r\n                                 ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereDiMerito)"\r\n                                 ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereDiMerito\');"\r\n                                 ng-if="commissione.id != vm.idCommissioneControllo">\r\n                        {{commissione.nome}}\r\n                    </md-checkbox>\r\n                </div>\r\n            </div --><div layout="column" flex-offset-gt-xs="5"><md-radio-group ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereIstituzionale" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || vm.parereIstituzionaleDisabled || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))"><label data-translate="gestioneAttiApp.form.assignment.parereIstituzionale" ng-click="vm.clearRadio(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || vm.parereIstituzionaleDisabled || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')), vm.sezioniMap.ASSIGNMENT_LETTER, \'parereIstituzionale\')" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereIstituzionale\')}"></label><md-radio-button ng-value="true" class="md-primary">S\xEC</md-radio-button><md-radio-button ng-value="false" class="md-primary">No</md-radio-button></md-radio-group></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereObbligatorio" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereObbligatorio\')}"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereObbligatorio)" ng-click="vm.toggle(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereObbligatorio\'); vm.toggleOsservazioni()">{{soggetto.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.osservazioni"></label><div ng-repeat="soggetto in vm.soggettiEsterni"><md-checkbox class="md-primary" ng-disabled="vm.osservazioniDisableMap[soggetto.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.osservazioni)" ng-click="vm.toggle(soggetto.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'osservazioni\')">{{soggetto.nome}}</md-checkbox></div></div></div><div class="spacer"></div><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'COMMISSIONE\'\r\n                  || (vm.atto.statoCorrente.statoAtto.name !== \'PRESENTATO\'\r\n                  && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione)" layout="row" layout-xs="column"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione" date-label="\'gestioneAttiApp.form.assignment.dataRettificaAssegnazione\'" disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !vm.userRolesMap.isSettoreAtti)" edit-only-last-value="true" style="width: 100%"></addable-input></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/pea.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div layout="row" layout-xs="row" layout-align="start center" layout-align-xs="start start"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateAssegnazione" inner-label="true" date-label="\'gestioneAttiApp.form.assignment.dataAssegnazioneCommissione\'" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')) || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div class="spacer"></div><div layout="column" layout-align="space-between start" layout-align-xs="start start" flex-offset-gt-xs="5"><div layout="column"><label ng-if="vm.atto.tipoAtto !== \'PEL\' && vm.atto.tipoAtto !== \'DEA\'" data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><label ng-if="vm.atto.tipoAtto === \'PEL\' || vm.atto.tipoAtto === \'DEA\'" data-translate="gestioneAttiApp.form.assignment.parereObbligatorioCommissioni" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-hide="(commissione.nome === \'Commissione di controllo\')" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 4)">{{commissione.nome}}</md-checkbox></div></div></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/presentation.html','<div class="panel-heading"><a class="hand glyphicon" name="presentation" ng-click="vm.sezioniMap.PRESENTATION.visible = !vm.sezioniMap.PRESENTATION.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.PRESENTATION.visible, \'glyphicon-chevron-up\': vm.sezioniMap.PRESENTATION.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.presentation" ng-class="{\'readonly-section\': !vm.sezioniMap.PRESENTATION.editable}"></span></div><div ng-if="vm.sezioniMap.PRESENTATION.visible" id="presentation-body" class="panel-body" layout-padding><form name="prefilledForm" layout="column"><!-- Legislatura --><div layout="row" layout-xs="column" layout-align="start start"><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input value="{{vm.atto.legislatura| romanize}}" ng-disabled="true"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'legislatura\')}"><label data-translate="gestioneAttiApp.form.presentation.legislatura"></label><input type="number" ng-model="vm.atto.legislatura"></md-input-container><!-- Tipo atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.tipoAtto.title" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoAtto\')}"></label><md-select ng-model="vm.atto.tipoAtto" vm.sezionimapplaceholder="Tipo atto" ng-disabled="!vm.sezioniMap.PRESENTATION.insert" ng-change="vm.tipoAttoChange()"><md-option ng-repeat="item in ::vm.actTypes track by item.value" value="{{::item.value}}">{{::item.name| translate}}</md-option></md-select></md-input-container><!-- Numero atto --><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroAtto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroAtto\')}"></label><input ng-model="vm.atto.numeroAtto" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container></div><div layout="row" layout-xs="column"><!-- Titolo atto --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.oggetto" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'titolo\')}"></label><textarea ng-model="vm.atto.titolo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></textarea></md-input-container></div><div layout="row"><!-- Titolo atto modificato --><md-input-container flex="grow"><label data-translate="gestioneAttiApp.form.presentation.titoloModificato"></label><textarea ng-model="vm.atto.titoloModificato" ng-disabled="!vm.userRolesMap.isProtocollo && !vm.userRolesMap.isSettoreAtti"></textarea></md-input-container></div><!--N\xB0 protocollo, Data protocollo --><div layout="row" layout-xs="column"><md-input-container><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.numeroProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroProtocollo\')}"></label><input type="number" ng-model="vm.atto.numeroProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label style="overflow: visible" data-translate="gestioneAttiApp.form.presentation.dataProtocollo" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataProtocollo\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.dataProtocollo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.dataProtocollo && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.dataProtocollo = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data protocollo</md-tooltip></md-button></span><md-input-container ng-if="!vm.isInsert && vm.sezioniMap.PRESENTATION.metadati.plipTermine"><label data-translate="gestioneAttiApp.form.presentation.plipTermine"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.plipTermine" ng-disabled="true"></md-datepicker></md-input-container></div><!--sse == PDL: Numero Aritcoli, Numero Commissioni, Numero Caratteri --><div ng-if="vm.atto.tipoAtto === \'PDL\'" layout="row" layout-xs="column"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroArticoli" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroArticoli\')}"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.numeroArticoli" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroCommi" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroCommi\')}"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.numeroCommi" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroCaratteri" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroCaratteri\')}"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.numeroCaratteri" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container></div><!--sse != PEA,ODG,PDRIS: N\xB0 documento preliminare, Data documento preliminare --><div ng-if="vm.atto.tipoAtto !== \'PEA\' && vm.atto.tipoAtto !== \'ODG\' && vm.atto.tipoAtto !== \'PDRIS\' && vm.atto.tipoAtto !== \'REL\' && vm.atto.tipoAtto !== \'PLIP\' && vm.atto.tipoAtto !== \'PEL\' && vm.atto.tipoAtto !== \'RINT\' && vm.atto.tipoAtto !== \'MOZIONE\'" layout="row" layout-xs="column"><md-input-container><label>N\xB0 documento preliminare</label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.ndocumentoPreliminare" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label>Data documento preliminare</label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoPreliminare" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoPreliminare && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.PRESENTATION.metadati.dataDocumentoPreliminare = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data documento preliminare</md-tooltip></md-button></span></div><!--sse != PLIP: Tipo proponente e tabella proponenti--><div ng-if="vm.atto.tipoAtto !== \'PLIP\'"><div layout="row" layout-xs="column"><div layout="row" ng-if="vm.tipiProponente"><md-input-container ng-if="!vm.sezioniMap.PRESENTATION.editable"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><input ng-model="vm.atto.tipoProponente" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container ng-if="vm.sezioniMap.PRESENTATION.editable" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'tipoProponente\')}" style="min-width: 90px"><label data-translate="gestioneAttiApp.form.presentation.proponente"></label><md-select ng-model="vm.atto.tipoProponente" ng-change="vm.tipoProponenteChange()"><md-option ng-value="proponente" ng-repeat="proponente in vm.tipiProponente">{{proponente}}</md-option></md-select></md-input-container></div><!-- TABELLA PROPONENTI\r\n                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">\r\n                    Nome firmatario --><!-- Gruppo --><!-- Primo firmatario --><!-- Data aggiunta firma --></div><div ng-if="vm.atto.tipoProponente" layout="column" layout-align-gt-xs="start start"><label ng-if="vm.atto.tipoProponente === \'GR\'" data-translate="gestioneAttiApp.form.presentation.assessori" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><label ng-if="vm.atto.tipoProponente === \'CR\' || vm.atto.tipoProponente === \'UP\'" data-translate="gestioneAttiApp.form.presentation.consiglieri" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'proponenti\')}"></label><md-chips md-autocomplete-snap ng-model="vm.atto.proponente.proponenti" md-on-add="vm.onAddProponente($index, $chip)" md-on-remove="vm.onRemoveProponente($index, $chip, $event)" readonly="::!vm.sezioniMap.PRESENTATION.editable && !vm.displayProtocolloSaveButton"><md-autocomplete md-selected-item="vm.selectedProponenteFirmatari" md-search-text="vm.selectedProponenteFirmatarioSearchText" md-items="item in vm.searchFirmatari(vm.selectedProponenteFirmatarioSearchText)" md-item-text="item.descrizione" placeholder="{{\'emendments.searchPlaceholder\'| translate}}"><span md-highlight-text="vm.selectedProponenteFirmatarioSearchText">{{item.codice}} - {{item.descrizione}}</span></md-autocomplete><md-chip-template><span>{{$chip.descrizione}}</span><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder($event, -1, $chip)" ng-if="vm.sezioniMap.PRESENTATION.editable"><span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span><md-tooltip>Sposta a sinistra</md-tooltip></md-button><md-button class="md-icon-button order-chip-arrow" ng-click="vm.changeOrder($event, 1, $chip)" ng-if="vm.sezioniMap.PRESENTATION.editable"><span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span><md-tooltip>Sposta a destra</md-tooltip></md-button></md-chip-template></md-chips><div class="spacer"></div></div><div ng-show="vm.atto.tipoProponente === \'GR\'" layout="column" layout-align="start start"><div layout="row" layout-xs="column" layout-align="start start"><div ng-if="vm.atto.tipoAtto !== \'PEA\' && vm.atto.tipoAtto !== \'PEL\'"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroGR"></label><input ng-model="vm.atto.proponente.numeroGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><div layout="row"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data GR</md-tooltip></md-button></span></div></div></div><div layout="row" layout-xs="column" layout-align="start start"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.protocolloTrasmissioneGR"></label><input ng-model="vm.atto.proponente.protocolloTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataTrasmissioneGR"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataTrasmissioneGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataTrasmissioneGR && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataTrasmissioneGR = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data trasmissione GR</md-tooltip></md-button></span></div></div><!-- <div ng-show="vm.atto.tipoProponente === \'GR\'" layout="row" layout-xs="column">\r\n\r\n                <md-input-container>\r\n                    <label data-translate="gestioneAttiApp.form.presentation.direzioneGR"></label>\r\n                    <md-select ng-model="vm.atto.proponente.direzioneGR.id" placeholder="Direzione" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                        <md-option value="none" data-translate="gestioneAttiApp.form.presentation.tipoAtto.empty"></md-option>\r\n                        <md-option ng-repeat="direzione in vm.direzioni" ng-value="direzione.id">\r\n                            {{direzione.nome}}\r\n                        </md-option>\r\n                    </md-select>\r\n                </md-input-container>\r\n\r\n                <md-input-container flex-offset-gt-xs="5">\r\n                    <label data-translate="gestioneAttiApp.form.presentation.estensoreGR"></label>\r\n                    <input ng-model="vm.atto.proponente.estensoreGR" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n                </md-input-container>\r\n            </div> --><div layout="row"><md-input-container ng-show="vm.atto.tipoProponente === \'UP\'" style="width: 210px"><label data-translate="gestioneAttiApp.form.presentation.dataSedutaUP"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataSedutaUP" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.atto.proponente.dataSedutaUP && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.atto.proponente.dataSedutaUP = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta UP</md-tooltip></md-button></span></div><div ng-show="vm.atto.tipoProponente === \'CR\' && vm.atto.proponente && vm.atto.proponente.proponenti && vm.atto.proponente.proponenti.length > 0" layout="row" layout-xs="column" layout-align="start start"><div style="min-width: 80%"><table class="table"><thead><tr><th>Nome Firmatario</th><th>Gruppo</th><th class="text-center">Primo Firmatario</th><th class="text-center">Data Aggiunta Firma</th></tr></thead><tbody><tr ng-repeat="proponente in vm.atto.proponente.proponenti " ng-class="{\'striped-row\': $index % 2 === 0}"><td style="vertical-align: middle">{{proponente.descrizione}}</td><td><md-input-container style="width: 100%"><md-select ng-model="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].gruppo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"><md-option ng-if="vm.isGruppoPoliticoCustom(proponente.id)" ng-value="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].gruppo">{{vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].gruppo}}</md-option><md-option ng-repeat="gr in vm.gruppiPolitici" ng-value="gr.id">{{gr.description}}</md-option></md-select></md-input-container></td><td class="text-center" style="vertical-align: middle"><md-checkbox class="md-primary" ng-disabled="!vm.sezioniMap.PRESENTATION.editable" ng-model="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].isPrimoFirmatario"></md-checkbox></td><td class="text-center" style="vertical-align: middle"><div layout="row"><div class="spacer" style="width: 20%"></div><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].dataFirma" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker><div style="margin-left: 10px; margin-top: -13px"><span ng-if="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].dataFirma && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.PRESENTATION.metadati.proponentiDetailsMap[proponente.id].dataFirma = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data</md-tooltip></md-button></span></div></div></td></tr></tbody></table></div></div></div><!-- ROBA VECCHIA SOSTITUITA DALLA TABELLA SOPRA: PROBABILMENTE DA ELIMINARE--><!-- <div ng-show="vm.atto.tipoProponente === \'CR\'" layout="row" layout-xs="column" layout-align="start start">\r\n            <md-input-container>\r\n                <label data-translate="gestioneAttiApp.form.presentation.dataFirma"></label>\r\n                <md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.atto.proponente.dataFirma" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker>\r\n            </md-input-container>\r\n\r\n            <md-input-container flex-offset-gt-xs="5">\r\n                <label data-translate="gestioneAttiApp.form.presentation.gruppo"></label>\r\n                <input ng-model="vm.atto.proponente.gruppo" ng-disabled="!vm.sezioniMap.PRESENTATION.editable">\r\n            </md-input-container>\r\n        </div> --><div ng-if="vm.atto.tipoAtto === \'PEA\' || vm.atto.tipoAtto === \'PEL\'" layout="row" layout-xs="column" layout-align="start start"><md-input-container><label data-translate="gestioneAttiApp.form.presentation.numeroDelibera" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'numeroProtocollo\')}"></label><input type="number" ng-model="vm.sezioniMap.PRESENTATION.metadati.numeroDelibera" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-input-container><md-input-container><label data-translate="gestioneAttiApp.form.presentation.dataDelibera"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.PRESENTATION.metadati.dataDelibera" ng-disabled="!vm.sezioniMap.PRESENTATION.editable"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.PRESENTATION.metadati.dataDelibera && vm.sezioniMap.PRESENTATION.editable"><md-button ng-click="vm.sezioniMap.PRESENTATION.metadati.dataDelibera = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data delibera</md-tooltip></md-button></span></div><div ng-if="vm.atto.tipoAtto === \'PLIP\'" layout="row" layout-xs="column"><addable-input input-type="\'text\'" input-model="vm.atto.proponentiText" inner-label="true" text-label="\'gestioneAttiApp.form.presentation.proponente\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div ng-if="!vm.isInsert && vm.atto.tipoAtto !== \'REL\'" layout="row" layout-xs="column"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.PRESENTATION.metadati.dateTestoSotitutivo" inner-label="true" date-label="\'gestioneAttiApp.form.presentation.dateTestoSotitutivo\'" disabled="!vm.sezioniMap.PRESENTATION.editable" class="testo-sostitutivo-datepicker" style="width: 100%"></addable-input></div><div ng-if="vm.dataDecadenza && (vm.userRolesMap.isAdmin || vm.userRolesMap.isCommissione || vm.userRolesMap.isSettoreAtti || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAula)" layout="row" layout-xs="column" style="margin-top: 45px"><fieldset><legend>Data Decadenza:</legend><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.dataDecadenza" disabled="disabled"></md-datepicker></fieldset></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.PRESENTATION.visible && !vm.sezioniMap.PRESENTATION.insert"><a name="presentation-documents"></a><document-toolbar change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" document-types="::vm.docTypes" editable="::(vm.sezioniMap.PRESENTATION.editable || vm.userRolesMap.isProtocollo)" include-notes="true" public-view="::vm.publicView" section="::vm.sezioniMap.PRESENTATION" user="::vm.utente" tipo-atto="::vm.atto.tipoAtto" include-links="true" default-links="[]"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/rel.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div layout="column" layout-align-gt-xs="center"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataAssegnazione" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataAssegnazione\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data assegnazione</md-tooltip></md-button></span></div><div class="spacer"></div><div layout="row" layout-xs="column" layout-align-xs="start start" layout-wrap><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 4); vm.toggleParereSecondario(); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereReferente\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereSecondario"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="vm.parereSecondarioDisableMap[commissione.id] || (!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereSecondario)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereSecondario\'); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereSecondario\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div></div><div class="spacer"></div><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'COMMISSIONE\'\r\n                      || (vm.atto.statoCorrente.statoAtto.name !== \'PRESENTATO\'\r\n                      && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione)" layout="row" layout-xs="column"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione" date-label="\'gestioneAttiApp.form.assignment.dataRettificaAssegnazione\'" disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !vm.userRolesMap.isSettoreAtti)" edit-only-last-value="true" style="width: 100%"></addable-input></div></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/rint.assignmentLetter.html','<div class="panel-heading"><a class="hand glyphicon" name="assignmentLetter" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.visible = !vm.sezioniMap.ASSIGNMENT_LETTER.visible" ng-class="{\'glyphicon-chevron-down\': !vm.sezioniMap.ASSIGNMENT_LETTER.visible, \'glyphicon-chevron-up\': vm.sezioniMap.ASSIGNMENT_LETTER.visible}"></a> <span data-translate="gestioneAttiApp.form.sezioni.assignment" ng-class="{\'readonly-section\': !vm.sezioniMap.ASSIGNMENT_LETTER.editable}"></span></div><div ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible" id="assignment-letter-body" class="panel-body" layout-padding><form name="assignmentForm" layout="column"><div layout="column" layout-align="center center"><div layout="row" layout-align="center"><label ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'aulaDiretta\')}" data-translate="gestioneAttiApp.form.assignment.sceltaAula"></label></div><div layout="row" layout-align="center"><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = true" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                            || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                            || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">Si</md-button><md-button class="md-raised" ng-class="{\r\n                    \'md-primary\': !vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta}" ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta = false" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                        || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                        || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)">No</md-button></div></div><div ng-show="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="row" layout-align-gt-xs="center"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataSedutaUp" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataSedutaUp\')}"></label><md-datepicker style="width: 210px" md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                    || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                    || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataSedutaUp = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data seduta UP</md-tooltip></md-button></span></div><div ng-show="!vm.sezioniMap.ASSIGNMENT_LETTER.metadati.aulaDiretta" layout="column" layout-align-gt-xs="center"><div layout="column" layout-align-gt-xs="center"><div layout="row" layout-xs="column" layout-align="center" layout-align-xs="start start"><md-input-container><label data-translate="gestioneAttiApp.form.assignment.dataAssegnazione" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'dataAssegnazione\')}"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable\r\n                                || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\'))\r\n                                || vm.sezioniMap.ASSIGNMENT_LETTER.skipCurrentStateCheck)"></md-datepicker></md-input-container><span ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione && vm.sezioniMap.ASSIGNMENT_LETTER.editable"><md-button ng-click="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dataAssegnazione = null" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data assegnazione</md-tooltip></md-button></span></div><div class="spacer"></div><div layout="row" layout-xs="column" layout-align-xs="start start" layout-wrap><div layout="column" flex-offset-gt-xs="5"><label data-translate="gestioneAttiApp.form.assignment.parereReferente" ng-class="{\'field-invalid\': vm.validating && vm.isInvalidField(\'parereReferente\')}"></label><div ng-repeat="commissione in vm.commissioni"><md-checkbox class="md-primary" ng-disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !(vm.userRolesMap.isAdmin || vm.isSectorUserEnabled(\'GENERAL_SECTIONS\')))" ng-checked="vm.exists(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati.parereReferente)" ng-click="vm.toggle(commissione.id, vm.sezioniMap.ASSIGNMENT_LETTER.metadati, \'parereReferente\', 4); vm.toggleParereSecondario(); vm.toggleParereIstituzionale(); vm.toggleParereDiMerito(\'parereReferente\');" ng-if="commissione.id != vm.idCommissioneControllo">{{commissione.nome}}</md-checkbox></div></div><div class="spacer"></div><div ng-if="vm.atto.statoCorrente.statoAtto.name === \'COMMISSIONE\'\r\n                              || (vm.atto.statoCorrente.statoAtto.name !== \'PRESENTATO\'\r\n                              && vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione)" layout="row" layout-xs="column"><addable-input input-type="\'date\'" input-model="vm.sezioniMap.ASSIGNMENT_LETTER.metadati.dateRettificaAssegnazione" date-label="\'gestioneAttiApp.form.assignment.dataRettificaAssegnazione\'" disabled="::(!vm.sezioniMap.ASSIGNMENT_LETTER.editable || !vm.userRolesMap.isSettoreAtti)" edit-only-last-value="true" style="width: 100%"></addable-input></div></div></div></div></form></div><div class="panel-footer" ng-if="vm.sezioniMap.ASSIGNMENT_LETTER.visible"><document-toolbar section="::vm.sezioniMap.ASSIGNMENT_LETTER" document-types="::vm.docTypes" include-notes="true" editable="::((vm.sezioniMap.ASSIGNMENT_LETTER.editable && vm.userRolesMap.isSettoreAtti) || vm.userRolesMap.isProtocollo || vm.userRolesMap.isAdmin)" user="::vm.utente" change-document-type-callback="vm.changeDocumentType(document, newDocumentType)" change-document-visibility-callback="vm.changeDocumentVisibility(document, newDocumentVisibility)" change-document-frontpiece-callback="vm.changeDocumentFrontpiece(document, frontpiece)" public-view="::vm.publicView" tipo-atto="::vm.atto.tipoAtto"></document-toolbar></div>');
$templateCache.put('app/entities/atto/sezioni/sendBackDate.html','<md-dialog aria-label="data rinvio" class="send-back-date-container" flex="15" layout-padding layout-align="center center"><div layout="row"><md-input-container><label data-translate="gestioneAttiApp.form.courtroomOutcome.dataRinvio"></label><md-datepicker md-open-on-focus onkeydown="return false" ng-model="dataRinvio"></md-datepicker></md-input-container><span ng-if="dataRinvio"><md-button ng-click="removeDataRinvio()" class="md-icon-button home-prom-date-clear-button"><span class="glyphicon glyphicon-remove-circle"></span><md-tooltip>Rimuovi data rinvio</md-tooltip></md-button></span></div><md-dialog-actions layout="row" flex="100"><md-button class="md-raised md-primary" ng-click="confirm();"><span data-translate="entity.action.confirm"></span></md-button><span flex></span><md-button class="md-raised md-accent" ng-click="cancel();"><span data-translate="entity.action.cancel"></span></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/bootstrap-ui-datetime-picker-iterlegis/example/index.html','<!DOCTYPE html><html ng-app="app" ng-controller="MyController as ctrl"><head><link rel="stylesheet" href="style.css"><link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.min.css"><link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.1/css/bootstrap.min.css"><script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.5.0/angular.min.js"></script><script src="https://cdnjs.cloudflare.com/ajax/libs/angular-ui-bootstrap/1.2.0/ui-bootstrap-tpls.js"></script><script src="../dist/datetime-picker.js"></script><script src="index.js"></script></head><body style="padding:10px" class="container-fluid"><h1>DateTime Picker Demo</h1><p>Use datetime calendar to choose a date and/or time from a popup calendar. This can be used as a replacement for the bootstrap-ui datepicker-popup control</p><hr><div><h3>Pick a date</h3><ul><li>dateDisabled used, todays date is disabled when the picker is displaying days</li><li>closeOnDateSelection="false"</li><li>datepickerOptions - showWeeks=false, startingDay=1</li></ul><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Date</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="mediumDate" ng-model="ctrl.picker1.date" is-open="ctrl.picker1.open" enable-time="false" datepicker-options="ctrl.picker1.datepickerOptions" close-on-date-selection="false" datepicker-append-to-body="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker1\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker1.date }}</p></div></div></form><hr><h3>Pick a time</h3><ul><li>timepickerOptions - showMeridian=false, readonlyInput=true</li></ul><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Time</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="HH:mm" ng-model="ctrl.picker2.date" is-open="ctrl.picker2.open" enable-date="false" timepicker-options="ctrl.picker2.timepickerOptions" close-on-selection="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker2\')"><i class="fa fa-clock-o"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker2.date }}</p></div></div></form><hr><h3>Pick a date and time</h3><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Both</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="MM/dd/yyyy HH:mm" ng-model="ctrl.picker3.date" is-open="ctrl.picker3.open"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker3\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker3.date }}</p></div></div></form><hr><h3>Pick two dates to calculate difference</h3><p>Pick a date range, using two dates. Use minDate and maxDate to make sure your end date cannot be before your start date and vice-versa</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">From</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd MMM yyyy" ng-model="ctrl.picker4.date" is-open="ctrl.picker4.open" enable-time="false" datepicker-options="ctrl.picker4.datepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker4\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">To</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd MMM yyyy" ng-model="ctrl.picker5.date" is-open="ctrl.picker5.open" enable-time="false" datepicker-options="ctrl.picker5.datepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker5\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">Difference</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.dayRange }} (days)</p></div></div></form><h3>Global Configured DateTime Picker</h3><p>Date picker only passes in the model and isOpen parameters, the rest are determined by the constant uiDatetimePickerConfig</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Both</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker ng-model="ctrl.picker6.date" is-open="ctrl.picker6.open"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker6\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker6.date }}</p></div></div></form><h3>Use bootstrap dropup class</h3><p>Use dropup to make the dropdown menu go upwards instead of down. NOTE: Cannot currently use append-to-body="true" with dropup class</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Date</label><div class="col-sm-10"><p class="input-group dropup"><input type="text" class="form-control" datetime-picker="mediumDate" ng-model="ctrl.picker7.date" is-open="ctrl.picker7.open" enable-time="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker7\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker7.date }}</p></div></div></form><hr><h3>View Mode</h3><p>Use a particular view mode only for the datepicker.</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Date</label><div class="col-sm-10"><p class="input-group dropup"><input type="text" class="form-control" datepicker-mode="\'year\'" datetime-picker="yyyy" ng-model="ctrl.picker8.date" is-open="ctrl.picker8.open" enable-time="false" datepicker-options="ctrl.picker8.datepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker8\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker8.date }}</p></div></div></form><hr><h3>Default Time</h3><p>Set a default time when choosing a date</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Both</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker ng-model="ctrl.picker9.date" default-time="17:00" is-open="ctrl.picker9.open"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker9\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">model</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker9.date }}</p></div></div></form><h3>Min / Max times</h3><p>Pick a minimum time in 1 picker and a maximum time in another picker. The opposite picker will disable so you cannot overlay the ranges</p><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Min</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="HH:mm" ng-model="ctrl.picker10.date" is-open="ctrl.picker10.open" timepicker-options="ctrl.picker10.timepickerOptions" enable-date="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker10\')"><i class="fa fa-clock-o"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">Max</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="HH:mm" ng-model="ctrl.picker11.date" is-open="ctrl.picker11.open" timepicker-options="ctrl.picker11.timepickerOptions" enable-date="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker11\')"><i class="fa fa-clock-o"></i></button></span></p></div></div></form><hr><h3>Customize Button bar</h3><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Date</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="mediumDate" ng-model="ctrl.picker12.date" is-open="ctrl.picker12.open" enable-time="false" button-bar="ctrl.picker12.buttonBar"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker12\')"><i class="fa fa-calendar"></i></button></span></p></div></div></form><hr><h3>Call function when closed</h3><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Date</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd/MM/yyyy HH:mm" ng-model="ctrl.picker13.date" is-open="ctrl.picker13.open" when-closed="ctrl.picker13.closed(args)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker13\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">On Close</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.closedArgs }}</p></div></div></form><hr><h3>Save As ISO</h3><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">ISO</label><div class="col-sm-10"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd/MM/yyyy" enable-time="false" ng-model="ctrl.picker14.date" is-open="ctrl.picker14.open" save-as="ISO"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="ctrl.openCalendar($event, \'picker14\')"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group"><label class="col-sm-2 control-label">On Close</label><div class="col-sm-10"><p class="form-control-static">{{ ctrl.picker14.date }}</p></div></div></form><hr></div></body></html>');}]);})();